!function(e,t){"object"==typeof exports?module.exports=t(require("angular")):"function"==typeof define&&define.amd?define(["angular"],t):t(e.angular)}(this,function(e){"use strict";e.module("ngWYSIWYG",["ngSanitize"]),e.module("ngWYSIWYG").config(["$provide",function(e){e.decorator("$sanitize",["$delegate","$log",function(e,t){return function(t,n){var o=e(t,n);return o}}])}]),e.module("ngWYSIWYG").constant("NGP_EVENTS",{ELEMENT_CLICKED:"ngp-element-clicked",CLICK_AWAY:"ngp-click-away"}),e.module("ngWYSIWYG").directive("ngpColorsGrid",["NGP_EVENTS",function(e){var t=function(t,n){t.$on(e.CLICK_AWAY,function(){t.$apply(function(){t.show=!1})}),n.parent().bind("click",function(e){e.stopPropagation()}),t.colors=["#000000","#993300","#333300","#003300","#003366","#000080","#333399","#333333","#800000","#FF6600","#808000","#008000","#008080","#0000FF","#666699","#808080","#FF0000","#FF9900","#99CC00","#339966","#33CCCC","#3366FF","#800080","#999999","#FF00FF","#FFCC00","#FFFF00","#00FF00","#00FFFF","#00CCFF","#993366","#C0C0C0","#FF99CC","#FFCC99","#FFFF99","#CCFFCC","#CCFFFF","#99CCFF","#CC99FF","#FFFFFF"],t.pick=function(e){t.onPick({color:e})},n.ready(function(){function e(t){1==t.nodeType&&(t.setAttribute("unselectable","on"),t.unselectable="on");for(var n=t.firstChild;n;)e(n),n=n.nextSibling}for(var t=0;t<document.getElementsByClassName("ngp-colors-grid").length;t+=1)e(document.getElementsByClassName("ngp-colors-grid")[t])})};return{link:t,scope:{show:"=",onPick:"&"},restrict:"AE",template:'<ul ng-show="show" class="ngp-colors-grid"><li ng-style="{\'background-color\': color}" title: "{{color}}" ng-repeat="color in colors" unselectable="on" ng-click="pick(color)"></li></ul>'}}]),e.module("ngWYSIWYG").directive("ngpSymbolsGrid",["NGP_EVENTS",function(e){var t=function(t,n){t.$on(e.CLICK_AWAY,function(){t.$apply(function(){t.show=!1})}),n.parent().bind("click",function(e){e.stopPropagation()}),t.symbols=["&iexcl;","&iquest;","&ndash;","&mdash;","&raquo;","&laquo;","&copy;","&divide;","&micro;","&para;","&plusmn;","&cent;","&euro;","&pound;","&reg;","&sect;","&trade;","&yen;","&deg;","&forall;","&part;","&exist;","&empty;","&nabla;","&isin;","&notin;","&ni;","&prod;","&sum;","&uarr;","&rarr;","&darr;","&spades;","&clubs;","&hearts;","&diams;","&aacute;","&agrave;","&acirc;","&aring;","&atilde;","&auml;","&aelig;","&ccedil;","&eacute;","&egrave;","&ecirc;","&euml;","&iacute;","&igrave;","&icirc;","&iuml;","&ntilde;","&oacute;","&ograve;","&ocirc;","&oslash;","&otilde;","&ouml;","&szlig;","&uacute;","&ugrave;","&ucirc;","&uuml;","&yuml;"],t.pick=function(e){t.onPick({symbol:e})},n.ready(function(){function e(t){1==t.nodeType&&(t.setAttribute("unselectable","on"),t.unselectable="on");for(var n=t.firstChild;n;)e(n),n=n.nextSibling}for(var t=0;t<document.getElementsByClassName("ngp-symbols-grid").length;t+=1)e(document.getElementsByClassName("ngp-symbols-grid")[t])})};return{link:t,scope:{show:"=",onPick:"&"},restrict:"AE",template:'<ul ng-show="show" class="ngp-symbols-grid"><li ng-repeat="symbol in symbols" unselectable="on" ng-click="pick(symbol)" ng-bind-html="symbol"></li></ul>'}}]),e.module("ngWYSIWYG").service("ngpImageResizer",["NGP_EVENTS",function(e){function t(e){e.preventDefault()}function n(e){e.preventDefault(),e.stopPropagation(),v.style.height="",v.style.width="",l()}function o(e){e.preventDefault(),e.stopPropagation(),v.style.width="100%",v.style.height="",l()}function i(e){return e.target!=y?(c.removeEventListener("mousemove",r),void(h=!1)):(e.stopPropagation(),e.preventDefault(),c.addEventListener("mousemove",r),void(h=!0))}function r(e){e.stopPropagation(),e.preventDefault();var t=e.pageY,n=t-(v.getBoundingClientRect().top+d.pageYOffset);v.style.height=n+"px",v.style.width="",g&&e.clientY>g&&d.innerHeight-e.clientY<=45&&d.scrollTo(0,d.innerHeight),g=e.clientY,l()}function a(e,t){return t==p||h?void c.removeEventListener("mousemove",r):"IMG"!==t.tagName?s():(p.parentNode||u.appendChild(p),v=t,void l())}function l(){var e=d.getComputedStyle(v);p.style.height=e.getPropertyValue("height"),p.style.width=e.getPropertyValue("width"),p.style.top=v.getBoundingClientRect().top+d.pageYOffset+"px",p.style.left=v.getBoundingClientRect().left+d.pageXOffset+"px",p.style.display="block"}function s(e){p.parentNode&&(e&&"IMG"===e.target.tagName||(p.style.display="none",g=null))}var c,d,u,p,g,m,y,f,h,v,b=this;b.setup=function(r,l){d=l.defaultView,c=l,u=c.querySelector("body"),m=r,p=c.createElement("div"),p.className="ngp-image-resizer",p.style.position="absolute",p.style.border="1px dashed black",p.style.display="none",p.setAttribute("contenteditable",!1),y=c.createElement("div"),y.style.position="absolute",y.style.height="10px",y.style.width="10px",y.style.bottom="-5px",y.style.right="-5px",y.style.border="1px solid black",y.style.backgroundColor="#fff",y.style.cursor="se-resize",y.setAttribute("contenteditable",!1),p.appendChild(y),f=c.createElement("div"),f.style.position="absolute",f.style.height="30px",f.style.width="150px",f.style.bottom="-30px",f.style.left="0",p.appendChild(f);var g=c.createElement("button");g.addEventListener("click",n),g.innerHTML="Auto",f.appendChild(g);var h=c.createElement("button");h.addEventListener("click",o),h.innerHTML="100%",f.appendChild(h),c.addEventListener("mousedown",i),c.addEventListener("mouseup",i),d.parent.document.addEventListener("mouseup",i),u.addEventListener("mscontrolselect",t),m.$on(e.ELEMENT_CLICKED,a),m.$on(e.CLICK_AWAY,s)}}]);var t='<div class="tinyeditor"><div class="tinyeditor-header" ng-hide="editMode">{toolbar}<div style="clear: both;"></div></div><div class="sizer" ngp-resizable><textarea data-placeholder-attr="" style="-webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; resize: none; width: 100%; height: 100%;" ng-show="editMode" ng-model="content"></textarea><iframe style="-webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; width: 100%; height: 100%;" ng-hide="editMode" ngp-content-frame="{sanitize: config.sanitize}" content-style="{contentStyle}" ng-model="content"></iframe></div><div class="tinyeditor-footer"><div ng-switch="editMode" ng-click="editMode = !editMode" class="toggle"><span ng-switch-when="true">wysiwyg</span><span ng-switch-default>source</span></div></div></div>';return e.module("ngWYSIWYG").directive("wysiwygEdit",["ngpUtils","NGP_EVENTS","$rootScope","$compile","$timeout","$q",function(n,o,i,r,a,l){var s=function(a,s,c,d){function u(){null==m&&(m=document.querySelector("wysiwyg-edit").querySelector("iframe"),y=m.contentDocument,f=y.defaultView)}function p(e){a.$broadcast("insertElement",e)}function g(e){var t="<"+e.type;if(t+=' class="'+e["class"],h&&(t+=" tinyeditor-control-fa"),t+='" ',"div"==e.type){if(e.title&&(t+='title="'+e.title+'" '),e.backgroundPos&&!h&&(t+='style="background-position: '+e.backgroundPos+'; position: relative;" '),e.pressed&&(t+="ng-class=\"{'pressed': cursorStyle."+e.pressed+'}" '),e.command){var n="'"+e.command+"'";e.commandParameter&&(n+=", '"+e.commandParameter+"'"),t+='ng-click="execCommand('+n+')" '}else e.specialCommand&&(t+='ng-click="'+e.specialCommand+'" ');t+=">",e.faIcon&&h&&"-"!=e.faIcon&&(t+='<i class="fa fa-'+e.faIcon+'"></i>'),e.faIcon&&h&&"-"==e.faIcon&&(t+='<div class="hr"></div>'),e.inner&&(t+=e.inner)}else"select"==e.type&&(t+='ng-model="'+e.model+'" ',t+='ng-options="'+e.options+'" ',t+='ng-change="'+e.change+'" ',t+='<option value="">'+e.title+"</option>");return t+="</"+e.type+">"}a.editMode=!1,a.cursorStyle={},document.addEventListener("click",function(){i.$broadcast(o.CLICK_AWAY)});var m=null,y=null,f=null;a.panelButtons={"-":{type:"div","class":"tinyeditor-divider"},bold:{type:"div",title:"Bold","class":"tinyeditor-control",faIcon:"bold",backgroundPos:"34px -120px",pressed:"bold",command:"bold"},italic:{type:"div",title:"Italic","class":"tinyeditor-control",faIcon:"italic",backgroundPos:"34px -150px",pressed:"italic",command:"italic"},underline:{type:"div",title:"Underline","class":"tinyeditor-control",faIcon:"underline",backgroundPos:"34px -180px",pressed:"underline",command:"underline"},strikethrough:{type:"div",title:"Strikethrough","class":"tinyeditor-control",faIcon:"strikethrough",backgroundPos:"34px -210px",pressed:"strikethrough",command:"strikethrough"},subscript:{type:"div",title:"Subscript","class":"tinyeditor-control",faIcon:"subscript",backgroundPos:"34px -240px",pressed:"sub",command:"subscript"},superscript:{type:"div",title:"Superscript","class":"tinyeditor-control",faIcon:"superscript",backgroundPos:"34px -270px",pressed:"super",command:"superscript"},leftAlign:{type:"div",title:"Left Align","class":"tinyeditor-control",faIcon:"align-left",backgroundPos:"34px -420px",pressed:"alignmet == 'left'",command:"justifyleft"},centerAlign:{type:"div",title:"Center Align","class":"tinyeditor-control",faIcon:"align-center",backgroundPos:"34px -450px",pressed:"alignment == 'center'",command:"justifycenter"},rightAlign:{type:"div",title:"Right Align","class":"tinyeditor-control",faIcon:"align-right",backgroundPos:"34px -480px",pressed:"alignment == 'right'",command:"justifyright"},blockJustify:{type:"div",title:"Block Justify","class":"tinyeditor-control",faIcon:"align-justify",backgroundPos:"34px -510px",pressed:"alignment == 'justify'",command:"justifyfull"},orderedList:{type:"div",title:"Insert Ordered List","class":"tinyeditor-control",faIcon:"list-ol",backgroundPos:"34px -300px",command:"insertorderedlist"},unorderedList:{type:"div",title:"Insert Unordered List","class":"tinyeditor-control",faIcon:"list-ul",backgroundPos:"34px -330px",command:"insertunorderedlist"},outdent:{type:"div",title:"Outdent","class":"tinyeditor-control",faIcon:"outdent",backgroundPos:"34px -360px",command:"outdent"},indent:{type:"div",title:"Indent","class":"tinyeditor-control",faIcon:"indent",backgroundPos:"34px -390px",command:"indent"},removeFormatting:{type:"div",title:"Remove Formatting","class":"tinyeditor-control",faIcon:"eraser",backgroundPos:"34px -720px",command:"removeformat"},undo:{type:"div",title:"Undo","class":"tinyeditor-control",faIcon:"undo",backgroundPos:"34px -540px",command:"undo"},redo:{type:"div",title:"Redo","class":"tinyeditor-control",faIcon:"repeat",backgroundPos:"34px -570px",command:"redo"},fontColor:{type:"div",title:"Font Color","class":"tinyeditor-control",faIcon:"font",backgroundPos:"34px -779px",specialCommand:"showFontColors = !showFontColors",inner:'<ngp-colors-grid show="showFontColors" on-pick="setFontColor(color)"><ngp-colors-grid>'},backgroundColor:{type:"div",title:"Background Color","class":"tinyeditor-control",faIcon:"paint-brush",backgroundPos:"34px -808px",specialCommand:"showBgColors = !showBgColors",inner:'<ngp-colors-grid show="showBgColors" on-pick="setBgColor(color)"><ngp-colors-grid>'},image:{type:"div",title:"Insert Image","class":"tinyeditor-control",faIcon:"picture-o",backgroundPos:"34px -600px",specialCommand:"insertImage()"},hr:{type:"div",title:"Insert Horizontal Rule","class":"tinyeditor-control",faIcon:"-",backgroundPos:"34px -630px",command:"inserthorizontalrule"},symbols:{type:"div",title:"Insert Special Symbol","class":"tinyeditor-control",faIcon:"cny",backgroundPos:"34px -838px",specialCommand:"showSpecChars = !showSpecChars",inner:'<ngp-symbols-grid show="showSpecChars" on-pick="insertSpecChar(symbol)"><ngp-symbols-grid>'},link:{type:"div",title:"Insert Hyperlink","class":"tinyeditor-control",faIcon:"link",backgroundPos:"34px -660px",specialCommand:"insertLink()"},unlink:{type:"div",title:"Remove Hyperlink","class":"tinyeditor-control",faIcon:"chain-broken",backgroundPos:"34px -690px",command:"unlink"},print:{type:"div",title:"Print","class":"tinyeditor-control",faIcon:"print",backgroundPos:"34px -750px",command:"print"},font:{type:"select",title:"Font","class":"tinyeditor-font",model:"font",options:"a as a for a in fonts",change:"fontChange()"},size:{type:"select",title:"Size","class":"tinyeditor-size",model:"fontsize",options:"a.key as a.name for a in fontsizes",change:"sizeChange()"},format:{type:"select",title:"Style","class":"tinyeditor-size",model:"textstyle",options:"s.key as s.name for s in styles",change:"styleChange()"}};var h=a.config&&a.config.fontAwesome;a.toolbar=a.config&&a.config.toolbar?a.config.toolbar:[{name:"basicStyling",items:["bold","italic","underline","strikethrough","subscript","superscript","leftAlign","centerAlign","rightAlign","blockJustify","-"]},{name:"paragraph",items:["orderedList","unorderedList","outdent","indent","-"]},{name:"doers",items:["removeFormatting","undo","redo","-"]},{name:"colors",items:["fontColor","backgroundColor","-"]},{name:"links",items:["image","hr","symbols","link","unlink","-"]},{name:"tools",items:["print","-"]},{name:"styling",items:["font","size","format"]}];var v=[];e.forEach(a.toolbar,function(t,n){var o=[];e.forEach(t.items,function(e,t){var n=a.panelButtons[e];n||(n=a.config.buttons[e]),this.push(g(n))},o),this.push('<div class="tinyeditor-buttons-group">'+o.join("")+"</div>")},v);var b=t.replace("{toolbar}",v.join(""));b=b.replace("{contentStyle}",c.contentStyle||""),s.html(b),r(s.contents())(a),a.execCommand=function(e,t){switch(e){case"bold":a.cursorStyle.bold=!a.cursorStyle.bold;break;case"italic":a.cursorStyle.italic=!a.cursorStyle.italic;break;case"underline":a.cursorStyle.underline=!a.cursorStyle.underline;break;case"strikethrough":a.cursorStyle.strikethrough=!a.cursorStyle.strikethrough;break;case"subscript":a.cursorStyle.sub=!a.cursorStyle.sub;break;case"superscript":a.cursorStyle["super"]=!a.cursorStyle["super"];break;case"justifyleft":a.cursorStyle.alignment="left";break;case"justifycenter":a.cursorStyle.alignment="center";break;case"justifyright":a.cursorStyle.alignment="right";break;case"justifyfull":a.cursorStyle.alignment="justify"}a.$broadcast("execCommand",{command:e,arg:t})},a.fonts=["Verdana","Arial","Arial Black","Arial Narrow","Courier New","Century Gothic","Comic Sans MS","Georgia","Impact","Tahoma","Times","Times New Roman","Webdings","Trebuchet MS"],a.fontChange=function(){a.execCommand("fontname",a.font)},a.fontsizes=[{key:1,name:"x-small"},{key:2,name:"small"},{key:3,name:"normal"},{key:4,name:"large"},{key:5,name:"x-large"},{key:6,name:"xx-large"},{key:7,name:"xxx-large"}],a.mapFontSize={10:1,13:2,16:3,18:4,24:5,32:6,48:7},a.sizeChange=function(){a.execCommand("fontsize",a.fontsize)},a.styles=[{name:"Paragraph",key:"<p>"},{name:"Header 1",key:"<h1>"},{name:"Header 2",key:"<h2>"},{name:"Header 3",key:"<h3>"},{name:"Header 4",key:"<h4>"},{name:"Header 5",key:"<h5>"},{name:"Header 6",key:"<h6>"}],a.styleChange=function(){a.execCommand("formatblock",a.textstyle)},a.showFontColors=!1,a.setFontColor=function(e){a.execCommand("foreColor",e)},a.showBgColors=!1,a.setBgColor=function(e){a.execCommand("hiliteColor",e)},a.showSpecChars=!1,a.insertSpecChar=function(e){p(e)},a.insertLink=function(){if(u(),null!=f.getSelection().focusNode){var t=n.getSelectionBoundaryElement(f,!0),o="http://";if(t&&"A"==t.nodeName){o=t.href;var i=y.createRange();i.setStart(t.firstChild,0),i.setEnd(t.firstChild,t.firstChild.length);var r=f.getSelection();r.removeAllRanges(),r.addRange(i)}var s;s=a.api&&a.api.insertLink&&e.isFunction(a.api.insertLink)?a.api.insertLink.apply(a.api.scope||null,[o]):prompt("Please enter the URL","http://"),l.when(s).then(function(e){a.execCommand("createlink",e)})}},a.insertImage=function(){var t;a.api&&a.api.insertImage&&e.isFunction(a.api.insertImage)?t=a.api.insertImage.apply(a.api.scope||null):(t=prompt("Please enter the picture URL","http://"),t='<img src="'+t+'">'),l.when(t).then(function(e){p(e)})},s.ready(function(){function e(t){1==t.nodeType&&(t.setAttribute("unselectable","on"),t.unselectable="on");for(var n=t.firstChild;n;)e(n),n=n.nextSibling}for(var t=0;t<document.getElementsByClassName("tinyeditor-header").length;t+=1)e(document.getElementsByClassName("tinyeditor-header")[t])}),a.$on("cursor-position",function(e,t){a.cursorStyle=t,a.font=t.font.replace(/(')/g,""),a.fontsize=a.mapFontSize[t.size]?a.mapFontSize[t.size]:0})};return{link:s,scope:{content:"=",api:"=",config:"="},restrict:"AE",replace:!0}}]),e.module("ngWYSIWYG").directive("ngpContentFrame",["ngpImageResizer","ngpUtils","NGP_EVENTS","$compile","$timeout","$sanitize",function(t,n,o,i,r,a){var l=function(i,l,s,c){var d=l[0].contentDocument;d.open(),d.write('<!DOCTYPE html><html><head></head><body contenteditable="true"></body></html>'),d.close(),d.designMode="On",t.setup(i,d);var u=e.element(l[0].contentDocument.body),p=e.element(l[0].contentDocument.head);u.attr("contenteditable","true"),d.addEventListener("click",function(e){"HTML"===e.target.tagName&&e.target.querySelector("body").focus(),i.$emit(o.ELEMENT_CLICKED,e.target)}),s.contentStyle&&p.append('<link rel="stylesheet" type="text/css" href="'+s.contentStyle+'">'),c.$render=function(){u[0].innerHTML=c.$viewValue?i.config&&i.config.sanitize?a(c.$viewValue):c.$viewValue:""},i.sync=function(){i.$evalAsync(function(e){c.$setViewValue(u.html())})};var g=null;u.bind("click keyup change paste",function(){g&&r.cancel(g),g=r(function(){var e=u[0].ownerDocument,t=e.querySelector(".ngp-image-resizer"),o=u[0].innerHTML;t&&(o=o.replace(t.outerHTML,"")),c.$setViewValue(o);var r=n.getSelectionBoundaryElement(l[0].contentWindow,!0);if(r){var a=l[0].contentWindow.getComputedStyle(r),s={bold:"bold"==a.getPropertyValue("font-weight")||parseInt(a.getPropertyValue("font-weight"))>=700,italic:"italic"==a.getPropertyValue("font-style"),underline:"underline"==a.getPropertyValue("text-decoration"),strikethrough:"line-through"==a.getPropertyValue("text-decoration"),font:a.getPropertyValue("font-family"),size:parseInt(a.getPropertyValue("font-size")),color:a.getPropertyValue("color"),sub:"sub"==a.getPropertyValue("vertical-align"),"super":"super"==a.getPropertyValue("vertical-align"),background:a.getPropertyValue("background-color"),alignment:a.getPropertyValue("text-align")};i.$emit("cursor-position",s)}},100,!0)}),i.range=null,i.getSelection=function(){if(d.getSelection){var e=d.getSelection();e.getRangeAt&&e.rangeCount&&(i.range=e.getRangeAt(0))}},i.restoreSelection=function(){if(i.range&&d.getSelection){var e=d.getSelection();e.removeAllRanges(),e.addRange(i.range)}},i.$on("execCommand",function(e,t){console.log("execCommand: "),console.log(t),l[0].contentDocument.body.focus();var n=d.selection;if(n){var o=n.createRange();d.execCommand(t.command,0,t.arg),o.collapse(!1),o.select()}else d.execCommand(t.command,0,t.arg);d.body.focus(),i.sync()}),i.$on("insertElement",function(e,t){var n,o;if(d.defaultView.getSelection){if(n=d.defaultView.getSelection(),n.getRangeAt&&n.rangeCount){o=n.getRangeAt(0),o.deleteContents();var r=d.createElement("div");r.innerHTML=t;for(var a,l,s=d.createDocumentFragment();a=r.firstChild;)l=s.appendChild(a);s.firstChild;o.insertNode(s),l&&(o=o.cloneRange(),o.setStartAfter(l),o.collapse(!0),n.removeAllRanges(),n.addRange(o))}}else d.selection&&"Control"!=d.selection.type&&d.selection.createRange().pasteHTML(t);i.sync()}),i.$on("$destroy",function(){});try{d.execCommand("styleWithCSS",0,0),d.execCommand("enableObjectResizing",!1,"false"),d.execCommand("contentReadOnly",0,"false")}catch(m){try{d.execCommand("useCSS",0,1)}catch(m){}}};return{link:l,require:"ngModel",scope:{config:"=ngpContentFrame"},replace:!0,restrict:"AE"}}]),e.module("ngWYSIWYG").directive("ngpResizable",["$document",function(e){return function(t,n){var o=e[0],i=n[0],r=o.createElement("span");r.className="resizer",i.appendChild(r),r.addEventListener("mousedown",function(){function e(e){e.preventDefault();var t=e.pageY;e.view!=o.defaultView&&(t=e.pageY+e.view.frameElement.getBoundingClientRect().top+o.defaultView.pageYOffset);var n=t-(i.getBoundingClientRect().top+o.defaultView.pageYOffset),r=i.style.height.replace("px","");r&&n>r&&window.innerHeight-e.clientY<=45&&o.defaultView.scrollBy(0,n-r),i.style.height=n+"px"}function t(){o.removeEventListener("mousemove",e),o.removeEventListener("mouseup",t);for(var n=o.querySelectorAll("iframe"),i=0;i<n.length;i++)n[i].contentWindow.document.removeEventListener("mouseup",t),n[i].contentWindow.document.removeEventListener("mousemove",e)}o.addEventListener("mousemove",e),o.addEventListener("mouseup",t);for(var n=o.querySelectorAll("iframe"),r=0;r<n.length;r++)n[r].contentWindow.document.addEventListener("mouseup",t),n[r].contentWindow.document.addEventListener("mousemove",e)})}}]),e.module("ngWYSIWYG").service("ngpUtils",[function(){var e=this;e.getSelectionBoundaryElement=function(e,t){var n,o,i=null,r=e.document;return r.selection?(n=r.selection.createRange(),n.collapse(t),n.parentElement()):(r.getSelection?(o=r.getSelection(),o.rangeCount>0&&(n=o.getRangeAt(0),i=n[t?"startContainer":"endContainer"],3===i.nodeType&&(i=i.parentNode))):e.getSelection&&(o=e.getSelection(),o.rangeCount>0&&(n=o.getRangeAt(0),i=n[t?"startContainer":"endContainer"],3===i.nodeType&&(i=i.parentNode))),i)}}]),"ngWYSIWYG"});
(function() {
  angular.module('fsa', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ui.router', 'ui.calendar', 'ui.bootstrap', 'ui.bootstrap.tooltip', 'ui.bootstrap.modal', 'toastr', 'pouchdb', 'ui.grid', 'ui.grid.selection', 'ui.grid.resizeColumns', 'ui.grid.saveState', 'ui.grid.cellNav', 'ui.grid.edit', 'ui.grid.moveColumns', 'ui.grid.pagination', 'ui.grid.autoResize', 'mgo-angular-wizard', 'ngDropzone', 'angular-md5', 'ngStorage', 'barcodeListener', 'cfp.hotkeys', 'angularMoment', 'base64', 'ui.select', 'ui.carousel', 'ui.calendar', 'angular-storage', 'ngImgCrop', 'flow', 'angular-loading-bar', 'ui.mask', 'angular-js-xlsx', 'xeditable', 'pascalprecht.translate', 'ngWYSIWYG', 'chart.js', 'ncy-angular-breadcrumb']);

}).call(this);



(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('fsa').controller('DocsSaleEditController', function(hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal, $uibModalStack) {
    'ngInject';
    var addApprovalRole, delApprovalRole, getDefault, initDoc, preSave, productEdit, productFromNew, productNew, productRemove, vm;
    vm = this;
    vm.productsGridOptions = {
      noUnselect: true,
      data: [],
      columnDefs: [
        {
          name: 'product_id',
          displayName: 'Продукт',
          cellTemplate: '<div class="ui-grid-cell-contents"><product-select-name product-id="grid.getCellValue(row,col)"></product-select-name></div>'
        }, {
          name: 'unit_id',
          displayName: 'Единица изм.',
          cellTemplate: '<div class="ui-grid-cell-contents" ng-init="units=[]" stock-dict="units" dict-table="Units" dict-filter="{_id:grid.getCellValue(row,col)}"><span ng-repeat="unit in units | filter:{_id:grid.getCellValue(row,col)} track by unit._id">{{unit.name}}</span></div>'
        }, {
          name: 'quantity',
          displayName: 'Количество'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена за ед.'
        }, {
          name: 'total_cost',
          displayName: 'Общая цена'
        }, {
          name: 'additional_cost',
          displayName: 'Дополнительная цена'
        }, {
          name: 'discount',
          displayName: 'Скидка (%)'
        }, {
          name: 'comment',
          displayName: 'Комментарий'
        }
      ],
      events: {
        onRowSelect: function(data) {
          if (data.grid.id === vm.productsGridOptions.gridApi.grid.id) {
            vm.selected_product = data.entity;
          }
        }
      }
    };
    vm.fromProductsGridOptions = {
      noUnselect: true,
      data: [],
      columnDefs: [
        {
          name: 'product.name',
          displayName: 'Продукт'
        }, {
          name: 'unit.name',
          displayName: 'Единица изм.'
        }, {
          name: 'quantity',
          displayName: 'Количество'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена за ед.'
        }, {
          name: 'total_cost',
          displayName: 'Общая цена'
        }, {
          name: 'additional_cost',
          displayName: 'Дополнительная цена'
        }, {
          name: 'comment',
          displayName: 'Комментарий'
        }
      ],
      events: {
        onRowSelect: function(event, data) {
          if (data.grid.id === vm.fromProductsGridOptions.gridApi.grid.id) {
            vm.selected_from_product = data.entity;
          }
        }
      }
    };
    initDoc = function() {
      vm.document = $scope.entry.document;
      vm.productsGridOptions.data = angular.copy(vm.document.data.products || []);
      vm.fromProductsGridOptions.data = angular.copy(vm.document.data.from_products || []);
      getDefault();
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.approval_not_editable = doc_def.data.approval && doc_def.data.approval.required === true;
          if (vm.approval_not_editable) {
            vm.document.approval.required = doc_def.data.approval.required;
            vm.document.approval.roles_id = doc_def.data.approval.roles_id;
            vm.document.approval.approval_type = doc_def.data.approval.approval_type;
          }
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    preSave = function() {
      var product;
      if (vm.document.approval && vm.document.approval.required === true) {
        if (vm.document.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return false;
        }
        if (angular.isUndefined(vm.document.approval.roles_id) || vm.document.approval.roles_id.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return false;
        }
      }
      if (vm.productsGridOptions.data === void 0 || vm.productsGridOptions.data.length === 0) {
        toastr.warning('Добавьте товары!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.branch_id)) {
        toastr.warning('Укажите филиал!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите принимающегопринимающего!');
        vm.saving = false;
        return;
      }
      vm.document.data.products = (function() {
        var i, len, ref, results;
        ref = vm.productsGridOptions.data;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push({
            product_id: product.product_id,
            unit_id: product.unit_id,
            rules_id: product.rules_id,
            quote_unit_price: product.quote_unit_price,
            quantity: product.quantity,
            total_cost: product.total_cost,
            additional_cost: product.additional_cost,
            discount: product.discount,
            comment: product.comment
          });
        }
        return results;
      })();
      return true;
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.document.approval.roles_id ? vm.document.approval.roles_id : vm.document.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.document.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.document.approval.roles_id.indexOf(role_id);
      if (index > -1) {
        vm.document.approval.roles_id.splice(index, 1);
      }
    };
    productNew = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/sale/product_select.html',
        controller: 'SaleProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: void 0
        }
      });
      editModal.result.then(function(product) {
        vm.productsGridOptions.data.push(product);
        return delete vm.selected_product;
      });
    };
    productEdit = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/sale/product_select.html',
        controller: 'SaleProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: angular.copy(vm.selected_product)
        }
      });
      editModal.result.then(function(product) {
        var index;
        index = vm.productsGridOptions.data.indexOf(vm.selected_product);
        vm.productsGridOptions.data.splice(index, 1, product);
        return delete vm.selected_product;
      });
    };
    productRemove = function() {
      var index;
      index = vm.productsGridOptions.data.indexOf(vm.selected_product);
      if (index !== -1) {
        vm.productsGridOptions.data.splice(index, 1);
      }
      delete vm.selected_product;
    };
    productFromNew = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/components/productSelect/select.html',
        controller: 'ProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          modalOptions: {},
          search: vm.selected_from_product
        }
      });
      return editModal.result.then(function(result) {
        editModal = $uibModal.open({
          templateUrl: 'app/docs/sale/product_select.html',
          controller: 'SaleProductSelectController',
          controllerAs: 'product',
          size: 'lg',
          scope: $scope,
          resolve: {
            product: angular.copy({
              product_id: result._id,
              quantity: vm.selected_from_product.quantity,
              quote_unit_price: vm.selected_from_product.quote_unit_price,
              additional_cost: vm.selected_from_product.additional_cost,
              total_cost: vm.selected_from_product.total_cost
            })
          }
        });
        editModal.result.then(function(product) {
          vm.productsGridOptions.data.push(product);
          return delete vm.selected_product;
        });
      });
    };
    $scope.$watch('sale.payment_method', function() {
      if (vm.payment_method === 'cash') {
        vm.document.data.is_due = false;
      } else if (vm.payment_method === 'debt') {
        vm.document.data.is_due = true;
      }
    });
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    vm.productNew = productNew;
    vm.productEdit = productEdit;
    vm.productRemove = productRemove;
    vm.productFromNew = productFromNew;
    initDoc();
  }).controller('DocsSaleViewController', function($scope, $state) {
    'ngInject';
    var fromTotalSum, totalSum, vm;
    vm = this;
    totalSum = function() {
      var product;
      return ((function() {
        var i, len, ref, ref1, ref2, results;
        ref = ($scope.view.document && $scope.view.document.data.products ? $scope.view.document.data.products : []);
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push(1 * ((ref1 = product.total_cost) != null ? ref1 : 0) + 1 * ((ref2 = product.additional_cost) != null ? ref2 : 0));
        }
        return results;
      })()).reduce(function(a, b) {
        return 1 * (a != null ? a : 0) + 1 * (b != null ? b : 0);
      }, 0);
    };
    fromTotalSum = function() {
      var product;
      return ((function() {
        var i, len, ref, ref1, ref2, results;
        ref = ($scope.view.document && $scope.view.document.data.from_products ? $scope.view.document.data.from_products : []);
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push(1 * ((ref1 = product.total_cost) != null ? ref1 : 0) + 1 * ((ref2 = product.additional_cost) != null ? ref2 : 0));
        }
        return results;
      })()).reduce(function(a, b) {
        return 1 * (a != null ? a : 0) + 1 * (b != null ? b : 0);
      }, 0);
    };
    vm.totalSum = totalSum;
    vm.fromTotalSum = fromTotalSum;
  }).controller('SaleProductSelectController', function($scope, Session, RequestService, toastr, product, $uibModalInstance) {
    'ngInject';
    var calcTotalCost, calcUnitPrice, isEmpty, onProductLoaded, onRuleSelect, onRulesLoaded, productSave, vm;
    vm = this;
    vm.product = product || {};
    isEmpty = function(value) {
      return angular.isUndefined(value) || value === null || value === '';
    };
    productSave = function() {
      if (angular.isUndefined(vm.product.product_id)) {
        toastr.warning('Выберите продукт');
        return;
      }
      delete vm.product.unit;
      $uibModalInstance.close(vm.product);
    };
    calcTotalCost = function(product) {
      var d, q, qup, ref, ref1, ref2;
      if (isEmpty(product) || isEmpty(product.quantity) || isEmpty(product.quote_unit_price)) {
        return;
      }
      q = (ref = product.quantity) != null ? ref : 0;
      qup = (ref1 = product.quote_unit_price) != null ? ref1 : 0;
      d = (ref2 = product.discount) != null ? ref2 : 0;
      product.total_cost = (q * qup / 100 * (100 - d)).toFixed(2) * 1;
    };
    calcUnitPrice = function(product) {
      var q, ref, ref1, tc;
      if (isEmpty(product) || isEmpty(product.quantity) || isEmpty(product.total_cost)) {
        return;
      }
      q = (ref = product.quantity) != null ? ref : 0;
      tc = (ref1 = product.total_cost) != null ? ref1 : 0;
      product.quote_unit_price = (tc / q).toFixed(2) * 1;
    };
    onRuleSelect = function() {
      var i, len, pr, ref, ref1;
      vm.product.discount = 0;
      ref = vm.pr;
      for (i = 0, len = ref.length; i < len; i++) {
        pr = ref[i];
        if (ref1 = pr._id, indexOf.call(vm.product.rules_id, ref1) >= 0) {
          vm.product.discount += pr.discount;
        }
      }
      calcTotalCost(vm.product);
    };
    onProductLoaded = function(product) {
      if (product && product.data && product.data.price) {
        vm.product.quote_unit_price = product.data.price;
      }
      calcTotalCost(vm.product);
    };
    onRulesLoaded = function() {
      var pr, rule_id, rules_id;
      rules_id = (function() {
        var i, len, ref, results;
        ref = vm.pr;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          pr = ref[i];
          results.push(pr._id);
        }
        return results;
      })();
      vm.product.rules_id = (function() {
        var i, len, ref, results;
        ref = vm.product.rules_id;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          rule_id = ref[i];
          if (indexOf.call(rules_id, rule_id) >= 0) {
            results.push(rule_id);
          }
        }
        return results;
      })();
      calcTotalCost(vm.product);
    };
    vm.productSave = productSave;
    vm.calcTotalCost = calcTotalCost;
    vm.calcUnitPrice = calcUnitPrice;
    vm.onRuleSelect = onRuleSelect;
    vm.onProductLoaded = onProductLoaded;
    vm.onRulesLoaded = onRulesLoaded;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DocsSalaryEditController', function(hotkeys, $scope, $state, RequestService, $stateParams, toastr, uiGridConstants, $uibModal, $uibModalStack) {
    'ngInject';
    var addApprovalRole, delApprovalRole, getDefault, initDoc, preSave, vm;
    vm = this;
    initDoc = function() {
      vm.document = $scope.entry.document;
      if ($stateParams.document && $stateParams.document.document_type === 'medical_examination') {
        vm.document.title = $stateParams.document.title;
        vm.document.data.employee_id = $stateParams.document.data.employee_id;
        vm.document.data.executor_id = $stateParams.document.data.executor_id;
        vm.document.data.amount = $stateParams.document.data.amount;
      }
      getDefault();
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.approval_not_editable = doc_def.data.approval && doc_def.data.approval.required === true;
          if (vm.approval_not_editable) {
            vm.document.approval.required = doc_def.data.approval.required;
            vm.document.approval.roles_id = doc_def.data.approval.roles_id;
            vm.document.approval.approval_type = doc_def.data.approval.approval_type;
          }
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    preSave = function() {
      if (vm.document.approval && vm.document.approval.required === true) {
        if (vm.document.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return false;
        }
        if (angular.isUndefined(vm.document.approval.roles_id) || vm.document.approval.roles_id.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return false;
        }
      }
      if (angular.isUndefined(vm.document.branch_id)) {
        toastr.warning('Укажите филиал!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите исполнителя!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.currency_id)) {
        toastr.warning('Укажите валюту!');
        vm.saving = false;
        return;
      }
      return true;
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.document.approval.roles_id ? vm.document.approval.roles_id : vm.document.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.document.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.document.approval.roles_id.indexOf(role_id);
      if (index > -1) {
        vm.document.approval.roles_id.splice(index, 1);
      }
    };
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    initDoc();
  }).controller('DocsSalaryViewController', function($scope, $state) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DocsRepaymentEditController', function(hotkeys, $scope, $state, $stateParams, RequestService, toastr, uiGridConstants, $uibModal, $uibModalStack) {
    'ngInject';
    var addApprovalRole, delApprovalRole, getDefault, initDoc, preSave, vm;
    vm = this;
    initDoc = function() {
      vm.document = $scope.entry.document;
      if (!vm.document.data) {
        vm.document.data = {};
      }
      getDefault();
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.approval_not_editable = doc_def.data.approval && doc_def.data.approval.required === true;
          if (vm.approval_not_editable) {
            vm.document.approval.required = doc_def.data.approval.required;
            vm.document.approval.roles_id = doc_def.data.approval.roles_id;
            vm.document.approval.approval_type = doc_def.data.approval.approval_type;
          }
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    preSave = function() {
      if (vm.document.approval && vm.document.approval.required === true) {
        if (vm.document.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return false;
        }
        if (angular.isUndefined(vm.document.approval.roles_id) || vm.document.approval.roles_id.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return false;
        }
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите принимающего!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.payment_type)) {
        toastr.warning('Укажите тип платежа!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.contractor_id)) {
        toastr.warning('Укажите контрагента!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.currency_id)) {
        toastr.warning('Укажите валюту!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.amount)) {
        toastr.warning('Укажите сумму!');
        vm.saving = false;
        return;
      }
      return true;
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.document.approval.roles_id ? vm.document.approval.roles_id : vm.document.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.document.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.document.approval.roles_id.indexOf(role_id);
      if (index > -1) {
        vm.document.approval.roles_id.splice(index, 1);
      }
    };
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    initDoc();
  }).controller('DocsRepaymentViewController', function($scope, $state, $uibModal) {
    'ngInject';
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DocsPurchaseReceptionEditController', function(hotkeys, $scope, $state, $stateParams, RequestService, toastr, uiGridConstants, $uibModal, $uibModalStack) {
    'ngInject';
    var addApprovalRole, delApprovalRole, getDefault, initDoc, linkPurchaseDoc, preSave, productEdit, productNew, productRemove, removeLinkPurchaseDoc, vm;
    vm = this;
    vm.productsGridOptions = {
      noUnselect: true,
      data: [],
      columnDefs: [
        {
          name: 'product_id',
          displayName: 'Продукт',
          cellTemplate: '<div class="ui-grid-cell-contents"><product-select-name product-id="grid.getCellValue(row,col)"></product-select-name></div>'
        }, {
          name: 'unit_id',
          displayName: 'Единица изм.',
          cellTemplate: '<div class="ui-grid-cell-contents" ng-init="units=[]" stock-dict="units" dict-table="Units" dict-filter="{_id:grid.getCellValue(row,col)}"><span ng-repeat="unit in units | filter:{_id:grid.getCellValue(row,col)} track by unit._id">{{unit.name}}</span></div>'
        }, {
          name: 'quantity',
          displayName: 'Количество'
        }, {
          name: 'comment',
          displayName: 'Комментарий'
        }
      ],
      events: {
        onRowSelect: function(data) {
          vm.selected_product = data.entity;
        }
      }
    };
    initDoc = function() {
      var product;
      vm.document = $scope.entry.document;
      if (!vm.document.data) {
        vm.document.data = {};
      }
      if (!vm.document.data.executor_id) {
        vm.document.data.executor_id = $scope.app.ua.id;
      }
      if (!vm.document.data.purchase_documents_id) {
        vm.document.data.purchase_documents_id = [];
      }
      if (!vm.document.purchase_documents) {
        vm.document.purchase_documents = [];
      }
      if ($stateParams.document && $stateParams.document.document_type === 'purchase') {
        vm.document.branch_id = $stateParams.document.branch_id;
        vm.document.data.contractor_id = $stateParams.document.data.contractor_id;
        vm.document.data.purchase_documents_id.push($stateParams.document._id);
        vm.document.purchase_documents.push($stateParams.document);
        vm.document.data.products = vm.document.data.products.concat((function() {
          var i, len, ref, results;
          ref = $stateParams.document.data.products;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            product = ref[i];
            results.push({
              product_id: product.product_id,
              unit_id: product.unit_id,
              quantity: product.quantity - product.delivered_quantity,
              comment: product.comment
            });
          }
          return results;
        })());
      }
      vm.productsGridOptions.data = angular.copy(vm.document.data.products || []);
      if (vm.productsGridOptions.gridApi) {
        vm.productsGridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      }
      getDefault();
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.approval_not_editable = doc_def.data.approval && doc_def.data.approval.required === true;
          if (vm.approval_not_editable) {
            vm.document.approval.required = doc_def.data.approval.required;
            vm.document.approval.roles_id = doc_def.data.approval.roles_id;
            vm.document.approval.approval_type = doc_def.data.approval.approval_type;
          }
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    preSave = function() {
      var product;
      if (vm.document.approval && vm.document.approval.required === true) {
        if (vm.document.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return false;
        }
        if (angular.isUndefined(vm.document.approval.roles_id) || vm.document.approval.roles_id.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return false;
        }
      }
      if (vm.productsGridOptions.data === void 0 || vm.productsGridOptions.data.length === 0) {
        toastr.warning('Добавьте товары!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.branch_id)) {
        toastr.warning('Укажите филиал!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите принимающего!');
        vm.saving = false;
        return;
      }
      vm.document.data.products = (function() {
        var i, len, ref, results;
        ref = vm.productsGridOptions.data;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push({
            product_id: product.product_id,
            unit_id: product.unit_id,
            quantity: product.quantity,
            comment: product.comment
          });
        }
        return results;
      })();
      return true;
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.document.approval.roles_id ? vm.document.approval.roles_id : vm.document.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.document.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.document.approval.roles_id.indexOf(role_id);
      if (index > -1) {
        vm.document.approval.roles_id.splice(index, 1);
      }
    };
    productNew = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/purchase_reception/product_select.html',
        controller: 'PurchaseReceptionProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: void 0
        }
      });
      editModal.result.then(function(product) {
        vm.productsGridOptions.data.push(product);
        return delete vm.selected_product;
      });
    };
    productEdit = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/purchase_reception/product_select.html',
        controller: 'PurchaseReceptionProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: angular.copy(vm.selected_product)
        }
      });
      editModal.result.then(function(product) {
        var index;
        index = vm.productsGridOptions.data.indexOf(vm.selected_product);
        vm.productsGridOptions.data.splice(index, 1, product);
        return delete vm.selected_product;
      });
    };
    productRemove = function() {
      var index;
      index = vm.productsGridOptions.data.indexOf(vm.selected_product);
      if (index !== -1) {
        vm.productsGridOptions.data.splice(index, 1);
      }
      delete vm.selected_product;
    };
    removeLinkPurchaseDoc = function(doc_id) {
      var index, pd_index, purchase_document, purchase_document_index;
      if (vm.document.data && vm.document.data.purchase_documents_id) {
        index = vm.document.data.purchase_documents_id.indexOf(doc_id);
        vm.document.data.purchase_documents_id.splice(index, 1);
      }
      pd_index = -1;
      for (purchase_document_index in vm.document.purchase_documents) {
        purchase_document = vm.document.purchase_documents[purchase_document_index];
        if (purchase_document._id === doc_id) {
          pd_index = purchase_document_index;
        }
      }
      return vm.document.purchase_documents.splice(pd_index, 1);
    };
    linkPurchaseDoc = function() {
      var linkModal;
      linkModal = $uibModal.open({
        templateUrl: 'app/docs/purchase_reception/purchase-select-modal.html',
        controller: 'PurchaseReceptionPurchaseSelectController',
        controllerAs: 'purchase',
        scope: $scope,
        resolve: {
          purchase_reception: vm.document
        }
      });
      return linkModal.result.then(function(result) {
        if (-1 < vm.document.data.purchase_documents_id.indexOf(result._id)) {
          toastr.warning("Документ уже привязан");
          return;
        }
        vm.document.data.purchase_documents_id.push(result._id);
        if (!vm.document.purchase_documents) {
          vm.document.purchase_documents = [];
        }
        return vm.document.purchase_documents.push(result);
      });
    };
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    vm.productNew = productNew;
    vm.productEdit = productEdit;
    vm.productRemove = productRemove;
    vm.removeLinkPurchaseDoc = removeLinkPurchaseDoc;
    vm.linkPurchaseDoc = linkPurchaseDoc;
    initDoc();
  }).controller('DocsPurchaseReceptionViewController', function($scope, $state) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('PurchaseReceptionProductSelectController', function($scope, Session, RequestService, toastr, product, $uibModalInstance) {
    'ngInject';
    var productSave, vm;
    vm = this;
    vm.product = product || {};
    productSave = function() {
      if (angular.isUndefined(vm.product.product_id)) {
        toastr.warning('Выберите продукт');
        return;
      }
      delete vm.product.unit;
      $uibModalInstance.close(vm.product);
    };
    vm.productSave = productSave;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('PurchaseReceptionPurchaseSelectController', function($scope, $uibModalInstance, RequestService, purchase_reception, $rootScope) {
    'ngInject';
    var getDocs, vm;
    vm = this;
    getDocs = function() {
      var filter;
      vm.doc_loading = true;
      filter = {
        filter: {
          document_type: 'purchase',
          document_status: 'committed',
          branch_id: purchase_reception.branch_id
        }
      };
      RequestService.post('doc.listing', filter).then(function(result) {
        vm.docs = result.docs;
        vm.doc_loading = false;
      }, function() {
        return vm.doc_loading = false;
      });
    };
    vm.getDocs = getDocs;
    vm.docSelect = function(document) {
      return $uibModalInstance.close(document);
    };
    vm.cancel = function() {
      return $uibModalInstance.dismiss('close');
    };
    getDocs();
  });

}).call(this);



(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('fsa').controller('DocsPurchaseEditController', function(hotkeys, $scope, $state, $stateParams, RequestService, toastr, uiGridConstants, $uibModal, $uibModalStack) {
    'ngInject';
    var addApprovalRole, delApprovalRole, getDefault, initDoc, linkOrderDoc, preSave, productEdit, productFromNew, productNew, productRemove, removeLinkOrderDoc, vm;
    vm = this;
    vm.productsGridOptions = {
      noUnselect: true,
      data: [],
      columnDefs: [
        {
          name: 'product_id',
          displayName: 'Продукт',
          cellTemplate: '<div class="ui-grid-cell-contents"><product-select-name product-id="grid.getCellValue(row,col)"></product-select-name></div>'
        }, {
          name: 'unit_id',
          displayName: 'Единица изм.',
          cellTemplate: '<div class="ui-grid-cell-contents" ng-init="units=[]" stock-dict="units" dict-table="Units" dict-filter="{_id:grid.getCellValue(row,col)}"><span ng-repeat="unit in units | filter:{_id:grid.getCellValue(row,col)} track by unit._id">{{unit.name}}</span></div>'
        }, {
          name: 'quantity',
          displayName: 'Количество'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена за ед.'
        }, {
          name: 'total_cost',
          displayName: 'Общая цена'
        }, {
          name: 'additional_cost',
          displayName: 'Дополнительная цена'
        }, {
          name: 'discount',
          displayName: 'Скидка (%)'
        }, {
          name: 'comment',
          displayName: 'Комментарий'
        }
      ],
      events: {
        onRowSelect: function(data) {
          if (data.grid.id === vm.productsGridOptions.gridApi.grid.id) {
            vm.selected_product = data.entity;
          }
        }
      }
    };
    vm.fromProductsGridOptions = {
      noUnselect: true,
      data: [],
      columnDefs: [
        {
          name: 'product.name',
          displayName: 'Продукт'
        }, {
          name: 'unit.name',
          displayName: 'Единица изм.'
        }, {
          name: 'quantity',
          displayName: 'Количество'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена за ед.'
        }, {
          name: 'total_cost',
          displayName: 'Общая цена'
        }, {
          name: 'additional_cost',
          displayName: 'Дополнительная цена'
        }, {
          name: 'comment',
          displayName: 'Комментарий'
        }
      ],
      events: {
        onRowSelect: function(data) {
          if (data.grid.id === vm.fromProductsGridOptions.gridApi.grid.id) {
            vm.selected_from_product = data.entity;
          }
        }
      }
    };
    initDoc = function() {
      var product;
      vm.document = $scope.entry.document;
      if (!vm.document.data) {
        vm.document.data = {};
      }
      if (!vm.document.data.executor_id) {
        vm.document.data.executor_id = $scope.app.ua.id;
      }
      if (!vm.document.data.order_documents_id) {
        vm.document.data.order_documents_id = [];
      }
      if (!vm.document.order_documents) {
        vm.document.order_documents = [];
      }
      if ($stateParams.document && $stateParams.document.document_type === 'order') {
        vm.document.branch_id = $stateParams.document.branch_id;
        vm.document.data.executor_id = $stateParams.document.data.user_id;
        vm.document.data.order_documents_id.push($stateParams.document._id);
        vm.document.order_documents.push($stateParams.document);
        vm.document.data.products = vm.document.data.products.concat((function() {
          var i, len, ref, results;
          ref = $stateParams.document.data.products;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            product = ref[i];
            if (product.selected) {
              results.push({
                product_id: product.product_id,
                unit_id: product.unit_id,
                quantity: product.quantity - product.bought_quantity,
                comment: product.comment
              });
            }
          }
          return results;
        })());
      }
      vm.productsGridOptions.data = angular.copy(vm.document.data.products || []);
      vm.fromProductsGridOptions.data = angular.copy(vm.document.data.from_products || []);
      getDefault();
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.approval_not_editable = doc_def.data.approval && doc_def.data.approval.required === true;
          if (vm.approval_not_editable) {
            vm.document.approval.required = doc_def.data.approval.required;
            vm.document.approval.roles_id = doc_def.data.approval.roles_id;
            vm.document.approval.approval_type = doc_def.data.approval.approval_type;
          }
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    preSave = function() {
      var product;
      if (vm.document.approval && vm.document.approval.required === true) {
        if (vm.document.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return false;
        }
        if (angular.isUndefined(vm.document.approval.roles_id) || vm.document.approval.roles_id.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return false;
        }
      }
      if (vm.productsGridOptions.data === void 0 || vm.productsGridOptions.data.length === 0) {
        toastr.warning('Добавьте товары!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.branch_id)) {
        toastr.warning('Укажите филиал!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите исполнителя!');
        vm.saving = false;
        return;
      }
      if (vm.document.data.is_advance === true) {
        delete vm.document.data.is_due;
        delete vm.document.data.due_date;
        if (angular.isUndefined(vm.document.data.employee_id)) {
          toastr.warning('Укажите сотрудника!');
          vm.saving = false;
          return;
        }
      }
      if (!vm.document.data.delivered_products) {
        vm.document.data.delivered_products = [];
      }
      vm.document.data.products = (function() {
        var i, len, ref, results;
        ref = vm.productsGridOptions.data;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push({
            product_id: product.product_id,
            unit_id: product.unit_id,
            rules_id: product.rules_id,
            quote_unit_price: product.quote_unit_price,
            quantity: product.quantity,
            delivered_quantity: product.delivered_quantity,
            total_cost: product.total_cost,
            additional_cost: product.additional_cost,
            discount: product.discount,
            comment: product.comment
          });
        }
        return results;
      })();
      return true;
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.document.approval.roles_id ? vm.document.approval.roles_id : vm.document.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.document.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.document.approval.roles_id.indexOf(role_id);
      if (index > -1) {
        vm.document.approval.roles_id.splice(index, 1);
      }
    };
    productNew = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/purchase/product_select.html',
        controller: 'PurchaseProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: void 0
        }
      });
      editModal.result.then(function(product) {
        vm.productsGridOptions.data.push(product);
        return delete vm.selected_product;
      });
    };
    productEdit = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/purchase/product_select.html',
        controller: 'PurchaseProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: angular.copy(vm.selected_product)
        }
      });
      editModal.result.then(function(product) {
        var index;
        index = vm.productsGridOptions.data.indexOf(vm.selected_product);
        vm.productsGridOptions.data.splice(index, 1, product);
        return delete vm.selected_product;
      });
    };
    productRemove = function() {
      var index;
      index = vm.productsGridOptions.data.indexOf(vm.selected_product);
      if (index !== -1) {
        vm.productsGridOptions.data.splice(index, 1);
      }
      delete vm.selected_product;
    };
    productFromNew = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/components/productSelect/select.html',
        controller: 'ProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          modalOptions: {},
          search: vm.selected_from_product
        }
      });
      return editModal.result.then(function(result) {
        editModal = $uibModal.open({
          templateUrl: 'app/docs/purchase/product_select.html',
          controller: 'PurchaseProductSelectController',
          controllerAs: 'product',
          size: 'lg',
          scope: $scope,
          resolve: {
            product: angular.copy({
              product_id: result._id,
              quantity: vm.selected_from_product.quantity,
              quote_unit_price: vm.selected_from_product.quote_unit_price,
              additional_cost: vm.selected_from_product.additional_cost,
              total_cost: vm.selected_from_product.total_cost
            })
          }
        });
        editModal.result.then(function(product) {
          vm.productsGridOptions.data.push(product);
          return delete vm.selected_product;
        });
      });
    };
    removeLinkOrderDoc = function(doc_id) {
      var index, od_index, order_document, order_document_index;
      if (vm.document.data && vm.document.data.order_documents_id) {
        index = vm.document.data.order_documents_id.indexOf(doc_id);
        vm.document.data.order_documents_id.splice(index, 1);
      }
      od_index = -1;
      for (order_document_index in vm.document.order_documents) {
        order_document = vm.document.order_documents[order_document_index];
        if (order_document._id === doc_id) {
          od_index = order_document_index;
        }
      }
      return vm.document.order_documents.splice(od_index, 1);
    };
    linkOrderDoc = function() {
      var linkModal;
      linkModal = $uibModal.open({
        templateUrl: 'app/docs/purchase/order-select-modal.html',
        controller: 'PurchaseOrderSelectController',
        controllerAs: 'order',
        scope: $scope,
        resolve: {
          purchase: vm.document
        }
      });
      return linkModal.result.then(function(result) {
        if (-1 < vm.document.data.order_documents_id.indexOf(result._id)) {
          toastr.warning("Документ уже привязан");
          return;
        }
        vm.document.data.order_documents_id.push(result._id);
        if (!vm.document.order_documents) {
          vm.document.order_documents = [];
        }
        return vm.document.order_documents.push(result);
      });
    };
    $scope.$watch('purchase.payment_method', function() {
      if (vm.payment_method === 'cash') {
        vm.document.data.is_due = false;
        vm.document.data.is_advance = false;
      } else if (vm.payment_method === 'debt') {
        vm.document.data.is_due = true;
        vm.document.data.is_advance = false;
      } else if (vm.payment_method === 'advance') {
        vm.document.data.is_advance = true;
        vm.document.data.is_due = false;
      }
    });
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    vm.productNew = productNew;
    vm.productEdit = productEdit;
    vm.productRemove = productRemove;
    vm.productFromNew = productFromNew;
    vm.removeLinkOrderDoc = removeLinkOrderDoc;
    vm.linkOrderDoc = linkOrderDoc;
    initDoc();
  }).controller('DocsPurchaseViewController', function($scope, $state, $uibModal) {
    'ngInject';
    var canCreatePurchaseReception, createPurchaseReception, fromTotalSum, totalSum, vm;
    vm = this;
    totalSum = function() {
      var product;
      return ((function() {
        var i, len, ref, ref1, ref2, results;
        ref = ($scope.view.document && $scope.view.document.data.products ? $scope.view.document.data.products : []);
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push(1 * ((ref1 = product.total_cost) != null ? ref1 : 0) + 1 * ((ref2 = product.additional_cost) != null ? ref2 : 0));
        }
        return results;
      })()).reduce(function(a, b) {
        return 1 * (a != null ? a : 0) + 1 * (b != null ? b : 0);
      }, 0);
    };
    fromTotalSum = function() {
      var product;
      return ((function() {
        var i, len, ref, ref1, ref2, results;
        ref = ($scope.view.document && $scope.view.document.data.from_products ? $scope.view.document.data.from_products : []);
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push(1 * ((ref1 = product.total_cost) != null ? ref1 : 0) + 1 * ((ref2 = product.additional_cost) != null ? ref2 : 0));
        }
        return results;
      })()).reduce(function(a, b) {
        return 1 * (a != null ? a : 0) + 1 * (b != null ? b : 0);
      }, 0);
    };
    createPurchaseReception = function() {
      var purchaseModal;
      purchaseModal = $uibModal.open({
        templateUrl: 'app/docs/purchase/purchase_reception-select-modal.html',
        controller: 'PurchasePurchaseReceptionSelectController',
        controllerAs: 'purchase_reception',
        scope: $scope,
        resolve: {
          purchase: $scope.view.document
        }
      });
      purchaseModal.result.then(function(result) {
        return $state.go('app.docs.entry', {
          id: result.id,
          type: 'purchase_reception',
          document: $scope.view.document
        });
      });
    };
    canCreatePurchaseReception = function() {
      var i, len, product, ref;
      if ($scope.view.document && $scope.view.document.data && $scope.app.ua && $scope.view.document.document_status === 'committed') {
        ref = $scope.view.document.data.products;
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          if (product.quantity > product.delivered_quantity) {
            return true;
          }
        }
      }
      return false;
    };
    vm.totalSum = totalSum;
    vm.fromTotalSum = fromTotalSum;
    vm.createPurchaseReception = createPurchaseReception;
    vm.canCreatePurchaseReception = canCreatePurchaseReception;
  }).controller('PurchaseProductSelectController', function($scope, Session, RequestService, toastr, product, $uibModalInstance) {
    'ngInject';
    var calcTotalCost, calcUnitPrice, isEmpty, onProductLoaded, onRuleSelect, onRulesLoaded, productSave, vm;
    vm = this;
    vm.product = product || {};
    isEmpty = function(value) {
      return angular.isUndefined(value) || value === null || value === '';
    };
    productSave = function() {
      if (angular.isUndefined(vm.product.product_id)) {
        toastr.warning('Выберите продукт');
        return;
      }
      delete vm.product.unit;
      $uibModalInstance.close(vm.product);
    };
    calcTotalCost = function(product) {
      var d, q, qup, ref, ref1, ref2;
      if (isEmpty(product) || isEmpty(product.quantity) || isEmpty(product.quote_unit_price)) {
        return;
      }
      q = (ref = product.quantity) != null ? ref : 0;
      qup = (ref1 = product.quote_unit_price) != null ? ref1 : 0;
      d = (ref2 = product.discount) != null ? ref2 : 0;
      product.total_cost = (q * qup / 100 * (100 - d)).toFixed(2) * 1;
    };
    calcUnitPrice = function(product) {
      var q, ref, ref1, tc;
      if (isEmpty(product) || isEmpty(product.quantity) || isEmpty(product.total_cost)) {
        return;
      }
      q = (ref = product.quantity) != null ? ref : 0;
      tc = (ref1 = product.total_cost) != null ? ref1 : 0;
      product.quote_unit_price = (tc / q).toFixed(2) * 1;
    };
    onRuleSelect = function() {
      var i, len, pr, ref, ref1;
      vm.product.discount = 0;
      ref = vm.pr;
      for (i = 0, len = ref.length; i < len; i++) {
        pr = ref[i];
        if (ref1 = pr._id, indexOf.call(vm.product.rules_id, ref1) >= 0) {
          vm.product.discount += pr.discount;
        }
      }
      calcTotalCost(vm.product);
    };
    onProductLoaded = function(product) {
      if (product && product.data && product.data.price) {
        vm.product.quote_unit_price = product.data.price;
      }
      calcTotalCost(vm.product);
    };
    onRulesLoaded = function() {
      var pr, rule_id, rules_id;
      rules_id = (function() {
        var i, len, ref, results;
        ref = vm.pr;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          pr = ref[i];
          results.push(pr._id);
        }
        return results;
      })();
      vm.product.rules_id = (function() {
        var i, len, ref, results;
        ref = vm.product.rules_id;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          rule_id = ref[i];
          if (indexOf.call(rules_id, rule_id) >= 0) {
            results.push(rule_id);
          }
        }
        return results;
      })();
      calcTotalCost(vm.product);
    };
    vm.productSave = productSave;
    vm.calcTotalCost = calcTotalCost;
    vm.calcUnitPrice = calcUnitPrice;
    vm.onRuleSelect = onRuleSelect;
    vm.onProductLoaded = onProductLoaded;
    vm.onRulesLoaded = onRulesLoaded;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('PurchaseOrderSelectController', function($scope, $uibModalInstance, RequestService, purchase, $rootScope) {
    'ngInject';
    var getDocs, vm;
    vm = this;
    getDocs = function() {
      var filter;
      vm.doc_loading = true;
      filter = {
        filter: {
          document_type: 'order',
          document_status: 'approved',
          branch_id: purchase.branch_id
        }
      };
      RequestService.post('doc.listing', filter).then(function(result) {
        vm.docs = result.docs;
        vm.doc_loading = false;
      }, function() {
        return vm.doc_loading = false;
      });
    };
    vm.getDocs = getDocs;
    vm.docSelect = function(document) {
      return $uibModalInstance.close(document);
    };
    vm.cancel = function() {
      return $uibModalInstance.dismiss('close');
    };
    getDocs();
  }).controller('PurchasePurchaseReceptionSelectController', function($scope, $uibModalInstance, RequestService, purchase, $rootScope) {
    'ngInject';
    var getDocs, vm;
    vm = this;
    getDocs = function() {
      var filter;
      vm.doc_loading = true;
      filter = {
        filter: {
          document_type: 'purchase_reception',
          document_status: 'draft',
          branch_id: purchase.branch_id,
          data: {
            user_id: $scope.app.ua.id
          }
        }
      };
      RequestService.post('doc.listing', filter).then(function(result) {
        vm.docs = result.docs;
        vm.doc_loading = false;
      }, function() {
        return vm.doc_loading = false;
      });
    };
    vm.getDocs = getDocs;
    vm.docSelect = function(id) {
      return $uibModalInstance.close({
        id: id
      });
    };
    vm.cancel = function() {
      return $uibModalInstance.dismiss('close');
    };
    getDocs();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DocsOrderEditController', function(hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal, $uibModalStack) {
    'ngInject';
    var getDefault, initDoc, preSave, productEdit, productNew, productRemove, selectProduct, vm;
    vm = this;
    vm.productsGridOptions = {
      noUnselect: true,
      data: [],
      columnDefs: [
        {
          name: 'product_id',
          displayName: 'Продукт',
          cellTemplate: '<div class="ui-grid-cell-contents"><product-select-name product-id="grid.getCellValue(row,col)"></product-select-name></div>'
        }, {
          name: 'unit_id',
          displayName: 'Единица изм.',
          cellTemplate: '<div class="ui-grid-cell-contents" ng-init="units=[]" stock-dict="units" dict-table="Units" dict-filter="{_id:grid.getCellValue(row,col)}"><span ng-repeat="unit in units | filter:{_id:grid.getCellValue(row,col)} track by unit._id">{{unit.name}}</span></div>'
        }, {
          name: 'quantity',
          displayName: 'Количество'
        }, {
          name: 'comment',
          displayName: 'Комментарий'
        }
      ],
      events: {
        onRowSelect: function(data) {
          vm.selected_product = data.entity;
        }
      }
    };
    initDoc = function() {
      vm.document = $scope.entry.document;
      vm.productsGridOptions.data = angular.copy(vm.document.data.products || []);
      if (vm.productsGridOptions.gridApi) {
        vm.productsGridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      }
      getDefault();
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    preSave = function() {
      var product;
      if (vm.productsGridOptions.data === void 0 || vm.productsGridOptions.data.length === 0) {
        toastr.warning('Добавьте товары!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.branch_id)) {
        toastr.warning('Укажите филиал!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите исполнителя!');
        vm.saving = false;
        return;
      }
      if (!vm.document.data.executed_products) {
        vm.document.data.executed_products = [];
      }
      vm.document.data.products = (function() {
        var i, len, ref, results;
        ref = vm.productsGridOptions.data;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push({
            product_id: product.product_id,
            unit_id: product.unit_id,
            quantity: product.quantity,
            comment: product.comment,
            executed: product.executed,
            bought_quantity: product.bought_quantity
          });
        }
        return results;
      })();
      return true;
    };
    productNew = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/order/product_select.html',
        controller: 'OrderProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: void 0
        }
      });
      editModal.result.then(function(product) {
        vm.productsGridOptions.data.push(product);
        return delete vm.selected_product;
      });
    };
    productEdit = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/order/product_select.html',
        controller: 'OrderProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: angular.copy(vm.selected_product)
        }
      });
      editModal.result.then(function(product) {
        var index;
        index = vm.productsGridOptions.data.indexOf(vm.selected_product);
        vm.productsGridOptions.data.splice(index, 1, product);
        return delete vm.selected_product;
      });
    };
    productRemove = function() {
      var index;
      index = vm.productsGridOptions.data.indexOf(vm.selected_product);
      if (index !== -1) {
        vm.productsGridOptions.data.splice(index, 1);
      }
      delete vm.selected_product;
    };
    selectProduct = function(product) {
      if (product.active === true) {
        return;
      }
      return product.selected = !product.selected;
    };
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.productNew = productNew;
    vm.productEdit = productEdit;
    vm.productRemove = productRemove;
    vm.selectProduct = selectProduct;
    initDoc();
  }).controller('DocsOrderViewController', function($scope, $state, $uibModal) {
    'ngInject';
    var canCreatePurchase, createPurchase, vm;
    vm = this;
    createPurchase = function() {
      var product, products, purchaseModal;
      products = (function() {
        var i, len, ref, results;
        ref = $scope.view.document.data.products;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          if (product.selected) {
            results.push(product);
          }
        }
        return results;
      })();
      if (products.length > 0) {
        purchaseModal = $uibModal.open({
          templateUrl: 'app/docs/order/purchase-select-modal.html',
          controller: 'OrderPurchaseSelectController',
          controllerAs: 'purchase',
          scope: $scope,
          resolve: {
            order: $scope.view.document
          }
        });
        purchaseModal.result.then(function(result) {
          return $state.go('app.docs.entry', {
            id: result.id,
            type: 'purchase',
            document: $scope.view.document
          });
        });
      }
    };
    canCreatePurchase = function() {
      if ($scope.view.document && $scope.view.document.data && $scope.app.ua) {
        return $scope.view.document.document_status === 'approved' && $scope.view.document.data.executor_id === $scope.app.ua.id;
      }
      return false;
    };
    vm.createPurchase = createPurchase;
    vm.canCreatePurchase = canCreatePurchase;
  }).controller('OrderProductSelectController', function($scope, Session, RequestService, toastr, product, $uibModalInstance) {
    'ngInject';
    var productSave, vm;
    vm = this;
    vm.product = product || {};
    productSave = function() {
      if (angular.isUndefined(vm.product.product_id)) {
        toastr.warning('Выберите продукт');
        return;
      }
      delete vm.product.unit;
      $uibModalInstance.close(vm.product);
    };
    vm.productSave = productSave;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('OrderPurchaseSelectController', function($scope, $uibModalInstance, RequestService, order, $rootScope) {
    'ngInject';
    var getDocs, vm;
    vm = this;
    getDocs = function() {
      var filter;
      vm.doc_loading = true;
      filter = {
        filter: {
          document_type: 'purchase',
          document_status: 'draft',
          branch_id: order.branch_id,
          data: {
            user_id: $scope.app.ua.id
          }
        }
      };
      RequestService.post('doc.listing', filter).then(function(result) {
        vm.docs = result.docs;
        vm.doc_loading = false;
      }, function() {
        return vm.doc_loading = false;
      });
    };
    vm.getDocs = getDocs;
    vm.docSelect = function(id) {
      return $uibModalInstance.close({
        id: id
      });
    };
    vm.cancel = function() {
      return $uibModalInstance.dismiss('close');
    };
    getDocs();
  });

}).call(this);



(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('fsa').controller('DocsMoveEditController', function(hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal, $uibModalStack) {
    'ngInject';
    var addApprovalRole, delApprovalRole, getDefault, initDoc, preSave, productEdit, productNew, productRemove, vm;
    vm = this;
    vm.productsGridOptions = {
      noUnselect: true,
      data: [],
      columnDefs: [
        {
          name: 'product_id',
          displayName: 'Продукт',
          cellTemplate: '<div class="ui-grid-cell-contents"><product-select-name product-id="grid.getCellValue(row,col)"></product-select-name></div>'
        }, {
          name: 'unit_id',
          displayName: 'Единица изм.',
          cellTemplate: '<div class="ui-grid-cell-contents" ng-init="units=[]" stock-dict="units" dict-table="Units" dict-filter="{_id:grid.getCellValue(row,col)}"><span ng-repeat="unit in units | filter:{_id:grid.getCellValue(row,col)} track by unit._id">{{unit.name}}</span></div>'
        }, {
          name: 'quantity',
          displayName: 'Количество'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена за ед.'
        }, {
          name: 'total_cost',
          displayName: 'Общая цена'
        }, {
          name: 'additional_cost',
          displayName: 'Дополнительная цена'
        }, {
          name: 'discount',
          displayName: 'Скидка (%)'
        }, {
          name: 'comment',
          displayName: 'Комментарий'
        }
      ],
      events: {
        onRowSelect: function(data) {
          vm.selected_product = data.entity;
        }
      }
    };
    initDoc = function() {
      vm.document = $scope.entry.document;
      vm.productsGridOptions.data = angular.copy(vm.document.data.products || []);
      if (vm.productsGridOptions.gridApi) {
        vm.productsGridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      }
      getDefault();
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.approval_not_editable = doc_def.data.approval && doc_def.data.approval.required === true;
          if (vm.approval_not_editable) {
            vm.document.approval.required = doc_def.data.approval.required;
            vm.document.approval.roles_id = doc_def.data.approval.roles_id;
            vm.document.approval.approval_type = doc_def.data.approval.approval_type;
          }
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    preSave = function() {
      var product;
      if (vm.document.approval && vm.document.approval.required === true) {
        if (vm.document.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return false;
        }
        if (angular.isUndefined(vm.document.approval.roles_id) || vm.document.approval.roles_id.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return false;
        }
      }
      if (vm.productsGridOptions.data === void 0 || vm.productsGridOptions.data.length === 0) {
        toastr.warning('Добавьте товары!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.branch_id)) {
        toastr.warning('Укажите филиал!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.branch_id)) {
        toastr.warning('Укажите филиал назначения!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите исполнителя!');
        vm.saving = false;
        return;
      }
      vm.document.data.products = (function() {
        var i, len, ref, results;
        ref = vm.productsGridOptions.data;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push({
            product_id: product.product_id,
            unit_id: product.unit_id,
            rules_id: product.rules_id,
            quote_unit_price: product.quote_unit_price,
            quantity: product.quantity,
            total_cost: product.total_cost,
            additional_cost: product.additional_cost,
            discount: product.discount,
            comment: product.comment
          });
        }
        return results;
      })();
      return true;
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.document.approval.roles_id ? vm.document.approval.roles_id : vm.document.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.document.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.document.approval.roles_id.indexOf(role_id);
      if (index > -1) {
        vm.document.approval.roles_id.splice(index, 1);
      }
    };
    productNew = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/move/product_select.html',
        controller: 'MoveProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: void 0
        }
      });
      editModal.result.then(function(product) {
        vm.productsGridOptions.data.push(product);
        return delete vm.selected_product;
      });
    };
    productEdit = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/move/product_select.html',
        controller: 'MoveProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: angular.copy(vm.selected_product)
        }
      });
      editModal.result.then(function(product) {
        var index;
        index = vm.productsGridOptions.data.indexOf(vm.selected_product);
        vm.productsGridOptions.data.splice(index, 1, product);
        return delete vm.selected_product;
      });
    };
    productRemove = function() {
      var index;
      index = vm.productsGridOptions.data.indexOf(vm.selected_product);
      if (index !== -1) {
        vm.productsGridOptions.data.splice(index, 1);
      }
      delete vm.selected_product;
    };
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    vm.productNew = productNew;
    vm.productEdit = productEdit;
    vm.productRemove = productRemove;
    initDoc();
  }).controller('DocsMoveViewController', function($scope, $state) {
    'ngInject';
    var totalSum, vm;
    vm = this;
    totalSum = function() {
      var product;
      return ((function() {
        var i, len, ref, ref1, ref2, results;
        ref = ($scope.view.document && $scope.view.document.data.products ? $scope.view.document.data.products : []);
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push(1 * ((ref1 = product.total_cost) != null ? ref1 : 0) + 1 * ((ref2 = product.additional_cost) != null ? ref2 : 0));
        }
        return results;
      })()).reduce(function(a, b) {
        return 1 * (a != null ? a : 0) + 1 * (b != null ? b : 0);
      }, 0);
    };
    vm.totalSum = totalSum;
  }).controller('MoveProductSelectController', function($scope, Session, RequestService, toastr, product, $uibModalInstance) {
    'ngInject';
    var calcTotalCost, calcUnitPrice, isEmpty, onProductLoaded, onRuleSelect, onRulesLoaded, productSave, vm;
    vm = this;
    vm.product = product || {};
    isEmpty = function(value) {
      return angular.isUndefined(value) || value === null || value === '';
    };
    productSave = function() {
      if (angular.isUndefined(vm.product.product_id)) {
        toastr.warning('Выберите продукт');
        return;
      }
      delete vm.product.unit;
      $uibModalInstance.close(vm.product);
    };
    calcTotalCost = function(product) {
      var d, q, qup, ref, ref1, ref2;
      if (isEmpty(product) || isEmpty(product.quantity) || isEmpty(product.quote_unit_price)) {
        return;
      }
      q = (ref = product.quantity) != null ? ref : 0;
      qup = (ref1 = product.quote_unit_price) != null ? ref1 : 0;
      d = (ref2 = product.discount) != null ? ref2 : 0;
      product.total_cost = (q * qup / 100 * (100 - d)).toFixed(2) * 1;
    };
    calcUnitPrice = function(product) {
      var q, ref, ref1, tc;
      if (isEmpty(product) || isEmpty(product.quantity) || isEmpty(product.total_cost)) {
        return;
      }
      q = (ref = product.quantity) != null ? ref : 0;
      tc = (ref1 = product.total_cost) != null ? ref1 : 0;
      product.quote_unit_price = (tc / q).toFixed(2) * 1;
    };
    onRuleSelect = function() {
      var i, len, pr, ref, ref1;
      vm.product.discount = 0;
      ref = vm.pr;
      for (i = 0, len = ref.length; i < len; i++) {
        pr = ref[i];
        if (ref1 = pr._id, indexOf.call(vm.product.rules_id, ref1) >= 0) {
          vm.product.discount += pr.discount;
        }
      }
      calcTotalCost(vm.product);
    };
    onProductLoaded = function(product) {
      if (product && product.data && product.data.price) {
        vm.product.quote_unit_price = product.data.price;
      }
      calcTotalCost(vm.product);
    };
    onRulesLoaded = function() {
      var pr, rule_id, rules_id;
      rules_id = (function() {
        var i, len, ref, results;
        ref = vm.pr;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          pr = ref[i];
          results.push(pr._id);
        }
        return results;
      })();
      vm.product.rules_id = (function() {
        var i, len, ref, results;
        ref = vm.product.rules_id;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          rule_id = ref[i];
          if (indexOf.call(rules_id, rule_id) >= 0) {
            results.push(rule_id);
          }
        }
        return results;
      })();
      calcTotalCost(vm.product);
    };
    vm.productSave = productSave;
    vm.calcTotalCost = calcTotalCost;
    vm.calcUnitPrice = calcUnitPrice;
    vm.onRuleSelect = onRuleSelect;
    vm.onProductLoaded = onProductLoaded;
    vm.onRulesLoaded = onRulesLoaded;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('fsa').controller('DocsMedicalExaminationEditController', function(hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal) {
    'ngInject';
    var currenciesLoaded, discountEdit, getDefault, initDoc, preSave, productNew, productRemove, vm;
    vm = this;
    vm.contractorModalOptions = {
      title: "Выбрать пациента",
      can_create: true,
      filter: {
        contractor_type: 'client'
      }
    };
    vm.productsGridOptions = {
      noUnselect: true,
      data: [],
      columnDefs: [
        {
          name: 'product_id',
          displayName: 'Услуга',
          cellTemplate: '<div class="ui-grid-cell-contents"><product-select-name product-id="grid.getCellValue(row,col)"></product-select-name></div>'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена'
        }, {
          name: 'total_cost',
          displayName: 'Итоговая цена'
        }, {
          name: 'discount',
          displayName: 'Скидка (%)'
        }, {
          name: 'comment',
          displayName: 'Комментарий'
        }
      ],
      events: {
        onRowSelect: function(data) {
          if (data.grid.id === vm.productsGridOptions.gridApi.grid.id) {
            vm.selected_product = data.entity;
          }
        }
      }
    };
    initDoc = function() {
      vm.document = $scope.entry.document;
      vm.productsGridOptions.data = angular.copy(vm.document.data.products || []);
      getDefault();
      if (angular.isUndefined(vm.document.data.reception_date)) {
        vm.document.data.reception_date = new Date();
      }
      if (angular.isUndefined(vm.document.branch_id && $scope.app.uc)) {
        vm.document.branch_id = $scope.app.uc.branches_id[0];
      }
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    preSave = function() {
      var now, product;
      if (vm.productsGridOptions.data === void 0 || vm.productsGridOptions.data.length === 0) {
        toastr.warning('Добавьте услуги!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.branch_id)) {
        toastr.warning('Укажите филиал!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите принимающего!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.title)) {
        now = moment().format('DD.MM.YY HH.mm.ss');
        vm.document.title = vm.document.data.patient.name + " " + now;
      }
      vm.document.data.products = (function() {
        var i, len, ref, results;
        ref = vm.productsGridOptions.data;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push({
            product_id: product.product_id,
            unit_id: product.unit_id,
            rules_id: product.rules_id,
            quantity: product.quantity,
            quote_unit_price: product.quote_unit_price,
            payd_quantity: product.payd_quantity,
            total_cost: product.total_cost,
            discount: product.discount,
            comment: product.comment
          });
        }
        return results;
      })();
      return true;
    };
    productNew = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/components/productSelect/select.html',
        controller: 'ProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          modalOptions: {
            columns: ['name', 'data.price'],
            title: 'Выбрать услугу',
            filter: {
              product_type: 'service'
            }
          },
          search: null
        }
      });
      editModal.result.then(function(product) {
        vm.productsGridOptions.data.push({
          product_id: product._id,
          unit_id: product.data.unit_id,
          quantity: 1,
          quote_unit_price: product.data.price,
          total_cost: product.data.price,
          discount: 0,
          rules_id: []
        });
        return delete vm.selected_product;
      });
    };
    discountEdit = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/medical_examination/discount_select.html',
        controller: 'MedicalExaminationDiscountSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: angular.copy(vm.selected_product)
        }
      });
      editModal.result.then(function(product) {
        var index;
        index = vm.productsGridOptions.data.indexOf(vm.selected_product);
        vm.productsGridOptions.data.splice(index, 1, product);
        return delete vm.selected_product;
      });
    };
    productRemove = function() {
      var index;
      index = vm.productsGridOptions.data.indexOf(vm.selected_product);
      if (index !== -1) {
        vm.productsGridOptions.data.splice(index, 1);
      }
      delete vm.selected_product;
    };
    currenciesLoaded = function(event) {
      var currency, i, len, ref, results;
      if (!vm.document.data.currency_id) {
        ref = vm.currencies || [];
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          currency = ref[i];
          if (currency.data.name = 'KGS') {
            results.push(vm.document.data.currency_id = currency._id);
          }
        }
        return results;
      }
    };
    $scope.$watch('medical_examination.payment_method', function() {
      if (vm.payment_method === 'cash') {
        vm.document.data.is_due = false;
      } else if (vm.payment_method === 'debt') {
        vm.document.data.is_due = true;
      }
    });
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.productNew = productNew;
    vm.discountEdit = discountEdit;
    vm.productRemove = productRemove;
    vm.currenciesLoaded = currenciesLoaded;
    initDoc();
  }).controller('DocsMedicalExaminationViewController', function($scope, $state, $uibModal) {
    'ngInject';
    var canCreateCustomerPayment, createCustomerPayment, totalSum, vm;
    vm = this;
    totalSum = function() {
      var product;
      return ((function() {
        var i, len, ref, ref1, results;
        ref = ($scope.view.document && $scope.view.document.data.products ? $scope.view.document.data.products : []);
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push(1 * ((ref1 = product.total_cost) != null ? ref1 : 0));
        }
        return results;
      })()).reduce(function(a, b) {
        return 1 * (a != null ? a : 0) + 1 * (b != null ? b : 0);
      }, 0);
    };
    createCustomerPayment = function() {
      var customer_paymentModal;
      customer_paymentModal = $uibModal.open({
        templateUrl: 'app/docs/medical_examination/customer_payment-select-modal.html',
        controller: 'MedicalExaminationCustomerPaymentSelectController',
        controllerAs: 'customer_payment',
        scope: $scope,
        resolve: {
          medical_examination: $scope.view.document
        }
      });
      customer_paymentModal.result.then(function(result) {
        return $state.go('app.docs.entry', {
          id: result.id,
          type: 'customer_payment',
          document: $scope.view.document
        });
      });
    };
    canCreateCustomerPayment = function() {
      var i, len, product, ref;
      if ($scope.view.document && $scope.view.document.data && $scope.app.ua && $scope.view.document.document_status === 'approved') {
        ref = $scope.view.document.data.products;
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          if (product.quantity > product.payd_quantity) {
            return true;
          }
        }
      }
      return false;
    };
    vm.totalSum = totalSum;
    vm.createCustomerPayment = createCustomerPayment;
    vm.canCreateCustomerPayment = canCreateCustomerPayment;
  }).controller('MedicalExaminationDiscountSelectController', function($scope, Session, RequestService, toastr, product, $uibModalInstance) {
    'ngInject';
    var calcTotalCost, onRuleSelect, productSave, vm;
    vm = this;
    vm.product = product || {};
    vm.productModalOptions = {
      title: 'Выбрать услугу',
      filter: {
        product_type: 'service'
      }
    };
    productSave = function() {
      if (angular.isUndefined(vm.product.product_id)) {
        toastr.warning('Выберите продукт');
        return;
      }
      delete vm.product.unit;
      $uibModalInstance.close(vm.product);
    };
    calcTotalCost = function(product) {
      var d, q, qup, ref, ref1, ref2;
      q = (ref = product.quantity) != null ? ref : 0;
      d = (ref1 = product.discount) != null ? ref1 : 0;
      qup = (ref2 = product.quote_unit_price) != null ? ref2 : 0;
      product.total_cost = q * qup / 100 * (100 - d);
    };
    onRuleSelect = function() {
      var i, len, pr, ref, ref1;
      vm.product.discount = 0;
      ref = vm.pr;
      for (i = 0, len = ref.length; i < len; i++) {
        pr = ref[i];
        if (ref1 = pr._id, indexOf.call(vm.product.rules_id, ref1) >= 0) {
          vm.product.discount += pr.discount;
        }
      }
      calcTotalCost(vm.product);
    };
    vm.productSave = productSave;
    vm.calcTotalCost = calcTotalCost;
    vm.onRuleSelect = onRuleSelect;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('MedicalExaminationCustomerPaymentSelectController', function($scope, $uibModalInstance, RequestService, medical_examination, $rootScope) {
    'ngInject';
    var getDocs, vm;
    vm = this;
    getDocs = function() {
      var filter;
      vm.doc_loading = true;
      filter = {
        filter: {
          document_type: 'customer_payment',
          document_status: 'draft',
          branch_id: medical_examination.branch_id,
          data: {
            user_id: $scope.app.ua.id,
            currency_id: medical_examination.data.currency_id
          }
        }
      };
      RequestService.post('doc.listing', filter).then(function(result) {
        vm.docs = result.docs;
        vm.doc_loading = false;
      }, function() {
        return vm.doc_loading = false;
      });
    };
    vm.getDocs = getDocs;
    vm.docSelect = function(id) {
      return $uibModalInstance.close({
        id: id
      });
    };
    vm.cancel = function() {
      return $uibModalInstance.dismiss('close');
    };
    getDocs();
  });

}).call(this);



(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('fsa').controller('DocsLetterEditController', function(hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal, $uibModalStack) {
    'ngInject';
    var addApprovalRole, delApprovalRole, getDefault, initDoc, preSave, productEdit, productFromNew, productNew, productRemove, vm;
    vm = this;
    vm.productsGridOptions = {
      noUnselect: true,
      data: [],
      columnDefs: [
        {
          name: 'product_id',
          displayName: 'Продукт',
          cellTemplate: '<div class="ui-grid-cell-contents"><product-select-name product-id="grid.getCellValue(row,col)"></product-select-name></div>'
        }, {
          name: 'unit_id',
          displayName: 'Единица изм.',
          cellTemplate: '<div class="ui-grid-cell-contents" ng-init="units=[]" stock-dict="units" dict-table="Units" dict-filter="{_id:grid.getCellValue(row,col)}"><span ng-repeat="unit in units | filter:{_id:grid.getCellValue(row,col)} track by unit._id">{{unit.name}}</span></div>'
        }, {
          name: 'quantity',
          displayName: 'Количество'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена за ед.'
        }, {
          name: 'total_cost',
          displayName: 'Общая цена'
        }, {
          name: 'additional_cost',
          displayName: 'Дополнительная цена'
        }, {
          name: 'discount',
          displayName: 'Скидка (%)'
        }, {
          name: 'comment',
          displayName: 'Комментарий'
        }
      ],
      events: {
        onRowSelect: function(data) {
          if (data.grid.id === vm.productsGridOptions.gridApi.grid.id) {
            vm.selected_product = data.entity;
          }
        }
      }
    };
    vm.fromProductsGridOptions = {
      noUnselect: true,
      data: [],
      columnDefs: [
        {
          name: 'product.name',
          displayName: 'Продукт'
        }, {
          name: 'unit.name',
          displayName: 'Единица изм.'
        }, {
          name: 'quantity',
          displayName: 'Количество'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена за ед.'
        }, {
          name: 'total_cost',
          displayName: 'Общая цена'
        }, {
          name: 'additional_cost',
          displayName: 'Дополнительная цена'
        }, {
          name: 'comment',
          displayName: 'Комментарий'
        }
      ],
      events: {
        onRowSelect: function(event, data) {
          if (data.grid.id === vm.fromProductsGridOptions.gridApi.grid.id) {
            vm.selected_from_product = data.entity;
          }
        }
      }
    };
    initDoc = function() {
      vm.document = $scope.entry.document;
      vm.productsGridOptions.data = angular.copy(vm.document.data.products || []);
      vm.fromProductsGridOptions.data = angular.copy(vm.document.data.from_products || []);
      getDefault();
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.approval_not_editable = doc_def.data.approval && doc_def.data.approval.required === true;
          if (vm.approval_not_editable) {
            vm.document.approval.required = doc_def.data.approval.required;
            vm.document.approval.roles_id = doc_def.data.approval.roles_id;
            vm.document.approval.approval_type = doc_def.data.approval.approval_type;
          }
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    preSave = function() {
      var product;
      if (vm.document.approval && vm.document.approval.required === true) {
        if (vm.document.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return false;
        }
        if (angular.isUndefined(vm.document.approval.roles_id) || vm.document.approval.roles_id.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return false;
        }
      }
      if (vm.productsGridOptions.data === void 0 || vm.productsGridOptions.data.length === 0) {
        toastr.warning('Добавьте товары!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.branch_id)) {
        toastr.warning('Укажите филиал!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите принимающегопринимающего!');
        vm.saving = false;
        return;
      }
      vm.document.data.products = (function() {
        var i, len, ref, results;
        ref = vm.productsGridOptions.data;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push({
            product_id: product.product_id,
            unit_id: product.unit_id,
            rules_id: product.rules_id,
            quote_unit_price: product.quote_unit_price,
            quantity: product.quantity,
            total_cost: product.total_cost,
            additional_cost: product.additional_cost,
            discount: product.discount,
            comment: product.comment
          });
        }
        return results;
      })();
      return true;
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.document.approval.roles_id ? vm.document.approval.roles_id : vm.document.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.document.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.document.approval.roles_id.indexOf(role_id);
      if (index > -1) {
        vm.document.approval.roles_id.splice(index, 1);
      }
    };
    productNew = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/sale/product_select.html',
        controller: 'SaleProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: void 0
        }
      });
      editModal.result.then(function(product) {
        vm.productsGridOptions.data.push(product);
        return delete vm.selected_product;
      });
    };
    productEdit = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/sale/product_select.html',
        controller: 'SaleProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: angular.copy(vm.selected_product)
        }
      });
      editModal.result.then(function(product) {
        var index;
        index = vm.productsGridOptions.data.indexOf(vm.selected_product);
        vm.productsGridOptions.data.splice(index, 1, product);
        return delete vm.selected_product;
      });
    };
    productRemove = function() {
      var index;
      index = vm.productsGridOptions.data.indexOf(vm.selected_product);
      if (index !== -1) {
        vm.productsGridOptions.data.splice(index, 1);
      }
      delete vm.selected_product;
    };
    productFromNew = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/components/productSelect/select.html',
        controller: 'ProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          modalOptions: {},
          search: vm.selected_from_product
        }
      });
      return editModal.result.then(function(result) {
        editModal = $uibModal.open({
          templateUrl: 'app/docs/sale/product_select.html',
          controller: 'SaleProductSelectController',
          controllerAs: 'product',
          size: 'lg',
          scope: $scope,
          resolve: {
            product: angular.copy({
              product_id: result._id,
              quantity: vm.selected_from_product.quantity,
              quote_unit_price: vm.selected_from_product.quote_unit_price,
              additional_cost: vm.selected_from_product.additional_cost,
              total_cost: vm.selected_from_product.total_cost
            })
          }
        });
        editModal.result.then(function(product) {
          vm.productsGridOptions.data.push(product);
          return delete vm.selected_product;
        });
      });
    };
    $scope.$watch('sale.payment_method', function() {
      if (vm.payment_method === 'cash') {
        vm.document.data.is_due = false;
      } else if (vm.payment_method === 'debt') {
        vm.document.data.is_due = true;
      }
    });
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    vm.productNew = productNew;
    vm.productEdit = productEdit;
    vm.productRemove = productRemove;
    vm.productFromNew = productFromNew;
    initDoc();
  }).controller('DocsSaleViewController', function($scope, $state) {
    'ngInject';
    var fromTotalSum, totalSum, vm;
    vm = this;
    totalSum = function() {
      var product;
      return ((function() {
        var i, len, ref, ref1, ref2, results;
        ref = ($scope.view.document && $scope.view.document.data.products ? $scope.view.document.data.products : []);
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push(1 * ((ref1 = product.total_cost) != null ? ref1 : 0) + 1 * ((ref2 = product.additional_cost) != null ? ref2 : 0));
        }
        return results;
      })()).reduce(function(a, b) {
        return 1 * (a != null ? a : 0) + 1 * (b != null ? b : 0);
      }, 0);
    };
    fromTotalSum = function() {
      var product;
      return ((function() {
        var i, len, ref, ref1, ref2, results;
        ref = ($scope.view.document && $scope.view.document.data.from_products ? $scope.view.document.data.from_products : []);
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push(1 * ((ref1 = product.total_cost) != null ? ref1 : 0) + 1 * ((ref2 = product.additional_cost) != null ? ref2 : 0));
        }
        return results;
      })()).reduce(function(a, b) {
        return 1 * (a != null ? a : 0) + 1 * (b != null ? b : 0);
      }, 0);
    };
    vm.totalSum = totalSum;
    vm.fromTotalSum = fromTotalSum;
  }).controller('SaleProductSelectController', function($scope, Session, RequestService, toastr, product, $uibModalInstance) {
    'ngInject';
    var calcTotalCost, calcUnitPrice, isEmpty, onProductLoaded, onRuleSelect, onRulesLoaded, productSave, vm;
    vm = this;
    vm.product = product || {};
    isEmpty = function(value) {
      return angular.isUndefined(value) || value === null || value === '';
    };
    productSave = function() {
      if (angular.isUndefined(vm.product.product_id)) {
        toastr.warning('Выберите продукт');
        return;
      }
      delete vm.product.unit;
      $uibModalInstance.close(vm.product);
    };
    calcTotalCost = function(product) {
      var d, q, qup, ref, ref1, ref2;
      if (isEmpty(product) || isEmpty(product.quantity) || isEmpty(product.quote_unit_price)) {
        return;
      }
      q = (ref = product.quantity) != null ? ref : 0;
      qup = (ref1 = product.quote_unit_price) != null ? ref1 : 0;
      d = (ref2 = product.discount) != null ? ref2 : 0;
      product.total_cost = (q * qup / 100 * (100 - d)).toFixed(2) * 1;
    };
    calcUnitPrice = function(product) {
      var q, ref, ref1, tc;
      if (isEmpty(product) || isEmpty(product.quantity) || isEmpty(product.total_cost)) {
        return;
      }
      q = (ref = product.quantity) != null ? ref : 0;
      tc = (ref1 = product.total_cost) != null ? ref1 : 0;
      product.quote_unit_price = (tc / q).toFixed(2) * 1;
    };
    onRuleSelect = function() {
      var i, len, pr, ref, ref1;
      vm.product.discount = 0;
      ref = vm.pr;
      for (i = 0, len = ref.length; i < len; i++) {
        pr = ref[i];
        if (ref1 = pr._id, indexOf.call(vm.product.rules_id, ref1) >= 0) {
          vm.product.discount += pr.discount;
        }
      }
      calcTotalCost(vm.product);
    };
    onProductLoaded = function(product) {
      if (product && product.data && product.data.price) {
        vm.product.quote_unit_price = product.data.price;
      }
      calcTotalCost(vm.product);
    };
    onRulesLoaded = function() {
      var pr, rule_id, rules_id;
      rules_id = (function() {
        var i, len, ref, results;
        ref = vm.pr;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          pr = ref[i];
          results.push(pr._id);
        }
        return results;
      })();
      vm.product.rules_id = (function() {
        var i, len, ref, results;
        ref = vm.product.rules_id;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          rule_id = ref[i];
          if (indexOf.call(rules_id, rule_id) >= 0) {
            results.push(rule_id);
          }
        }
        return results;
      })();
      calcTotalCost(vm.product);
    };
    vm.productSave = productSave;
    vm.calcTotalCost = calcTotalCost;
    vm.calcUnitPrice = calcUnitPrice;
    vm.onRuleSelect = onRuleSelect;
    vm.onProductLoaded = onProductLoaded;
    vm.onRulesLoaded = onRulesLoaded;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('fsa').controller('DocsCustomerPaymentEditController', function(hotkeys, $scope, $state, $stateParams, RequestService, toastr, uiGridConstants, $uibModal, BObjectService, $compile) {
    'ngInject';
    var currenciesLoaded, discountEdit, getContractor, getDefault, getPayments, initDoc, linkMedicalExaminationDoc, onRuleSelect, openSelectEmployee, preSave, productNew, productRemove, removeLinkMedicalExaminationDoc, vm;
    vm = this;
    vm.product_sum = 0;
    vm.discount = 0;
    vm.total_sum = 0;
    vm.product = {
      rules_id: [],
      employee_id: null
    };
    vm.productsGridOptions = {
      noUnselect: true,
      data: [],
      columnDefs: [
        {
          name: 'product_id',
          displayName: 'Услуга',
          cellTemplate: '<div class="ui-grid-cell-contents"><product-select-name product-id="grid.getCellValue(row,col)"></product-select-name></div>'
        }, {
          name: 'employee_id',
          displayName: 'Врач',
          cellTemplate: '<div class="ui-grid-cell-contents"><employee-select-name employee-id="grid.getCellValue(row,col)"></employee-select-name></div>'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена'
        }, {
          name: 'total_cost',
          displayName: 'Итоговая цена'
        }, {
          name: 'discount',
          displayName: 'Скидка (%)'
        }
      ],
      events: {
        onRowSelect: function(data) {
          vm.selected_product = data.entity;
        }
      }
    };
    initDoc = function() {
      var product;
      vm.document = $scope.entry.document;
      if (!vm.document.data) {
        vm.document.data = {};
      }
      if (!vm.document.data.executor_id) {
        vm.document.data.executor_id = $scope.app.ua.id;
      }
      if (!vm.document.data.medical_examination_documents_id) {
        vm.document.data.medical_examination_documents_id = [];
      }
      if (!vm.document.medical_examination_documents) {
        vm.document.medical_examination_documents = [];
      }
      if ($stateParams.document && $stateParams.document.document_type === 'medical_examination') {
        if (!vm.document.data.fact_amount) {
          vm.document.data.fact_amount = 0;
        }
        vm.document.branch_id = $stateParams.document.branch_id;
        vm.document.data.contractor_id = $stateParams.document.data.contractor_id;
        vm.document.data.executor_id = $stateParams.document.data.executor_id;
        vm.document.data.currency_id = $stateParams.document.data.currency_id;
        vm.document.data.medical_examination_documents_id.push($stateParams.document._id);
        vm.document.medical_examination_documents.push($stateParams.document);
        vm.document.data.products = vm.document.data.products.concat((function() {
          var i, len, ref, results;
          ref = $stateParams.document.data.products;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            product = ref[i];
            if (product.quantity - product.payd_quantity > 0) {
              results.push({
                product_id: product.product_id,
                unit_id: product.unit_id,
                rules_id: product.rules_id,
                quantity: product.quantity - product.payd_quantity,
                quote_unit_price: product.quote_unit_price,
                total_cost: product.total_cost,
                discount: product.discount,
                comment: product.comment,
                roles_id: product.roles_id
              });
            }
          }
          return results;
        })());
      }
      vm.productsGridOptions.data = angular.copy(vm.document.data.products || []);
      getDefault();
      if (angular.isUndefined(vm.document.branch_id && $scope.app.uc)) {
        vm.document.branch_id = $scope.app.uc.branches_id ? $scope.app.uc.branches_id[0] : void 0;
        if (!$scope.app.uc.branches_id || $scope.app.uc.branches_id.length === 0) {
          BObjectService.list('Branches', {}).then(function(data) {
            if (!vm.document.branch_id && data.docs.length > 0) {
              vm.document.branch_id = data.docs[0]._id;
            }
          });
        }
      }
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    getContractor = function() {
      var filter;
      filter = {
        limit: 1,
        filter: {
          _id: vm.document.data.contractor_id
        }
      };
      RequestService.post('contractor.list', filter).then(function(result) {
        var cont, i, len, ref;
        vm.conts = result.docs;
        ref = vm.conts;
        for (i = 0, len = ref.length; i < len; i++) {
          cont = ref[i];
          vm.contractor_name = cont.name;
          getPayments(cont._id);
        }
      });
    };
    getPayments = function(id) {
      var filter;
      filter = {
        limit: vm.limit,
        offset: vm.offset,
        with_related: true,
        order_by: ['payment_date desc'],
        filter: {
          data: {
            contractor_id: id
          }
        }
      };
      RequestService.post('payment.listing', filter).then(function(result) {
        var i, len, payment, ref;
        delete vm.selected_payment;
        vm.summa = result.sum;
        vm.paymentSum = 0;
        ref = result.payments;
        for (i = 0, len = ref.length; i < len; i++) {
          payment = ref[i];
          if (payment.payment_status === 'not_paid') {
            vm.paymentSum += payment.amount;
          }
        }
      });
    };
    preSave = function() {
      var now, product;
      if (vm.productsGridOptions.data === void 0 || vm.productsGridOptions.data.length === 0) {
        toastr.warning('Добавьте услуги!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.branch_id)) {
        toastr.warning('Укажите филиал!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите исполнителя!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.currency_id)) {
        toastr.warning('Укажите валюту!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.title)) {
        now = moment().format('DD.MM.YY ');
        vm.document.title = vm.contractor_name + " " + now;
      }
      vm.document.data.products = (function() {
        var i, len, ref, results;
        ref = vm.productsGridOptions.data;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push({
            product_id: product.product_id,
            unit_id: product.unit_id,
            rules_id: product.rules_id,
            quote_unit_price: product.quote_unit_price,
            quantity: product.quantity,
            total_cost: product.total_cost,
            discount: product.discount,
            comment: product.comment,
            employee_id: product.employee_id,
            roles_id: product.roles_id
          });
        }
        return results;
      })();
      return true;
    };
    productNew = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/components/productSelect/select.html',
        controller: 'ProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          modalOptions: {
            title: 'Выбрать услугу',
            filter: {
              product_type: 'service'
            }
          },
          search: null
        }
      });
      editModal.result.then(function(product) {
        var d, i, len, pr, q, qup, ref, ref1;
        product.discount = 0;
        ref = vm.pr;
        for (i = 0, len = ref.length; i < len; i++) {
          pr = ref[i];
          if (ref1 = pr._id, indexOf.call(vm.product.rules_id, ref1) >= 0) {
            product.discount += pr.discount;
          }
        }
        q = 1;
        d = product.discount;
        qup = product.data.price;
        product.total_cost = q * qup / 100 * (100 - d);
        vm.productsGridOptions.data.push({
          product_id: product._id,
          unit_id: product.data.unit_id,
          quantity: 1,
          quote_unit_price: product.data.price,
          total_cost: product.total_cost,
          discount: product.discount,
          rules_id: vm.product.rules_id,
          employee_id: null,
          roles_id: product.data.roles_id
        });
        vm.total_sum += product.total_cost;
        return delete vm.selected_product;
      });
    };
    onRuleSelect = function() {
      var d, i, j, len, len1, pr, product, q, qup, ref, ref1, ref2;
      vm.total_sum = 0;
      ref = vm.productsGridOptions.data;
      for (i = 0, len = ref.length; i < len; i++) {
        product = ref[i];
        vm.discount = 0;
        ref1 = vm.pr;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          pr = ref1[j];
          if (ref2 = pr._id, indexOf.call(vm.product.rules_id, ref2) >= 0) {
            vm.discount += pr.discount;
          }
        }
        q = 1;
        d = vm.discount;
        qup = product.quote_unit_price;
        product.total_cost = q * qup / 100 * (100 - d);
        product.discount = vm.discount;
        vm.total_sum += product.total_cost;
      }
    };
    discountEdit = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/medical_examination/discount_select.html',
        controller: 'MedicalExaminationDiscountSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: angular.copy(vm.selected_product)
        }
      });
      editModal.result.then(function(product) {
        var index;
        index = vm.productsGridOptions.data.indexOf(vm.selected_product);
        vm.productsGridOptions.data.splice(index, 1, product);
        return delete vm.selected_product;
      });
    };
    productRemove = function() {
      var index;
      index = vm.productsGridOptions.data.indexOf(vm.selected_product);
      if (index !== -1) {
        vm.productsGridOptions.data.splice(index, 1);
      }
      vm.total_sum = vm.total_sum - vm.selected_product.total_cost;
      delete vm.selected_product;
    };
    currenciesLoaded = function(event) {
      var currency, i, len, ref, results;
      if (!vm.document.data.currency_id) {
        ref = vm.currencies || [];
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          currency = ref[i];
          if (currency.data.name = 'KGS') {
            results.push(vm.document.data.currency_id = currency._id);
          }
        }
        return results;
      }
    };
    removeLinkMedicalExaminationDoc = function(doc_id) {
      var index, medical_examination_document, medical_examination_document_index, pd_index;
      if (vm.document.data && vm.document.data.medical_examination_documents_id) {
        index = vm.document.data.medical_examination_documents_id.indexOf(doc_id);
        vm.document.data.medical_examination_documents_id.splice(index, 1);
      }
      pd_index = -1;
      for (medical_examination_document_index in vm.document.medical_examination_documents) {
        medical_examination_document = vm.document.medical_examination_documents[medical_examination_document_index];
        if (medical_examination_document._id === doc_id) {
          pd_index = medical_examination_document_index;
        }
      }
      return vm.document.medical_examination_documents.splice(pd_index, 1);
    };
    linkMedicalExaminationDoc = function() {
      var linkModal;
      linkModal = $uibModal.open({
        templateUrl: 'app/docs/customer_payment/medical_examination-select-modal.html',
        controller: 'CustomerPaymentMedicalExaminationSelectController',
        controllerAs: 'medical_examination',
        scope: $scope,
        resolve: {
          customer_payment: vm.document
        }
      });
      return linkModal.result.then(function(result) {
        if (-1 < vm.document.data.medical_examination_documents_id.indexOf(result._id)) {
          toastr.warning("Документ уже привязан");
          return;
        }
        vm.document.data.medical_examination_documents_id.push(result._id);
        if (!vm.document.medical_examination_documents) {
          vm.document.medical_examination_documents = [];
        }
        return vm.document.medical_examination_documents.push(result);
      });
    };
    $scope.$watch('entry.document.data.contractor_id', function() {
      return getContractor();
    });
    openSelectEmployee = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/components/employeeSelect/select.html',
        controller: 'EmployeeSelectController',
        controllerAs: 'employee',
        size: 'lg',
        scope: $scope,
        resolve: {
          modalOptions: {
            filter: {
              roles: angular.copy(vm.selected_product.roles_id[0])
            }
          }
        }
      });
      editModal.result.then(function(result) {
        vm.selected_product.employee_id = result.user_id;
        return delete vm.selected_product;
      });
    };
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.productNew = productNew;
    vm.discountEdit = discountEdit;
    vm.productRemove = productRemove;
    vm.getContractor = getContractor;
    vm.openSelectEmployee = openSelectEmployee;
    vm.getPayments = getPayments;
    vm.onRuleSelect = onRuleSelect;
    vm.currenciesLoaded = currenciesLoaded;
    vm.removeLinkMedicalExaminationDoc = removeLinkMedicalExaminationDoc;
    vm.linkMedicalExaminationDoc = linkMedicalExaminationDoc;
    initDoc();
  }).controller('DocsCustomerPaymentViewController', function($scope, $state) {
    'ngInject';
    var remaintSum, totalSum, vm;
    vm = this;
    totalSum = function() {
      var product;
      return ((function() {
        var i, len, ref, ref1, results;
        ref = ($scope.view.document && $scope.view.document.data.products ? $scope.view.document.data.products : []);
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push(1 * ((ref1 = product.total_cost) != null ? ref1 : 0));
        }
        return results;
      })()).reduce(function(a, b) {
        return 1 * (a != null ? a : 0) + 1 * (b != null ? b : 0);
      }, 0);
    };
    remaintSum = function() {
      var i, len, payment, ref;
      vm.paymentSum = 0;
      ref = $scope.view.document.payments;
      for (i = 0, len = ref.length; i < len; i++) {
        payment = ref[i];
        if (payment.payment_status === 'not_paid') {
          vm.paymentSum += payment.amount;
        }
      }
    };
    vm.totalSum = totalSum;
    vm.remaintSum = remaintSum;
    remaintSum();
  }).controller('CustomerPaymentMedicalExaminationSelectController', function($scope, $uibModalInstance, RequestService, customer_payment, $rootScope) {
    'ngInject';
    var getDocs, vm;
    vm = this;
    getDocs = function() {
      var filter;
      vm.doc_loading = true;
      filter = {
        filter: {
          document_type: 'medical_examination',
          document_status: 'approved',
          branch_id: customer_payment.branch_id,
          data: {
            currency_id: customer_payment.data.currency_id
          }
        }
      };
      RequestService.post('doc.listing', filter).then(function(result) {
        vm.docs = result.docs;
        vm.doc_loading = false;
      }, function() {
        return vm.doc_loading = false;
      });
    };
    vm.getDocs = getDocs;
    vm.docSelect = function(document) {
      return $uibModalInstance.close(document);
    };
    vm.cancel = function() {
      return $uibModalInstance.dismiss('close');
    };
    getDocs();
  });

}).call(this);



(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('fsa').controller('DocsConsumptionEditController', function(hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal, $uibModalStack) {
    'ngInject';
    var addApprovalRole, delApprovalRole, getDefault, initDoc, preSave, productEdit, productNew, productRemove, purposeParentGroup, sourceSelected, vm;
    vm = this;
    vm.productsGridOptions = {
      noUnselect: true,
      data: [],
      columnDefs: [
        {
          name: 'product_id',
          displayName: 'Продукт',
          cellTemplate: '<div class="ui-grid-cell-contents"><product-select-name product-id="grid.getCellValue(row,col)"></product-select-name></div>'
        }, {
          name: 'unit_id',
          displayName: 'Единица изм.',
          cellTemplate: '<div class="ui-grid-cell-contents" ng-init="units=[]" stock-dict="units" dict-table="Units" dict-filter="{_id:grid.getCellValue(row,col)}"><span ng-repeat="unit in units | filter:{_id:grid.getCellValue(row,col)} track by unit._id">{{unit.name}}</span></div>'
        }, {
          name: 'quantity',
          displayName: 'Количество'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена за ед.'
        }, {
          name: 'total_cost',
          displayName: 'Общая цена'
        }, {
          name: 'additional_cost',
          displayName: 'Дополнительная цена'
        }, {
          name: 'discount',
          displayName: 'Скидка (%)'
        }, {
          name: 'comment',
          displayName: 'Комментарий'
        }
      ],
      events: {
        onRowSelect: function(data) {
          vm.selected_product = data.entity;
        }
      }
    };
    initDoc = function() {
      vm.document = $scope.entry.document;
      vm.productsGridOptions.data = angular.copy(vm.document.data.products || []);
      if (vm.productsGridOptions.gridApi) {
        vm.productsGridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      }
      getDefault();
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.approval_not_editable = doc_def.data.approval && doc_def.data.approval.required === true;
          if (vm.approval_not_editable) {
            vm.document.approval.required = doc_def.data.approval.required;
            vm.document.approval.roles_id = doc_def.data.approval.roles_id;
            vm.document.approval.approval_type = doc_def.data.approval.approval_type;
          }
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    preSave = function() {
      var product;
      if (vm.document.approval && vm.document.approval.required === true) {
        if (vm.document.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return false;
        }
        if (angular.isUndefined(vm.document.approval.roles_id) || vm.document.approval.roles_id.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return false;
        }
      }
      if (vm.productsGridOptions.data === void 0 || vm.productsGridOptions.data.length === 0) {
        toastr.warning('Добавьте товары!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.branch_id)) {
        toastr.warning('Укажите филиал!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите исполнителя!');
        vm.saving = false;
        return;
      }
      if (vm.document.data.is_advance === true) {
        delete vm.document.data.is_due;
        delete vm.document.data.due_date;
        if (angular.isUndefined(vm.document.data.employee_id)) {
          toastr.warning('Укажите сотрудника!');
          vm.saving = false;
          return;
        }
      }
      vm.document.data.products = (function() {
        var i, len, ref, results;
        ref = vm.productsGridOptions.data;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push({
            product_id: product.product_id,
            unit_id: product.unit_id,
            rules_id: product.rules_id,
            quote_unit_price: product.quote_unit_price,
            quantity: product.quantity,
            total_cost: product.total_cost,
            additional_cost: product.additional_cost,
            discount: product.discount,
            comment: product.comment
          });
        }
        return results;
      })();
      return true;
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.document.approval.roles_id ? vm.document.approval.roles_id : vm.document.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.document.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.document.approval.approval_roles.indexOf(role_id);
      if (index > -1) {
        vm.document.approval.approval_roles.splice(index, 1);
      }
    };
    productNew = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/consumption/product_select.html',
        controller: 'ConsumptionProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: void 0
        }
      });
      editModal.result.then(function(product) {
        vm.productsGridOptions.data.push(product);
        return delete vm.selected_product;
      });
    };
    productEdit = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/docs/consumption/product_select.html',
        controller: 'ConsumptionProductSelectController',
        controllerAs: 'product',
        size: 'lg',
        scope: $scope,
        resolve: {
          product: angular.copy(vm.selected_product)
        }
      });
      editModal.result.then(function(product) {
        var index;
        index = vm.productsGridOptions.data.indexOf(vm.selected_product);
        vm.productsGridOptions.data.splice(index, 1, product);
        return delete vm.selected_product;
      });
    };
    productRemove = function() {
      var index;
      index = vm.productsGridOptions.data.indexOf(vm.selected_product);
      if (index !== -1) {
        vm.productsGridOptions.data.splice(index, 1);
      }
      delete vm.selected_product;
    };
    sourceSelected = function() {
      vm.document.data.is_due = false;
      vm.document.data.is_advance = false;
    };
    purposeParentGroup = function(item) {
      if (!item.parent) {
        return '';
      }
      return item.parent.name;
    };
    $scope.$watch('consumption.payment_method', function() {
      if (vm.payment_method === 'cash') {
        vm.document.data.is_due = false;
        vm.document.data.is_advance = false;
      } else if (vm.payment_method === 'debt') {
        vm.document.data.is_due = true;
        vm.document.data.is_advance = false;
      } else if (vm.payment_method === 'advance') {
        vm.document.data.is_advance = true;
        vm.document.data.is_due = false;
      }
    });
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    vm.productNew = productNew;
    vm.productEdit = productEdit;
    vm.productRemove = productRemove;
    vm.sourceSelected = sourceSelected;
    vm.purposeParentGroup = purposeParentGroup;
    initDoc();
  }).controller('DocsConsumptionViewController', function($scope, $state) {
    'ngInject';
    var totalSum, vm;
    vm = this;
    totalSum = function() {
      var product;
      return ((function() {
        var i, len, ref, ref1, ref2, results;
        ref = ($scope.view.document && $scope.view.document.data.products ? $scope.view.document.data.products : []);
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          results.push(1 * ((ref1 = product.total_cost) != null ? ref1 : 0) + 1 * ((ref2 = product.additional_cost) != null ? ref2 : 0));
        }
        return results;
      })()).reduce(function(a, b) {
        return 1 * (a != null ? a : 0) + 1 * (b != null ? b : 0);
      }, 0);
    };
    vm.totalSum = totalSum;
  }).controller('ConsumptionProductSelectController', function($scope, Session, RequestService, toastr, product, $uibModalInstance) {
    'ngInject';
    var calcTotalCost, calcUnitPrice, isEmpty, onProductLoaded, onRuleSelect, onRulesLoaded, productSave, vm;
    vm = this;
    vm.product = product || {};
    isEmpty = function(value) {
      return angular.isUndefined(value) || value === null || value === '';
    };
    productSave = function() {
      if (angular.isUndefined(vm.product.product_id)) {
        toastr.warning('Выберите продукт');
        return;
      }
      delete vm.product.unit;
      $uibModalInstance.close(vm.product);
    };
    calcTotalCost = function(product) {
      var d, q, qup, ref, ref1, ref2;
      if (isEmpty(product) || isEmpty(product.quantity) || isEmpty(product.quote_unit_price)) {
        return;
      }
      q = (ref = product.quantity) != null ? ref : 0;
      qup = (ref1 = product.quote_unit_price) != null ? ref1 : 0;
      d = (ref2 = product.discount) != null ? ref2 : 0;
      product.total_cost = (q * qup / 100 * (100 - d)).toFixed(2) * 1;
    };
    calcUnitPrice = function(product) {
      var q, ref, ref1, tc;
      if (isEmpty(product) || isEmpty(product.quantity) || isEmpty(product.total_cost)) {
        return;
      }
      q = (ref = product.quantity) != null ? ref : 0;
      tc = (ref1 = product.total_cost) != null ? ref1 : 0;
      product.quote_unit_price = (tc / q).toFixed(2) * 1;
    };
    onRuleSelect = function() {
      var i, len, pr, ref, ref1;
      vm.product.discount = 0;
      ref = vm.pr;
      for (i = 0, len = ref.length; i < len; i++) {
        pr = ref[i];
        if (ref1 = pr._id, indexOf.call(vm.product.rules_id, ref1) >= 0) {
          vm.product.discount += pr.discount;
        }
      }
      calcTotalCost(vm.product);
    };
    onProductLoaded = function(product) {
      if (product && product.data && product.data.price) {
        vm.product.quote_unit_price = product.data.price;
      }
      calcTotalCost(vm.product);
    };
    onRulesLoaded = function() {
      var pr, rule_id, rules_id;
      rules_id = (function() {
        var i, len, ref, results;
        ref = vm.pr;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          pr = ref[i];
          results.push(pr._id);
        }
        return results;
      })();
      vm.product.rules_id = (function() {
        var i, len, ref, results;
        ref = vm.product.rules_id;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          rule_id = ref[i];
          if (indexOf.call(rules_id, rule_id) >= 0) {
            results.push(rule_id);
          }
        }
        return results;
      })();
      calcTotalCost(vm.product);
    };
    vm.productSave = productSave;
    vm.calcTotalCost = calcTotalCost;
    vm.calcUnitPrice = calcUnitPrice;
    vm.onRuleSelect = onRuleSelect;
    vm.onProductLoaded = onProductLoaded;
    vm.onRulesLoaded = onRulesLoaded;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DocsCashExpenditureEditController', function(hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal, $uibModalStack) {
    'ngInject';
    var addApprovalRole, delApprovalRole, getDefault, initDoc, preSave, vm;
    vm = this;
    initDoc = function() {
      vm.document = $scope.entry.document;
      getDefault();
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.approval_not_editable = doc_def.data.approval && doc_def.data.approval.required === true;
          if (vm.approval_not_editable) {
            vm.document.approval.required = doc_def.data.approval.required;
            vm.document.approval.roles_id = doc_def.data.approval.roles_id;
            vm.document.approval.approval_type = doc_def.data.approval.approval_type;
          }
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    preSave = function() {
      if (vm.document.approval && vm.document.approval.required === true) {
        if (vm.document.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return false;
        }
        if (angular.isUndefined(vm.document.approval.roles_id) || vm.document.approval.roles_id.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return false;
        }
      }
      if (angular.isUndefined(vm.document.branch_id)) {
        toastr.warning('Укажите филиал!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите исполнителя!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.currency_id)) {
        toastr.warning('Укажите валюту!');
        vm.saving = false;
        return;
      }
      return true;
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.document.approval.roles_id ? vm.document.approval.roles_id : vm.document.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.document.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.document.approval.roles_id.indexOf(role_id);
      if (index > -1) {
        vm.document.approval.roles_id.splice(index, 1);
      }
    };
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    initDoc();
  }).controller('DocsCashExpenditureViewController', function($scope, $state) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DocsAdvanceEditController', function(hotkeys, $scope, $state, $stateParams, RequestService, toastr, uiGridConstants, $uibModal, $uibModalStack) {
    'ngInject';
    var addApprovalRole, delApprovalRole, getDefault, initDoc, preSave, vm;
    vm = this;
    initDoc = function() {
      vm.document = $scope.entry.document;
      if (!vm.document.data) {
        vm.document.data = {};
      }
      getDefault();
      if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
        vm.is_executor = true;
      }
    };
    getDefault = function() {
      var filter;
      filter = {
        filter: {
          document_type: vm.document.document_type
        }
      };
      RequestService.post('defaults.list', filter).then(function(result) {
        var doc_def;
        if (result.docs.length === 1) {
          doc_def = result.docs[0];
          vm.approval_not_editable = doc_def.data.approval && doc_def.data.approval.required === true;
          if (vm.approval_not_editable) {
            vm.document.approval.required = doc_def.data.approval.required;
            vm.document.approval.roles_id = doc_def.data.approval.roles_id;
            vm.document.approval.approval_type = doc_def.data.approval.approval_type;
          }
          vm.executor_not_editable = angular.isDefined(doc_def.data.data.executor_id);
          if (vm.executor_not_editable) {
            vm.document.data.executor_id = doc_def.data.data.executor_id;
          }
        }
      });
    };
    preSave = function() {
      if (vm.document.approval && vm.document.approval.required === true) {
        if (vm.document.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return false;
        }
        if (angular.isUndefined(vm.document.approval.roles_id) || vm.document.approval.roles_id.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return false;
        }
      }
      if (angular.isUndefined(vm.document.data.executor_id)) {
        toastr.warning('Укажите принимающего!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.currency_id)) {
        toastr.warning('Укажите валюту!');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.document.data.amount)) {
        toastr.warning('Укажите сумму!');
        vm.saving = false;
        return;
      }
      return true;
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.document.approval.roles_id ? vm.document.approval.roles_id : vm.document.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.document.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.document.approval.roles_id.indexOf(role_id);
      if (index > -1) {
        vm.document.approval.roles_id.splice(index, 1);
      }
    };
    vm.initDoc = initDoc;
    $scope.entry.postGet = initDoc;
    $scope.entry.preSave = preSave;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    initDoc();
  }).controller('DocsAdvanceViewController', function($scope, $state, $uibModal) {
    'ngInject';
  });

}).call(this);



(function() {
  angular.module('fsa').controller('TypeofownershipController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('SectorController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('SectionsofpublicationactivityController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('SectionsofpublicationController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportsectionstypesController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportsectionsController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportingdeadlinesController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportCategoryController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReestrController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ProductController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('PollDepartmentController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('PeriodController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('LegalframedoctypeController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('LanguageController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('InsurancetypesController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('InsuranceobjectsController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('InsuranceformsController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('IndustryController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('GraphicsController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
    vm.ismeridian = false;
    vm.hstep = 1;
    vm.mstep = 1;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ExamSectionsController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('EnumController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DirtagsController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DirstructureController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DirReportCategoriesController', function($scope, RequestService, toastr) {
    var vm;
    vm = this;
    vm.dirReportCategories = [];
    RequestService.post('reporta.category_listing', {}).then(function(response) {
      vm.dirReportCategories = response.docs;
    });
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DirPositionController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DepartmentdocumentController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DepartmentController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('CurrencyController', function($scope) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('FileLoadController', function($scope, $rootScope, RequestService, flowFactory, $base64, Session, toastr) {
    'ngInject';
    var getFileSize, initFlow, vm;
    vm = this;
    vm.api = $rootScope.api;
    initFlow = function() {
      var auth_token;
      auth_token = 'Basic ' + $base64.encode('web' + ':' + Session.getToken());
      vm.flow = flowFactory.create({
        target: $rootScope.api + 'upload/docs/file/' + $scope.type,
        singleFile: true,
        headers: {
          Authorization: auth_token
        },
        withCredentials: true,
        testChunks: false
      });
      vm.flow.on('fileAdded', function(file, event) {
        var ext;
        ext = file.name.substring(file.name.lastIndexOf('.'));
        if (ext !== '.pdf' && ext !== '.doc' && ext !== '.docx' && ext !== '.zip' && ext !== '.jpg' && ext !== '.jpeg' && ext !== '.png' && ext !== '.gif') {
          toastr.warning('Выберите файл PDF или Word или Zip');
          event.preventDefault();
          return false;
        }
        if (file.size > 15 * 1024 * 1024) {
          toastr.warning('Файл слишком большой');
          event.preventDefault();
          return false;
        }
      });
      vm.flow.on('filesSubmitted', function(array, event) {
        if (array.length > 0) {
          vm.flow.upload();
        }
      });
      vm.flow.on('complete', function() {
        vm.flow.files.clear();
      });
      vm.flow.on('fileSuccess', function(file, message, chunk) {
        $scope.fileSrc = message;
      });
      return vm.flow.on('error', function(message, file, chunk) {
        console.log(message, file, chunk);
      });
    };
    initFlow();
    getFileSize = function() {
      RequestService.post('education.file_size', {
        bobject: $scope.fileSrc
      }).then(function(result) {
        if (vm.file) {
          return vm.file.size = result.bobject;
        }
      });
    };
    $scope.$watch('fileSrc', function(newVal) {
      if (newVal && newVal.lastIndexOf('/') > -1) {
        vm.file = {
          name: newVal.substring(1 + newVal.lastIndexOf('/')),
          size: 0
        };
        getFileSize();
      } else {
        delete vm.file;
      }
    });
  }).directive('fileLoad', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        fileSrc: '=',
        type: '@'
      },
      controller: 'FileLoadController',
      controllerAs: 'file',
      templateUrl: 'app/components/fileLoad/file-load.html'
    };
  }).directive('fileLink', function($rootScope) {
    return {
      restrict: 'A',
      scope: {
        fileLink: '@'
      },
      link: function(scope, elem, attr) {
        attr.$observe('fileLink', function(val) {
          if (val) {
            scope.file_link = $rootScope.api + val;
            return scope.file_name = val && val.length > 0 ? val.substring(val.lastIndexOf('/') + 1) : '';
          }
        });
      },
      templateUrl: 'app/components/fileLoad/file-link.html'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').constant('fsaContractorModalOptions', {
    title: 'Выбрать контрагента',
    can_create: false,
    filter: {}
  }).controller('ContractorSelectController', function($scope, RequestService, $uibModalInstance, modalOptions, fsaContractorModalOptions, $uibModal) {
    'ngInject';
    var cancel, createContractor, industryParentGroup, searchContractors, selectContractor, vm;
    vm = this;
    vm.modalOptions = angular.merge({}, fsaContractorModalOptions, angular.copy(modalOptions || {}));
    vm.offset = 0;
    vm.limit = 10;
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      appScopeProvider: {
        onDoubleClick: function(row) {
          return selectContractor(row.entity);
        }
      },
      rowTemplate: '<div ng-dblclick="grid.appScope.onDoubleClick(row)" ng-repeat="col in colContainer.renderedColumns" class="ui-grid-cell" ui-grid-cell></div>',
      columnDefs: [
        {
          name: 'name',
          displayName: 'Наименование'
        }, {
          name: 'data.email',
          displayName: 'E-mail'
        }, {
          name: 'data.industry.name',
          displayName: 'Индустрия'
        }, {
          name: 'contractor_type_value.data.name',
          displayName: 'Тип'
        }, {
          name: 'contractor_company.name',
          displayName: 'Компания агента',
          visible: false
        }
      ],
      events: {
        onPageSelect: function(page, size) {
          vm.offset = page * size;
          vm.limit = size;
          searchContractors(true);
        },
        onRowSelect: function(row) {
          vm.selected_contractor = angular.copy(row.entity);
        }
      }
    };
    searchContractors = function(paging) {
      var filter;
      if (!paging || angular.isUndefined(paging)) {
        vm.offset = 0;
      }
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        search: vm.search_name,
        filter: {
          contractor_type: vm.modalOptions.filter.contractor_type || vm.contractor_type,
          data: {
            industry_id: vm.industry_id
          }
        }
      };
      RequestService.post('contractor.list', filter).then(function(result) {
        delete vm.selected_contractor;
        vm.gridOptions.data = result.docs;
        vm.gridOptions.totalItems = result.count;
      });
    };
    industryParentGroup = function(item) {
      if (!item.parent) {
        return '';
      }
      return item.parent.name;
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    selectContractor = function(selected_contractor) {
      if (selected_contractor) {
        $uibModalInstance.close(selected_contractor);
      } else if (angular.isDefined(vm.selected_contractor)) {
        $uibModalInstance.close(vm.selected_contractor);
      }
    };
    createContractor = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/contractor/edit.html',
        controller: 'ContractorEditController',
        controllerAs: 'contractor',
        size: 'lg',
        scope: $scope,
        resolve: {
          contractor: void 0
        }
      });
      editModal.result.then(function() {
        return searchContractors();
      });
    };
    searchContractors();
    vm.searchContractors = searchContractors;
    vm.industryParentGroup = industryParentGroup;
    vm.cancel = cancel;
    vm.selectContractor = selectContractor;
    vm.createContractor = createContractor;
  });

}).call(this);



(function() {
  angular.module('fsa').directive('contractorSelect', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        contractorId: '=',
        item: '=',
        ngDisabled: '=?',
        ngRequired: '=?',
        modalOptions: '=?'
      },
      controller: function($scope, $attrs, RequestService, $uibModal, $uibModalStack) {
        'ngInject';
        var vm;
        vm = this;
        vm.openSelectContractor = function() {
          var editModal;
          editModal = $uibModal.open({
            templateUrl: 'app/components/contractorSelect/select.html',
            controller: 'ContractorSelectController',
            controllerAs: 'contractor',
            size: 'lg',
            scope: $scope.$parent,
            resolve: {
              modalOptions: $scope.modalOptions || {}
            }
          });
          editModal.result.then(function(result) {
            vm.selected = result;
          });
        };
        vm.searchContractor = function(search_name) {
          var filter;
          filter = {
            limit: 10,
            search: search_name,
            filter: $scope.modalOptions ? $scope.modalOptions.filter : void 0
          };
          return RequestService.post('contractor.list', filter).then(function(result) {
            return result.docs;
          });
        };
        $scope.$watch('contractorId', function() {
          if ((angular.isDefined($scope.contractorId)) && vm.watch_prevent !== true) {
            RequestService.post('contractor.list', {
              filter: {
                _id: $scope.contractorId
              }
            }).then(function(result) {
              if (result.docs.length === 1) {
                vm.watch_prevent = true;
                vm.selected = result.docs[0];
              }
            });
          }
        });
        $scope.$watch('contractor.selected', function() {
          if ((angular.isDefined(vm.selected)) && vm.watch_prevent !== true) {
            vm.watch_prevent = true;
            $scope.contractorId = vm.selected._id;
            if ($attrs.item) {
              $scope.item = vm.selected;
            }
          }
          vm.watch_prevent = false;
        });
      },
      controllerAs: 'contractor',
      link: function(scope, element, attr) {},
      templateUrl: 'app/components/contractorSelect/contractor-select.html'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('UsersController', function(RequestService, $scope, $uibModal) {
    'ngInject';
    var editUser, getUsers, newUser, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.usersGridOptions = {
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [10, 20, 50, 100],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'username',
          displayName: 'Имя'
        }, {
          name: 'email',
          displayName: 'Емайл'
        }, {
          name: 'role',
          displayName: 'Важность'
        }, {
          name: 'rec_date',
          displayName: 'Дата регистрации'
        }
      ]
    };
    getUsers = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "login") {
          filter.filter.login = v;
        }
        if (k === "email") {
          filter.filter.email = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      RequestService.post('user.listing', filter).then(function(result) {
        vm.users = result.users;
        vm.usersGridOptions.data = vm.users;
        vm.usersGridOptions.totalItems = result.count;
      });
    };
    editUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/users/edit.html',
        controller: 'UsersEditController',
        controllerAs: 'user',
        size: 'lg',
        backdrop: 'static',
        resolve: {
          user: angular.copy(vm.selected_user)
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    newUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/users/create.html',
        controller: 'UsersEditController',
        controllerAs: 'user',
        size: 'lg',
        backdrop: 'static',
        resolve: {
          user: void 0
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_user = row.entity;
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getUsers();
    });
    vm.editUser = editUser;
    vm.newUser = newUser;
    vm.getUsers = getUsers;
    getUsers();
  }).controller('UsersEditController', function(RequestService, user, $scope, $uibModalInstance) {
    'ngInject';
    var cancel, createUser, updateUser, vm;
    vm = this;
    if (user === null || user === void 0) {
      vm.user = {};
    } else {
      vm.user = user;
    }
    createUser = function() {
      RequestService.post('user.register', vm.user).then(function(result) {
        console.log("createUser ->result.token = " + result.token);
        $uibModalInstance.close(result);
      });
    };
    updateUser = function() {
      RequestService.post('user.put', vm.user).then(function(result) {
        console.log("updateUser ->result.user = ");
        console.log(result.user);
        $uibModalInstance.close(result);
      });
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.updateUser = updateUser;
    vm.createUser = createUser;
    vm.cancel = cancel;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('TpolicyController', function() {
    'ngInject';
    var vm;
    vm = this;
  }).controller('TpolicyListController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, downloadPDF, editBranch, fiterPolicy, getAgents, getPolicies, goToIssue, goToNew, goToShow, onDblClick, resetFilter, savePDF, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 50;
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/tpolicy/show.html',
        controller: 'TpolicyShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [50, 100, 500],
      paginationPageSize: 50,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'data.currency.name',
          displayName: 'Валюта'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      $state.go('app.policy_select');
      return false;
    };
    goToIssue = function() {
      $state.go('app.policy_issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/edit.html',
        controller: 'PolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "date_end") {
          filter.filter.date_end = v;
        }
        if (k === "date_start") {
          filter.filter.date_start = v;
        }
        if (k === "agent_id") {
          filter.filter.edit_user_id = v;
        }
        if (k === "branch_id") {
          filter.filter.branch_id = v;
        }
        if (k === "client") {
          filter.filter.client = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      filter.order_by = ["issue_date DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.success("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getAgents = function() {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        id: vm.company._id
      };
      RequestService.post('agentemployee.listing', filter).then(function(data) {
        vm.agents = data.users;
      });
    };
    downloadPDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'LN') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'NED') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    savePDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        ReportService.saveReportPdf('TS', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'LN') {
        ReportService.saveReportPdf('LN', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'NED') {
        ReportService.saveReportPdf('NED', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, i, issue_d, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (i = 0, len = ref.length; i < len; i++) {
          policy = ref[i];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.savePDF = savePDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    vm.getAgents = getAgents;
    getAgents();
    getPolicies();
  }).controller('TpolicyShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var cancel, confirmAction, confirmActionForm, confirmActionTerm, date1, diffDays, downloadPDF, goToForm, goToPolicy, spoilPolicy, termPolicy, timeDiff, vm;
    vm = this;
    vm.today = new Date();
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    vm.flag_status_policy = true;
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.tpolicy.list");
    } else {
      date1 = new Date(vm.policy.issue_date);
      timeDiff = Math.abs(date1.getTime() - vm.today.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays >= 1) {
        vm.flag_status_policy = false;
      }
    }
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.tpolicy.list");
      });
      return false;
    };
    downloadPDF = function() {
      if (vm.policy.objects === 'TS') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'LN') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'NED') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    termPolicy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.tpolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.tpolicy.list');
    };
    goToForm = function() {
      $state.go('app.policy_form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issuePolicy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('SidebarController', function() {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('RoleController', function($scope, $state, RequestService, toastr, hotkeys, $uibModal) {
    'ngInject';
    var editRole, getRoles, newRole, vm;
    vm = this;
    vm.rolesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Наименование'
        }, {
          name: 'data.approval_name',
          displayName: 'Наим. для одобрения'
        }, {
          name: 'data.read',
          displayName: 'Чтение'
        }, {
          name: 'data.write',
          displayName: 'Редактирование'
        }, {
          name: 'data.delete',
          displayName: 'Удаление'
        }
      ]
    };
    getRoles = function() {
      var filter;
      filter = {};
      RequestService.post('role.listing', filter).then(function(result) {
        delete vm.selected_role;
        vm.roles = result.docs;
        vm.rolesGridOptions.data = vm.roles;
      });
    };
    editRole = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/role/edit.html',
        controller: 'RoleEditController',
        controllerAs: 'role',
        size: 'lg',
        resolve: {
          role: angular.copy(vm.selected_role)
        }
      });
      editModal.result.then(function() {
        return getRoles();
      });
      return false;
    };
    newRole = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/role/edit.html',
        controller: 'RoleEditController',
        controllerAs: 'role',
        size: 'lg',
        resolve: {
          role: void 0
        }
      });
      editModal.result.then(function() {
        return getRoles();
      });
    };
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить роль',
      callback: newRole
    }).add({
      combo: 'r',
      description: 'Обновить список ролей',
      callback: getRoles
    });
    $scope.$on('data-selected', function(event, row) {
      vm.selected_role = row.entity;
    });
    vm.getRoles = getRoles;
    vm.editRole = editRole;
    vm.newRole = newRole;
    getRoles();
  });

  angular.module('fsa').controller('RoleEditController', function($scope, RequestService, AppStorage, toastr, role, $uibModalInstance) {
    'ngInject';
    var menuParentGroup, saveRole, vm;
    vm = this;
    vm.role = role || {
      type: 'Roles',
      data: {
        read: true
      }
    };
    vm.menus = AppStorage.getObject('menus') || [];
    saveRole = function() {
      vm.role.type = 'Roles';
      RequestService.post('role.save', vm.role).then(function(result) {
        $uibModalInstance.close(result);
      });
      return false;
    };
    menuParentGroup = function(menu) {
      if (menu && menu.parent && menu.parent.name) {
        return menu.parent.name;
      }
    };
    vm.saveRole = saveRole;
    vm.menuParentGroup = menuParentGroup;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportperiodController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var date, downloadEXCELRPCR, downloadEXCELRPFR, downloadExcelOR, downloadExcelRPAP, downloadPDFOR, downloadPDFRPA, downloadPDFRPAR, downloadPDFRPC, downloadPDFRPCR, downloadPDFRPF, downloadPDFRPFR, getAgents, getBranches, getPolicies, m, removeAgents, removeBranches, vm, y;
    vm = this;
    vm.today = new Date();
    date = new Date();
    y = date.getFullYear();
    m = date.getMonth();
    vm.date_start = new Date(y, m, 1);
    vm.date_end = new Date();
    vm.offset = 0;
    vm.limit = 50;
    vm.branch_id = null;
    vm.user_id = null;
    vm.agents = [];
    vm.branches = [];
    vm.policies = null;
    vm.policy_filtered = [];
    vm.policy_status = 'Оформлен';
    vm.company = Session.getCompany();
    vm.user = Session.getUser();
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [50, 100, 500],
      paginationPageSize: 50,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'insurance_amount',
          displayName: 'Страховая сумма'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ]
    };
    downloadPDFRPC = function() {
      ReportService.printReport('RPC', {
        'status': vm.policy_status + '',
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadPDFRPCR = function() {
      ReportService.printReport('RPCR', {
        'status': vm.policy_status + '',
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadPDFOR = function() {
      ReportService.printReport('OR', {
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadEXCELRPCR = function() {
      ReportService.saveReportExcel('RPCR', {
        'status': vm.policy_status + '',
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadPDFRPFR = function() {
      ReportService.printReport('RPFR', {
        'branch_id': vm.branch_id + '',
        'status': vm.policy_status + '',
        'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
        'end_date': moment(vm.date_end).format('DD.MM.YYYY') + ''
      });
    };
    downloadEXCELRPFR = function() {
      ReportService.saveReportExcel('RPFR', {
        'branch_id': vm.branch_id + '',
        'status': vm.policy_status + '',
        'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
        'end_date': moment(vm.date_end).format('DD.MM.YYYY') + ''
      });
    };
    downloadPDFRPF = function() {
      ReportService.printReport('RPF', {
        'branch_id': vm.branch_id + '',
        'status': vm.policy_status + '',
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadPDFRPAR = function() {
      ReportService.printReport('RPAR', {
        'user_id': String(vm.user_id) + '',
        'status': vm.policy_status + '',
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        end_date: moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadPDFRPA = function() {
      ReportService.printReport('RPA', {
        'user_id': String(vm.user_id) + '',
        'status': vm.policy_status + '',
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        end_date: moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadExcelRPAP = function() {
      ReportService.saveReportExcel('RPCR', {
        'status': vm.policy_status + '',
        'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
        end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
      });
    };
    downloadExcelOR = function() {
      ReportService.saveReportExcel('OR', {
        'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
        end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
      });
    };
    getPolicies = function() {
      if (vm.company.company_type === 'insurance_company' && vm.branch_id === null && vm.user_id === null) {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            date_start: vm.date_start,
            date_end: vm.date_end,
            data: {
              status: vm.policy_status
            }
          }
        };
      } else if (vm.company.company_type === 'branch_company') {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            company_id: vm.company._id,
            date_end: vm.date_end,
            edit_user_id: vm.user.id,
            data: {
              status: vm.policy_status
            }
          }
        };
      } else if (vm.company.company_type === 'insurance_company' && vm.branch_id !== null && vm.user_id === null) {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            company_id: vm.branch_id,
            date_start: vm.date_start,
            date_end: vm.date_end,
            data: {
              status: vm.policy_status
            }
          }
        };
      } else if (vm.company.company_type === 'insurance_company' && vm.user_id !== null) {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            user_id: String(vm.user_id),
            date_start: vm.date_start,
            date_end: vm.date_end,
            data: {
              status: vm.policy_status
            }
          }
        };
      }
      RequestService.post('policies.listing', vm.filter).then(function(data) {
        delete vm.selected_policy;
        vm.policiesGridOptions.data = angular.copy(data.docs);
        return vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getBranches = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'agent'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        return vm.branches = data.docs;
      });
    };
    getAgents = function() {
      var filter;
      if (vm.branch_id) {
        filter = {
          offset: vm.offset,
          limit: vm.limit,
          with_related: true,
          id: vm.branch_id
        };
        RequestService.post('agentemployee.listing', filter).then(function(data) {
          return vm.agents = data.users;
        });
      } else {
        vm.agents = [];
      }
    };
    removeAgents = function() {
      vm.user_id = null;
    };
    removeBranches = function() {
      vm.branch_id = null;
      vm.user_id = null;
      $scope.$watch('reportperiod.user_id', function() {
        vm.agents = [];
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDFRPFR = downloadPDFRPFR;
    vm.downloadPDFRPF = downloadPDFRPF;
    vm.downloadExcelRPAP = downloadExcelRPAP;
    vm.downloadPDFRPA = downloadPDFRPA;
    vm.downloadPDFOR = downloadPDFOR;
    vm.downloadPDFRPAR = downloadPDFRPAR;
    vm.downloadPDFRPC = downloadPDFRPC;
    vm.downloadPDFRPCR = downloadPDFRPCR;
    vm.getPolicies = getPolicies;
    vm.getBranches = getBranches;
    vm.getAgents = getAgents;
    vm.removeAgents = removeAgents;
    vm.removeBranches = removeBranches;
    vm.downloadEXCELRPCR = downloadEXCELRPCR;
    vm.downloadExcelOR = downloadExcelOR;
    vm.downloadEXCELRPFR = downloadEXCELRPFR;
    getBranches();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportendController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var date, downloadEXCELRPCR, downloadPDFRPCR, getAgents, getBranches, getPolicies, m, removeAgents, removeBranches, vm, y;
    vm = this;
    vm.today = new Date();
    date = new Date();
    y = date.getFullYear();
    m = date.getMonth();
    vm.date_start = new Date(y, m, 1);
    vm.date_end = new Date();
    vm.offset = 0;
    vm.limit = 50;
    vm.branch_id = null;
    vm.user_id = null;
    vm.agents = [];
    vm.branches = [];
    vm.policies = null;
    vm.policy_filtered = [];
    vm.policy_status = 'Оформлен';
    vm.company = Session.getCompany();
    vm.user = Session.getUser();
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [50, 100, 500],
      paginationPageSize: 50,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'insurance_amount',
          displayName: 'Страховая сумма'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ]
    };
    downloadPDFRPCR = function() {
      ReportService.printReport('RPCRI', {
        'status': vm.policy_status + '',
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadEXCELRPCR = function() {
      ReportService.saveReportExcel('RPCRI', {
        'status': vm.policy_status + '',
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    getPolicies = function() {
      if (vm.company.company_type === 'insurance_company' && vm.branch_id === null && vm.user_id === null) {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            dateStart: vm.date_start,
            dateEnd: vm.date_end,
            data: {
              status: vm.policy_status
            }
          }
        };
      } else if (vm.company.company_type === 'branch_company') {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            company_id: vm.company._id,
            dateEnd: vm.date_end,
            edit_user_id: vm.user.id,
            data: {
              status: vm.policy_status
            }
          }
        };
      } else if (vm.company.company_type === 'insurance_company' && vm.branch_id !== null && vm.user_id === null) {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            company_id: vm.branch_id,
            dateStart: vm.date_start,
            dateEnd: vm.date_end,
            data: {
              status: vm.policy_status
            }
          }
        };
      } else if (vm.company.company_type === 'insurance_company' && vm.user_id !== null) {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            user_id: String(vm.user_id),
            dateStart: vm.date_start,
            dateEnd: vm.date_end,
            data: {
              status: vm.policy_status
            }
          }
        };
      }
      RequestService.post('policies.listing', vm.filter).then(function(data) {
        delete vm.selected_policy;
        vm.policiesGridOptions.data = angular.copy(data.docs);
        return vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getBranches = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'agent'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        return vm.branches = data.docs;
      });
    };
    getAgents = function() {
      var filter;
      if (vm.branch_id) {
        filter = {
          offset: vm.offset,
          limit: vm.limit,
          with_related: true,
          id: vm.branch_id
        };
        RequestService.post('agentemployee.listing', filter).then(function(data) {
          return vm.agents = data.users;
        });
      } else {
        vm.agents = [];
      }
    };
    removeAgents = function() {
      vm.user_id = null;
    };
    removeBranches = function() {
      vm.branch_id = null;
      vm.user_id = null;
      $scope.$watch('reportperiod.user_id', function() {
        vm.agents = [];
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDFRPCR = downloadPDFRPCR;
    vm.getPolicies = getPolicies;
    vm.getBranches = getBranches;
    vm.getAgents = getAgents;
    vm.removeAgents = removeAgents;
    vm.removeBranches = removeBranches;
    vm.downloadEXCELRPCR = downloadEXCELRPCR;
    getBranches();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('Report_templateEditController', function($scope, RequestService, $uibModalInstance, report_template, toastr) {
    var save, vm;
    vm = this;
    vm.template = report_template || {
      "ReportVersion": "2016.2.5",
      "ReportGuid": "fa01abce0ca5d18ec4ad5a91c86cf9ed",
      "ReportName": "Report",
      "ReportAlias": "Report",
      "ReportCreated": "/Date(1480997975000+0600)/",
      "ReportChanged": "/Date(1480997975000+0600)/",
      "EngineVersion": "EngineV2",
      "CalculationMode": "Interpretation",
      "Pages": {
        "0": {
          "Ident": "StiPage",
          "Name": "Page1",
          "Guid": "4c037a5bc82cc89b8aaeaca0d31be61e",
          "Interaction": {
            "Ident": "StiInteraction"
          },
          "Border": ";;2;;;;;solid:Black",
          "Brush": "solid:Transparent",
          "PageWidth": 21.01,
          "PageHeight": 29.69,
          "Watermark": {
            "TextBrush": "solid:50,0,0,0"
          },
          "Margins": {
            "Left": 1,
            "Right": 1,
            "Top": 1,
            "Bottom": 1
          }
        }
      }
    };
    save = function() {
      if (vm.saving) {
        return;
      }
      vm.saving = true;
      if (!vm.template.code) {
        toastr.warning('Укажите код');
        vm.saving = false;
        return;
      }
      if (!vm.template.name) {
        toastr.warning('Укажите наименование');
        vm.saving = false;
        return;
      }
      if (!vm.template.report_category_id) {
        toastr.warning('Укажите категорию');
        vm.saving = false;
        return;
      }
      if (!vm.template.template) {
        toastr.warning('Заполните шаблон');
        vm.saving = false;
        return;
      }
      return RequestService.post('report.put', vm.template).then(function(data) {
        vm.saving = false;
        return $uibModalInstance.close(data);
      }, function() {
        return vm.saving = false;
      });
    };
    vm.save = save;
    vm.cancel = function() {
      return $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('Report_templateController', function($scope, RequestService, $uibModal) {
    var editQuery, editTemplate, getQueries, getTemplates, newQuery, newTemplate, vm;
    vm = this;
    vm.gridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          field: 'code',
          displayName: 'Код'
        }, {
          field: 'name',
          displayName: 'Наименование'
        }, {
          field: 'report_category.name',
          displayName: 'Категория'
        }
      ]
    };
    vm.queriesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          field: 'code',
          displayName: 'Код'
        }, {
          field: 'name',
          displayName: 'Наименование'
        }, {
          field: 'result_key',
          displayName: 'Ключ возврата'
        }
      ]
    };
    getTemplates = function() {
      var filter;
      filter = {
        with_related: true
      };
      return RequestService.post('report.listing', filter).then(function(data) {
        delete vm.selected_template;
        vm.gridOptions.data = data.report_list;
        return vm.gridOptions.totalItems = data.count;
      });
    };
    newTemplate = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/report_template/template_edit.html',
        controller: 'Report_templateEditController',
        controllerAs: 'edit',
        size: 'lg',
        scope: $scope,
        resolve: {
          report_template: null
        }
      });
      return editModal.result.then(function() {
        return getTemplates();
      });
    };
    editTemplate = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/report_template/template_edit.html',
        controller: 'Report_templateEditController',
        controllerAs: 'edit',
        size: 'lg',
        scope: $scope,
        resolve: {
          report_template: vm.selected_template
        }
      });
      return editModal.result.then(function() {
        delete vm.selected_template;
        return getTemplates();
      });
    };
    getQueries = function() {
      var filter;
      filter = {};
      return RequestService.post('report.query_listing', filter).then(function(data) {
        delete vm.selected_query;
        vm.queriesGridOptions.data = data.docs;
        return vm.queriesGridOptions.totalItems = data.count;
      });
    };
    newQuery = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/report_template/query_edit.html',
        controller: 'ReportQueryEditController',
        controllerAs: 'edit',
        size: 'lg',
        scope: $scope,
        resolve: {
          report_query: null
        }
      });
      return editModal.result.then(function() {
        return getQueries();
      });
    };
    editQuery = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/report_template/query_edit.html',
        controller: 'ReportQueryEditController',
        controllerAs: 'edit',
        size: 'lg',
        scope: $scope,
        resolve: {
          report_query: vm.selected_query
        }
      });
      return editModal.result.then(function() {
        delete vm.selected_query;
        return getQueries();
      });
    };
    $scope.$on('data-selected', function(event, data) {
      if (data.grid.id === vm.gridOptions.gridApi.grid.id) {
        vm.selected_template = data.entity;
      } else if (data.grid.id === vm.queriesGridOptions.gridApi.grid.id) {
        vm.selected_query = data.entity;
      }
    });
    getTemplates();
    getQueries();
    vm.getTemplates = getTemplates;
    vm.newTemplate = newTemplate;
    vm.editTemplate = editTemplate;
    vm.getQueries = getQueries;
    vm.newQuery = newQuery;
    vm.editQuery = editQuery;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportQueryEditController', function($scope, RequestService, $uibModalInstance, report_query, toastr) {
    var save, vm;
    vm = this;
    vm.query = report_query || {};
    save = function() {
      if (vm.saving) {
        return;
      }
      vm.saving = true;
      if (!vm.query.code) {
        toastr.warning('Укажите код');
        vm.saving = false;
        return;
      }
      if (!vm.query.name) {
        toastr.warning('Укажите наименование');
        vm.saving = false;
        return;
      }
      if (!vm.query.result_key) {
        toastr.warning('Укажите ключ возврата');
        vm.saving = false;
        return;
      }
      if (!vm.query.query) {
        toastr.warning('Заполните запрос');
        vm.saving = false;
        return;
      }
      return RequestService.post('report.query_put', vm.query).then(function(data) {
        vm.saving = false;
        return $uibModalInstance.close(data);
      }, function() {
        return vm.saving = false;
      });
    };
    vm.save = save;
    vm.cancel = function() {
      return $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportaController', function($scope, RequestService, $timeout, $document, $stateParams) {
    var createDesigner, createViewer, designer, designerFullWindowToggle, getCategoryList, getReportList, reportObj, reportTemp, search, setReport, setSelected, viewer, vm;
    vm = this;
    viewer = null;
    designer = null;
    reportTemp = {
      "ReportVersion": "2016.2.5",
      "ReportGuid": "fa01abce0ca5d18ec4ad5a91c86cf9ed",
      "ReportName": "Report",
      "ReportAlias": "Report",
      "ReportCreated": "/Date(1480997975000+0600)/",
      "ReportChanged": "/Date(1480997975000+0600)/",
      "EngineVersion": "EngineV2",
      "CalculationMode": "Interpretation",
      "Pages": {
        "0": {
          "Ident": "StiPage",
          "Name": "Page1",
          "Guid": "4c037a5bc82cc89b8aaeaca0d31be61e",
          "Interaction": {
            "Ident": "StiInteraction"
          },
          "Border": ";;2;;;;;solid:Black",
          "Brush": "solid:Transparent",
          "PageWidth": 21.01,
          "PageHeight": 29.69,
          "Watermark": {
            "TextBrush": "solid:50,0,0,0"
          },
          "Margins": {
            "Left": 1,
            "Right": 1,
            "Top": 1,
            "Bottom": 1
          }
        }
      }
    };
    reportObj = {};
    search = {};
    Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile("assets/stimulsoft/ru.xml");
    createViewer = function() {
      var options;
      options = new Stimulsoft.Viewer.StiViewerOptions();
      options.height = "100%";
      options.appearance.scrollbarsMode = true;
      options.toolbar.showDesignButton = false;
      options.toolbar.showFullScreenButton = false;
      options.toolbar.showAboutButton = false;
      options.exports.showExportToPdf = true;
      options.exports.showExportToExcel2007 = true;
      options.exports.ShowExportToWord2007 = false;
      options.exports.showExportToHtml = false;
      options.exports.showExportToDocument = false;
      viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
      viewer.renderHtml("viewerContent");
      viewer.jsObject.postInteractionOld = viewer.jsObject.postInteraction;
      viewer.jsObject.postInteraction = function(params) {
        var report;
        if (params.action === 'Variables' && reportObj.code) {
          report = viewer.report;
          RequestService.post('report/get_query_result', {
            code: reportObj.code,
            parameters: params.variables
          }).then(function(response) {
            report.dictionary.databases.clear();
            report.regData(reportObj.code, reportObj.code, response.data);
          });
        }
        viewer.jsObject.postInteractionOld(params);
      };
      setReport(reportTemp);
      document.getElementById("StiViewerReportPanel").style.cssText = "text-align: center;bottom: 0px;position: static;top: 35px;overflow: auto;margin-top: 0px;";
    };
    designerFullWindowToggle = function() {
      var body, reportDesigner;
      body = $document.find('body');
      reportDesigner = $document.find('#designerContent');
      if (body.hasClass('report-designer-fullscreen')) {
        body.removeClass('report-designer-fullscreen');
        reportDesigner.removeClass('fullscreen');
      } else {
        body.addClass('report-designer-fullscreen');
        reportDesigner.addClass('fullscreen');
      }
    };
    createDesigner = function() {
      var options, resizeBtn;
      options = new Stimulsoft.Designer.StiDesignerOptions();
      options.appearance.fullScreenMode = false;
      options.appearance.htmlRenderMode = Stimulsoft.Report.Export.StiHtmlExportMode.Table;
      options.appearance.showSaveDialog = false;
      options.toolbar.showFileMenuExit = false;
      options.toolbar.showFileMenu = false;
      options.toolbar.showPreviewButton = true;
      options.toolbar.showAboutButton = false;
      designer = new Stimulsoft.Designer.StiDesigner(options, "StiDesigner", false);
      designer.onSaveReport = function(event) {
        var _params;
        if (!reportObj.code) {
          return;
        }
        reportObj.template = event.report.saveToJsonString();
        RequestService.post('report.put', reportObj).then(function(response) {});
        _params = {};
        angular.forEach(event.report.dictionary.variables.list, function(variable) {
          _params[variable.name] = variable.value;
        });
        RequestService.post('report.get_query_result', {
          code: reportObj.code,
          parameters: _params
        }).then(function(response) {
          event.report.dictionary.databases.clear();
          event.report.regData(reportObj.code, reportObj.code, response.data);
        });
      };
      designer.renderHtml("designerContent");
      viewer = designer.jsObject.options.viewerContainer.firstChild;
      viewer.jsObject.postInteractionOld = viewer.jsObject.postInteraction;
      viewer.jsObject.postInteraction = function(params) {
        var report;
        if (params.action === 'Variables' && reportObj.code) {
          report = viewer.jsObject.viewer.report;
          RequestService.post('report.get_query_result', {
            code: reportObj.code,
            parameters: params.variables
          }).then(function(response) {
            report.dictionary.databases.clear();
            report.regData(reportObj.code, reportObj.code, response.data);
          });
        }
        viewer.jsObject.postInteractionOld(params);
      };
      resizeBtn = $document.find('#StiDesignerresizeDesigner');
      resizeBtn[0].action = designerFullWindowToggle;
      setReport(reportTemp);
    };
    getCategoryList = function() {
      RequestService.post('report.category_listing', {}).then(function(response) {
        vm.report_categories = response.docs;
      });
    };
    getReportList = function() {
      var filter;
      filter = {
        filter: {
          report_category_id: vm.search.report_category_id
        }
      };
      RequestService.post('report.listing', filter).then(function(data) {
        vm.reports = data.report_list;
      });
    };
    setReport = function(reportObject) {
      $timeout(function() {
        var report;
        report = new Stimulsoft.Report.StiReport();
        report.load(reportObject);
        if (viewer) {
          viewer.report = report;
        }
        if (designer) {
          designer.report = report;
        }
      });
    };
    setSelected = function(selectedReport) {
      if (selectedReport === void 0) {
        return;
      }
      reportObj = selectedReport;
      setReport(JSON.parse(reportObj.template));
    };
    vm.getReportList = getReportList;
    vm.getCategoryList = getCategoryList;
    vm.setSelected = setSelected;
    getCategoryList();
    if ($stateParams.reportMode && $stateParams.reportMode === 'designer') {
      createDesigner();
    } else {
      createViewer();
    }
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportController', function($scope, RequestService) {
    var createViewer, getReportList, setReport, showReport, viewer, vm;
    vm = this;
    viewer = null;
    Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile("app/stimullib/ru.xml");
    createViewer = function() {
      var options;
      options = new Stimulsoft.Viewer.StiViewerOptions();
      options.height = "100%";
      options.appearance.scrollbarsMode = true;
      options.toolbar.showDesignButton = false;
      options.toolbar.showFullScreenButton = false;
      options.exports.showExportToPdf = true;
      options.exports.showExportToExcel2007 = true;
      options.exports.ShowExportToWord2007 = false;
      options.exports.showExportToHtml = false;
      options.exports.showExportToDocument = false;
      viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
      viewer.renderHtml("reportViewer");
    };
    setReport = function(reportObject) {
      viewer.showProcessIndicator();
      setTimeout(function() {
        var report;
        report = new Stimulsoft.Report.StiReport();
        report.load(reportObject);
        viewer.report = report;
      }, 50);
    };
    getReportList = function() {
      var filter;
      filter = {
        filter: {
          report_category_id: vm.report_category_id
        }
      };
      RequestService.post('report.listing', filter).then(function(data) {
        vm.reports = data.report_list;
      });
    };
    showReport = function(report) {
      var reportObject;
      reportObject = JSON.parse(report.template) || {};
      return setReport(reportObject);
    };
    $scope.$watch('report.report_category_id', function(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        return getReportList();
      }
    });
    $scope.$watch('report.selected_report', function(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        return showReport(newVal);
      }
    });
    vm.getReportList = getReportList;
    vm.showReport = showReport;
    createViewer();
    setReport({});
    document.getElementById("StiViewerReportPanel").style.cssText = "text-align: center;bottom: 0px;position: static;top: 35px;overflow: auto;margin-top: 0px;";
  });

}).call(this);



(function() {
  angular.module('fsa').controller('RegulationsController', function($timeout, toastr, $rootScope, $http, $state) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('RegulationsListController', function($rootScope, $scope, $state, RequestService, $http, $uibModal) {
    'ngInject';
    var confirmAction, getRegulations, openCreateForm, openEditForm, removeRegulations, vm;
    vm = this;
    vm.searchValues = {};
    vm.searchValuesLang = {};
    vm.dateOptions = {
      startingDay: 1,
      opened1: false,
      opened2: false
    };
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [100, 200, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          displayName: 'Наименование',
          name: 'name'
        }
      ],
      events: {
        onRowSelect: function(row) {
          vm.selected_regulations = angular.copy(row.entity);
        },
        onPageSelect: function(page, size) {
          vm.offset = page * size;
          vm.limit = size;
          getRegulations();
        }
      }
    };
    getRegulations = function() {
      var filters, lang;
      lang = vm.searchValuesLang;
      filters = vm.searchValues;
      RequestService.post('regulations/listing', filters, lang).then(function(response) {
        vm.gridOptions.data = response.list;
      }, function(response) {});
    };
    openCreateForm = function() {
      $state.go('app.regulations.form');
    };
    openEditForm = function() {
      return $state.go('app.regulations.form', {
        regulations: vm.selected_regulations
      });
    };
    removeRegulations = function() {
      if (!vm.selected_regulations) {
        return;
      }
      vm.selected_regulations.crud = 'Regulations';
      RequestService.post('regulations/remove', vm.selected_regulations).then(function(result) {
        getRegulations();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_regulations = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getRegulations();
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот документ"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeRegulations();
        }
      });
    };
    vm.removeRegulations = removeRegulations;
    vm.getRegulations = getRegulations;
    vm.openCreateForm = openCreateForm;
    vm.openEditForm = openEditForm;
    vm.confirmAction = confirmAction;
    getRegulations();
  }).controller('RegulationsFormController', function($rootScope, $scope, $state, $stateParams, RequestService, $http, $base64, Session, toastr) {
    'ngInject';
    var goBack, saveRegulations, vm;
    vm = this;
    vm.regulationsItem = $stateParams.regulations;
    saveRegulations = function() {
      RequestService.post('regulations/put', vm.regulationsItem).then(function(response) {
        goBack();
      }, function(response) {});
    };
    goBack = function() {
      $state.go('app.regulations.list');
    };
    vm.saveRegulations = saveRegulations;
    vm.goBack = goBack;
  });

}).call(this);



(function() {


}).call(this);



(function() {
  angular.module('fsa').controller('ProfileController', function($scope, $rootScope) {
    'ngInject';
    var vm;
    vm = this;
    vm.api = $rootScope.api;
  }).controller('ProfileEditController', function($scope, $state, RequestService, $uibModal, $uibModalStack, toastr, Session, AppStorage) {
    'ngInject';
    var canChangePassword, changePassword, imageSelected, isEdited, openDatePicker, passwordConfirmed, passwordLevel, putData, vm;
    vm = this;
    vm.profile = angular.copy($scope.app.ua);
    imageSelected = function(event, $flow, flowFile) {
      var avatarModal;
      if (!flowFile.file.type.startsWith('image/')) {
        toastr.warning('Выберите изображение');
        event.preventDefault();
        return false;
      }
      avatarModal = $uibModal.open({
        templateUrl: 'app/profile/avatar.html',
        controller: 'AvatarEditController',
        controllerAs: 'avatar',
        size: 'lg',
        resolve: {
          image: flowFile.file
        }
      });
      avatarModal.result.then(function(image) {
        $flow.cancel();
        RequestService.post('upload/user/' + vm.profile.id, {
          file: image
        }).then(function(result) {
          vm.profile.data.image = 'image/' + result.file;
        });
      }, function(result) {
        $flow.cancel();
      });
    };
    isEdited = function() {
      if (angular.isUndefined($scope.app.ua)) {
        return false;
      }
      if (!angular.equals(vm.profile.username, $scope.app.ua.username)) {
        return true;
      }
      if (!angular.equals(vm.profile.email, $scope.app.ua.email)) {
        return true;
      }
      if (!angular.equals(vm.profile.data, $scope.app.ua.data)) {
        return true;
      }
    };
    canChangePassword = function() {
      return angular.isDefined(vm.profile.password) && passwordConfirmed();
    };
    passwordConfirmed = function() {
      if ((angular.isDefined(vm.profile.new_password)) && vm.profile.new_password.length >= 6) {
        return angular.equals(vm.profile.new_password, vm.profile.confirm_password);
      }
      return false;
    };
    passwordLevel = function() {
      var hasCaps, hasNumber, length;
      if (angular.isUndefined(vm.profile.new_password)) {
        return 0;
      }
      hasCaps = /[A-Z]/.test(vm.profile.new_password);
      hasNumber = /\d/.test(vm.profile.new_password);
      length = vm.profile.new_password.length;
      if (length < 6) {
        return 0;
      } else if (hasCaps && hasNumber && length > 8) {
        return 3;
      } else if (((hasCaps || hasNumber) && length > 8) || ((hasCaps && hasNumber) || length > 8)) {
        return 2;
      } else {
        return 1;
      }
    };
    putData = function() {
      return RequestService.post('user.put', vm.profile).then(function(result) {
        vm.profile = result.user;
        Session.setUser(result.user);
        $scope.app.ua = Session.getUser();
        $state.go('app.dashboard');
        toastr.success('Изменения сохранены');
      });
    };
    changePassword = function() {
      if (!canChangePassword()) {
        return;
      }
      return RequestService.post('user.putPassword', vm.profile).then(function(result) {
        vm.profile = $scope.app.ua;
      });
    };
    openDatePicker = function() {
      vm.datepicker_opened = !vm.datepicker_opened;
    };
    vm.imageSelected = imageSelected;
    vm.isEdited = isEdited;
    vm.canChangePassword = canChangePassword;
    vm.passwordLevel = passwordLevel;
    vm.passwordConfirmed = passwordConfirmed;
    vm.putData = putData;
    vm.changePassword = changePassword;
    vm.openDatePicker = openDatePicker;
  }).controller('ProfileViewController', function($scope, $rootScope) {
    'ngInject';
    var vm;
    vm = this;
    vm.api = $rootScope.api;
  }).controller('AvatarEditController', function($scope, image, $uibModalInstance) {
    'ngInject';
    var readFile, vm;
    vm = this;
    vm.image = '';
    vm.result_image = '';
    readFile = function() {
      var reader;
      if (angular.isUndefined(image)) {
        return;
      }
      vm.imageLoading = true;
      reader = new FileReader();
      reader.onload = function(event) {
        $scope.$apply(function($scope) {
          vm.imageLoading = false;
          vm.image = event.target.result;
        });
      };
      return reader.readAsDataURL(image);
    };
    vm.ok = function() {
      $uibModalInstance.close(vm.result_image);
    };
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    readFile();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ProductController', function($scope, Session, $state, RequestService, toastr, hotkeys, $uibModal) {
    'ngInject';
    var confirmAction, deleteProduct, getProducts, gotoedit, gotoview, vm;
    vm = this;
    $scope.g;
    vm.offset = 0;
    vm.limit = 10;
    vm.productsGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'description',
          displayName: 'описание'
        }, {
          name: 'code',
          displayName: 'Код'
        }, {
          name: 'date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'date_update',
          displayName: 'Дата обновления',
          visible: false
        }, {
          name: 'date_close',
          displayName: 'Закрытие',
          visible: false
        }, {
          name: 'user_update',
          displayName: 'Пользователь',
          visible: false
        }, {
          name: 'user_entry',
          displayName: 'Залогинившийся',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ]
    };
    deleteProduct = function() {
      RequestService.post('productsbasefactor.deleteall', {
        items: vm.selected_product.basefactors
      }).then(function(result) {});
      RequestService.post('productfactor.deleteall', {
        items: vm.selected_product.factors
      }).then(function(result) {});
      RequestService.post('product.delete', vm.selected_product).then(function(result) {
        getProducts();
      });
    };
    getProducts = function() {
      var company, filter, filter1;
      company = Session.getCompany();
      filter1 = {};
      if (company !== null && company !== void 0) {
        filter1.company_id = company._id;
      }
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        filter: filter1
      };
      RequestService.post('product.listing', filter).then(function(result) {
        var item, j, len, ref;
        delete vm.selected_product;
        vm.products = result.docs;
        ref = vm.products;
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          item.date_start = new Date(item.date_start);
          item.date_end = new Date(item.date_end);
        }
        console.log(vm.products);
        vm.productsGridOptions.data = vm.products;
        vm.productsGridOptions.totalItems = result.count;
      });
    };
    gotoedit = function(item) {
      return $state.go('app.product_new', {
        product: item
      });
    };
    gotoview = function(item) {
      return $state.go('app.product_view', {
        product: item
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_product = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getProducts();
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот продукт"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deleteProduct();
        }
      });
    };
    vm.confirmAction = confirmAction;
    vm.deleteProduct = deleteProduct;
    vm.gotoview = gotoview;
    vm.gotoedit = gotoedit;
    vm.getProducts = getProducts;
    getProducts();
  }).controller('ProductNewController', function($scope, Session, RequestService, $stateParams, $filter, $state, toastr, $uibModal) {
    'ngInject';
    var addBF, basefactorDelete, basefactorEdit, basefactorRowEdit, clearFactorValues, confirmActionBF, confirmActionBFdelete, confirmActionF, confirmActionFDeleteAll, confirmActionFdelete, confirmActionFinish, countryFilter, deleteBF, deleteBFandDB, factorValueFilter, getInsAmount, getProductsBaseFactor, getProductsFactor, initFunc, removeAllFactors, removeFactor, resetForm, saveProduct, saveProductsBaseFactor, saveProductsFactor, sortFactorValues, vm;
    vm = this;
    vm.today = new Date();
    vm.new_product = $stateParams.product | {
      services_id: []
    };
    vm.selected_country = '';
    vm.current_BF = {
      countries_id: [],
      values: []
    };
    vm.current_F = {};
    vm.BFitem = {};
    resetForm = function() {
      vm.current_BF = {
        countries_id: [],
        values: []
      };
    };
    addBF = function() {
      var i, item, j, k, len, len1, ref, ref1, temp_bf;
      temp_bf = null;
      if (vm.BFitem.from_day > vm.BFitem.to_day) {
        console.log("product.controller.coffee/ProductNewController/addBF: Такой промежуток НЕВОЗМОЖЕН");
        return;
      }
      ref = vm.current_BF.values;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if ((item.to_day < vm.BFitem.from_day) || (item.from_day > vm.BFitem.to_day)) {
          null;
        } else {
          if (vm.BFitem._id !== void 0 && vm.BFitem._id !== null) {
            if (item._id === vm.BFitem._id) {
              continue;
            }
          }
          console.log("product.controller.coffee/ProductNewController/addBF: Конфлик интервалов");
          return;
        }
      }
      if (vm.BFitem._id !== void 0 && vm.BFitem._id !== null) {
        ref1 = vm.current_BF.values;
        for (i = k = 0, len1 = ref1.length; k < len1; i = ++k) {
          item = ref1[i];
          if (item._id === vm.BFitem._id) {
            vm.current_BF.values.splice(i, 1);
          }
        }
      }
      vm.current_BF.values.push(vm.BFitem);
      return vm.BFitem = {};
    };
    removeFactor = function(index, item, top) {
      vm.factorListTS.splice(index, 1);
      RequestService.post('productfactor.delete', {
        _id: item._id,
        _rev: item._rev
      }).then(function(result) {
        getProductsFactor();
      });
    };
    removeAllFactors = function(bf) {
      RequestService.post('productfactor.deleteall', {
        items: bf.data
      }).then(function(result) {
        getProductsFactor();
      });
    };
    deleteBF = function(index) {
      return vm.current_BF.values.splice(index, 1);
    };
    deleteBFandDB = function(index, item) {
      vm.current_BF.values.splice(index, 1);
      RequestService.post('productsbasefactor.delete', {
        _id: item._id,
        _rev: item._rev
      }).then(function(result) {});
    };
    initFunc = function() {
      if ($stateParams.product === null || $stateParams.product === void 0) {
        vm.new_product = {};
      } else {
        vm.new_product = $stateParams.product;
        vm.current_BF.product_id = vm.new_product._id | null;
        return vm.current_F.product_id = vm.new_product._id | null;
      }
    };
    saveProduct = function() {
      var company, company_id, product_code;
      company = Session.getCompany();
      company_id = null;
      product_code = null;
      if (company !== null && company !== void 0) {
        company_id = company._id;
        if (vm.new_product.insurance_type !== null && vm.new_product.insurance_type !== void 0) {
          product_code = company.code + vm.new_product.insurance_type + '00';
          vm.new_product.code = product_code;
        } else {
          console.log("vm.insurance_type_code isnt null and vm.insurance_type_code isnt undefined");
          return;
        }
      }
      if (vm.new_product.company_id === null || vm.new_product.company_id === void 0) {
        vm.new_product.company_id = company_id;
      }
      if (vm.new_product.basefactors) {
        delete vm.new_product.basefactors;
      }
      if (vm.new_product.factors) {
        delete vm.new_product.factors;
      }
      if (vm.new_product.services) {
        delete vm.new_product.services;
      }
      RequestService.post('product.save', vm.new_product).then(function(result) {
        vm.current_BF.product_id = result.id;
        vm.current_F.product_id = result.id;
        vm.new_product._id = result.id;
        return toastr.success('Продукт Сохранен успешно');
      });
      return false;
    };
    basefactorRowEdit = function(bf) {
      vm.BFitem = angular.copy(bf);
    };
    basefactorDelete = function(index, bf) {
      RequestService.post('productsbasefactor.deleteall', {
        items: bf.data
      }).then(function(result) {
        getProductsBaseFactor();
      });
    };
    basefactorEdit = function(bf) {
      var item, item1, j, k, len, len1, ref, ref1;
      vm.current_BF.countries_id = [];
      ref = bf.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        vm.current_BF.countries_id.push(item._id);
      }
      vm.current_BF.insurance_amount = bf.data[0].insurance_amount;
      vm.current_BF.values = [];
      vm.current_BF.values = bf.data;
      ref1 = vm.current_BF.values;
      for (k = 0, len1 = ref1.length; k < len1; k++) {
        item1 = ref1[k];
        item1.from_day = item1.interval.from_day;
        item1.to_day = item1.interval.to_day;
      }
    };
    saveProductsBaseFactor = function() {
      var arraytopass, item, j, len, ref, x;
      arraytopass = [];
      ref = vm.current_BF.values;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        x = {
          _id: item._id,
          product_id: vm.current_BF.product_id,
          insurance_amount: vm.insurance_amount,
          countries_id: vm.current_BF.countries_id,
          base_price: item.base_price,
          is_per_day: item.is_per_day,
          interval: {
            from_day: item.from_day,
            to_day: item.to_day
          }
        };
        arraytopass.push(x);
      }
      RequestService.post('productsbasefactor.save', {
        items: arraytopass
      }).then(function(result) {
        var id;
        id = vm.current_BF.product_id;
        vm.current_BF.product_id = id;
        vm.current_BF.values = [];
        return getProductsBaseFactor();
      });
      return false;
    };
    vm.basefactorList = [];
    getProductsBaseFactor = function() {
      var filter, tmp_product_id;
      filter = {};
      if (vm.new_product._id === null || vm.new_product._id === void 0) {
        tmp_product_id = "1";
      } else {
        tmp_product_id = vm.new_product._id;
      }
      filter = {
        with_related: true,
        filter: {
          product_id: tmp_product_id
        }
      };
      RequestService.post('productsbasefactor.listing', filter).then(function(result) {
        var atom, atom1, is_included, item, item2, j, k, len, len1, ref, ref1, tempAtom;
        vm.basefactorList = result.docs;
        vm.basefactorListTS = [];
        is_included = false;
        ref = vm.basefactorList;
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          ref1 = vm.basefactorListTS;
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            item2 = ref1[k];
            item.countries = $filter('orderBy')(item.countries, 'name');
            item2.countries = $filter('orderBy')(item2.countries, 'name');
            if (angular.equals(item.countries, item2.countries)) {
              is_included = true;
              atom1 = {
                _id: item._id,
                _rev: item._rev,
                interval: item.interval,
                base_price: item.base_price,
                insurance_amount: item.insurance_amount,
                is_per_day: item.is_per_day
              };
              item2.data.push(atom1);
            }
          }
          if (is_included === false) {
            tempAtom = {
              countries: item.countries,
              data: []
            };
            atom = {
              _id: item._id,
              _rev: item._rev,
              interval: item.interval,
              base_price: item.base_price,
              insurance_amount: item.insurance_amount,
              is_per_day: item.is_per_day
            };
            tempAtom.data.push(atom);
            vm.basefactorListTS.push(tempAtom);
          }
          is_included = false;
        }
        console.log("vm.basefactorListTS");
        return console.log(vm.basefactorListTS);
      });
      return false;
    };
    saveProductsFactor = function() {
      vm.current_F.factor_id = vm.current_F.factor._id;
      RequestService.post('productfactor.save', vm.current_F).then(function(result) {
        var id;
        id = vm.current_F.product_id;
        vm.current_F = {
          product_id: id
        };
        return getProductsFactor();
      });
      return false;
    };
    vm.factorList = [];
    getProductsFactor = function() {
      var filter, tmp_product_id;
      filter = {};
      if (vm.new_product._id === null || vm.new_product._id === void 0) {
        tmp_product_id = "1";
      } else {
        tmp_product_id = vm.new_product._id;
      }
      filter = {
        with_related: true,
        filter: {
          product_id: tmp_product_id
        }
      };
      RequestService.post('productfactor.listing', filter).then(function(result) {
        var atom, atom1, index1, is_included, item, item2, item3, itemvalue, j, k, l, len, len1, len2, len3, m, ref, ref1, ref2, ref3, results, tempAtom;
        vm.factorList = result.docs;
        vm.factorListTS = [];
        is_included = false;
        ref = vm.factorList;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          ref1 = vm.factorListTS;
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            item2 = ref1[k];
            if (item2.factor_name === item.factor.name) {
              is_included = true;
              atom1 = {
                _id: item._id,
                _rev: item._rev,
                values: item.values,
                coefficient: item.coefficient,
                coefficient_type: item.coefficient_type,
                is_default: item.is_default
              };
              ref2 = item2.data;
              for (l = 0, len2 = ref2.length; l < len2; l++) {
                item3 = ref2[l];
                ref3 = item3.values;
                for (m = 0, len3 = ref3.length; m < len3; m++) {
                  itemvalue = ref3[m];
                  index1 = atom1.values.indexOf(itemvalue);
                  if (index1 === !-1) {
                    atom1.values.splice(index1, 1);
                    console.log(item3 + " Уже содержится в списке значений факторов");
                  }
                }
              }
              item2.data.push(atom1);
            }
          }
          if (is_included === false) {
            tempAtom = {
              factor_name: item.factor.name,
              data: []
            };
            atom = {
              _id: item._id,
              _rev: item._rev,
              values: item.values,
              coefficient: item.coefficient,
              coefficient_type: item.coefficient_type,
              is_default: item.is_default
            };
            tempAtom.data.push(atom);
            vm.factorListTS.push(tempAtom);
          }
          results.push(is_included = false);
        }
        return results;
      });
      return false;
    };
    getInsAmount = function() {
      var item, j, len, ref;
      vm.current_BF.insurance_amount = 0;
      ref = vm.tmp_countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if (vm.current_BF.countries_id.indexOf(item._id) > -1 && item.min_insurance > vm.current_BF.insurance_amount) {
          vm.current_BF.insurance_amount = item.min_insurance;
        }
      }
    };
    factorValueFilter = function(f_value) {
      var f_item, j, len, ref;
      ref = vm.factorList;
      for (j = 0, len = ref.length; j < len; j++) {
        f_item = ref[j];
        if (f_item.factor_id === vm.current_F.factor._id) {
          if (-1 !== f_item.values.indexOf(f_value)) {
            return false;
          }
        }
      }
      return true;
    };
    countryFilter = function(f_value) {
      var f_item, item2, j, k, len, len1, ref, ref1;
      if (vm.basefactorListTS === null || vm.basefactorListTS === void 0) {
        return true;
      }
      ref = vm.basefactorListTS;
      for (j = 0, len = ref.length; j < len; j++) {
        f_item = ref[j];
        ref1 = f_item.countries;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          item2 = ref1[k];
          if (f_value._id === item2._id && vm.current_BF.countries_id.indexOf(f_value._id) < 0) {
            return false;
          }
        }
      }
      return true;
    };
    clearFactorValues = function() {
      vm.current_F.values = [];
    };
    sortFactorValues = function(value) {
      if (isNaN(value)) {
        return value;
      } else {
        return parseInt(value, 10);
      }
    };
    confirmActionBF = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          saveProductsBaseFactor();
        }
      });
    };
    confirmActionF = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          saveProductsFactor();
        }
      });
    };
    confirmActionBFdelete = function(index, bf) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          basefactorDelete(index, bf);
        }
      });
    };
    confirmActionFDeleteAll = function(bf) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeAllFactors(bf);
        }
      });
    };
    confirmActionFdelete = function(index, item, top) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeFactor(index, item, top);
        }
      });
    };
    confirmActionFinish = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите закончить создание продукта"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          $state.go("app.product");
        }
      });
    };
    vm.confirmActionFinish = confirmActionFinish;
    vm.confirmActionBFdelete = confirmActionBFdelete;
    vm.confirmActionFdelete = confirmActionFdelete;
    vm.confirmActionFDeleteAll = confirmActionFDeleteAll;
    vm.confirmActionF = confirmActionF;
    vm.confirmActionBF = confirmActionBF;
    vm.sortFactorValues = sortFactorValues;
    vm.clearFactorValues = clearFactorValues;
    vm.removeAllFactors = removeAllFactors;
    vm.removeFactor = removeFactor;
    vm.basefactorDelete = basefactorDelete;
    vm.resetForm = resetForm;
    vm.deleteBFandDB = deleteBFandDB;
    vm.saveProductsFactor = saveProductsFactor;
    vm.getProductsBaseFactor = getProductsBaseFactor;
    vm.saveProduct = saveProduct;
    vm.saveProductsBaseFactor = saveProductsBaseFactor;
    vm.factorValueFilter = factorValueFilter;
    vm.getInsAmount = getInsAmount;
    vm.addBF = addBF;
    vm.deleteBF = deleteBF;
    vm.basefactorEdit = basefactorEdit;
    vm.basefactorRowEdit = basefactorRowEdit;
    vm.countryFilter = countryFilter;
    initFunc();
    getProductsBaseFactor();
    getProductsFactor();
  }).controller('ProductViewController', function($scope, Session, RequestService, $stateParams, $filter, $state) {
    'ngInject';
    var toDate, vm;
    vm = this;
    vm.product = $stateParams.product;
    if (vm.product) {
      console.log(vm.product);
    } else {
      console.log("Данные не получены");
    }
    toDate = function(arg) {
      return new Date(arg);
    };
    vm.toDate = toDate;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('PolicyController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, downloadPDF, editBranch, fiterPolicy, getPolicies, goToIssue, goToNew, goToPersonal, goToRealEstate, goToShow, goToVehicle, onDblClick, resetFilter, savePDF, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 50;
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/show.html',
        controller: 'PolicyShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getPolicies();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [50, 100, 500],
      paginationPageSize: 50,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис',
          width: "10%"
        }, {
          name: 'data.status',
          displayName: 'Статус',
          width: "10%"
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false,
          width: "10%"
        }, {
          name: 'client',
          displayName: 'Страхователь',
          width: "30%"
        }, {
          name: 'client_inn',
          displayName: 'ИНН',
          width: "10%",
          cellTemplate: '<span>{{(row.entity.data.inn)}} </span>'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\'',
          width: "10%"
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\'',
          width: "10%"
        }, {
          name: 'data.currency.name',
          displayName: 'Валюта',
          width: "10%"
        }, {
          name: 'insurance_amount',
          displayName: 'Страховая сумма',
          width: "10%"
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия',
          width: "10%"
        }, {
          name: 'insurance_premium_com',
          displayName: 'Комиссионные',
          width: "10%",
          cellTemplate: '<span>{{((row.entity.insurance_premium/1.03)*0.4 | number:2 )}} </span>'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD-MMM-YYYY\'',
          width: "10%"
        }, {
          name: 'company',
          displayName: 'Филиал',
          width: "30%"
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>',
          width: "30%"
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false,
          width: "10%"
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false,
          width: "10%"
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false,
          width: "10%"
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false,
          width: "10%"
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false,
          width: "10%"
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false,
          width: "10%"
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      $state.go('app.policy_select');
      return false;
    };
    goToRealEstate = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/real_estate.html',
        controller: 'PolicyNedController',
        controllerAs: 'select',
        scope: $scope,
        size: 'lg',
        backdrop: 'static',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getPolicies();
      });
    };
    goToVehicle = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/vehicle.html',
        controller: 'PolicyVehicleController',
        controllerAs: 'select',
        scope: $scope,
        size: 'lg',
        backdrop: 'static',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getPolicies();
      });
    };
    goToPersonal = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/personal.html',
        controller: 'PolicyPersonalController',
        controllerAs: 'select',
        scope: $scope,
        size: 'lg',
        backdrop: 'static',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getPolicies();
      });
    };
    goToIssue = function() {
      $state.go('app.policy_issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/edit.html',
        controller: 'PolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getPolicies();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!vm.company) {
        filter.with_related = true;
      } else if (vm.company.company_type === 'agent') {
        filter.with_related = true;
        filter.filter = {
          agent_id: vm.company._id
        };
      } else if (vm.company.company_type === 'branch_company') {
        filter.with_related = true;
        filter.filter = {
          branch_id: vm.company._id
        };
      }
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "date_end") {
          filter.filter.date_end = v;
        }
        if (k === "date_start") {
          filter.filter.date_start = v;
        }
        if (k === "client") {
          filter.filter.client = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      filter.order_by = ["issue_date DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        vm.current_date = angular.copy(data.current_date);
        toastr.success("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    downloadPDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        if (new Date(vm.selected_policy.issue_date) > new Date('2019-07-22 00:00:00')) {
          ReportService.printReport('TS2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'LN') {
        if (new Date(vm.selected_policy.issue_date) > new Date('2024-09-03 00:00:00')) {
          ReportService.printReport('LN2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'NED') {
        if (new Date(vm.selected_policy.issue_date) > new Date('2019-07-22 00:00:00')) {
          ReportService.printReport('NED2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    savePDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        ReportService.saveReportPdf('TS', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'LN') {
        ReportService.saveReportPdf('LN', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'NED') {
        ReportService.saveReportPdf('NED', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    deletePolicy = function(policy) {
      return RequestService.post('policies.delete', policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, i, issue_d, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (i = 0, len = ref.length; i < len; i++) {
          policy = ref[i];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function(policy) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy(policy);
        }
      });
    };
    vm.downloadPDF = downloadPDF;
    vm.savePDF = savePDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    vm.goToRealEstate = goToRealEstate;
    vm.goToVehicle = goToVehicle;
    vm.goToPersonal = goToPersonal;
    getPolicies();
  }).controller('PolicyEditController', function($scope, hotkeys, $state, RequestService, Session, $uibModalInstance, branch, toastr) {
    'ngInject';
    var putBranch, vm;
    vm = this;
    vm.branch = branch || {
      type: 'Branches'
    };
    putBranch = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (vm.branch.name === void 0 || vm.branch.name.trim().length === 0) {
        toastr.warning('Укажите имя филиала');
        vm.saving = false;
        return false;
      }
      if (angular.isUndefined(vm.branch.branch_type)) {
        toastr.warning('Выберите тип');
        vm.saving = false;
        return false;
      }
      RequestService.post('branch.save', vm.branch).then(function(result) {
        $uibModalInstance.close(result(result));
      }, function() {
        return vm.saving = false;
      });
      return false;
    };
    vm.putBranch = putBranch;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('PolicyNewController', function($scope, hotkeys, $state, RequestService, Session, toastr) {
    'ngInject';
    var getDiffDays, goToSelect, vm;
    vm = this;
    vm.diffDays = 0;
    vm.today = new Date();
    goToSelect = function(item) {
      $state.go('app.policy_select', {
        product: item
      });
    };
    getDiffDays = function() {
      var end, start;
      if (vm.pruduct.date_end && vm.pruduct.date_start) {
        start = new Date(vm.pruduct.date_start);
        end = new Date(vm.pruduct.date_end);
        vm.diffDays = Math.round(Math.abs((end.getTime() - start.getTime()) / (24 * 60 * 60 * 1000))) + 1;
      }
    };
    vm.goToSelect = goToSelect;
    vm.getDiffDays = getDiffDays;
  }).controller('PolicySelectController', function($scope, hotkeys, $state, $stateParams, RequestService, $filter, Session, toastr) {
    'ngInject';
    var addCollateralLn, addCollateralNed, addCollateralTs, calculatePremiumLn, calculatePremiumNed, calculatePremiumTs, confirmAction, deleteCollateralLn, deleteCollateralNed, deleteCollateralTs, getInsuranceForms, getInsuranceLnObjects, getInsuranceNedObjects, getInsuranceTsObjects, getInsuranceTypes, getPeriods, pdrobneeIconCnange, recalculateOnEventAll, recalculateOnEventisAnnual, savePolicy, showPanel, vm;
    vm = this;
    vm.parseInt = parseInt;
    vm.today = new Date();
    vm.finish_date = moment(vm.today).add(365, 'day').toDate();
    vm.diffDays = 0;
    vm.nedPanel = false;
    vm.tsPanel = false;
    vm.lnPanel = false;
    vm.product = $stateParams.product;
    if (vm.product === null || vm.product === void 0) {
      vm.product = {};
      vm.product.factors = {};
    }
    vm.annualPolicies = [45, 90];
    vm.annualDays = vm.annualPolicies[0];
    vm.productsList = [];
    vm.collateralsned = {
      ned: []
    };
    vm.collateralsts = {
      ts: []
    };
    vm.collateralsln = {
      ln: []
    };
    vm.selectedProduct = {};
    vm.selectedAge = {};
    vm.currentCountryId = '';
    vm.min_insurance_amount = 0;
    vm.insurance_amount = 0;
    vm.currency_name = "USD";
    vm.policy = {
      objects: [],
      insurance_amount: 0,
      insurance_amountts: 0,
      insurance_amountned: 0,
      insurance_amountln: 0,
      insurance_premiumts: 0,
      insurance_premiumned: 0,
      insurance_premiumln: 0,
      date_start: moment().toDate()
    };
    vm.insuranceform = {
      adres: 'Кыргызская Республика'
    };
    vm.insuranceformned = {
      adres: 'Кыргызская Республика'
    };
    vm.insuranceformts = {
      adres: 'Кыргызская Республика',
      driver: 'Лица, имеющие право на управление застрахованным транспортным средством.'
    };
    vm.insuranceformln = {
      adres: 'Кыргызская Республика'
    };
    vm.inputCheck = true;
    vm.period_rate = 0;
    vm.company = Session.getCompany();
    showPanel = function(insurance_type, check) {
      if (insurance_type.code === 'NED') {
        if (check === true) {
          vm.nedPanel = true;
          getInsuranceNedObjects(insurance_type._id);
        } else if (check !== true & vm.collateralsned.ned.length > 0) {
          toastr.warning('Невозможно закрыть');
          vm.nedPanel = true;
          vm.insuranceformned.objectned = null;
          vm.insuranceformned.insurance_summ = null;
          vm.insuranceformned.coll_price = null;
          vm.insuranceformned.description = null;
          vm.insuranceformned.insurance_premium = null;
        } else if (check !== true & vm.collateralsned.ned.length === 0) {
          vm.nedPanel = false;
          vm.insuranceformned.objectned = null;
          vm.insuranceformned.insurance_summ = null;
          vm.insuranceformned.coll_price = null;
          vm.insuranceformned.description = null;
          vm.insuranceformned.insurance_premium = null;
        }
      }
      if (insurance_type.code === 'TC') {
        if (check === true) {
          vm.tsPanel = true;
          getInsuranceTsObjects(insurance_type._id);
        } else if (check !== true & vm.collateralsts.ts.length > 0) {
          toastr.warning('Невозможно закрыть');
          vm.tsPanel = true;
          vm.insuranceformts.objectts = null;
          vm.insuranceformts.model = null;
          vm.insuranceformts.gosnumber = null;
          vm.insuranceformts.number = null;
          vm.insuranceformts.year_issue = null;
          vm.insuranceformts.insurance_summ = null;
          vm.insuranceformts.coll_price = null;
          vm.insuranceformts.insurance_premium = null;
        } else if (check !== true & vm.collateralsts.ts.length === 0) {
          vm.tsPanel = false;
          vm.insuranceformts.objectts = null;
          vm.insuranceformts.model = null;
          vm.insuranceformts.gosnumber = null;
          vm.insuranceformts.number = null;
          vm.insuranceformts.year_issue = null;
          vm.insuranceformts.insurance_summ = null;
          vm.insuranceformts.coll_price = null;
          vm.insuranceformts.insurance_premium = null;
        }
      }
      if (insurance_type.code === 'LN') {
        if (check === true) {
          vm.lnPanel = true;
          getInsuranceLnObjects(insurance_type._id);
        } else if (check !== true & vm.collateralsln.ln.length > 0) {
          toastr.warning('Невозможно закрыть');
          vm.lnPanel = false;
          vm.insuranceformln.objectln = null;
          vm.insuranceformln.birthday = null;
          vm.insuranceformln.pasport = null;
          vm.insuranceformln.insurance_summ = null;
          vm.insuranceformln.coll_price = null;
          vm.insuranceformln.insurance_premium = null;
        } else if (check !== true & vm.collateralsln.ln.length === 0) {
          vm.lnPanel = false;
          vm.insuranceformln.objectln = null;
          vm.insuranceformln.birthday = null;
          vm.insuranceformln.pasport = null;
          vm.insuranceformln.insurance_summ = null;
          vm.insuranceformln.coll_price = null;
          vm.insuranceformln.insurance_premium = null;
        }
      }
    };
    getInsuranceTypes = function() {
      var filter;
      filter = {
        filter: {}
      };
      filter.filter.code = 'NED';
      return RequestService.post('insurancetypes.listing', filter).then(function(data) {
        vm.insurancetype = angular.copy(data.docs[0]);
        getInsuranceNedObjects();
      });
    };
    getInsuranceNedObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: vm.insurancetype._id
      }).then(function(data) {
        vm.insuranceobjectsned = angular.copy(data.docs);
      });
    };
    getInsuranceTsObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: insurance_type
      }).then(function(data) {
        vm.insuranceobjectsts = angular.copy(data.docs);
      });
    };
    getInsuranceLnObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: insurance_type
      }).then(function(data) {
        vm.insuranceobjectsln = angular.copy(data.docs);
      });
    };
    getInsuranceForms = function() {
      return RequestService.post('insuranceforms.listing', {
        insurance_object_id: vm.insuranceform.object._id
      }).then(function(data) {
        vm.insuranceforms = angular.copy(data.docs);
      });
    };
    getPeriods = function() {
      return RequestService.post('period.listing').then(function(data) {
        vm.periods = angular.copy(data.docs);
      });
    };
    addCollateralNed = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.nedvijimost = {
          owner: insuranceform.owner,
          object: insuranceform.objectned.name,
          objectned: insuranceform.objectned,
          adres: insuranceform.adres,
          coll_price: insuranceform.coll_price,
          description: insuranceform.description,
          insurance_summ: insuranceform.insurance_summ,
          insurance_premium: insuranceform.insurance_premium
        };
        vm.collateralsned.ned.push(vm.nedvijimost);
        vm.nedvijimost = {};
        vm.insuranceformned = {
          objectned: null,
          insurance_summ: null,
          insurance_premium: null,
          adres: 'Кыргызская Республика'
        };
        vm.policy.insurance_amountned = vm.policy.insurance_amountned + insuranceform.insurance_summ;
        vm.policy.insurance_premiumned = vm.policy.insurance_premiumned + insuranceform.insurance_premium;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralNed = function(collateral, index) {
      vm.collateralsned.ned.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumned = vm.policy.insurance_premiumned - collateral.insurance_premium;
      vm.policy.insurance_amountned = vm.policy.insurance_amountned - collateral.insurance_summ;
    };
    addCollateralTs = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.ts = {
          object: insuranceform.objectts.name,
          objectts: insuranceform.objectts,
          adres: insuranceform.adres,
          model: insuranceform.model,
          gosnumber: insuranceform.gosnumber,
          number: insuranceform.number,
          year_issue: insuranceform.year_issue,
          insurance_summ: insuranceform.insurance_summ,
          coll_price: insuranceform.coll_price,
          insurance_premium: insuranceform.insurance_premium,
          driver: insuranceform.driver
        };
        vm.collateralsts.ts.push(vm.ts);
        vm.ts = {};
        vm.insuranceformts = {
          objectts: null,
          adres: 'Кыргызская Республика',
          model: null,
          gosnumber: null,
          number: null,
          year_issue: null,
          insurance_summ: null,
          coll_price: null,
          insurance_premium: null
        };
        vm.policy.insurance_premiumts = vm.policy.insurance_premiumts + insuranceform.insurance_premium;
        vm.policy.insurance_amountts = vm.policy.insurance_amountts + insuranceform.insurance_summ;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralTs = function(collateral, index) {
      vm.collateralsts.ts.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumts = vm.policy.insurance_premiumts - collateral.insurance_premium;
      vm.policy.insurance_amountts = vm.policy.insurance_amountts - collateral.insurance_summ;
    };
    addCollateralLn = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.ln = {
          adres: insuranceform.adres,
          birthday: insuranceform.birthday,
          pasport: insuranceform.pasport,
          insurance_summ: insuranceform.insurance_summ,
          client: insuranceform.client,
          insurance_premium: insuranceform.insurance_premium
        };
        vm.collateralsln.ln.push(vm.ln);
        vm.ln = {};
        vm.insuranceformln = {
          adres: 'Кыргызская Республика',
          birthday: null,
          pasport: null,
          insurance_summ: null,
          client: null,
          insurance_premium: null
        };
        vm.policy.insurance_premiumln = vm.policy.insurance_premiumln + insuranceform.insurance_premium;
        vm.policy.insurance_amountln = vm.policy.insurance_amountln + insuranceform.insurance_summ;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralLn = function(collateral, index) {
      vm.collateralsln.ln.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumln = vm.policy.insurance_premiumln - collateral.insurance_premium;
      vm.policy.insurance_amountln = vm.policy.insurance_amountln - collateral.insurance_summ;
    };
    recalculateOnEventisAnnual = function() {
      vm.policy.date_end = moment(vm.policy.date_start).add(365, 'day').toDate();
      recalculateOnEventAll();
    };
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, timeDiff;
      date1 = "";
      date2 = "";
      date1 = vm.policy.date_start;
      date2 = vm.policy.date_end || moment(vm.policy.date_start).add(1, 'day').toDate();
      diffDays = 0;
      if (vm.isAnnual) {
        vm.diffDays = 365;
      } else {
        timeDiff = Math.abs(date2.getTime() - date1.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        vm.diffDays = diffDays + 1;
      }
    };
    savePolicy = function() {
      var agent_id, branch_id, policy, policyList, policy_no, theUser;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
        branch_id = vm.company.company_id;
      } else if (vm.company.company_type === "branch_company") {
        branch_id = vm.company._id;
      }
      theUser = Session.getUser();
      policyList = {
        items: []
      };
      if (vm.collateralsned.ned.length > 0) {
        policy_no = 'CBK/PI';
        policy = {
          policy_no: policy_no,
          credit_no: vm.policy.credit_no,
          issue_date: new Date(),
          product_id: vm.policy.product_id,
          company_id: vm.company._id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: vm.policy.client,
          insurance_amount: vm.policy.insurance_amountned,
          insurance_premium: vm.policy.insurance_premiumned,
          insurance_data: {
            ned: vm.collateralsned.ned,
            date_start: vm.policy.date_start,
            date_end: vm.policy.date_end,
            diffDays: vm.diffDays
          },
          objects: 'NED',
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency.name,
            currency: vm.currency,
            insurance_premium_kgs: 0
          }
        };
        policyList.items.push(policy);
      }
      if (vm.collateralsts.ts.length > 0) {
        policy_no = 'CBK/VI';
        policy = {
          policy_no: policy_no,
          credit_no: vm.policy.credit_no,
          issue_date: new Date(),
          product_id: vm.policy.product_id,
          company_id: vm.company._id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: vm.policy.client,
          insurance_amount: vm.policy.insurance_amountts,
          insurance_premium: vm.policy.insurance_premiumts,
          insurance_data: {
            ts: vm.collateralsts.ts,
            date_start: vm.policy.date_start,
            date_end: vm.policy.date_end,
            diffDays: vm.diffDays
          },
          objects: 'TS',
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency.name,
            currency: vm.currency,
            insurance_premium_kgs: 0
          }
        };
        policyList.items.push(policy);
      }
      if (vm.collateralsln.ln.length > 0) {
        policy_no = 'CBK/AI';
        policy = {
          policy_no: policy_no,
          credit_no: vm.policy.credit_no,
          issue_date: new Date(),
          product_id: vm.policy.product_id,
          company_id: vm.company._id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: vm.policy.client,
          insurance_amount: vm.policy.insurance_amountln,
          insurance_premium: vm.policy.insurance_premiumln,
          insurance_data: {
            ln: vm.collateralsln.ln,
            date_start: vm.policy.date_start,
            date_end: vm.policy.date_end,
            diffDays: vm.diffDays
          },
          objects: 'LN',
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency.name,
            currency: vm.currency,
            insurance_premium_kgs: 0
          }
        };
        policyList.items.push(policy);
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        return $state.go("app.policy");
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var i, item, len, ref, temp, to_save;
        if (result) {
          to_save = [];
          ref = vm.insurants;
          for (i = 0, len = ref.length; i < len; i++) {
            item = ref[i];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    pdrobneeIconCnange = function() {
      if (vm.pdrobneeIcon === 'fa fa-chevron-down') {
        vm.pdrobneeIcon = 'fa fa-chevron-up';
      } else {
        vm.pdrobneeIcon = 'fa fa-chevron-down';
      }
    };
    calculatePremiumNed = function() {
      var i, len, period, ref;
      if (!vm.insuranceformned.objectned) {
        toastr.warning('Выберите объект страхования');
        return;
      }
      if (!vm.insuranceformned.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      ref = vm.periods;
      for (i = 0, len = ref.length; i < len; i++) {
        period = ref[i];
        if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
          vm.period_rate = period.rate;
        }
      }
      vm.insuranceformned.insurance_premium = Math.round(vm.insuranceformned.insurance_summ * (vm.insuranceformned.objectned.rate / 100) * vm.period_rate);
    };
    calculatePremiumTs = function() {
      var i, len, period, ref;
      if (!vm.insuranceformts.objectts) {
        toastr.warning('Выберите объект страхования');
        return;
      }
      if (!vm.insuranceformts.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      ref = vm.periods;
      for (i = 0, len = ref.length; i < len; i++) {
        period = ref[i];
        if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
          vm.period_rate = period.rate;
        }
      }
      vm.insuranceformts.insurance_premium = Math.round(vm.insuranceformts.insurance_summ * (vm.insuranceformts.objectts.rate / 100) * vm.period_rate);
    };
    calculatePremiumLn = function() {
      var i, len, period, ref;
      if (!vm.insuranceformln.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      ref = vm.periods;
      for (i = 0, len = ref.length; i < len; i++) {
        period = ref[i];
        if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
          vm.period_rate = period.rate;
        }
      }
      vm.insuranceformln.insurance_premium = Math.round(vm.insuranceformln.insurance_summ * 0.3 * vm.period_rate);
    };
    vm.addCollateralNed = addCollateralNed;
    vm.addCollateralTs = addCollateralTs;
    vm.addCollateralLn = addCollateralLn;
    vm.deleteCollateralNed = deleteCollateralNed;
    vm.deleteCollateralTs = deleteCollateralTs;
    vm.deleteCollateralLn = deleteCollateralLn;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    vm.pdrobneeIconCnange = pdrobneeIconCnange;
    vm.confirmAction = confirmAction;
    vm.savePolicy = savePolicy;
    vm.recalculateOnEventisAnnual = recalculateOnEventisAnnual;
    vm.getInsuranceForms = getInsuranceForms;
    vm.calculatePremiumNed = calculatePremiumNed;
    vm.calculatePremiumTs = calculatePremiumTs;
    vm.calculatePremiumLn = calculatePremiumLn;
    vm.getPeriods = getPeriods;
    vm.getInsuranceTypes = getInsuranceTypes;
    vm.showPanel = showPanel;
    recalculateOnEventAll();
    getPeriods();
    getInsuranceTypes();
  }).controller('PolicyIssueController', function($scope, hotkeys, $state, RequestService, Session, $filter, toastr, $stateParams, $uibModal) {
    'ngInject';
    var addInsurant, changeIcon, computePrice, confirmAction, deleteInsurant, email, getCountries, i, j, len, len1, pdrobneeIconCnange, phone, reCompute, ref, ref1, savePolicy, vm;
    vm = this;
    vm.today = new Date();
    vm.countries = null;
    vm.countriesView = [];
    vm.currentCountryId = '';
    vm.min_insurance = 0;
    vm.product = $stateParams.product;
    vm.currency_name = '';
    vm.currencyRate = 0;
    vm.iconsList = [];
    vm.pdrobneeIcon = 'fa fa-chevron-down';
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    vm.company = Session.getCompany();
    vm.buyer = {};
    if (vm.company.company_type = 'agent') {
      vm.buyer.surname = null;
      vm.buyer.name = null;
      if (vm.company.data.emails) {
        ref = vm.company.data.emails;
        for (i = 0, len = ref.length; i < len; i++) {
          email = ref[i];
          vm.buyer.email = email;
          break;
        }
      } else {
        vm.buyer.email = null;
      }
      if (vm.company.data.phones) {
        ref1 = vm.company.data.phones;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          phone = ref1[j];
          vm.buyer.phone = phone;
          break;
        }
      } else {
        vm.buyer.phone = null;
      }
    }
    getCountries = function() {
      var filter;
      filter = {
        with_related: true
      };
      RequestService.post('select.issue_listing', filter).then(function(result) {
        var country, currency, item, itemx, l, len2, len3, len4, m, n, ref2, ref3, ref4, results;
        vm.countries = result.countries;
        vm.min_insurance = 0;
        ref2 = result.countries;
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          item = ref2[l];
          ref3 = vm.product.tmp_product.country_id;
          for (m = 0, len3 = ref3.length; m < len3; m++) {
            itemx = ref3[m];
            if (itemx === item._id) {
              vm.countriesView.push(item);
              if (item.min_insurance > vm.min_insurance) {
                vm.min_insurance = item.min_insurance;
                vm.currentCountryId = itemx;
              }
            }
          }
        }
        vm.currencies = result.currencies;
        ref4 = vm.countries;
        results = [];
        for (n = 0, len4 = ref4.length; n < len4; n++) {
          country = ref4[n];
          if (country._id === vm.currentCountryId) {
            results.push((function() {
              var len5, o, ref5, results1;
              ref5 = vm.currencies;
              results1 = [];
              for (o = 0, len5 = ref5.length; o < len5; o++) {
                currency = ref5[o];
                if (country.currency_id === currency._id) {
                  vm.currency_name = currency.data.name;
                  results1.push(RequestService.post('currencynbkr.get_nbkr_rate', {
                    iso: vm.currency_name
                  }).then(function(result) {
                    return vm.currencyRate = result.results;
                  }));
                } else {
                  results1.push(void 0);
                }
              }
              return results1;
            })());
          } else {
            results.push(void 0);
          }
        }
        return results;
      });
    };
    if (vm.product) {
      getCountries();
      vm.insurants = [
        {
          surname: '',
          name: '',
          passport_no: '',
          date_of_birth: '',
          factorListing: angular.copy(vm.product.factorListing),
          factors: angular.copy(vm.product.tmp_product.factors),
          theprice: angular.copy(vm.product.theprice)
        }
      ];
      vm.iconsList.push('fa fa-plus-square');
    } else {
      $state.go("app.policy_select");
    }
    addInsurant = function() {
      vm.insurants.push({
        surname: '',
        name: '',
        passport_no: '',
        date_of_birth: '',
        factorListing: angular.copy(vm.product.factorListing),
        factors: angular.copy(vm.product.tmp_product.factors),
        theprice: angular.copy(vm.product.theprice)
      });
      vm.iconsList.push('fa fa-plus-square');
    };
    deleteInsurant = function(index) {
      vm.insurants.splice(index, 1);
      vm.iconsList.splice(index, 1);
    };
    changeIcon = function(index) {
      if (vm.iconsList[index] === 'fa fa-plus-square') {
        return vm.iconsList[index] = 'fa fa-minus-square';
      } else {
        return vm.iconsList[index] = 'fa fa-plus-square';
      }
    };
    reCompute = function(insurant) {
      if (insurant.date_of_birth) {
        insurant.factors['Возраст'] = moment().diff(insurant.date_of_birth, 'years');
        insurant.theprice = $filter('number')(computePrice(insurant), 2);
        console.log(insurant);
        console.log(vm.insurants);
      }
    };
    computePrice = function(insurant) {
      var base_price, basefactor, country_id, country_x, date1, date2, diffDays, factor, fixedamounts, foundcountry, insurance_amount, item_fact, l, len2, len3, len4, len5, m, n, o, obj_x, prod, ref2, ref3, ref4, ref5, theprice, timeDiff;
      prod = angular.copy(vm.product);
      prod.tmp_product.factors = insurant.factors;
      if (vm.countries === null || vm.countries === void 0 || vm.countries.length === 0) {
        console.log("vm.countries is null || vm.countries is undefined || vm.countries.length is 0");
        return;
      }
      if (prod.tmp_product === null || prod.tmp_product === void 0) {
        console.log("vm.prod.tmp_product is null || prod.tmp_product is undefined");
        return;
      }
      theprice = 0;
      base_price = 0;
      insurance_amount = 0;
      foundcountry = false;
      date1 = "";
      date2 = "";
      country_id = [];
      if (prod.tmp_product.country_id === null || prod.tmp_product.country_id === void 0 || prod.tmp_product.country_id.length === 0) {
        prod.tmp_product.country_id = country_id;
      } else {
        country_id = prod.tmp_product.country_id;
      }
      if (prod.tmp_product.date_start === null || prod.tmp_product.date_start === void 0 || prod.tmp_product.date_start === "") {
        prod.tmp_product.date_start = "2016-11-03T18:00:00.000Z";
        date1 = new Date(prod.tmp_product.date_start);
      } else {
        date1 = new Date(prod.tmp_product.date_start);
      }
      if (prod.tmp_product.date_end === null || prod.tmp_product.date_end === void 0 || prod.tmp_product.date_end === "") {
        prod.tmp_product.date_end = "2016-11-04T18:00:00.000Z";
        date2 = new Date(prod.tmp_product.date_end);
      } else {
        date2 = new Date(prod.tmp_product.date_end);
      }
      timeDiff = Math.abs(date2.getTime() - date1.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      if (country_id.length > 1) {
        obj_x = {
          min_insurance: 0,
          country_id: ""
        };
        ref2 = vm.countries;
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          country_x = ref2[l];
          if (country_id.indexOf(country_x._id) > -1) {
            if (parseFloat(country_x.min_insurance) > parseFloat(obj_x.min_insurance)) {
              obj_x.min_insurance = country_x.min_insurance;
              obj_x.country_id = country_x._id;
            }
          }
        }
        country_id = obj_x.country_id;
      } else {
        country_id = country_id[0];
      }
      ref3 = prod.basefactors;
      for (m = 0, len3 = ref3.length; m < len3; m++) {
        basefactor = ref3[m];
        if (basefactor.countries_id.indexOf(country_id) > -1 && basefactor.interval.from_day <= diffDays && basefactor.interval.to_day >= diffDays && parseInt(basefactor.insurance_amount) === parseInt(vm.product.insurance_amount)) {
          foundcountry = true;
          base_price = basefactor.base_price;
          if (basefactor.is_per_day) {
            base_price = base_price * diffDays;
          }
          insurance_amount = basefactor.insurance_amount;
        }
      }
      if (foundcountry === false) {
        console.log("the country OR the interval does't match to this product");
        return;
      }
      theprice = base_price;
      fixedamounts = 0;
      ref4 = prod.factors;
      for (n = 0, len4 = ref4.length; n < len4; n++) {
        factor = ref4[n];
        ref5 = factor.factor;
        for (o = 0, len5 = ref5.length; o < len5; o++) {
          item_fact = ref5[o];
          if (prod.tmp_product.factors[item_fact.name] !== null && prod.tmp_product.factors[item_fact.name] !== void 0 && factor.values.indexOf(prod.tmp_product.factors[item_fact.name].toString()) > -1) {
            if (factor.coefficient_type === "Множитель") {
              theprice = theprice * factor.coefficient;
            }
            if (factor.coefficient_type === "Слагаемое") {
              fixedamounts = fixedamounts + factor.coefficient;
            }
          }
        }
      }
      theprice = theprice + fixedamounts;
      theprice = theprice + ((theprice / 100) * 2);
      return theprice;
    };
    savePolicy = function() {
      var agent_id, branch_id, insurance_data, item, key, l, len2, len3, m, policy, policyList, policy_no, ref2, ref3, ref4, theUser, user, value;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
      }
      theUser = Session.getUser();
      if (vm.company) {
        ref2 = vm.company.staff;
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          user = ref2[l];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      vm.product.data;
      insurance_data = angular.copy(vm.product.tmp_product);
      policyList = {
        items: []
      };
      ref3 = vm.insurants;
      for (m = 0, len3 = ref3.length; m < len3; m++) {
        item = ref3[m];
        insurance_data.factors = item.factors;
        insurance_data.factors_list = [];
        ref4 = item.factors;
        for (key in ref4) {
          value = ref4[key];
          value = value + "";
          insurance_data.factors_list.push({
            key: key,
            value: value
          });
        }
        policy_no = vm.product.code;
        if (vm.company.company_type === "agent") {
          agent_id = vm.company._id;
          policy_no = vm.company.code + "00000";
        } else {
          policy_no = policy_no + "00000";
        }
        policy = {
          policy_no: policy_no,
          issue_date: new Date(),
          product_id: vm.product._id,
          company_id: vm.product.company_id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: {
            surname: item.surname.toUpperCase(),
            name: item.name.toUpperCase(),
            passport_no: item.passport_no,
            date_of_birth: item.date_of_birth
          },
          insurance_amount: vm.product.insurance_amount,
          insurance_premium: item.theprice,
          insurance_data: angular.copy(insurance_data),
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency_name,
            insurance_premium_kgs: (item.theprice * vm.currencyRate).toFixed(2)
          }
        };
        policyList.items.push(policy);
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        if (policyList.items.length === 1) {
          policy = angular.copy(policyList.items[0]);
          policy._id = result.resultList[0].id;
          policy._rev = result.resultList[0].rev;
          policy.policy_no = result.resultList[0].policy_no;
          return $state.go('app.policy_view', {
            product: policy
          });
        } else {
          return $state.go("app.policy");
        }
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var item, l, len2, ref2, temp, to_save;
        if (result) {
          to_save = [];
          ref2 = vm.insurants;
          for (l = 0, len2 = ref2.length; l < len2; l++) {
            item = ref2[l];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    pdrobneeIconCnange = function() {
      if (vm.pdrobneeIcon === 'fa fa-chevron-down') {
        vm.pdrobneeIcon = 'fa fa-chevron-up';
      } else {
        vm.pdrobneeIcon = 'fa fa-chevron-down';
      }
    };
    vm.pdrobneeIconCnange = pdrobneeIconCnange;
    vm.changeIcon = changeIcon;
    vm.confirmAction = confirmAction;
    vm.addInsurant = addInsurant;
    vm.deleteInsurant = deleteInsurant;
    vm.reCompute = reCompute;
    vm.savePolicy = savePolicy;
  }).controller('PolicyViewController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal) {
    'ngInject';
    var FormPolicy, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, findCurrencyName, findMinInsurance, getProducts, goToForm, goToPolicy, issueAgent_policy, sendMail, spoilPolicy, termAgent_policy, vm;
    vm = this;
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    getProducts = function(product_id) {
      var filter;
      filter = {
        with_related: true,
        _id: product_id
      };
      RequestService.post('select.view_listing', filter).then(function(result) {
        vm.product = result.product;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        findMinInsurance();
        findCurrencyName();
        if (!vm.policy.product) {
          vm.policy.product = angular.copy(vm.product);
        }
      });
    };
    findCurrencyName = function() {
      var country, currency, i, j, len, len1, ref, ref1;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        country = ref[i];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            currency = ref1[j];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.policy.policy_no === '00000' && vm.currency_name) {
                RequestService.post('currencynbkr.get_nbkr_rate', {
                  iso: vm.currency_name
                }).then(function(result) {
                  var currencyRate;
                  currencyRate = result.results;
                  return vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * currencyRate).toFixed(2);
                });
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var i, item, itemx, j, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        ref1 = vm.policy.insurance_data.country_id;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          itemx = ref1[j];
          if (itemx === item._id) {
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = $stateParams.product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.apolicy.list");
    } else {
      getProducts(vm.policy.product_id);
    }
    sendMail = function() {
      var countries, country, country_id, i, j, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (i = 0, len = ref.length; i < len; i++) {
        country_id = ref[i];
        ref1 = vm.countries;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          country = ref1[j];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        console.log(result);
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, i, len, policyList, policy_no, policy_to_send, ref, theUser, user;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = vm.company.code + "00000";
      } else {
        policy_no = policy_no + "00000";
      }
      vm.policy.policy_no = policy_no;
      vm.policy.issue_date = new Date();
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      delete vm.policy.product;
      policy_to_send = angular.copy(vm.policy);
      policy_to_send.data.status = 'Оформлен';
      policyList.items.push(policy_to_send);
      RequestService.post('policies.save', policyList).then(function(result) {
        delete vm.product.company;
        delete vm.product.factors;
        delete vm.product.services;
        delete vm.product.basefactors;
        vm.policy.policy_no = result.resultList[0].policy_no;
        vm.policy.data.status = 'Оформлен';
        sendMail();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    issueAgent_policy = function() {
      RequestService.post('currencynbkr.get_nbkr_rate', {
        iso: vm.currency_name
      }).then(function(result) {
        vm.currencyRate = result.results;
        console.log("vm.currencyRate " + vm.currencyRate);
        FormPolicy();
      });
    };
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        policyNumber: vm.policy.policy_no
      });
    };
    termAgent_policy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.apolicy.list');
    };
    goToForm = function() {
      $state.go('app.apolicy.form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issueAgent_policy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termAgent_policy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
  }).controller('PolicyShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var cancel, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, goToForm, goToPolicy, spoilPolicy, termPolicy, vm;
    vm = this;
    vm.today = new Date();
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    vm.flag_status_policy = true;
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    vm.current_date = new Date();
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.policy");
    }
    spoilPolicy = function() {
      vm.policy.data.status = "Испорчен";
      RequestService.post('policies.put', vm.policy).then(function(result) {
        toastr.success('Полис испорчен успешно');
        $uibModalInstance.close(true);
        return $scope.getPolicies();
      });
      return false;
    };
    downloadPDF = function() {
      if (vm.policy.objects === 'TS') {
        if (new Date(vm.policy.issue_date) > new Date('2019-07-22 00:00:00')) {
          ReportService.printReport('TS2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'LN') {
        if (new Date(vm.policy.issue_date) > new Date('2024-09-03 00:00:00')) {
          ReportService.printReport('LN2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'NED') {
        if (new Date(vm.policy.issue_date) > new Date('2019-07-22 00:00:00')) {
          ReportService.printReport('NED2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    termPolicy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.policy');
    };
    goToForm = function() {
      $state.go('app.policy_form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var date1, diffDays, timeDiff;
        if (result) {
          date1 = new Date(vm.policy.issue_date);
          timeDiff = Math.abs(date1.getTime() - vm.today.getTime());
          diffDays = Math.ceil((timeDiff / (1000 * 3600 * 24)) - 1);
          if (diffDays < 1 || $scope.app.ua.role >= 10) {
            spoilPolicy();
          } else {
            toastr.warning('Данная операция невозможна!');
          }
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issuePolicy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  }).controller('PolicyFormController', function($scope, hotkeys, $state, RequestService, Session, $filter, toastr, $stateParams, $uibModal) {
    'ngInject';
    var SavePolicy, confirmActionSave, getPeriods, recalculateOnEventAll, vm;
    vm = this;
    vm.today = new Date();
    vm.finish_date = moment(vm.today).add(365, 'day').toDate();
    vm.diffDays = 0;
    vm.min_insurance = 0;
    vm.currency_name = '';
    vm.currencyRate = 1;
    vm.policy = $stateParams.policy;
    vm.policy.date_start = moment().toDate();
    vm.policy.date_end = null;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, i, j, l, len, len1, len2, len3, len4, len5, ln, m, n, ned, o, period, ref, ref1, ref2, ref3, ref4, ref5, timeDiff, ts;
      date1 = "";
      date2 = "";
      date1 = vm.policy.date_start;
      date2 = vm.policy.date_end || moment(vm.policy.date_start).add(1, 'day').toDate();
      vm.policy.insurance_premium = 0;
      vm.policy.insurance_amount = 0;
      diffDays = 0;
      if (vm.isAnnual) {
        vm.diffDays = 365;
      } else {
        timeDiff = Math.abs(date2.getTime() - date1.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        vm.diffDays = diffDays + 1;
      }
      if (vm.policy.insurance_data.ned) {
        ref = vm.policy.insurance_data.ned;
        for (i = 0, len = ref.length; i < len; i++) {
          ned = ref[i];
          ref1 = vm.periods;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            period = ref1[j];
            if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
              vm.period_rate = period.rate;
            }
            ned.insurance_premium = Math.round(ned.insurance_summ * (ned.objectned.rate / 100) * vm.period_rate);
          }
          vm.policy.insurance_premium += ned.insurance_premium;
          vm.policy.insurance_amount += ned.insurance_summ;
        }
      } else if (vm.policy.insurance_data.ts) {
        ref2 = vm.policy.insurance_data.ts;
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          ts = ref2[l];
          ref3 = vm.periods;
          for (m = 0, len3 = ref3.length; m < len3; m++) {
            period = ref3[m];
            if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
              vm.period_rate = period.rate;
            }
            ts.insurance_premium = Math.round(ts.insurance_summ * (ts.objectts.rate / 100) * vm.period_rate);
          }
          vm.policy.insurance_premium += ts.insurance_premium;
          vm.policy.insurance_amount += ts.insurance_summ;
        }
      } else if (vm.policy.insurance_data.ln) {
        ref4 = vm.policy.insurance_data.ln;
        for (n = 0, len4 = ref4.length; n < len4; n++) {
          ln = ref4[n];
          ref5 = vm.periods;
          for (o = 0, len5 = ref5.length; o < len5; o++) {
            period = ref5[o];
            if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
              vm.period_rate = period.rate;
            }
            ln.insurance_premium = Math.round(ln.insurance_summ * 0.004 * vm.period_rate);
          }
          vm.policy.insurance_premium += ln.insurance_premium;
          vm.policy.insurance_amount += ln.insurance_summ;
        }
      }
    };
    SavePolicy = function() {
      var old_policy_no, policyList, policy_no;
      policyList = {
        items: []
      };
      old_policy_no = vm.policy.policy_no;
      delete vm.policy._id;
      delete vm.policy._created;
      delete vm.policy._deleted;
      delete vm.policy._rev;
      if (vm.policy.insurance_data.ned) {
        policy_no = 'CBK/PI';
        vm.policy.policy_no = policy_no;
        vm.policy.data.status = 'Оформлен';
        vm.policy.data.old_policy_no = old_policy_no;
      } else if (vm.policy.insurance_data.ts) {
        policy_no = 'CBK/VI';
        vm.policy.policy_no = policy_no;
        vm.policy.data.status = 'Оформлен';
        vm.policy.data.old_policy_no = old_policy_no;
      } else if (vm.policy.insurance_data.ln) {
        policy_no = 'CBK/AI';
        vm.policy.policy_no = policy_no;
        vm.policy.data.status = 'Оформлен';
        vm.policy.data.old_policy_no = old_policy_no;
      }
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис сохранен успешно');
        return $state.go('app.policy');
      });
      return false;
    };
    confirmActionSave = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          SavePolicy();
        }
      });
    };
    getPeriods = function() {
      return RequestService.post('period.listing').then(function(data) {
        vm.periods = angular.copy(data.docs);
      });
    };
    vm.getPeriods = getPeriods;
    vm.confirmActionSave = confirmActionSave;
    vm.SavePolicy = SavePolicy;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    getPeriods();
  }).controller('PolicyDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    ok = function() {
      $uibModalInstance.close(true);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).controller('TerminateDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    vm.moneyBack = 0;
    ok = function() {
      $uibModalInstance.close(result(vm.moneyBack));
    };
    cancel = function() {
      $uibModalInstance.close(result(false));
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).filter('filterCountries', function() {
    return function(input, search) {
      var i, item, len, res;
      res = [];
      if (input) {
        for (i = 0, len = input.length; i < len; i++) {
          item = input[i];
          if (item.name.toLowerCase().indexOf(search.toLowerCase()) !== -1 || item.data.name_eng.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
            res.push(item);
          }
        }
      } else {
        return [];
      }
      return res;
    };
  }).controller('PolicyNedController', function($scope, hotkeys, $state, $stateParams, RequestService, $filter, Session, toastr, $uibModalInstance) {
    'ngInject';
    var addCollateralNed, calculatePremiumNed, confirmAction, deleteCollateralNed, getInsuranceForms, getInsuranceLnObjects, getInsuranceNedObjects, getInsuranceTsObjects, getInsuranceTypes, getPeriods, pdrobneeIconCnange, recalculateOnEventAll, recalculateOnEventisAnnual, savePolicy, showPanel, vm;
    vm = this;
    vm.parseInt = parseInt;
    vm.today = new Date();
    vm.finish_date = moment(vm.today).add(365, 'day').toDate();
    vm.diffDays = 0;
    vm.nedPanel = false;
    vm.tsPanel = false;
    vm.lnPanel = false;
    vm.product = $stateParams.product;
    if (vm.product === null || vm.product === void 0) {
      vm.product = {};
      vm.product.factors = {};
    }
    vm.annualPolicies = [45, 90];
    vm.annualDays = vm.annualPolicies[0];
    vm.productsList = [];
    vm.collateralsned = {
      ned: []
    };
    vm.collateralsts = {
      ts: []
    };
    vm.collateralsln = {
      ln: []
    };
    vm.selectedProduct = {};
    vm.selectedAge = {};
    vm.currentCountryId = '';
    vm.min_insurance_amount = 0;
    vm.insurance_amount = 0;
    vm.currency_name = "USD";
    vm.policy = {
      objects: [],
      insurance_amount: 0,
      insurance_amountts: 0,
      insurance_amountned: 0,
      insurance_amountln: 0,
      insurance_premiumts: 0,
      insurance_premiumned: 0,
      insurance_premiumln: 0,
      date_start: moment().toDate()
    };
    vm.insuranceform = {
      adres: 'Кыргызская Республика'
    };
    vm.insuranceformned = {
      adres: 'Кыргызская Республика'
    };
    vm.insuranceformts = {
      adres: 'Кыргызская Республика',
      driver: 'Лица, имеющие право на управление застрахованным транспортным средством.'
    };
    vm.insuranceformln = {
      adres: 'Кыргызская Республика'
    };
    vm.inputCheck = true;
    vm.period_rate = 0;
    vm.company = Session.getCompany();
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    showPanel = function(insurance_type, check) {
      if (insurance_type.code === 'NED') {
        if (check === true) {
          vm.nedPanel = true;
          getInsuranceNedObjects(insurance_type._id);
        } else if (check !== true & vm.collateralsned.ned.length > 0) {
          toastr.warning('Невозможно закрыть');
          vm.nedPanel = true;
          vm.insuranceformned.objectned = null;
          vm.insuranceformned.insurance_summ = null;
          vm.insuranceformned.coll_price = null;
          vm.insuranceformned.description = null;
          vm.insuranceformned.insurance_premium = null;
        } else if (check !== true & vm.collateralsned.ned.length === 0) {
          vm.nedPanel = false;
          vm.insuranceformned.objectned = null;
          vm.insuranceformned.insurance_summ = null;
          vm.insuranceformned.coll_price = null;
          vm.insuranceformned.description = null;
          vm.insuranceformned.insurance_premium = null;
        }
      }
    };
    getInsuranceTypes = function() {
      var filter;
      filter = {
        filter: {}
      };
      filter.filter.code = 'NED';
      return RequestService.post('insurancetypes.listing', filter).then(function(data) {
        vm.insurancetype = angular.copy(data.docs[0]);
        getInsuranceNedObjects();
      });
    };
    getInsuranceNedObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: vm.insurancetype._id
      }).then(function(data) {
        vm.insuranceobjectsned = angular.copy(data.docs);
      });
    };
    getInsuranceTsObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: insurance_type
      }).then(function(data) {
        vm.insuranceobjectsts = angular.copy(data.docs);
      });
    };
    getInsuranceLnObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: insurance_type
      }).then(function(data) {
        vm.insuranceobjectsln = angular.copy(data.docs);
      });
    };
    getInsuranceForms = function() {
      return RequestService.post('insuranceforms.listing', {
        insurance_object_id: vm.insuranceform.object._id
      }).then(function(data) {
        vm.insuranceforms = angular.copy(data.docs);
      });
    };
    getPeriods = function() {
      return RequestService.post('period.listing').then(function(data) {
        vm.periods = angular.copy(data.docs);
      });
    };
    addCollateralNed = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.nedvijimost = {
          owner: insuranceform.owner,
          object: insuranceform.objectned.name,
          objectned: insuranceform.objectned,
          adres: insuranceform.adres,
          coll_price: insuranceform.coll_price,
          description: insuranceform.description,
          insurance_summ: insuranceform.insurance_summ,
          insurance_premium: insuranceform.insurance_premium + insuranceform.nsp
        };
        vm.collateralsned.ned.push(vm.nedvijimost);
        vm.nedvijimost = {};
        vm.insuranceformned = {
          objectned: null,
          insurance_summ: null,
          insurance_premium: null,
          adres: 'Кыргызская Республика'
        };
        vm.policy.insurance_amountned = vm.policy.insurance_amountned + insuranceform.insurance_summ;
        vm.policy.insurance_premiumned = vm.policy.insurance_premiumned + insuranceform.insurance_premium;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralNed = function(collateral, index) {
      vm.collateralsned.ned.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumned = vm.policy.insurance_premiumned - collateral.insurance_premium;
      vm.policy.insurance_amountned = vm.policy.insurance_amountned - collateral.insurance_summ;
    };
    recalculateOnEventisAnnual = function() {
      vm.policy.date_end = moment(vm.policy.date_start).add(365, 'day').toDate();
      recalculateOnEventAll();
    };
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, timeDiff;
      date1 = "";
      date2 = "";
      date1 = vm.policy.date_start;
      date2 = vm.policy.date_end || moment(vm.policy.date_start).add(1, 'day').toDate();
      diffDays = 0;
      if (vm.isAnnual) {
        vm.diffDays = 365;
      } else {
        timeDiff = Math.abs(date2.getTime() - date1.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        vm.diffDays = diffDays + 1;
      }
    };
    savePolicy = function() {
      var agent_id, branch_id, policy, policyList, policy_no, theUser;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
        branch_id = vm.company.company_id;
      } else if (vm.company.company_type === "branch_company") {
        branch_id = vm.company._id;
      }
      theUser = Session.getUser();
      policyList = {
        items: []
      };
      if (vm.collateralsned.ned.length > 0) {
        policy_no = 'CBK/PI';
        policy = {
          policy_no: policy_no,
          credit_no: vm.policy.credit_no,
          issue_date: new Date(),
          product_id: vm.policy.product_id,
          company_id: vm.company._id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: vm.policy.client,
          insurance_amount: vm.policy.insurance_amountned,
          insurance_premium: vm.policy.insurance_premiumned + Math.round(vm.policy.insurance_premiumned * 0.02),
          insurance_data: {
            ned: vm.collateralsned.ned,
            date_start: vm.policy.date_start,
            date_end: vm.policy.date_end,
            diffDays: vm.diffDays
          },
          objects: 'NED',
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            inn: vm.policy.inn,
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency.name,
            currency: vm.currency,
            insurance_premium_kgs: 0
          }
        };
        policyList.items.push(policy);
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        return $uibModalInstance.close(result);
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var i, item, len, ref, temp, to_save;
        if (result) {
          to_save = [];
          ref = vm.insurants;
          for (i = 0, len = ref.length; i < len; i++) {
            item = ref[i];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    pdrobneeIconCnange = function() {
      if (vm.pdrobneeIcon === 'fa fa-chevron-down') {
        vm.pdrobneeIcon = 'fa fa-chevron-up';
      } else {
        vm.pdrobneeIcon = 'fa fa-chevron-down';
      }
    };
    calculatePremiumNed = function() {
      var i, len, period, ref;
      if (!vm.insuranceformned.objectned) {
        toastr.warning('Выберите объект страхования');
        return;
      }
      if (!vm.insuranceformned.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      ref = vm.periods;
      for (i = 0, len = ref.length; i < len; i++) {
        period = ref[i];
        if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
          vm.period_rate = period.rate;
        }
      }
      vm.insuranceformned.insurance_premium = +((vm.insuranceformned.insurance_summ * (vm.insuranceformned.objectned.rate / 100) / 365) * vm.diffDays).toFixed(2);
      vm.insuranceformned.nsp = Math.round(vm.insuranceformned.insurance_premium * 0.02);
    };
    vm.addCollateralNed = addCollateralNed;
    vm.deleteCollateralNed = deleteCollateralNed;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    vm.pdrobneeIconCnange = pdrobneeIconCnange;
    vm.confirmAction = confirmAction;
    vm.savePolicy = savePolicy;
    vm.recalculateOnEventisAnnual = recalculateOnEventisAnnual;
    vm.getInsuranceForms = getInsuranceForms;
    vm.calculatePremiumNed = calculatePremiumNed;
    vm.getPeriods = getPeriods;
    vm.getInsuranceTypes = getInsuranceTypes;
    vm.showPanel = showPanel;
    recalculateOnEventAll();
    getPeriods();
    getInsuranceTypes();
  }).controller('PolicyVehicleController', function($scope, hotkeys, $state, $stateParams, RequestService, $filter, Session, toastr, $uibModalInstance) {
    'ngInject';
    var addCollateralTs, calculatePremiumTs, confirmAction, deleteCollateralTs, getInsuranceForms, getInsuranceLnObjects, getInsuranceTsObjects, getInsuranceTypes, getPeriods, pdrobneeIconCnange, recalculateOnEventAll, recalculateOnEventisAnnual, savePolicy, showPanel, vm;
    vm = this;
    vm.parseInt = parseInt;
    vm.today = new Date();
    vm.finish_date = moment(vm.today).add(365, 'day').toDate();
    vm.diffDays = 0;
    vm.nedPanel = false;
    vm.tsPanel = false;
    vm.lnPanel = false;
    vm.product = $stateParams.product;
    if (vm.product === null || vm.product === void 0) {
      vm.product = {};
      vm.product.factors = {};
    }
    vm.annualPolicies = [45, 90];
    vm.annualDays = vm.annualPolicies[0];
    vm.productsList = [];
    vm.collateralsned = {
      ned: []
    };
    vm.collateralsts = {
      ts: []
    };
    vm.collateralsln = {
      ln: []
    };
    vm.selectedProduct = {};
    vm.selectedAge = {};
    vm.currentCountryId = '';
    vm.min_insurance_amount = 0;
    vm.insurance_amount = 0;
    vm.currency_name = "USD";
    vm.policy = {
      objects: [],
      insurance_amount: 0,
      insurance_amountts: 0,
      insurance_amountned: 0,
      insurance_amountln: 0,
      insurance_premiumts: 0,
      insurance_premiumned: 0,
      insurance_premiumln: 0,
      date_start: moment().toDate()
    };
    vm.insuranceform = {
      adres: 'Кыргызская Республика'
    };
    vm.insuranceformned = {
      adres: 'Кыргызская Республика'
    };
    vm.insuranceformts = {
      adres: 'Кыргызская Республика',
      driver: 'Лица, имеющие право на управление застрахованным транспортным средством.'
    };
    vm.insuranceformln = {
      adres: 'Кыргызская Республика'
    };
    vm.inputCheck = true;
    vm.period_rate = 0;
    vm.company = Session.getCompany();
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    showPanel = function(insurance_type, check) {
      if (insurance_type.code === 'TC') {
        if (check === true) {
          vm.tsPanel = true;
          getInsuranceTsObjects(insurance_type._id);
        } else if (check !== true & vm.collateralsts.ts.length > 0) {
          toastr.warning('Невозможно закрыть');
          vm.tsPanel = true;
          vm.insuranceformts.objectts = null;
          vm.insuranceformts.model = null;
          vm.insuranceformts.gosnumber = null;
          vm.insuranceformts.number = null;
          vm.insuranceformts.year_issue = null;
          vm.insuranceformts.insurance_summ = null;
          vm.insuranceformts.coll_price = null;
          vm.insuranceformts.insurance_premium = null;
        } else if (check !== true & vm.collateralsts.ts.length === 0) {
          vm.tsPanel = false;
          vm.insuranceformts.objectts = null;
          vm.insuranceformts.model = null;
          vm.insuranceformts.gosnumber = null;
          vm.insuranceformts.number = null;
          vm.insuranceformts.year_issue = null;
          vm.insuranceformts.insurance_summ = null;
          vm.insuranceformts.coll_price = null;
          vm.insuranceformts.insurance_premium = null;
        }
      }
    };
    getInsuranceTypes = function() {
      var filter;
      filter = {
        filter: {}
      };
      filter.filter.code = 'TC';
      return RequestService.post('insurancetypes.listing', filter).then(function(data) {
        vm.insurancetype = angular.copy(data.docs[0]);
        getInsuranceTsObjects();
      });
    };
    getInsuranceTsObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: vm.insurancetype._id
      }).then(function(data) {
        vm.insuranceobjectsts = angular.copy(data.docs);
      });
    };
    getInsuranceLnObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: insurance_type
      }).then(function(data) {
        vm.insuranceobjectsln = angular.copy(data.docs);
      });
    };
    getInsuranceForms = function() {
      return RequestService.post('insuranceforms.listing', {
        insurance_object_id: vm.insuranceform.object._id
      }).then(function(data) {
        vm.insuranceforms = angular.copy(data.docs);
      });
    };
    getPeriods = function() {
      return RequestService.post('period.listing').then(function(data) {
        vm.periods = angular.copy(data.docs);
      });
    };
    addCollateralTs = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.ts = {
          object: insuranceform.objectts.name,
          objectts: insuranceform.objectts,
          adres: insuranceform.adres,
          model: insuranceform.model,
          gosnumber: insuranceform.gosnumber,
          number: insuranceform.number,
          year_issue: insuranceform.year_issue,
          insurance_summ: insuranceform.insurance_summ,
          coll_price: insuranceform.coll_price,
          insurance_premium: insuranceform.insurance_premium + insuranceform.nsp,
          driver: insuranceform.driver
        };
        vm.collateralsts.ts.push(vm.ts);
        vm.ts = {};
        vm.insuranceformts = {
          objectts: null,
          adres: 'Кыргызская Республика',
          model: null,
          gosnumber: null,
          number: null,
          year_issue: null,
          insurance_summ: null,
          coll_price: null,
          insurance_premium: null
        };
        vm.policy.insurance_premiumts = vm.policy.insurance_premiumts + insuranceform.insurance_premium;
        vm.policy.insurance_amountts = vm.policy.insurance_amountts + insuranceform.insurance_summ;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralTs = function(collateral, index) {
      vm.collateralsts.ts.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumts = vm.policy.insurance_premiumts - collateral.insurance_premium;
      vm.policy.insurance_amountts = vm.policy.insurance_amountts - collateral.insurance_summ;
    };
    recalculateOnEventisAnnual = function() {
      vm.policy.date_end = moment(vm.policy.date_start).add(365, 'day').toDate();
      recalculateOnEventAll();
    };
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, timeDiff;
      date1 = "";
      date2 = "";
      date1 = vm.policy.date_start;
      date2 = vm.policy.date_end || moment(vm.policy.date_start).add(1, 'day').toDate();
      diffDays = 0;
      if (vm.isAnnual) {
        vm.diffDays = 365;
      } else {
        timeDiff = Math.abs(date2.getTime() - date1.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        vm.diffDays = diffDays + 1;
      }
    };
    savePolicy = function() {
      var agent_id, branch_id, policy, policyList, policy_no, theUser;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
        branch_id = vm.company.company_id;
      } else if (vm.company.company_type === "branch_company") {
        branch_id = vm.company._id;
      }
      theUser = Session.getUser();
      policyList = {
        items: []
      };
      if (vm.collateralsts.ts.length > 0) {
        policy_no = 'CBK/VI';
        policy = {
          policy_no: policy_no,
          credit_no: vm.policy.credit_no,
          issue_date: new Date(),
          product_id: vm.policy.product_id,
          company_id: vm.company._id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: vm.policy.client,
          insurance_amount: vm.policy.insurance_amountts,
          insurance_premium: vm.policy.insurance_premiumts + Math.round(vm.policy.insurance_premiumts * 0.02),
          insurance_data: {
            ts: vm.collateralsts.ts,
            date_start: vm.policy.date_start,
            date_end: vm.policy.date_end,
            diffDays: vm.diffDays
          },
          objects: 'TS',
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            inn: vm.policy.inn,
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency.name,
            currency: vm.currency,
            insurance_premium_kgs: 0
          }
        };
        policyList.items.push(policy);
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        return $uibModalInstance.close(result);
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var i, item, len, ref, temp, to_save;
        if (result) {
          to_save = [];
          ref = vm.insurants;
          for (i = 0, len = ref.length; i < len; i++) {
            item = ref[i];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    pdrobneeIconCnange = function() {
      if (vm.pdrobneeIcon === 'fa fa-chevron-down') {
        vm.pdrobneeIcon = 'fa fa-chevron-up';
      } else {
        vm.pdrobneeIcon = 'fa fa-chevron-down';
      }
    };
    calculatePremiumTs = function() {
      var i, len, period, ref;
      if (!vm.insuranceformts.objectts) {
        toastr.warning('Выберите объект страхования');
        return;
      }
      if (!vm.insuranceformts.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      ref = vm.periods;
      for (i = 0, len = ref.length; i < len; i++) {
        period = ref[i];
        if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
          vm.period_rate = period.rate;
        }
      }
      vm.insuranceformts.insurance_premium = +((vm.insuranceformts.insurance_summ * ((vm.insuranceformts.objectts.rate / 100) / 365)) * vm.diffDays).toFixed(2);
      vm.insuranceformts.nsp = Math.round(vm.insuranceformts.insurance_premium * 0.02);
    };
    vm.addCollateralTs = addCollateralTs;
    vm.deleteCollateralTs = deleteCollateralTs;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    vm.pdrobneeIconCnange = pdrobneeIconCnange;
    vm.confirmAction = confirmAction;
    vm.savePolicy = savePolicy;
    vm.recalculateOnEventisAnnual = recalculateOnEventisAnnual;
    vm.getInsuranceForms = getInsuranceForms;
    vm.calculatePremiumTs = calculatePremiumTs;
    vm.getPeriods = getPeriods;
    vm.getInsuranceTypes = getInsuranceTypes;
    vm.showPanel = showPanel;
    recalculateOnEventAll();
    getPeriods();
    getInsuranceTypes();
  }).controller('PolicyPersonalController', function($scope, hotkeys, $state, $stateParams, RequestService, $filter, Session, toastr, $uibModalInstance) {
    'ngInject';
    var addCollateralLn, calculatePremiumLn, confirmAction, deleteCollateralLn, getInsuranceForms, getInsuranceLnObjects, getInsuranceTypes, getPeriods, pdrobneeIconCnange, recalculateOnEventAll, recalculateOnEventisAnnual, savePolicy, showPanel, vm;
    vm = this;
    vm.parseInt = parseInt;
    vm.today = new Date();
    vm.finish_date = moment(vm.today).add(365, 'day').toDate();
    vm.diffDays = 0;
    vm.nedPanel = false;
    vm.tsPanel = false;
    vm.lnPanel = false;
    vm.product = $stateParams.product;
    if (vm.product === null || vm.product === void 0) {
      vm.product = {};
      vm.product.factors = {};
    }
    vm.annualPolicies = [45, 90];
    vm.annualDays = vm.annualPolicies[0];
    vm.productsList = [];
    vm.collateralsned = {
      ned: []
    };
    vm.collateralsts = {
      ts: []
    };
    vm.collateralsln = {
      ln: []
    };
    vm.selectedProduct = {};
    vm.selectedAge = {};
    vm.currentCountryId = '';
    vm.min_insurance_amount = 0;
    vm.insurance_amount = 0;
    vm.currency_name = "USD";
    vm.policy = {
      objects: [],
      insurance_amount: 0,
      insurance_amountts: 0,
      insurance_amountned: 0,
      insurance_amountln: 0,
      insurance_premiumts: 0,
      insurance_premiumned: 0,
      insurance_premiumln: 0,
      date_start: moment().toDate()
    };
    vm.insuranceform = {
      adres: 'Кыргызская Республика'
    };
    vm.insuranceformned = {
      adres: 'Кыргызская Республика'
    };
    vm.insuranceformts = {
      adres: 'Кыргызская Республика',
      driver: 'Лица, имеющие право на управление застрахованным транспортным средством.'
    };
    vm.insuranceformln = {
      adres: 'Кыргызская Республика'
    };
    vm.inputCheck = true;
    vm.period_rate = 0;
    vm.company = Session.getCompany();
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    showPanel = function(insurance_type, check) {
      if (insurance_type.code === 'LN') {
        if (check === true) {
          vm.lnPanel = true;
          getInsuranceLnObjects(insurance_type._id);
        } else if (check !== true & vm.collateralsln.ln.length > 0) {
          toastr.warning('Невозможно закрыть');
          vm.lnPanel = false;
          vm.insuranceformln.objectln = null;
          vm.insuranceformln.birthday = null;
          vm.insuranceformln.pasport = null;
          vm.insuranceformln.insurance_summ = null;
          vm.insuranceformln.coll_price = null;
          vm.insuranceformln.insurance_premium = null;
          vm.insuranceformln.nsp = null;
        } else if (check !== true & vm.collateralsln.ln.length === 0) {
          vm.lnPanel = false;
          vm.insuranceformln.objectln = null;
          vm.insuranceformln.birthday = null;
          vm.insuranceformln.pasport = null;
          vm.insuranceformln.insurance_summ = null;
          vm.insuranceformln.coll_price = null;
          vm.insuranceformln.insurance_premium = null;
          vm.insuranceformln.nsp = null;
        }
      }
    };
    getInsuranceTypes = function() {
      var filter;
      filter = {
        filter: {}
      };
      filter.filter.code = 'LN';
      return RequestService.post('insurancetypes.listing', filter).then(function(data) {
        vm.insurancetype = angular.copy(data.docs[0]);
        getInsuranceLnObjects();
      });
    };
    getInsuranceLnObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: vm.insurancetype._id
      }).then(function(data) {
        vm.insuranceobjectsln = angular.copy(data.docs);
      });
    };
    getInsuranceForms = function() {
      return RequestService.post('insuranceforms.listing', {
        insurance_object_id: vm.insuranceform.object._id
      }).then(function(data) {
        vm.insuranceforms = angular.copy(data.docs);
      });
    };
    getPeriods = function() {
      return RequestService.post('period.listing').then(function(data) {
        vm.periods = angular.copy(data.docs);
      });
    };
    addCollateralLn = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.ln = {
          adres: insuranceform.adres,
          birthday: insuranceform.birthday,
          pasport: insuranceform.pasport,
          insurance_summ: insuranceform.insurance_summ,
          client: insuranceform.client,
          insurance_premium: insuranceform.insurance_premium + insuranceform.nsp
        };
        vm.collateralsln.ln.push(vm.ln);
        vm.ln = {};
        vm.insuranceformln = {
          adres: 'Кыргызская Республика',
          birthday: null,
          pasport: null,
          insurance_summ: null,
          client: null,
          insurance_premium: null
        };
        vm.policy.insurance_premiumln = vm.policy.insurance_premiumln + insuranceform.insurance_premium;
        vm.policy.insurance_amountln = vm.policy.insurance_amountln + insuranceform.insurance_summ;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralLn = function(collateral, index) {
      vm.collateralsln.ln.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumln = vm.policy.insurance_premiumln - collateral.insurance_premium;
      vm.policy.insurance_amountln = vm.policy.insurance_amountln - collateral.insurance_summ;
    };
    recalculateOnEventisAnnual = function() {
      vm.policy.date_end = moment(vm.policy.date_start).add(365, 'day').toDate();
      recalculateOnEventAll();
    };
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, timeDiff;
      date1 = "";
      date2 = "";
      date1 = vm.policy.date_start;
      date2 = vm.policy.date_end || moment(vm.policy.date_start).add(1, 'day').toDate();
      diffDays = 0;
      if (vm.isAnnual) {
        vm.diffDays = 365;
      } else {
        timeDiff = Math.abs(date2.getTime() - date1.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        vm.diffDays = diffDays + 1;
      }
    };
    savePolicy = function() {
      var agent_id, branch_id, policy, policyList, policy_no, theUser;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
        branch_id = vm.company.company_id;
      } else if (vm.company.company_type === "branch_company") {
        branch_id = vm.company._id;
      }
      theUser = Session.getUser();
      policyList = {
        items: []
      };
      if (vm.collateralsln.ln.length > 0) {
        policy_no = 'CBK/AI';
        policy = {
          policy_no: policy_no,
          credit_no: vm.policy.credit_no,
          issue_date: new Date(),
          product_id: vm.policy.product_id,
          company_id: vm.company._id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: vm.policy.client,
          insurance_amount: vm.policy.insurance_amountln,
          insurance_premium: vm.policy.insurance_premiumln + Math.round(vm.policy.insurance_premiumln * 0.02),
          insurance_data: {
            ln: vm.collateralsln.ln,
            date_start: vm.policy.date_start,
            date_end: vm.policy.date_end,
            diffDays: vm.diffDays
          },
          objects: 'LN',
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            inn: vm.policy.inn,
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency.name,
            currency: vm.currency,
            insurance_premium_kgs: 0
          }
        };
        policyList.items.push(policy);
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        return $uibModalInstance.close(result);
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var i, item, len, ref, temp, to_save;
        if (result) {
          to_save = [];
          ref = vm.insurants;
          for (i = 0, len = ref.length; i < len; i++) {
            item = ref[i];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    pdrobneeIconCnange = function() {
      if (vm.pdrobneeIcon === 'fa fa-chevron-down') {
        vm.pdrobneeIcon = 'fa fa-chevron-up';
      } else {
        vm.pdrobneeIcon = 'fa fa-chevron-down';
      }
    };
    calculatePremiumLn = function() {
      var i, len, period, ref;
      if (!vm.insuranceformln.objectln) {
        toastr.warning('Выберите объект страхования');
        return;
      }
      if (!vm.insuranceformln.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      ref = vm.periods;
      for (i = 0, len = ref.length; i < len; i++) {
        period = ref[i];
        if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
          vm.period_rate = period.rate;
        }
      }
      vm.insuranceformln.insurance_premium = +((vm.insuranceformln.insurance_summ * (vm.insuranceformln.objectln.rate / 100) / 365) * vm.diffDays).toFixed(2);
      vm.insuranceformln.nsp = Math.round(vm.insuranceformln.insurance_premium * 0.85);
    };
    vm.addCollateralLn = addCollateralLn;
    vm.deleteCollateralLn = deleteCollateralLn;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    vm.pdrobneeIconCnange = pdrobneeIconCnange;
    vm.confirmAction = confirmAction;
    vm.savePolicy = savePolicy;
    vm.recalculateOnEventisAnnual = recalculateOnEventisAnnual;
    vm.getInsuranceForms = getInsuranceForms;
    vm.calculatePremiumLn = calculatePremiumLn;
    vm.getPeriods = getPeriods;
    vm.getInsuranceTypes = getInsuranceTypes;
    vm.showPanel = showPanel;
    recalculateOnEventAll();
    getPeriods();
    getInsuranceTypes();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('PaymentController', function($scope, $state, RequestService, hotkeys, $uibModal) {
    'ngInject';
    var editPayment, getPayments, newPayment, viewPayment, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'branch.name',
          displayName: 'Филиал'
        }, {
          name: 'amount',
          displayName: 'Наименование'
        }, {
          name: 'currency.name',
          displayName: 'Валюта'
        }, {
          name: 'payment_direction_value.data.name',
          displayName: 'Направление платежа'
        }, {
          name: 'payment_type_value.data.name',
          displayName: 'Тип платежа'
        }, {
          name: 'payment_date',
          displayName: 'Дата редактирования',
          cellTemplate: '<div class="ui-grid-cell-contents" am-time-ago="grid.getCellValue(row,col)"></div>'
        }
      ],
      appScopeProvider: {
        onDoubleClick: function(row) {
          viewPayment(row.entity);
        }
      },
      rowTemplate: '<div ng-dblclick="grid.appScope.onDoubleClick(row)" ng-repeat="col in colContainer.renderedColumns" class="ui-grid-cell" ui-grid-cell></div>'
    };
    getPayments = function() {
      var filter;
      filter = {
        limit: vm.limit,
        offset: vm.offset,
        with_related: true
      };
      RequestService.post('payment.listing', filter).then(function(result) {
        delete vm.selected_payment;
        vm.gridOptions.data = result.payments;
        vm.gridOptions.totalItems = result.count;
      });
    };
    newPayment = function() {
      var paymentModal;
      paymentModal = $uibModal.open({
        controller: 'PaymentEditController',
        controllerAs: 'edit',
        templateUrl: 'app/payment/edit.html',
        size: 'lg',
        resolve: {
          payment: void 0
        }
      });
      paymentModal.result.then(function(result) {
        getPayments();
      });
    };
    editPayment = function() {
      var paymentModal;
      paymentModal = $uibModal.open({
        controller: 'PaymentEditController',
        controllerAs: 'edit',
        templateUrl: 'app/payment/edit.html',
        size: 'lg',
        resolve: {
          payment: angular.copy(vm.selected_payment)
        }
      });
      paymentModal.result.then(function(result) {
        getPayments();
      });
    };
    viewPayment = function(payment) {
      var paymentModal;
      paymentModal = $uibModal.open({
        controller: 'PaymentViewController',
        controllerAs: 'view',
        templateUrl: 'app/payment/view.html',
        size: 'lg',
        resolve: {
          payment: payment
        }
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_payment = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPayments();
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить платеж',
      callback: newPayment
    }).add({
      combo: 'r',
      description: 'Обновить список платежей',
      callback: getPayments
    });
    vm.getPayments = getPayments;
    vm.newPayment = newPayment;
    vm.editPayment = editPayment;
    getPayments();
  }).controller('PaymentEditController', function($scope, $state, RequestService, payment, $uibModalInstance, toastr) {
    'ngInject';
    var savePayment, vm;
    vm = this;
    vm.payment = payment;
    savePayment = function() {
      if (vm.saving === true) {
        return;
      }
      if ((angular.isDefined(vm.payment.data.contractor_id)) && (angular.isDefined(vm.payment.data.employee_id)) && (angular.isDefined(vm.payment.data.branch_id))) {
        vm.contractor_error = angular.isDefined(vm.payment.data.contractor_id);
        vm.employee_error = angular.isDefined(vm.payment.data.employee_id);
        vm.brach_error = angular.isDefined(vm.payment.data.branch_id);
        toastr.warning('Укажите только одного');
        vm.saving = false;
        return;
      }
      if ((angular.isUndefined(vm.payment.data.contractor_id)) && (angular.isUndefined(vm.payment.data.employee_id)) && (angular.isUndefined(vm.payment.data.branch_id))) {
        vm.contractor_error = true;
        vm.employee_error = true;
        vm.brach_error = true;
        toastr.warning('Заполните одно из полей');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.branch_id)) {
        toastr.warning('Укажите филиал');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.currency_id)) {
        toastr.warning('Укажите валюту');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.payment_direction)) {
        toastr.warning('Укажите направление платежа');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.payment_type)) {
        toastr.warning('Укажите тип платежа');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.amount)) {
        toastr.warning('Укажите сумму');
        vm.saving = false;
        return;
      }
      vm.saving = true;
      RequestService.post('payment.put', vm.payment).then(function(result) {
        vm.saving = false;
        return $uibModalInstance.close(result);
      }, function(result) {
        vm.saving = false;
      });
    };
    vm.savePayment = savePayment;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('PaymentViewController', function($scope, $state, RequestService, payment, $uibModalInstance) {
    'ngInject';
    var vm;
    vm = this;
    vm.payment = payment;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('OperationController', function($scope, $state, RequestService, hotkeys, $uibModal) {
    'ngInject';
    var getOperations, viewOperation, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'branch.name',
          displayName: 'Филиал'
        }, {
          name: 'product.name',
          displayName: 'Продукт'
        }, {
          name: 'quantity',
          displayName: 'Наименование'
        }, {
          name: 'currency.name',
          displayName: 'Валюта'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена'
        }, {
          name: 'total_cost',
          displayName: 'Сумма'
        }, {
          name: 'additional_cost',
          displayName: 'Доп. стоимость'
        }
      ],
      appScopeProvider: {
        onDoubleClick: function(row) {
          viewOperation(row.entity);
        }
      },
      rowTemplate: '<div ng-dblclick="grid.appScope.onDoubleClick(row)" ng-repeat="col in colContainer.renderedColumns" class="ui-grid-cell" ui-grid-cell></div>'
    };
    getOperations = function() {
      var filter;
      filter = {
        limit: vm.limit,
        offset: vm.offset,
        with_related: true
      };
      RequestService.post('operation.listing', filter).then(function(result) {
        delete vm.selected_operation;
        vm.gridOptions.data = result.operations;
        vm.gridOptions.totalItems = result.count;
      });
    };
    viewOperation = function(operation) {
      var operationModal;
      operationModal = $uibModal.open({
        controller: 'OperationViewController',
        controllerAs: 'view',
        templateUrl: 'app/operation/view.html',
        size: 'lg',
        resolve: {
          operation: operation
        }
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_operation = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getOperations();
    });
    hotkeys.bindTo($scope).add({
      combo: 'r',
      description: 'Обновить список операций',
      callback: getOperations
    });
    vm.getOperations = getOperations;
    getOperations();
  }).controller('OperationViewController', function($scope, $state, RequestService, operation, $uibModalInstance) {
    'ngInject';
    var vm;
    vm = this;
    vm.operation = operation;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('NewsController', function(RequestService, $timeout, toastr, $rootScope, $http, $state) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('NewsListController', function($rootScope, $scope, $state, RequestService, $http) {
    'ngInject';
    var getNews, openCreateForm, openEditForm, removeNews, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 20;
    vm.searchValues = {};
    vm.searchValuesLang = {};
    vm.dateOptions = {
      startingDay: 1,
      opened1: false,
      opened2: false
    };
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [100, 200, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          displayName: 'Название',
          name: 'name'
        }, {
          displayName: 'Актив',
          name: 'is_active'
        }
      ],
      events: {
        onRowSelect: function(row) {
          vm.selected_news = angular.copy(row.entity);
        },
        onPageSelect: function(page, size) {
          vm.offset = page * size;
          vm.limit = size;
          getNews();
        }
      }
    };
    getNews = function() {
      var filter;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      RequestService.post('news.listing', filter).then(function(response) {
        vm.gridOptions.data = response.docs;
      }, function(response) {});
    };
    openCreateForm = function() {
      $state.go('app.news.form');
    };
    openEditForm = function() {
      return $state.go('app.news.form', {
        news: vm.selected_news
      });
    };
    removeNews = function() {
      if (!vm.selected_news) {
        return;
      }
      vm.selected_news.crud = 'News';
      RequestService.post('news/delete', vm.selected_news).then(function(result) {
        getNews();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_news = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getRegulations();
    });
    vm.removeNews = removeNews;
    vm.getNews = getNews;
    vm.openCreateForm = openCreateForm;
    vm.openEditForm = openEditForm;
    getNews();
  }).controller('NewsFormController', function($rootScope, $scope, $state, $stateParams, RequestService, $http, hotkeys, toastr, $base64, $uibModal) {
    'ngInject';
    var goBack, saveNews, vm;
    vm = this;
    vm.newsItem = $stateParams.news;
    if (angular.isUndefined(vm.newsItem || vm.newsItem === null)) {
      goBack();
    }
    saveNews = function() {
      RequestService.post('news.put', vm.newsItem).then(function(response) {
        $state.go('app.news.list');
        return toastr.success('Вы успешно добавили новость');
      });
    };
    goBack = function() {
      $state.go('app.news.list');
    };
    vm.saveNews = saveNews;
    vm.goBack = goBack;
  }).controller('NewsViewController', function($rootScope, $scope, $state, $stateParams, RequestService, $http, hotkeys, toastr, $base64, $uibModal) {
    'ngInject';
    var vm;
    vm = this;
    vm.document = $stateParams.news;
    if (angular.isUndefined(vm.document || vm.document === null)) {
      goBack();
    }
  });

}).call(this);



(function() {
  angular.module('fsa').controller('SearchProdController', function($scope, $uibModalInstance, uiGridConstants, $timeout) {
    $scope.gridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'data.name',
          pinnedLeft: true,
          displayName: 'Наименование'
        }, {
          name: 'data.price',
          pinnedLeft: true,
          displayName: 'Цена'
        }
      ]
    };
    $scope.ok = function() {
      return $uibModalInstance.close($scope.entity);
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss();
    };
    $scope.pressed = function(e) {
      if (e.keyCode === 13 && $scope.entity) {
        $scope.ok();
      }
    };
    $scope.$on('data-selected', function(e, row) {
      return $scope.entity = row.entity;
    });
  });

}).call(this);



(function() {
  angular.module('fsa').controller('MenuController', function($scope, RequestService, Session, $state, AppStorage, hotkeys) {
    'ngInject';
    var filterOnlyParents, getMenus, vm;
    vm = this;
    if ($scope.app.ua.role < 10) {
      $state.go('app.company');
      return;
    }
    getMenus = function() {
      RequestService.post('menu.listing').then(function(result) {
        vm.menus = result.docs;
      });
    };
    filterOnlyParents = function(menu) {
      if ((angular.isUndefined(menu)) || (angular.isUndefined(menu.parent_id)) || menu.parent_id === null) {
        return true;
      }
      return false;
    };
    $scope.$on('refresh-menus', function() {
      return getMenus();
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Новое меню',
      callback: function() {
        return $state.go('app.menu.item', {
          id: 'new'
        });
      }
    }).add({
      combo: 'r',
      description: 'Обновить сисок меню',
      callback: getMenus
    });
    vm.getMenus = getMenus;
    vm.filterOnlyParents = filterOnlyParents;
    getMenus();
  }).controller('MenuItemController', function($scope, RequestService, $stateParams, AppStorage, $state, $rootScope, $uibModal) {
    'ngInject';
    var confirmAction, initMenu, putMenu, refreshMenus, removeMenu, vm;
    vm = this;
    refreshMenus = function() {
      return $rootScope.$broadcast('refresh-menus');
    };
    putMenu = function() {
      var data;
      data = {
        _id: vm.menu._id,
        _rev: vm.menu._rev,
        name: vm.menu.name,
        parent_id: vm.menu.parent_id,
        data: {
          position: vm.menu.data.position,
          icon: vm.menu.data.icon,
          route: vm.menu.data.route
        }
      };
      RequestService.post('menu.save', data).then(function(result) {
        vm.menu._id = result.id;
        if ($stateParams.id === 'new') {
          $state.go('app.menu.item', {
            id: vm.menu._id
          });
        }
        refreshMenus();
        return;
      });
      return false;
    };
    removeMenu = function(item) {
      return RequestService.post('menu.remove', item).then(function(data) {
        refreshMenus();
      });
    };
    confirmAction = function(item) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", Вы уверены, что хотите продолжить?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeMenu(item);
        }
      });
    };
    initMenu = function() {
      vm.menu = {};
      if ($stateParams.id !== 'new') {
        return RequestService.post('menu.listing', {
          filter: {
            _id: $stateParams.id
          }
        }).then(function(result) {
          if (result.docs.length === 1) {
            return vm.menu = result.docs[0];
          }
        });
      }
    };
    $rootScope.$on('menus-updated', function() {
      return initMenu();
    });
    vm.putMenu = putMenu;
    vm.removeMenu = removeMenu;
    vm.confirmAction = confirmAction;
    initMenu();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('MainController', function($scope, AppStorage, $rootScope, RequestService, $state, Session, EVENTS, $window, toastr, $translate, lang_name) {
    'ngInject';
    var getMenus, goBack, logOut, parentGroup, vm;
    vm = this;
    vm.lang_name = lang_name;
    $scope.$on(EVENTS.notAuthenticated, function() {
      Session.destroy();
      delete vm.ua;
      $state.go('login', $state.current.name !== 'login' ? {
        r: $state.current.name,
        params: $state.params
      } : void 0);
      return AppStorage.clear();
    });
    $scope.$on(EVENTS.businessError, function(e, message) {
      return toastr.warning(message);
    });
    $scope.$on(EVENTS.applicationError, function(e, message) {
      return toastr.error(message);
    });
    $scope.$on(EVENTS.connectionError, function() {
      return toastr.error('Проверьте соединение с сервером');
    });
    $scope.$on(EVENTS.successMessage, function(e, message) {
      return toastr.success(message);
    });
    vm.changeLanguage = function(langCode) {
      $translate.use(langCode);
      vm.lang_name = name || lang_name;
    };
    $rootScope.company = {
      name: "ICT LAB",
      id: 1
    };
    $rootScope.branch = {
      name: "Main Office",
      id: 5
    };
    $rootScope.user = {
      name: "User",
      id: 1
    };
    vm.api = $rootScope.api;
    vm.ua = Session.getUser();
    vm.uc = Session.getCompany();
    vm.languages = [
      {
        code: 'kg',
        short_name: 'Кырг',
        name: 'Кыргызча',
        image: 'img/flags/kg.png'
      }, {
        code: 'ru',
        short_name: 'Рус',
        name: 'Русский',
        image: 'img/flags/ru.png'
      }, {
        code: 'en',
        short_name: 'Eng',
        name: 'English',
        image: 'img/flags/us.png'
      }
    ];
    logOut = function() {
      return $scope.$emit(EVENTS.notAuthenticated);
    };
    if (!Session.getToken() || !vm.ua) {
      logOut();
      return;
    }
    vm.navigation = AppStorage.getObject('navigation') || [];
    if (vm.ua.role >= 10) {
      vm.admin_menu = [
        {
          name: 'Настройки',
          data: {
            icon: 'fa fa-cogs',
            position: 1
          },
          children: [
            {
              name: 'Меню',
              data: {
                route: 'app.menu',
                position: 1
              }
            }, {
              name: 'Роли',
              data: {
                route: 'app.role',
                position: 2
              }
            }, {
              name: 'Пользователи',
              data: {
                route: 'app.users',
                position: 3
              }
            }, {
              name: 'Справочники',
              data: {
                route: 'app.dictionary',
                position: 3
              }
            }, {
              name: 'Просмотр отчетов',
              data: {
                route: 'app.report_viewer',
                position: 4
              }
            }, {
              name: 'Дизайнер отчетов',
              data: {
                route: 'app.report_designer',
                position: 4
              }
            }, {
              name: 'Шаблоны отчетов',
              data: {
                route: 'app.report_template',
                position: 5
              }
            }
          ]
        }
      ];
    }
    getMenus = function() {
      var filter;
      filter = {
        with_related: true
      };
      return RequestService.post('menu.listing', filter).then(function(result) {
        var child, children, i, j, k, len, len1, len2, menu, parents, ref;
        parents = [];
        children = [];
        ref = result.docs;
        for (i = 0, len = ref.length; i < len; i++) {
          menu = ref[i];
          if (menu.parent_id === null || angular.isUndefined(menu.parent_id)) {
            parents.push(menu);
          } else {
            children.push(menu);
          }
        }
        for (j = 0, len1 = parents.length; j < len1; j++) {
          menu = parents[j];
          menu.children = [];
          for (k = 0, len2 = children.length; k < len2; k++) {
            child = children[k];
            if (menu._id === child.parent_id) {
              menu.children.push(child);
            }
          }
        }
        vm.navigation = parents;
        AppStorage.setObject('navigation', vm.navigation);
        AppStorage.setObject('menus', result.docs);
        return $scope.$broadcast('menus-updated');
      });
    };
    parentGroup = function(item) {
      if (!item.parent) {
        return '';
      }
      return item.parent.name;
    };
    $scope.$on('refresh-menus', function() {
      getMenus();
    });
    $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options) {});
    goBack = function() {
      if ($window.history.length === 1) {
        $state.go("app.docs.list");
        return;
      }
      $window.history.back();
    };
    vm.logOut = logOut;
    vm.getMenus = getMenus;
    vm.parentGroup = parentGroup;
    $scope.goBack = goBack;
    getMenus();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('HpolicyController', function() {
    'ngInject';
    var vm;
    vm = this;
  }).controller('HpolicyListController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, downloadPDF, editBranch, fiterPolicy, getAgents, getBranches, getPolicies, goToIssue, goToNew, goToShow, onDblClick, resetFilter, savePDF, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 50;
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/hpolicy/show.html',
        controller: 'HpolicyShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [50, 100, 500],
      paginationPageSize: 50,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'data.currency.name',
          displayName: 'Валюта'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      $state.go('app.policy_select');
      return false;
    };
    goToIssue = function() {
      $state.go('app.policy_issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/edit.html',
        controller: 'PolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "date_end") {
          filter.filter.date_end = v;
        }
        if (k === "date_start") {
          filter.filter.date_start = v;
        }
        if (k === "agent_id") {
          filter.filter.edit_user_id = v;
        }
        if (k === "branch_id") {
          filter.filter.branch_id = v;
        }
        if (k === "client") {
          filter.filter.client = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      filter.order_by = ["issue_date DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.success("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getBranches = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'branch_company'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        vm.branches = data.docs;
      });
    };
    getAgents = function(company_id) {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        id: company_id
      };
      RequestService.post('agentemployee.listing', filter).then(function(data) {
        vm.agents = data.users;
      });
    };
    downloadPDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'LN') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'NED') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    savePDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        ReportService.saveReportPdf('TS', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'LN') {
        ReportService.saveReportPdf('LN', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'NED') {
        ReportService.saveReportPdf('NED', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, i, issue_d, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (i = 0, len = ref.length; i < len; i++) {
          policy = ref[i];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.savePDF = savePDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    vm.getAgents = getAgents;
    getBranches();
    getPolicies();
  }).controller('HpolicyShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var cancel, confirmAction, confirmActionForm, confirmActionTerm, date1, diffDays, downloadPDF, goToForm, goToPolicy, spoilPolicy, termPolicy, timeDiff, vm;
    vm = this;
    vm.today = new Date();
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    vm.flag_status_policy = true;
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.policy");
    } else {
      date1 = new Date(vm.policy.issue_date);
      timeDiff = Math.abs(date1.getTime() - vm.today.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays >= 1) {
        vm.flag_status_policy = false;
      }
    }
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    downloadPDF = function() {
      if (vm.policy.objects === 'TS') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'LN') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'NED') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    termPolicy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.policy');
    };
    goToForm = function() {
      $state.go('app.policy_form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issuePolicy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('FpolicyController', function() {
    'ngInject';
    var vm;
    vm = this;
  }).controller('FpolicyListController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, downloadPDF, editBranch, fiterPolicy, getAgents, getPolicies, goToIssue, goToNew, goToShow, onDblClick, resetFilter, savePDF, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 50;
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/fpolicy/show.html',
        controller: 'FpolicyShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [50, 100, 500],
      paginationPageSize: 50,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'data.currency.name',
          displayName: 'Валюта'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      $state.go('app.policy_select');
      return false;
    };
    goToIssue = function() {
      $state.go('app.policy_issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/edit.html',
        controller: 'PolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "date_end") {
          filter.filter.date_end = v;
        }
        if (k === "date_start") {
          filter.filter.date_start = v;
        }
        if (k === "agent_id") {
          filter.filter.edit_user_id = v;
        }
        if (k === "branch_id") {
          filter.filter.branch_id = v;
        }
        if (k === "client") {
          filter.filter.client = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      filter.order_by = ["issue_date DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.success("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getAgents = function() {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        id: vm.company._id
      };
      RequestService.post('agentemployee.listing', filter).then(function(data) {
        vm.agents = data.users;
      });
    };
    downloadPDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'LN') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'NED') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    savePDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        ReportService.saveReportPdf('TS', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'LN') {
        ReportService.saveReportPdf('LN', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'NED') {
        ReportService.saveReportPdf('NED', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, i, issue_d, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (i = 0, len = ref.length; i < len; i++) {
          policy = ref[i];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.savePDF = savePDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    vm.getAgents = getAgents;
    getAgents();
    getPolicies();
  }).controller('FpolicyShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var cancel, confirmAction, confirmActionForm, confirmActionTerm, date1, diffDays, downloadPDF, goToForm, goToPolicy, spoilPolicy, termPolicy, timeDiff, vm;
    vm = this;
    vm.today = new Date();
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    vm.flag_status_policy = true;
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.policy");
    } else {
      date1 = new Date(vm.policy.issue_date);
      timeDiff = Math.abs(date1.getTime() - vm.today.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays >= 1) {
        vm.flag_status_policy = false;
      }
    }
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    downloadPDF = function() {
      if (vm.policy.objects === 'TS') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'LN') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'NED') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    termPolicy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.policy');
    };
    goToForm = function() {
      $state.go('app.policy_form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issuePolicy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('EmployeeController', function(RequestService, product_types, $scope, $uibModal, toastr, Session) {
    'ngInject';
    var deleteEmployee, editEmployee, getEmployees, newEmployee, vm;
    vm = this;
    vm.company = Session.getCompany();
    vm.employeeGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'ФИО'
        }, {
          name: 'birthday',
          displayName: 'Дата рождения',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }
      ]
    };
    getEmployees = function() {
      RequestService.post('employee.listing', {
        company_id: vm.company._id
      }).then(function(data) {
        vm.employees = data.docs;
        vm.employeeGridOptions.data = vm.employees;
        vm.employeeGridOptions.totalItems = vm.employees.length;
      });
    };
    editEmployee = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/employee/edit.html',
        controller: 'EmployeeCreateController',
        controllerAs: 'employee',
        size: 'lg',
        resolve: {
          employee: angular.copy(vm.selected_user)
        }
      });
      employeeDialog.result.then(function() {
        return getEmployees();
      });
    };
    deleteEmployee = function(user) {
      RequestService.post('employee.delete', {
        _id: user._id,
        _rev: user._rev
      }).then(function(data) {
        toastr.success('Сотрудник удален');
        return getEmployees();
      });
    };
    newEmployee = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/employee/create.html',
        controller: 'EmployeeCreateController',
        controllerAs: 'employee',
        size: 'lg',
        resolve: {
          employee: void 0
        }
      });
      employeeDialog.result.then(function() {
        return getEmployees();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_user = row.entity;
    });
    vm.newEmployee = newEmployee;
    vm.editEmployee = editEmployee;
    vm.getEmployees = getEmployees;
    vm.deleteEmployee = deleteEmployee;
    getEmployees();
  }).controller('EmployeeCreateController', function(RequestService, employee, $scope, $uibModalInstance) {
    'ngInject';
    var cancel, createEmployee, updateEmployee, vm;
    vm = this;
    if (employee === null || employee === void 0) {
      vm.employee = {};
    } else {
      vm.employee = employee;
    }
    createEmployee = function() {
      RequestService.post('employee.put', vm.employee).then(function(result) {
        return $uibModalInstance.close(result);
      });
    };
    updateEmployee = function() {
      RequestService.post('employee.put', vm.employee).then(function(result) {
        return $uibModalInstance.close(result);
      });
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.updateEmployee = updateEmployee;
    vm.createEmployee = createEmployee;
    vm.cancel = cancel;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DoctemplatesController', function() {
    'ngInject';
    var vm;
    vm = this;
  }).controller('DoctemplatesAddController', function($rootScope, $scope, RequestService, $state, $http, Session) {
    'ngInject';
    var goBack, saveDocTemp, vm;
    vm = this;
    vm.company = Session.getCompany();
    vm.flowConfig = {
      target: $rootScope.api + 'upload/' + vm.company.name + '/' + vm.company._id,
      singleFile: true
    };
    vm.docTemp = {};
    goBack = function() {
      $state.go('app.doctemplates.list');
    };
    saveDocTemp = function() {
      console.log(vm.docTemp);
      RequestService.post('doc_templates/put', vm.docTemp).then(function(response) {
        goBack();
      }, function(response) {
        console.log(response);
      });
    };
    vm.goBack = goBack;
    vm.saveDocTemp = saveDocTemp;
  }).controller('DoctemplatesListController', function($rootScope, $scope, AppStorage, RequestService, $http, $state, Session, $base64) {
    'ngInject';
    var deleteDoc, getDocTeplates, openAddForm, vm;
    vm = this;
    vm.docTemps = [];
    vm.api = $rootScope.api;
    getDocTeplates = function() {
      RequestService.post('doc_templates.listing', {}).then(function(response) {
        vm.docTemps = response.docs;
      }, function(response) {
        console.log(response);
      });
    };
    deleteDoc = function(docTemp) {
      if (!confirm('Вы действительно хотите удалить шаблон ?')) {
        return;
      }
      RequestService.post('doc_templates.delete', docTemp).then(function(response) {
        console.log(response);
        getDocTeplates();
      }, function(response) {
        console.log(response);
      });
    };
    openAddForm = function() {
      $state.go('app.doctemplates.add');
    };
    vm.getDocTeplates = getDocTeplates;
    vm.deleteDoc = deleteDoc;
    vm.openAddForm = openAddForm;
    getDocTeplates();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DocsViewController', function($scope, RequestService, $state, $stateParams, $uibModal, hotkeys, $uibModalStack, confirmModal, ReportPrint, toastr) {
    var approve, canCommit, canEdit, canRollback, commitDoc, editDoc, execute, getDoc, print, reject, rollbackDoc, send, vm;
    vm = this;
    vm.doc_id = (angular.isDefined($stateParams.id)) && $stateParams.id !== '' ? $stateParams.id : null;
    if (vm.doc_id === null) {
      $state.go('app.docs.list');
      return;
    }
    getDoc = function() {
      var filter;
      filter = {
        id: vm.doc_id,
        with_related: true,
        document_type: $stateParams.type
      };
      vm.doc_loading = true;
      RequestService.post('doc.get', filter).then(function(result) {
        var approval_role, approval_user, can_approve, can_execute, doc_type, i, j, k, len, len1, len2, ref, ref1, ref2;
        vm.doc_loading = false;
        vm.document = result.doc;
        vm.template = "app/docs/" + vm.document.document_type + "/view.html";
        ref = $scope.docs.doc_types;
        for (i = 0, len = ref.length; i < len; i++) {
          doc_type = ref[i];
          if (doc_type.id === vm.document.document_type) {
            vm.doc_type = doc_type;
          }
        }
        vm.postGet();
        can_approve = null;
        if (vm.document.document_status === 'approval') {
          ref1 = vm.document.approval.approval_roles;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            approval_role = ref1[j];
            if ((angular.isUndefined(approval_role.approved)) && $scope.app.uc.roles_id.indexOf(approval_role.role_id) > -1) {
              if (angular.isUndefined(approval_role.approval_users)) {
                can_approve = true;
              } else {
                ref2 = approval_role.approval_users;
                for (k = 0, len2 = ref2.length; k < len2; k++) {
                  approval_user = ref2[k];
                  if (approval_user.user_id === $scope.app.ua.id) {
                    can_approve = false;
                    break;
                  }
                }
                if (can_approve === null) {
                  can_approve = true;
                }
              }
            }
          }
        }
        vm.can_approve = can_approve === null ? false : can_approve;
        can_execute = null;
        if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
          can_execute = true;
        }
        vm.can_execute = can_execute === null ? false : can_execute;
      }, function() {
        vm.doc_loading = false;
      });
    };
    rollbackDoc = function() {
      var confirm, options;
      if ((angular.isUndefined(vm.document._id)) || (!vm.preRollback())) {
        return;
      }
      options = {
        classes: {
          description: 'text-danger'
        }
      };
      confirm = confirmModal.open('Откат', 'Вы уверены что хотите продолжить? Все связанные данные будут отменены и документ примет статус "Отменен"', options);
      confirm.result.then(function() {
        RequestService.post('doc.rollback', {
          document_type: vm.doc_type.id,
          document: {
            id: vm.document._id
          }
        }).then(function(result) {
          getDoc();
        });
      });
    };
    commitDoc = function() {
      var confirm, options;
      if ((angular.isUndefined(vm.document._id)) || (!vm.preSave()) || (!vm.preCommit())) {
        return;
      }
      options = {
        classes: {
          description: 'text-danger'
        }
      };
      confirm = confirmModal.open('Применить', 'Вы уверены что хотите продолжить?', options);
      confirm.result.then(function() {
        var params;
        params = {
          document_type: vm.document.document_type,
          document: vm.document
        };
        RequestService.post('doc.approve', params).then(function(result) {
          getDoc();
        });
      });
    };
    approve = function() {
      var confirm, options;
      if (angular.isUndefined(vm.document)) {
        return;
      }
      options = {
        comment: true
      };
      confirm = confirmModal.open('Одобрить', null, options);
      confirm.result.then(function(result) {
        var params;
        params = {
          document_type: vm.document.document_type,
          approve: true,
          comment: result.comment,
          document: vm.document
        };
        RequestService.post('doc.approve', params).then(function(result) {
          getDoc();
        });
      });
    };
    reject = function() {
      var confirm, options;
      if (angular.isUndefined(vm.document)) {
        return;
      }
      options = {
        comment: true
      };
      confirm = confirmModal.open('Отклонить', null, options);
      confirm.result.then(function(result) {
        var params;
        params = {
          document_type: vm.document.document_type,
          approve: false,
          comment: result.comment,
          document: vm.document
        };
        RequestService.post('doc.approve', params).then(function(result) {
          getDoc();
        });
      });
    };
    execute = function() {
      var confirm, options;
      if (angular.isUndefined(vm.document)) {
        return;
      }
      options = {
        comment: true
      };
      confirm = confirmModal.open('Исполнить', null, options);
      confirm.result.then(function(comment) {
        var params;
        params = {
          document_type: vm.document.document_type,
          comment: comment,
          document: vm.document
        };
        RequestService.post('doc.approve', params).then(function(result) {
          getDoc();
        });
      });
    };
    send = function() {
      var confirm, options;
      if (angular.isUndefined(vm.document)) {
        return;
      }
      options = {
        classes: {
          description: 'text-info'
        }
      };
      confirm = confirmModal.open('Отправить', 'Копия документа будет отправлен контрагенту как входящий.', options);
      confirm.result.then(function(comment) {
        var params;
        params = {
          document_type: vm.document.document_type,
          document: vm.document
        };
        RequestService.post('doc.send', params).then(function(result) {
          getDoc();
        });
      });
    };
    print = function() {
      var obj;
      if (!vm.document || !vm.document.document_type || !vm.document._id || vm.printing) {
        return;
      }
      vm.printing = true;
      return ReportPrint.print("DOC_" + vm.document.document_type, (
        obj = {},
        obj["DOC_" + vm.document.document_type] = {
          document_id: vm.document._id
        },
        obj
      )).then(function() {
        vm.printing = false;
      }, function(data) {
        vm.printing = false;
        if (!data.result && data.ok === false) {
          return toastr.error(data.message);
        }
      });
    };
    canCommit = function() {
      var can_commit;
      can_commit = false;
      if ((angular.isDefined(vm.document)) && (angular.isDefined($scope.app.ua)) && (angular.isDefined(vm.document._id)) && vm.document.data.user_id === $scope.app.ua.id && vm.document.document_status === 'draft') {
        can_commit = true;
      }
      can_commit = vm.saving === true ? false : can_commit;
      return can_commit;
    };
    canRollback = function() {
      var can_rollback;
      can_rollback = false;
      if ((angular.isDefined(vm.document)) && (angular.isDefined($scope.app.ua)) && (angular.isDefined(vm.document._id)) && vm.document.data.user_id === $scope.app.ua.id && vm.document.document_status === 'committed') {
        can_rollback = true;
      }
      can_rollback = vm.saving === true ? false : can_rollback;
      return can_rollback;
    };
    canEdit = function() {
      if (!vm.document || !vm.document.data) {
        return false;
      }
      return vm.document.data.user_id === 0 || ($scope.app.ua && vm.document.data.user_id === $scope.app.ua.id) || vm.can_approve || vm.can_execute;
    };
    editDoc = function() {
      $state.go('app.docs.entry', {
        id: vm.document._id,
        type: vm.document.document_type
      });
    };
    $scope.$on('$destroy', function() {
      return $uibModalStack.dismiss('fsa destroy');
    });
    hotkeys.bindTo($scope).add({
      combo: 'r',
      description: 'Обновить',
      callback: getDoc
    }).add({
      combo: 'p',
      description: 'Распечатать',
      callback: print
    });
    vm.getDoc = getDoc;
    vm.editDoc = editDoc;
    vm.rollback = rollbackDoc;
    vm.commit = commitDoc;
    vm.approve = approve;
    vm.reject = reject;
    vm.execute = execute;
    vm.send = send;
    vm.canCommit = canCommit;
    vm.canRollback = canRollback;
    vm.canEdit = canEdit;
    vm.preSave = function() {
      return true;
    };
    vm.preCommit = function() {
      return true;
    };
    vm.preRollback = function() {
      return true;
    };
    vm.postGet = function() {};
    getDoc();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DocsEntryController', function(hotkeys, db, $scope, RequestService, $state, $stateParams, toastr, $uibModal, $uibModalStack, confirmModal) {
    var approve, backToList, canCommit, canRollback, canSave, commitDoc, doc_type, execute, getDoc, i, len, ref, reject, rollbackDoc, saveDoc, vm;
    vm = this;
    vm.doc_id = $stateParams.id;
    ref = $scope.docs.doc_types;
    for (i = 0, len = ref.length; i < len; i++) {
      doc_type = ref[i];
      if (doc_type.id === $stateParams.type) {
        vm.doc_type = doc_type;
      }
    }
    if (angular.isDefined(vm.doc_type)) {
      vm.document = {
        document_type: vm.doc_type.id,
        approval: {
          required: false
        },
        data: {
          products: []
        }
      };
      vm.template = "app/docs/" + vm.doc_type.id + "/edit.html";
    } else {
      $state.go('app.docs.new');
      return;
    }
    getDoc = function() {
      var filter;
      if (angular.isUndefined(vm.doc_id) || vm.doc_id === '') {
        return;
      }
      filter = {
        id: vm.doc_id,
        document_type: $stateParams.type,
        with_related: true
      };
      vm.doc_loading = true;
      RequestService.post('doc.get', filter).then(function(result) {
        var approval_role, approval_user, can_approve, can_execute, j, k, l, len1, len2, len3, ref1, ref2, ref3;
        vm.doc_loading = false;
        vm.document_origin = angular.copy(result.doc);
        vm.document = result.doc;
        vm.template = "app/docs/" + vm.document.document_type + "/edit.html";
        ref1 = $scope.docs.doc_types;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          doc_type = ref1[j];
          if (doc_type.id === vm.document.document_type) {
            vm.doc_type = doc_type;
          }
        }
        vm.postGet();
        can_approve = null;
        if (vm.document.document_status === 'approval') {
          ref2 = vm.document.approval.approval_roles;
          for (k = 0, len2 = ref2.length; k < len2; k++) {
            approval_role = ref2[k];
            if ((angular.isUndefined(approval_role.approved)) && $scope.app.uc.roles_id.indexOf(approval_role.role_id) > -1) {
              if (angular.isUndefined(approval_role.approval_users)) {
                can_approve = true;
              } else {
                ref3 = approval_role.approval_users;
                for (l = 0, len3 = ref3.length; l < len3; l++) {
                  approval_user = ref3[l];
                  if (approval_user.user_id === $scope.app.ua.id) {
                    can_approve = false;
                    break;
                  }
                }
                if (can_approve === null) {
                  can_approve = true;
                }
              }
            }
          }
        }
        vm.can_approve = can_approve === null ? false : can_approve;
        can_execute = null;
        if (vm.document.document_status === 'approved' && vm.document.data.executor_id === $scope.app.ua.id) {
          can_execute = true;
        }
        vm.can_execute = can_execute === null ? false : can_execute;
      }, function() {
        vm.doc_loading = false;
      });
    };
    saveDoc = function(no_confirm) {
      var confirm, options;
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if ((angular.isDefined(vm.document._id)) && vm.document.document_status !== 'draft' && !no_confirm) {
        options = {
          classes: {
            description: 'text-danger'
          }
        };
        confirm = confirmModal.open('Сохранение', 'Вы уверены что хотите продолжить? После сохранения документ примет статус "черновик" и все одобрения отменятся', options);
        confirm.result.then(function(result) {
          vm.saving = false;
          saveDoc(true);
        }, function() {
          return vm.saving = false;
        });
        return;
      }
      if (!vm.preSave()) {
        vm.saving = false;
        return;
      }
      RequestService.post('doc/save', {
        document_type: vm.document.document_type,
        document: vm.document
      }).then(function(result) {
        $state.go('app.docs.view', {
          id: result.id,
          type: vm.document.document_type
        });
        vm.saving = false;
      }, function() {
        vm.saving = false;
      });
    };
    rollbackDoc = function() {
      var confirm, options;
      if ((angular.isUndefined(vm.document._id)) || (!vm.preRollback())) {
        return;
      }
      options = {
        classes: {
          description: 'text-danger'
        }
      };
      confirm = confirmModal.open('Откат', 'Вы уверены что хотите продолжить? Все связанные данные будут отменены и документ примет статус "Отменен"', options);
      confirm.result.then(function(result) {
        RequestService.post('doc.rollback', {
          document_type: vm.doc_type.id,
          document: {
            id: vm.document._id
          }
        }).then(function(result) {
          getDoc();
        });
      });
    };
    commitDoc = function() {
      var confirm, options;
      if ((angular.isUndefined(vm.document._id)) || (!vm.preSave()) || (!vm.preCommit())) {
        return;
      }
      options = {
        classes: {
          description: 'text-danger'
        }
      };
      confirm = confirmModal.open('Применить', 'Вы уверены что хотите продолжить?', options);
      confirm.result.then(function() {
        var params;
        params = {
          document_type: vm.document.document_type,
          document: vm.document
        };
        RequestService.post('doc.approve', params).then(function(result) {
          $state.go('app.approval.view', {
            id: vm.document._id,
            type: vm.document.document_type
          });
        });
      });
    };
    approve = function() {
      var confirm, options;
      if (angular.isUndefined(vm.document)) {
        return;
      }
      if (!vm.preSave()) {
        vm.saving = false;
        return;
      }
      options = {
        comment: true
      };
      confirm = confirmModal.open('Одобрить', null, options);
      confirm.result.then(function(comment) {
        var params;
        params = {
          document_type: vm.document.document_type,
          approve: true,
          comment: comment,
          document: vm.document
        };
        RequestService.post('doc.approve', params).then(function(result) {
          $state.go('app.approval.view', {
            id: vm.document._id,
            type: vm.document.document_type
          });
        });
      });
    };
    reject = function() {
      var confirm, options;
      if (angular.isUndefined(vm.document)) {
        return;
      }
      if (!vm.preSave()) {
        vm.saving = false;
        return;
      }
      options = {
        comment: true
      };
      confirm = confirmModal.open('Отклонить', null, options);
      confirm.result.then(function(comment) {
        var params;
        params = {
          document_type: vm.document.document_type,
          approve: false,
          comment: comment,
          document: vm.document
        };
        RequestService.post('doc.approve', params).then(function(result) {
          $state.go('app.approval.view', {
            id: vm.document._id,
            type: vm.document.document_type
          });
        });
      });
    };
    execute = function() {
      var confirm, options;
      if (angular.isUndefined(vm.document)) {
        return;
      }
      if (!vm.preSave()) {
        vm.saving = false;
        return;
      }
      options = {
        comment: true
      };
      confirm = confirmModal.open('Исполнить', null, options);
      confirm.result.then(function(comment) {
        var params;
        params = {
          document_type: vm.document.document_type,
          comment: comment,
          document: vm.document
        };
        RequestService.post('doc.approve', params).then(function(result) {
          $state.go('app.approval.view', {
            id: vm.document._id,
            type: vm.document.document_type
          });
        });
      });
    };
    canSave = function() {
      var can_save;
      can_save = false;
      if (angular.isUndefined(vm.document)) {
        return can_save;
      }
      if (!vm.doc_loading && angular.isUndefined(vm.document._id)) {
        can_save = true;
      } else {
        if ((vm.document.data.user_id === 0 || vm.document.data.user_id === $scope.app.ua.id) && vm.document.document_status !== 'committed' && vm.document.document_status !== 'canceled') {
          can_save = true;
        }
      }
      can_save = vm.saving === true ? false : can_save;
      return can_save;
    };
    canCommit = function() {
      var can_commit;
      can_commit = false;
      if ((angular.isDefined(vm.document)) && (angular.isDefined(vm.document._id)) && vm.document.data.user_id === $scope.app.ua.id && vm.document.document_status === 'draft') {
        can_commit = true;
      }
      can_commit = vm.saving === true ? false : can_commit;
      return can_commit;
    };
    canRollback = function() {
      var can_rollback;
      can_rollback = false;
      if ((angular.isDefined(vm.document)) && (angular.isDefined(vm.document._id)) && vm.document.data.user_id === $scope.app.ua.id && vm.document.document_status === 'committed') {
        can_rollback = true;
      }
      can_rollback = vm.saving === true ? false : can_rollback;
      return can_rollback;
    };
    backToList = function() {
      var confirm, options;
      if (!angular.equals(vm.document, vm.document_origin)) {
        options = {
          classes: {
            description: 'text-danger'
          }
        };
        confirm = confirmModal.open(null, 'Вы уверены что хотите перейти? Изменения не будут сохранены.', options);
        confirm.result.then(function() {
          $state.go('app.docs.list');
        });
      } else {
        $state.go('app.docs.list');
      }
    };
    vm.getDoc = getDoc;
    vm.save = saveDoc;
    vm.rollback = rollbackDoc;
    vm.commit = commitDoc;
    vm.approve = approve;
    vm.reject = reject;
    vm.execute = execute;
    vm.canSave = canSave;
    vm.canCommit = canCommit;
    vm.canRollback = canRollback;
    vm.backToList = backToList;
    vm.preSave = function() {
      return true;
    };
    vm.preCommit = function() {
      return true;
    };
    vm.preRollback = function() {
      return true;
    };
    vm.postGet = function() {};
    getDoc();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DocsController', function(RequestService, AppStorage) {
    var vm;
    vm = this;
    vm.doc_types = AppStorage.getObject('doc_types') || [];
    RequestService.post('doc/all').then(function(result) {
      vm.doc_types = result.doc_types;
      AppStorage.setObject('doc_types', vm.doc_types);
    });
  }).controller('DocsListController', function(hotkeys, $scope, $state, RequestService) {
    var add, edit, getDocs, gridOptions, remove, view, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 50;
    gridOptions = {
      noUnselect: true,
      paginationPageSizes: [50, 100, 500],
      paginationPageSize: 50,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'document_type_value.data.name',
          pinnedLeft: true,
          displayName: 'Тип'
        }, {
          name: 'document_status_value.data.name',
          pinnedLeft: true,
          displayName: 'Статус'
        }, {
          name: 'title',
          pinnedLeft: true,
          displayName: 'Наименование'
        }, {
          name: 'short_desc',
          pinnedLeft: true,
          displayName: 'Описание'
        }, {
          name: '_created',
          pinnedLeft: true,
          displayName: 'Дата',
          cellTemplate: '<div class="ui-grid-cell-contents">{{grid.getCellValue(row,col) | amDateFormat:"DD.MM.YYYY HH:mm"}}</div>'
        }, {
          name: 'company.name',
          displayName: 'Компания',
          visible: false
        }
      ],
      events: {
        onRowSelect: function(row) {
          vm.selected_doc = row.entity;
        },
        onPageSelect: function(page, size) {
          vm.offset = page * size;
          vm.limit = size;
          getDocs();
        }
      },
      appScopeProvider: {
        onDoubleClick: function(row) {
          view(row.entity);
        }
      },
      rowTemplate: '<div ng-dblclick="grid.appScope.onDoubleClick(row)" ng-repeat="col in colContainer.renderedColumns" class="ui-grid-cell" ui-grid-cell></div>'
    };
    getDocs = function() {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        filter: vm.filter || {}
      };
      RequestService.post('doc.listing', filter).then(function(result) {
        vm.gridOptions.data = result.docs;
        vm.gridOptions.totalItems = result.count;
        delete vm.selected_doc;
      });
    };
    add = function() {
      $state.go('app.docs.new');
    };
    view = function(row) {
      $state.go('app.docs.view', {
        id: row._id,
        type: row.document_type
      });
    };
    edit = function() {
      $state.go('app.docs.entry', {
        id: vm.selected_doc._id,
        type: vm.selected_doc.document_type
      });
    };
    remove = function() {};
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить новый документ',
      callback: add
    }).add({
      combo: 'r',
      description: 'Обновить данные',
      callback: getDocs
    });
    vm.gridOptions = gridOptions;
    vm.add = add;
    vm.view = view;
    vm.edit = edit;
    vm.remove = remove;
    getDocs();
  }).controller('DocsNewController', function($scope) {}).controller('CommentsController', function($scope, RequestService) {
    var addComment, getComments, vm;
    vm = this;
    getComments = function() {
      var filter;
      filter = {
        with_related: true,
        filter: {
          document_id: $scope.documentId
        },
        order_by: ['_created desc']
      };
      RequestService.post('comment.list', filter).then(function(result) {
        vm.comments = result.docs;
      });
    };
    addComment = function() {
      var comment_data;
      if (angular.isUndefined($scope.documentId)) {
        return;
      }
      comment_data = {
        document_id: $scope.documentId,
        data: {
          comment_type: 'comment',
          comment: vm.comment
        }
      };
      RequestService.post('comment.save', comment_data).then(function(result) {
        delete vm.comment;
        getComments();
      });
    };
    $scope.$watch('documentId', function() {
      if (angular.isDefined($scope.documentId)) {
        return getComments();
      }
    });
    vm.getComments = getComments;
    vm.addComment = addComment;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DictionaryController', function($scope, RequestService, $state, $stateParams, toastr, $uibModal) {
    'ngInject';
    var editDictionary, getDictionaries, listTables, newDictionary, removeConfirmAction, removeDictionary, roleFilter, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 50;
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [50, 100, 500],
      paginationPageSize: 50,
      useExternalPagination: true,
      columnDefs: []
    };
    listTables = function() {
      RequestService.post('dictionary.tables_list').then(function(result) {
        vm.tables = result.tables;
        if ((angular.isUndefined(vm.active_table)) && vm.tables.length > 0) {
          vm.active_table = vm.tables[0];
        }
      });
    };
    getDictionaries = function() {
      var filter;
      if (angular.isUndefined(vm.active_table)) {
        listDictionaries();
        return;
      }
      filter = {
        type: vm.active_table.table,
        offset: vm.offset,
        limit: vm.limit,
        with_related: true
      };
      RequestService.post('dictionary.listing', filter).then(function(result) {
        delete vm.selected_dictionary;
        vm.gridOptions.data = result.docs;
        vm.gridOptions.totalItems = result.count;
      });
    };
    newDictionary = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/dictionary/modal.html',
        controller: 'DictionaryEditController',
        controllerAs: 'edit',
        size: 'lg',
        resolve: {
          table: vm.active_table,
          dictionary: void 0
        }
      });
      editModal.result.then(function() {
        return getDictionaries();
      });
    };
    editDictionary = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/dictionary/modal.html',
        controller: 'DictionaryEditController',
        controllerAs: 'edit',
        size: 'lg',
        resolve: {
          table: vm.active_table,
          dictionary: angular.copy(vm.selected_dictionary)
        }
      });
      editModal.result.then(function() {
        return getDictionaries();
      });
    };
    roleFilter = function(table) {
      if (table.role_requires <= $scope.app.ua.role) {
        return true;
      }
      return false;
    };
    removeDictionary = function() {
      vm.selected_dictionary.type = vm.active_table.table;
      return RequestService.post('dictionary.remove', vm.selected_dictionary).then(function(data) {
        getDictionaries();
      });
    };
    removeConfirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить справочник"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeDictionary();
        }
      });
    };
    $scope.$watch('dictionary.active_table', function() {
      var column;
      if (angular.isDefined(vm.active_table)) {
        vm.gridOptions.columnDefs = (function() {
          var i, len, ref, results;
          ref = vm.active_table.columns;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            column = ref[i];
            results.push({
              name: column.name,
              displayName: column.displayName
            });
          }
          return results;
        })();
        vm.grid = '<paged-table options="dictionary.gridOptions" disable-search="true"></paged-table>';
        getDictionaries();
      }
    });
    $scope.$on('data-selected', function(event, row) {
      vm.selected_dictionary = row.entity;
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getDictionaries();
    });
    vm.roleFilter = roleFilter;
    vm.getDictionaries = getDictionaries;
    vm.newDictionary = newDictionary;
    vm.editDictionary = editDictionary;
    vm.removeDictionary = removeDictionary;
    vm.removeConfirmAction = removeConfirmAction;
    vm.grid = '';
    listTables();
  }).controller('DictionaryEditController', function($scope, RequestService, table, dictionary, $uibModalInstance) {
    'ngInject';
    var saveDictionary, vm;
    vm = this;
    if (angular.isUndefined(table)) {
      $uibModalInstance.dismiss('cancel');
      return;
    }
    vm.template = 'app/dictionary/' + (table.table.toLowerCase()) + '/edit.html';
    if (angular.isUndefined(dictionary)) {
      dictionary = {
        type: table.table
      };
    }
    vm.table = table;
    vm.dictionary = dictionary;
    saveDictionary = function() {
      if (vm.preSave() === false) {
        return;
      }
      vm.dictionary.type = vm.table.table;
      RequestService.post('dictionary.save', vm.dictionary).then(function(result) {
        $uibModalInstance.close(result);
      });
    };
    vm.preSave = function() {};
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.saveDictionary = saveDictionary;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DefaultsController', function($scope, $state, $stateParams, toastr, hotkeys, RequestService, $uibModal) {
    'ngInject';
    var editDefault, getDefaults, vm;
    vm = this;
    vm.gridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Тип'
        }, {
          name: 'data.approval.required',
          displayName: 'Обьязательное одобрение'
        }, {
          name: 'data.data.executor.username',
          displayName: 'Исполнитель'
        }
      ]
    };
    getDefaults = function() {
      vm.doc_types = [];
      RequestService.post('doc/all').then(function(result) {
        var doc_type, filter;
        delete vm.selected_default;
        vm.doc_types = result.doc_types;
        vm.gridOptions.data = (function() {
          var i, len, ref, results;
          ref = vm.doc_types;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            doc_type = ref[i];
            results.push({
              document_type: doc_type.id,
              name: doc_type.name
            });
          }
          return results;
        })();
        filter = {
          with_related: true
        };
        return RequestService.post('defaults.listing', filter).then(function(result) {
          var doc_default, i, item, len, position, ref, ref1;
          ref = result.docs;
          for (i = 0, len = ref.length; i < len; i++) {
            doc_type = ref[i];
            position = -1;
            ref1 = vm.gridOptions.data;
            for (item in ref1) {
              doc_default = ref1[item];
              if (doc_default.document_type === doc_type.document_type) {
                doc_type.name = doc_default.name;
                position = item;
                break;
              }
            }
            if (position > -1) {
              vm.gridOptions.data.splice(position, 1, doc_type);
            }
          }
        });
      });
    };
    editDefault = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/defaults/edit.html',
        controller: 'DefaultsEditController',
        controllerAs: 'defaults',
        size: 'lg',
        resolve: {
          doc_types: function() {
            return angular.copy(vm.doc_types);
          },
          doc_default: angular.copy(vm.selected_default)
        }
      });
      editModal.result.then(function() {
        return getDefaults();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_default = row.entity;
    });
    hotkeys.bindTo($scope).add({
      combo: 'r',
      description: 'Обновить',
      callback: function() {
        return getDefaults();
      }
    });
    vm.getDefaults = getDefaults;
    vm.editDefault = editDefault;
    getDefaults();
  }).controller('DefaultsEditController', function($scope, $state, $stateParams, toastr, RequestService, doc_types, doc_default, $uibModalInstance) {
    'ngInject';
    var addApprovalRole, delApprovalRole, putDefault, vm;
    vm = this;
    vm.doc_types = doc_types;
    vm.doc_default = doc_default;
    putDefault = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (vm.doc_default.data.approval && vm.doc_default.data.approval.required === true) {
        if (vm.doc_default.data.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return;
        }
        if (angular.isUndefined(vm.doc_default.data.approval.approval_roles) || vm.doc_default.data.approval.approval_roles.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return;
        }
      } else {
        delete vm.doc_default.data.approval;
      }
      RequestService.post('defaults.save', vm.doc_default).then(function(result) {
        vm.saving = false;
        $uibModalInstance.close(result);
      }, function() {
        return vm.saving = false;
      });
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.doc_default.data.approval.roles_id ? vm.doc_default.data.approval.roles_id : vm.doc_default.data.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.doc_default.data.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.doc_default.data.approval.roles_id.indexOf(role_id);
      if (index > -1) {
        vm.doc_default.data.approval.roles_id.splice(index, 1);
      }
    };
    vm.putDefault = putDefault;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DashboardController', function($rootScope, $scope, $state, RequestService) {
    'ngInject';
    var getCurrency, getNews, getPolicies, getRegulations, goToNewsPage, onDblClick, vm;
    vm = this;
    vm.today = new Date();
    vm.api = $rootScope.api;
    vm.offset = 0;
    vm.limit = 20;
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
    };
    vm.policiesGridOptions = {
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'day',
          displayName: 'Истекает через N дней'
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent',
          displayName: 'Сотрудник'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    getNews = function() {
      var filter;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.with_related = true;
      filter.order_by = ["create_date DESC"];
      filter.limit = 3;
      RequestService.post('news.listing', filter).then(function(response) {
        vm.news = response.docs;
      }, function(response) {});
    };
    getPolicies = function() {
      var filter;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.report_period = ['Оформлен'];
      RequestService.post('policies.list_period', filter).then(function(response) {
        vm.policiesGridOptions.data = angular.copy(response.docs);
        vm.policiesGridOptions.totalItems = response.count;
      }, function(response) {});
    };
    getCurrency = function() {
      RequestService.post('currencynbkr.get_nbkr_rate', {
        date: vm.today
      }).then(function(response) {
        return vm.currencies = response.results;
      });
    };
    goToNewsPage = function(item) {
      $state.go('app.news.view', {
        news: item
      });
    };
    getRegulations = function() {
      RequestService.post('regulations.listing').then(function(result) {
        return vm.regulations = result.list;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.getNews = getNews;
    vm.goToNewsPage = goToNewsPage;
    vm.getCurrency = getCurrency;
    vm.getRegulations = getRegulations;
    vm.getPolicies = getPolicies;
    getCurrency();
    getNews();
    getRegulations();
    getPolicies();
  });

}).call(this);



(function() {
  angular.module('fsa').directive('pagedTable', function($location, $rootScope, store) {
    var link;
    link = function(scope, el, attr) {
      var localStore;
      if (angular.isUndefined(scope.options)) {
        scope.options = {};
      }
      localStore = store.getNamespacedStore($location.path());
      scope.options.enableRowSelection = scope.options.enableRowSelection || true;
      scope.options.enableRowHeaderSelection = scope.options.enableRowHeaderSelection || false;
      scope.options.multiSelect = scope.options.multiSelect || false;
      scope.options.saveWidths = scope.options.saveWidths || true;
      scope.options.enableGridMenu = scope.options.enableGridMenu || true;
      scope.options.gridMenuCustomItems = scope.options.gridMenuCustomItems || [];
      scope.options.gridMenuCustomItems.push({
        title: 'Сохранить',
        action: function() {
          return localStore.set('state', scope.options.gridApi.saveState.save());
        },
        order: 210
      });
      scope.options.onRegisterApi = function(gridApi) {
        scope.options.gridApi = gridApi;
        gridApi.selection.on.rowSelectionChanged(scope, function(row) {
          return $rootScope.$broadcast('data-selected', row);
        });
        gridApi.cellNav.on.navigate(scope, function(newRowCol, oldRowCol) {
          return gridApi.selection.selectRow(newRowCol.row.entity);
        });
        if (gridApi.pagination) {
          gridApi.pagination.on.paginationChanged(scope, function(newPage, pageSize) {
            return $rootScope.$broadcast('get-page', {
              page: newPage - 1,
              size: pageSize
            });
          });
        }
      };
      scope.$watch('query', function() {
        return $rootScope.$broadcast('data-search', {
          query: scope.query
        });
      });
      scope.$on('ngGridEventData', function(id) {
        var state;
        state = localStore.get('state');
        if (state) {
          scope.options.gridApi.saveState.restore(scope, state);
          return;
        }
      });
    };
    return {
      restrict: 'E',
      link: link,
      transclude: true,
      scope: {
        options: '=',
        disablePaging: '@',
        disableSearch: '@',
        enableEdit: '@'
      },
      template: function(elem, attr) {
        var editing, html, pagination;
        editing = attr.enableEdit ? "ui-grid-edit" : "";
        pagination = attr.disablePaging ? "" : "ui-grid-pagination";
        html = "<input ng-hide=\"disableSearch\" class=\"form-control\" ng-model=\"query\" ng-model-options=\"{debounce:200}\" placeholder=\"Поиск\" autofocus> <div ui-grid=\"options\" class=\"grid\" ui-grid-selection ui-grid-resize-columns ui-grid-save-state ui-grid-cellNav " + editing + " " + pagination + "></div> </div>";
        return html;
      }
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('fsaSrc', function($rootScope, $compile) {
    return {
      restrict: 'A',
      scope: {
        fsaSrc: '@'
      },
      link: function(scope, element, attr) {
        if (!attr.ngSrc) {
          attr.$set('ng-src', $rootScope.api + scope.fsaSrc);
          $compile(element)(scope);
        }
      }
    };
  });

}).call(this);



(function() {
  angular.module('fsa').service('ProductService', function(db) {
    var service;
    service = this;
    return service;
  });

}).call(this);



(function() {
  angular.module('fsa').directive('productSelect', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        productId: '=',
        asText: '=?',
        productUnitId: '=?',
        ngDisabled: '=?'
      },
      controller: function($scope, RequestService, $uibModal) {
        'ngInject';
        var vm;
        vm = this;
        vm.openSelectProduct = function() {
          var editModal;
          editModal = $uibModal.open({
            templateUrl: 'app/product/select.html',
            controller: 'ProductSelectController',
            controllerAs: 'product',
            size: 'lg'
          });
          editModal.result.then(function(result) {
            vm.selected = result;
          });
        };
        vm.searchProduct = function(search_name) {
          return RequestService.post('product.listing', {
            limit: 10,
            filter: {
              name: search_name
            }
          }).then(function(result) {
            return result.docs;
          });
        };
        $scope.$watch('productId', function() {
          if ((angular.isDefined($scope.productId)) && vm.watch_prevent !== true) {
            RequestService.post('product.listing', {
              filter: {
                _id: $scope.productId
              }
            }).then(function(result) {
              if (result.docs.length === 1) {
                vm.watch_prevent = true;
                vm.selected = result.docs[0];
              }
            });
          }
          vm.watch_prevent = false;
        });
        $scope.$watch('product.selected', function() {
          if ((angular.isDefined(vm.selected)) && vm.watch_prevent !== true) {
            vm.watch_prevent = true;
            $scope.productId = vm.selected._id;
            $scope.productUnitId = (angular.isDefined(vm.selected)) && (angular.isObject(vm.selected)) && (angular.isDefined(vm.selected.data)) ? vm.selected.data.unit_id : void 0;
          }
          vm.watch_prevent = false;
        });
      },
      controllerAs: 'product',
      link: function(scope, element, attr) {},
      template: '<div><div ng-hide="asText===true" class="input-group"> <div class="input-group-addon" ng-show="loadingProducts"> <span class="glyphicon glyphicon-refresh"></span> </div> <div class="input-group-addon" ng-show="noProducts"> <span class="glyphicon glyphicon-remove text-danger"></span> </div> <input type="text" ng-model="product.selected" class="form-control" uib-typeahead="product as product.name for product in product.searchProduct($viewValue)" typeahead-loading="loadingProducts" typeahead-no-results="noProducts" ng-disabled="ngDisabled"> <div class="input-group-btn"> <button class="btn btn-primary" type="button" ng-click="product.openSelectProduct()" ng-disabled="ngDisabled"> <span class="glyphicon glyphicon-paperclip"></span> </button> </div> </div> <span ng-show="asText===true">{{ product.selected.name }}</span></div>'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('panel', function() {
    var link;
    link = function(scope, el) {
      el.find('.collapse-link').on('click', function() {
        var $BOX_CONTENT, $BOX_PANEL, $ICON;
        $BOX_PANEL = $(this).closest('.panel');
        $ICON = $(this).find('i');
        $BOX_CONTENT = $BOX_PANEL.find('.panel-body');
        if ($BOX_PANEL.attr('style')) {
          $BOX_CONTENT.slideToggle(200, function() {
            return $BOX_PANEL.removeAttr('style');
          });
        } else {
          $BOX_CONTENT.slideToggle(200);
          $BOX_PANEL.css('height', 'auto');
        }
        return $ICON.toggleClass('fa-chevron-up fa-chevron-down');
      });
    };
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        title: '@'
      },
      link: link,
      template: '<div class="wrapper lter b-b "> <div class="panel"> <div class="panel-heading font-bold"> <h2>{{title}}</h2> </div> <div class="panel-body" ng-transclude> </div> </div> </div>'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').service('OpService', function(db) {
    var service;
    service = this;
    service.sale = function(invoice) {
      var docs;
      docs = [
        {
          type: 'sale',
          data: invoice
        }
      ];
      angular.forEach(invoice.products, function(p) {
        return docs.push({
          type: 'fsa_record',
          data: {
            product_id: p.id,
            count: -p.count
          }
        });
      });
      return db.insert(docs);
    };
    service.purchase = function() {
      var docs;
      docs = [
        {
          type: 'purchase',
          data: invoice
        }
      ];
      angular.forEach(invoice.products, function(p) {
        return docs.push({
          type: 'fsa_record',
          data: {
            product_id: p.id,
            count: p.count
          }
        });
      });
      return db.insert(docs);
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('fsa').service('IntermediateDataService', function() {
    var clear, get, savedData, set;
    savedData = null;
    set = function(data) {
      return savedData = data;
    };
    get = function(_default) {
      return savedData || _default;
    };
    clear = function() {
      return savedData = null;
    };
    return {
      set: set,
      get: get,
      clear: clear
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('input', function() {
    var link;
    link = function(scope, element, attr, ngModel) {
      if (attr.type !== 'file' || !ngModel) {
        return;
      }
      element.on('change', function() {
        var file, reader;
        file = element[0].files[0];
        reader = new FileReader();
        reader.onload = function(e) {
          var data;
          data = e.target.result;
          return ngModel.$setViewValue(data);
        };
        reader.readAsBinaryString(file);
      });
    };
    return {
      restrict: 'E',
      link: link,
      require: '?ngModel'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').filter('fileSize', function() {
    var sizes;
    sizes = [[1, 'b'], [1024, 'Kb'], [1024 * 1024, 'Mb'], [1024 * 1024 * 1024, 'Gb']];
    return function(input) {
      var i, l_size, len, out, size;
      input = input || 0;
      out = '';
      for (i = 0, len = sizes.length; i < len; i++) {
        size = sizes[i];
        if (input < size[0] && l_size) {
          out = (input / l_size[0]).toFixed(2) + ' ' + l_size[1];
        } else {
          l_size = size;
        }
      }
      return out;
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('employeeSelect', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        employeeId: '=',
        asText: '=',
        ngDisabled: '=?'
      },
      controller: function($scope, RequestService, $uibModal) {
        'ngInject';
        var vm;
        vm = this;
        vm.openSelectEmployee = function() {
          var editModal;
          editModal = $uibModal.open({
            templateUrl: 'app/employee/select.html',
            controller: 'EmployeeSelectController',
            controllerAs: 'employee',
            size: 'lg'
          });
          editModal.result.then(function(result) {
            vm.selected = result;
          });
        };
        vm.searchEmployee = function(search_name) {
          return RequestService.post('employee.listing', {
            name: search_name,
            limit: 10,
            with_related: true
          }).then(function(result) {
            return result.docs;
          });
        };
        $scope.$watch('employeeId', function() {
          if ((angular.isDefined($scope.employeeId)) && vm.watch_prevent !== true) {
            RequestService.post('employee.listing', {
              with_related: true,
              filter: {
                _id: $scope.employeeId
              }
            }).then(function(result) {
              if (result.docs.length === 1) {
                vm.watch_prevent = true;
                vm.selected = result.docs[0];
              }
            });
          }
          vm.watch_prevent = false;
        });
        $scope.$watch('employee.selected', function() {
          if ((angular.isDefined(vm.selected)) && vm.watch_prevent !== true) {
            vm.watch_prevent = true;
            $scope.employeeId = vm.selected._id;
          }
          vm.watch_prevent = false;
        });
      },
      controllerAs: 'employee',
      link: function(scope, element, attr) {},
      template: '<div class="col-responsive"><div ng-hide="asText===true" class="form-group"> <div class="input-group-addon" ng-show="loadingEmployees"> <span class="glyphicon glyphicon-refresh"></span> </div> <div class="input-group-addon" ng-show="noEmployees"> <span class="glyphicon glyphicon-remove text-danger"></span> </div> <input type="text" ng-model="employee.selected" class="form-control" uib-typeahead="employee as employee.name for employee in employee.searchEmployee($viewValue)" typeahead-loading="loadingEmployees" typeahead-no-results="noEmployees" ng-disabled="ngDisabled"> </div> <span ng-show="asText===true">{{ employee.selected.name }}</span></div>'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('dynamic', function($compile) {
    var link;
    link = function(scope, ele, attrs) {
      scope.$watch(attrs.dynamic, function(html) {
        ele.html(html);
        return $compile(ele.contents())(scope);
      });
    };
    return {
      restrict: 'A',
      replace: true,
      link: link
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('stockDict', function(BObjectService) {
    return {
      restrict: 'A',
      scope: {
        stockDict: '=',
        dictTable: '@',
        dictFilter: '=',
        dictFirstItem: '=',
        dictOptions: '='
      },
      link: function(scope, element, attr) {
        var getDict;
        getDict = function() {
          var filter;
          filter = {
            type: scope.dictTable,
            with_related: true,
            filter: scope.dictFilter
          };
          BObjectService.list(filter.type, filter).then(function(data) {
            var dict, dicts;
            if (angular.isDefined(scope.dictOptions)) {
              if (scope.dictOptions.onlyParents === true) {
                dicts = (function() {
                  var i, len, ref, results;
                  ref = data.docs;
                  results = [];
                  for (i = 0, len = ref.length; i < len; i++) {
                    dict = ref[i];
                    if (dict.parent_id === null || angular.isUndefined(dict.parent_id)) {
                      results.push(dict);
                    }
                  }
                  return results;
                })();
              } else if (scope.dictOptions.onlyChildren === true) {
                dicts = (function() {
                  var i, len, ref, results;
                  ref = data.docs;
                  results = [];
                  for (i = 0, len = ref.length; i < len; i++) {
                    dict = ref[i];
                    if (dict.parent_id !== null && angular.isDefined(dict.parent_id)) {
                      results.push(dict);
                    }
                  }
                  return results;
                })();
              }
              if (angular.isUndefined(dicts)) {
                dicts = angular.copy(data.docs);
              }
            } else {
              dicts = angular.copy(data.docs);
            }
            if (angular.isDefined(scope.dictFirstItem)) {
              dicts.unshift(scope.dictFirstItem);
            }
            scope.stockDict = dicts;
          });
        };
        scope.$watch('dictTable', function(oldVal, newVal) {
          if (newVal !== void 0) {
            getDict();
          }
        });
        scope.$watch('dictFilter', function(oldVal, newVal) {
          if (newVal !== void 0) {
            getDict();
          }
        });
        scope.$watch('dictFirstItem', function(oldVal, newVal) {
          if (newVal !== void 0) {
            getDict();
          }
        });
        scope.$watch('dictOptions', function(oldVal, newVal) {
          if (newVal !== void 0) {
            getDict();
          }
        });
      }
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('documentComment', function() {
    return {
      scope: {
        documentId: '='
      },
      templateUrl: 'app/docs/comments.html',
      controller: 'CommentsController',
      controllerAs: 'comments'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('colResponsive', function() {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      template: '<div class="col col-xs-12 col-sm-4 col-md-4" ng-transclude></div>'
    };
  });

}).call(this);



(function() {
  'use strict';
  angular.module('fsa').service('ClientService', function($http, $rootScope) {
    var clientService;
    clientService = {};
    clientService.find = function(search, limit, type) {
      return $http.post($rootScope.api + 'contractor.find', {
        search: search,
        limit: limit,
        type: type
      });
    };
    clientService.getAddress = function(client_id, type) {
      return $http.post($rootScope.api + 'contractor/get_address', {
        client_id: client_id,
        type: type
      });
    };
    clientService.get = function(client_id) {
      return $http.post($rootScope.api + 'contractor.find', {
        client_id: client_id
      });
    };
    return clientService;
  });

}).call(this);




/**
 * Created by Ilyas on 17/11/20.
 */

(function() {
  'use strict';
  angular.module('fsa').directive('cbsClient', function($compile, ClientService) {
    return {
      restrict: 'AEC',
      scope: {
        modeldisplay: '=?',
        modelret: '=?',
        clientType: '=?',
        modelobject: '=?',
        ngDisabled: '=?',
        ngRequired: '=?'
      },
      link: function(scope) {
        scope.current = 0;
        scope.selected = false;
        scope.da = function(txt) {
          scope.ajaxClass = 'loadImage';
          ClientService.find(txt, 10, scope.clientType).then(function(response) {
            scope.TypeAheadData = response.data.clients;
            scope.ajaxClass = '';
          });
        };
        scope.handleSelection = function(key, val, object) {
          scope.modelret = key;
          scope.modeldisplay = object.last_name + ' ' + object.first_name;
          scope.modelobject = object;
          scope.current = 0;
          scope.selected = true;
        };
        scope.isCurrent = function(index) {
          return scope.current === index;
        };
        scope.setCurrent = function(index) {
          scope.current = index;
        };
        scope.$watch('modelret', function(value) {
          if (value) {
            ClientService.get(value).then(function(response) {
              var client;
              if (response.data.clients.length === 0) {
                scope.modeldisplay = null;
                scope.modelobject = null;
                return;
              }
              client = response.data.clients[0];
              scope.modeldisplay = client.last_name + ' ' + client.first_name;
              scope.modelobject = client;
            });
          } else {
            scope.modeldisplay = null;
            scope.modelobject = null;
          }
        });
      },
      template: '<input type="text" ng-model="modeldisplay" ng-keyup="da(modeldisplay)" class="form-control"  ng-keydown="selected=false" ' + 'style="width:100%;" ng-class="ajaxClass" ng-disabled="ngDisabled" ng-required="ngRequired"> ' + '<div class="list-group table-condensed overlap" ng-hide="!modeldisplay.length || selected" style="width:100%"> ' + '<a href="javascript:;" class="list-group-item noTopBottomPad" ng-repeat="item in TypeAheadData|filter:model  track by $index" ' + 'ng-click="handleSelection(item.id,item.last_name,item)" style="cursor:pointer" ' + 'ng-class="{active:isCurrent($index)}" ' + 'ng-mouseenter="setCurrent($index)"> ' + ' {{item.id}} ' + '<i>{{item.last_name}} {{item.first_name}}</i> ' + '</a> ' + '</div> ' + '</input> '
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('CurrencyController', function(RequestService, ReportService, $scope, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deleteCurrency, getCurrency, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.currencyGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'currency_date',
          displayName: 'День',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'currency',
          displayName: 'Валюта'
        }, {
          name: 'rate',
          displayName: 'Ставка'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      }
    };
    getCurrency = function() {
      var filter;
      filter = {
        filter: {}
      };
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["currency_date DESC"];
      RequestService.post('currencyrate.listing', filter).then(function(result) {
        vm.currencyGridOptions.data = result.docs;
        vm.currencyGridOptions.totalItems = result.count;
      });
    };
    deleteCurrency = function() {
      RequestService.post('currencyrate.delete', vm.selected_currency).then(function(data) {
        toastr.success('Операция выполнена успешно');
        getCurrency();
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот курс валют"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deleteCurrency();
        }
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_currency = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getCurrency();
    });
    vm.getCurrency = getCurrency;
    vm.deleteCurrency = deleteCurrency;
    vm.confirmAction = confirmAction;
    getCurrency();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('CompanyController', function($scope, RequestService, Session, $rootScope, AppStorage, $uibModal) {
    'ngInject';
    var editCompany, getCompanies, newCompany, setActiveCompany, vm;
    vm = this;
    vm.companiesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'short_name',
          displayName: 'Короткое имя'
        }, {
          name: 'code',
          displayName: 'Код'
        }, {
          name: 'data.addresses[0]',
          displayName: 'Адреса'
        }, {
          name: 'data.phones[0]',
          displayName: 'Телефон'
        }, {
          name: 'data.emails[0]',
          displayName: 'E-mail'
        }, {
          name: 'data.manager',
          displayName: 'Менеджер'
        }, {
          name: 'company_type',
          displayName: 'Тип Компании'
        }, {
          name: 'data.description',
          displayName: 'Описание'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'data.logo',
          displayName: 'Логотип',
          visible: false
        }, {
          name: 'data.industry',
          displayName: 'Отрасль',
          visible: false
        }, {
          name: 'data.status',
          displayName: 'Статус',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата добавления',
          visible: false
        }, {
          name: 'edit_user_id',
          displayName: 'Изменивший',
          visible: false
        }
      ]
    };
    getCompanies = function() {
      var filter;
      filter = {
        with_related: true,
        filter: {
          company_type: 'insurance_company'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        delete vm.selected_company;
        vm.companiesGridOptions.data = data.docs;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_company = angular.copy(row.entity);
    });
    setActiveCompany = function(user_company) {
      RequestService.post('user.set_company', user_company).then(function(result) {
        Session.setCompany(angular.copy(user_company));
        return $rootScope.$broadcast('set-active-company');
      });
    };
    newCompany = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/company/edit.html',
        controller: 'CompanyEditController',
        controllerAs: 'company',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: void 0
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    editCompany = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/company/edit.html',
        controller: 'CompanyEditController',
        controllerAs: 'company',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: vm.selected_company
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    vm.getCompanies = getCompanies;
    vm.setActiveCompany = setActiveCompany;
    vm.newCompany = newCompany;
    vm.editCompany = editCompany;
    getCompanies();
  }).controller('CompanyEditController', function($scope, RequestService, Session, email_mask, $uibModalInstance, company, toastr, flowFactory) {
    'ngInject';
    var addAddress, addAssistance, addEmail, addPhone, addStaff, addWebsite, deleteAddress, deleteAssistance, deleteEmail, deletePhone, deleteStaff, deleteWebsite, getUsers, handleFileSelect, putCompany, upload, vm;
    vm = this;
    vm.ua = Session.getUser();
    vm.users = [];
    vm.branches = [];
    vm.companiesAsAgents = [];
    vm.agentList = [];
    vm.company = '';
    vm.image = '';
    vm.result_image = '';
    vm.currflow = '';
    if (company === null || company === void 0) {
      vm.company = {
        data: {
          assistants: []
        },
        agents_id: [],
        staff: [],
        company_type: "insurance_company"
      };
    } else {
      vm.company = company;
    }
    upload = function() {
      if (!vm.result_image) {
        console.log("vm.result_image == null");
        return;
      }
      RequestService.post('upload/company/' + vm.company._id, {
        file: vm.result_image
      }).then(function(result) {
        vm.company.data.image = 'image/' + result.file;
        vm.currflow.cancel();
        vm.currflow = '';
      });
    };
    handleFileSelect = function(event, $flow, flowFile) {
      var image, reader;
      vm.currflow = $flow;
      if (!flowFile.file.type.startsWith('image/')) {
        toastr.warning('Выберите изображение');
        event.preventDefault();
        return false;
      }
      image = flowFile.file;
      if (angular.isUndefined(image)) {
        return;
      }
      vm.imageLoading = true;
      reader = new FileReader();
      reader.onload = function(event) {
        $scope.$apply(function($scope) {
          vm.imageLoading = false;
          vm.image = event.target.result;
        });
      };
      reader.readAsDataURL(image);
    };
    putCompany = function() {
      console.log(vm.company);
      if (vm.company.name === void 0 || vm.company.name.trim().length === 0) {
        toastr.warning('Укажите имя компании');
        return false;
      }
      if (vm.company.email !== void 0 && !vm.company.email.match(email_mask)) {
        toastr.warning('Укажите валидный email');
        return false;
      }
      vm.company.user_id = 1;
      vm.company.company_type = 'insurance_company';
      RequestService.post('company.put', vm.company).then(function(result) {
        $uibModalInstance.close(result);
      });
      return false;
    };
    vm.putCompany = putCompany;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    getUsers = function() {
      RequestService.post('user.listing').then(function(result) {
        vm.users = result.users;
        console.log(vm.users);
      });
    };
    vm.currStaff = {
      user_id: '',
      branch_id: ''
    };
    addStaff = function() {
      var i, len, ref, x1;
      if (vm.currStaff.user_id !== null && vm.currStaff.user_id !== void 0) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1.user_id === vm.currStaff.user_id) {
            toastr.warning("Этот user уже в списке");
            return;
          }
        }
        vm.company.staff.push(vm.currStaff);
        vm.currStaff = {
          user_id: '',
          branch_id: ''
        };
        return;
      } else {
        alert("В начале выберите user или филиал !");
        return;
      }
    };
    deleteStaff = function(index) {
      vm.company.staff.splice(index, 1);
    };
    addAssistance = function() {
      var i, len, ref, x1;
      if (vm.assistance !== null && vm.assistance !== void 0) {
        ref = vm.company.data.assistants;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1._id === vm.assistance._id) {
            console.log("Этот ассистанс уже в списке");
            return;
          }
        }
        vm.company.data.assistants.push(vm.assistance);
        return;
      } else {
        alert("В начале выберите Ассистанс !");
        return;
      }
    };
    deleteAssistance = function(index) {
      vm.company.data.assistants.splice(index, 1);
    };
    vm.address = '';
    addAddress = function() {
      if (vm.company.data.addresses === null || vm.company.data.addresses === void 0) {
        vm.company.data.addresses = [];
      } else {
        if (vm.company.data.addresses.includes(vm.address)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.address !== null && vm.address !== void 0 && vm.address !== '') {
        vm.company.data.addresses.push(vm.address);
        vm.address = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteAddress = function(index) {
      vm.company.data.addresses.splice(index, 1);
    };
    vm.email = '';
    addEmail = function() {
      if (vm.company.data.emails === null || vm.company.data.emails === void 0) {
        vm.company.data.emails = [];
      } else {
        if (vm.company.data.emails.includes(vm.email)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.email !== null && vm.email !== void 0 && vm.email !== '') {
        vm.company.data.emails.push(vm.email);
        vm.email = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteEmail = function(index) {
      vm.company.data.emails.splice(index, 1);
    };
    vm.website = '';
    addWebsite = function() {
      if (vm.company.data.websites === null || vm.company.data.websites === void 0) {
        vm.company.data.websites = [];
      } else {
        if (vm.company.data.websites.includes(vm.website)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.website !== null && vm.website !== void 0 && vm.website !== '') {
        vm.company.data.websites.push(vm.website);
        vm.website = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteWebsite = function(index) {
      vm.company.data.websites.splice(index, 1);
    };
    vm.phone = '';
    addPhone = function() {
      if (vm.company.data.phones === null || vm.company.data.phones === void 0) {
        vm.company.data.phones = [];
      } else {
        if (vm.company.data.phones.includes(vm.phone)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.phone !== null && vm.phone !== void 0 && vm.phone !== '') {
        vm.company.data.phones.push(vm.phone);
        vm.phone = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deletePhone = function(index) {
      vm.company.data.phones.splice(index, 1);
    };
    vm.upload = upload;
    vm.handleFileSelect = handleFileSelect;
    vm.deleteStaff = deleteStaff;
    vm.addStaff = addStaff;
    vm.addPhone = addPhone;
    vm.deletePhone = deletePhone;
    vm.addWebsite = addWebsite;
    vm.deleteWebsite = deleteWebsite;
    vm.addEmail = addEmail;
    vm.deleteEmail = deleteEmail;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.addAssistance = addAssistance;
    vm.deleteAssistance = deleteAssistance;
    getUsers();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('CollateralController', function($scope, RequestService, $state, email_mask, $uibModal, hotkeys) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('CollateralListController', function($scope, RequestService, $state, email_mask, $uibModal, hotkeys) {
    'ngInject';
    var getCollaterals, goToShow, onDblClick, vm;
    vm = this;
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
    };
    vm.collateralGridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [10, 20, 50, 100],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'policy_client_fullname',
          displayName: 'Заемщик'
        }, {
          name: 'policy_number',
          displayName: 'Номер полиса'
        }, {
          name: 'client_fullname',
          displayName: 'Залогодатель'
        }, {
          name: 'type',
          displayName: 'Тип залога'
        }, {
          name: 'market_price',
          displayName: 'Рын. стоимость'
        }, {
          name: 'coll_price',
          displayName: 'Зал. стоимость'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    getCollaterals = function() {
      var filter;
      filter = {
        filter: {}
      };
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      filter.order_by = ["_created DESC"];
      RequestService.post('collateral.search', filter).then(function(data) {
        delete vm.selected_collateral;
        vm.collateralGridOptions.data = angular.copy(data.list);
        vm.collateralGridOptions.totalItems = data.count;
      });
    };
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/collateral/view.html',
        controller: 'CollateralViewController',
        controllerAs: 'view',
        scope: $scope,
        size: 'lg',
        resolve: {
          collateral: vm.selected_collateral
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_collateral = angular.copy(row.entity);
    });
    vm.getCollaterals = getCollaterals;
    vm.goToShow = goToShow;
    getCollaterals();
  }).controller('CollateralCreateController', function($scope, RequestService, $state, email_mask, $uibModal, hotkeys, toastr) {
    'ngInject';
    var putCollateral, vm;
    vm = this;
    vm.collateral = {};
    putCollateral = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (angular.isUndefined(vm.collateral.data)) {
        vm.collateral.data = {};
      }
      vm.collateral.type = 'Collateral';
      RequestService.post('collateral.save', vm.collateral).then(function(result) {
        vm.saving = false;
        toastr.success('Сохранено!');
      }, function() {
        return vm.saving = false;
      });
    };
    vm.putCollateral = putCollateral;
  }).controller('CollateralViewController', function(collateral, $scope, RequestService, $state, email_mask, $uibModal, hotkeys, toastr) {
    'ngInject';
    var vm;
    vm = this;
    vm.collateral = collateral;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ClientsController', function($scope, $state, RequestService, toastr, hotkeys, $uibModal, $uibModalStack) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('ClientsListController', function($scope, $state, RequestService, toastr, hotkeys, $uibModal, $uibModalStack) {
    'ngInject';
    var editContractor, getContractors, newContractor, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 20;
    vm.contractorsGridOptions = {
      noUnselect: true,
      paginationPageSizes: [20, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Наименование'
        }, {
          name: 'data.email',
          displayName: 'E-mail'
        }, {
          name: 'industry.name',
          displayName: 'Индустрия'
        }, {
          name: 'contractor_type_value.data.name',
          displayName: 'Тип'
        }, {
          name: 'contractor_company.name',
          displayName: 'Компания агента',
          visible: false
        }, {
          name: 'company.name',
          displayName: 'Компания',
          visible: false
        }
      ],
      events: {
        onRowSelect: function(row) {
          vm.selected_contractor = angular.copy(row.entity);
        },
        onPageSelect: function(page, size) {
          vm.offset = page * size;
          vm.limit = size;
          getContractors();
        }
      }
    };
    newContractor = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/contractor/edit.html',
        controller: 'ContractorEditController',
        controllerAs: 'contractor',
        size: 'lg',
        scope: $scope,
        resolve: {
          contractor: void 0
        }
      });
      editModal.result.then(function() {
        return getContractors();
      });
    };
    editContractor = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/contractor/edit.html',
        controller: 'ContractorEditController',
        controllerAs: 'contractor',
        size: 'lg',
        scope: $scope,
        resolve: {
          contractor: angular.copy(vm.selected_contractor)
        }
      });
      editModal.result.then(function() {
        return getContractors();
      });
    };
    getContractors = function() {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true
      };
      RequestService.post('contractor.list', filter).then(function(result) {
        vm.contractorsGridOptions.data = result.docs;
        vm.contractorsGridOptions.totalItems = result.count;
        delete vm.selected_contractor;
      });
    };
    vm.newContractor = newContractor;
    vm.editContractor = editContractor;
    vm.getContractors = getContractors;
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить контрагента',
      callback: newContractor
    }).add({
      combo: 'r',
      description: 'Обновить список контрагентов',
      callback: getContractors
    });
    getContractors();
  }).controller('ClientsCreateController', function($scope, $state, RequestService, toastr, hotkeys, $uibModal, $uibModalStack) {
    'ngInject';
    var putContractor, vm;
    vm = this;
    putContractor = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (angular.isUndefined(vm.contractor.data)) {
        vm.contractor.data = {};
      }
      RequestService.post('contractor.save', vm.contractor).then(function(result) {
        vm.saving = false;
        toastr.success('Сохранено!');
      }, function() {
        return vm.saving = false;
      });
    };
    vm.putContractor = putContractor;
  }).controller('ClientsViewController', function($scope, $state, $stateParams, RequestService, toastr, hotkeys, $uibModal, $uibModalStack) {
    'ngInject';
    var getContractor, vm;
    vm = this;
    vm.id = $stateParams.id;
    getContractor = function() {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        filter: {
          _id: vm.id
        }
      };
      RequestService.post('contractor.get', filter).then(function(result) {
        vm.contractor = result.doc;
      });
    };
    vm.getContractor = getContractor;
    getContractor();
  }).controller('ClientsEditController', function($scope, $state, $stateParams, RequestService, toastr, hotkeys, $uibModal, $uibModalStack) {
    'ngInject';
    var cancel, editDiagnosis, editHistory, editIdentity, finishDiagnosis, finishHistory, finishIdentity, getContractor, getEmployee, getproduct, removeDiagnosis, removeHistory, removeIdentity, saveClient, vm;
    vm = this;
    vm.id = $stateParams.id;
    vm.identities = [];
    vm.diagnosises = [];
    vm.histories = [];
    getContractor = function() {
      var filter;
      filter = {
        with_related: true,
        filter: {
          _id: vm.id
        }
      };
      RequestService.post('contractor.get', filter).then(function(result) {
        vm.contractor = result.doc;
      });
    };
    editIdentity = function(identity) {
      vm.curIdentity = identity;
    };
    finishIdentity = function(push) {
      if (push && !vm.curIdentity.id) {
        if (vm.prod) {
          vm.curIdentity.product_name = vm.prod.name;
        }
        if (vm.prod.unit) {
          vm.curIdentity.product_unit = vm.prod.unit.name;
        }
        vm.contractor.data.identities.push(vm.curIdentity);
        vm.product_id = null;
      }
      vm.curIdentity = null;
    };
    removeIdentity = function(index) {
      vm.identities.splice(index, 1);
    };
    editDiagnosis = function(diagnosis) {
      vm.curDiagnosis = diagnosis;
    };
    finishDiagnosis = function(push) {
      if (push && !vm.curDiagnosis.id) {
        if (vm.current_employee) {
          vm.curDiagnosis.employee = vm.current_employee;
        }
        vm.contractor.data.diagnosises.push(vm.curDiagnosis);
      }
      vm.curDiagnosis = null;
    };
    removeDiagnosis = function(index) {
      vm.diagnosises.splice(index, 1);
    };
    editHistory = function(history) {
      vm.curHistories = history;
    };
    finishHistory = function(push) {
      if (push && !vm.curHistories.id) {
        vm.contractor.data.histories.push(vm.curHistories);
      }
      vm.curHistories = null;
    };
    removeHistory = function(index) {
      vm.histories.splice(index, 1);
    };
    $scope.$watch('edit.product_id', function() {
      return getproduct();
    });
    $scope.$watch('edit.current_employee', function() {
      return getEmployee();
    });
    getproduct = function() {
      var filter;
      if (vm.product_id) {
        filter = {
          with_related: true,
          filter: {
            _id: vm.product_id
          }
        };
        RequestService.post('product.get', filter).then(function(result) {
          vm.prod = result.doc;
        });
      }
    };
    getEmployee = function() {
      var filter;
      if (vm.current_employee) {
        filter = {
          with_related: true,
          filter: {
            id: vm.current_employee
          }
        };
        RequestService.post('user.get', filter).then(function(result) {
          vm.employee = result.doc;
        });
      }
    };
    saveClient = function() {
      if (!vm.contractor.data) {
        vm.contractor.data = {};
      }
      RequestService.post('contractor.save', vm.contractor).then(function(result) {
        toastr.success('Сохранено!');
      });
    };
    cancel = function() {
      $state.go('app.clients.list');
    };
    vm.getContractor = getContractor;
    vm.editIdentity = editIdentity;
    vm.finishIdentity = finishIdentity;
    vm.removeIdentity = removeIdentity;
    vm.editDiagnosis = editDiagnosis;
    vm.finishDiagnosis = finishDiagnosis;
    vm.getproduct = getproduct;
    vm.getEmployee = getEmployee;
    vm.removeDiagnosis = removeDiagnosis;
    vm.editHistory = editHistory;
    vm.finishHistory = finishHistory;
    vm.removeHistory = removeHistory;
    vm.saveClient = saveClient;
    vm.cancel = cancel;
    getContractor();
  }).controller('ClientsModalController', function($scope, RequestService, $uibModalInstance, contractor, toastr) {
    'ngInject';
    var industryParentGroup, putContractor, vm;
    vm = this;
    vm.contractor = angular.copy(contractor || {
      type: 'Contractor'
    });
    putContractor = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (angular.isUndefined(vm.contractor.data)) {
        vm.contractor.data = {};
      }
      RequestService.post('contractor.save', vm.contractor).then(function(result) {
        vm.saving = false;
        $uibModalInstance.close(result);
      }, function() {
        return vm.saving = false;
      });
    };
    industryParentGroup = function(item) {
      if (!item.parent) {
        return '';
      }
      return item.parent.name;
    };
    vm.putContractor = putContractor;
    vm.industryParentGroup = industryParentGroup;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('BranchController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, date, deletePolicy, downloadPDF, editBranch, fiterPolicy, getAgents, getPolicies, goToIssue, goToNew, goToShow, m, onDblClick, resetFilter, vm, y;
    vm = this;
    vm.today = new Date();
    date = new Date();
    y = date.getFullYear();
    m = date.getMonth();
    vm.date_start = new Date(y, m, 1);
    vm.date_end = new Date();
    vm.date_start.setHours(vm.date_start.getHours() + 6);
    vm.date_end.setHours(vm.date_end.getHours() + 6);
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 10;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/branch/show.html',
        controller: 'BranchShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product.name',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'ФИО клиента'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'company',
          displayName: 'Страховщик'
        }, {
          name: 'agent',
          displayName: 'Агент'
        }, {
          name: 'branch',
          displayName: 'Филиал'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      if (!vm.company) {
        $state.go('app.apolicy.new');
      } else if (vm.company.company_type === "insurance_company") {
        $state.go('app.apolicy.select');
      } else if (vm.company.company_type === "agent") {
        $state.go('app.apolicy.select');
      } else {
        $state.go('app.apolicy.new');
      }
      return false;
    };
    goToIssue = function() {
      $state.go('app.apolicy.issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/apolicy/edit.html',
        controller: 'ApolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!vm.company) {
        filter.with_related = true;
      } else if (vm.company.company_type === 'agent') {
        filter.with_related = true;
        filter.filter = {
          agent_id: vm.company._id
        };
      }
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.filter.insurance_data = {};
      filter.filter.client = {};
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "agent_id") {
          filter.filter.agent_id = v;
        }
        if (k === "branch_id") {
          filter.filter.branch_id = v;
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "name") {
          filter.filter.client.name = v;
        }
        if (k === "surname") {
          filter.filter.client.surname = v;
        }
      }
      if (Object.keys(filter.filter.insurance_data).length === 0) {
        delete filter.filter.insurance_data;
      }
      if (Object.keys(filter.filter.client).length === 0) {
        delete filter.filter.client;
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["_created DESC"];
      filter.filter.date_end = vm.date_end;
      filter.filter.date_start = vm.date_start;
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.success("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getAgents = function() {
      RequestService.post('branch.branchlisting', {
        company_id: vm.company._id
      }).then(function(data) {
        return vm.agents = data.docs;
      });
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        'policyNumber': vm.selected_policy.policy_no
      });
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, i, issue_d, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (i = 0, len = ref.length; i < len; i++) {
          policy = ref[i];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    getAgents();
    getPolicies();
  }).controller('BranchShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var FormPolicy, cancel, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, findCurrencyName, findMinInsurance, getProducts, goToForm, goToPolicy, issueAgent_policy, sendMail, spoilPolicy, termAgent_policy, vm;
    vm = this;
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    getProducts = function(product_id) {
      var filter;
      filter = {
        with_related: true,
        _id: product_id
      };
      RequestService.post('select.view_listing', filter).then(function(result) {
        vm.product = result.product;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        findMinInsurance();
        findCurrencyName();
        if (!vm.policy.product) {
          vm.policy.product = angular.copy(vm.product);
        }
      });
    };
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    findCurrencyName = function() {
      var country, currency, i, j, len, len1, ref, ref1;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        country = ref[i];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            currency = ref1[j];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.currency_name) {
                RequestService.post('currencynbkr.get_nbkr_rate', {
                  iso: vm.currency_name
                }).then(function(result) {
                  var currencyRate;
                  currencyRate = result.results;
                  return vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * currencyRate).toFixed(2);
                });
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var i, item, itemx, j, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        ref1 = vm.policy.insurance_data.country_id;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          itemx = ref1[j];
          if (itemx === item._id) {
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.apolicy.list");
    } else {
      getProducts(vm.policy.product_id);
      console.log(vm.policy);
    }
    sendMail = function() {
      var countries, country, country_id, i, j, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (i = 0, len = ref.length; i < len; i++) {
        country_id = ref[i];
        ref1 = vm.countries;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          country = ref1[j];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        console.log(result);
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, i, len, policyList, policy_no, policy_to_send, ref, theUser, user;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = policy_no.slice(0, 3) + vm.company.code + "00000";
      } else {
        policy_no = policy_no + "00000";
      }
      vm.policy.policy_no = policy_no;
      vm.policy.issue_date = new Date();
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      delete vm.policy.product;
      policy_to_send = angular.copy(vm.policy);
      policy_to_send.data.status = 'Оформлен';
      policyList.items.push(policy_to_send);
      RequestService.post('policies.save', policyList).then(function(result) {
        delete vm.product.company;
        delete vm.product.factors;
        delete vm.product.services;
        delete vm.product.basefactors;
        vm.policy.policy_no = result.resultList[0].policy_no;
        vm.policy.data.status = 'Оформлен';
        sendMail();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    issueAgent_policy = function() {
      RequestService.post('currencynbkr.get_nbkr_rate', {
        iso: vm.currency_name
      }).then(function(result) {
        vm.currencyRate = result.results;
        console.log("vm.currencyRate " + vm.currencyRate);
        FormPolicy();
      });
    };
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        policyNumber: vm.policy.policy_no
      });
    };
    termAgent_policy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.apolicy.list');
    };
    goToForm = function() {
      $state.go('app.apolicy.form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issueAgent_policy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termAgent_policy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('AuthController', function(RequestService, $scope, $rootScope, toastr, EVENTS, Session, browser, email_mask, AppStorage, $http, $state, $translate) {
    'ngInject';
    var login, ref, register, toast, vm;
    vm = this;
    vm.os = (ref = browser()) != null ? ref : 'unknown';
    vm.email = null;
    vm.phone = null;
    vm.otp = null;
    vm.isCountingDown = false;
    vm.isPasswordDown = false;
    vm.isMessage = false;
    vm.message = null;
    vm.countdownTime = null;
    vm.setState = {};
    vm.countryCode = 996;
    vm.min = 0;
    vm.max = 10;
    vm.first_number = Math.floor(Math.random() * (vm.max - vm.min + 1) + vm.min);
    vm.second_number = Math.floor(Math.random() * (vm.max - vm.min + 1) + vm.min);
    register = function() {
      if (vm.password !== vm.password2) {
        toastr.warning('Пароли не совпадают');
        return false;
      }
      RequestService.post('user/register', vm).then(function(data) {
        Session.create(data.token, data.user);
        $rootScope.$broadcast(EVENTS.loginSuccess);
      }, function(result) {
        toast(result ? result : {
          result: -1,
          message: 'Ошибка сети'
        });
      });
      return false;
    };
    login = function() {
      if (vm.auth_loading === true) {
        return;
      }
      vm.auth_loading = true;
      RequestService.post('user/auth', vm).then(function(data) {
        Session.create(data.token, data.user, data.company);
        $scope.$emit(EVENTS.loginSuccess);
        vm.auth_loading = false;
      }, function(result) {
        vm.auth_loading = false;
        toast(result ? result : {
          result: -1,
          message: 'Ошибка сети'
        });
      });
      return false;
    };
    toast = function(result) {
      if (result.result > 0) {
        return toastr.warning(result.message);
      } else if (result.result < 0) {
        return toastr.error(result.message);
      }
    };
    $rootScope.$on(EVENTS.loginSuccess, function() {
      AppStorage.clear();
      vm.company = Session.getCompany();
      $state.go('app.dashboard');
    });
    vm.register = register;
    vm.login = login;
  }).controller('AuthReportController', function(RequestService, ReportService, $scope, $rootScope, toastr, $stateParams, $http) {
    'ngInject';
    var getPolicy, vm;
    vm = this;
    vm.policyNumber = $stateParams.policyNumber;
    vm.policyShow = false;
    vm.textError = false;
    getPolicy = function() {
      var filter;
      filter = {
        policy_no: vm.policyNumber
      };
      return $http.post($rootScope.api + 'get_policy/' + vm.policyNumber).then(function(data) {
        vm.selected_policy = data.data.doc;
        vm.policyShow = true;
        vm.textError = false;
        switch (vm.selected_policy.objects) {
          case 'LN':
            return ReportService.printReport('LN2', {
              policyNumber: vm.selected_policy.policy_no
            });
          default:
            return toastr.warning('Не существует шаблона');
        }
      })["catch"](function(error) {
        vm.policyShow = false;
        vm.textError = true;
        return toastr.error('Ошибка при загрузке полиса');
      });
    };
    vm.getPolicy = getPolicy;
    getPolicy();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ApolicyController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('ApolicyListController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, downloadPDF, editBranch, fiterPolicy, getAgents, getPolicies, goToIssue, goToNew, goToPersonal, goToRealEstate, goToShow, goToVehicle, onDblClick, resetFilter, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 25;
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/apolicy/show.html',
        controller: 'ApolicyShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [25, 50, 100, 500],
      paginationPageSize: 25,
      useExternalPagination: true,
      enableHorizontalScrollbar: 1,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'data.currency.name',
          displayName: 'Валюта'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'insurance_com',
          displayName: 'Комиссионные',
          cellTemplate: '<span>{{(row.entity.insurance_premium*0.4 | number:2 )}} </span>',
          width: "10%"
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      $state.go('app.apolicy.select');
      return false;
    };
    goToIssue = function() {
      $state.go('app.apolicy.issue');
      return false;
    };
    goToRealEstate = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/real_estate.html',
        controller: 'PolicyNedController',
        controllerAs: 'select',
        scope: $scope,
        size: 'lg',
        backdrop: 'static',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getPolicies();
      });
    };
    goToVehicle = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/vehicle.html',
        controller: 'PolicyVehicleController',
        controllerAs: 'select',
        scope: $scope,
        size: 'lg',
        backdrop: 'static',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getPolicies();
      });
    };
    goToPersonal = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/personal.html',
        controller: 'PolicyPersonalController',
        controllerAs: 'select',
        scope: $scope,
        size: 'lg',
        backdrop: 'static',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getPolicies();
      });
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/apolicy/edit.html',
        controller: 'ApolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.filter.insurance_data = {};
      filter.filter.client = {};
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "agent_id") {
          filter.filter.agent_id = v;
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "date_end") {
          filter.filter.insurance_data.date_end = v;
        }
        if (k === "date_start") {
          filter.filter.insurance_data.date_start = v;
        }
        if (k === "name") {
          filter.filter.client = v;
        }
      }
      if (Object.keys(filter.filter.insurance_data).length === 0) {
        delete filter.filter.insurance_data;
      }
      if (Object.keys(filter.filter.client).length === 0) {
        delete filter.filter.client;
      }
      filter.offset = vm.offset;
      filter.filter.edit_user_id = $scope.app.ua.id;
      filter.limit = vm.limit;
      filter.with_related = true;
      filter.order_by = ["issue_date DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        vm.current_date = angular.copy(data.current_date);
        toastr.success("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getAgents = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'agent'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        vm.agents = data.docs;
      });
    };
    downloadPDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        if (new Date(vm.selected_policy.issue_date) > new Date('2019-07-22 00:00:00')) {
          ReportService.printReport('TS2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'LN') {
        if (new Date(vm.selected_policy.issue_date) > new Date('2024-09-03 00:00:00')) {
          ReportService.printReport('LN2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'NED') {
        if (new Date(vm.selected_policy.issue_date) > new Date('2019-07-22 00:00:00')) {
          ReportService.printReport('NED2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    deletePolicy = function(policy) {
      return RequestService.post('policies.delete', policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, i, issue_d, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (i = 0, len = ref.length; i < len; i++) {
          policy = ref[i];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function(policy) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy(policy);
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    vm.goToRealEstate = goToRealEstate;
    vm.goToVehicle = goToVehicle;
    vm.goToPersonal = goToPersonal;
    getAgents();
    getPolicies();
  }).controller('ApolicyEditController', function($scope, hotkeys, $state, RequestService, Session, $uibModalInstance, branch, toastr) {
    'ngInject';
    var putBranch, vm;
    vm = this;
    vm.branch = branch || {
      type: 'Branches'
    };
    putBranch = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (vm.branch.name === void 0 || vm.branch.name.trim().length === 0) {
        toastr.warning('Укажите имя филиала');
        vm.saving = false;
        return false;
      }
      if (angular.isUndefined(vm.branch.branch_type)) {
        toastr.warning('Выберите тип');
        vm.saving = false;
        return false;
      }
      RequestService.post('branch.save', vm.branch).then(function(result) {
        $uibModalInstance.close(result);
      }, function() {
        return vm.saving = false;
      });
      return false;
    };
    vm.putBranch = putBranch;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('ApolicyNewController', function($scope, hotkeys, $state, RequestService, Session, toastr) {
    'ngInject';
    var getDiffDays, goToSelect, vm;
    vm = this;
    vm.diffDays = 0;
    vm.today = new Date();
    goToSelect = function(item) {
      $state.go('app.apolicy.select', {
        product: item
      });
    };
    getDiffDays = function() {
      var end, start;
      if (vm.pruduct.date_end && vm.pruduct.date_start) {
        start = new Date(vm.pruduct.date_start);
        end = new Date(vm.pruduct.date_end);
        vm.diffDays = Math.round(Math.abs((end.getTime() - start.getTime()) / (24 * 60 * 60 * 1000))) + 1;
      }
    };
    vm.goToSelect = goToSelect;
    vm.getDiffDays = getDiffDays;
  }).controller('ApolicySelectController', function($scope, hotkeys, $state, $stateParams, RequestService, $filter, Session, toastr) {
    'ngInject';
    var addCollateralLn, addCollateralNed, addCollateralTs, calculatePremiumLn, calculatePremiumNed, calculatePremiumTs, confirmAction, deleteCollateralLn, deleteCollateralNed, deleteCollateralTs, getInsuranceForms, getInsuranceLnObjects, getInsuranceNedObjects, getInsuranceTsObjects, getInsuranceTypes, getPeriods, pdrobneeIconCnange, recalculateOnEventAll, recalculateOnEventisAnnual, savePolicy, showPanel, vm;
    vm = this;
    vm.parseInt = parseInt;
    vm.today = new Date();
    vm.finish_date = moment(vm.today).add(365, 'day').toDate();
    vm.diffDays = 0;
    vm.nedPanel = false;
    vm.tsPanel = false;
    vm.lnPanel = false;
    vm.product = $stateParams.product;
    if (vm.product === null || vm.product === void 0) {
      vm.product = {};
      vm.product.factors = {};
    }
    vm.annualPolicies = [45, 90];
    vm.annualDays = vm.annualPolicies[0];
    vm.productsList = [];
    vm.collateralsned = {
      ned: []
    };
    vm.collateralsts = {
      ts: []
    };
    vm.collateralsln = {
      ln: []
    };
    vm.selectedProduct = {};
    vm.selectedAge = {};
    vm.currentCountryId = '';
    vm.min_insurance_amount = 0;
    vm.insurance_amount = 0;
    vm.currency_name = "USD";
    vm.policy = {
      objects: [],
      insurance_amount: 0,
      insurance_amountts: 0,
      insurance_amountned: 0,
      insurance_amountln: 0,
      insurance_premiumts: 0,
      insurance_premiumned: 0,
      insurance_premiumln: 0,
      date_start: moment().toDate()
    };
    vm.insuranceform = {
      adres: 'Кыргызская Республика'
    };
    vm.insuranceformned = {
      adres: 'Кыргызская Республика'
    };
    vm.insuranceformts = {
      adres: 'Кыргызская Республика',
      driver: 'Лица, имеющие право на управление застрахованным транспортным средством.'
    };
    vm.insuranceformln = {
      adres: 'Кыргызская Республика'
    };
    vm.inputCheck = true;
    vm.period_rate = 0;
    vm.company = Session.getCompany();
    showPanel = function(insurance_type, check) {
      if (insurance_type.code === 'NED') {
        if (check === true) {
          vm.nedPanel = true;
          getInsuranceNedObjects(insurance_type._id);
        } else if (check !== true & vm.collateralsned.ned.length > 0) {
          toastr.warning('Невозможно закрыть');
          vm.nedPanel = true;
          vm.insuranceformned.objectned = null;
          vm.insuranceformned.insurance_summ = null;
          vm.insuranceformned.coll_price = null;
          vm.insuranceformned.description = null;
          vm.insuranceformned.insurance_premium = null;
        } else if (check !== true & vm.collateralsned.ned.length === 0) {
          vm.nedPanel = false;
          vm.insuranceformned.objectned = null;
          vm.insuranceformned.insurance_summ = null;
          vm.insuranceformned.coll_price = null;
          vm.insuranceformned.description = null;
          vm.insuranceformned.insurance_premium = null;
        }
      }
      if (insurance_type.code === 'TC') {
        if (check === true) {
          vm.tsPanel = true;
          getInsuranceTsObjects(insurance_type._id);
        } else if (check !== true & vm.collateralsts.ts.length > 0) {
          toastr.warning('Невозможно закрыть');
          vm.tsPanel = true;
          vm.insuranceformts.objectts = null;
          vm.insuranceformts.model = null;
          vm.insuranceformts.gosnumber = null;
          vm.insuranceformts.number = null;
          vm.insuranceformts.year_issue = null;
          vm.insuranceformts.insurance_summ = null;
          vm.insuranceformts.coll_price = null;
          vm.insuranceformts.insurance_premium = null;
        } else if (check !== true & vm.collateralsts.ts.length === 0) {
          vm.tsPanel = false;
          vm.insuranceformts.objectts = null;
          vm.insuranceformts.model = null;
          vm.insuranceformts.gosnumber = null;
          vm.insuranceformts.number = null;
          vm.insuranceformts.year_issue = null;
          vm.insuranceformts.insurance_summ = null;
          vm.insuranceformts.coll_price = null;
          vm.insuranceformts.insurance_premium = null;
        }
      }
      if (insurance_type.code === 'LN') {
        if (check === true) {
          vm.lnPanel = true;
          getInsuranceLnObjects(insurance_type._id);
        } else if (check !== true & vm.collateralsln.ln.length > 0) {
          toastr.warning('Невозможно закрыть');
          vm.lnPanel = false;
          vm.insuranceformln.objectln = null;
          vm.insuranceformln.birthday = null;
          vm.insuranceformln.pasport = null;
          vm.insuranceformln.insurance_summ = null;
          vm.insuranceformln.coll_price = null;
          vm.insuranceformln.insurance_premium = null;
        } else if (check !== true & vm.collateralsln.ln.length === 0) {
          vm.lnPanel = false;
          vm.insuranceformln.objectln = null;
          vm.insuranceformln.birthday = null;
          vm.insuranceformln.pasport = null;
          vm.insuranceformln.insurance_summ = null;
          vm.insuranceformln.coll_price = null;
          vm.insuranceformln.insurance_premium = null;
        }
      }
    };
    getInsuranceTypes = function() {
      return RequestService.post('insurancetypes.listing').then(function(data) {
        vm.insurancetypes = angular.copy(data.docs);
      });
    };
    getInsuranceNedObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: insurance_type
      }).then(function(data) {
        vm.insuranceobjectsned = angular.copy(data.docs);
      });
    };
    getInsuranceTsObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: insurance_type
      }).then(function(data) {
        vm.insuranceobjectsts = angular.copy(data.docs);
      });
    };
    getInsuranceLnObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: insurance_type
      }).then(function(data) {
        vm.insuranceobjectsln = angular.copy(data.docs);
      });
    };
    getInsuranceForms = function() {
      return RequestService.post('insuranceforms.listing', {
        insurance_object_id: vm.insuranceform.object._id
      }).then(function(data) {
        vm.insuranceforms = angular.copy(data.docs);
      });
    };
    getPeriods = function() {
      return RequestService.post('period.listing').then(function(data) {
        vm.periods = angular.copy(data.docs);
      });
    };
    addCollateralNed = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.nedvijimost = {
          owner: insuranceform.owner,
          object: insuranceform.objectned.name,
          objectned: insuranceform.objectned,
          adres: insuranceform.adres,
          coll_price: insuranceform.coll_price,
          description: insuranceform.description,
          insurance_summ: insuranceform.insurance_summ,
          insurance_premium: insuranceform.insurance_premium
        };
        vm.collateralsned.ned.push(vm.nedvijimost);
        vm.nedvijimost = {};
        vm.insuranceformned = {
          objectned: null,
          insurance_summ: null,
          insurance_premium: null,
          adres: 'Кыргызская Республика'
        };
        vm.policy.insurance_amountned = vm.policy.insurance_amountned + insuranceform.insurance_summ;
        vm.policy.insurance_premiumned = vm.policy.insurance_premiumned + insuranceform.insurance_premium;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralNed = function(collateral, index) {
      vm.collateralsned.ned.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumned = vm.policy.insurance_premiumned - collateral.insurance_premium;
      vm.policy.insurance_amountned = vm.policy.insurance_amountned - collateral.insurance_summ;
    };
    addCollateralTs = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.ts = {
          object: insuranceform.objectts.name,
          objectts: insuranceform.objectts,
          adres: insuranceform.adres,
          model: insuranceform.model,
          gosnumber: insuranceform.gosnumber,
          number: insuranceform.number,
          year_issue: insuranceform.year_issue,
          insurance_summ: insuranceform.insurance_summ,
          coll_price: insuranceform.coll_price,
          insurance_premium: insuranceform.insurance_premium,
          driver: insuranceform.driver
        };
        vm.collateralsts.ts.push(vm.ts);
        vm.ts = {};
        vm.insuranceformts = {
          objectts: null,
          adres: 'Кыргызская Республика',
          model: null,
          gosnumber: null,
          number: null,
          year_issue: null,
          insurance_summ: null,
          coll_price: null,
          insurance_premium: null
        };
        vm.policy.insurance_premiumts = vm.policy.insurance_premiumts + insuranceform.insurance_premium;
        vm.policy.insurance_amountts = vm.policy.insurance_amountts + insuranceform.insurance_summ;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralTs = function(collateral, index) {
      vm.collateralsts.ts.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumts = vm.policy.insurance_premiumts - collateral.insurance_premium;
      vm.policy.insurance_amountts = vm.policy.insurance_amountts - collateral.insurance_summ;
    };
    addCollateralLn = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.ln = {
          adres: insuranceform.adres,
          birthday: insuranceform.birthday,
          pasport: insuranceform.pasport,
          insurance_summ: insuranceform.insurance_summ,
          client: insuranceform.client,
          insurance_premium: insuranceform.insurance_premium
        };
        vm.collateralsln.ln.push(vm.ln);
        vm.ln = {};
        vm.insuranceformln = {
          adres: 'Кыргызская Республика',
          birthday: null,
          pasport: null,
          insurance_summ: null,
          client: null,
          insurance_premium: null
        };
        vm.policy.insurance_premiumln = vm.policy.insurance_premiumln + insuranceform.insurance_premium;
        vm.policy.insurance_amountln = vm.policy.insurance_amountln + insuranceform.insurance_summ;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralLn = function(collateral, index) {
      vm.collateralsln.ln.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumln = vm.policy.insurance_premiumln - collateral.insurance_premium;
      vm.policy.insurance_amountln = vm.policy.insurance_amountln - collateral.insurance_summ;
    };
    recalculateOnEventisAnnual = function() {
      vm.policy.date_end = moment(vm.policy.date_start).add(365, 'day').toDate();
      recalculateOnEventAll();
    };
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, timeDiff;
      date1 = "";
      date2 = "";
      date1 = vm.policy.date_start;
      date2 = vm.policy.date_end || moment(vm.policy.date_start).add(1, 'day').toDate();
      diffDays = 0;
      if (vm.isAnnual) {
        vm.diffDays = 365;
      } else {
        timeDiff = Math.abs(date2.getTime() - date1.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        vm.diffDays = diffDays + 1;
      }
    };
    savePolicy = function() {
      var agent_id, branch_id, policy, policyList, policy_no, theUser;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
        branch_id = vm.company.company_id;
      } else if (vm.company.company_type === "branch_company") {
        branch_id = vm.company._id;
      }
      theUser = Session.getUser();
      policyList = {
        items: []
      };
      if (vm.collateralsned.ned.length > 0) {
        policy_no = 'ARS/PI';
        policy = {
          policy_no: policy_no,
          credit_no: vm.policy.credit_no,
          issue_date: new Date(),
          product_id: vm.policy.product_id,
          company_id: vm.company._id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: vm.policy.client,
          insurance_amount: vm.policy.insurance_amountned,
          insurance_premium: vm.policy.insurance_premiumned,
          insurance_data: {
            ned: vm.collateralsned.ned,
            date_start: vm.policy.date_start,
            date_end: vm.policy.date_end,
            diffDays: vm.diffDays
          },
          objects: 'NED',
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency.name,
            currency: vm.currency,
            insurance_premium_kgs: 0
          }
        };
        policyList.items.push(policy);
      }
      if (vm.collateralsts.ts.length > 0) {
        policy_no = 'ARS/VI';
        policy = {
          policy_no: policy_no,
          credit_no: vm.policy.credit_no,
          issue_date: new Date(),
          product_id: vm.policy.product_id,
          company_id: vm.company._id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: vm.policy.client,
          insurance_amount: vm.policy.insurance_amountts,
          insurance_premium: vm.policy.insurance_premiumts,
          insurance_data: {
            ts: vm.collateralsts.ts,
            date_start: vm.policy.date_start,
            date_end: vm.policy.date_end,
            diffDays: vm.diffDays
          },
          objects: 'TS',
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            buyer: vm.buyer,
            status: 'Оформлен',
            ccurrency_name: vm.currency.name,
            currency: vm.currency,
            insurance_premium_kgs: 0
          }
        };
        policyList.items.push(policy);
      }
      if (vm.collateralsln.ln.length > 0) {
        policy_no = 'ARS/AI';
        policy = {
          policy_no: policy_no,
          credit_no: vm.policy.credit_no,
          issue_date: new Date(),
          product_id: vm.policy.product_id,
          company_id: vm.company._id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: vm.policy.client,
          insurance_amount: vm.policy.insurance_amountln,
          insurance_premium: vm.policy.insurance_premiumln,
          insurance_data: {
            ln: vm.collateralsln.ln,
            date_start: vm.policy.date_start,
            date_end: vm.policy.date_end,
            diffDays: vm.diffDays
          },
          objects: 'LN',
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency.name,
            currency: vm.currency,
            insurance_premium_kgs: 0
          }
        };
        policyList.items.push(policy);
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var i, item, len, ref, temp, to_save;
        if (result) {
          to_save = [];
          ref = vm.insurants;
          for (i = 0, len = ref.length; i < len; i++) {
            item = ref[i];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    pdrobneeIconCnange = function() {
      if (vm.pdrobneeIcon === 'fa fa-chevron-down') {
        vm.pdrobneeIcon = 'fa fa-chevron-up';
      } else {
        vm.pdrobneeIcon = 'fa fa-chevron-down';
      }
    };
    calculatePremiumNed = function() {
      var i, len, period, ref;
      if (!vm.insuranceformned.objectned) {
        toastr.warning('Выберите объект страхования');
        return;
      }
      if (!vm.insuranceformned.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      ref = vm.periods;
      for (i = 0, len = ref.length; i < len; i++) {
        period = ref[i];
        if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
          vm.period_rate = period.rate;
        }
      }
      vm.insuranceformned.insurance_premium = Math.round(vm.insuranceformned.insurance_summ * (vm.insuranceformned.objectned.rate / 100) * vm.period_rate);
    };
    calculatePremiumTs = function() {
      var i, len, period, ref;
      if (!vm.insuranceformts.objectts) {
        toastr.warning('Выберите объект страхования');
        return;
      }
      if (!vm.insuranceformts.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      ref = vm.periods;
      for (i = 0, len = ref.length; i < len; i++) {
        period = ref[i];
        if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
          vm.period_rate = period.rate;
        }
      }
      vm.insuranceformts.insurance_premium = Math.round(vm.insuranceformts.insurance_summ * (vm.insuranceformts.objectts.rate / 100) * vm.period_rate);
    };
    calculatePremiumLn = function() {
      var i, len, period, ref;
      if (!vm.insuranceformln.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      ref = vm.periods;
      for (i = 0, len = ref.length; i < len; i++) {
        period = ref[i];
        if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
          vm.period_rate = period.rate;
        }
      }
      vm.insuranceformln.insurance_premium = vm.insuranceformln.insurance_summ * 0.0022 * vm.period_rate;
    };
    vm.addCollateralNed = addCollateralNed;
    vm.addCollateralTs = addCollateralTs;
    vm.addCollateralLn = addCollateralLn;
    vm.deleteCollateralNed = deleteCollateralNed;
    vm.deleteCollateralTs = deleteCollateralTs;
    vm.deleteCollateralLn = deleteCollateralLn;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    vm.pdrobneeIconCnange = pdrobneeIconCnange;
    vm.confirmAction = confirmAction;
    vm.savePolicy = savePolicy;
    vm.recalculateOnEventisAnnual = recalculateOnEventisAnnual;
    vm.getInsuranceForms = getInsuranceForms;
    vm.calculatePremiumNed = calculatePremiumNed;
    vm.calculatePremiumTs = calculatePremiumTs;
    vm.calculatePremiumLn = calculatePremiumLn;
    vm.getPeriods = getPeriods;
    vm.getInsuranceTypes = getInsuranceTypes;
    vm.showPanel = showPanel;
    recalculateOnEventAll();
    getPeriods();
    getInsuranceTypes();
  }).controller('ApolicyIssueController', function($scope, hotkeys, $state, RequestService, Session, $filter, toastr, $stateParams, $uibModal) {
    'ngInject';
    var addInsurant, changeIcon, computePrice, confirmAction, deleteInsurant, getCountries, i, len, pdrobneeIconCnange, phone, reCompute, ref, savePolicy, vm;
    vm = this;
    vm.countries = null;
    vm.countriesView = [];
    vm.currentCountryId = '';
    vm.min_insurance = 0;
    vm.product = $stateParams.product;
    vm.currency_name = '';
    vm.currencyRate = 0;
    vm.iconsList = [];
    vm.pdrobneeIcon = 'fa fa-chevron-down';
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    vm.company = Session.getCompany();
    vm.buyer = {};
    if (vm.company.company_type = 'agent') {
      vm.buyer.surname = null;
      vm.buyer.name = null;
      if (vm.company.data.phones) {
        ref = vm.company.data.phones;
        for (i = 0, len = ref.length; i < len; i++) {
          phone = ref[i];
          vm.buyer.phone = phone;
          break;
        }
      } else {
        vm.buyer.phone = null;
      }
    }
    getCountries = function() {
      var filter;
      filter = {
        with_related: true
      };
      RequestService.post('select.issue_listing', filter).then(function(result) {
        var country, currency, item, itemx, j, l, len1, len2, len3, m, ref1, ref2, ref3, results;
        vm.countries = result.countries;
        vm.min_insurance = 0;
        ref1 = result.countries;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          item = ref1[j];
          ref2 = vm.product.tmp_product.country_id;
          for (l = 0, len2 = ref2.length; l < len2; l++) {
            itemx = ref2[l];
            if (itemx === item._id) {
              vm.countriesView.push(item);
              if (item.min_insurance > vm.min_insurance) {
                vm.min_insurance = item.min_insurance;
                vm.currentCountryId = itemx;
              }
            }
          }
        }
        vm.currencies = result.currencies;
        ref3 = vm.countries;
        results = [];
        for (m = 0, len3 = ref3.length; m < len3; m++) {
          country = ref3[m];
          if (country._id === vm.currentCountryId) {
            results.push((function() {
              var len4, n, ref4, results1;
              ref4 = vm.currencies;
              results1 = [];
              for (n = 0, len4 = ref4.length; n < len4; n++) {
                currency = ref4[n];
                if (country.currency_id === currency._id) {
                  vm.currency_name = currency.data.name;
                  results1.push(RequestService.post('currencynbkr.get_nbkr_rate', {
                    iso: vm.currency_name
                  }).then(function(result) {
                    return vm.currencyRate = result.results;
                  }));
                } else {
                  results1.push(void 0);
                }
              }
              return results1;
            })());
          } else {
            results.push(void 0);
          }
        }
        return results;
      });
    };
    if (vm.product) {
      getCountries();
      vm.insurants = [
        {
          surname: '',
          name: '',
          passport_no: '',
          date_of_birth: '',
          factorListing: angular.copy(vm.product.factorListing),
          factors: angular.copy(vm.product.tmp_product.factors),
          theprice: angular.copy(vm.product.theprice)
        }
      ];
      vm.iconsList.push('fa fa-plus-square');
    } else {
      $state.go("app.apolicy.select");
    }
    addInsurant = function() {
      vm.insurants.push({
        surname: '',
        name: '',
        passport_no: '',
        date_of_birth: '',
        factorListing: angular.copy(vm.product.factorListing),
        factors: angular.copy(vm.product.tmp_product.factors),
        theprice: angular.copy(vm.product.theprice)
      });
      vm.iconsList.push('fa fa-plus-square');
    };
    deleteInsurant = function(index) {
      vm.insurants.splice(index, 1);
      vm.iconsList.splice(index, 1);
    };
    changeIcon = function(index) {
      if (vm.iconsList[index] === 'fa fa-plus-square') {
        return vm.iconsList[index] = 'fa fa-minus-square';
      } else {
        return vm.iconsList[index] = 'fa fa-plus-square';
      }
    };
    reCompute = function(insurant) {
      if (insurant.date_of_birth) {
        insurant.factors['Возраст'] = moment().diff(insurant.date_of_birth, 'years');
        insurant.theprice = $filter('number')(computePrice(insurant), 2);
        console.log(insurant);
        console.log(vm.insurants);
      }
    };
    computePrice = function(insurant) {
      var base_price, basefactor, country_id, country_x, date1, date2, diffDays, factor, fixedamounts, foundcountry, insurance_amount, item_fact, j, l, len1, len2, len3, len4, m, n, obj_x, prod, ref1, ref2, ref3, ref4, theprice, timeDiff;
      prod = angular.copy(vm.product);
      prod.tmp_product.factors = insurant.factors;
      if (vm.countries === null || vm.countries === void 0 || vm.countries.length === 0) {
        console.log("vm.countries is null || vm.countries is undefined || vm.countries.length is 0");
        return;
      }
      if (prod.tmp_product === null || prod.tmp_product === void 0) {
        console.log("vm.prod.tmp_product is null || prod.tmp_product is undefined");
        return;
      }
      theprice = 0;
      base_price = 0;
      insurance_amount = 0;
      foundcountry = false;
      date1 = "";
      date2 = "";
      country_id = [];
      if (prod.tmp_product.country_id === null || prod.tmp_product.country_id === void 0 || prod.tmp_product.country_id.length === 0) {
        prod.tmp_product.country_id = country_id;
      } else {
        country_id = prod.tmp_product.country_id;
      }
      if (prod.tmp_product.date_start === null || prod.tmp_product.date_start === void 0 || prod.tmp_product.date_start === "") {
        prod.tmp_product.date_start = "2016-11-03T18:00:00.000Z";
        date1 = new Date(prod.tmp_product.date_start);
      } else {
        date1 = new Date(prod.tmp_product.date_start);
      }
      if (prod.tmp_product.date_end === null || prod.tmp_product.date_end === void 0 || prod.tmp_product.date_end === "") {
        prod.tmp_product.date_end = "2016-11-04T18:00:00.000Z";
        date2 = new Date(prod.tmp_product.date_end);
      } else {
        date2 = new Date(prod.tmp_product.date_end);
      }
      timeDiff = Math.abs(date2.getTime() - date1.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      if (country_id.length > 1) {
        obj_x = {
          min_insurance: 0,
          country_id: ""
        };
        ref1 = vm.countries;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          country_x = ref1[j];
          if (country_id.indexOf(country_x._id) > -1) {
            if (parseFloat(country_x.min_insurance) > parseFloat(obj_x.min_insurance)) {
              obj_x.min_insurance = country_x.min_insurance;
              obj_x.country_id = country_x._id;
            }
          }
        }
        country_id = obj_x.country_id;
      } else {
        country_id = country_id[0];
      }
      ref2 = prod.basefactors;
      for (l = 0, len2 = ref2.length; l < len2; l++) {
        basefactor = ref2[l];
        if (basefactor.countries_id.indexOf(country_id) > -1 && basefactor.interval.from_day <= diffDays && basefactor.interval.to_day >= diffDays && parseInt(basefactor.insurance_amount) === parseInt(vm.product.insurance_amount)) {
          foundcountry = true;
          base_price = basefactor.base_price;
          if (basefactor.is_per_day) {
            base_price = base_price * diffDays;
          }
          insurance_amount = basefactor.insurance_amount;
        }
      }
      if (foundcountry === false) {
        console.log("the country OR the interval does't match to this product");
        return;
      }
      theprice = base_price;
      fixedamounts = 0;
      ref3 = prod.factors;
      for (m = 0, len3 = ref3.length; m < len3; m++) {
        factor = ref3[m];
        ref4 = factor.factor;
        for (n = 0, len4 = ref4.length; n < len4; n++) {
          item_fact = ref4[n];
          if (prod.tmp_product.factors[item_fact.name] !== null && prod.tmp_product.factors[item_fact.name] !== void 0 && factor.values.indexOf(prod.tmp_product.factors[item_fact.name].toString()) > -1) {
            if (factor.coefficient_type === "Множитель") {
              theprice = theprice * factor.coefficient;
            }
            if (factor.coefficient_type === "Слагаемое") {
              fixedamounts = fixedamounts + factor.coefficient;
            }
          }
        }
      }
      theprice = theprice + fixedamounts;
      theprice = theprice + ((theprice / 100) * 2);
      return theprice;
    };
    savePolicy = function() {
      var agent_id, branch_id, insurance_data, item, j, key, l, len1, len2, policy, policyList, policy_no, ref1, ref2, ref3, theUser, user, value;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
      }
      theUser = Session.getUser();
      if (vm.company) {
        ref1 = vm.company.staff;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          user = ref1[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      vm.product.data;
      insurance_data = angular.copy(vm.product.tmp_product);
      policyList = {
        items: []
      };
      ref2 = vm.insurants;
      for (l = 0, len2 = ref2.length; l < len2; l++) {
        item = ref2[l];
        insurance_data.factors = item.factors;
        insurance_data.factors_list = [];
        ref3 = item.factors;
        for (key in ref3) {
          value = ref3[key];
          value = value + "";
          insurance_data.factors_list.push({
            key: key,
            value: value
          });
        }
        policy_no = vm.product.code;
        if (vm.company.company_type === "agent") {
          agent_id = vm.company._id;
          policy_no = vm.company.code + "00000";
        } else {
          policy_no = policy_no + "00000";
        }
        policy = {
          policy_no: policy_no,
          issue_date: new Date(),
          product_id: vm.product._id,
          company_id: vm.product.company_id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: {
            surname: item.surname.toUpperCase(),
            name: item.name.toUpperCase(),
            passport_no: item.passport_no,
            date_of_birth: item.date_of_birth
          },
          insurance_amount: vm.product.insurance_amount,
          insurance_premium: item.theprice,
          insurance_data: angular.copy(insurance_data),
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency_name,
            insurance_premium_kgs: (item.theprice * vm.currencyRate).toFixed(2)
          }
        };
        policyList.items.push(policy);
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        if (policyList.items.length === 1) {
          policy = angular.copy(policyList.items[0]);
          policy._id = result.resultList[0].id;
          policy._rev = result.resultList[0].rev;
          policy.policy_no = result.resultList[0].policy_no;
          return $state.go('app.apolicy.view', {
            product: policy
          });
        } else {
          return $state.go("app.apolicy.list");
        }
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        var item, j, len1, ref1, temp, to_save;
        if (result) {
          to_save = [];
          ref1 = vm.insurants;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            item = ref1[j];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    pdrobneeIconCnange = function() {
      if (vm.pdrobneeIcon === 'fa fa-chevron-down') {
        vm.pdrobneeIcon = 'fa fa-chevron-up';
      } else {
        vm.pdrobneeIcon = 'fa fa-chevron-down';
      }
    };
    vm.pdrobneeIconCnange = pdrobneeIconCnange;
    vm.changeIcon = changeIcon;
    vm.confirmAction = confirmAction;
    vm.addInsurant = addInsurant;
    vm.deleteInsurant = deleteInsurant;
    vm.reCompute = reCompute;
    vm.savePolicy = savePolicy;
  }).controller('ApolicyViewController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal) {
    'ngInject';
    var FormPolicy, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, findCurrencyName, findMinInsurance, getProducts, goToForm, goToPolicy, issueAgent_policy, sendMail, spoilPolicy, termAgent_policy, vm;
    vm = this;
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    getProducts = function(product_id) {
      var filter;
      filter = {
        with_related: true,
        _id: product_id
      };
      RequestService.post('select.view_listing', filter).then(function(result) {
        vm.product = result.product;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        findMinInsurance();
        findCurrencyName();
        if (!vm.policy.product) {
          vm.policy.product = angular.copy(vm.product);
        }
      });
    };
    findCurrencyName = function() {
      var country, currency, i, j, len, len1, ref, ref1;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        country = ref[i];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            currency = ref1[j];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.policy.policy_no === '00000' && vm.currency_name) {
                RequestService.post('currencynbkr.get_nbkr_rate', {
                  iso: vm.currency_name
                }).then(function(result) {
                  var currencyRate;
                  currencyRate = result.results;
                  return vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * currencyRate).toFixed(2);
                });
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var i, item, itemx, j, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        ref1 = vm.policy.insurance_data.country_id;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          itemx = ref1[j];
          if (itemx === item._id) {
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = $stateParams.product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.apolicy.list");
    } else {
      getProducts(vm.policy.product_id);
    }
    sendMail = function() {
      var countries, country, country_id, i, j, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (i = 0, len = ref.length; i < len; i++) {
        country_id = ref[i];
        ref1 = vm.countries;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          country = ref1[j];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        console.log(result);
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, i, len, policyList, policy_no, policy_to_send, ref, theUser, user;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = vm.company.code + "00000";
      } else {
        policy_no = policy_no + "00000";
      }
      vm.policy.policy_no = policy_no;
      vm.policy.issue_date = new Date();
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      delete vm.policy.product;
      policy_to_send = angular.copy(vm.policy);
      policy_to_send.data.status = 'Оформлен';
      policyList.items.push(policy_to_send);
      RequestService.post('policies.save', policyList).then(function(result) {
        delete vm.product.company;
        delete vm.product.factors;
        delete vm.product.services;
        delete vm.product.basefactors;
        vm.policy.policy_no = result.resultList[0].policy_no;
        vm.policy.data.status = 'Оформлен';
        sendMail();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    issueAgent_policy = function() {
      RequestService.post('currencynbkr.get_nbkr_rate', {
        iso: vm.currency_name
      }).then(function(result) {
        vm.currencyRate = result.results;
        console.log("vm.currencyRate " + vm.currencyRate);
        FormPolicy();
      });
    };
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        'policyNumber': vm.policy.policy_no
      });
    };
    termAgent_policy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.apolicy.list');
    };
    goToForm = function() {
      $state.go('app.apolicy.form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issueAgent_policy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termAgent_policy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
  }).controller('ApolicyShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var cancel, confirmAction, confirmActionForm, confirmActionTerm, date1, diffDays, downloadPDF, goToForm, goToPolicy, spoilPolicy, termPolicy, timeDiff, vm;
    vm = this;
    vm.today = new Date();
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    vm.flag_status_policy = true;
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    vm.current_date = new Date();
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.apolicy.list");
    } else {
      date1 = new Date(vm.policy.issue_date);
      timeDiff = Math.abs(date1.getTime() - vm.today.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays >= 1) {
        vm.flag_status_policy = false;
      }
    }
    spoilPolicy = function() {
      vm.policy.data.status = "Испорчен";
      RequestService.post('policies.put', vm.policy).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $scope.getPolicies();
      });
      return false;
    };
    downloadPDF = function() {
      if (vm.policy.objects === 'TS') {
        if (new Date(vm.policy.issue_date) > new Date('2019-07-22 00:00:00')) {
          ReportService.printReport('TS2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'LN') {
        if (new Date(vm.policy.issue_date) > new Date('2024-09-03 00:00:00')) {
          ReportService.printReport('LN2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'NED') {
        if (new Date(vm.policy.issue_date) > new Date('2019-07-22 00:00:00')) {
          ReportService.printReport('NED2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    termPolicy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.apolicy.list');
    };
    goToForm = function() {
      $state.go('app.apolicy.form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          date1 = new Date(vm.policy.issue_date);
          timeDiff = Math.abs(date1.getTime() - vm.today.getTime());
          diffDays = Math.ceil((timeDiff / (1000 * 3600 * 24)) - 1);
          if (diffDays < 1) {
            spoilPolicy();
          } else {
            toastr.warning('Данная операция невозможна!');
          }
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issuePolicy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  }).controller('ApolicyFormController', function($scope, hotkeys, $state, RequestService, Session, $filter, toastr, $stateParams, $uibModal) {
    'ngInject';
    var SavePolicy, addCollateralNed, cancelNed, confirmActionNed, confirmActionSave, editNed, getInsuranceNedObjects, getPeriods, recalculateOnEventAll, removeNed, vm;
    vm = this;
    vm.today = new Date();
    vm.finish_date = moment(vm.today).add(365, 'day').toDate();
    vm.diffDays = 0;
    vm.min_insurance = 0;
    vm.currency_name = '';
    vm.currencyRate = 1;
    vm.policy = $stateParams.policy;
    vm.policy.date_start = moment().toDate();
    vm.policy.date_end = null;
    vm.ned = null;
    vm.collateralsned = {
      ned: []
    };
    vm.collateralsts = {
      ts: []
    };
    vm.collateralsln = {
      ln: []
    };
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    getInsuranceNedObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: vm.policy.objects
      }).then(function(data) {
        vm.insuranceobjectsned = angular.copy(data.docs);
      });
    };
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, i, j, l, len, len1, len2, len3, len4, len5, ln, m, n, ned, o, period, ref, ref1, ref2, ref3, ref4, ref5, timeDiff, ts;
      date1 = "";
      date2 = "";
      date1 = vm.policy.date_start;
      date2 = vm.policy.date_end || moment(vm.policy.date_start).add(1, 'day').toDate();
      vm.policy.insurance_premium = 0;
      vm.policy.insurance_amount = 0;
      diffDays = 0;
      if (vm.isAnnual) {
        vm.diffDays = 365;
      } else {
        timeDiff = Math.abs(date2.getTime() - date1.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        vm.diffDays = diffDays + 1;
      }
      if (vm.policy.insurance_data.ned) {
        ref = vm.policy.insurance_data.ned;
        for (i = 0, len = ref.length; i < len; i++) {
          ned = ref[i];
          ref1 = vm.periods;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            period = ref1[j];
            if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
              vm.period_rate = period.rate;
            }
            ned.insurance_premium = Math.round(ned.insurance_summ * (ned.objectned.rate / 100) * vm.period_rate);
          }
          vm.policy.insurance_premium += ned.insurance_premium;
          vm.policy.insurance_amount += ned.insurance_summ;
        }
      } else if (vm.policy.insurance_data.ts) {
        ref2 = vm.policy.insurance_data.ts;
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          ts = ref2[l];
          ref3 = vm.periods;
          for (m = 0, len3 = ref3.length; m < len3; m++) {
            period = ref3[m];
            if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
              vm.period_rate = period.rate;
            }
            ts.insurance_premium = Math.round(ts.insurance_summ * (ts.objectts.rate / 100) * vm.period_rate);
          }
          vm.policy.insurance_premium += ts.insurance_premium;
          vm.policy.insurance_amount += ts.insurance_summ;
        }
      } else if (vm.policy.insurance_data.ln) {
        ref4 = vm.policy.insurance_data.ln;
        for (n = 0, len4 = ref4.length; n < len4; n++) {
          ln = ref4[n];
          ref5 = vm.periods;
          for (o = 0, len5 = ref5.length; o < len5; o++) {
            period = ref5[o];
            if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
              vm.period_rate = period.rate;
            }
            ln.insurance_premium = Math.round(ln.insurance_summ * 0.004 * vm.period_rate);
          }
          vm.policy.insurance_premium += ln.insurance_premium;
          vm.policy.insurance_amount += ln.insurance_summ;
        }
      }
    };
    SavePolicy = function() {
      var old_policy_no, policyList, policy_no;
      policyList = {
        items: []
      };
      old_policy_no = vm.policy.policy_no;
      delete vm.policy._id;
      delete vm.policy._created;
      delete vm.policy._deleted;
      delete vm.policy._rev;
      if (vm.policy.insurance_data.ned) {
        policy_no = 'ARS/PI';
        vm.policy.policy_no = policy_no;
        vm.policy.data.status = 'Оформлен';
        vm.policy.data.old_policy_no = old_policy_no;
      } else if (vm.policy.insurance_data.ts) {
        policy_no = 'ARS/VI';
        vm.policy.policy_no = policy_no;
        vm.policy.data.status = 'Оформлен';
        vm.policy.data.old_policy_no = old_policy_no;
      } else if (vm.policy.insurance_data.ln) {
        policy_no = 'ARS/AI';
        vm.policy.policy_no = policy_no;
        vm.policy.data.status = 'Оформлен';
        vm.policy.data.old_policy_no = old_policy_no;
      }
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис сохранен успешно');
        return $state.go('app.apolicy.list');
      });
      return false;
    };
    confirmActionSave = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          SavePolicy();
        }
      });
    };
    getPeriods = function() {
      return RequestService.post('period.listing').then(function(data) {
        vm.periods = angular.copy(data.docs);
      });
    };
    addCollateralNed = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.nedvijimost = {
          owner: insuranceform.owner,
          object: insuranceform.objectned.name,
          adres: insuranceform.adres,
          insurance_summ: insuranceform.insurance_summ,
          insurance_premium: insuranceform.insurance_premium
        };
        vm.collateralsned.ned.push(vm.nedvijimost);
        vm.nedvijimost = {};
        vm.insuranceformned = {
          objectned: null,
          insurance_summ: null,
          insurance_premium: null,
          adres: 'Кыргызская Республика'
        };
        vm.policy.insurance_amountned = vm.policy.insurance_amountned + insuranceform.insurance_summ;
        vm.policy.insurance_premiumned = vm.policy.insurance_premiumned + insuranceform.insurance_premium;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    editNed = function(identity) {
      vm.insuranceformned = identity;
    };
    cancelNed = function() {
      vm.insuranceformned = null;
    };
    removeNed = function(index) {
      vm.neds.splice(index, 1);
    };
    confirmActionNed = function(index) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ProfileDialogController',
        controllerAs: 'profile_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeNed(index);
        }
      });
    };
    vm.getPeriods = getPeriods;
    vm.confirmActionSave = confirmActionSave;
    vm.SavePolicy = SavePolicy;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    vm.getInsuranceNedObjects = getInsuranceNedObjects;
    vm.addCollateralNed = addCollateralNed;
    vm.editNed = editNed;
    vm.cancelNed = cancelNed;
    vm.removeNed = removeNed;
    vm.confirmActionNed = confirmActionNed;
    getInsuranceNedObjects();
    getPeriods();
  }).controller('ApolicyDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    ok = function() {
      $uibModalInstance.close(true);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).controller('TerminateDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    vm.moneyBack = 0;
    ok = function() {
      $uibModalInstance.close(vm.moneyBack);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).filter('filterCountries', function() {
    return function(input, search) {
      var i, item, len, res;
      res = [];
      if (input) {
        for (i = 0, len = input.length; i < len; i++) {
          item = input[i];
          if (item.name.toLowerCase().indexOf(search.toLowerCase()) !== -1 || item.data.name_eng.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
            res.push(item);
          }
        }
      } else {
        return [];
      }
      return res;
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('AgentreportController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var date, downloadExcelRPA, downloadExcelRPAP, downloadPDFRPA, downloadPDFRPAP, getPolicies, m, vm, y;
    vm = this;
    vm.today = new Date();
    date = new Date();
    y = date.getFullYear();
    m = date.getMonth();
    vm.date_start = new Date(y, m, 1);
    vm.date_end = new Date();
    vm.offset = 0;
    vm.limit = 10;
    vm.user = Session.getUser();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20, 50],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'amDateFormat:\'DD MMMM YYYY\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ]
    };
    downloadPDFRPA = function() {
      ReportService.printReport('RPA', {
        'user_id': vm.user.id + '',
        'start_date': moment(vm.date_start).format('MM/DD/YYYY') + '',
        'end_date': moment(vm.date_end).format('MM/DD/YYYY') + ''
      });
    };
    downloadExcelRPA = function() {
      if (vm.company.company_type !== 'agent' && vm.company._id === vm.agent_id) {
        ReportService.saveReportExcel('RPC', {
          'company_id': vm.filter.filter.agent_id + '',
          'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
          end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
        });
        return;
      } else {
        ReportService.saveReportExcel('RPA', {
          'agent_id': vm.filter.filter.agent_id + '',
          'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
          end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
        });
      }
    };
    downloadPDFRPAP = function() {
      ReportService.printReport('RPAP', {
        'agent_id': vm.filter.filter.agent_id + '',
        'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
        end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
      });
    };
    downloadExcelRPAP = function() {
      ReportService.saveReportExcel('RPAP', {
        'agent_id': vm.filter.filter.agent_id + '',
        'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
        end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
      });
    };
    getPolicies = function() {
      if (!vm.company) {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            edit_user_id: vm.user.id,
            date_start: vm.date_start,
            date_end: vm.date_end,
            report_period: ['Оформлен', 'Истек']
          }
        };
      }
      RequestService.post('policies.listing', vm.filter).then(function(data) {
        delete vm.selected_policy;
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadExcelRPA = downloadExcelRPA;
    vm.downloadExcelRPAP = downloadExcelRPAP;
    vm.downloadPDFRPA = downloadPDFRPA;
    vm.downloadPDFRPAP = downloadPDFRPAP;
    vm.getPolicies = getPolicies;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('AgentemployeeController', function(RequestService, Session, email_mask, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var editUser, getUsers, newUser, removeUser, vm;
    vm = this;
    vm.company = Session.getCompany();
    vm.users = {};
    vm.agentemployeeGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'User.username',
          displayName: 'Имя'
        }, {
          name: 'branch',
          displayName: 'Филиал'
        }, {
          name: 'User.email',
          displayName: 'Емайл'
        }, {
          name: 'User.rec_date',
          displayName: 'Дата регистрации'
        }
      ]
    };
    getUsers = function() {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        id: vm.company._id
      };
      RequestService.post('agentemployee.listing', filter).then(function(result) {
        delete vm.selected_agent;
        vm.agentemployeeGridOptions.data = result.users;
        return vm.agentemployeeGridOptions.totalItems = result.count;
      });
    };
    newUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/agentemployee/create.html',
        controller: 'AgentemployeeCreateController',
        controllerAs: 'user',
        size: 'lg',
        resolve: {
          user: void 0
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    editUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/agentemployee/edit.html',
        controller: 'AgentemployeeCreateController',
        controllerAs: 'user',
        size: 'lg',
        resolve: {
          user: angular.copy(vm.selected_user)
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    removeUser = function(row) {
      var removeModal;
      removeModal = $uibModal.open({
        controller: function($scope, $uibModalInstance) {
          var vmm;
          vmm = this;
          vmm.ok = function() {
            return $uibModalInstance.close(vmm.report);
          };
          vmm.cancel = function() {
            return $uibModalInstance.dismiss('cancel');
          };
        },
        controllerAs: 'removeModal',
        template: '<div class="modal-header"><h3>Удаление пользователя</h3></div><div class="modal-body"><h5 class="text-danger">Вы уверены что хотите удалить?</h5></div><div class="modal-footer"><button class="btn btn-primary btn-sm pull-right" ng-click="removeModal.ok()">ок</button><button class="btn btn-default btn-sm pull-right" ng-click="removeModal.cancel()">Отмена</button></div>'
      });
      removeModal.result.then(function(report) {
        RequestService.post('agentemployee.remove', {
          id: vm.selected_user.User.id
        }).then(function(result) {
          getUsers();
        });
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_user = row.entity;
    });
    vm.getUsers = getUsers;
    vm.newUser = newUser;
    vm.editUser = editUser;
    vm.removeUser = removeUser;
    getUsers();
  }).controller('AgentemployeeCreateController', function(RequestService, product_types, user, $scope, $uibModalInstance, Session) {
    'ngInject';
    var cancel, createUser, getBranches, updateUser, vm;
    vm = this;
    if (user === null || user === void 0) {
      vm.user = {};
    } else {
      vm.user = user.User;
    }
    getBranches = function() {
      var company, filter;
      company = Session.getCompany();
      if (company) {
        filter = {
          with_related: true,
          filter: {
            company_id: company._id
          }
        };
      } else {
        filter = {
          with_related: true
        };
      }
      RequestService.post('branch.listing', filter).then(function(data) {
        delete vm.selected_branch;
        vm.branches = data.docs;
      });
    };
    createUser = function() {
      RequestService.post('agentemployee.register', vm.user).then(function(result) {
        $uibModalInstance.close(result);
      });
    };
    updateUser = function() {
      RequestService.post('user.put', vm.user).then(function(result) {
        console.log("updateUser ->result.user = ");
        console.log(result.user);
        $uibModalInstance.close(result);
      });
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.updateUser = updateUser;
    vm.createUser = createUser;
    vm.cancel = cancel;
    vm.getBranches = getBranches;
    getBranches();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('AgentbranchController', function($scope, RequestService, Session, $rootScope, AppStorage, $uibModal) {
    'ngInject';
    var editCompany, getCompanies, newCompany, setActiveCompany, vm;
    vm = this;
    vm.uc = Session.getCompany();
    vm.companiesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'short_name',
          displayName: 'Короткое имя'
        }, {
          name: 'code',
          displayName: 'Код'
        }, {
          name: 'data.addresses[0]',
          displayName: 'Адреса'
        }, {
          name: 'data.phones[0]',
          displayName: 'Телефон'
        }, {
          name: 'data.emails[0]',
          displayName: 'E-mail'
        }, {
          name: 'data.manager',
          displayName: 'Менеджер'
        }, {
          name: 'company_type',
          displayName: 'Тип Компании'
        }, {
          name: 'data.description',
          displayName: 'Описание'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'data.logo',
          displayName: 'Логотип',
          visible: false
        }, {
          name: 'data.industry',
          displayName: 'Отрасль',
          visible: false
        }, {
          name: 'data.status',
          displayName: 'Статус',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата добавления',
          visible: false
        }, {
          name: 'edit_user_id',
          displayName: 'Изменивший',
          visible: false
        }
      ]
    };
    getCompanies = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'branch_company'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        delete vm.selected_company;
        vm.companiesGridOptions.data = data.docs;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_company = angular.copy(row.entity);
    });
    setActiveCompany = function(user_company) {
      RequestService.post('user.set_company', user_company).then(function(result) {
        Session.setCompany(angular.copy(user_company));
        return $rootScope.$broadcast('set-active-company');
      });
    };
    newCompany = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/agentbranch/edit.html',
        controller: 'AgentbranchEditController',
        controllerAs: 'agentbranch',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: void 0
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    editCompany = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/agentbranch/edit.html',
        controller: 'AgentbranchEditController',
        controllerAs: 'agentbranch',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: vm.selected_company
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    vm.getCompanies = getCompanies;
    vm.setActiveCompany = setActiveCompany;
    vm.newCompany = newCompany;
    vm.editCompany = editCompany;
    getCompanies();
  }).controller('AgentbranchEditController', function($scope, RequestService, Session, email_mask, $uibModalInstance, company, toastr, flowFactory) {
    'ngInject';
    var addAddress, addAssistance, addEmail, addPhone, addStaff, addWebsite, deleteAddress, deleteAssistance, deleteEmail, deletePhone, deleteStaff, deleteWebsite, getCompanies, getUsers, handleFileSelect, putCompany, upload, vm;
    vm = this;
    vm.ua = Session.getUser();
    vm.users = [];
    vm.branches = [];
    vm.companiesAsAgents = [];
    vm.agentList = [];
    vm.company = '';
    vm.image = '';
    vm.result_image = '';
    vm.currflow = '';
    vm.uc = Session.getCompany();
    getCompanies = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'branch_company'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        return vm.branches = data.docs;
      });
    };
    if (company === null || company === void 0) {
      vm.company = {
        data: {
          assistants: []
        },
        agents_id: [],
        staff: [],
        company_type: "branch_company"
      };
    } else {
      vm.company = company;
    }
    upload = function() {
      if (!vm.result_image) {
        console.log("vm.result_image == null");
        return;
      }
      RequestService.post('upload/company/' + vm.company._id, {
        file: vm.result_image
      }).then(function(result) {
        vm.company.data.image = 'image/' + result.file;
        vm.currflow.cancel();
        vm.currflow = '';
      });
    };
    handleFileSelect = function(event, $flow, flowFile) {
      var image, reader;
      vm.currflow = $flow;
      if (!flowFile.file.type.startsWith('image/')) {
        toastr.warning('Выберите изображение');
        event.preventDefault();
        return false;
      }
      image = flowFile.file;
      if (angular.isUndefined(image)) {
        return;
      }
      vm.imageLoading = true;
      reader = new FileReader();
      reader.onload = function(event) {
        $scope.$apply(function($scope) {
          vm.imageLoading = false;
          vm.image = event.target.result;
        });
      };
      reader.readAsDataURL(image);
    };
    putCompany = function() {
      console.log(vm.company);
      if (vm.company.name === void 0 || vm.company.name.trim().length === 0) {
        toastr.warning('Укажите имя компании');
        return false;
      }
      if (vm.company.email !== void 0 && !vm.company.email.match(email_mask)) {
        toastr.warning('Укажите валидный email');
        return false;
      }
      vm.company.user_id = 1;
      vm.company.company_type = 'branch_company';
      vm.company.company_id = vm.uc._id;
      RequestService.post('company.put', vm.company).then(function(result) {
        $uibModalInstance.close(result);
      });
      return false;
    };
    vm.putCompany = putCompany;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    getUsers = function() {
      RequestService.post('user.listing').then(function(result) {
        vm.users = result.users;
      });
    };
    vm.currStaff = {
      user_id: '',
      branch_id: ''
    };
    addStaff = function() {
      var i, len, ref, x1;
      if (vm.currStaff.user_id !== null && vm.currStaff.user_id !== void 0) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1.user_id === vm.currStaff.user_id) {
            toastr.warning('Этот user уже в списке');
            return;
          }
        }
        vm.company.staff.push(vm.currStaff);
        vm.currStaff = {
          user_id: '',
          branch_id: ''
        };
        return;
      }
    };
    deleteStaff = function(index) {
      vm.company.staff.splice(index, 1);
    };
    addAssistance = function() {
      var i, len, ref, x1;
      if (vm.assistance !== null && vm.assistance !== void 0) {
        ref = vm.company.data.assistants;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1._id === vm.assistance._id) {
            console.log("Этот ассистанс уже в списке");
            return;
          }
        }
        vm.company.data.assistants.push(vm.assistance);
        return;
      } else {
        alert("В начале выберите Ассистанс !");
        return;
      }
    };
    deleteAssistance = function(index) {
      vm.company.data.assistants.splice(index, 1);
    };
    vm.address = '';
    addAddress = function() {
      if (vm.company.data.addresses === null || vm.company.data.addresses === void 0) {
        vm.company.data.addresses = [];
      } else {
        if (vm.company.data.addresses.includes(vm.address)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.address !== null && vm.address !== void 0 && vm.address !== '') {
        vm.company.data.addresses.push(vm.address);
        vm.address = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteAddress = function(index) {
      vm.company.data.addresses.splice(index, 1);
    };
    vm.email = '';
    addEmail = function() {
      if (vm.company.data.emails === null || vm.company.data.emails === void 0) {
        vm.company.data.emails = [];
      } else {
        if (vm.company.data.emails.includes(vm.email)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.email !== null && vm.email !== void 0 && vm.email !== '') {
        vm.company.data.emails.push(vm.email);
        vm.email = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteEmail = function(index) {
      vm.company.data.emails.splice(index, 1);
    };
    vm.website = '';
    addWebsite = function() {
      if (vm.company.data.websites === null || vm.company.data.websites === void 0) {
        vm.company.data.websites = [];
      } else {
        if (vm.company.data.websites.includes(vm.website)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.website !== null && vm.website !== void 0 && vm.website !== '') {
        vm.company.data.websites.push(vm.website);
        vm.website = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteWebsite = function(index) {
      vm.company.data.websites.splice(index, 1);
    };
    vm.phone = '';
    addPhone = function() {
      if (vm.company.data.phones === null || vm.company.data.phones === void 0) {
        vm.company.data.phones = [];
      } else {
        if (vm.company.data.phones.includes(vm.phone)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.phone !== null && vm.phone !== void 0 && vm.phone !== '') {
        vm.company.data.phones.push(vm.phone);
        vm.phone = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deletePhone = function(index) {
      vm.company.data.phones.splice(index, 1);
    };
    vm.upload = upload;
    vm.handleFileSelect = handleFileSelect;
    vm.deleteStaff = deleteStaff;
    vm.addStaff = addStaff;
    vm.addPhone = addPhone;
    vm.deletePhone = deletePhone;
    vm.addWebsite = addWebsite;
    vm.deleteWebsite = deleteWebsite;
    vm.addEmail = addEmail;
    vm.deleteEmail = deleteEmail;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.addAssistance = addAssistance;
    vm.deleteAssistance = deleteAssistance;
    vm.getCompanies = getCompanies;
    getUsers();
    getCompanies();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('AgentController', function($scope, RequestService, Session, $rootScope, AppStorage, $uibModal) {
    'ngInject';
    var editAgent, getCompanies, newAgent, setActiveCompany, vm;
    vm = this;
    vm.uc = Session.getCompany();
    vm.companiesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'short_name',
          displayName: 'Короткое имя'
        }, {
          name: 'code',
          displayName: 'Код'
        }, {
          name: 'data.addresses[0]',
          displayName: 'Адреса'
        }, {
          name: 'data.phones[0]',
          displayName: 'Телефон'
        }, {
          name: 'data.emails[0]',
          displayName: 'E-mail'
        }, {
          name: 'data.manager',
          displayName: 'Менеджер'
        }, {
          name: 'company_type',
          displayName: 'Тип Компании'
        }, {
          name: 'data.description',
          displayName: 'Описание'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'data.logo',
          displayName: 'Логотип',
          visible: false
        }, {
          name: 'data.industry',
          displayName: 'Отрасль',
          visible: false
        }, {
          name: 'data.status',
          displayName: 'Статус',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата добавления',
          visible: false
        }, {
          name: 'edit_user_id',
          displayName: 'Изменивший',
          visible: false
        }
      ]
    };
    getCompanies = function() {
      var filter;
      filter = {
        with_related: true,
        filter: {
          company_type: 'agent'
        }
      };
      RequestService.post('company.list', filter).then(function(data) {
        delete vm.selected_company;
        vm.companiesGridOptions.data = data.docs;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_company = angular.copy(row.entity);
    });
    setActiveCompany = function(user_company) {
      RequestService.post('user.set_company', user_company).then(function(result) {
        Session.setCompany(angular.copy(user_company));
        return $rootScope.$broadcast('set-active-company');
      });
    };
    newAgent = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/agent/create.html',
        controller: 'AgentCreateController',
        controllerAs: 'company',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: void 0
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    editAgent = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/agent/create.html',
        controller: 'AgentCreateController',
        controllerAs: 'company',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: vm.selected_company
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    vm.getCompanies = getCompanies;
    vm.setActiveCompany = setActiveCompany;
    vm.newAgent = newAgent;
    vm.editAgent = editAgent;
    getCompanies();
  }).controller('AgentCreateController', function($scope, RequestService, Session, email_mask, $uibModalInstance, company, toastr, flowFactory) {
    'ngInject';
    var addAddress, addAssistance, addEmail, addPhone, addStaff, addWebsite, deleteAddress, deleteAssistance, deleteEmail, deletePhone, deleteStaff, deleteWebsite, getUsers, handleFileSelect, putCompany, upload, vm;
    vm = this;
    vm.ua = Session.getUser();
    vm.users = [];
    vm.branches = [];
    vm.companiesAsAgents = [];
    vm.agentList = [];
    vm.company = '';
    vm.image = '';
    vm.result_image = '';
    vm.currflow = '';
    if (company === null || company === void 0) {
      vm.company = {
        data: {
          assistants: []
        },
        agents_id: [],
        staff: [],
        company_type: "agent"
      };
    } else {
      vm.company = company;
    }
    upload = function() {
      if (!vm.result_image) {
        console.log("vm.result_image == null");
        return;
      }
      RequestService.post('upload/company/' + vm.company._id, {
        file: vm.result_image
      }).then(function(result) {
        vm.company.data.image = 'image/' + result.file;
        vm.currflow.cancel();
        vm.currflow = '';
      });
    };
    handleFileSelect = function(event, $flow, flowFile) {
      var image, reader;
      vm.currflow = $flow;
      if (!flowFile.file.type.startsWith('image/')) {
        toastr.warning('Выберите изображение');
        event.preventDefault();
        return false;
      }
      image = flowFile.file;
      if (angular.isUndefined(image)) {
        return;
      }
      vm.imageLoading = true;
      reader = new FileReader();
      reader.onload = function(event) {
        $scope.$apply(function($scope) {
          vm.imageLoading = false;
          vm.image = event.target.result;
        });
      };
      reader.readAsDataURL(image);
    };
    putCompany = function() {
      if (vm.company.name === void 0 || vm.company.name.trim().length === 0) {
        toastr.warning('Укажите имя компании');
        return false;
      }
      if (vm.company.email !== void 0 && !vm.company.email.match(email_mask)) {
        toastr.warning('Укажите валидный email');
        return false;
      }
      vm.company.user_id = 1;
      vm.company.company_id = $scope.app.uc._id;
      RequestService.post('company.put', vm.company).then(function(result) {
        $uibModalInstance.close(result);
      });
      return false;
    };
    vm.putCompany = putCompany;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    getUsers = function() {
      RequestService.post('user.listing').then(function(result) {
        vm.users = result.users;
        console.log(vm.users);
      });
    };
    vm.currStaff = {
      user_id: '',
      branch_id: ''
    };
    addStaff = function() {
      var i, len, ref, x1;
      if (vm.currStaff.user_id !== null && vm.currStaff.user_id !== void 0) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1.user_id === vm.currStaff.user_id) {
            console.log("Этот user уже в списке");
            return;
          }
        }
        vm.company.staff.push(vm.currStaff);
        vm.currStaff = {
          user_id: '',
          branch_id: ''
        };
        return;
      } else {
        alert("В начале выберите user или филиал !");
        return;
      }
    };
    deleteStaff = function(index) {
      vm.company.staff.splice(index, 1);
    };
    addAssistance = function() {
      var i, len, ref, x1;
      if (vm.assistance !== null && vm.assistance !== void 0) {
        ref = vm.company.data.assistants;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1._id === vm.assistance._id) {
            console.log("Этот ассистанс уже в списке");
            return;
          }
        }
        vm.company.data.assistants.push(vm.assistance);
        return;
      } else {
        alert("В начале выберите Ассистанс !");
        return;
      }
    };
    deleteAssistance = function(index) {
      vm.company.data.assistants.splice(index, 1);
    };
    vm.address = '';
    addAddress = function() {
      if (vm.company.data.addresses === null || vm.company.data.addresses === void 0) {
        vm.company.data.addresses = [];
      } else {
        if (vm.company.data.addresses.includes(vm.address)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.address !== null && vm.address !== void 0 && vm.address !== '') {
        vm.company.data.addresses.push(vm.address);
        vm.address = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteAddress = function(index) {
      vm.company.data.addresses.splice(index, 1);
    };
    vm.email = '';
    addEmail = function() {
      if (vm.company.data.emails === null || vm.company.data.emails === void 0) {
        vm.company.data.emails = [];
      } else {
        if (vm.company.data.emails.includes(vm.email)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.email !== null && vm.email !== void 0 && vm.email !== '') {
        vm.company.data.emails.push(vm.email);
        vm.email = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteEmail = function(index) {
      vm.company.data.emails.splice(index, 1);
    };
    vm.website = '';
    addWebsite = function() {
      if (vm.company.data.websites === null || vm.company.data.websites === void 0) {
        vm.company.data.websites = [];
      } else {
        if (vm.company.data.websites.includes(vm.website)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.website !== null && vm.website !== void 0 && vm.website !== '') {
        vm.company.data.websites.push(vm.website);
        vm.website = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteWebsite = function(index) {
      vm.company.data.websites.splice(index, 1);
    };
    vm.phone = '';
    addPhone = function() {
      if (vm.company.data.phones === null || vm.company.data.phones === void 0) {
        vm.company.data.phones = [];
      } else {
        if (vm.company.data.phones.includes(vm.phone)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.phone !== null && vm.phone !== void 0 && vm.phone !== '') {
        vm.company.data.phones.push(vm.phone);
        vm.phone = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deletePhone = function(index) {
      vm.company.data.phones.splice(index, 1);
    };
    getUsers();
    vm.upload = upload;
    vm.handleFileSelect = handleFileSelect;
    vm.deleteStaff = deleteStaff;
    vm.addStaff = addStaff;
    vm.addPhone = addPhone;
    vm.deletePhone = deletePhone;
    vm.addWebsite = addWebsite;
    vm.deleteWebsite = deleteWebsite;
    vm.addEmail = addEmail;
    vm.deleteEmail = deleteEmail;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.addAssistance = addAssistance;
    vm.deleteAssistance = deleteAssistance;
  });

}).call(this);



(function() {
  angular.module('fsa').service('BObjectService', function($rootScope, RequestService, $cacheFactory, $q) {
    var bObject, dictionaryCache;
    bObject = {};
    dictionaryCache = $cacheFactory('dictionaries');
    bObject.list = function(type, filter, nocache) {
      var data, defer;
      if (angular.isUndefined(filter)) {
        filter = {};
      }
      filter.type = type;
      defer = $q.defer();
      data = null;
      if (angular.isUndefined(nocache) || nocache === false) {
        data = dictionaryCache.get(type + JSON.stringify(filter));
      }
      if (data) {
        defer.resolve(data);
      } else {
        RequestService.post('dictionary/listing', filter).then(function(data) {
          dictionaryCache.put(type + JSON.stringify(filter), data);
          return defer.resolve(data);
        }, function(data) {
          return defer.reject(data);
        });
      }
      return defer.promise;
    };
    bObject.clear = function() {
      return dictionaryCache.removeAll();
    };
    return bObject;
  }).service('RequestService', function($http, $rootScope, $q) {
    return {
      post: function(methodName, data, silent, timeOutSec) {
        var result, timedOut, timedOutFunc, timeout;
        timeOutSec = timeOutSec || 60;
        timeout = $q.defer();
        result = $q.defer();
        timedOut = false;
        timedOutFunc = function() {
          timedOut = true;
          timeout.resolve();
        };
        setTimeout(timedOutFunc, 100000 * timeOutSec);
        if (silent) {
          silent;
        }
        data = data || {};
        $rootScope.httPromise = $http({
          method: 'post',
          url: $rootScope.api + methodName,
          data: data,
          cache: false,
          timeout: timeout.promise
        }).success(function(data, status, headers, config) {
          if (!silent) {
            !silent;
          }
          if (data.result === 0) {
            return result.resolve(data);
          } else {
            return result.reject(data);
          }
        }).error(function(data, status, headers, config) {
          if (timedOut) {
            if (!silent) {
              !silent;
            }
            result.reject({
              error: 'timeout',
              message: 'Request took longer than ' + timeOutSec + ' seconds.'
            });
          } else {

          }
          if (!silent) {
            !silent;
          }
          return result.reject(data);
        });
        return result.promise;
      }
    };
  }).service('browser', function($window) {
    var userAgent;
    userAgent = $window.navigator.userAgent;
    return function() {
      return userAgent;
    };
  }).service('Session', function($localStorage) {
    return {
      create: function(token, user, user_company) {
        $localStorage.token = token;
        $localStorage.user = user;
        $localStorage.user_company = user_company;
      },
      setUser: function(user) {
        $localStorage.user = user;
      },
      setUserCompany: function(uc) {
        $localStorage.uc = uc;
      },
      destroy: function() {
        delete $localStorage.token;
        delete $localStorage.user;
        delete $localStorage.user_company;
      },
      getToken: function() {
        return $localStorage.token;
      },
      getUser: function() {
        return $localStorage.user;
      },
      getCompany: function() {
        return $localStorage.user_company;
      }
    };
  }).service('AppToast', function(toastr) {
    return {
      pop: function(type, message) {
        toastr.clear();
        if (toastr.hasOwnProperty(type)) {
          toastr[type](message);
        }
      }
    };
  }).service('AppStorage', function($window) {
    return {
      set: function(key, value) {
        $window.localStorage[key] = value;
      },
      get: function(key) {
        return $window.localStorage[key] || null;
      },
      setObject: function(key, value) {
        $window.localStorage[key] = JSON.stringify(value);
      },
      getObject: function(key) {
        return JSON.parse($window.localStorage[key] || null);
      },
      remove: function(key) {
        var err;
        try {
          $window.localStorage.removeItem(key);
        } catch (error) {
          err = error;
        }
      },
      clear: function() {
        var err;
        try {
          $window.localStorage.clear();
        } catch (error) {
          err = error;
        }
      }
    };
  }).service('passData', function() {
    var getData, passData, setData;
    passData = {};
    setData = function(key, data) {
      return passData[key] = data;
    };
    getData = function(key) {
      return passData[key];
    };
    return {
      setData: setData,
      getData: getData
    };
  }).service('ReportService', function($http, RequestService) {
    var service;
    service = {};
    service.printReport = function(code, params) {
      RequestService.post('reporta.listing', {
        filter: {
          code: code
        }
      }).then(function(data) {
        var report, report_template;
        if (data.report_list && data.report_list.length === 1) {
          report = new Stimulsoft.Report.StiReport();
          report_template = data.report_list[0].template;
          report.load(report_template);
          RequestService.post('reporta.get_query_result', {
            code: code,
            parameters: params
          }).then(function(response) {
            report.dictionary.databases.clear();
            report.regData(code, code, response.data);
            report.render();
            report.print();
          });
        }
      });
    };
    service.saveReportPdf = function(code, params) {
      RequestService.post('reporta.listing', {
        filter: {
          code: code
        }
      }).then(function(data) {
        var report, report_template;
        if (data.report_list && data.report_list.length === 1) {
          report = new Stimulsoft.Report.StiReport();
          report_template = data.report_list[0].template;
          report.load(report_template);
          RequestService.post('reporta.get_query_result', {
            code: code,
            parameters: params
          }).then(function(response) {
            var fileName, settings, stream;
            report.dictionary.databases.clear();
            report.regData(code, code, response.data);
            report.render();
            settings = new Stimulsoft.Report.Export.StiPdfExportSettings;
            service = new Stimulsoft.Report.Export.StiPdfExportService;
            stream = new Stimulsoft.System.IO.MemoryStream();
            service.exportTo(report, stream, settings);
            data = stream.toArray();
            fileName = String.isNullOrEmpty(report.reportAlias) ? report.reportName : report.reportAlias;
            Object.saveAs(data, fileName + '.pdf', 'application/pdf');
          });
        }
      });
    };
    service.saveReportExcel = function(code, params) {
      RequestService.post('report.listing', {
        filter: {
          code: code
        }
      }).then(function(data) {
        var report, report_template;
        if (data.report_list && data.report_list.length === 1) {
          report = new Stimulsoft.Report.StiReport();
          report_template = data.report_list[0].template;
          report.load(report_template);
          RequestService.post('reporta.get_query_result', {
            code: code,
            parameters: params
          }).then(function(response) {
            var fileName, settings, stream;
            report.dictionary.databases.clear();
            report.regData(code, code, response.data);
            report.render();
            settings = new Stimulsoft.Report.Export.StiExcelExportSettings();
            service = new Stimulsoft.Report.Export.StiExcel2007ExportService();
            stream = new Stimulsoft.System.IO.MemoryStream();
            service.exportTo(report, stream, settings);
            data = stream.toArray();
            fileName = String.isNullOrEmpty(report.reportAlias) ? report.reportName : report.reportAlias;
            Object.saveAs(data, fileName + '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
          });
        }
      });
    };
    return service;
  }).factory('authInterceptor', function($rootScope, $q, $location, $log, Session, EVENTS, $base64) {
    return {
      request: function(config) {
        config.headers = config.headers || {};
        if (Session.getToken()) {
          config.headers.Authorization = 'Basic ' + $base64.encode('web' + ':' + Session.getToken());
        }
        $rootScope.$broadcast(EVENTS.requestStart);
        return config;
      },
      requestError: function(rejection) {
        $rootScope.$broadcast(EVENTS.connectionError);
        return $q.reject(rejection);
      },
      responseError: function(rejection) {
        $rootScope.$broadcast(EVENTS.connectionError);
        return $q.reject(rejection);
      },
      response: function(response) {
        $rootScope.$broadcast(EVENTS.requestEnd);
        if (response.data.result === 107) {
          $rootScope.$broadcast(EVENTS.notAuthenticated);
        }
        if (response.data.result > 0) {
          $rootScope.$broadcast(EVENTS.businessError, response.data.message);
        }
        if (response.data.result < 0) {
          $rootScope.$broadcast(EVENTS.applicationError, response.data.message);
        }
        return response || $q.when(response);
      }
    };
  }).service('confirmModal', function($uibModal) {
    return {
      open: function(title, description, options) {
        return $uibModal.open({
          templateUrl: 'app/templates/confirm-modal.html',
          resolve: {
            title: function() {
              return title;
            },
            description: function() {
              return description;
            },
            options: function() {
              return options;
            }
          },
          controller: function($scope, title, description, options, $uibModalInstance) {
            'ngInject';
            var vm;
            vm = this;
            vm.title = title;
            vm.description = description;
            vm.options = options;
            vm.ok = function() {
              var message;
              message = 'ok';
              if (vm.options.comment === true) {
                message = {
                  comment: vm.comment
                };
              }
              return $uibModalInstance.close(message);
            };
            vm.cancel = function() {
              return $uibModalInstance.dismiss('cancel');
            };
          },
          controllerAs: 'confirm'
        });
      }
    };
  });

}).call(this);



(function() {
  angular.module('fsa').run(function($log, $rootScope, amMoment) {
    'ngInject';
    $log.debug('runBlock end');
    $rootScope.api = 'https://mbulak.arsins.kg/';
    amMoment.changeLocale('ru');
  });

}).call(this);



(function() {
  angular.module('fsa').config(function($stateProvider, $urlRouterProvider) {
    'ngInject';
    var args, c, i, j, len, path, r, template, url;
    $stateProvider.state('app', {
      abstract: true,
      url: '/app',
      templateUrl: 'app/main/main.html',
      controller: 'MainController',
      controllerAs: 'app'
    }).state('login', {
      url: '/login',
      templateUrl: 'app/auth/login.html',
      controller: 'AuthController',
      controllerAs: 'auth'
    }).state('register', {
      url: '/register',
      templateUrl: 'app/auth/register.html',
      controller: 'AuthController',
      controllerAs: 'auth'
    }).state('reportPolicy', {
      url: '/reportPolicy/:policyNumber',
      templateUrl: 'app/auth/reportPolicy.html',
      controller: 'AuthReportController',
      controllerAs: 'auth'
    }).state('app.policy_new', {
      url: '/policy/new',
      templateUrl: 'app/policy/new.html',
      controller: 'PolicyNewController',
      controllerAs: 'policies'
    }).state('app.policy_show', {
      url: '/policy/show',
      templateUrl: 'app/policy/show.html',
      controller: 'PolicyShowController',
      controllerAs: 'show',
      params: {
        product: null
      }
    }).state('app.policy_form', {
      url: '/policy/form',
      templateUrl: 'app/policy/form.html',
      controller: 'PolicyFormController',
      controllerAs: 'forming',
      params: {
        policy: null
      }
    }).state('app.policy_select', {
      url: '/policy/select',
      templateUrl: 'app/policy/select.html',
      controller: 'PolicySelectController',
      controllerAs: 'select',
      params: {
        product: null
      }
    }).state('app.policy_issue', {
      url: '/policy/issue',
      templateUrl: 'app/policy/issue.html',
      controller: 'PolicyIssueController',
      controllerAs: 'issue',
      params: {
        product: null,
        policy: null
      }
    }).state('app.policy_view', {
      url: '/policy/view',
      templateUrl: 'app/policy/view.html',
      controller: 'PolicyViewController',
      controllerAs: 'view',
      params: {
        product: null,
        policy: null
      }
    }).state('app.product', {
      abstract: false,
      url: '/product',
      templateUrl: 'app/product/product.html',
      controller: 'ProductController',
      controllerAs: 'product'
    }).state('app.product_new', {
      url: '/product/new',
      templateUrl: 'app/product/new.html',
      controller: 'ProductNewController',
      controllerAs: 'new_product',
      params: {
        product: null
      }
    }).state('app.product_view', {
      url: '/product/view',
      templateUrl: 'app/product/view.html',
      controller: 'ProductViewController',
      controllerAs: 'view_product',
      params: {
        product: null
      }
    }).state('app.report_viewer', {
      url: '/report_viewer',
      templateUrl: 'app/report/reporta.html',
      controller: 'ReportaController',
      controllerAs: 'reporta',
      params: {
        reportMode: 'viewer'
      }
    }).state('app.report_designer', {
      url: '/report_designer',
      templateUrl: 'app/report/reporta.html',
      controller: 'ReportaController',
      controllerAs: 'reporta',
      params: {
        reportMode: 'designer'
      }
    }).state('app.policya.main-limited', {
      url: '/policya-main-limited',
      templateUrl: 'app/policya/main-limited.html',
      controller: 'PolicyaMainController',
      controllerAs: 'main'
    });
    i = [
      {
        'n': 'app.dashboard'
      }, {
        'n': 'app.company'
      }, {
        'n': 'app.agentbranch'
      }, {
        'n': 'app.policy'
      }, {
        'n': 'app.clients',
        'a': true,
        e: true
      }, {
        'n': 'app.clients.list'
      }, {
        'n': 'app.clients.edit',
        'u': '.edit/{id}'
      }, {
        'n': 'app.clients.view',
        'u': '.view/{id}'
      }, {
        'n': 'app.clients.create'
      }, {
        'n': 'app.collateral',
        'a': true,
        e: true
      }, {
        'n': 'app.collateral.list'
      }, {
        'n': 'app.collateral.edit',
        'u': '.edit/{id}'
      }, {
        'n': 'app.collateral.create'
      }, {
        'n': 'app.agent'
      }, {
        'n': 'app.agent.accesses',
        'u': '.accesses/{id}'
      }, {
        'n': 'app.menu'
      }, {
        'n': 'app.menu.item',
        'u': '.item/{id}'
      }, {
        'n': 'app.udf',
        'u': '.udf/{is_admin:bool}'
      }, {
        'n': 'app.role'
      }, {
        'n': 'app.currency'
      }, {
        'n': 'app.category'
      }, {
        'n': 'app.industry'
      }, {
        'n': 'app.unit'
      }, {
        'n': 'app.purpose'
      }, {
        'n': 'app.rule'
      }, {
        'n': 'app.docs',
        'a': true,
        e: true
      }, {
        'n': 'app.docs.list'
      }, {
        'n': 'app.docs.entry',
        u: '.entry/{id}'
      }, {
        'n': 'app.docs.view',
        u: '.view/{id}'
      }, {
        'n': 'app.defaults'
      }, {
        'n': 'app.dictionary'
      }, {
        'n': 'app.profile',
        'a': true
      }, {
        'n': 'app.profile.view'
      }, {
        'n': 'app.profile.edit'
      }, {
        'n': 'app.approval.view',
        u: '.view/{id}'
      }, {
        'n': 'app.payment'
      }, {
        'n': 'app.operation'
      }, {
        'n': 'app.users'
      }, {
        'n': 'app.report'
      }, {
        'n': 'app.reportperiod'
      }, {
        'n': 'app.reportend'
      }, {
        'n': 'app.agentreport'
      }, {
        'n': 'app.report_template'
      }, {
        'n': 'app.doctemplates',
        'a': true,
        'e': true
      }, {
        'n': 'app.doctemplates.list'
      }, {
        'n': 'app.doctemplates.add'
      }, {
        'n': 'app.equipment',
        'a': true,
        e: true
      }, {
        'n': 'app.equipment.list'
      }, {
        'n': 'app.equipment.create'
      }, {
        'n': 'app.equipment.show',
        u: '.show/{id}'
      }, {
        'n': 'app.employee'
      }, {
        'n': 'app.insurancesumm'
      }, {
        'n': 'app.branch'
      }, {
        'n': 'app.agentemployee'
      }, {
        'n': 'app.news',
        'a': true,
        'e': true
      }, {
        'n': 'app.news.list'
      }, {
        'n': 'app.news.form',
        p: {
          'news': null
        }
      }, {
        'n': 'app.news.view',
        p: {
          news: null
        }
      }, {
        'n': 'app.news.uploadimage'
      }, {
        'n': 'app.apolicy',
        'a': true,
        'e': true
      }, {
        'n': 'app.apolicy.list'
      }, {
        'n': 'app.apolicy.new'
      }, {
        'n': 'app.apolicy.select'
      }, {
        'n': 'app.apolicy.form',
        p: {
          policy: null
        }
      }, {
        'n': 'app.apolicy.issue',
        p: {
          product: null
        }
      }, {
        'n': 'app.apolicy.show'
      }, {
        'n': 'app.apolicy.view',
        p: {
          product: null
        }
      }, {
        'n': 'app.hpolicy',
        'a': true,
        'e': true
      }, {
        'n': 'app.hpolicy.list'
      }, {
        'n': 'app.fpolicy',
        'a': true,
        'e': true
      }, {
        'n': 'app.fpolicy.list'
      }, {
        'n': 'app.tpolicy',
        'a': true,
        'e': true
      }, {
        'n': 'app.tpolicy.list'
      }, {
        'n': 'app.regulations',
        'a': true,
        'e': true
      }, {
        'n': 'app.regulations.list'
      }, {
        'n': 'app.regulations.form',
        p: {
          'regulations': null
        }
      }
    ];
    for (j = 0, len = i.length; j < len; j++) {
      r = i[j];
      url = r.n.substring(r.n.lastIndexOf('.') + 1);
      path = r.n.split('.');
      template = [path[0], path[1], (path.length > 2 ? path[2] : path[1]) + '.html'].join('/');
      path[1] = path[1].toUpperCase().charAt(0) + path[1].substring(1);
      if (path.length > 2) {
        path[2] = path[2].toUpperCase().charAt(0) + path[2].substring(1);
      }
      c = path.length > 2 ? path[1] + path[2] : path[1];
      args = {
        url: '.' + url,
        controller: c + 'Controller',
        controllerAs: url,
        abstract: angular.isDefined(r.a && r.a)
      };
      if (angular.isDefined(r.u)) {
        args.url = r.u;
      }
      if (angular.isDefined(r.p)) {
        args.params = r.p;
      }
      if (angular.isDefined(r.t)) {
        args.template = r.t;
      } else if (r.e) {
        args.template = '<ui-view></ui-view>';
      } else {
        args.templateUrl = template;
      }
      console.log('Generated ' + r.n + ' as ' + angular.toJson(args));
      $stateProvider.state(r.n, args);
    }
    return $urlRouterProvider.otherwise('/login');
  });

}).call(this);



(function() {
  angular.module('fsa').constant('moment', moment).constant('EVENTS', {
    loginSuccess: 'auth-login-success',
    loginFailed: 'auth-login-failed',
    logoutSuccess: 'auth-logout-success',
    sessionTimeout: 'auth-session-timeout',
    notAuthenticated: 'auth-not-authenticated',
    notAuthorized: 'auth-not-authorized',
    connectionError: 'http-connection-error',
    businessError: 'business-error',
    applicationError: 'application-error',
    requestStart: 'http-request-start',
    requestEnd: 'http-request-end',
    successMessage: 'business-success',
    errorMessage: 'business-error'
  }).constant('email_mask', /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i).constant('lang_name', 'Русский').constant('insurance_company', [
    {
      "id": 1,
      "name": "ЗАО СК Кыргызинстрах ",
      "director": "Тезекбаева Динара Сарылбековна ",
      "lisience": "18.12.1996г. ",
      "adres": "г.Бишкек. пр. Чуй 219 ",
      "phone": "614588"
    }, {
      "id": null,
      "name": "",
      "director": "",
      "lisience": "",
      "adres": "",
      "phone": "614649"
    }, {
      "id": 2,
      "name": "ЗАО СК Здоровье ",
      "director": "Последова Татьяна Алексеевна ",
      "lisience": "22.04.1993г. ",
      "adres": "г. Бишкек. ул. Токтогула 181 ",
      "phone": "31-28-20, "
    }, {
      "id": null,
      "name": "",
      "director": "",
      "lisience": "",
      "adres": "",
      "phone": "31-29-39 "
    }, {
      "id": 3,
      "name": "ЗАО ««Jubilee Kyrgyzstan  Insurance Company» ",
      "director": "Хегай Валерия Ивановна ",
      "lisience": "15.08.1997г. ",
      "adres": "г. Бишкек .буль. Эркиндик,21 офис 203 ",
      "phone": "541373"
    }, {
      "id": null,
      "name": "",
      "director": " ",
      "lisience": "",
      "adres": " ",
      "phone": "541591"
    }, {
      "id": 4,
      "name": "ЗАО СК «Кыргызстан» ",
      "director": "Аденова Мария Сафаровна ",
      "lisience": "05.07.1991г. ",
      "adres": "г. Бишкек ул. Московская, 76 б ",
      "phone": "38-31-31;  "
    }, {
      "id": null,
      "name": " ",
      "director": "",
      "lisience": "",
      "adres": "",
      "phone": "38-36-36 "
    }, {
      "id": 5,
      "name": "ЗАО СК «А Плюс» ",
      "director": "Каниметов Сейит Дайирович ",
      "lisience": "20.09.2006г. ",
      "adres": "г. Бишкек ул. Абдрахманова 176/1 ",
      "phone": "901531"
    }, {
      "id": null,
      "name": " ",
      "director": " ",
      "lisience": "",
      "adres": "",
      "phone": ""
    }, {
      "id": 6,
      "name": "ЗАО «Мега Иншуренс Групп» ",
      "director": "Исаков Борис Юрьевич ",
      "lisience": "10.09.2008г. ",
      "adres": "Г. Бишкек, ул. К. Акиева,109 ",
      "phone": "39-16-72 "
    }, {
      "id": 7,
      "name": "ЗАО СК «Аманат Полис» ",
      "director": "Джумашев Азамат Мелисович ",
      "lisience": "02.09.2011г. ",
      "adres": "г .Бишкек ул .Горького 1 (Таш Рабат) ",
      "phone": "90-38-24 "
    }, {
      "id": 8,
      "name": "ОАО СК «АЮ Гарант» ",
      "director": "Давлеталиев Санжарбек Усенбекович ",
      "lisience": "27.12.2012г. ",
      "adres": "г. Бишкек, ул. Токтогула 126 ",
      "phone": "66-17-84 "
    }, {
      "id": 9,
      "name": "ЗАО  «СК  АРСЕНАЛЪ-",
      "director": "Сейдахметова  Эльмира ",
      "lisience": "07.06.2013г. ",
      "adres": "г. Бишкек, ул. Орозбекова 26 ",
      "phone": "39 86 86  "
    }, {
      "id": null,
      "name": "КЫРГЫЗСТАН» ",
      "director": "Мусуратбековна ",
      "lisience": "",
      "adres": " ",
      "phone": " "
    }, {
      "id": 10,
      "name": "ЗАО СК «Али Гарант» ",
      "director": "Асанакунов Камиль Таразбекович ",
      "lisience": "12.09.2014г. ",
      "adres": "г.Бишкек, ул. Исанова 42 ",
      "phone": "0701 75 53 18 "
    }, {
      "id": null,
      "name": " ",
      "director": " ",
      "lisience": "",
      "adres": " ",
      "phone": ""
    }, {
      "id": 11,
      "name": "ОАО  «Государственная ",
      "director": "Эгембердиева Джумагуль Шариповна  ",
      "lisience": "11.01.2016г. ",
      "adres": "г. Бишкек пр. Чуй 114 ",
      "phone": "90 01 24 "
    }, {
      "id": null,
      "name": "страховая организация» ",
      "director": "",
      "lisience": "",
      "adres": " ",
      "phone": ""
    }, {
      "id": 12,
      "name": "ЗАО «СК «АТН Полис» ",
      "director": "Сулайманов Нурлан  Эсенгазиевич ",
      "lisience": "14.11.2001г. ",
      "adres": "г. Бишкек ул. Токтогула д. 230 ",
      "phone": "34 30 07 "
    }, {
      "id": 13,
      "name": "ЗАО СК «Алма Иншуренс»  ",
      "director": "Кравченко Александр Михайлович ",
      "lisience": "28.09.2015г. ",
      "adres": "г. Бишкек ул. Медерова д. 117  ",
      "phone": "43 33 33 "
    }, {
      "id": null,
      "name": "",
      "director": " ",
      "lisience": "",
      "adres": "",
      "phone": ""
    }, {
      "id": 14,
      "name": "ЗАО «НСК» ",
      "director": "Хавазов Энвер Нариманович ",
      "lisience": "23.03.2007г. ",
      "adres": "г. Бишкек ул. Турусбекова 109/1 ",
      "phone": "64 45 55 "
    }, {
      "id": null,
      "name": " ",
      "director": " ",
      "lisience": "",
      "adres": "",
      "phone": ""
    }, {
      "id": 15,
      "name": "ЗАО СК «Аксай» ",
      "director": "Аширалиева Чинара Казбековна.  ",
      "lisience": "30.11.2004г. ",
      "adres": "Г. Бишкек пр. Ч. Айтматова 303, СЭЗ «Бишкек» ",
      "phone": "62 27 03 "
    }, {
      "id": null,
      "name": " ",
      "director": "",
      "lisience": "",
      "adres": "",
      "phone": ""
    }, {
      "id": 16,
      "name": "ЗАО СК «Приоритет» ",
      "director": "Алиев Омурбек Мукашевич ",
      "lisience": "14.02.2017г. ",
      "adres": "Г. Бишкек ул. Токтогула д. 169 кв. 45 ",
      "phone": "62 41 71 "
    }, {
      "id": null,
      "name": "",
      "director": " ",
      "lisience": "",
      "adres": "",
      "phone": ""
    }
  ]).constant('coate', [
    {
      "id": 1,
      "code": 41700000000000,
      "parent_id": null
    }, {
      "id": 2,
      "code": 41702000000000,
      "parent_id": null
    }, {
      "id": 3,
      "code": 41702200000000,
      "parent_id": null
    }, {
      "id": 4,
      "code": 41702205000000,
      "parent_id": null
    }, {
      "id": 5,
      "code": 41702205800000,
      "parent_id": null
    }, {
      "id": 6,
      "code": 41702205805000,
      "parent_id": null
    }, {
      "id": 7,
      "code": 41702205805010,
      "parent_id": null
    }, {
      "id": 8,
      "code": 41702205805020,
      "parent_id": null
    }, {
      "id": 9,
      "code": 41702205805030,
      "parent_id": null
    }, {
      "id": 10,
      "code": 41702205805040,
      "parent_id": null
    }, {
      "id": 11,
      "code": 41702205807000,
      "parent_id": null
    }, {
      "id": 12,
      "code": 41702205807010,
      "parent_id": null
    }, {
      "id": 13,
      "code": 41702205807030,
      "parent_id": null
    }, {
      "id": 14,
      "code": 41702205812000,
      "parent_id": null
    }, {
      "id": 15,
      "code": 41702205812010,
      "parent_id": null
    }, {
      "id": 16,
      "code": 41702205812020,
      "parent_id": null
    }, {
      "id": 17,
      "code": 41702205812030,
      "parent_id": null
    }, {
      "id": 18,
      "code": 41702205812060,
      "parent_id": null
    }, {
      "id": 19,
      "code": 41702205813000,
      "parent_id": null
    }
  ]).constant('loterei', [
    {
      "id": 1,
      "name": "ГП “Государственная лотерейная компания”",
      "type": "Мгновенная лотерея\n«ТУЛПАР»",
      "region": "Кыргызская Республика",
      "license_deadline": "Бессрочная",
      "inn": 707201610023,
      "register_license_number": "02.08.18 г.\n№4 Л №0004",
      "stop_license": null,
      "end_license": null,
      "adress": "г. Бишкек пр. Чуй 114/401\n0-312 623925",
      "": null
    }, {
      "id": 2,
      "name": "ГП “Государственная лотерейная компания”",
      "type": "Мгновенная лотерея «Илбирс»",
      "region": "Кыргызская Республика",
      "license_deadline": "Бессрочная",
      "inn": 707201610023,
      "register_license_number": "02.08.18 г.\n№5 Л №0005",
      "stop_license": null,
      "end_license": null,
      "adress": "г. Бишкек пр. Чуй 114/401\n0-312 623925",
      "": null
    }, {
      "id": 3,
      "name": "ГП “Государственная лотерейнвая компания”",
      "type": "Мгновенная лотерея «Жетиген»",
      "region": "Кыргызская Республика",
      "license_deadline": "Бессрочная",
      "inn": 707201610023,
      "register_license_number": "02.08.18 г.\n№3 Л №0003",
      "stop_license": null,
      "end_license": null,
      "adress": "г. Бишкек пр. Чуй 114/401\n0-312 623925",
      "": null
    }, {
      "id": 4,
      "name": "ГП “Государственная лотерейнвая компания”",
      "type": "Мгновенная лотерея «Ордо»",
      "region": "Кыргызская Республика",
      "license_deadline": "Бессрочная",
      "inn": 707201610023,
      "register_license_number": "02.08.18 г.\n№2 Л №0002",
      "stop_license": null,
      "end_license": null,
      "adress": "г. Бишкек пр. Чуй 114/401\n0-312 623925",
      "": null
    }, {
      "id": 5,
      "name": "ГП “Государственная лотерейнвая компания”",
      "type": "Тиражная лотерея «Ала Тоо»",
      "region": "Кыргызская Республика",
      "license_deadline": "Бессрочная",
      "inn": 707201610023,
      "register_license_number": "02.08.18 г.\n№1 Л №0001",
      "stop_license": null,
      "end_license": null,
      "adress": "г. Бишкек пр. Чуй 114/401\n0-312 623925",
      "": null
    }
  ]).constant('license', [
    {
      "id": 1,
      "name": "ОсДО «Рос- Ломбард»",
      "inn": 2404200910152,
      "reg_number": 1,
      "date": "14.08.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй д. 50 кв.19",
      "phone": "0 555039393"
    }, {
      "id": 2,
      "name": "ОсДО «Кредит ВС»",
      "inn": 280220170229,
      "reg_number": 2,
      "date": "22.09.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Суеркулова, рынок Оберон 29 павильон",
      "phone": "0 778587758"
    }, {
      "id": 3,
      "name": "ОсДО «МИКАС»",
      "inn": 1111199910022,
      "reg_number": 3,
      "date": "29,09,2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Киевская д. 250",
      "phone": "0 555128585"
    }, {
      "id": 4,
      "name": "ОсДО Ломбард «Сырга»",
      "inn": 507201710184,
      "reg_number": 4,
      "date": "16.10.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Бейшеналиева д. 29 кв. 45",
      "phone": "0 707951358"
    }, {
      "id": 5,
      "name": "ОсДО «Ломбард »Три семерки Кей Джи",
      "inn": 302201510090,
      "reg_number": 5,
      "date": "16.10.2017",
      "date_update": "Приказ об отзыве № 184 –п от 29.11.2017 г.",
      "coate": "г. Бишкек",
      "adres": "5 мкр. д. 79 кв. 33",
      "phone": "0 770855000"
    }, {
      "id": 6,
      "name": "ОсДо «Надежный ломбард»",
      "inn": 2707201710133,
      "reg_number": 6,
      "date": "16.10.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "мкр. Юг-2 д. 3, кв 29",
      "phone": "0 555701221"
    }, {
      "id": 7,
      "name": "ОсДО «Лига ломбардов»",
      "inn": 2808201710152,
      "reg_number": 7,
      "date": "16.10.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "7 мкр. д. 14 кв. 8",
      "phone": "0 554007007 \n"
    }, {
      "id": 8,
      "name": "ОсДО Ломбард «Миан»",
      "inn": 1210200610067,
      "reg_number": 8,
      "date": "20.10.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул.Тыналиева д. 92",
      "phone": "0 550308838"
    }, {
      "id": 9,
      "name": "ОсДО Ломбард «Грот»",
      "inn": 1509200410244,
      "reg_number": 9,
      "date": "20.10.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Манас ад. 8",
      "phone": "0 550308838"
    }, {
      "id": 10,
      "name": "ОсДО Ломбард «Ясон»",
      "inn": 2707200510090,
      "reg_number": 10,
      "date": "20.10.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "\nпр. Чуй д. 30",
      "phone": "0 550308838 \n"
    }, {
      "id": 11,
      "name": "ОсДО Ломбард «Провид»",
      "inn": 2503201010080,
      "reg_number": 11,
      "date": "20.10.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "мкр. Тунгуч д. 36",
      "phone": "0 550308838"
    }, {
      "id": 12,
      "name": "ОсДО Ломбард «Элайф»",
      "inn": 16032010127,
      "reg_number": 12,
      "date": "20.10.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Кольбаева д. 68",
      "phone": "0 550308838"
    }, {
      "id": 13,
      "name": "ОсДО Сеть ломбардов «Джимо»",
      "inn": 1303201710126,
      "reg_number": 13,
      "date": "20.10.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "3 мкр. д. 24/1",
      "phone": "0 554207702"
    }, {
      "id": 14,
      "name": "ОсДО Ломбард «Ишеним Кредит»",
      "inn": 2504201710102,
      "reg_number": 14,
      "date": "25.10.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Бейшеналиева д. 23",
      "phone": "0 705300500"
    }, {
      "id": 15,
      "name": "ОсДО Ломбард «ЭСЕП - кредит»",
      "inn": 2905200910122,
      "reg_number": 15,
      "date": "28.10.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "5 мкр, д. 58 кв. 36",
      "phone": "0 555977919"
    }, {
      "id": 16,
      "name": "ОсДО Ломбард «03»",
      "inn": 910201710044,
      "reg_number": 16,
      "date": "27.10.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "бульвар Эркиндик д. 43 кв. 32",
      "phone": "0 773666766"
    }, {
      "id": 17,
      "name": "ОсДО Ломбард «Престиж Кредит»",
      "inn": 2411199410098,
      "reg_number": 17,
      "date": "08.11.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Киевская д. 93",
      "phone": "0 555490913"
    }, {
      "id": 18,
      "name": "ОсДО Ломбард «Кредит Траст»",
      "inn": 709201010363,
      "reg_number": 18,
      "date": "08.11.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй д. 257 кв. 6",
      "phone": "0557910035, 0554225188"
    }, {
      "id": 19,
      "name": "ОсДО Ломбард «Автоломбард Кей Джи Плюс»",
      "inn": 2709201710284,
      "reg_number": 19,
      "date": "08.11.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "уу. Абдрахманова д. 45 офис 6",
      "phone": "0 312881008"
    }, {
      "id": 20,
      "name": "ОсДО Ломбард «Илек- Илек»",
      "inn": 1601201710329,
      "reg_number": 20,
      "date": "10.11.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Бейшеналиева д. 23",
      "phone": "0312655970, 0556031937"
    }, {
      "id": 21,
      "name": "ОсДО Ломбард «Астра»",
      "inn": 406199610059,
      "reg_number": 21,
      "date": "14.11.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Байтик Баатыр д. 6-2",
      "phone": "312 268 858"
    }, {
      "id": 22,
      "name": "ОсДО Ломбард «Алтын Дос»",
      "inn": 606201310034,
      "reg_number": 22,
      "date": "10.11.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": ", ул. Бейшеналиева д. 23",
      "phone": "0 551925035"
    }, {
      "id": 23,
      "name": "ОсДО Ломбард «Алтын Дос и Ко»",
      "inn": 1102201610082,
      "reg_number": 23,
      "date": "10.11.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 204",
      "phone": "0 551925035"
    }, {
      "id": 24,
      "name": "ОсДО Ломбард «Сити Кей Джи»",
      "inn": 307201510052,
      "reg_number": 24,
      "date": "14.11.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй д. 194 кв. 15",
      "phone": "0 555301530"
    }, {
      "id": 25,
      "name": "ОсДО Ломбард «Алтын- Куш Групп»",
      "inn": 1306201310168,
      "reg_number": 25,
      "date": "23.11.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 204",
      "phone": "0 705927317"
    }, {
      "id": 26,
      "name": "ОсДО Ломбард «Бай Насыя»",
      "inn": 2511201610084,
      "reg_number": 26,
      "date": "23.11.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Кожомбердиева д. 128",
      "phone": "0 551925035"
    }, {
      "id": 27,
      "name": "ОсДО Ломбард «Бай Казына»",
      "inn": 2206200710312,
      "reg_number": 27,
      "date": "23.11.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Бейшеналиева д. 29, кв.29",
      "phone": "0 555955322"
    }, {
      "id": 28,
      "name": "ОсДО Ломбард «Джади»",
      "inn": 2010200410204,
      "reg_number": 28,
      "date": "01.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Бейшкналиева д. 29/17- 18",
      "phone": "0553525446, 0772525446"
    }, {
      "id": 29,
      "name": "ОсДО Ломбард «СЭР»",
      "inn": 1112200310158,
      "reg_number": 29,
      "date": "04.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул, Байтик Баатыра 1",
      "phone": "312 578 029"
    }, {
      "id": 30,
      "name": "ОсДО Ломабрд «Мани Шоп»",
      "inn": 2510201610036,
      "reg_number": 30,
      "date": "05.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Ч. Вадиханова д. 2",
      "phone": "0 770495500"
    }, {
      "id": 31,
      "name": "ОсДО Ломбард «Тааныш»",
      "inn": 101199410303,
      "reg_number": 31,
      "date": "06.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Курманжан Датка 266",
      "phone": "0 553110225"
    }, {
      "id": 32,
      "name": "ОсДО Ломбард «Акура»",
      "inn": 1806200910087,
      "reg_number": 32,
      "date": "06.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Абдрахманова д. 148, кв. 3",
      "phone": "0 555204427"
    }, {
      "id": 33,
      "name": "ОсДО Ломбард «Русский Капитал»",
      "inn": 2208201710217,
      "reg_number": 33,
      "date": "06.12.2017",
      "date_update": null,
      "coate": "г.Ош",
      "adres": "ул. Зайнабединова д. 13",
      "phone": ""
    }, {
      "id": 34,
      "name": "ОсДО Ломбард «Блиц Кредит»",
      "inn": 3012199910040,
      "reg_number": 34,
      "date": "06.12.2017",
      "date_update": "Прекращена на основании заявления директора ОсДО Кутушова К. О. приказ № 76- П от 06.04.2018 г.",
      "coate": "г. Бишкек",
      "adres": "ул. Киевская 129-2",
      "phone": "0312311272, 0708874300"
    }, {
      "id": 35,
      "name": "ОсДО Ломбард «КЭШ ломбард»",
      "inn": 3005201310115,
      "reg_number": 35,
      "date": "06.12.2017",
      "date_update": null,
      "coate": "с.Ново-Павловка",
      "adres": "ул. Фрунзе д. 172 а",
      "phone": "0 555 010125"
    }, {
      "id": 36,
      "name": "ОсДО Ломбард «Голд ломбард АГА»",
      "inn": 802201710054,
      "reg_number": 36,
      "date": "07.12.2017",
      "date_update": null,
      "coate": "г.Кызыл-Кыя",
      "adres": "ул. Асаналиева б/н.",
      "phone": "0 556434288"
    }, {
      "id": 37,
      "name": "ОсДО Ломбард «Камышай»",
      "inn": 404199610088,
      "reg_number": 37,
      "date": "07.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Турусбекова д. 49",
      "phone": "0 312634718"
    }, {
      "id": 38,
      "name": "ОсДО Ломбард «Три семерки Кей Джи»",
      "inn": 302201510090,
      "reg_number": 38,
      "date": "08.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "5 мкр. д. 79 кв. 33",
      "phone": "0 770855000"
    }, {
      "id": 39,
      "name": "ОсДО «Ломбард «Акча»",
      "inn": 1109200310273,
      "reg_number": 39,
      "date": "11.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Бейшеналиева д. 23",
      "phone": "0 555925025"
    }, {
      "id": 40,
      "name": "ОсДО Ломбард «312»",
      "inn": 807201110262,
      "reg_number": 40,
      "date": "11.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 162",
      "phone": "0 553103333"
    }, {
      "id": 41,
      "name": "ОсДО Ломбард «Алтын Тор»",
      "inn": 2601201210215,
      "reg_number": 41,
      "date": "18.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Жибек Жолу/ Парковая (ТК «Табылга»)",
      "phone": "0 312 363330"
    }, {
      "id": 42,
      "name": "ОсДО Ломбард «Аманат Плюс»",
      "inn": 808201110134,
      "reg_number": 42,
      "date": "19.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Бейшеналиева 23",
      "phone": "0553525446, 0772525446"
    }, {
      "id": 43,
      "name": "ОсДО Ломбард «Дания»",
      "inn": 1003201110042,
      "reg_number": 43,
      "date": "19.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Абрахманова 146",
      "phone": "0 555511393"
    }, {
      "id": 44,
      "name": "ОсДО Ломбард «Алтын Алым»",
      "inn": 1708201710262,
      "reg_number": 44,
      "date": "19.12.2017",
      "date_update": null,
      "coate": "с.Кочкор",
      "adres": "ул. Орозбекова д. 117",
      "phone": "0 55192535"
    }, {
      "id": 45,
      "name": "ОсДО Ломбард «Кунгур»",
      "inn": 1610200210093,
      "reg_number": 45,
      "date": "19.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Курманжан Датка д. 26",
      "phone": "0 772217944"
    }, {
      "id": 46,
      "name": "ОсДО Ломбард «Удача Партнер»",
      "inn": 2803200910044,
      "reg_number": 46,
      "date": "18.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 174",
      "phone": "0 312881747"
    }, {
      "id": 47,
      "name": "ОсДО Ломбард «Озирис»",
      "inn": 206200410225,
      "reg_number": 47,
      "date": "18.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 273-22",
      "phone": "0312 342039 \n"
    }, {
      "id": 48,
      "name": "ОсДО Ломабрд «Сандык Голд»",
      "inn": 1901201510298,
      "reg_number": 48,
      "date": "21.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 155",
      "phone": "0 700100644"
    }, {
      "id": 49,
      "name": "ОсДО Ломбард «Казына Голд»",
      "inn": 1212201310186,
      "reg_number": 49,
      "date": "21.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 155",
      "phone": "0 558125775"
    }, {
      "id": 50,
      "name": "ОсДО Ломбард «Байсал»",
      "inn": 2504201610117,
      "reg_number": 50,
      "date": "22.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Суеркулова рынок «Оберон»",
      "phone": "0 553525446 \n"
    }, {
      "id": 51,
      "name": "ОсДО Ломбард «Даана кредит»",
      "inn": 1002201110213,
      "reg_number": 51,
      "date": "22.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй д. 194, кв, 1",
      "phone": "0 553525446 \n"
    }, {
      "id": 52,
      "name": "ОсДО Ломбард «Тезакча»",
      "inn": 2209201710326,
      "reg_number": 52,
      "date": "20.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Рыскулова д. 95 а, кв. 21",
      "phone": "0 772501511"
    }, {
      "id": 53,
      "name": "ОсДО Ломбард «Тез- Тез»",
      "inn": 1703201010221,
      "reg_number": 53,
      "date": "20.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй д. 204",
      "phone": "0 555958999"
    }, {
      "id": 54,
      "name": "ОсДО Ломбард «ИФК Ломбард»",
      "inn": 3006201010039,
      "reg_number": 54,
      "date": "27.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 50-17",
      "phone": "0 772550222"
    }, {
      "id": 55,
      "name": "ОсДО Ломбард «Дайым»",
      "inn": 1607200110113,
      "reg_number": 55,
      "date": "30.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Токтогула 247",
      "phone": ""
    }, {
      "id": 56,
      "name": "ОсДО Ломбард «Удача»",
      "inn": 1008199410078,
      "reg_number": 56,
      "date": "30.12.2017",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Токтогула 247",
      "phone": ""
    }, {
      "id": 57,
      "name": "ОсДО Ломбард «Манас Плюс»",
      "inn": 108200810087,
      "reg_number": 57,
      "date": "10.01.2018",
      "date_update": null,
      "coate": "г.Ош",
      "adres": "ул. Курманжан Датка 180",
      "phone": "0 777902070"
    }, {
      "id": 58,
      "name": "ОсДО Ломбард «Ан Сан»",
      "inn": 30062000510157,
      "reg_number": 58,
      "date": "10.01.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Киевская 199 а",
      "phone": "299716, 0777510524"
    }, {
      "id": 59,
      "name": "ОсДО Ломбард «Алтынкен Плюс»",
      "inn": 2412201010046,
      "reg_number": 59,
      "date": "10.01.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": ",пр. Чуй 155",
      "phone": ""
    }, {
      "id": 60,
      "name": "ОсДО Ломбард «Ай -Алтын»",
      "inn": 2106201110066,
      "reg_number": 60,
      "date": "10.01.2018",
      "date_update": null,
      "coate": "г.Балыкчы",
      "adres": "ул.Кулакунова 78",
      "phone": "0 703634763"
    }, {
      "id": 61,
      "name": "ОсДО Ломбард «Сыйна»",
      "inn": 1205200410159,
      "reg_number": 61,
      "date": "10.01.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Бейшеналиева 29-19",
      "phone": "645086"
    }, {
      "id": 62,
      "name": "ОсДО Ломбард «Финмаркет»",
      "inn": 2006201710149,
      "reg_number": 62,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г.Нарын",
      "adres": "ул. Токтосунова д. 31, кв. 43",
      "phone": ""
    }, {
      "id": 63,
      "name": "ОсДО Ломбард «Овердрафт плюс»",
      "inn": 2508201610143,
      "reg_number": 63,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г.Нарын",
      "adres": "ул. Ленина д. 174, кв. 2",
      "phone": ""
    }, {
      "id": 64,
      "name": "ОсДО Ломбард «312 Кей Джи»",
      "inn": 911201610094,
      "reg_number": 64,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Абдрахманова 182",
      "phone": ""
    }, {
      "id": 65,
      "name": "ОсДО Ломбард «Акрам Капитал»",
      "inn": 1307200510029,
      "reg_number": 65,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "с. Араван",
      "adres": "ул. М. Султанова 1а- 3",
      "phone": ""
    }, {
      "id": 66,
      "name": "ОсДО Ломбард «Гарант Инвест»",
      "inn": 2108201510070,
      "reg_number": 66,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Нарын",
      "adres": "ул. Кулумбаева д. 23",
      "phone": ""
    }, {
      "id": 67,
      "name": "ОсДО Ломбард «НАКТА»",
      "inn": 503200910096,
      "reg_number": 67,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Бейшеналиева 23",
      "phone": ""
    }, {
      "id": 68,
      "name": "ОсДО Ломбард «ЧИНК»",
      "inn": 1511200210130,
      "reg_number": 68,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "3 мкр. д.24 кв. 33",
      "phone": ""
    }, {
      "id": 69,
      "name": "ОсДО Ломбард «Куранты»",
      "inn": 2708201510255,
      "reg_number": 69,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй д. 175/1",
      "phone": ""
    }, {
      "id": 70,
      "name": "ОсДО Ломбард «Аденис»",
      "inn": 1212200810021,
      "reg_number": 70,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Жибек Жолу 215",
      "phone": ""
    }, {
      "id": 71,
      "name": "ОсДО Ломбард «Булак»",
      "inn": 2508201510117,
      "reg_number": 71,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Ош",
      "adres": "ул. Баялинова б.н.",
      "phone": ""
    }, {
      "id": 72,
      "name": "ОсДО Ломбард «999»",
      "inn": 2710201610161,
      "reg_number": 72,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Кара Балта",
      "adres": "ул. Кожомбердиева 107",
      "phone": ""
    }, {
      "id": 73,
      "name": "ОсДО Ломбард «Элант»",
      "inn": 2003119810115,
      "reg_number": 73,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Тоголок Молдо 26-6",
      "phone": ""
    }, {
      "id": 74,
      "name": "ОсДО Ломбард «№1»",
      "inn": 1806200910293,
      "reg_number": 74,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Кара Балта",
      "adres": "ул. Кожомбердиева 33",
      "phone": ""
    }, {
      "id": 75,
      "name": "ОсДО Ломбард «Нотник Кей Джи»",
      "inn": 3105201310250,
      "reg_number": 75,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г.Бишкек",
      "adres": "ул. абдрахманова д. 135",
      "phone": ""
    }, {
      "id": 76,
      "name": "ОсДО Ломбард «Инвест Ломбард»",
      "inn": 2304201510172,
      "reg_number": 76,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Токтогула 171/1",
      "phone": ""
    }, {
      "id": 77,
      "name": "ОсДО Ломбард «Гобсек»",
      "inn": 912199410036,
      "reg_number": 77,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Киевская 135-3",
      "phone": ""
    }, {
      "id": 78,
      "name": "ОсДО Ломбард «Семь плюс Девять»",
      "inn": 1503200610328,
      "reg_number": 78,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Абдрахманова д. 182",
      "phone": ""
    }, {
      "id": 79,
      "name": "ОсДО Ломбард «Алтын Плюс»",
      "inn": 1503201110046,
      "reg_number": 79,
      "date": "16.02.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Пионер 36",
      "phone": ""
    }, {
      "id": 80,
      "name": "ОсДО Ломбард «Тез Ломбард»",
      "inn": 1201201810211,
      "reg_number": 80,
      "date": "02.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "7 мкр. д. 53 кв.3",
      "phone": ""
    }, {
      "id": 81,
      "name": "ОсДО Ломбард «Дос Ломбард»",
      "inn": 2005201510074,
      "reg_number": 81,
      "date": "12.03.2018",
      "date_update": null,
      "coate": "г. Ош",
      "adres": ", мкр. Достук ул. 47 д. 61",
      "phone": ""
    }, {
      "id": 82,
      "name": "ОсДО Ломбард «ТАРК»",
      "inn": 1211200210030,
      "reg_number": 82,
      "date": "12.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Б. Баатыра д. 3 а, кв. 53",
      "phone": ""
    }, {
      "id": 83,
      "name": "ОсДО Ломбард «Призма»",
      "inn": 2707200910065,
      "reg_number": 83,
      "date": "13.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Киевская 112/3",
      "phone": ""
    }, {
      "id": 84,
      "name": "ОсДО Ломбард «Городской ломбард»",
      "inn": 512201610207,
      "reg_number": 84,
      "date": "13.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Пушкина 283",
      "phone": ""
    }, {
      "id": 85,
      "name": "ОсДО Ломбард «РЭН Плюс»",
      "inn": 2601201810461,
      "reg_number": 85,
      "date": "13.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "мкр. Джал-23, д. 67 кв.13",
      "phone": ""
    }, {
      "id": 86,
      "name": "ОсДО Ломбард «Бумеранг беш плюс»",
      "inn": 3110201710050,
      "reg_number": 86,
      "date": "13.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Н. Айтматовой центральный рынок",
      "phone": ""
    }, {
      "id": 87,
      "name": "ОсДО Ломбард «Кредит Экспресс»",
      "inn": 2410200010139,
      "reg_number": 87,
      "date": "13.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Ч. Айтматова д. 55 кв.13",
      "phone": ""
    }, {
      "id": 88,
      "name": "ОсДО Ломбард «Сапат»",
      "inn": 303201610065,
      "reg_number": 88,
      "date": "13.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 204",
      "phone": ""
    }, {
      "id": 89,
      "name": "ОсДО Ломбард «Д. Ж. Алтын кумуш»",
      "inn": 1109200910170,
      "reg_number": 89,
      "date": "13.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 204",
      "phone": ""
    }, {
      "id": 90,
      "name": "ОсДО Ломбард «Алтын кредит плюс»",
      "inn": 181200710225,
      "reg_number": 90,
      "date": "13.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй д. 119 кв.108",
      "phone": ""
    }, {
      "id": 91,
      "name": "ОсДО Ломбард «Супара»",
      "inn": 709201010112,
      "reg_number": 91,
      "date": "15.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Курманжан Датка 266",
      "phone": ""
    }, {
      "id": 92,
      "name": "ОсДО Ломбард «Алтын Финанс»",
      "inn": 412201510056,
      "reg_number": 92,
      "date": "15.03.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Пионерская 36",
      "phone": ""
    }, {
      "id": 93,
      "name": "ОсДО Ломбард «Альянс А»",
      "inn": 611201510159,
      "reg_number": 93,
      "date": "15.03.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Октябрьская д. 99 кв.35",
      "phone": ""
    }, {
      "id": 94,
      "name": "ОсДО Ломбард «Три Карата»",
      "inn": 412201510104,
      "reg_number": 94,
      "date": "15.03.2018",
      "date_update": null,
      "coate": "Г Бишкек",
      "adres": "ул. Бейшеналиева д. 36",
      "phone": ""
    }, {
      "id": 95,
      "name": "ОсДО Ломбард «Дастан- Бий»",
      "inn": 510201110105,
      "reg_number": 95,
      "date": "19.03.2018",
      "date_update": null,
      "coate": "г. Ош,",
      "adres": "ул. Масалиева 44",
      "phone": ""
    }, {
      "id": 96,
      "name": "ОсДО Ломбард «Азатик»",
      "inn": 1508201710063,
      "reg_number": 96,
      "date": "19.03.2018",
      "date_update": null,
      "coate": "с.Новопавловка",
      "adres": "ул. Северная 168",
      "phone": ""
    }, {
      "id": 97,
      "name": "ОсДО Ломбард «Лазурит»",
      "inn": 1102201110079,
      "reg_number": 97,
      "date": "19.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": ", пр. Чуй д. 155/2",
      "phone": ""
    }, {
      "id": 98,
      "name": "ОсДО Ломбард «Дан Улан»",
      "inn": 502201510030,
      "reg_number": 98,
      "date": "19.03.2018",
      "date_update": "Прекращена действия лицензии на основании Приказа № 186-п от 11 июля 2018 г.",
      "coate": "г. Балыкчы",
      "adres": "ул. Аманбаева 130",
      "phone": ""
    }, {
      "id": 99,
      "name": "ОсДО Ломбард «Нурата»",
      "inn": 312201010139,
      "reg_number": 99,
      "date": "26.03.2018",
      "date_update": null,
      "coate": "г.Жалал-Абад",
      "adres": "Ж-Абад центральный рынок",
      "phone": ""
    }, {
      "id": 100,
      "name": "ОсДО Ломбард «К- Ломбард»",
      "inn": 1101201810173,
      "reg_number": 100,
      "date": "27.03.2018",
      "date_update": null,
      "coate": "г. Ош",
      "adres": "г. Ош",
      "phone": ""
    }, {
      "id": 101,
      "name": "ОсДО Ломбард «Червонец»",
      "inn": 1709200810077,
      "reg_number": 101,
      "date": "28.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "Б. Баатыра д. 67/1",
      "phone": ""
    }, {
      "id": 102,
      "name": "ОсДО Ломбард «Рублевка»",
      "inn": 2011200810010,
      "reg_number": 102,
      "date": "28.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 26",
      "phone": ""
    }, {
      "id": 103,
      "name": "ОсДО Ломбард «Пять минут»",
      "inn": 1506201210091,
      "reg_number": 103,
      "date": "30.03.2018",
      "date_update": null,
      "coate": "Жети Огузский р-н, с. Кызыл Суу",
      "adres": "ул. Ибраева 53",
      "phone": ""
    }, {
      "id": 104,
      "name": "ОсДО «Бай ордо голд»",
      "inn": 1307201610139,
      "reg_number": 104,
      "date": "30.03.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Абдрахманова 150",
      "phone": ""
    }, {
      "id": 105,
      "name": "ОсДО Ломбард «Кредит за пять минут плюс»",
      "inn": 1106201510026,
      "reg_number": 105,
      "date": "04.04.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "7 мкр. д. 42, кв. 58",
      "phone": ""
    }, {
      "id": 106,
      "name": "ОсДО Ломбард «Эстет Кредит»",
      "inn": 901201810097,
      "reg_number": 106,
      "date": "04.04.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Ч. Айтматова д. 5",
      "phone": ""
    }, {
      "id": 107,
      "name": "ОсДО Ломбард «Четыре Д»",
      "inn": 901201710017,
      "reg_number": 107,
      "date": "04.04.2018",
      "date_update": null,
      "coate": "с. Сокулук",
      "adres": "ул. Фрунзе б/н",
      "phone": ""
    }, {
      "id": 108,
      "name": "ОсДО Ломбард «Автоденьги»",
      "inn": 1712201510160,
      "reg_number": 108,
      "date": "04.04.2018",
      "date_update": null,
      "coate": "с. Лебединовка",
      "adres": "пр. Победы 135",
      "phone": ""
    }, {
      "id": 109,
      "name": "ОсДО Ломбард «НУР ПЛЮС»",
      "inn": 2307201510043,
      "reg_number": 109,
      "date": "06.04.2018",
      "date_update": null,
      "coate": "г. Ош",
      "adres": "ул. Курманжан Датка 180",
      "phone": ""
    }, {
      "id": 110,
      "name": "ОсДО Ломбард «Элнар- кредит»",
      "inn": 1302201710264,
      "reg_number": 110,
      "date": "05.04.2018",
      "date_update": null,
      "coate": "г. Жалал- абад",
      "adres": "ул. Нагима Айтматова б-н.",
      "phone": ""
    }, {
      "id": 111,
      "name": "ОсДО «Хрустал Юг»",
      "inn": 1506201710036,
      "reg_number": 111,
      "date": "13.04.2018",
      "date_update": null,
      "coate": "г. Узген",
      "adres": "ул. Манаса д 189. Кв 144.",
      "phone": ""
    }, {
      "id": 112,
      "name": "ОсДО «Гермес»",
      "inn": 1005201710012,
      "reg_number": 112,
      "date": "13.04.2018",
      "date_update": null,
      "coate": "г. Узген",
      "adres": "ул. Манаса б/н.",
      "phone": ""
    }, {
      "id": 113,
      "name": "ОсДО ломбард «Эльфа»",
      "inn": 1807200310115,
      "reg_number": 113,
      "date": "13.04.2018",
      "date_update": null,
      "coate": "г. Кызыл –Кыя",
      "adres": "ул. Молодежная 4",
      "phone": ""
    }, {
      "id": 114,
      "name": "ОсДО Ломбард «Сапат Финанс»",
      "inn": 2604201710133,
      "reg_number": 114,
      "date": "12.04.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Убукеева д. 63",
      "phone": ""
    }, {
      "id": 115,
      "name": "ОсДО Ломбард «МСК- Сервис»",
      "inn": 2410200210176,
      "reg_number": 115,
      "date": "12.04.2018",
      "date_update": null,
      "coate": "с. Сокулук",
      "adres": "ул. Фрунзе д. 132 кв. 34",
      "phone": ""
    }, {
      "id": 116,
      "name": "ОсДО «Альфа Ломбард»",
      "inn": 2411201510172,
      "reg_number": 116,
      "date": "16.04.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Киевская д. 77",
      "phone": ""
    }, {
      "id": 117,
      "name": "ОсДО Ломбард «Дастан –Кредит»",
      "inn": 2502200910070,
      "reg_number": 117,
      "date": "19.04.2018",
      "date_update": null,
      "coate": "г. Кербен",
      "adres": "ул. Уметалиева, б/н.",
      "phone": ""
    }, {
      "id": 118,
      "name": "ОсДО Ломбард «ТИКО»",
      "inn": 410201110169,
      "reg_number": 118,
      "date": "19.04.2018",
      "date_update": "Прекращена на основании заявления директора, приказ № 167-п от 26.06.2018 г.",
      "coate": "г. Бишкек",
      "adres": "пр. Ч. Айтматова 49",
      "phone": ""
    }, {
      "id": 119,
      "name": "ОсДО Ломбард «ГРАДИЕНТ",
      "inn": 2709201610130,
      "reg_number": 119,
      "date": "19.04.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 178 помещения №4",
      "phone": ""
    }, {
      "id": 120,
      "name": "ОсДО Ломбард «Мидас Кредит»",
      "inn": 2209200910086,
      "reg_number": 120,
      "date": "19.04.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 155/5",
      "phone": ""
    }, {
      "id": 121,
      "name": "ОсДО Ломбард «Алмаз»",
      "inn": 911201610131,
      "reg_number": 121,
      "date": "23.04.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чуй б-н.",
      "phone": ""
    }, {
      "id": 122,
      "name": "ОсДО Ломбард «Реал Мани Групп»",
      "inn": 1810201610099,
      "reg_number": 122,
      "date": "26.04.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. К,Датка 193",
      "phone": ""
    }, {
      "id": 123,
      "name": "ОсДО «Ломбард «Тур-Хан»",
      "inn": 1605201710075,
      "reg_number": 123,
      "date": "26.04.2018",
      "date_update": null,
      "coate": "г. Балыкчы",
      "adres": "ул. Иссык-Кульская 116",
      "phone": ""
    }, {
      "id": 124,
      "name": "ОсДО Ломбард «Money Box» (Мани Бокс )",
      "inn": 2906200910142,
      "reg_number": 124,
      "date": "26.04.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Бейшеналиева 36",
      "phone": ""
    }, {
      "id": 125,
      "name": "ОсДО Ломбард «Нур Кредит»",
      "inn": 2502200910067,
      "reg_number": 125,
      "date": "27.04.2018",
      "date_update": null,
      "coate": "г. Жалал-Абад",
      "adres": "ул. Нагима Айтматовой д. 22",
      "phone": ""
    }, {
      "id": 126,
      "name": "ОсДО «Дос Финанс»",
      "inn": 703201810355,
      "reg_number": 126,
      "date": "08.05.2018",
      "date_update": null,
      "coate": "г. Кант",
      "adres": "ул. Ленина д. 55 г",
      "phone": ""
    }, {
      "id": 127,
      "name": "ОсДО Ломбард «Турбозайм»",
      "inn": 2602201810173,
      "reg_number": 127,
      "date": "08.05.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "пр. Чукй д. 194 кв.14",
      "phone": ""
    }, {
      "id": 128,
      "name": "ОсДО Ломбард «Байлык Финанс КБ»",
      "inn": 802201810381,
      "reg_number": 128,
      "date": "08.05.2018",
      "date_update": null,
      "coate": "г. Кара Балта",
      "adres": "ул. Т. Кожомбердиева 121",
      "phone": ""
    }, {
      "id": 129,
      "name": "ОсДО Ломбард «Айдай Кредит»",
      "inn": 2012201010147,
      "reg_number": 129,
      "date": "16.05.2018",
      "date_update": null,
      "coate": "г. Ош",
      "adres": "ул. Кара-Суу д. 26 кв. 49",
      "phone": ""
    }, {
      "id": 130,
      "name": "ОсДО «Ломбард Кант»",
      "inn": 1303201810241,
      "reg_number": 130,
      "date": "16.05.2018",
      "date_update": null,
      "coate": "г. Кант",
      "adres": "ул. Ленина 51",
      "phone": ""
    }, {
      "id": 131,
      "name": "ОсДО Ломбард «КРИСТАЛЛ-АТБ»",
      "inn": 1805201110015,
      "reg_number": 131,
      "date": "16.05.2018",
      "date_update": null,
      "coate": "г. Каракол.",
      "adres": "ул. Л.Толстого 37",
      "phone": ""
    }, {
      "id": 132,
      "name": "ОсДО Ломбард «Жемчуг плюс»",
      "inn": 2903201210088,
      "reg_number": 132,
      "date": "16.05.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Ленина 155",
      "phone": ""
    }, {
      "id": 133,
      "name": "ОсДО Ломбард «Рабия и Ко»",
      "inn": 406201410182,
      "reg_number": 133,
      "date": "16.05.2018",
      "date_update": null,
      "coate": "г. Талас",
      "adres": "ул. Манаса №60/93",
      "phone": ""
    }, {
      "id": 134,
      "name": "ОсДО Ломбард «Манас Плюс»",
      "inn": 108200810087,
      "reg_number": 134,
      "date": "18.05.2018",
      "date_update": null,
      "coate": "г. Ош",
      "adres": "ул. Курманжан-Датка 180",
      "phone": ""
    }, {
      "id": 135,
      "name": "ОсДО Ломбард «Пакровка»",
      "inn": 1001201710096,
      "reg_number": 135,
      "date": "23.05.2018",
      "date_update": null,
      "coate": "с. Покровка",
      "adres": "ул. Кояшева 44",
      "phone": ""
    }, {
      "id": 136,
      "name": "ОсДо Ломбард «Богат 71»",
      "inn": 2110201110201,
      "reg_number": 136,
      "date": "23.05.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Абдрахманова 146",
      "phone": ""
    }, {
      "id": 137,
      "name": "ОсДО Ломбард «Аманат-финанс»",
      "inn": 2309201310107,
      "reg_number": 137,
      "date": "23.05.2018",
      "date_update": null,
      "coate": "с. Кызыл-Суу",
      "adres": "ул. Элебаева 31",
      "phone": ""
    }, {
      "id": 138,
      "name": "ОсДО Ломбард «Выручалка»",
      "inn": 1401201010046,
      "reg_number": 138,
      "date": "28.05.2018",
      "date_update": null,
      "coate": "г. Балыкчы",
      "adres": "ул. Иссык-Кульская 116",
      "phone": ""
    }, {
      "id": 139,
      "name": "ОсДО Ломбард «Агат»",
      "inn": 1302201210044,
      "reg_number": 139,
      "date": "29.05.2018",
      "date_update": null,
      "coate": "г. Ош",
      "adres": "ул. Ленина д. 351",
      "phone": ""
    }, {
      "id": 140,
      "name": "ОсДО Ломбард «Капитал Каракол»",
      "inn": 2002201310074,
      "reg_number": 140,
      "date": "29.05.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "г. Каракол",
      "phone": ""
    }, {
      "id": 141,
      "name": "ОсДО Ломбард «Голден плюс»",
      "inn": 3005201210015,
      "reg_number": 141,
      "date": "29.05.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "г. Каракол",
      "phone": ""
    }, {
      "id": 142,
      "name": "ОсДО Ломбард «Темиржан ата улук»",
      "inn": 2510201010052,
      "reg_number": 142,
      "date": "01.06.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Ленина 155",
      "phone": ""
    }, {
      "id": 143,
      "name": "ОсДО Ломбард «Нуржигит»",
      "inn": 801200910067,
      "reg_number": 143,
      "date": "04.06.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Ленина 155",
      "phone": ""
    }, {
      "id": 144,
      "name": "ОсДО Ломбард «ЛОМБАРДжини",
      "inn": 504201810247,
      "reg_number": 144,
      "date": "12.06.2018",
      "date_update": "Прекращена на основании заявления директора, приказ № 168-п от 26.06.2018 г.",
      "coate": "г. Бишкек",
      "adres": "пр. Чуй 155",
      "phone": ""
    }, {
      "id": 145,
      "name": "ОсДО АЛА-Бука",
      "inn": 603201810098,
      "reg_number": 145,
      "date": "14.06.2018",
      "date_update": null,
      "coate": "Жалал-Абад обл. Ала-Бука р. с. Ала-Бука",
      "adres": "ул. Сартмамбетова 39",
      "phone": ""
    }, {
      "id": 146,
      "name": "ОсДО Ломбард «Сто плюс»»",
      "inn": 1011201710148,
      "reg_number": 146,
      "date": "18.06.2018",
      "date_update": null,
      "coate": "г. Ош",
      "adres": "ул. Масалиева 85",
      "phone": ""
    }, {
      "id": 147,
      "name": "ОсДО Ломбард «Жолуке»",
      "inn": 2712200110032,
      "reg_number": 147,
      "date": "18.06.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Ленина 155",
      "phone": ""
    }, {
      "id": 148,
      "name": "ОсДО Ломбард «Лимонка»",
      "inn": 604201810112,
      "reg_number": 148,
      "date": "21.06.2018",
      "date_update": null,
      "coate": "с. Кызыл Суу",
      "adres": "ул. Ибраева 74",
      "phone": ""
    }, {
      "id": 149,
      "name": "ОсДО ",
      "inn": 22001201010070,
      "reg_number": 149,
      "date": "27.06.2018",
      "date_update": null,
      "coate": "г. Чолпон ата",
      "adres": "ул. Советская 78/1",
      "phone": "555 518 516"
    }, {
      "id": 150,
      "name": "ОсДО Ломбард Алтын Магнит",
      "inn": 1005201810201,
      "reg_number": 150,
      "date": "28..06.18",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Кыштобаева д. 2 кв. 5",
      "phone": ""
    }, {
      "id": 151,
      "name": "ОсДО Ломбард «Магнит Плюс»",
      "inn": 1907201310082,
      "reg_number": 151,
      "date": "28.06.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Ленина 160",
      "phone": ""
    }, {
      "id": 152,
      "name": "ОсДО Ломбард «Элдик»",
      "inn": 1205201710046,
      "reg_number": 152,
      "date": "28.06.2018",
      "date_update": null,
      "coate": "г. Узген",
      "adres": "ул. Манаса б.н.",
      "phone": ""
    }, {
      "id": 153,
      "name": "ОсДО Ломбард «Актив Кредит»",
      "inn": 1906201810076,
      "reg_number": 153,
      "date": "03.07.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "мкр. Тунгуч д. 17/2",
      "phone": ""
    }, {
      "id": 154,
      "name": "ОсДО Ломбард «Билл- и- он»",
      "inn": 2407201210013,
      "reg_number": 154,
      "date": "03.07.2018",
      "date_update": null,
      "coate": "г. Балыкчы",
      "adres": "ул. Каралаева 38",
      "phone": ""
    }, {
      "id": 155,
      "name": "ОсДО Ломбард «Автоплюс»",
      "inn": 2812201110032,
      "reg_number": 155,
      "date": "03.07.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Кыштобаева 159",
      "phone": ""
    }, {
      "id": 156,
      "name": "ОсДО «Нур-Финанс»»",
      "inn": 712201510217,
      "reg_number": 156,
      "date": "10.07.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Дербишева 36",
      "phone": ""
    }, {
      "id": 157,
      "name": "ОсДО Ломбард «Умут»",
      "inn": 212199410037,
      "reg_number": 157,
      "date": "20.07.2018",
      "date_update": null,
      "coate": "г. Кара Балта",
      "adres": "Кожомбердиева рынок «Жайыл» 5 павильон",
      "phone": ""
    }, {
      "id": 158,
      "name": "ОсДО «Ломбард Витас»",
      "inn": 1601201410064,
      "reg_number": 158,
      "date": "27.07.2018",
      "date_update": null,
      "coate": "г. Ош",
      "adres": "ул. Баялинова 1",
      "phone": ""
    }, {
      "id": 159,
      "name": "ОсДО Ломбард «НКБ Капитал»",
      "inn": 806201810206,
      "reg_number": 159,
      "date": "27.07.2018",
      "date_update": null,
      "coate": "г. Нарын",
      "adres": "ул. Ленина 98/1",
      "phone": ""
    }, {
      "id": 160,
      "name": "ОсДО Ломбард «Серебро и Ко»",
      "inn": 2505201710224,
      "reg_number": 160,
      "date": "21.07.2018",
      "date_update": null,
      "coate": "с. Туп",
      "adres": "ул. Элебаева 2",
      "phone": ""
    }, {
      "id": 161,
      "name": "ОсДО Ломбард «ЛОМБАРДжини",
      "inn": 504201810247,
      "reg_number": 161,
      "date": "01.08.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "Чуй 155",
      "phone": ""
    }, {
      "id": 162,
      "name": "ОсДО Ломбард «Тянь- Шань Групп»",
      "inn": 1003201710204,
      "reg_number": 162,
      "date": "03.08.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "Чуй- 50, д. 5",
      "phone": ""
    }, {
      "id": 163,
      "name": "ОсДО Ломбард «Экстра-Тюп»",
      "inn": 507201210012,
      "reg_number": 163,
      "date": "08.08.2018",
      "date_update": null,
      "coate": "с. Тюп",
      "adres": "ул. Элебаева д .70",
      "phone": ""
    }, {
      "id": 164,
      "name": "ОсДО Ломбард «Каракол»",
      "inn": 808199610061,
      "reg_number": 164,
      "date": "08.08.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Орозова-Жусаева б/н",
      "phone": ""
    }, {
      "id": 165,
      "name": "ОсДО «Аурум ломбард»",
      "inn": 3001201810085,
      "reg_number": 165,
      "date": "10.08.2018",
      "date_update": null,
      "coate": "г. Кызыл- Кыя",
      "adres": "ул. Асаналиева б-н",
      "phone": ""
    }, {
      "id": 166,
      "name": "ОсДО Ломбард «Антинарий»",
      "inn": 2802200210144,
      "reg_number": 166,
      "date": "24.08.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "Г. Каракол ул. Ленина 155",
      "phone": ""
    }, {
      "id": 167,
      "name": "ОсДО Ломбард «Рубинь Плюс»",
      "inn": 2709201710195,
      "reg_number": 167,
      "date": "28.08.2018",
      "date_update": null,
      "coate": "Ошск. Обл. г. Узген",
      "adres": "ул. Манаса б-н",
      "phone": ""
    }, {
      "id": 168,
      "name": "ОсДО Ломбард «Корлофф»",
      "inn": 912200410197,
      "reg_number": 168,
      "date": "28.08.2018",
      "date_update": null,
      "coate": "Г. Бишкек",
      "adres": "пр. Чуй 204",
      "phone": ""
    }, {
      "id": 169,
      "name": "ОсДО Ломбард «Монетка»",
      "inn": 611201510161,
      "reg_number": 169,
      "date": "28.08.2018",
      "date_update": null,
      "coate": "Г. Каракол",
      "adres": "ул. Торгоева б-н.",
      "phone": ""
    }, {
      "id": 170,
      "name": "ОсДО Ломбард «Кут - Кредит",
      "inn": 1201200810107,
      "reg_number": 170,
      "date": "10.09.2018",
      "date_update": null,
      "coate": "Г. Бишкек",
      "adres": "ул. Дэн Сяопина д.4",
      "phone": ""
    }, {
      "id": 171,
      "name": "ОсДО «Рус Ломбард»",
      "inn": 1909201710186,
      "reg_number": 171,
      "date": "14.09.2018",
      "date_update": null,
      "coate": "Г. Жала- Абад",
      "adres": "ул. Токтогула 44-4",
      "phone": ""
    }, {
      "id": 172,
      "name": "ОсДО «Ломбард «Зумрат+ К»",
      "inn": 1406201310043,
      "reg_number": 172,
      "date": "14.09.2018",
      "date_update": null,
      "coate": "Г. Каракол",
      "adres": "ул. Ленина 155",
      "phone": ""
    }, {
      "id": 173,
      "name": "ОсДО «Ломбард «Дан Улан»",
      "inn": 502201510030,
      "reg_number": 173,
      "date": "14.09.2019",
      "date_update": null,
      "coate": "Г. Балыкчы",
      "adres": "ул. Аманбаева 130",
      "phone": ""
    }, {
      "id": 174,
      "name": "ОсДО Ломбард «Гарант»",
      "inn": 1702199710046,
      "reg_number": 174,
      "date": "14.09.2018",
      "date_update": null,
      "coate": "Г. Каракол",
      "adres": "ул. Орозова 9",
      "phone": ""
    }, {
      "id": 175,
      "name": "ОсДО Ломбард «Чынара беш плюс»",
      "inn": 2308201810027,
      "reg_number": 175,
      "date": "14.09.2018",
      "date_update": null,
      "coate": "Г. Жалал- Абад",
      "adres": "ул. Н. Айтматова Центральный рынок",
      "phone": ""
    }, {
      "id": 176,
      "name": "ОсДО «ВИП Ломбард»",
      "inn": 3003201810132,
      "reg_number": 176,
      "date": "20.09.2018",
      "date_update": null,
      "coate": "Г. Ош",
      "adres": "ул. А. Навои № 13А",
      "phone": ""
    }, {
      "id": 177,
      "name": "ОсДО «Ломбард 24»",
      "inn": 1901201610051,
      "reg_number": 177,
      "date": "20.09.2018",
      "date_update": null,
      "coate": "Г. Ош",
      "adres": "ул. А. Навои № 13А",
      "phone": ""
    }, {
      "id": 178,
      "name": "ОсДО Ломбард «ДК Инвест плюс»",
      "inn": 607201810205,
      "reg_number": 178,
      "date": "22.09.2018",
      "date_update": null,
      "coate": "Г. Нарын",
      "adres": "ул. Акунова Турганалы д. 11",
      "phone": ""
    }, {
      "id": 179,
      "name": "ОсДО Ломбард «Уют»",
      "inn": 1505200710209,
      "reg_number": 179,
      "date": "01.10.2018",
      "date_update": null,
      "coate": "Г. Кант",
      "adres": "ул. Ленина д. 59",
      "phone": ""
    }, {
      "id": 180,
      "name": "ОсДО Ломбард «Дасмия»",
      "inn": 1608201810049,
      "reg_number": 180,
      "date": "04.10.2018",
      "date_update": null,
      "coate": "Г. Жалал Абад",
      "adres": "ул. Ленина, Центральный рынок",
      "phone": ""
    }, {
      "id": 181,
      "name": "ОсДО Ломбард «Колесо Фортуны»",
      "inn": 1601201710201,
      "reg_number": 181,
      "date": "30.10.2018",
      "date_update": null,
      "coate": "Г. Бишкек",
      "adres": "ул. Московская 69",
      "phone": ""
    }, {
      "id": 182,
      "name": "ОсДО Ломбард «Кредит Капитал»",
      "inn": 1602201710364,
      "reg_number": 182,
      "date": "02.11.2018",
      "date_update": null,
      "coate": "г. Токмок",
      "adres": "ул. Борончиева д 30",
      "phone": ""
    }, {
      "id": 183,
      "name": "ОсДО Ломбард «Кредитный двор»",
      "inn": 2509201810220,
      "reg_number": 183,
      "date": "02.11.2018",
      "date_update": null,
      "coate": "Г. Бишкек",
      "adres": "ул. Кожевенная д. 73",
      "phone": ""
    }, {
      "id": 184,
      "name": "ОсДО Ломбард «Гранд Азия»",
      "inn": 2907201310015,
      "reg_number": 184,
      "date": "01.11.2018",
      "date_update": null,
      "coate": "г. Каракол",
      "adres": "ул. Ленина 160",
      "phone": ""
    }, {
      "id": 185,
      "name": "ОсДО Ломбард «Акниет Плюс»",
      "inn": 23062011110191,
      "reg_number": 185,
      "date": "06.11.2018",
      "date_update": null,
      "coate": "Г. Токмок",
      "adres": "ул. Дубовицкий д. 122 кв. 59",
      "phone": ""
    }, {
      "id": 186,
      "name": "ОсДО Ломбард «Золото 585- Узген»",
      "inn": 111201710051,
      "reg_number": 186,
      "date": "06.11.2018",
      "date_update": null,
      "coate": "Ошск. Обл. Узгенский р-н, Г. Узген",
      "adres": "ул. Манаса б/н.",
      "phone": ""
    }, {
      "id": 187,
      "name": "ОсДО Ломбард «Денежный»",
      "inn": 2706201810195,
      "reg_number": 187,
      "date": "06.11.2018",
      "date_update": null,
      "coate": "С. Сокулук",
      "adres": "ул. Фрунзе д. 132 кв. 26",
      "phone": ""
    }, {
      "id": 188,
      "name": "ОсДО Ломбард «ББ Успех»",
      "inn": 1307201210123,
      "reg_number": 188,
      "date": "06.11.2018",
      "date_update": null,
      "coate": "Г. Токмок",
      "adres": "ул. Советская 106 Б",
      "phone": ""
    }, {
      "id": 189,
      "name": "ОсДО «Микро Капитал»",
      "inn": 303201810122,
      "reg_number": 189,
      "date": "06.11.2018",
      "date_update": null,
      "coate": "г. Бишкек",
      "adres": "ул. Суеркулова д 5/1",
      "phone": ""
    }, {
      "id": 190,
      "name": "ОсДО Ломбард «Кенч Плюс»",
      "inn": 2801201010166,
      "reg_number": 190,
      "date": "06.11.2018",
      "date_update": null,
      "coate": "Г. Ош",
      "adres": "ул. Лумумбы 1а",
      "phone": ""
    }, {
      "id": 191,
      "name": "ОсДО Ломбард «Идеальный»",
      "inn": 3107201710033,
      "reg_number": 191,
      "date": "12.11.2018",
      "date_update": null,
      "coate": "Г. Ош",
      "adres": "ул. Б.Осмонова б/н",
      "phone": ""
    }, {
      "id": 192,
      "name": "ОсДО Тилек Капитал",
      "inn": 806201110107,
      "reg_number": 192,
      "date": "22.11.2018",
      "date_update": null,
      "coate": "Г.Джалал-Абад",
      "adres": "ул. Н. Айтматовой центральный рынок",
      "phone": ""
    }, {
      "id": 193,
      "name": "ДС КАпитал",
      "inn": 2110201510080,
      "reg_number": 193,
      "date": "04.12.2018",
      "date_update": null,
      "coate": "Г. Нарын",
      "adres": "ул. Ленина 65а",
      "phone": ""
    }, {
      "id": 194,
      "name": "ОсДО «Евро Кызыл Суу»",
      "inn": 110201810066,
      "reg_number": 194,
      "date": "04.12.2018",
      "date_update": null,
      "coate": "Иссык-Кульская обл. Жети-Огузский р. с. Кызыл-Суу",
      "adres": "ул. Т.Бербаева 36",
      "phone": ""
    }, {
      "id": 195,
      "name": "ОсДО Байнур Ломбард",
      "inn": 1612201510081,
      "reg_number": 195,
      "date": "05.12.2018",
      "date_update": null,
      "coate": "Чуй обл. г. Кара-Балта",
      "adres": "ул. Кожомбердиева 128",
      "phone": ""
    }, {
      "id": 196,
      "name": "ОсДО Ломбард Келечек",
      "inn": 18012012110223,
      "reg_number": 196,
      "date": "05.12.2018",
      "date_update": null,
      "coate": "Г. Ош",
      "adres": "пр. Масалиева 44",
      "phone": ""
    }, {
      "id": 197,
      "name": "ОсДО Ломбард Берешен и Ко",
      "inn": 3107201310308,
      "reg_number": 197,
      "date": "05.12.2018",
      "date_update": null,
      "coate": "Чуй обл. Панфиловскйи р. с. Панфиловка",
      "adres": "пер. Каиндинский 24",
      "phone": ""
    }, {
      "id": 198,
      "name": "ОсДО Ломбард «Монетка Юг»",
      "inn": 2709201710202,
      "reg_number": 198,
      "date": "05.12.2018",
      "date_update": null,
      "coate": "Ош обл. Кара-Сууйский р. г. Кара-Суу",
      "adres": "ул. Ленина б/н",
      "phone": ""
    }, {
      "id": 199,
      "name": "ОсДО Ломбард «ЭМКО»",
      "inn": 2612200210229,
      "reg_number": 199,
      "date": "05.12.2018",
      "date_update": null,
      "coate": "Г. Бишкек",
      "adres": "ул. Ауэзова 7",
      "phone": ""
    }, {
      "id": 200,
      "name": "ОсДО «Элхан»",
      "inn": 207201410010,
      "reg_number": 200,
      "date": "07.12.2018",
      "date_update": null,
      "coate": "Г. Ош",
      "adres": "ул. Масалиева 44.",
      "phone": ""
    }, {
      "id": 201,
      "name": "ОсДО Ломбард «Нуркен»",
      "inn": 2607201310027,
      "reg_number": 201,
      "date": "07.12.2018",
      "date_update": null,
      "coate": "Г.Джалал-Абад",
      "adres": "ул. Н. Айтматовой б/н",
      "phone": ""
    }, {
      "id": 202,
      "name": "ОсДО Ломбард «Бишкек»",
      "inn": 602201710229,
      "reg_number": 202,
      "date": "07.12.2018",
      "date_update": null,
      "coate": "Г. Бишкек",
      "adres": "ул. Орозбекова д 52 кв 54",
      "phone": ""
    }, {
      "id": 203,
      "name": "ОсДО Ломбард « Салем Алтын",
      "inn": 2910201310292,
      "reg_number": 203,
      "date": "07.12.2018",
      "date_update": null,
      "coate": "Чуй обл. г. Каинды",
      "adres": "ул. Тынчтык б/н",
      "phone": ""
    }, {
      "id": 204,
      "name": "ОсДО Ломбард «Астим»",
      "inn": 3003200510143,
      "reg_number": 204,
      "date": "07.12.2018",
      "date_update": null,
      "coate": "Г. Бишкек",
      "adres": "пр. Чуй 127",
      "phone": ""
    }, {
      "id": 205,
      "name": "ОсДО Ломбард «Алтын Гарант»",
      "inn": 2706201610241,
      "reg_number": 205,
      "date": "11.12.2018",
      "date_update": null,
      "coate": "Чуй обл. г. Кара-Балта",
      "adres": "ул. Кожомбердиева 125",
      "phone": ""
    }, {
      "id": 206,
      "name": "ОсДО Ломбард «ЧС»",
      "inn": 302201110085,
      "reg_number": 206,
      "date": "18.12.2018",
      "date_update": null,
      "coate": "Г. Кара- Балта",
      "adres": "ул. Кожомбердиева 128 тел.",
      "phone": "550694450"
    }, {
      "id": 207,
      "name": "ОсДО Ломбард «Байхан»",
      "inn": 1202200410133,
      "reg_number": 207,
      "date": "18.12.2018",
      "date_update": null,
      "coate": "Г. Жалал- Абад,",
      "adres": "Центральный рынок тел.",
      "phone": "773604440"
    }, {
      "id": 208,
      "name": "ОсДО ломбард «Рейн»",
      "inn": 2204201310079,
      "reg_number": 208,
      "date": "24.12.2018",
      "date_update": null,
      "coate": "Г. Джалал Абад",
      "adres": "ул. Центральный рынок здание КЕНЧ",
      "phone": ""
    }, {
      "id": 209,
      "name": "ОсДО Ломбард «ТС»",
      "inn": 1908201310265,
      "reg_number": 209,
      "date": "25.12.2018",
      "date_update": null,
      "coate": "Г. Бишкек",
      "adres": "ул. Кулатова д. 8/1 тел.",
      "phone": "0700888851, 0558505505"
    }, {
      "id": 210,
      "name": "ОсДо Ломбард «ДЕНИСЛАН»",
      "inn": 1411200310075,
      "reg_number": 210,
      "date": "26.12.2018",
      "date_update": null,
      "coate": "Г.Джалал-Абад",
      "adres": "ул. Н. Айтматовой б/н",
      "phone": ""
    }
  ]).constant('top', [
    {
      "A": "1",
      "B": "Абыдынова Жанаргуль Кошбаевна",
      "C": "№ 013 от 30.06.2005 г.",
      "D": "Узгенский р-н, с. Куршаб, ул.К. Бекмырзаева, 202. т. 0555 807868",
      "E": "_"
    }, {
      "A": "2",
      "B": "Асанова Бермет Баатырбековна",
      "C": "№ 017 от 02.07.2007 г.",
      "D": "г. Бишкек, ул. Гоголя 8-113, т. 289527 д.0543-800741",
      "E": ""
    }, {
      "A": "3",
      "B": "Дыйканалиева Айгуль Эсенкуловна",
      "C": "№ 000107 от 05.08.2002 г.",
      "D": "г. Бишкек, ул. Кольбаева дом 4, кв. 54, М:0553777476 Р:432487",
      "E": ""
    }, {
      "A": "4",
      "B": "Ермолина Тамара Васильевна",
      "C": "№ 006 от 07.07.2004 г.",
      "D": "с. Лебединовка, ул.  Боконбаева 19. т. 937733, 0772-301080, 0770 90 10 80",
      "E": ""
    }, {
      "A": "5",
      "B": "Какилов Тобокел",
      "C": "№ 020 от 23.01.2009 г.",
      "D": "г. Бишкек, ул. Садыбакасова 168. 0772-070062, 568602",
      "E": ""
    }, {
      "A": "6",
      "B": "Касымов Сакымамат",
      "C": "№023 от 19.02.2009 г.",
      "D": "г. Бишкек, мкр. Асанбай, 41-84 т:543475 р., 416108 д., 0772-227128",
      "E": ""
    }, {
      "A": "7",
      "B": "Колосова Любовь Сергеевна",
      "C": "№022 от 23.01.2009 г.",
      "D": "г. Бишкек, ул. Киевская, 218/4. т: 51-65-35, 0550-98-18-57, 0705-98-18-57",
      "E": ""
    }, {
      "A": "8",
      "B": "Кочунц Эдуард Михайлович",
      "C": "№ 015 от 24.01.2007 г.",
      "D": "Аламудунский район, с. Лебединовка, пр. Ленина 4-28. М:0777 456622 Р:0312 333076",
      "E": ""
    }, {
      "A": "9",
      "B": "Махкамов Сабиржан",
      "C": "№ 014 от 13.07.2005 г.",
      "D": "г. Ош, ул.К-Датка 264/6. т. 03222-21553 д.0772-391852 ",
      "E": ""
    }, {
      "A": "10",
      "B": "Новикова Наталья Даниловна",
      "C": "№ 008 от 07.07.2004 г.",
      "D": "г. Бишкек, ул. Исанова 42. т: 0779-88-88-28",
      "E": ""
    }, {
      "A": "11",
      "B": "Орозобаев Жекшенбек Мухамбетович",
      "C": "№ 016 от 02.07.2007 г. ",
      "D": "г. Бишкек, 7 мкр, дом 11, кв. 48. т:664015 р.469610 д.0772-627468 ",
      "E": ""
    }, {
      "A": "12",
      "B": "Самудинов Каныбек",
      "C": "№ 011 от 13.02.1995 г.",
      "D": "Нарынская обл, Жумгалский р-н, с. Чаек, ул.Э-Сапарбекова 161. т. 03536-22146 д.0773-858668 ",
      "E": ""
    }, {
      "A": "13",
      "B": "Ускенбаева Гульнара Тураровна",
      "C": "№024 от 07.09.2009 г.",
      "D": "г. Бишкек, пр. Манаса, 5-11. т. 0555923272 ",
      "E": ""
    }, {
      "A": "14",
      "B": "Халип Людмила Ивановна",
      "C": "№ 010 от 27.12.2004 г.",
      "D": "Иссык-Кульский р-н, с. Бостери, ул. Мамытова 14/31. т: 03943-35379 д., 03943-43957 р.",
      "E": ""
    }, {
      "A": "15",
      "B": "Гетман Валерия Валерьевна",
      "C": "№026 от 25.03. 2010 г.",
      "D": "г. Бишкек, ул. Новая 1а, кв. 17. т. 664452, 664844, 0 555 975 284",
      "E": ""
    }, {
      "A": "16",
      "B": "Асанбеков Нурбек Укубаевич",
      "C": "№ 027 от 22.08.2011 г.",
      "D": "г.  Бишкек, мкр. Джал 12, кв.13. т.0552-32-48-42",
      "E": ""
    }, {
      "A": "17",
      "B": "Сарикеев Абдылда Жумабекович",
      "C": "№ 028 от 05.12.2011 г.",
      "D": "с. Байтик, ул, Эшмамбет уулу Асылбек, дом 36.  т: 0555-35-39-48, 0772-24-82-24, 42-18-13",
      "E": ""
    }, {
      "A": "18",
      "B": "Калиева Жаныл Кутпидиновна",
      "C": "№029 от 23.01.2012 г.",
      "D": "г. Бишкек ул.Каховская 37, кв.89. т: 0773177306",
      "E": ""
    }, {
      "A": "19",
      "B": "Иманалиев Казы Султаналиевич",
      "C": "№ 030 от 10.10.2012 г.",
      "D": "Кочкорский р-н, с.Кала-Тоо, ул,Жээк, 11",
      "E": ""
    }, {
      "A": "",
      "B": "",
      "C": "",
      "D": "т:0779-277636",
      "E": ""
    }, {
      "A": "20",
      "B": "Белецкая  Емма Генриховна",
      "C": "№ 031 от 06.08.2013 г.",
      "D": "г. Кара-Балта, квартал Западный дом 14, кв. 7",
      "E": ""
    }, {
      "A": "",
      "B": "",
      "C": "",
      "D": "0777-97-97-02 ",
      "E": ""
    }, {
      "A": "21",
      "B": "Качканаков Озубек Эсенбекович",
      "C": "№032 от 20.09.2013 г.",
      "D": "с. Лебединовка, пр. Победы 173 т: 0550-018692",
      "E": ""
    }, {
      "A": "22",
      "B": "Султаналиева Нуржамал Кочербековна",
      "C": "№033 от29.01.2014 г.",
      "D": "с. Лебединовка, городок Энергетиков, дом 13.кв 33 т:75-15-92, 0550-506-999",
      "E": ""
    }, {
      "A": "23",
      "B": "Намазбеков Абдыкерим Жусупович",
      "C": "№ 034 от 04.03.2014 г.",
      "D": "с. Беш-Кунгей ул. Масадыка 46.                              т: 0779-051906",
      "E": ""
    }, {
      "A": "24",
      "B": "Карпыкова Айым Руслановна",
      "C": "№ 035 от 09.12.2015 г.",
      "D": "г. Бишкек, ул. Гоголя, 113 кв.49 ",
      "E": ""
    }, {
      "A": "",
      "B": "",
      "C": "",
      "D": "426494, 0770988060",
      "E": ""
    }, {
      "A": "25",
      "B": "Исираилов Абсамат Жоробекович",
      "C": "№036 от 23.12. 2015 г.",
      "D": "г. Бишкек ул. Усенбаева 191 ",
      "E": ""
    }, {
      "A": "",
      "B": "",
      "C": "",
      "D": "Т. 0772777221",
      "E": ""
    }, {
      "A": "26",
      "B": "Назаралиева Жаныл Тууганбаевна ",
      "C": "№ 037 от 11.03.2016 г. ",
      "D": "г. Бишкек ул. Древесная д.26 а.тел:0550711735 ",
      "E": ""
    }, {
      "A": "27",
      "B": "Рузиев Акимжан Якубович ",
      "C": "№ 038 от 05.04.2017 г. ",
      "D": "Кыргызская Республика, Чуйская область., Аламудунский р-н, с. Кок-Жар, ул Карагул Акмат, 14/2 Тел 0555-350617",
      "E": ""
    }, {
      "A": "28",
      "B": "Султанов Бек Шайбекович",
      "C": "№ 039 от 23.08.2017 г.",
      "D": "Кыргызская Республика г. Бишкек 11 мкр. Д.17а, кв14. Тел; 0550347722, 0700 087440",
      "E": ""
    }, {
      "A": "29",
      "B": "Черикчиева Мээрим Койчубековна ",
      "C": "№ 040 от 24.08.2017 г.",
      "D": "Кыргызская Республика г. Бишкек 4 мкр. ",
      "E": ""
    }, {
      "A": "",
      "B": "",
      "C": "",
      "D": "д 26/1 кв. 9  Тел; 0555311797 ",
      "E": ""
    }, {
      "A": "30",
      "B": "Нургазиева Рауза Каныбековна ",
      "C": "№041 от 17.10.2017 г. ",
      "D": "г. Бишкек мкр. Джал – 15.д.30.кв 27 0772500502",
      "E": ""
    }, {
      "A": "31",
      "B": "Бейшеналиева Алтынай Ускенбековна",
      "C": "№042 от 25.12.2017 г.",
      "D": "г. Бишкек ул. Московская д.183 кв.78",
      "E": ""
    }, {
      "A": "32",
      "B": "Койчубекова Гульнара Турсунбековна",
      "C": "№ 043 от  17.04.2018 г.",
      "D": "г. Бишкек ул. Салиева229/1 кв.20 Тел:0708889080",
      "E": ""
    }, {
      "A": "33",
      "B": "Ибраймакунов Айдар Касымович",
      "C": "№044 от 18.04.2018 г.",
      "D": "г. Бишкек мкр.12.,д.62 кв.80 Тел: 0555798189",
      "E": ""
    }, {
      "A": "34",
      "B": "Мамбетова Нургуль Кулбаевна",
      "C": "№045 от 28.05.2018 г.",
      "D": "г. Бишкек ул.Ж-Жолу д 478 Тел 0552959576",
      "E": ""
    }, {
      "A": "35",
      "B": "Калинина Анна Владимировна",
      "C": "№ 046 от 12.10.2018 г",
      "D": "г. Бишкек ул. Л.Толстого 204-11 0772322255",
      "E": ""
    }
  ]).constant('audit', [
    {
      "A": "1",
      "B": "Общественное объединение «Палата бухгалтеров и аудиторов Кыргызской Республики  ",
      "C": "г. Бишкек пр. Чуй, 106-101 г.Бишкек бул.М. Гвардии 27 тел:0312653467,653468",
      "D": "Леднева Н.Е. Атаханов Ш.Е. Беличенко А. И. Аргинов Б. А",
      "E": "Действительных членов в реестре ПБА на 19.11.2004 г 289 человек. ",
      "F": ""
    }, {
      "A": "2",
      "B": "Общественное объединение «Объединение бухгалтеров и аудиторов» ",
      "C": "г. Бишкек булл. Эркиндик, 42-1 ",
      "D": "Ан Н. В. Афонина О. Г. Белецкая Э. Г. Бочаринкова Т. Ф Винникова В. В. Гофлин Л. Г. Курманалиева Г. К. Качаева И. М. Морозова Е. Е. Полтавская Г. Я. Самарская Е. Ф. Сабко С. В. Турдышаева Э Г.",
      "E": "Действительных членов в реестре ОБА на 19.01.2005 года 57 человек",
      "F": ""
    }, {
      "A": "3",
      "B": "Общественное объединение «Общественное объединение преподавателей бухгалтерского учета и аудитора ",
      "C": "г. Бишкек ул. Гоголя 20-92",
      "D": "",
      "E": "Действительных членов в реестре ОПБА 43 человек ",
      "F": ""
    }, {
      "A": "4",
      "B": "Общественное объединение «Ассоциация бухгалтеров и аудиторов Кыргызской Республики «АБА»",
      "C": "",
      "D": "",
      "E": "",
      "F": ""
    }, {
      "A": "5",
      "B": "Объединение юридических лиц «Интернациональный Союз Независимых Аудиторов»  ",
      "C": "г. Бишкек ул. Атбашинская ,5/7 тел: 0312 321943",
      "D": "Абдраманова Э. А. Истемесова Ж. К Мусаева Р. И. ",
      "E": "",
      "F": ""
    }, {
      "A": "6",
      "B": "Объединение юридических лиц Ассоциация «Совета по финансовой отчетности и аудиту»",
      "C": "г. Бишкек булл. М. Гвардии 20/1 тел: 0312 391713, 641828 ",
      "D": "Самарская Е. Ф.Алапаев А. Б\n" + "Мишунова Л. Я. Бутенко Н. В. Ермолина Т. В. Кобрицева Н. Н. Леднева Н. Е. Пухирева Е. Ю Ростопина Г. Р. Чупрета О. А. Шейшекеева Д. С.\n",
      "E": "",
      "F": ""
    }, {
      "A": "7",
      "B": "Общественное объединение «Институт Профессиональных бухгалтеров и аудиторов Кыргызстана» ",
      "C": "г. Бишкек ул.Орозбекова. д110 А, кВ.1.  \n" + "тел 0312298498, 0555500182\n ",
      "D": "Ускенбаева Г. Т. Абдыгулов Т. С. Бабби Бароэнс",
      "E": "",
      "F": ""
    }
  ]).constant('auditor', [
    {
      "A": "1.",
      "B": "ОсОО «Делойт и Туш»\nДиректор – Садырбекова Канышай Садырбековна",
      "C": "г. Бишкек, пр. Манаса, 40,\nтел 39-82-88\ne-mail\nBishkek@deloitte.kg",
      "D": "Садырбекова К.С.\nФакердиноваА.М.\nКаниметова М.С.",
      "E": "№ 0001 от 04.11.2002 года",
      "F": ""
    }, {
      "A": "2.",
      "B": "ОсОО Аудиторская фирма «ВЛАТА – Аудит»\nДиректор – Ермолина Тамара Васильевна",
      "C": "г. Бишкек, ул. Лермонтова, 2\nтел: 902-196, 902-195.\nФакс 902-195\ne-mail\naudit@vlata.kg,",
      "D": "Винникова В.В\nЕрмолова Т.В.",
      "E": "№ 0003 от 27.02.2003 г.",
      "F": ""
    }, {
      "A": "3.",
      "B": "ОсОО «Компания «Консультант»\nГенеральный директор – Самарский Ярослав Владимирович",
      "C": "г. Бишкек, ул. Боконбаева 162\nтел.:,0555-371-651\n93-77-33\ne-mail\nbit-rushana@yandex.ru",
      "D": "Пухирова Е.Ю.\nСабко С. В.",
      "E": "№ 0004 от 10.04.2003 год.",
      "F": ""
    }, {
      "A": "4.",
      "B": "ОсОО «ПрайсуотерхаусКуперс Бишкек»\nДиректор – Каирова Гульнара Аубакировна",
      "C": "г. Бишкек, ул. Профессора Зимы, 38а\nтел.: 690542; факс 690528",
      "D": "Каирова Г.А.\nТажиев Э.К.",
      "E": "№ 0005 от 24.06.2003 год.",
      "F": ""
    }, {
      "A": "5.",
      "B": "ОсОО «Тандем аудит»\nДиректор – Соломатова Ирина Петровна",
      "C": "г. Бишкек, ул. Московская, 41а-9,\nтел: 48-66-42, 48-61-95\ne-mail\notandem@gmail.com",
      "D": "Соломатова И.П.\nДоолоталиева Г.А",
      "E": "№ 0006 от 06.08.2003 г.",
      "F": ""
    }, {
      "A": "6.",
      "B": "ЗАО «В. Якобс-Аудит»\nДиректор - Растокина Галина Радиковна",
      "C": "г. Бишкек, ул. Салиева, 72\nтел.: 367370, факс 367441\n\ne-mail\nwww.jacobs-audit.kg",
      "D": "Раскоткина Г. Р\nГеоргиади Л.Х,\nБочков М. Я,\nМорозова Е. Е\nКутепова Т. Ф",
      "E": "№ 0007 от 06.08.2003г.",
      "F": ""
    }, {
      "A": "7.",
      "B": "ОсОО «КПМГ Бишкек»\nДиректор – Джумашова Элиза Кабылбековна",
      "C": "г. Бишкек, бул. Эркиндик, 21\nтел: 62-33-80\ne-mai\nwww.kpmg.kg",
      "D": "Джумашева Э. К.\nТретьякова Н.В.\nАсырандиева А.К",
      "E": "№ 0008 от 24.09.2003 г.",
      "F": ""
    }, {
      "A": "8.",
      "B": "ОсОО «Битекс – Аудит»\nдиректор –\nМусурманкулов Нурбек Алмамбекович",
      "C": "г. Бишкек, ул. Киевская, 107 – 401,\nтел./факс: 610261\ne-mail\nsales@biteks-audit.kg",
      "D": "Жумашалиев У.Э\nМусурманкулов Н.Б.",
      "E": "№ 0010 от 05.02.2004 г.",
      "F": ""
    }, {
      "A": "9.",
      "B": "ОсОО «Аудиторско – Консультационная Фирма «Альпари»\nГенеральный директор – Винникова Валентина Васильевна",
      "C": "г.Бишкек, жилой городок Сов.Мин., 4а-14\nтел.: 554-128",
      "D": "Винникова В.В.\nЭрмолина Т.В.",
      "E": "№ 0013 от 07.07.2004 г.",
      "F": ""
    }, {
      "A": "10.",
      "B": "ОсОО «Аудит- Прайс»\nДиректор – Чупрета Ольга Анатольевна",
      "C": "г. Бишкек, мрн. Восток-5, 2 – 2,\nтел. 365026,591857\nтел/факс 365025 e-mail\nauditco@mail.ru",
      "D": "Чупрета О.А.\nСамарская Е.Ф., Розыбаев М.М.\nСамарский Я.В.",
      "E": "№ 0015 от 14.07.2004 г.",
      "F": ""
    }, {
      "A": "11.",
      "B": "ОсОО «Промторг-Аудит»\nДиректор – Дыйканалиева Айгуль Эсенкуловна",
      "C": "г. Бишкек, ул. Жибек – Жолу, 222-12,\nтел.: 432487",
      "D": "Дыйканалиева А. Э. Токторов Б. С.",
      "E": "№ 0014 от 14.07.2004 г.",
      "F": ""
    }, {
      "A": "12.",
      "B": "ОсОО «Аудит – Консалтинг»\nДиректор – Самарская Евгения Филипповна",
      "C": "г. Бишкек, буль. Молодой – Гвардии, 20/1,\nтел.: 652564, факс: 652558",
      "D": "Чупрета О. А.\nСамарский Я. В.\nСамарская Е. Ф.",
      "E": "№ 0016 от 19.08.2004 г.",
      "F": ""
    }, {
      "A": "13.",
      "B": "ОсОО «ХАЙТЭК Аудит»\nГенеральный директор -\nХакимов Керимкул Кадырович",
      "C": "г. Бишкек, пр. Чуй 106. факт. М. Гвардия д.2а, кв.46\nтел./факс: 654649",
      "D": "Хакимов К. К.\nМуканов У. Б.",
      "E": "№ 0019 от 06.09.2004 год",
      "F": ""
    }, {
      "A": "14.",
      "B": "ОсОО Аудиторская компания «Джон Эшворт»\nДиректор – Алапаев Артур Бектурович",
      "C": "г. Бишкек, пр. Чуй, 170-11\nтел 39-17-13\noffice@ashworth.pro",
      "D": "Алапаев А. Б.\nМамбетакунов Д.Т,\nЦой Е.П.,\nЦой И.В",
      "E": "№ 0020 от 06.09.2004 год.",
      "F": ""
    }, {
      "A": "15.",
      "B": "ОсОО «Альфа Ширсфилд Аудит»\nДиректор – Мааткабылова Аида Асыкбаевна",
      "C": "г.Бишкек, ул.Рыскулова 95-А\nтел: 98-61-39\ne-mail\nwww.audit.alpha.kg",
      "D": "Мааткабылова А. А.\nАбазбекова Г.Н. Жапарова Н.М., Калматова Ч.Т.",
      "E": "№ 0022 от 06.09.2004 г.",
      "F": ""
    }, {
      "A": "16.",
      "B": "ЗАО «Interin Audit»\nДиректор – Абдраманова Эркингуль Абыловна",
      "C": "г. Бишкек, ул. Киевская, 248/5\nт. 32-19-48\ne-mail\naudit312@mail.ru",
      "D": "Абдраманова Э. А.\nАбдырасулова Г.А, Осмонбекова А.С",
      "E": "№ 0028 от 27.12.2004 г.",
      "F": ""
    }, {
      "A": "17.",
      "B": "ОсОО «Консультационная фирма «АУДИТЭКС»\nДиректор – Лобанова Валентина Алексеевна",
      "C": "г. Бишкек, мрн. Аламедин-1, 77-40,\nтел.: 665476 , 667364",
      "D": "Лобанова В.А.\nАлексеева В.П",
      "E": "№ 0023 от 22.09.2004 г.",
      "F": ""
    }, {
      "A": "18.",
      "B": "ОсОО «Компания «Аудит-Ош»\nДиректор – Райимкулов Маматназар",
      "C": "г. Ош, ул. Ленина, 205, каб. 409\nтел.: 03222-57138",
      "D": "Райимкулов М.\nКарымшаков А.\nКеримов М.",
      "E": "№ 0024 от 22.09.2004 г.",
      "F": ""
    }, {
      "A": "19.",
      "B": "ЗАО «Международный центр консалтинга и аудита»\nГенеральный директор – Садыков Каныбек Рысбекович",
      "C": "г. Бишкек, пр. Чуй, 207,. 615,616,\nтел.: 625738, 665980,\nс. 0555-900186",
      "D": "Садыков К.Р.\nАбилдаева А.Ш.\nФетисова Н.В.",
      "E": "№ 0025 от 13.10.2004 г.",
      "F": ""
    }, {
      "A": "20.",
      "B": "ОсОО «Ош Аудит»\nДиректор – Аширбеков Маткарим",
      "C": "г. Ош, ул. Курманжан-Датка, 209,\nтел. 03222-22340 р.\n0552-728051, 0772728051\ne-mail\nOshaudit@mail.ru",
      "D": "Аширбеков М.\nАбдылаев А. А.",
      "E": "№ 0026 от 10.11.2004 г",
      "F": ""
    }, {
      "A": "21.",
      "B": "ОсОО «Консалтинговая компания АСS»\nГенеральный директор – Зюзьков Владимир Алексеевич",
      "C": "г. Бишкек, ул. Фрунзе, 429 (2 этаж)\nтел./факс: 680118\ne-mail\nacscompany@mail.ru",
      "D": "Зюзьков В.А.\nГордиенко С. В",
      "E": "№ 0029 от 10.01.2005 г.",
      "F": ""
    }, {
      "A": "22.",
      "B": "ЗАО АКФ «Кыргызаудит»\nГенеральный директор – Леднева Нина Евгеньевна",
      "C": "г. Бишкек, ул. Чокморова, 3-56,\nтел.: 324958, факс 324968\nэл. почта\ninfo@kyrgyzaudit.com",
      "D": "Леднева Н. Е.\nЛеднев Е.В,\nРубанова А. В,\nХристоева Т.В",
      "E": "№ 0030 от 16.02.2005 г.",
      "F": ""
    }, {
      "A": "23.",
      "B": "ОсОО «Аудиторская контора «Баст»\nДиректор – Токторов Бакытбек Сатиевич",
      "C": "г. Жалалабат, ул. Маяковского, 56-27\nтел. 03722-70493",
      "D": "Токторов Б.С.\nДыйканалиева А.Э.",
      "E": "№ 0031 от 07.03.2005 г.",
      "F": ""
    }, {
      "A": "24.",
      "B": "ОсОО «АУДИТ-ФИНАНСИСТ»\nДиректор – Сатаров Асыранбек",
      "C": "г. Бишкек, ул. Киевская, 218-14,\nтел.: 654959, 0772441186\ne-mail\nauditfinansist@mail.ru",
      "D": "Касымов С.\nСатаров А.",
      "E": "№ 0032 от 07.03.2005 г.",
      "F": ""
    }, {
      "A": "25.",
      "B": "ОсОО «КОНСУЛЬТ»\nДиректор – Тажиев Эсенкул Кызайбекович",
      "C": "г. Бишкек, мкр. 6, 40 – 41,\nтел.: 426358, 0771105540\ne-mail\ntajiev.azamat@mail.ru",
      "D": "Таджиев Э.К\nСатаров А.",
      "E": "№ 0033 от 07.03.2005 г",
      "F": ""
    }, {
      "A": "26.",
      "B": "ОсОО «Бухучет и аудит»\nДиректор – Ызгыбаев Сыдыкбай",
      "C": "г. Бишкек, ул. Суюмбаева, 140-2, почт. Адрес: ул. Ш.Руставелли, 46-31\nтел.: р. 25-07-86, 0557228477\nд. 627944 с.",
      "D": "Ызгыбаев С.\nШаршенбаев Т.Р\nАлиев К.Ж.",
      "E": "№ 0035 от 15.06.2005 г",
      "F": ""
    }, {
      "A": "27.",
      "B": "ОсОО «БНК Аудит»\nДиректор – Мишукова Людмила Яковлевна",
      "C": "г.Бишкек,ул.Исанова, д. 25 кв1\nтел: 97-97-51, 97-97-55 0557228477\ne-mail\nbnk@ktnet.kg",
      "D": "Мишукова Л.Я.\nАрамян И.А.",
      "E": "№0036 от 30.06.2005 г.",
      "F": ""
    }, {
      "A": "28.",
      "B": "ОсОО Аудиторская компания «ZMC Audit»\nДиректор – Истемесова Жыпаркуль Келдыкеевна",
      "C": "г. Бишкек, ул. Саманчина, 6,\nтел.: 43-68-38",
      "D": "Истемесова Ж.К\nСуранаев Т. Дж. Истемесов У.Т.",
      "E": "№ 0034 от 15.06.2005 г.",
      "F": ""
    }, {
      "A": "29.",
      "B": "ОсОО «Аудит Эксперт»\nДиректор – Сыдыков Жолдошбай Чыракович",
      "C": "г. Ош, ул. Курманжан – Датка, 280,\nтел.: 03222-75411, факс 03222-55072",
      "D": "Сыдыков Ж.Ч.\nЖороев З. А.",
      "E": "№ 0038 от 20.07.2005 г",
      "F": ""
    }, {
      "A": "30.",
      "B": "ОсОО Компания «Азия-Аудит ЛТД»\nДиректор – Махкамов Сабиржан",
      "C": "г. Ош, ул. Алишера Новои, 54,\nтел.: 03222-7-81-19\ne-mail\naziyaaudit@mail.ru",
      "D": "Махкамов С.\nБакиров И.",
      "E": "№ 0040 от 01.09.2005 г",
      "F": ""
    }, {
      "A": "31.",
      "B": "ОсОО «Инаудит – СЭЗ»\nДиректор – Абыдынов Насирдин",
      "C": "пр. Мира, 303,\nтел.: 493588\ne-mail\nAida 1973@inbox.ru",
      "D": "Абдынов Н.\nАбдынова Ж.К.",
      "E": "№ 0041 от 30.01.2006 г",
      "F": ""
    }, {
      "A": "32.",
      "B": "ОсОО «МФИ-Аудит»\nдиректор – Мусаева Роза Имашевна",
      "C": "г. Бишкек, ул. Панфилова, 203-4,\nтел./факс: 627436",
      "D": "Мусаева Р.И.\nЕрмолина Т.В.",
      "E": "№ 0042 от 28.04.2006 г.",
      "F": ""
    }, {
      "A": "33.",
      "B": "ОсОО «Жалалабат – Аудит»\nДиректор – Бакиров Исакбек",
      "C": "г. Жалалабат, ул. Московская, 62,\nтел.: 03722-55983, 72409\n0773-042803",
      "D": "МахкамовС,\nРайимкулов М.",
      "E": "№ 0045 от 03.07.2006 г.",
      "F": ""
    }, {
      "A": "34.",
      "B": "ОсОО Аудиторско-консалтинговый Центр\n«Владимир-Аудит» LTD\nДиректор – Голубцов Александр Николаевич",
      "C": "г. Карабалта, ул. Кожомбердиева 107\nтел.: 03133-22083, факс 03133-33747\n0772348358\ne-mail\nsam888@mail.ru",
      "D": "Голубцов А.Н.\nДыйканалиева А.Э",
      "E": "№ 0046 от 16.03.2007 г",
      "F": ""
    }, {
      "A": "35.",
      "B": "ОсОО «Баланс-Аудит»\nДиректор –\nРысбаев Омурбек Маметабылдаевич",
      "C": "г. Бишкек, ул Тоголок Молдо-60\n0778-634-766/0553-288-385",
      "D": "Рысбаев О.М.\nБейшекеев Э",
      "E": "№ 0047 от 29.03.2007 г",
      "F": ""
    }, {
      "A": "36.",
      "B": "ОсОО «Эккаунтинг-Аудит»\nДиректор – Суералиев Атай Каныбекович",
      "C": "г.Бишкек, ул. Исанова/25\n90-62-78",
      "D": "Суералиев А.К\nАбдымомунова С. Р",
      "E": "№ 0048 от 15.06.2007 г.",
      "F": ""
    }, {
      "A": "37.",
      "B": "ОсОО «А.Аудит-Профит»\nПрезидент – Халитова Найля Рустамовна",
      "C": "г. Бишкек, ул. Суеркулова, 8/1-155\nтел.: 471700",
      "D": "Халитова Н.Р.\nАкимбаев Э.Ю.",
      "E": "№ 0047 от 03.10.2007 г.",
      "F": ""
    }, {
      "A": "38.",
      "B": "ОсОО «Оптима Аудит»\nДиректор – Пухирева Елена Юрьевна",
      "C": "г.Бишкек, 7 мкр, д 15/1 кв9\n555706605\noptima_audit@mail.ru",
      "D": "Пухирева Е.Ю.\nСабко С.В.",
      "E": "№ 0050 от 15.11.2007 г",
      "F": ""
    }, {
      "A": "39.",
      "B": "ОсОО «Компания Консультант Аудит»\nДиректор – Сабко Сергей Васильевич",
      "C": "г. Бишкек, ул. Боконбаева 162\nтел.: 902196 факс 902195",
      "D": "Сабко С.В.\nПухирева Е.Ю.",
      "E": "№ 0053 от 21.07.2008 г",
      "F": ""
    }, {
      "A": "40.",
      "B": "ОсОО «Айкын – Аудит»\nДиректор – Шейшекеева Дильбара Санташевна",
      "C": "г.Бишкек/ул.Б.Баатыра 1а-64\nтел. 0555-915-897\nэл. почта\naikyn.audit@gmail.com",
      "D": "Шейшекеева Д.С.\nДыйканбаева К.И",
      "E": "№ 0055 от 08.09.2008 г",
      "F": ""
    }, {
      "A": "41.",
      "B": "ОсОО Компания «Аудит Стандарт»\nДиректор – Абдраимов Артыкали Мукумбевич",
      "C": "г. Бишкек, мрн. Тунгуч, 64-5\n0772223825, 44-79-28\ne-mail\norozaliev.64@mail.ru",
      "D": "Орозалиев Н. Т.\nАбдраимов А. М.",
      "E": "№ 0056 от 23.01.2009 г.",
      "F": ""
    }, {
      "A": "42.",
      "B": "ОсОО «ФинЭкс-Аудит»\nДиректор – Халип Денис Иванович",
      "C": "г. Бишкек, ул. Московская, д. 194\nтел.\n0772-929-402",
      "D": "Халип Д.И\nХалип Л.И.",
      "E": "№ 0064 от 22.01.2010 г.",
      "F": ""
    }, {
      "A": "43.",
      "B": "ОсОО Аудиторская компания «Актан»\nДиректор – Абдраимов Артыкали Мукумбаевич,",
      "C": "г. Ош, ул. Курманжан Датка, 209\nт. 03222 8-40-03\n0778-982-497",
      "D": "Абдраимов А. М. Нарматов К.А.",
      "E": "№ 0058 от 19.02.2009 г.",
      "F": ""
    }, {
      "A": "44.",
      "B": "ОсОО «ОБ-Тендик-Аудит»\nДиректор Осмонова Бурул Тендиковна",
      "C": "г. Бишкек, пер. Чатыркульский, д.62, кВ.1 т. 51-24-78, 573458\ne-mail\ntendikaudit@mail.ru",
      "D": "Осмонова Б.Т.\nОрозалиев Н.Т.",
      "E": "№ 0059 от 29.06.2009 г.",
      "F": ""
    }, {
      "A": "45.",
      "B": "ОсОО «Baker Tilly Bishkek» (Байкер Тили Бишкек)\nДиректор\nАбдуманапова Юлия Эмильевна",
      "C": "г. Бишкек, ул. Ибраимова 115 а.\nт. 696232",
      "D": "Абдуманапова Ю. Э.\nАлымкулов К.А. Давлеталиева Дж.Дж",
      "E": "№ 0077 от 01.07.2011 г.",
      "F": ""
    }, {
      "A": "46.",
      "B": "ОсОО «Сыйна-Аудит»\nДиректор – Долотбаева Сыйнагуль Суйуновна",
      "C": "г. Бишкек, ул. Беларусская, д. 30\nт. 32-07-61,320740",
      "D": "ДолотбаеваС.С.\nЭмильбаева Н.С.",
      "E": "№ 0061 от 06.10.2009 г.",
      "F": ""
    }, {
      "A": "47.",
      "B": "ОсОО «Аудит Самудин»\nДиректор – Самудинов Кенешбек Боронович",
      "C": "г. Ош, ул. К-Датка, 209\nт. 0773-786274",
      "D": "Сыдыков Ж.Ч.\nАширбеков М.",
      "E": "№ 0062 от 15.12.2009 г.",
      "F": ""
    }, {
      "A": "48.",
      "B": "ОсОО Компания «Ак-Аудит»\nДиректор – Кармышаков Абдиллабек Мурзабекович",
      "C": "г. Ош, ул. Ленина, д. 205\nт. 03222 7-42-07\ne-mail\nabdish59@mail.ru",
      "D": "Кармышаков А.М.\nРаимкулов М.",
      "E": "№ 0063 от 22.01.2010 г.",
      "F": ""
    }, {
      "A": "49.",
      "B": "ОсОО «ERNST&YOUNG» («Эрнст энд Янг Аудит»)\nДиректор-Цой Елизавета Павловна",
      "C": "г. Бишкек, ул. Абдрахманова, 191 офис 110\nт. 665997\ne-mail\nbishkek@kg.ey.com",
      "D": "Цой Е.П.\nАлапаев А.Б.",
      "E": "№ 0065 от 20.02.2010 г.",
      "F": ""
    }, {
      "A": "50.",
      "B": "ОсОО «Консалтинг «ABS» («Консалтинг «АБС»)\nДиректор-Увайдаева Сагынбубу Арысовна",
      "C": "г. Бишкек, ул. Орозбекова 112\nт. 0557005037, 0555 787890",
      "D": "Увайдаева С.А.\nАбыльева Т.С.",
      "E": "№ 0066 от 25.03.2010 г.",
      "F": ""
    }, {
      "A": "51.",
      "B": "ОсОО «ИДИС-Аудит Консалтинг»\nДиректор –\nАтанова Гульсаара Тургумбаевна",
      "C": "г. Бишкек, мкр. 4, д. 19, кв. 21.\nТел: 93-69-82, 46-88-81\ne-mail\nidis-audit@mail.ru",
      "D": "Атанова Г. Т.\nМамедова А. В, Фетисова Н.В, Мусурманкулов Н.А. Борбугулова Г.Т.\nИбраева А.Т.\n.",
      "E": "№ 0068 от 14.06.2010 г.",
      "F": ""
    }, {
      "A": "52.",
      "B": "ОсОО  «АудиТ Групп»\nОсОО «Talic Partners» (Талик Партнерс)\nДиректор – Базаркулова Гульзада Аскарбековна",
      "C": "г. Бишкек, ул. Московская, д.139, кв.52\n, Тел. 31 28 09, 0555751592\ne-mail\nauditgroup08@gmail.com",
      "D": "Ибраева А.Т.\nБазаркулова Г.А.",
      "E": "№ 0075 от 05.04.2011 г",
      "F": ""
    }, {
      "A": "53.",
      "B": "ОсОО «Консалтинговый центр «Tax Law Audit» (Такс Лау Аудит)\nДиректор – Ибраева Анара Турсуналиевна",
      "C": "г. Бишкек, ул. К.Акиева, д.72, кв.59\nтел р. 486194, 0770035757\ne-mail\nkctaxlawaudit@gmail.com/aibraeva2008@mail.ru",
      "D": "Ибраева А.Т.\nБазаркулова Г. А,",
      "E": "№ 0069 от 02.07.2010 г",
      "F": ""
    }, {
      "A": "54.",
      "B": "ОсОО «Эл Аудит»\nДиректор – Сатаров Асыранбек",
      "C": "г. Бишкек, ул. Боконбаева 162.\n90-25-95, 0772 – 441186, 0772-183231",
      "D": "Сатаров А.\nСуранаев Т. Дж",
      "E": "№ 0086 от 14.07.2011 г.\nг",
      "F": ""
    }, {
      "A": "55.",
      "B": "ОсОО «БУХГАЛТЕРИЯ АУДИТ ИННОВАЦИЯ»\nГенеральный директор – Бегматова Каиргуль Шаршекеевна",
      "C": "г. Бишкек, ул. Московская, 1\nт. 0559996618,\n430428\ne-mail\noffice@bai.kg, www.bai.kg",
      "D": "Бегматова К.Ш.\nКасымова А. Д",
      "E": "№ 0071 от 28.09.2010 г.",
      "F": ""
    }, {
      "A": "56.",
      "B": "ОсОО «Аудит плюс»\nДиректор – Ускенбаева Гульнара Тураровна",
      "C": "г. Бишкек, ул. Курганская 56\nр. 895543, 895440\n0555-923272",
      "D": "Ускенбаева Г. Т.\nАн Р. В,\nЛанюгова Т.А.",
      "E": "№ 0072 от 18.11.2010 г",
      "F": ""
    }, {
      "A": "57.",
      "B": "ОсОО «Компания «Аудит-Баланс»\nРысбаев Омурбек Мааткабылович",
      "C": "г. Бишкек, 6 мкр., 34-115\n0772-21-86-12",
      "D": "Рысбаев О.М.\nБейшекеев Э.",
      "E": "№ 0074 от 16.02.2011 г.",
      "F": ""
    }, {
      "A": "58.",
      "B": "ОсОО «Аудит-Практик»\nДиректор – Бейшекеев Эсенбек",
      "C": "г. Бишкек, ул. Тоголок Молдо, 60\n0772-334-706\ne-mail\ne.beishekeevich@mail.ru",
      "D": "Ибраимов Т. Ш.\nБейшекеев Э.",
      "E": "№ 0078 от 14.07.2011 г.",
      "F": ""
    }, {
      "A": "59.",
      "B": "ОсОО «GT Audit and Consulting» «ГТ Аудит и Консалтинг»\nЖусупбекова Луиза Шермаматовна",
      "C": "г. Бишкек,\nул. Рыскулова, д.6",
      "D": "Жусупбеков А.С.\nЖусупбекова Л.Ш.",
      "E": "№ 0080 от 25.11.2011 г.",
      "F": ""
    }, {
      "A": "60.",
      "B": "ОсОО «Аудит Эффект»\nДиректор- Абдылаев Абсатар Анарбаевич",
      "C": "г. Ош, ул. Курманжан Датка, №224\n0772-417-975, 0550-929-828\ne-mail\naudit-effect-",
      "D": "Абдылдаев А. А.\nЭсенов К.",
      "E": "№ 0081 от 20.12.2011 г.",
      "F": ""
    }, {
      "A": "61.",
      "B": "ОсОО “Аудит Максат”\nДиректор – Эсенов Кенжебек",
      "C": "г. Бишкек, ул. Абдрахманов, 176-18\n0770-57-92-19",
      "D": "Эсенов К.\nАбдылаев А.",
      "E": "№ 0083 от 08.02.2012 г.",
      "F": ""
    }, {
      "A": "62.",
      "B": "ОсОО «GRAND AUDIT» (Гранд Аудит)\nДиректор-Бутенко Наталья Валерьевна",
      "C": "г. Бишке, ул. Малдыбаева 9-17\nтел 87-00-79\ngrandaudit555@mail.ru",
      "D": "Бутенко Н.В.\nМаматова А.Б.",
      "E": "№ 0084 от 08.08.2012 г",
      "F": ""
    }, {
      "A": "63.",
      "B": "ОсОО “Ансар аккаунтантс”\nДиректор – Абдувалиев Зарылбек Рубенович",
      "C": "г. Бишкек, ул. Раззакова 32, офис 304\nтел: 89-79-27\noffice@ansaraccountants.com",
      "D": "Абдувалиев З.Р.\nЫзгыбаев С, Бейшеналиева А.У",
      "E": "№ 0085 от 08.08.2012 г",
      "F": ""
    }, {
      "A": "64.",
      "B": "ОсОО “Центр Профессионального Аудита”\nДиректор- Базарбаева Айнура Кудусовна",
      "C": "г. Бишкек, пр. М. Гвардия, 27\n65-22-75, 0555-776315",
      "D": "Базарбаева А.К.\nАбдылаев А.А.",
      "E": "№ 0086 от 14.09.2012 г",
      "F": ""
    }, {
      "A": "65. О",
      "B": "ОсОО “Бекадо Аудит”\nДиректор - Джокоева Мунара Толотбатовна",
      "C": "г. Бишкек, пр. Манаса 40, офис 315",
      "D": "Джокоева М.Т.\nБакеева К.А.",
      "E": "№ 0088 от 19.01.2013 г.",
      "F": ""
    }, {
      "A": "66.",
      "B": "ОсОО “Аудиторско – консалтинговая группа “AUDIT.KG” (АУДИТ. КЕЙ ДЖИ)\nДиректор - Ким Филимон Инсебович",
      "C": "г. Бишкек, ул. Токтогула , дом 191, кВ. 14.\nТел. 34-30-74, 0557545955\ne-mail\nauditkg97@gmail.com",
      "D": "Ким Ф.И.\nАбдурашидов Ш.З.",
      "E": "№ 0089 от 11.03.2013 г.",
      "F": ""
    }, {
      "A": "67.",
      "B": "ОсОО “Консультационно-Аудиторская Компания “La sphere-Audit” (Ла сфер-Аудит)\nДиректор - Самаков Нурдин Талантбекович",
      "C": "г. Бишкек, ул. Фрунзе 282 а\nтел: 933-166",
      "D": "Самаков Н.Т.\nСамакова С.Т.",
      "E": "№ 0090 от 11.04.2013 г.",
      "F": ""
    }, {
      "A": "68.",
      "B": "ОсОО “Грант Торнтон”\nДиректор -  Ванян Армен Леонович",
      "C": "г. Бишкек, пр. Манаса д. 47, кВ. 48\nтел: 0555-001-301",
      "D": "Ванян А. Л.\nСадиков Д.Т.\nАбдимажитов К.К.",
      "E": "№ 0091 от 03.05.2013 г.",
      "F": ""
    }, {
      "A": "69.",
      "B": "ОсОО “Global Audit» (Глобал Аудит)\nДиректор - Бакеева Гулжамал Асангазиевна",
      "C": "г. Бишкек, ж/м Колмо, ул. Илим. Дом 29\n0555924217",
      "D": "Бакеева К.А.\nАлымолдоев Т",
      "E": "№ 0092 от 14.05.2013 г.",
      "F": ""
    }, {
      "A": "70.",
      "B": "ОсОО “АУДИТ САПАТ”\nДиректор - Джундубаев Эсенбек Ашибекович",
      "C": "г. Бишкек, ул. Островского, дом 82\nтел: 0772-319-177",
      "D": "Джундубаев Э.А.\nКасымов С.",
      "E": "№ 0093 от 14.05.2013 г",
      "F": ""
    }, {
      "A": "71.",
      "B": "ОсОО “Аудит Профи Групп”\nДиректор - Ибрайманкунов Айдар Касымович",
      "C": "г. Бишкек, ул. Армавирская, дом 102\n0555-11-11-74",
      "D": "Ибрайманкунов А.К.\nИбрайманкунов О.К.",
      "E": "№ 0094 от 14.06.2013 г.",
      "F": ""
    }, {
      "A": "72.",
      "B": "ОсОО “ProfPoint” ПрофПоинт\nДиректор Атаханова Мира Рысбековна",
      "C": "г. Бишкек, ул. Исанова дом 25.\nТел. 90-62-78",
      "D": "Атаханова М. Р.\nАбдымомунова С.Р.",
      "E": "№ 0095 от 05.07.2013 г.",
      "F": ""
    }, {
      "A": "73.",
      "B": "ОсОО “Ай Эн Кей Груп”\nДиректор Каримова Назгуль Ирсалиевна",
      "C": "юр. адрес: г. Бишкек, пр. Манаса 16-66\nтел: 89-15-75\nink.group.kg@gmail.com",
      "D": "Каримова Н. И.\nЖумашалиев У. Э.",
      "E": "№ 0096 от 17.08.2013 г",
      "F": ""
    }, {
      "A": "74.",
      "B": "ОсОО “Аудит-Консалтинг Групп”\nДиректор- Омарова Асель Темирбековна",
      "C": "г. Бишкек, пр. Чуй, д. 186, кв. 67\nтел. 0700-773-842\ne-mail\nacg.098@mail.ru",
      "D": "Омарова А.Т.\nМусаева А. Р.",
      "E": "№ 0098 от 25.10.2013 г.",
      "F": ""
    }, {
      "A": "75.",
      "B": "ОсОО “Улан-Нур-Аудит”\nДиректор - Мадиев Кубат Ашымович",
      "C": "г. Бишкек, ул. Ереванская 105\nт; 0555334405",
      "D": "Мадиев К.А\nНамазбеков А.",
      "E": "№ 0099 от 29.01.2014 г.",
      "F": ""
    }, {
      "A": "76.",
      "B": "ОсОО “ЖАНИ Аудит-Зеркало”\nДиректор - Чекиров Насридин Эргешович",
      "C": "г. Ош, ул. Курманжан-Датка 209",
      "D": "Чекиров Н.\nКармышаков А.",
      "E": "№ 0100 от 29.01.2014 г.",
      "F": ""
    }, {
      "A": "77.",
      "B": "ОсОО «Астэй»\nДиректор - Бокошова Айша Чороевна",
      "C": "г. Бишкек, ул. Малдыбаева , дом 11,кв. 3",
      "D": "Бокошова А. Ч.\nЭсенов К.\nБатыркулов Р.",
      "E": "№ 0101 от 29.01.2014 г.",
      "F": ""
    }, {
      "A": "78. О",
      "B": "ОсОО «Кыргыз Аудит Консалтинг»\nДиректор – Сатылганова Жылдыз Толобаевна",
      "C": "г. Бишкек, пр. Чуй 114, кааб 201\nтел. 66-46-63",
      "D": "Сатылганова Ж.Т.\nМамедова А.",
      "E": "№ 0102 от 04.03.2014 г.",
      "F": ""
    }, {
      "A": "79.",
      "B": "ОсОО Аудит – консалтинг\nДиректор - Самарская Евгения Филипповна",
      "C": "г. Бишкек, бул. М. Гвардии 20/1\nтел: 65-25-64\ne-mail\naudit-cons@mail.ru",
      "D": "Самарская Е.Ф.\nЧупрета О.А,\nРысева Е. Ф",
      "E": "№ 0103 от 04.03.2014 г",
      "F": ""
    }, {
      "A": "80.",
      "B": "ОсОО «Ацентура Аудит»\nДиректор - Сулайманова Таалайкуль Кариевна",
      "C": "г. Бишкек, мкр. Аламудун-1, дом 29, кв. 26\n0558-77-15-05",
      "D": "Сулайманова Т.К.\nШакирова К.К.",
      "E": "№ 0104 от 21.05.2014 г.",
      "F": ""
    }, {
      "A": "81.",
      "B": "ОсОО «Финэспертиза»\nДиректор - Абдрахманов Бактыбек Калмаматович",
      "C": "г. Ош, ул. Курманжан Датка 224.\n0777-250593, 0772-223893\nfinexpertizaosh@gmail.com",
      "D": "Абдрахманов Б. К.\nЖороев З.А.",
      "E": "№ 0105 от 09.07.2014 г",
      "F": ""
    }, {
      "A": "82.",
      "B": "ОсОО «Interfinence» (Интерфайненс)\nДиректор - Курмашева Чолпон Дуйшеновна",
      "C": "г. Бишкек, ул. Лермонтова , дом 2.\n0555-009597\ne-mail\ninter.finance.kg@gmail.com,",
      "D": "Курмашева Ч.Д.\nЕрмолина Т.В,\nТилемишев А.",
      "E": "№ 0107 от 21.07.2014 г",
      "F": ""
    }, {
      "A": "83.",
      "B": "ОсОО «Ыссык-Коль Аудит»\nДиректор - Абдрахманова Эркингуль Абыловна",
      "C": "Ыссык-Кульской обл.,\nг. Каракол, мкр. Кашка-Суу, дом 5,кв. 13\n0557-413325\ne-mail\nauditors15@mail.ru, www.goldenleat.kg",
      "D": "Абдрахманова Э. А.\nМусаева Р.И, Осмонбекова А.С",
      "E": "№ 0108 от 28.11.2014 г.",
      "F": ""
    }, {
      "A": "84.",
      "B": "ОсОО «Огама7»\nДиректор - Кузьмина Ольга Владимировна",
      "C": "г. Бишкек, ул. Исанова, дом 24, кв. 25\nтел: 0555-72-77-70",
      "D": "Кузьмина О.В\nКулжигачева Н.С",
      "E": "№ 0109 от 28.11.2014 г.",
      "F": ""
    }, {
      "A": "85.",
      "B": "ОсОО «Фалькор ПРО»\nДиректор - Бактыбаев Марат Нишенбаевич",
      "C": "г. Бишкек,\nул. Саманчина 6, каб117\nр.т: 569635, 0555150327",
      "D": "Бактыбаев М.Н Токтомамабетова Ч.Б",
      "E": "№ 0110 от 04.12.2014 г.",
      "F": ""
    }, {
      "A": "86.",
      "B": "ОсОО «Анык Аудит»\nДиректор - Ускенбаева Эльмира Авроровна",
      "C": "г. Бишкек, ул. Исанова, 202\nтел: 89-54-40,\n0701-888114",
      "D": "Ускенбаева Э. А\nАн. Р.В.\n.",
      "E": "№ 0111 от 22.12.2014 г.",
      "F": ""
    }, {
      "A": "87.",
      "B": "ОсОО “Аудит-Финучет”\nДиректор -Жороев Замирбек Адылович",
      "C": "г. Ош, ул. Курмандан-Датка 224а\n0772428265",
      "D": "Жороев З.А.\nАбдылаев А. А.",
      "E": "№ 0112 от 29.12.2014 г.",
      "F": ""
    }, {
      "A": "88.",
      "B": "ОсОО «Кочкор-Аудит»\nДиректор - Иманалиев Казы Султанкулович",
      "C": "Нарынская обл. Кочкорский р-н, с. Мантыш, ул. Кок-Жар, д.10\n0779-277636\n0558-537323",
      "D": "Иманалиев К.С\nКачканаков О.Э.",
      "E": "№ 0115\nот 23.01.2015 г.",
      "F": ""
    }, {
      "A": "89.",
      "B": "ОсОО «Кей Аудит»\nДиректор- Мамбетакунов Дамир Талантович",
      "C": "Г. Бишкек 5 мкр 57-60",
      "D": "Акматов К.К\nМамбетакунов Д. Т.",
      "E": "№ 0113 от 8. 09.2015 г.",
      "F": ""
    }, {
      "A": "90.",
      "B": "ОсОО «МК Групп Консалтинг»\nЭстебесова Алтынай Сырдыбаевна",
      "C": "г. Бишкек, мкр5,дом 82, кв.22\n0777-200120\n0704-500000",
      "D": "Эстебесова А.С\nТыналиева А. А",
      "E": "№ 0117\nот 21.02.2015 г.",
      "F": ""
    }, {
      "A": "91.",
      "B": "ОсОО «Аудит - Учет»\nДиректор – Акматов Абдисамат Жуманович",
      "C": "Кыргызская Республика, Баткенская обл., Лейлекский р/н.\nг. Исфана, ул. Строительная, №83.\nТел; 0770818981",
      "D": "Акматов А. Ж.\nГапыров А. Ж.",
      "E": "№0118\nот 30.04.2015 г",
      "F": ""
    }, {
      "A": "92.",
      "B": "ОсОО «Аудит Юнион»\nДиректор Осмонкулова Бактыгуль Исламовна",
      "C": "г. Бишкек, ул. Анкара 142 каб 8\nс.0551 580008\ne-mail\nobaktygul17@mail.ru",
      "D": "Осмонкулова Б.И.\nАзизов Н.Т",
      "E": "№0119\nот 07.07.2015 г.",
      "F": ""
    }, {
      "A": "93.",
      "B": "ОсОО «Крестон Ансар»\nДиректор - Авдувалиев Зарылбек Рубенович",
      "C": "г. Бишкек, ул. Раззакова, 19, офис 1408\noffice@ansaraccountants.com",
      "D": "Авдувалиев З.Р Бейшеналиева А.",
      "E": "№ 0120\nот 22.07.2015 г.",
      "F": ""
    }, {
      "A": "94.",
      "B": "ОсОО «Аудиторская компания «Ас Ай Ти Аудит»\nДиректор- Атабаев Акылбек Токтобаевич",
      "C": "г. Бишкек ул. Киевская, д 96а каб.715\n0553 10 07 70",
      "D": "Атабаев А. Т\nБокошева А.Ч",
      "E": "№ 0121\n20.10.16г.",
      "F": ""
    }, {
      "A": "95.",
      "B": "ОсОО «Аудит Актив»\nДиректор-Раимкулов Маматназар",
      "C": "г. Ош, ул. Ленина 205\n0558610203",
      "D": "Раимкулов М.\nОсмонова Б.Т.",
      "E": "№ 0123\n06.07.16г",
      "F": "."
    }, {
      "A": "96.",
      "B": "ОсОО «Аудит Партнерс» Генеральный директор - Омуралиев Нурбек Асекович",
      "C": "г. Бишкек ул. Ю. Фучика, д.38",
      "D": "Омуралиев Н. А. Байгончокова Ж. К.",
      "E": "№ 0124\n04.01.2017 г.",
      "F": ""
    }, {
      "A": "97.",
      "B": "ОсОО «КурсТал Аудит» Генеральный директор - Заффаров Курсантбек Аскарбекович",
      "C": "г. Бишкек ул. Кулиева, д.37 кв. 8",
      "D": "Заффаров К. А.\nСулайманова Т. К.",
      "E": "№ 0125\n23.01.2017",
      "F": ""
    }, {
      "A": "98.",
      "B": "ОсОО «Аудит Эдвайзер» Директор - Орозалиев Нурдин Тукеевич",
      "C": "Чуй. обл. Аламудунский р-н, с. Лебединовка ж/м Кырман 13-44 ГА",
      "D": "Орозалиев Н. Т.\nАкопян Т. И.",
      "E": "№ 0127 от 14.02.2017",
      "F": ""
    }, {
      "A": "99.",
      "B": "ОсОО «Аудит Бизнес Репорт» Генеральный директор – Акопян Тамара Ивановна",
      "C": "Чуй. обл. Аламудунский р-н, с.Новопавловка ул. Строительная д.2 кв.2",
      "D": "Акопян Т. И.\nОрозалиев Н. Т.",
      "E": "№ 0128 от 14.02.2017",
      "F": ""
    }, {
      "A": "100.",
      "B": "ОсОО «Мазарс» Генеральный директор – Дьяконова Людмила Николаевна",
      "C": "г. Бишкек ул. Абдрахманова д. 191,офис 124",
      "D": "Дьяконова Л.Н\nЭстебесова А. С.",
      "E": "№ 0126 от 28.02.2017",
      "F": ""
    }, {
      "A": "101.",
      "B": "ОсОО «Тэкс Эдвайзер»\nДиректор - Мамбеталиев Азамат Айдарбекович",
      "C": "Кыргызская Республика, г. Бишкек, ул. Льва Толстого, 100/1, каб.304",
      "D": "Мамбеталиев А. А.\nТилемишев А. Т.",
      "E": "№ 0129 от 26.04.2017 г",
      "F": ""
    }, {
      "A": "102.",
      "B": "ОсОО «Аудит Гарант»\nДиректор- Омурбеков Асаналы Асизович",
      "C": "г. Бишкек ул. Брестская ,69\nтелефон: 0555909521",
      "D": "Омурбеков А. А.\nМавлянкулов Ж. Н.\nКачканаков О. Э.",
      "E": "№ 0130 от 12.07.2017 г.",
      "F": ""
    }, {
      "A": "103.",
      "B": "ОсОО «Аудиторская компания «Адиссан Аудит»\nДиректор - Истемесов Улан Турусбекович",
      "C": "г. Бишкек 4 мкр. Д. 44 кв. 28\nТелефон 0555800816",
      "D": "Истемесов У. Т.\nИстемесова Ж.К.",
      "E": "№ 0131 от 11.09.2017 г.",
      "F": ""
    }, {
      "A": "104.",
      "B": "ОсОО «Академ Аудит»\nДиректор – Ормонов Нурбек Аккозович",
      "C": "г. Жалал-Абад ул. Жени – Жок д.30\nТелефон: 0772553070",
      "D": "Ормонов Н. А.\nКасымов С.",
      "E": "№ 0132\nОт 21.09.2017 г.",
      "F": ""
    }, {
      "A": "105.",
      "B": "ОсОО «Кыял-Аудит»\nДиректор – Ормонов Нурбек Аккозович",
      "C": "Г. Жалал – Абад ул. Чехова\nТел: 0772553070",
      "D": "Ормонов Н. А.\nКасымов С.",
      "E": "№ 0133 от 03.10.2017 г.",
      "F": ""
    }, {
      "A": "106.",
      "B": "ОсОО «Жаз-Аудит»\nКойчуманова Джамиля Азатовна",
      "C": "Г. Бишкек ж/м Арча-Бешик, ул. Шералиева, д.326",
      "D": "Койчуманова Дж. А.\nАбдуматов К. А.",
      "E": "№0134 от 20.10.2017 г.",
      "F": ""
    }, {
      "A": "107.",
      "B": "ОсОО «БДО Кыргызстан»\nДиректор- Атаканова Мира Рысбековна",
      "C": "Г. Бишкек пр. Чуй д.230, 8 этаж",
      "D": "Абдымомунова С. Р\nАтаканова М.Р.",
      "E": "№079 от 10.10.2017 года Серия А 0022",
      "F": ""
    }, {
      "A": "108.",
      "B": "ОсОО «АНМ Консалт»\nДиректор – Асанбекова Назгуль Насировна",
      "C": "г. Бишкек ул. Серова д.36\nТел: 0703882077",
      "D": "Асанбекова Н. Н.\nКасенова М. М.",
      "E": "№ 0136 от 10.01.2018 г.",
      "F": ""
    }, {
      "A": "109.",
      "B": "ОсОО «Аудит Консультант»\nИсполнительный директор- Хамдамов Бобиржон Мамасидикович",
      "C": "г. Ош ул Атабаева д. 105\nТел 0557950999, 0773805557",
      "D": "Хамдамов Б. М.\nЭсенов К.",
      "E": "№ 0137 от 10.01.2018",
      "F": ""
    }, {
      "A": "110.",
      "B": "ОсОО «Кеменгер Аудит»\nДиректор- Суйундук уулу Айбек",
      "C": "Г. Бишкек мкр Тунгуч д 7 кв. 80\nТел: 0554558535",
      "D": "Суйундук уулу А.\nУсупбаева А.И.",
      "E": "№ 0138 от\n26.02.2018 г",
      "F": ""
    }, {
      "A": "111.",
      "B": "ОсОО «Финаудит эксперт»\nДиректор-Маматбекова Айгуль Эркинбековна",
      "C": "Г. Бишкек мкр. 8, д.17., кВ 93",
      "D": "Маматбекова А. Э.\nТурдалиева А.Т.",
      "E": "№ 0139 от 20.03.2018 г.",
      "F": ""
    }, {
      "A": "112.",
      "B": "ОсОО «Атлант-Аудит»\nДиректор-Айсаев Насирдин Асанбекович",
      "C": "Г. Бишкек ул. Т-Молдо 60а\nТел; 0701990003",
      "D": "Райимкулов М.\nАйсаев Н.А.",
      "E": "№0140 от 04.05.2018 г\nСерия А 0035",
      "F": ""
    }, {
      "A": "113.",
      "B": "ОсОО «КРОУ ХОРВАТ ЭЙСИДЖИ»\nДиректор – Суранаева Айдай Акылбековна",
      "C": "Г. Бишкек ул. Уметалиева д.112\n0701400258",
      "D": "Мамбеталиев А.А.\nСуранаева А. А.",
      "E": "№ 0141 от 10.07.2018 г\nСерия А 0037",
      "F": ""
    }, {
      "A": "114.",
      "B": "ОсОО «ФинЛайн Консалтинг»\nГенеральный директор- Султанов Бек Шайбекович",
      "C": "Г. Бишкек ул. Раззакова д.22\nТел: 0550347722",
      "D": "Султанов Б.Ш\nБекболотов А.Ж.",
      "E": "№ 0142 от 06.09.2018 г.\nСерия А 0040",
      "F": ""
    }, {
      "A": "115.",
      "B": "ОсОО «СТ-Аудит-консалт»\nДиректор – Орозалиева Бакен Мамытовна",
      "C": "Г. Бишкек 7 мкр, д.46 кв.39",
      "D": "Орозалиева Б.М.\nСамсалиев Б.К.",
      "E": "№ 0143 от 06.09.2018 г.\nСерия А 0041",
      "F": ""
    }, {
      "A": "116.",
      "B": "ОсОО «Аудит ПрофЛайн»\nДиректор- Сакеева Мырзагуль Насыровна",
      "C": "Г. Бишкек ул. Ахунбаева д 119 а\nТел 742075",
      "D": "Мирлан к Н\nСакеева М.Н.",
      "E": "№ 0144 от 04.10.2018 года\nСерии А 0042",
      "F": ""
    }, {
      "A": "117.",
      "B": "ОсОО «ЭйБиЭс Аудит»\nДиректор – Атакулова Алия Муратбековна",
      "C": "г. Бишкек ул. Орозбекова 2/4 офис № 3\nТел; 0558239888, 0705239888",
      "D": "Черикчиева М.К\nАтакулова А.М.",
      "E": "0145 от 06.11.2018 года\nСерия А 0045",
      "F": ""
    }, {
      "A": "118.",
      "B": "ОсОО «ЭйчЭлБи Марка Аудит»\nГенеральный директор – Тажибаева Салтанат Сартмаматовна",
      "C": "Г. Бишкек ул. Профессора Зимы дом 38",
      "D": "Тажибаева С. С.\nКутателадзе Л. Г.,\nАбдыкадырова Г.А., Кобрицева Н.Н.,\nТажибаева С. С.\nТилемишов А. Т.\nШулдяоква Г. И.\nЗалонина Л. Г.",
      "E": "0146 от 13.11.2018 года Серия А 0046",
      "F": ""
    }, {
      "A": "119.",
      "B": "ОсОО «Капитал Аудит»\nГенеральный директор – Исаков Болотбек Алмасбекович",
      "C": "Г. Бишкек пер. Лазурный дом 26",
      "D": "Исаков Б.А.\nАбдимомынова А.Б.",
      "E": "0147 от 05.12.2018 года Серия А 0047",
      "F": ""
    }
  ]).constant('name', [
    {
      "A": "1",
      "B": "Рысбек Токтогул",
      "C": "775975375",
      "D": "00001",
      "E": "11.07.03 г."
    }, {
      "A": "2",
      "B": "Шейшекеева Дильбара Санташевна",
      "C": "д. 575655, 0555915897",
      "D": "00002",
      "E": "11.07.03 г."
    }, {
      "A": "3",
      "B": "Истемесова Жыпаркуль Келдыкеевна",
      "C": "436838, 0543898774",
      "D": "00003",
      "E": "11.07.03 г."
    }, {
      "A": "5",
      "B": "Жусупбеков Айбек Советбекович",
      "C": "0770-77-07-09",
      "D": "00005",
      "E": "11.07.03 г."
    }, {
      "A": "6",
      "B": "Исмазова Тамара Владиславовна",
      "C": "0312641671,0558540064,0773722446",
      "D": "00006",
      "E": "11.07.03 г."
    }, {
      "A": "7",
      "B": "Сатаров Асыранбек",
      "C": "с. 0772-441186",
      "D": "00007",
      "E": "11.07.03 г."
    }, {
      "A": "8",
      "B": "Тихомирова Татьяна Витальевна",
      "C": "д. 0555999611, 0775999611.",
      "D": "00008",
      "E": "11.07.03 г."
    }, {
      "A": "9",
      "B": "Дадаян Светлана Валентиновнаб",
      "C": "0778662343, 0559042007",
      "D": "00009",
      "E": "11.07.03 г."
    }, {
      "A": "10",
      "B": "Георгиади Людмила Христиновна",
      "C": "М:0555 757616, Р:367370",
      "D": "00010",
      "E": "11.07.03 г."
    }, {
      "A": "11",
      "B": "Жусупбекова Луиза Шермаматовна",
      "C": "0770-77-07-09",
      "D": "00011",
      "E": "06.08.03 г."
    }, {
      "A": "12",
      "B": "Мурзалиев Азамат Муратович",
      "C": "р. 680573 д. 296865, м. 0772-326401",
      "D": "00012",
      "E": "05.12.03 г."
    }, {
      "A": "13",
      "B": "Красников Андрей Алексеевич",
      "C": "555775507",
      "D": "00013",
      "E": "05.12.03 г."
    }, {
      "A": "14",
      "B": "Турбатов Руслан Радмирович",
      "C": "раб 0312662920",
      "D": "00014",
      "E": "05.12.03 г."
    }, {
      "A": "16",
      "B": "Соломатова Ирина Петровна",
      "C": "486642, 0555582320",
      "D": "00016",
      "E": "05.12.03 г."
    }, {
      "A": "17",
      "B": "Долоталиева Гульнара Амантаевна",
      "C": "0703 545745",
      "D": "00017",
      "E": "05.12.03 г."
    }, {
      "A": "18",
      "B": "Бейшеналиева Алтынай Усенбековна",
      "C": "770990755",
      "D": "00018",
      "E": "05.12.03 г."
    }, {
      "A": "19",
      "B": "Антонова Татьяна Петровна",
      "C": "775976465",
      "D": "00019",
      "E": "12.12.03 г."
    }, {
      "A": "20",
      "B": "Торомырзаев Руслан Торомырзаевич",
      "C": "555299151",
      "D": "00020",
      "E": "05.12.03 г."
    }, {
      "A": "21",
      "B": "Аширбеков Маткарим",
      "C": "р. 03222-22340,д. 03233-32211 0552-728051\nм. 0772-728051",
      "D": "00021",
      "E": "05.12.03 г."
    }, {
      "A": "22",
      "B": "Ахматов Кыргызбай Ахмедович",
      "C": "555013544",
      "D": "00022",
      "E": "05.12.03 г."
    }, {
      "A": "23",
      "B": "Орозобаев Жекшенбек Мухамбетович",
      "C": "р. 664015 д. 469610\nм. 0772-627468",
      "D": "00023",
      "E": "05.12.03 г."
    }, {
      "A": "24",
      "B": "Боронбаев Сатар Боронбаевич",
      "C": "р. 216454",
      "D": "00024",
      "E": "05.12.03 г."
    }, {
      "A": "25",
      "B": "Абыдынов Насирдин",
      "C": "М:0555 778598",
      "D": "00025",
      "E": "15.06.04 г."
    }, {
      "A": "26",
      "B": "Винникова Валентина Васильевна",
      "C": "р. 59-18-57",
      "D": "00026",
      "E": "15.06.04 г."
    }, {
      "A": "27",
      "B": "Гофлин Людмила Гельевна",
      "C": "312283895",
      "D": "00027",
      "E": "15.06.04 г."
    }, {
      "A": "28",
      "B": "Качаева Ирина Марковна",
      "C": "312428195",
      "D": "00028",
      "E": "15.06.04 г."
    }, {
      "A": "29",
      "B": "Колосова Любовь Сергеевна",
      "C": "0550-98-18-57, 0705-98-18-57",
      "D": "00029",
      "E": "15.06.04 г."
    }, {
      "A": "31",
      "B": "Морозова Елена Егоровна",
      "C": "",
      "D": "00031",
      "E": "15.06.04 г."
    }, {
      "A": "32",
      "B": "Парфенова Татьяна Филипповна",
      "C": "",
      "D": "00032",
      "E": "15.06.04 г."
    }, {
      "A": "33",
      "B": "Садыков Каныбек Рысбекович",
      "C": "д. 625738,665980 0555-900186",
      "D": "00033",
      "E": "15.06.04 г."
    }, {
      "A": "34",
      "B": "Садыкова Асель Рысбековна",
      "C": "555334394",
      "D": "00034",
      "E": "15.06.04 г."
    }, {
      "A": "35",
      "B": "Сабко Сергей Васильевич",
      "C": "902196, 902195",
      "D": "00035",
      "E": "15.06.04 г."
    }, {
      "A": "36",
      "B": "Атанова Гульсаара Тургумбаевна",
      "C": "р. 936982,468881,м. 0772-560585",
      "D": "00036",
      "E": "24.06.04 г."
    }, {
      "A": "37",
      "B": "Арамян Ирина Алексеевна",
      "C": "М:0555 581018, Р:979751",
      "D": "00037",
      "E": "24.06.04 г."
    }, {
      "A": "38",
      "B": "Алапаев Артур Бектурович",
      "C": "м. 0777800022 391713/391711",
      "D": "00038",
      "E": "24.06.04 г."
    }, {
      "A": "39",
      "B": "Абыдынова Жанаргул Кошбаевна",
      "C": "0555 807868",
      "D": "00039",
      "E": "24.06.04 г."
    }, {
      "A": "40",
      "B": "Абыльева Турсунай Сабирбековна",
      "C": "",
      "D": "00040",
      "E": "24.06.04 г."
    }, {
      "A": "41",
      "B": "Алексеева Валентина Петровна",
      "C": "567728.54644",
      "D": "00041",
      "E": "24.06.04 г."
    }, {
      "A": "42",
      "B": "Гордиенко Сергей Владимирович",
      "C": "0559630909, 0312387544",
      "D": "00042",
      "E": "24.06.04 г."
    }, {
      "A": "43",
      "B": "Гинтер Галина Васильевна",
      "C": "312437767",
      "D": "00043",
      "E": "24.06.04 г."
    }, {
      "A": "44",
      "B": "Дыйканбаева Кулнаара Ибраимовна",
      "C": "701878801",
      "D": "00044",
      "E": "24.06.04 г."
    }, {
      "A": "45",
      "B": "Дыйканалиева Айгуль Эсенкуловна",
      "C": "М:0553 777476, Р:432487",
      "D": "00045",
      "E": "24.06.04 г."
    }, {
      "A": "46",
      "B": "Каирова Гульнара Аубакировна",
      "C": "м.0555515234",
      "D": "00046",
      "E": "24.06.04 г."
    }, {
      "A": "47",
      "B": "Кобрицева Наталья Николаевна",
      "C": "Р.т. 320568",
      "D": "00047",
      "E": "24.06.04 г."
    }, {
      "A": "48",
      "B": "Коркоцкая Элла Николаевна",
      "C": "",
      "D": "00048",
      "E": "24.06.04 г."
    }, {
      "A": "50",
      "B": "Лобанова Валентина Алексеевна",
      "C": "665476 , 667364",
      "D": "00050",
      "E": "24.06.04 г."
    }, {
      "A": "51",
      "B": "Мишукова Людмила Яковлевна",
      "C": "М:0555 588646, Р:979751",
      "D": "00051",
      "E": "24.06.04 г."
    }, {
      "A": "52",
      "B": "Новикова Наталья Даниловна",
      "C": "0779-88-88-28",
      "D": "00052",
      "E": "24.06.04 г."
    }, {
      "A": "53",
      "B": "Осмонова Бурул Тендиковна",
      "C": "М:0554 821482, Р:512478",
      "D": "00053",
      "E": "24.06.04 г."
    }, {
      "A": "54",
      "B": "Ускенбаева Гульнара Тураровна",
      "C": "555927232",
      "D": "00054",
      "E": "24.06.04 г."
    }, {
      "A": "55",
      "B": "Хакимов Керимкул Кадырович",
      "C": "М:0550 400526, Р:383107",
      "D": "00055",
      "E": "24.06.04 г."
    }, {
      "A": "56",
      "B": "Абдрешов Алмас Сапаргалиевич",
      "C": "",
      "D": "00056",
      "E": "23.08.04 г."
    }, {
      "A": "57",
      "B": "Багрий Клавдия Леонтьевна",
      "C": "312232904",
      "D": "00057",
      "E": "23.08.04 г."
    }, {
      "A": "58",
      "B": "Ермолина Тамара Васильевна",
      "C": "р. 682561, 0772-301080, 0770 90 10 80",
      "D": "00058",
      "E": "23.08.04 г."
    }, {
      "A": "59",
      "B": "Иващенко Наталья Николаевна",
      "C": "79645586284",
      "D": "00059",
      "E": "23.08.04 г."
    }, {
      "A": "60",
      "B": "Лозицкая Наталия Алексеевна",
      "C": "772500446",
      "D": "00060",
      "E": "23.08.04 г."
    }, {
      "A": "61",
      "B": "Тентиев Аман Мукамбетович",
      "C": "312650158",
      "D": "00061",
      "E": "23.08.04 г."
    }, {
      "A": "62",
      "B": "Учкемпирова Роза Мавлетовна",
      "C": "434776, 0559 25 25 70",
      "D": "00062",
      "E": "23.08.04 г."
    }, {
      "A": "64",
      "B": "Абилдаева Айгуля Шахтербековна",
      "C": "0555728893,0312 531536",
      "D": "00064",
      "E": "11.10.04 г"
    }, {
      "A": "65",
      "B": "Фетисова Наталья Викторовна",
      "C": "555950222",
      "D": "00065",
      "E": "11.10.04 г."
    }, {
      "A": "66",
      "B": "Абдраманова Эркингуль Абыловна",
      "C": "771417497",
      "D": "00066",
      "E": "16.12.04 г."
    }, {
      "A": "67",
      "B": "Зюзьков Владимир Алексеевич",
      "C": "680118, 0555330450",
      "D": "00067",
      "E": "16.12.04 г."
    }, {
      "A": "68",
      "B": "Корытова Наталья Владимировна",
      "C": "312485248",
      "D": "00068",
      "E": "16.12.04 г."
    }, {
      "A": "69",
      "B": "Самарская Евгения Филипповна",
      "C": "р. 652564, 652558 с. 0772-577221",
      "D": "00069",
      "E": "16.12.04 г."
    }, {
      "A": "70",
      "B": "Токторов Бакытбек Сатиевич",
      "C": "д. 03722-70493 с. 0772-625420, 0555707130",
      "D": "00070",
      "E": "16.12.04 г."
    }, {
      "A": "71",
      "B": "Чупрета Ольга Анатольевна",
      "C": "М:0555 800937,Р:365026",
      "D": "00071",
      "E": "16.12.04 г."
    }, {
      "A": "73",
      "B": "Халип Людмила Ивановна",
      "C": "р. 03943-43957 д. 03922-20895,с. 0772-929402",
      "D": "00073",
      "E": "16.12.04 г."
    }, {
      "A": "74",
      "B": "Зубарева Людмила Евгеньевна",
      "C": "д. 423270",
      "D": "00074",
      "E": "16.12.04 г."
    }, {
      "A": "75",
      "B": "Сатыбалдиев Анарбек Алишерович",
      "C": "0772508569 раб: 314371",
      "D": "00075",
      "E": "16.12.04 г."
    }, {
      "A": "76",
      "B": "Турдукулова Бермет Аскеровна",
      "C": "д. 620923, с. 0772-440144",
      "D": "00076",
      "E": "16.12.04 г."
    }, {
      "A": "77",
      "B": "Анарбаев Руслан Алимович",
      "C": "",
      "D": "00077",
      "E": "16.12.04 г."
    }, {
      "A": "78",
      "B": "Маделиев Алыбек Айтмолдоевич",
      "C": "р. 663402 д. 550567, м. 0772-505730",
      "D": "00078",
      "E": "16.12.04 г."
    }, {
      "A": "79",
      "B": "Сыдыков Жолдошбай Чыракович",
      "C": "р. 03222-75411 д. 03222-65842 с. 0773-218402",
      "D": "00079",
      "E": "16.12.04 г."
    }, {
      "A": "80",
      "B": "Абдырасулова Гулзат Аскарбековна",
      "C": "778886817",
      "D": "00080",
      "E": "16.12.04 г."
    }, {
      "A": "81",
      "B": "Нурманбетов Таалайбек Мусаевич",
      "C": "0555772932 0555508057, 0312468006,0312323470",
      "D": "00081",
      "E": "16.12.04 г."
    }, {
      "A": "82",
      "B": "Увайдаева Сагынбубу Арысовна",
      "C": "871178,557-005037,0555787890, 0770891000",
      "D": "00082",
      "E": "16.12.04 г."
    }, {
      "A": "84",
      "B": "Мусулманкулов Октябрь Кыдырмаевич",
      "C": "",
      "D": "00084",
      "E": "16.12.04 г."
    }, {
      "A": "85",
      "B": "Махкамов Сабиржан",
      "C": "р. 03222-28664 д. 03222-1553,м. 0772-391852",
      "D": "00085",
      "E": "16.12.04 г."
    }, {
      "A": "86",
      "B": "Самудинов Каныбек",
      "C": "д. 03536-22146 с. 0773-858668",
      "D": "00086",
      "E": "16.12.04 г."
    }, {
      "A": "87",
      "B": "Тажиев Эсенгул Кызайбекович",
      "C": "426358, 0771105540",
      "D": "00087",
      "E": "27.01.05 г."
    }, {
      "A": "88",
      "B": "Исраилов Мукаш Исраилович",
      "C": "р. 903106 м. 0555-752210",
      "D": "00088",
      "E": "27.01.05 г."
    }, {
      "A": "89",
      "B": "Суранаев Туратбек Джамалбекович",
      "C": "0772-183231",
      "D": "00089",
      "E": "27.01.05 г."
    }, {
      "A": "90",
      "B": "Ростокина Галина Радиковна",
      "C": "М:0555 914099, Р:367370",
      "D": "00090",
      "E": "27.01.05 г."
    }, {
      "A": "91",
      "B": "Акимбаев Эрик Юрданович",
      "C": "М:0777 456622, Р:0312 333076",
      "D": "00091",
      "E": "02.11.05 г."
    }, {
      "A": "92",
      "B": "Ким Наталья Алексеевна",
      "C": "312624548",
      "D": "00092",
      "E": "02.11.05 г."
    }, {
      "A": "93",
      "B": "Рысева Елена Федоровна",
      "C": "555780258",
      "D": "00093",
      "E": "02.11.05 г."
    }, {
      "A": "94",
      "B": "Халитова Найля Рустамовна",
      "C": "Моб. 0772808888, Р.т.568593",
      "D": "00094",
      "E": "02.11.05 г."
    }, {
      "A": "95",
      "B": "Керимбаева Алия Асанбековна",
      "C": "",
      "D": "00095",
      "E": "02.11.05 г."
    }, {
      "A": "96",
      "B": "Сагынов Канатбек Чолпонбаевич",
      "C": "Неверные данные",
      "D": "00096",
      "E": "28.02.06 г."
    }, {
      "A": "97",
      "B": "Халиков Рустам Раисович",
      "C": "Неверные данные",
      "D": "00097",
      "E": "28.02.06 г."
    }, {
      "A": "98",
      "B": "Цой Елизавета Павловна",
      "C": "",
      "D": "00098",
      "E": "28.02.06 г."
    }, {
      "A": "99",
      "B": "Юнникова Евгения Юрьевна",
      "C": "",
      "D": "00099",
      "E": "28.02.06 г."
    }, {
      "A": "100",
      "B": "Бакиров Исакбек",
      "C": "773042803",
      "D": "00100",
      "E": "28.02.06 г."
    }, {
      "A": "101",
      "B": "Шакирова Гульмира Абидиновна",
      "C": "770852727",
      "D": "00101",
      "E": "28.02.06 г."
    }, {
      "A": "102",
      "B": "Осмонкулова Бактыгуль Исламовна",
      "C": "551580008",
      "D": "00102",
      "E": "28.02.06 г."
    }, {
      "A": "103",
      "B": "Джакыпова Талайгуль Эсеновна",
      "C": "м. 0705039090",
      "D": "00103",
      "E": "28.02.06 г."
    }, {
      "A": "104",
      "B": "Джакыпова Светлана Эсеновна",
      "C": "м. 0705039090,0771638828",
      "D": "00104",
      "E": "28.02.06 г."
    }, {
      "A": "105",
      "B": "Качканаков Озубек Эсенбекович",
      "C": "550018692",
      "D": "00105",
      "E": "28.02.06 г."
    }, {
      "A": "106",
      "B": "Омурбеков Асаналы Асизович",
      "C": "",
      "D": "00106",
      "E": "28.02.06 г."
    }, {
      "A": "107",
      "B": "Суюмбаев Бакыт Рыспаевич",
      "C": "",
      "D": "00107",
      "E": "28.02.06 г."
    }, {
      "A": "108",
      "B": "Асанова Бермет Баатырбековна",
      "C": "0771 800741",
      "D": "00108",
      "E": "25.12.06 г."
    }, {
      "A": "109",
      "B": "Ермекбаева Сауле Амангельдиевна",
      "C": "551905444",
      "D": "00109",
      "E": "25.12.06 г."
    }, {
      "A": "110",
      "B": "Касымов Сакымамат",
      "C": "д. 576664 м. 0772-227128",
      "D": "00110",
      "E": "25.12.06 г."
    }, {
      "A": "111",
      "B": "Койлубаева Тынымжан Боромбаевна",
      "C": "312451005",
      "D": "00111",
      "E": "25.12.06 г."
    }, {
      "A": "112",
      "B": "Кочунц Эдуард Михайлович",
      "C": "М:0777 456622 Р:0312 333076",
      "D": "00112",
      "E": "25.12.06 г."
    }, {
      "A": "113",
      "B": "Кумашева Чолпон Дуйшеновна",
      "C": "0555 009597",
      "D": "00113",
      "E": "25.12.06 г."
    }, {
      "A": "114",
      "B": "Курманалиев Советбек Абазбекович",
      "C": "",
      "D": "00114",
      "E": "25.12.06 г."
    }, {
      "A": "115",
      "B": "Мусаева Айжан Рахимжановна",
      "C": "с. 0550-732951",
      "D": "00115",
      "E": "25.12.06 г."
    }, {
      "A": "116",
      "B": "Мусуралиева Наргиз Арстанбековна",
      "C": "",
      "D": "00116",
      "E": "25.12.06 г."
    }, {
      "A": "117",
      "B": "Назарматова Касийра Мукашевна",
      "C": "776978509",
      "D": "00117",
      "E": "25.12.06 г."
    }, {
      "A": "118",
      "B": "Пухирева Елена Юрьевна",
      "C": "д. 659860, М:0555 706605, Д:406605",
      "D": "00118",
      "E": "25.12.06 г."
    }, {
      "A": "119",
      "B": "Голубцов Александр Николаевич",
      "C": "р. 03133-22083 ф. 03133-33747, д. 03133-32381 м. 0772-348358",
      "D": "00119",
      "E": "25.12.06 г."
    }, {
      "A": "120",
      "B": "Ызгыбаев Сыдыкбай",
      "C": "557228477",
      "D": "00120",
      "E": "25.12.06 г."
    }, {
      "A": "121",
      "B": "Бочков Михаил Яковлевич",
      "C": "М:0555 990617, Р:0312 367254",
      "D": "00121",
      "E": "25.12.06 г."
    }, {
      "A": "122",
      "B": "Акопян Тамара Ивановна",
      "C": "р. 211464 м. 0555-226191",
      "D": "00122",
      "E": "11.03.08 г."
    }, {
      "A": "123",
      "B": "Ан Лилия Владимировна",
      "C": "772537163.031257",
      "D": "00123",
      "E": "11.03.08 г."
    }, {
      "A": "124",
      "B": "Андашева Айнура Турдубековна",
      "C": "р. 662553 м. 0555-590699",
      "D": "00124",
      "E": "11.03.08 г."
    }, {
      "A": "125",
      "B": "Джундубаев Эсенбек Аширбекович",
      "C": "м. 0772-319177",
      "D": "00125",
      "E": "11.03.08 г."
    }, {
      "A": "126",
      "B": "Дунганов Урмат Джумадилович",
      "C": "м. 0555-372839",
      "D": "00126",
      "E": "11.03.08 г."
    }, {
      "A": "127",
      "B": "Калиева Жаныл Кутпидиновна",
      "C": "0773177306,0312667533,0312570678",
      "D": "00127",
      "E": "11.03.08 г."
    }, {
      "A": "128",
      "B": "Джолдошев Бактыбек Муканович",
      "C": "р. 666335 м. 0555-990735",
      "D": "00128",
      "E": "11.03.08 г."
    }, {
      "A": "129",
      "B": "Кармышаков Абдиллабек Мурзабекович",
      "C": "д. 03222-36896, 74207, м. 0777-103762",
      "D": "00129",
      "E": "11.03.08 г."
    }, {
      "A": "130",
      "B": "Кожомкулова Гулбадам Ниязбековна",
      "C": "312666408",
      "D": "00130",
      "E": "11.03.08 г."
    }, {
      "A": "131",
      "B": "Кутателадзе Лариса Геннадьевна",
      "C": "р. 320569, 320568",
      "D": "00131",
      "E": "11.03.08 г."
    }, {
      "A": "132",
      "B": "Рузиев Акимжан Якубович",
      "C": "р. 625945 м. 0555-350617",
      "D": "00132",
      "E": "11.03.08 г."
    }, {
      "A": "133",
      "B": "Самсалиев Бакыт Кубанычевич",
      "C": "м. 0555-967574",
      "D": "00133",
      "E": "11.03.08 г."
    }, {
      "A": "134",
      "B": "Саубанов Марсель Рашидович",
      "C": "312600999",
      "D": "00134",
      "E": "11.03.08 г."
    }, {
      "A": "135",
      "B": "Султанкулов Алмасбек Садыкович",
      "C": "03722-55983 03722-72409, м. 0772-429114",
      "D": "00135",
      "E": "11.03.08 г."
    }, {
      "A": "136",
      "B": "Тажибаева Салтанат Сартмаматовна",
      "C": "М:0775 584270, Р:0312 320568",
      "D": "00136",
      "E": "11.03.08 г."
    }, {
      "A": "137",
      "B": "Тилемишов Азамат Темиркулович",
      "C": "М:0777 989821, Р:031 320571",
      "D": "00137",
      "E": "11.03.08 г."
    }, {
      "A": "138",
      "B": "Шаршенбаев Торокан Рысбекович",
      "C": "р. 648402 648403, м. 0772-126785",
      "D": "00138",
      "E": "11.03.08 г."
    }, {
      "A": "139",
      "B": "Таджибаев Улуг-Бек Абдумаликович",
      "C": "772354775",
      "D": "00139",
      "E": "11.03.08 г."
    }, {
      "A": "140",
      "B": "Абдраимов Артыкали Мукумбаевич",
      "C": "772895375",
      "D": "00140",
      "E": "26.11.08 г."
    }, {
      "A": "141",
      "B": "Абдурашидов Шамиль Зарманович",
      "C": "557770806",
      "D": "00141",
      "E": "26.11.08 г."
    }, {
      "A": "142",
      "B": "Асанкулова Марина Сагыналиевна",
      "C": "550669945",
      "D": "00142",
      "E": "26.11.08 г."
    }, {
      "A": "143",
      "B": "Гетман Валерия Валерьевна",
      "C": "д. 664452, 664844, 0 555 975 284",
      "D": "00143",
      "E": "26.11.08 г."
    }, {
      "A": "144",
      "B": "Джумашова Элиза Кабыловна",
      "C": "623856, 680204",
      "D": "00144",
      "E": "26.11.08 г."
    }, {
      "A": "145",
      "B": "Долотбаева Сыйнагул Суйуновна",
      "C": "М:0555 759080, Р:442516",
      "D": "00145",
      "E": "26.11.08 г."
    }, {
      "A": "146",
      "B": "Жунусов Жуманали",
      "C": "777631918",
      "D": "00146",
      "E": "26.11.08 г."
    }, {
      "A": "147",
      "B": "Какилов Тобокел",
      "C": "772070062",
      "D": "00147",
      "E": "26.11.08 г."
    }, {
      "A": "149",
      "B": "Нарматов Куштарали Абдамович",
      "C": "559650884",
      "D": "00149",
      "E": "26.11.08 г."
    }, {
      "A": "150",
      "B": "Орозалиев Нурдин Тукеевич",
      "C": "772223825",
      "D": "00150",
      "E": "26.11.08 г."
    }, {
      "A": "151",
      "B": "Пак Ульяна Юрьевна",
      "C": "",
      "D": "00151",
      "E": "26.11.08 г."
    }, {
      "A": "152",
      "B": "Раимкулов Маматназар",
      "C": "558610203",
      "D": "00152",
      "E": "26.11.08 г."
    }, {
      "A": "153",
      "B": "Рахматов Сабир Нарынбекович",
      "C": "",
      "D": "00153",
      "E": "26.11.08 г."
    }, {
      "A": "154",
      "B": "Тайлаков Кенешбай Доскулович",
      "C": "",
      "D": "00154",
      "E": "26.11.08 г."
    }, {
      "A": "155",
      "B": "Тыналиева Арна Астарбековна",
      "C": "777200120",
      "D": "00155",
      "E": "26.11.08 г."
    }, {
      "A": "156",
      "B": "Шеримбекова Гульнара Абылбековна",
      "C": "961304",
      "D": "00156",
      "E": "26.11.08 г."
    }, {
      "A": "157",
      "B": "Эмильбаева Нургуль Сарынжыевна",
      "C": "555998998",
      "D": "00157",
      "E": "26.11.08 г."
    }, {
      "A": "158",
      "B": "Эстебесова Алтынай Сыртбаевна",
      "C": "555743191",
      "D": "00158",
      "E": "26.11.08 г."
    }, {
      "A": "159",
      "B": "Юлдашева Камилахан Турахановна",
      "C": "М:0777 940540, Р:0322 274774",
      "D": "00159",
      "E": "26.11.08 г."
    }, {
      "A": "160",
      "B": "Алиев Камчыбек Жумаевич",
      "C": "555180869.077812",
      "D": "00160",
      "E": "19.10.09 г."
    }, {
      "A": "161",
      "B": "Абдувалиев Зарылбек Рубенович",
      "C": "М:0771 178 872, Р:897927",
      "D": "00161",
      "E": "19.10.09 г."
    }, {
      "A": "162",
      "B": "Айтбаев Данияр Кубанычбекович",
      "C": "0555 961776",
      "D": "00162",
      "E": "19.10.09 г."
    }, {
      "A": "163",
      "B": "Абдуманапова Юлия Эмильевна",
      "C": "0555 727544, 696232",
      "D": "00163",
      "E": "19.10.09 г."
    }, {
      "A": "164",
      "B": "Алымкулов Кубат Алымкулович",
      "C": "559515587.070051",
      "D": "00164",
      "E": "19.10.09 г."
    }, {
      "A": "165",
      "B": "Базаркулова Гульзада Аскарбековна",
      "C": "0555-751592",
      "D": "00165",
      "E": "19.10.09 г."
    }, {
      "A": "166",
      "B": "Бакеева Кульжамал Асангазиевна",
      "C": "312624475",
      "D": "00166",
      "E": "19.10.09 г."
    }, {
      "A": "167",
      "B": "Бегматова Каиргуль Шаршекеевна",
      "C": "М:0559 996618, Р:430428",
      "D": "00167",
      "E": "19.10.09 г."
    }, {
      "A": "168",
      "B": "Бейшекеев Эсенбек",
      "C": "0772 334706",
      "D": "00168",
      "E": "19.10.09 г."
    }, {
      "A": "169",
      "B": "Давлеталиева Джамиля Джолдошбековна",
      "C": "0555 751900",
      "D": "00169",
      "E": "19.10.09 г."
    }, {
      "A": "170",
      "B": "Джекшенова Кульнара Шейшеновна",
      "C": "0555 400139",
      "D": "00170",
      "E": "19.10.09 г."
    }, {
      "A": "171",
      "B": "Джумашев Саматбек Аспекович",
      "C": "0775 977957",
      "D": "00171",
      "E": "19.10.09 г."
    }, {
      "A": "172",
      "B": "Джумашева Бермет Мыктыбековна",
      "C": "д. 427260, 0770 645449, 0779494543",
      "D": "00172",
      "E": "19.10.09 г."
    }, {
      "A": "173",
      "B": "Джунусов Улукман Шарипович",
      "C": "0772 530227",
      "D": "00173",
      "E": "19.10.09 г."
    }, {
      "A": "174",
      "B": "Ибраева Анара Турсуналиевна",
      "C": "893199, 0550 787845",
      "D": "00174",
      "E": "19.10.09 г."
    }, {
      "A": "175",
      "B": "Ибраимов Таласбай Шаршенбаевич",
      "C": "0773 252557",
      "D": "00175",
      "E": "19.10.09 г."
    }, {
      "A": "176",
      "B": "Кульджигачева Зарина Викторовна",
      "C": "0772 074400",
      "D": "00176",
      "E": "19.10.09 г."
    }, {
      "A": "177",
      "B": "Макешова Назгул Аскаровна",
      "C": "д. 594472, с. 0543 911536",
      "D": "00177",
      "E": "19.10.09 г."
    }, {
      "A": "178",
      "B": "Мамедова Анна Владимировна",
      "C": "0772 322255, 316151",
      "D": "00178",
      "E": "19.10.09 г."
    }, {
      "A": "179",
      "B": "Осмоналиев Марс Мукашевич",
      "C": "0555 297480, 308029",
      "D": "00179",
      "E": "19.10.09 г."
    }, {
      "A": "180",
      "B": "Пак Елена Юрьевна",
      "C": "300001,300010, 0555 587657",
      "D": "00180",
      "E": "19.10.09 г."
    }, {
      "A": "181",
      "B": "Садыков Чингиз Каниметович",
      "C": "0772 326418",
      "D": "00181",
      "E": "19.10.09 г."
    }, {
      "A": "182",
      "B": "Самидинов Кенешбек Боронович",
      "C": "773786274",
      "D": "00182",
      "E": "19.10.09 г."
    }, {
      "A": "183",
      "B": "Токтомамбетова Чолпон Байжановна",
      "C": "0772 798071, М:0709 976600, Р:569635",
      "D": "00183",
      "E": "19.10.09 г."
    }, {
      "A": "184",
      "B": "Халип Денис Иванович",
      "C": "0772 573369",
      "D": "00184",
      "E": "19.10.09 г."
    }, {
      "A": "185",
      "B": "Эшенбаев Нурлан Саматович",
      "C": "0773 361938",
      "D": "00185",
      "E": "19.10.09 г."
    }, {
      "A": "186",
      "B": "Азизов Нармеджан Тахаевич",
      "C": "0555 583660",
      "D": "00186",
      "E": "01.06.10 г."
    }, {
      "A": "187",
      "B": "Дюшеева Замира Акматбековна",
      "C": "0555 938010, 0555129812",
      "D": "00187",
      "E": "01.06.10 г."
    }, {
      "A": "188",
      "B": "Камчибекова Гульчехра Садырбековна",
      "C": "0772 678651",
      "D": "00188",
      "E": "01.06.10 г."
    }, {
      "A": "189",
      "B": "Шамшиев Абдухалык Абдулхаевич",
      "C": "0555 900317",
      "D": "00189",
      "E": "01.06.10 г."
    }, {
      "A": "190",
      "B": "Шевелева Татьяна Владимировна",
      "C": "0555 921047, 0312564879",
      "D": "00190",
      "E": "01.06.10 г."
    }, {
      "A": "191",
      "B": "Шиваза Тахир Алимович",
      "C": "т. 386733, 0550 706267",
      "D": "00191",
      "E": "01.11.10 г."
    }, {
      "A": "192",
      "B": "Каниметова Мээрим Сталбековна",
      "C": "0555 727554, М:0555 750554, Р:0312 398288",
      "D": "00192",
      "E": "01.11.10 г."
    }, {
      "A": "193",
      "B": "Кочеров Руслан Бакыбаевич",
      "C": "374919, 0772 428235",
      "D": "00193",
      "E": "01.11.10 г."
    }, {
      "A": "194",
      "B": "Леднев Евгений Васильевич",
      "C": "324958, 0701 070107",
      "D": "00194",
      "E": "01.11.10 г."
    }, {
      "A": "195",
      "B": "Мааткабылова Аида Асыкбаевна",
      "C": "678837, 610800, 0772 502245, 0772 502243",
      "D": "00195",
      "E": "01.11.10 г."
    }, {
      "A": "196",
      "B": "Осмонова Жыпара Идирисовна",
      "C": "0555 754455",
      "D": "00196",
      "E": "01.11.10 г."
    }, {
      "A": "197",
      "B": "Пак Дмитрий Вадимович",
      "C": "320781, 0770 787885",
      "D": "00197",
      "E": "01.11.10 г."
    }, {
      "A": "198",
      "B": "Ускенбаева Эльмира Авроровна",
      "C": "895440",
      "D": "00198",
      "E": "01.11.10 г."
    }, {
      "A": "199",
      "B": "Факердинова Альбина Медербековна",
      "C": "612999, 0772 518551",
      "D": "00199",
      "E": "01.11.10 г."
    }, {
      "A": "200",
      "B": "Джоробеков Рустам Дуйшенбекович",
      "C": "0555 951511",
      "D": "00200",
      "E": "01.11.10 г."
    }, {
      "A": "201",
      "B": "Абазбекова Гульжан Нурмамбетовна",
      "C": "д.т 492029 р.т. 678313",
      "D": "00201",
      "E": "23.06.11 г."
    }, {
      "A": "202",
      "B": "Ан Роза Владимировна",
      "C": "д.т. 563953 р.т. 895440, 0705743525",
      "D": "00202",
      "E": "23.06.11 г."
    }, {
      "A": "203",
      "B": "Асанбеков Нурбек Укубаевич",
      "C": "0552-324842",
      "D": "00203",
      "E": "23.06.11 г."
    }, {
      "A": "204",
      "B": "Атаканова Мира Рысбековна",
      "C": "0555-5025005 д т: 521633 р.т. 899898",
      "D": "00204",
      "E": "23.06.11 г."
    }, {
      "A": "205",
      "B": "Бакаева Жумагул Асангазиевна",
      "C": "0550-583383, р. 03944-32573(32568)\nд. 03922-52362",
      "D": "00205",
      "E": "23.06.11 г."
    }, {
      "A": "206",
      "B": "Бейшеева Асель Турдубаевна",
      "C": "0557-703010",
      "D": "00206",
      "E": "23.06.11 г."
    }, {
      "A": "207",
      "B": "Истемесов Улан Турусбекович",
      "C": "д.т. 574058 р.т 902203 0555-800816",
      "D": "00207",
      "E": "23.06.11 г."
    }, {
      "A": "208",
      "B": "Касымова Аида Джакшылыковна",
      "C": "0555 088686",
      "D": "00208",
      "E": "21.06.11 г."
    }, {
      "A": "209",
      "B": "Медеров Алмаз Тилекович",
      "C": "д.т. 368851 0775-996775",
      "D": "00209",
      "E": "23.06.11 г."
    }, {
      "A": "210",
      "B": "Нусупбеков Кылычбек Чекирович",
      "C": "д.т.551637, 0770-978822, 0550-106600",
      "D": "00210",
      "E": "23.06.11 г."
    }, {
      "A": "211",
      "B": "Самаков Нурдин Таланбекович",
      "C": "д.т. 434579 р.т. 622190, 0702494494",
      "D": "00211",
      "E": "23.06.11 г."
    }, {
      "A": "212",
      "B": "Самакова Салтанат Толоновна",
      "C": "700971367",
      "D": "00212",
      "E": "23.06.11 г."
    }, {
      "A": "213",
      "B": "Сулайманова Рахат Орозбековна",
      "C": "770901368",
      "D": "00213",
      "E": "23.06.11 г."
    }, {
      "A": "214",
      "B": "Тусупбекова Лиза Ануаровна",
      "C": "д.т. 218534 р.т. 214683, 0777-900388",
      "D": "00214",
      "E": "23.06.11 г."
    }, {
      "A": "215",
      "B": "Усен кызы Назира",
      "C": "0549-927-927",
      "D": "00215",
      "E": "23.06.11 г."
    }, {
      "A": "216",
      "B": "Шулдякова Галина Ивановна",
      "C": "320568, 320569 0777-989887",
      "D": "00216",
      "E": "23.06.11 г."
    }, {
      "A": "217",
      "B": "Эржанов Советбек Алсеитович",
      "C": "д.т. 604117 р.т. 456604, 0772-539680",
      "D": "00217",
      "E": "23.06.11 г."
    }, {
      "A": "218",
      "B": "Абдылаев Абсатар Анарбаевич",
      "C": "0772-417975, 0550-929828 сдал серт. 2015",
      "D": "00218",
      "E": "31.10.11 г."
    }, {
      "A": "219",
      "B": "Адам Бейшеналы",
      "C": "0555-444435",
      "D": "00219",
      "E": "31.10.11 г."
    }, {
      "A": "220",
      "B": "Асанкожоев Саламатбек Тагаевич",
      "C": "0555-32 82 52",
      "D": "00220",
      "E": "31.10.11 г."
    }, {
      "A": "221",
      "B": "Ерибаева Нарзана Саргашкаевна",
      "C": "0555-822733, 0772-372131",
      "D": "00221",
      "E": "31.10.11 г."
    }, {
      "A": "222",
      "B": "Залунина Людмила Григорьевна",
      "C": "0777-979708",
      "D": "00222",
      "E": "31.10.11 г."
    }, {
      "A": "223",
      "B": "Мавлянкулов Жакшыбай Назымович",
      "C": "0779-180165",
      "D": "00223",
      "E": "31.10.11 г."
    }, {
      "A": "224",
      "B": "Мамырканов Казакбай Орозакунович",
      "C": "0772-500900",
      "D": "00224",
      "E": "31.10.11 г."
    }, {
      "A": "225",
      "B": "Нурмаматов Урубай Бапыевич",
      "C": "0772-105575, 0559105575",
      "D": "00225",
      "E": "31.10.11 г."
    }, {
      "A": "226",
      "B": "Сарикеев Абдылда Жумабекович",
      "C": "0555-35-39-48, 0772-24-82-24",
      "D": "00226",
      "E": "31.10.11 г."
    }, {
      "A": "227",
      "B": "Слугина Алле Владимировна",
      "C": "0772-570015",
      "D": "00227",
      "E": "31.10.11 г."
    }, {
      "A": "228",
      "B": "Третьякова Наталья Владимировна",
      "C": "62-33-80, 0555 96 22 06",
      "D": "00228",
      "E": "31.10.11 г."
    }, {
      "A": "229",
      "B": "Усманалиева Гульбайра Бейшенбековна",
      "C": "0551-240775",
      "D": "00229",
      "E": "31.10.11 г."
    }, {
      "A": "230",
      "B": "Эсенов Кенжебек",
      "C": "М:0770 579219, Р:896995",
      "D": "00230",
      "E": "31.10.11 г."
    }, {
      "A": "231",
      "B": "Акматов Куванычбек Кадырбекович",
      "C": "0555-777-501,890944",
      "D": "00231",
      "E": "01.06.12 г."
    }, {
      "A": "232",
      "B": "Алымолдоев Таласбек Доктурбекович",
      "C": "0543-009078, 0555-771232",
      "D": "00232",
      "E": "01.06.12 г."
    }, {
      "A": "233",
      "B": "Асаналиева Гульзат Турганбаевна",
      "C": "0557-907-779",
      "D": "00233",
      "E": "01.06.12 г."
    }, {
      "A": "234",
      "B": "Асаналиева Махабат Ийсаевна",
      "C": "0555-75-55-27",
      "D": "00234",
      "E": "01.06.12 г."
    }, {
      "A": "235",
      "B": "Базарбаева Айнура Кудусовна",
      "C": "0312-65-22-75, 0555-776315",
      "D": "00235",
      "E": "01.06.12 г."
    }, {
      "A": "236",
      "B": "Бокешев Нурлан Турганалиевич",
      "C": "0550-82-05-73",
      "D": "00236",
      "E": "01.06.12 г."
    }, {
      "A": "237",
      "B": "Бутенко Наталья Валерьевна",
      "C": "0555-771450",
      "D": "00237",
      "E": "01.06.12 г."
    }, {
      "A": "238",
      "B": "Джокоева Мунара Толобатовна",
      "C": "0312-311808, 0550-500156",
      "D": "00238",
      "E": "01.06.12 г."
    }, {
      "A": "239",
      "B": "Иманалиев Казы Султанкулович",
      "C": "0779-277636",
      "D": "00239",
      "E": "01.06.12 г."
    }, {
      "A": "240",
      "B": "Курманалиева Роза Ашуваевна",
      "C": "0555-600-120",
      "D": "00240",
      "E": "01.06.12 г."
    }, {
      "A": "241",
      "B": "Ласковая Ирина Викторовна",
      "C": "0555-773-902",
      "D": "00241",
      "E": "01.06.12 г."
    }, {
      "A": "242",
      "B": "Маматова Айдай Болотбековна",
      "C": "0555-772016",
      "D": "00242",
      "E": "01.06.12 г."
    }, {
      "A": "243",
      "B": "Мамбетакунов Дамир Талантович",
      "C": "0555-803-207",
      "D": "00243",
      "E": "01.06.12 г."
    }, {
      "A": "244",
      "B": "Мукашова Айтолкун Абдыжапаровна",
      "C": "0770-55-63-33",
      "D": "00244",
      "E": "01.06.12 г."
    }, {
      "A": "245",
      "B": "Садырбекова Канышай Садырбековна",
      "C": "0777-988050, +77019120184",
      "D": "00245",
      "E": "01.06.12 г."
    }, {
      "A": "246",
      "B": "Сакеева Мырзагуль Насыровна",
      "C": "550477601",
      "D": "00246",
      "E": "01.06.12 г."
    }, {
      "A": "247",
      "B": "Суйналиева Минара Мырзабековна",
      "C": "0552-101-106, д.т. 50-53-46",
      "D": "00247",
      "E": "01.06.12 г."
    }, {
      "A": "248",
      "B": "Тулеев Бейшембек Шабырбекович",
      "C": "0555-333-054",
      "D": "00248",
      "E": "01.06.12 г."
    }, {
      "A": "249",
      "B": "Цой Ирина Викторовна",
      "C": "0550-227796",
      "D": "00249",
      "E": "01.06.12 г."
    }, {
      "A": "250",
      "B": "Абдимажитов Кубулжан Каратаевич",
      "C": "0555-554-775, 0707-100-559",
      "D": "00250",
      "E": "14.11.12 г."
    }, {
      "A": "251",
      "B": "Аскарбеков Бакыт",
      "C": "0312-371819, 90-12-16",
      "D": "00251",
      "E": "14.11.12 г."
    }, {
      "A": "252",
      "B": "Асакеев Тимур Нурбекович",
      "C": "(0312)33-41-59, 0555-553355, 0550-925107",
      "D": "00252",
      "E": "14.11.12 г."
    }, {
      "A": "253",
      "B": "Ибраймакунов Омурбек Касымович",
      "C": "(0312)66-18-03 р. 36-31-04 д. 0555-111174",
      "D": "00253",
      "E": "14.11.12 г."
    }, {
      "A": "254",
      "B": "Ибраймакунов Айдар Касымович",
      "C": "52-25-07, 0700-798189, 0555-400182",
      "D": "00254",
      "E": "14.11.12 г."
    }, {
      "A": "255",
      "B": "Ким Филимон",
      "C": "0557-545955",
      "D": "00255",
      "E": "14.11.12 г."
    }, {
      "A": "256",
      "B": "Керимбекова Эркингуль Сагындыковна",
      "C": "0556-900-368 (в декрете)",
      "D": "00256",
      "E": "14.11.12 г."
    }, {
      "A": "257",
      "B": "Мамбеталиев Азамат Айдарбекович",
      "C": "0555-001453, 0777-979704",
      "D": "00257",
      "E": "14.11.12 г."
    }, {
      "A": "258",
      "B": "Нургазиева Рауза Канымбекова",
      "C": "(0312)491902, 0772-500-502",
      "D": "00258",
      "E": "14.11.12 г."
    }, {
      "A": "259",
      "B": "Омурбекова Асел Асаналиевна",
      "C": "0312-37-21-78, 0555-75-35-10, 0770-443-220",
      "D": "00259",
      "E": "14.11.12 г."
    }, {
      "A": "260",
      "B": "Ормон уулу Алинур",
      "C": "0555-900-184",
      "D": "00260",
      "E": "14.11.12 г."
    }, {
      "A": "261",
      "B": "Орозалиева Бакен Мамытовна",
      "C": "44-05-95, 0770-50-42-76",
      "D": "00261",
      "E": "14.11.12 г."
    }, {
      "A": "262",
      "B": "Садиков Давирбек Турсунбаевич",
      "C": "0555-001301",
      "D": "00262",
      "E": "14.11.12 г."
    }, {
      "A": "263",
      "B": "Сатылганова Жылдыз Толобаевна",
      "C": "0550-691100",
      "D": "00263",
      "E": "14.11.12 г."
    }, {
      "A": "264",
      "B": "Сулайманова Таалайкуль Кариевна",
      "C": "0559-25-00-99, 0772 981399",
      "D": "00264",
      "E": "14.11.12 г."
    }, {
      "A": "265",
      "B": "Торогулов Орозали",
      "C": "61-44-51, 0554-44-86-56",
      "D": "00265",
      "E": "14.11.12 г."
    }, {
      "A": "266",
      "B": "Шабданов Алмазбек Султанбекович",
      "C": "0555-900-120",
      "D": "00266",
      "E": "14.11.12 г."
    }, {
      "A": "267",
      "B": "Абдукаимова Гульзада Тилекбековна",
      "C": "0555 800 999",
      "D": "00267",
      "E": "05.07.13 г."
    }, {
      "A": "268",
      "B": "Айтымбетов Эрнис Жамадилович",
      "C": "57-19-96, 0772-308-601",
      "D": "00268",
      "E": "05.07.13 г."
    }, {
      "A": "269",
      "B": "Батыркулова Рахат Октомбековна",
      "C": "р.т: 66-40-35, д. 25-19-23, 0773-24-49-97",
      "D": "00269",
      "E": "05.07.13 г."
    }, {
      "A": "270",
      "B": "Белецкая Эмма Генриховна",
      "C": "0777-979702",
      "D": "00270",
      "E": "05.07.13 г."
    }, {
      "A": "271",
      "B": "Биримкулова Кыял Дуйшенбековна",
      "C": "р.т: 49-15-74, 0551-51-03-51",
      "D": "00271",
      "E": "05.07.13 г."
    }, {
      "A": "272",
      "B": "Бокошова Айша Чороевна",
      "C": "0778-799861,0708-455-155, д. 563434",
      "D": "00272",
      "E": "05.07.13 г."
    }, {
      "A": "273",
      "B": "Жороев Замирбек Адылович",
      "C": "772428265",
      "D": "00273",
      "E": "05.07.13 г."
    }, {
      "A": "274",
      "B": "Жумашалиев Урмат Эсенкулович",
      "C": "р.т. 39-18-16,39-18-21, 0558 (708)-918-558",
      "D": "00274",
      "E": "05.07.13 г."
    }, {
      "A": "275",
      "B": "Каримова Назгуль Ирсалиевна",
      "C": "0555-445-375",
      "D": "00275",
      "E": "05.07.13 г."
    }, {
      "A": "276",
      "B": "Каримбаева Анара Кыялбековна",
      "C": "0702-12-33-77",
      "D": "00276",
      "E": "05.07.13 г."
    }, {
      "A": "277",
      "B": "Койчуманова Джамиля Азатовна",
      "C": "0555-752292",
      "D": "00277",
      "E": "05.07.13 г."
    }, {
      "A": "278",
      "B": "Кудайбердиев Акылбек Насрединович",
      "C": "р. 511543,д. 484412, 0555-001153",
      "D": "00278",
      "E": "05.07.13 г."
    }, {
      "A": "279",
      "B": "Кулжигачева Асель Султанкуловна",
      "C": "0551-55-19-19",
      "D": "00279",
      "E": "05.07.13 г."
    }, {
      "A": "280",
      "B": "Ланюгова Татьяна Александровна",
      "C": "0555-91-53-03",
      "D": "00280",
      "E": "05.07.13 г."
    }, {
      "A": "281",
      "B": "Лебуза Махмут Хусеинович",
      "C": "0555-77-58-01",
      "D": "00281",
      "E": "05.07.13 г."
    }, {
      "A": "282",
      "B": "Малабекова Гульзада Маратовна",
      "C": "Неверные данные",
      "D": "00282",
      "E": "05.07.13 г."
    }, {
      "A": "283",
      "B": "Маматбекова Назгуль Эркинбековна",
      "C": "0553-57-16-57",
      "D": "00283",
      "E": "05.07.13 г."
    }, {
      "A": "284",
      "B": "Марифов Тянь-Шанбек Джолборсханович",
      "C": "0550-000168",
      "D": "00284",
      "E": "05.07.13 г."
    }, {
      "A": "285",
      "B": "Осмонов Идирис Термечикович",
      "C": "0555-92-99-75, 0555999528",
      "D": "00285",
      "E": "05.07.13 г."
    }, {
      "A": "286",
      "B": "Розыбаев Ауд Маликович",
      "C": "0555-999-567",
      "D": "00286",
      "E": "05.07.13 г."
    }, {
      "A": "287",
      "B": "Семенова Елена Юрьевна",
      "C": "0555-521213",
      "D": "00287",
      "E": "05.07.13 г."
    }, {
      "A": "288",
      "B": "Токочева Татьяна Александровна",
      "C": "0555-85-87-83, 0700858783",
      "D": "00288",
      "E": "05.07.13 г."
    }, {
      "A": "289",
      "B": "Токаматов Алтынбек Касымбекович",
      "C": "0555-83-18-75",
      "D": "00289",
      "E": "05.07.13 г."
    }, {
      "A": "290",
      "B": "Тургунбекова Эльнура Курвангалиевна",
      "C": "0772-500-131",
      "D": "00290",
      "E": "05.07.13 г."
    }, {
      "A": "291",
      "B": "Турдалиева Айгуль Тагайбековна",
      "C": "0772-577-309",
      "D": "00291",
      "E": "05.07.13 г."
    }, {
      "A": "292",
      "B": "Чекиров Насиридин Эргешович",
      "C": "0556-333319",
      "D": "00292",
      "E": "05.07.13 г."
    }, {
      "A": "293",
      "B": "Шайлообек уулу Нурбек",
      "C": "0555-20-40-66",
      "D": "00293",
      "E": "05.07.13 г."
    }, {
      "A": "294",
      "B": "Шакирова Клара Капановна",
      "C": "0555-27-21-79",
      "D": "00294",
      "E": "05.07.13 г."
    }, {
      "A": "295",
      "B": "Эркинбаева Айдай Турсункуловна",
      "C": "0558-009079",
      "D": "00295",
      "E": "05.07.13 г."
    }, {
      "A": "296",
      "B": "Рысбаев Омурбек Маметабылдаевич",
      "C": "0553-238385",
      "D": "00296",
      "E": "05.07.13 г."
    }, {
      "A": "296",
      "B": "Абдымомунова Сыйнагуль Рыскелдиевна",
      "C": "0555-80-26-26",
      "D": "00296",
      "E": "20.11.13 г."
    }, {
      "A": "297",
      "B": "Абдрахманов Бактыбек Калмаматович",
      "C": "777250593",
      "D": "00297",
      "E": "20.11.13 г."
    }, {
      "A": "298",
      "B": "Арутюнан Манвел Рудикович",
      "C": "0555-001301",
      "D": "00298",
      "E": "20.11.13 г."
    }, {
      "A": "299",
      "B": "Балбаков Турмушбек Айдралиевич",
      "C": "62-61-64 раб.тел., 0552(0772) 805514",
      "D": "00299",
      "E": "20.11.13 г."
    }, {
      "A": "300",
      "B": "Бексултанов Азисбек Абдилкариевич",
      "C": "",
      "D": "00300",
      "E": "20.11.13 г."
    }, {
      "A": "301",
      "B": "Бусурманкулов Абдыкалык Бурканбекович",
      "C": "0777-55-00-63",
      "D": "00301",
      "E": "20.11.13 г."
    }, {
      "A": "302",
      "B": "Лубуза Хаджеза Юбузовна",
      "C": "0550 49-20-85",
      "D": "00302",
      "E": "20.11.13 г."
    }, {
      "A": "303",
      "B": "Мадамбекова Айзада Асангазыевна",
      "C": "770805051.680698",
      "D": "00303",
      "E": "20.11.13 г."
    }, {
      "A": "304",
      "B": "Мадиев Кубат Ашымович",
      "C": "42-47-28 дом. тел., 59-00-69 раб тел.\n0555-334405",
      "D": "00304",
      "E": "20.11.13 г."
    }, {
      "A": "305",
      "B": "Намазбеков Абдыкерим Жусупович",
      "C": "0550-173775, 0779-051906",
      "D": "00305",
      "E": "20.11.13 г."
    }, {
      "A": "306",
      "B": "Омарова Асель Темирбековна",
      "C": "0551(0708)-19-01-77",
      "D": "00306",
      "E": "20.11.13 г."
    }, {
      "A": "307",
      "B": "Оморова Мира Кошойбековна",
      "C": "0550-500-247",
      "D": "00307",
      "E": "20.11.13 г."
    }, {
      "A": "308",
      "B": "Сапарбаева Чолпон Шаакеримова",
      "C": "0554-23-43-10 (в Японии)",
      "D": "00308",
      "E": "20.11.13 г."
    }, {
      "A": "309",
      "B": "Султаналиева Нуржамал Кочербековна",
      "C": "0555-506999",
      "D": "00309",
      "E": "20.11.13 г."
    }, {
      "A": "310",
      "B": "Абдыкадырова Гульмира Анарбековна",
      "C": "0777-97-97-87, 0775586200",
      "D": "00310",
      "E": "26.05.14 г."
    }, {
      "A": "311",
      "B": "Айсаев Насирдин Асанбекович",
      "C": "0555/772- 50 87 80",
      "D": "00311",
      "E": "26.05.14г."
    }, {
      "A": "312",
      "B": "Бейшенбаев Эдиль Нурбекович",
      "C": "0772-155094, 0772-427007, 0772 150607",
      "D": "00312",
      "E": "26.05.14 г."
    }, {
      "A": "313",
      "B": "Жапарова Нуризат Маратовна",
      "C": "0772-08-37-00",
      "D": "00313",
      "E": "26.05.14 г."
    }, {
      "A": "314",
      "B": "Ибрагимова Далиде Тыналиевна",
      "C": "0555-96-17-73",
      "D": "00314",
      "E": "26.05.14 г."
    }, {
      "A": "315",
      "B": "Исмаилова Эльмира Токтомушевна",
      "C": "0555-37-34-95, 0706373495",
      "D": "00315",
      "E": "26.05.14 г."
    }, {
      "A": "316",
      "B": "Калмаматова Чолпон Темирбековна",
      "C": "0772-54-22-22",
      "D": "00316",
      "E": "26.05.14 г."
    }, {
      "A": "317",
      "B": "Кузьмина Ольга Владимировна",
      "C": "0312-511815, 0555-72-77-70",
      "D": "00317",
      "E": "26.05.14 г."
    }, {
      "A": "318",
      "B": "Кулжигачева Нурзат Султанкуловна",
      "C": "0559-07-09-01",
      "D": "00318",
      "E": "26.05.14г."
    }, {
      "A": "319",
      "B": "Матибраимова Венера Райымкуловна",
      "C": "0772-32-74,19",
      "D": "00319",
      "E": "26.05.14 г."
    }, {
      "A": "320",
      "B": "Муканов Улан Бактыбекович",
      "C": "0708050708, 0776170709",
      "D": "00320",
      "E": "26.05.14 г."
    }, {
      "A": "321",
      "B": "Мусаева Роза Имашевна",
      "C": "0555-707517",
      "D": "00321",
      "E": "26.05.14 г."
    }, {
      "A": "322",
      "B": "Токтомбаева Назгуль Салиевна",
      "C": "0551-32-45-88",
      "D": "00322",
      "E": "26.05.14 г."
    }, {
      "A": "323",
      "B": "Асаналиева Кундуз Бекташовна",
      "C": "621833",
      "D": "00323",
      "E": "13.11.14 г."
    }, {
      "A": "324",
      "B": "Асанбекова Айгуль Муктарбековна",
      "C": "0559-161977",
      "D": "00324",
      "E": "13.11.14 г."
    }, {
      "A": "325",
      "B": "Асырандиева Аида Кенжебековна",
      "C": "0555-818800",
      "D": "00325",
      "E": "13.11.14 г."
    }, {
      "A": "326",
      "B": "Бактыбаев Марат Нишенбаевич",
      "C": "0555-150327",
      "D": "00326",
      "E": "13.11.14 г."
    }, {
      "A": "327",
      "B": "Джамашева Жылдызкан Жээналыевна",
      "C": "0701-770-009, 661795",
      "D": "00327",
      "E": "13.11.14 г."
    }, {
      "A": "328",
      "B": "Иманкулов Камчыбек Бактыбекович",
      "C": "620070, 0555-004010",
      "D": "00328",
      "E": "13.11.14 г."
    }, {
      "A": "330",
      "B": "Мусурманкулов Нурбек Алмамбекович",
      "C": "0555-331-563",
      "D": "00330",
      "E": "13.11.14 г."
    }, {
      "A": "331",
      "B": "Омурканов Жума Кайбылдаевич",
      "C": "0555-345555",
      "D": "00331",
      "E": "13.11.14 г."
    }, {
      "A": "332",
      "B": "Осмонбекова Айнур Сагындыковна",
      "C": "0703-227225, Моб. 0702 226229, Р.321948",
      "D": "00332",
      "E": "13.11.14 г."
    }, {
      "A": "333",
      "B": "Солтонбекова Джылдыз Сейитовна",
      "C": "0555-000390",
      "D": "00333",
      "E": "13.11.14 г."
    }, {
      "A": "334",
      "B": "Атабаев Акылбек Токтобаевич",
      "C": "0553 100770",
      "D": "00334",
      "E": "27.07.15 г."
    }, {
      "A": "335",
      "B": "Назаралиева Жаныл Турганбаевна",
      "C": "0550 711735",
      "D": "00335",
      "E": "27.07.15 г."
    }, {
      "A": "336",
      "B": "Черикчиева Мээрим Койчубековна",
      "C": "0555 311797",
      "D": "00336",
      "E": "27.07.15 г."
    }, {
      "A": "337",
      "B": "Дарбикеева Джылдыз Сейитовна",
      "C": "0772 522205",
      "D": "00337",
      "E": "27.07.15 г."
    }, {
      "A": "338",
      "B": "Ташматова Гульнарахон Рамонжоновна",
      "C": "0776 966020",
      "D": "00338",
      "E": "27.07.15 г."
    }, {
      "A": "339",
      "B": "Гапыров Авазбек Жакыпович",
      "C": "0555 060909",
      "D": "00339",
      "E": "27.07.15 г."
    }, {
      "A": "340",
      "B": "Бельгибаева Гульмира Кубанычбековна",
      "C": "555774424",
      "D": "00340",
      "E": "06.11.15 г."
    }, {
      "A": "341",
      "B": "Христоева Татьяна Валерьевна",
      "C": "556864255",
      "D": "00341",
      "E": "06.11.15 г"
    }, {
      "A": "342",
      "B": "Лозицкая Анна Александровна",
      "C": "556864255",
      "D": "00342",
      "E": "06.11.15 г"
    }, {
      "A": "343",
      "B": "Бексултанов Эруст Таубекович",
      "C": "551571770",
      "D": "00343",
      "E": "06.11.15 г"
    }, {
      "A": "344",
      "B": "Сакиев Мирлан Казыбекович",
      "C": "557238308",
      "D": "00344",
      "E": "06.11.15 г"
    }, {
      "A": "345",
      "B": "Сатимбаев Улан Кубанычбекович",
      "C": "555728358",
      "D": "00345",
      "E": "06.11.15 г"
    }, {
      "A": "346",
      "B": "Исираилов Абсамат Жоробекович",
      "C": "0772777221, 0702077221",
      "D": "00346",
      "E": "06.11.15 г"
    }, {
      "A": "347",
      "B": "Акматов Абдисамат Жуманович",
      "C": "770818981",
      "D": "00347",
      "E": "06.11.15 г"
    }, {
      "A": "348",
      "B": "Ибраев Нурлан Маркилович",
      "C": "550516366",
      "D": "00348",
      "E": "06.11.15 г"
    }, {
      "A": "349",
      "B": "Юсупова Бурулсун Турарбековна",
      "C": "555323310",
      "D": "00349",
      "E": "06.11.15 г"
    }, {
      "A": "350",
      "B": "Борбугулова Гульназ Тайырбековна",
      "C": "772180188",
      "D": "00350",
      "E": "06.11.15 г"
    }, {
      "A": "351",
      "B": "Карпыкова Айым Руслановна",
      "C": "770988060",
      "D": "00351",
      "E": "06.11.15 г"
    }, {
      "A": "352",
      "B": "Кулубаева Эльвира Калмуратовна",
      "C": "555328730",
      "D": "00352",
      "E": "06.11.15 г"
    }, {
      "A": "353",
      "B": "Нарматова Назгуль Балтабаевна",
      "C": "557586206",
      "D": "00353",
      "E": "06.11.15 г"
    }, {
      "A": "363",
      "B": "Султанова Адыла Тарлан кызы",
      "C": "559328688",
      "D": "00363",
      "E": "11.07.16 г."
    }, {
      "A": "354",
      "B": "Азизов Бобир Хасанбаевич",
      "C": "772700844",
      "D": "00354",
      "E": "42562"
    }, {
      "A": "355",
      "B": "Байгончокова Жылдыз Конушбековна",
      "C": "559545777",
      "D": "00355",
      "E": "42562"
    }, {
      "A": "356",
      "B": "Бакеев Болот Валиевич",
      "C": "",
      "D": "00356",
      "E": "11.07.16 г"
    }, {
      "A": "357",
      "B": "Ванян Армен",
      "C": "770009955",
      "D": "00357",
      "E": "11.07.16 г"
    }, {
      "A": "358",
      "B": "Запара Александр Дмитриевич",
      "C": "700456987",
      "D": "00358",
      "E": "42562"
    }, {
      "A": "359",
      "B": "Заффаров Курустанбек Аскербекович",
      "C": "779151959",
      "D": "00359",
      "E": "11.07.16 г"
    }, {
      "A": "360",
      "B": "Кутепова Татьяна Филлиповна",
      "C": "555990659",
      "D": "00360",
      "E": "11.07.16 г"
    }, {
      "A": "361",
      "B": "Омуралиев Нурбек Асекович",
      "C": "554554328",
      "D": "00361",
      "E": "11.07.16 г"
    }, {
      "A": "362",
      "B": "Сонунбек уулу Марс",
      "C": "",
      "D": "00362",
      "E": "11.07.16 г"
    }, {
      "A": "364",
      "B": "Суранаева Айдай Акылбековна",
      "C": "708687004",
      "D": "00364",
      "E": "11.07.16 г"
    }, {
      "A": "365",
      "B": "Усубалиев Дуйшон Аралбекович",
      "C": "773592425",
      "D": "00365",
      "E": "11.07.16 г"
    }, {
      "A": "366",
      "B": "Самарский Ярослав Владимирович",
      "C": "772227174",
      "D": "00366",
      "E": "11.07.16 г"
    }, {
      "A": "367",
      "B": "Нурматова Эльвира Мураталыевна",
      "C": "551535438",
      "D": "00367",
      "E": "01.11.16 г."
    }, {
      "A": "368",
      "B": "Жакыпов Байгазы Нуралыевич",
      "C": "773835893",
      "D": "00368",
      "E": "01.11.16 г"
    }, {
      "A": "369",
      "B": "Дюшебаева Асель Жумагуловна",
      "C": "0709334311, 0552334311",
      "D": "00369",
      "E": "01.11.16г"
    }, {
      "A": "370",
      "B": "Жоробеков Азаматбек Жолборсович",
      "C": "550012550",
      "D": "00370",
      "E": "01.11.16г"
    }, {
      "A": "371",
      "B": "Какеев Марат Саламатович",
      "C": "555320638",
      "D": "00371",
      "E": "01.11.16г"
    }, {
      "A": "372",
      "B": "Беримкулов Уланбек Закирович",
      "C": "557775391",
      "D": "00372",
      "E": "01.11.16 г"
    }, {
      "A": "373",
      "B": "Дъяконова Людмила Николаевна",
      "C": "551167067",
      "D": "00373",
      "E": "01.11.16г"
    }, {
      "A": "374",
      "B": "Джоотуманов Азамат Алымкулович",
      "C": "776570047",
      "D": "00374",
      "E": "01.11.16г"
    }, {
      "A": "375",
      "B": "Ходжамбердиев Закиржон Ахмадуллаевич",
      "C": "555620015",
      "D": "00375",
      "E": "01.11.16 г"
    }, {
      "A": "376",
      "B": "Калдыбаева Гульзат Кабылбековна",
      "C": "551771151",
      "D": "00376",
      "E": "01.11.16г"
    }, {
      "A": "377",
      "B": "Токтомушев Бакира Эстебесович",
      "C": "555898909",
      "D": "00377",
      "E": "01.11.16г"
    }, {
      "A": "378",
      "B": "Сарыбаева Бермет Ырысовна",
      "C": "770002207",
      "D": "00378",
      "E": "01.11.16г"
    }, {
      "A": "379",
      "B": "Абдуматов Кубанычбек Абдуматович",
      "C": "550182233",
      "D": "00379",
      "E": "14.06.17г"
    }, {
      "A": "380",
      "B": "Азамов Анвархон Сайфуллаевич",
      "C": "550584242",
      "D": "00380",
      "E": "14.06.17г"
    }, {
      "A": "381",
      "B": "Айдарбекова Асия Джумакеевна",
      "C": "550584241",
      "D": "00381",
      "E": "14.06.17г"
    }, {
      "A": "382",
      "B": "Алияскаров Марат Дуйшонбекович",
      "C": "554959537",
      "D": "00382",
      "E": "14.06.17г"
    }, {
      "A": "383",
      "B": "Дунганова Аида Тургунбековна",
      "C": "0772001182, 0772001187",
      "D": "00383",
      "E": "14.06.17г"
    }, {
      "A": "384",
      "B": "Закирова Елена Александровна",
      "C": "773532872",
      "D": "00384",
      "E": "14.06.17г"
    }, {
      "A": "385",
      "B": "Карбанова Барикан Дармановна",
      "C": "772719885",
      "D": "00385",
      "E": "14.06.17г"
    }, {
      "A": "386",
      "B": "Кыргызбаев Артур Абдрашитович",
      "C": "554000344",
      "D": "00386",
      "E": "14.06.17г"
    }, {
      "A": "387",
      "B": "Масалиев Бабырайим Кожонбаевич",
      "C": "0550401140 ,0770058080",
      "D": "00387",
      "E": "14.06.17г"
    }, {
      "A": "388",
      "B": "Нишанова Сабира Абдуалимовна",
      "C": "550100021",
      "D": "00388",
      "E": "14.06.17г"
    }, {
      "A": "389",
      "B": "Ормонов Нурбек Аккозович",
      "C": "772553070",
      "D": "00389",
      "E": "14.06.17г"
    }, {
      "A": "390",
      "B": "Сарыгулова Гулзат Жолдошбековна",
      "C": "555343450",
      "D": "00390",
      "E": "14.06.17г"
    }, {
      "A": "391",
      "B": "Султанов Бек Шайбекович",
      "C": "0550347722\n0700087440",
      "D": "00391",
      "E": "14.06.17г"
    }, {
      "A": "392",
      "B": "Токтогулова Каным Кенжеевна",
      "C": "553488881",
      "D": "00392",
      "E": "14.06.17г"
    }, {
      "A": "393",
      "B": "Арамян Любовь Сергеевна",
      "C": "555900804",
      "D": "00393",
      "E": "14.06.17г"
    }, {
      "A": "394",
      "B": "Иманалиева Айсалкын Узаковна",
      "C": "709348658",
      "D": "00394",
      "E": "14.06.17г"
    }, {
      "A": "395",
      "B": "Тенизбаев Темир Камбарбекович",
      "C": "558252552",
      "D": "00395",
      "E": "14.06.17г"
    }, {
      "A": "396",
      "B": "Пак Людмила Романовна",
      "C": "0551-46-66",
      "D": "00396",
      "E": "14.11.17г"
    }, {
      "A": "397",
      "B": "Томоева Айгуль Толомушевна",
      "C": "0550-70-78-37",
      "D": "00397",
      "E": "14.11.17г"
    }, {
      "A": "398",
      "B": "Жунусова Динара Жуманалиевна",
      "C": "0555-92-21-65",
      "D": "00398",
      "E": "14.11.17г"
    }, {
      "A": "399",
      "B": "Касенова Мээрим Майрамбековна",
      "C": "0703-88-20-77",
      "D": "00399",
      "E": "14.11.17г"
    }, {
      "A": "400",
      "B": "Черноволос Николай Федорович",
      "C": "",
      "D": "00400",
      "E": "14.11.17г"
    }, {
      "A": "401",
      "B": "Дербишалиев Адилет Эсенбекович",
      "C": "0557-98-74-47",
      "D": "00401",
      "E": "14.11.17г."
    }, {
      "A": "402",
      "B": "Суералиев Атай Каныбекович",
      "C": "0553-07-13-31",
      "D": "00402",
      "E": ""
    }, {
      "A": "403",
      "B": "Асанбекова Назгул Насировна",
      "C": "0555-11-61-61",
      "D": "00403",
      "E": "14.11.17г"
    }, {
      "A": "404",
      "B": "Суйундук уулу Айбек",
      "C": "0554-55-85-35",
      "D": "00404",
      "E": "14.11.17г"
    }, {
      "A": "405",
      "B": "Каткелдиев Сагынбек Рысбекович",
      "C": "0773-15-06-52",
      "D": "00405",
      "E": "14.11.17г"
    }, {
      "A": "406",
      "B": "Кожобергенов Нукеш Рахманович",
      "C": "",
      "D": "00406",
      "E": "14.11.17г"
    }, {
      "A": "407",
      "B": "Макеева Венера Кадыкеевна",
      "C": "0700-55-13-27",
      "D": "00407",
      "E": "14.11.17г"
    }, {
      "A": "408",
      "B": "Закирбаев Токтомамат Маматазимович",
      "C": "558313184",
      "D": "00408",
      "E": "14.11.17г"
    }, {
      "A": "409",
      "B": "Хамдамов Бабиржон Мамасидикович",
      "C": "773805557",
      "D": "00409",
      "E": "14.11.17г"
    }, {
      "A": "410",
      "B": "Осмоналиева Тамара Аскарбековна",
      "C": "0551-30-34-66",
      "D": "00410",
      "E": "43053"
    }, {
      "A": "411",
      "B": "Усупбаева Алима Искауновна",
      "C": "0555-24-54-72",
      "D": "00411",
      "E": "43053"
    }, {
      "A": "412",
      "B": "Койчубекова Гулнара Турсунбековна",
      "C": "779320200",
      "D": "00412",
      "E": "43053"
    }, {
      "A": "413",
      "B": "Омурбаева Асель Каныбековна",
      "C": "0555-77-20-94",
      "D": "00413",
      "E": "43053"
    }, {
      "A": "414",
      "B": "Доолотбаева Чолпонкул Суйуновна",
      "C": "550299250",
      "D": "00414",
      "E": "43259"
    }, {
      "A": "415",
      "B": "Бараканова Аида Толомушовна",
      "C": "0559778872 0555117703",
      "D": "00415",
      "E": "43259"
    }, {
      "A": "416",
      "B": "Тыналиев Канатбек Казакбаевич",
      "C": "",
      "D": "00416",
      "E": "43259"
    }, {
      "A": "417",
      "B": "Бабаяров Эркинбек Абдипаттаевич",
      "C": "0554771212 0778121277",
      "D": "00417",
      "E": "43259"
    }, {
      "A": "418",
      "B": "Бекболотов Азамат Жапарович",
      "C": "551083028",
      "D": "00418",
      "E": "43259"
    }, {
      "A": "419",
      "B": "Мамбетова Нургуль Кулбайевна",
      "C": "552959576",
      "D": "00419",
      "E": "43259"
    }, {
      "A": "420",
      "B": "Фирсов Сергей Вячеславович",
      "C": "555362558",
      "D": "00420",
      "E": "43259"
    }, {
      "A": "421",
      "B": "Атакулова Алия Муратбековна",
      "C": "558297788",
      "D": "00421",
      "E": "43259"
    }, {
      "A": "422",
      "B": "Эсенбеков Асылбек Алмасбекович",
      "C": "777979715",
      "D": "00422",
      "E": "43259"
    }, {
      "A": "423",
      "B": "Айтбаев Султан Кубанычбекович",
      "C": "558888555",
      "D": "00423",
      "E": "43259"
    }, {
      "A": "424",
      "B": "Нурбекова Алтынай Темирбековна",
      "C": "555008982",
      "D": "00424",
      "E": "43259"
    }, {
      "A": "425",
      "B": "Аргымбаева Нургуль Абдыкалыевна",
      "C": "0557333972 0557557408",
      "D": "00425",
      "E": "43259"
    }, {
      "A": "426",
      "B": "Гайнанов Фарид Равильевич",
      "C": "559567977",
      "D": "00426",
      "E": "43259"
    }, {
      "A": "427",
      "B": "Бирюков Марк Петрович",
      "C": "552197010",
      "D": "00427",
      "E": "43259"
    }, {
      "A": "428",
      "B": "Айбек уулу Лесбек",
      "C": "0707429441 0770429441",
      "D": "00428",
      "E": "43259"
    }, {
      "A": "429",
      "B": "Мирлан кызы Наргиза",
      "C": "",
      "D": "00429",
      "E": "43259"
    }, {
      "A": "430",
      "B": "Ким Александра Олеговна",
      "C": "",
      "D": "00430",
      "E": "43259"
    }, {
      "A": "431",
      "B": "Измайлова Залина Кемеловна",
      "C": "550089229",
      "D": "00431",
      "E": "43395"
    }, {
      "A": "431",
      "B": "Кайымов Ысмайыл",
      "C": "0555-770-855",
      "D": "00431",
      "E": "43395"
    }, {
      "A": "432",
      "B": "Абдимомунова Айжан Бауржановна",
      "C": "772612111",
      "D": "00432",
      "E": "43395"
    }, {
      "A": "434",
      "B": "Исаков Болотбек Алмасбекович",
      "C": "775989939",
      "D": "00434",
      "E": "43395"
    }, {
      "A": "435",
      "B": "Чукунова Индира Камалбековна",
      "C": "502212821",
      "D": "00435",
      "E": "43395"
    }, {
      "A": "436",
      "B": "Шонурова Айзада Суйналиевна",
      "C": "559933989",
      "D": "00436",
      "E": "43395"
    }, {
      "A": "437",
      "B": "Ибраймакунов Данияр Омурбекович",
      "C": "555111174",
      "D": "00437",
      "E": "43395"
    }, {
      "A": "438",
      "B": "Асылбек уулу Элдияр",
      "C": "558080301",
      "D": "00438",
      "E": "43395"
    }, {
      "A": "439",
      "B": "Жокен кызы Асира",
      "C": "",
      "D": "00439",
      "E": "43395"
    }, {
      "A": "440",
      "B": "Жакыпов Женишбек Сарбагышович",
      "C": "555787862",
      "D": "00440",
      "E": "43395"
    }, {
      "A": "441",
      "B": "Сапаралиева Айпери Бактыбековна",
      "C": "553534597",
      "D": "0441",
      "E": "43395"
    }, {
      "A": "442",
      "B": "Токуров Мыктыбек Шапыевич",
      "C": "552526767",
      "D": "0442",
      "E": "43395"
    }, {
      "A": "443",
      "B": "Умралиева Нагима Ишенбековна",
      "C": "555111174",
      "D": "00443",
      "E": "43395"
    }, {
      "A": "444",
      "B": "Абдыкеримова Кымбат Ибраевна",
      "C": "555900344",
      "D": "00444",
      "E": "43395"
    }, {
      "A": "445",
      "B": "Кенкешбаев Мамбеталы Сейиткасымович",
      "C": "700591506",
      "D": "00445",
      "E": "43395"
    }, {
      "A": "446",
      "B": "Пол Джордж Конго",
      "C": "312665997",
      "D": "00446",
      "E": "43395"
    }, {
      "A": "447",
      "B": "Джолдошев Токтобек",
      "C": "",
      "D": "00447",
      "E": "43395"
    }
  ]);

}).call(this);



(function() {
  angular.module('fsa').config(function($logProvider, toastrConfig, hotkeysProvider, $httpProvider, uibDatepickerPopupConfig) {
    'ngInject';
    $logProvider.debugEnabled(true);
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-bottom-right';
    toastrConfig.preventOpenDuplicates = true;
    toastrConfig.progressBar = true;
    hotkeysProvider.cheatSheetHotkey = ["h", "р"];
    hotkeysProvider.cheatSheetDescription = "Информация о быстрых кнопках открыть/закрыть";
    $httpProvider.interceptors.push('authInterceptor');
    uibDatepickerPopupConfig.datepickerPopup = 'dd-MM-yyyy';
    uibDatepickerPopupConfig.clearText = 'Очистить';
    uibDatepickerPopupConfig.closeText = 'Закрыть';
    uibDatepickerPopupConfig.currentText = 'Сегодня';
    return uibDatepickerPopupConfig.altInputFormats = ['YYYY-MM-DD HH:mm:ssZ'];
  }).config(function($provide) {
    $provide.decorator('uibDateParser', function($delegate) {
      var fromTimezone;
      fromTimezone = function(date, timezone) {
        if (moment && date && date !== '' && angular.isString(date)) {
          date = moment(date).toDate();
        }
        if (date && timezone) {
          return $delegate.convertTimezoneToLocal(date, timezone, true);
        } else {
          return date;
        }
      };
      $delegate.fromTimezone = fromTimezone;
      return $delegate;
    });
  });

}).call(this);



(function () {
    'use strict';

    angular.module('fsa')
        .directive('sideNav', function () {
            return {
                restrict: 'AC',
                link: function (scope, el) {
                    var $BODY = $('body'),
                        $MENU_TOGGLE = $('#menu_toggle'),
                        $SIDEBAR_MENU = $('#sidebar-menu'),
                        $SIDEBAR_FOOTER = $('.sidebar-footer'),
                        $LEFT_COL = $('.left_col'),
                        $RIGHT_COL = $('.right_col'),
                        $NAV_MENU = $('.nav_menu'),
                        $FOOTER = $('footer');

                    var setContentHeight = function () {
                        // reset height
                        $RIGHT_COL.css('min-height', $(window).height());

                        var bodyHeight = $BODY.outerHeight(),
                            footerHeight = $BODY.hasClass('footer_fixed') ? 0 : $FOOTER.height(),
                            leftColHeight = $LEFT_COL.eq(1).height() + $SIDEBAR_FOOTER.height(),
                            contentHeight = bodyHeight < leftColHeight ? leftColHeight : bodyHeight;

                        // normalize content
                        contentHeight -= $NAV_MENU.height() + footerHeight;

                        $RIGHT_COL.css('min-height', contentHeight);
                    };

                    var setCurrentPage = function (url) {
                        var CURRENT_URL = url || window.location.href.split('?')[0];

                        $SIDEBAR_MENU.find('li.current-page').removeClass('current-page');

                        $SIDEBAR_MENU.find('a').filter(function () {
                            return this.href == CURRENT_URL;
                        }).parent('li').addClass('current-page').parents('ul').slideDown(function () {
                            setContentHeight();
                        }).parent().addClass('active');
                    };

                    function initSideMenu (class_name) {
                        $SIDEBAR_MENU.find('a' + class_name).on('click', function (ev) {
                            if (ev.target.href) {
                                setCurrentPage(ev.target.href);
                            } else {
                                var $li = $(this).parent();

                                if ($li.is('.active')) {
                                    $li.removeClass('active active-sm');
                                    $('ul:first', $li).slideUp(function () {
                                        setContentHeight();
                                    });
                                } else {
                                    // prevent closing menu if we are on child menu
                                    if (!$li.parent().is('.child_menu')) {
                                        $SIDEBAR_MENU.find('li').removeClass('active active-sm');
                                        $SIDEBAR_MENU.find('li ul').slideUp();
                                    }

                                    $li.addClass('active');

                                    $('ul:first', $li).slideDown(function () {
                                        setContentHeight();
                                    });
                                }
                            }
                        });
                    }

                    initSideMenu();

                    scope.$watch('app.navigation', function () {
                        initSideMenu('.dynamic_menu');
                    });

                    scope.$watch('app.admin_menu', function () {
                        initSideMenu('.admin_menu');
                    });

                    // toggle small or large menu
                    $MENU_TOGGLE.on('click', function () {
                        if ($BODY.hasClass('nav-md')) {
                            $SIDEBAR_MENU.find('li.active ul').hide();
                            $SIDEBAR_MENU.find('li.active').addClass('active-sm').removeClass('active');
                        } else {
                            $SIDEBAR_MENU.find('li.active-sm ul').show();
                            $SIDEBAR_MENU.find('li.active-sm').addClass('active').removeClass('active-sm');
                        }

                        $BODY.toggleClass('nav-md nav-sm');

                        setContentHeight();
                    });

                    setCurrentPage();

                    // recompute content when resizing
                    $(window).smartresize(function () {
                        setContentHeight();
                    });

                    setContentHeight();

                    // fixed sidebar
                    if ($.fn.mCustomScrollbar) {
                        $('.menu_fixed').mCustomScrollbar({
                            autoHideScrollbar: true,
                            theme: 'minimal',
                            mouseWheel: {preventDefault: true}
                        });
                    }
                }
            };
        });
})();

/**
 * Created by jaynakus on 2/11/16.
 */
angular.module('fsa')
    .directive('autofocus', function () {
        return {
            restrict: 'A',
            link: function ($scope, $element) {
                $element[0].focus();
            }
        }
    });

angular.module("fsa").run(["$templateCache", function($templateCache) {$templateCache.put("app/agent/agent.html","<div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Агенты</div><div class=panel-body><button ng-click=agent.newAgent() class=\"btn btn-primary btn-sm\">Добавить агента</button> <button ng-click=agent.editAgent() ng-disabled=\"agent.selected_company==null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Редактировать</span></button><paged-table options=agent.companiesGridOptions disable-search=true></paged-table></div></div></div></div></div>");
$templateCache.put("app/agent/create.html","<!--\nCreated by Ilyas on 17/11/20.\n\n--><form ng-submit=company.putCompany() class=from-horizontal><div class=modal-header></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Основная информация</a></li><li><a data-toggle=tab data-target=#contact>Контакты</a></li><li><a data-toggle=tab data-target=#user>Пользователи</a></li><li><a data-toggle=tab data-target=#logo>Логотип</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><col-responsive><div class=form-group><label>Официальное имя</label><input type=text ng-model=company.company.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Краткое имя</label><input type=text ng-model=company.company.short_name ng-required=false ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код компании</label><input type=text ng-model=company.company.code ng-required=false ng-trim=true maxlength=2 class=form-control></div></col-responsive><col-responsive stock-dict=company.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=company.company.data.status ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in company.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Дата регистрации</label><div class=\"input-group no-margin\"><input type=text ng-required=true uib-datepicker-popup=dd-MM-yyyy ng-model=company.company.data.reg_date ng-click=\"company.registrationDP.popup_to_date.opened=true\" is-open=company.registrationDP.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"company.registrationDP.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Номер регистрации</label><input type=text ng-model=company.company.data.register_number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ИНН</label><input type=text ng-model=company.company.data.inn ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код ОКПО</label><input type=text ng-model=company.company.data.code_okpo ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=company.company_types dict-table=Enums dict-filter={name:&quot;company_type&quot;}><div class=form-group><label>Тип</label><ui-select ng-model=company.company.company_type ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in company.company_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><div stock-dict=agent.companies dict-table=Companies dict-filter={company_type:&quot;branch_company&quot;} class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Филиал</label><ui-select ng-model=company.company.company_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in agent.companies\">{{type.name}}</ui-select-choices></ui-select></div></div><col-responsive><div class=form-group><label>Менеджер</label><input type=text ng-model=company.company.data.manager ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Капитал</label><input type=text ng-model=company.company.data.capital ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Правила страхования</label><div class=input-group><input type=text ng-model=company.company.data.insurance_rules ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Образец полиса</label><div class=input-group><input type=text ng-model=company.company.data.policy_sample ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Описание</label><textarea ng-model=company.company.data.description rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Рекомендация</label><textarea ng-model=company.company.data.recommendation rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Франшиза</label><textarea ng-model=company.company.data.franchise rows=4 class=form-control></textarea></div></col-responsive></div></div><div id=contact class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Телефон</label><div class=input-group><input type=number ng-model=company.phone ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addPhone() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.phones\" class=list-group-item><label>{{x}}</label><a ng-click=company.deletePhone($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Адрес</label><div class=input-group><input type=text ng-model=company.address ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addAddress() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.addresses\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteAddress($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>E-mail</label><div class=input-group><input type=email ng-model=company.email ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addEmail() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.emails\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteEmail($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Вебсайт</label><div class=input-group><input type=text ng-model=company.website ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addWebsite() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.websites\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteWebsite($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div></div></div><div id=user class=\"tab-pane fade\"><div class=row><div class=row><!--.col.col-xs-12.col-sm-6.col-md-6(stock-dict=\'company.users\' dict-table=\'User\')--><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Ползователи</label><ui-select ng-model=company.currStaff.user_id ng-required=true class=form-control><ui-select-match>{{$select.selected.username}}</ui-select-match><ui-select-choices repeat=\"type.id as type in company.users\">{{type.username}}</ui-select-choices></ui-select></div></div><div stock-dict=company.branches dict-table=Companies dict-filter={company_id:company.company._id} class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Филиалы</label><ui-select ng-model=company.currStaff.branch_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in company.branches\">{{type.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col col-xs-12\"><button type=button ng-click=company.addStaff() class=\"btn btn-primary btn-sm pull-right\">Добавить</button></div></div><div class=row><div class=\"col col-xs-12\"><h2>Список пользователей</h2><table class=\"table table-bordered\"><thead><tr><th>Пользователь</th><th>Филиал</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in company.company.staff\"><td><span ng-repeat=\"user in company.users\" ng-if=\"user.id == item.user_id\">{{user.username}}</span></td><td><span ng-repeat=\"branch in company.branches | filter:{_id:item.branch_id}\">{{branch.name}}</span></td><td><a ng-click=company.deleteStaff($index) class=\"btn btn-danger glyphicon glyphicon-remove-sign\"></a></td></tr></tbody></table></div></div></div></div><div id=logo class=\"tab-pane fade\"><div class=row><div flow-init={singleFile:true} class=\"col col-xs-12 col-md-8 col-lg-8\"><span flow-btn flow-file-added=\"company.handleFileSelect($event, $flow, $file)\" class=\"btn btn-default margin-right-8\">Выбрать файл...</span><span>{{$flow.files[0].name}}</span></div></div><div class=row><div class=\"col col-xs-12 col-md-8 col-lg-8\"><div class=cropArea><img-crop image=company.image result-image=company.result_image area-type=square result-image-size=100></img-crop></div><div>Итоговое изибражение:<div><img ng-src={{company.result_image}}></div><a data-target=# ng-click=company.upload() class=\"btn btn-primary\">Заменить существующий</a></div></div><div class=\"col col-xs-12 col-md-4 col-lg-4\"><div class=\"clearfix pull-left\"><h3>Логотип компании</h3><img ng-src={{app.api}}{{company.company.data.image}} class=profile-image-lg></div></div></div></div></div></div><div class=modal-body><!--button.btn.btn-primary.btn-sm.pull-right(type=\'submit\', ng-if=\'company.company.user_id==company.ua.id\') Сохранить--> <button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=company.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/agentbranch/agentbranch.html","<!--Created by Ilyas on 17/11/20.\n--><div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Филиалы</div><div class=panel-body><button type=button ng-click=agentbranch.newCompany() class=\"btn btn-primary btn-xs\">Создать</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!branch.selected_branch\' ng-click=\'branch.editBranch()\')--> <button ng-click=agentbranch.editCompany() ng-disabled=!agentbranch.selected_company class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=agentbranch.confirmAction() ng-disabled=!agentbranch.selected_company class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=agentbranch.getCompanies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=agentbranch.companiesGridOptions disable-search=true disable-paging=true></paged-table></div></div></div></div></div>");
$templateCache.put("app/agentbranch/edit.html","<form ng-submit=agentbranch.putCompany() class=from-horizontal><div class=modal-header></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Основная информация</a></li><!--li--><!--  a(data-toggle=\'tab\', data-target=\'#contact\') Контакты--><li><a data-toggle=tab data-target=#user>Пользователи</a></li><!--li--><!--  a(data-toggle=\'tab\', data-target=\'#menu5\') Логотип--></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><col-responsive><div class=form-group><label>Официальное имя</label><input type=text ng-model=agentbranch.company.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Краткое имя</label><input type=text ng-model=agentbranch.company.short_name ng-required=false ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код компании</label><input type=text ng-model=agentbranch.company.code ng-required=false ng-trim=true maxlength=6 class=form-control></div></col-responsive><col-responsive stock-dict=agentbranch.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=agentbranch.company.data.status ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in agentbranch.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Дата регистрации</label><div class=\"input-group no-margin\"><input type=text ng-required=true uib-datepicker-popup=dd-MM-yyyy ng-model=agentbranch.company.data.reg_date ng-click=\"company.registrationDP.popup_to_date.opened=true\" is-open=company.registrationDP.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"agentbranch.registrationDP.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Номер регистрации</label><input type=text ng-model=agentbranch.company.data.register_number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ИНН</label><input type=text ng-model=agentbranch.company.data.inn ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код ОКПО</label><input type=text ng-model=agentbranch.company.data.code_okpo ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Менеджер</label><input type=text ng-model=agentbranch.company.data.manager ng-required=true ng-trim=true class=form-control></div></col-responsive><!--col-responsive(stock-dict=\'company.insurer_types\' dict-table=\'Enums\' dict-filter=\'{name:\"insurer_type\"}\')--><!--  .form-group--><!--    label Тип--><!--    ui-select.form-control(ng-model=\'agentbranch.company.data.insurer_type\' ng-required=\'true\')--><!--      ui-select-match {{$select.selected.data.name}}--><!--      ui-select-choices(repeat=\'type.data.key as type in company.insurer_types track by type.data.key\') {{type.data.name}}--><col-responsive><div class=form-group><label>Капитал</label><input type=text ng-model=agentbranch.company.data.capital ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Правила страхования</label><div class=input-group><input type=text ng-model=agentbranch.company.data.insurance_rules ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Образец полиса</label><div class=input-group><input type=text ng-model=agentbranch.company.data.policy_sample ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Описание</label><textarea ng-model=agentbranch.company.data.description rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Рекомендация</label><textarea ng-model=agentbranch.company.data.recommendation rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Франшиза</label><textarea ng-model=agentbranch.company.data.franchise rows=4 class=form-control></textarea></div></col-responsive></div></div><div id=user class=\"tab-pane fade\"><div class=row><col-responsive><div class=form-group><label>Ползователи</label><ui-select ng-model=agentbranch.currStaff.user_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.username}}</ui-select-match><ui-select-choices repeat=\"type.id as type in agentbranch.users |filter:{username:$select.search}\">{{type.username}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><button type=button ng-click=agentbranch.addStaff() class=\"btn btn-primary btn-sm pull-right\">Добавить</button></col-responsive><div class=row><div class=\"col col-xs-12\"><h2>Список пользователей</h2><table class=\"table table-bordered\"><thead><tr><th>Пользователь</th><th>Филиал</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in agentbranch.company.staff\"><td><span ng-repeat=\"user in agentbranch.users\" ng-if=\"user.id == item.user_id\">{{user.username}}</span></td><td><span ng-repeat=\"branch in agentbranch.branches | filter:{_id:item.branch_id}\">{{branch.name}}</span></td><td><a ng-click=agentbranch.deleteStaff($index) class=\"btn btn-danger glyphicon glyphicon-remove-sign\"></a></td></tr></tbody></table></div></div></div></div></div></div><div class=modal-body><div class=row><div class=\"col-lg-12 col-md-12 col-xs-12\"><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=agentbranch.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></div></div></form>");
$templateCache.put("app/agentemployee/agentemployee.html","<div class=container><panel title=Сотрудники><button type=button ng-click=agentemployee.newUser() class=\"btn btn-primary btn-xs\">Создать</button> <button ng-click=agentemployee.editUser() ng-disabled=!agentemployee.selected_user class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=agentemployee.removeUser() ng-disabled=!agentemployee.selected_user class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=agentemployee.getUsers() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=agentemployee.agentemployeeGridOptions disable-search=true disable-paging=true></paged-table></panel></div>");
$templateCache.put("app/agentemployee/create.html","<form ng-submit=user.createUser()><div class=modal-header><h3>Новый пользователь</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Информация для авторизации</a></li><li><a data-toggle=tab data-target=#menu1>Информация о пользователе</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Филиалы</label><ui-select ng-model=user.user.branch_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in user.branches\">{{type.name}}</ui-select-choices></ui-select></div></div></div></div><div id=menu1 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/agentemployee/edit.html","<form ng-submit=user.updateUser()><div class=modal-header><h3>Новый пользователь</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Информация для авторизации</a></li><li><a data-toggle=tab data-target=#menu1>Информация о пользователе</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Филиалы</label><ui-select ng-model=user.user.branch_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in user.branches\">{{type.name}}</ui-select-choices></ui-select></div></div></div></div><div id=menu1 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/agentreport/agentreport.html","<!--Created by ilias on 17.05.2018.\n--><div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Отчет</div><div class=panel-body><form><div class=row><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=agentreport.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=agentreport.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=agentreport.date_start ng-model=agentreport.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><button type=button ng-click=agentreport.getPolicies() class=\"btn btn-primary btn-sm\"><i aria-hidden=true class=\"fa fa-search\"></i> Применить фильтр</button> <button type=button ng-click=agentreport.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button> <button type=button ng-click=agentreport.downloadPDFRPA() class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет</button> <button type=button ng-click=agentreport.downloadExcelRPA() ng-if=false class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет Excel</button> <button type=button ng-click=agentreport.downloadPDFRPAP() ng-if=false ng-disabled=\"agentreport.company.company_type!=\'agent\' &amp;&amp; agentreport.company._id == agentreport.filter.agent_id\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет вознаграждения</button> <button type=button ng-if=false ng-click=agentreport.downloadExcelRPAP() ng-disabled=\"agentreport.company.company_type!=\'agent\' &amp;&amp; agentreport.company._id == agentreport.filter.agent_id\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет вознаграждения Excel</button></form><paged-table options=agentreport.policiesGridOptions disable-search=true height=700></paged-table></div></div></div></div></div>");
$templateCache.put("app/apolicy/form.html","<div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Возобновление</div><div class=panel-body><div class=row><div class=col-md-12><button type=button ui-sref=app.apolicy.list class=\"btn btn-warning\">Выход</button> <button type=button ng-click=form.confirmActionSave() ng-disabled=\"!form.policy.insurance_premium || form.policy.insurance_premium &lt;= 0\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Возобновить</button></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{form.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{form.policy.client}}</span></h5></div></div><div class=row><div class=col-md-10><h5>Номер кредита:<span class=text-info> {{form.policy.credit_no}}</span></h5></div><div class=col-md-2></div></div><div class=row><col-responsive><div class=form-group><label>Период страхования от</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=form.today max-date=form.policy.date_end ng-change=form.recalculateOnEventAll() ng-click=\"form.search.popup_to_date.opened1=true\" ng-model=form.policy.date_start is-open=form.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"form.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Период страхования до</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=form.isAnnual uib-datepicker-popup=dd.MM.yyyy min-date=form.policy.date_start max-date=form.finish_date ng-change=form.recalculateOnEventAll() ng-click=\"form.search.popup_from_date.opened=true\" ng-model=form.policy.date_end is-open=form.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=form.isAnnual ng-click=\"form.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{form.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{form.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{form.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=form.policy.insurance_data.ned class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in form.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=form.editWork(work) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=form.confirmActionWork(work) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></tbody></table></div></div></div><div ng-show=form.policy.insurance_data.ts class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in form.policy.insurance_data.ts\"><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=form.editWork(work) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=form.confirmActionWork(work) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></tbody></table></div></div></div><div ng-show=form.policy.insurance_data.ln class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in form.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=form.editWork(work) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=form.confirmActionWork(work) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></tbody></table></div></div></div><div ng-show=form.policy.insurance_data.ned class=row><div class=wrapper><table class=\"table table-user-information\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in form.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=form.editNed(c) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=form.confirmActionNed(c) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></tbody></table><button ng-click=form.editNed({}) class=\"btn btn-default\">Добавить</button></div><div class=wrapper><div ng-show=\"form.insuranceformned != null\" class=row><col-responsive><div class=form-group><label>Собственник</label><input type=text ng-model=form.insuranceformned.owner required class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Объект страхования</label><ui-select ng-model=form.insuranceformned.objectned class=form-control><ui-select-match>{{form.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"object as object in form.insuranceobjectsned track by object._id\">{{object.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=form.insuranceformned.adres required class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=form.insuranceformned.insurance_summ required min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=form.insuranceformned.insurance_premium required disabled class=form-control></div></col-responsive><div class=row><col-responsive><div class=form-group><button type=button ng-click=form.calculatePremiumNed() class=\"btn btn-default\">Раcсчитать</button> <button ng-click=form.addCollateralNed(form.insuranceformned) class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button> <button ng-click=form.cancelWork() class=\"btn btn-default m-b-lg\">Отмена</button></div></col-responsive></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/apolicy/issue.html","<!--\nCreated by ilias on 07.10.2016.\n\n--><div class=container><form ng-submit=issue.confirmAction() class=from-horizontal><div class=row><div class=col-md-10><button type=button ui-sref=app.apolicy.select class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-hand-o-left\"></i> Изменить полис</button><div class=\"panel panel-default\"><div class=panel-heading><h2 style=display:inline>Ваш страховой полис</h2></div><!--.panel-body(stock-dict=\'issue.currencies\' dict-table=\'Currencies\')--><div class=panel-body><table class=\"table table-striped\"><thead></thead><tbody><tr><td>Страховщик</td><td>{{issue.product.company[0].name}}</td></tr><tr ng-if=\"issue.company.company_type == \'agent\'\"><td>Агент страховой компании</td><td>{{issue.company.name}} Телефон {{issue.company.data.phones[0]}}</td></tr><tr><td>Период действия страхового полиса</td><td>с {{issue.product.tmp_product.date_start | date:\'dd-MM-yyyy\'}} по {{issue.product.tmp_product.date_end | date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Продукт</td><td>{{issue.product.name}}</td></tr><tr><td>Страна поездки</td><td><span ng-repeat=\"x in issue.countriesView\">{{x.name}} <mark>({{x.data.name_eng}})</mark></span></td></tr><tr><td>Страховая сумма</td><td><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><label ng-if=\"issue.min_insurance!=null\">{{issue.product.insurance_amount}}<span> {{issue.currency_name}}</span></label><label ng-if=\"issue.min_insurance==null\">0</label><a data-toggle=collapse data-target=#collapse1 ng-click=issue.pdrobneeIconCnange() style=cursor:pointer class=pull-right><i ng-class=issue.pdrobneeIcon aria-hidden=true></i> Сервисы</a></h4></div><div id=collapse1 class=\"panel-collapse collapse\"><div class=panel-body><ul><li ng-repeat=\"x in issue.product.services\"><span>{{x.name}}</span></li></ul></div></div></div></td></tr><tr ng-repeat=\"x in issue.insurants\"><td>Стоимость страхового полиса ({{$index+1}}-го)</td><td><h4 ng-if=\"x.theprice!=null\">{{x.theprice}} {{issue.currency_name}} / {{(x.theprice * issue.currencyRate).toFixed(2)}} KGS</h4><span class=small>(курс валют: 1 {{issue.currency_name}}: {{issue.currencyRate}} KGS)</span><h4 ng-if=\"x.theprice==null\">0</h4></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-md-10><div class=\"panel panel-default\"><div class=panel-heading><h2>Путешественники (застрахованные)</h2></div><div class=panel-body><div ng-repeat=\"x in issue.insurants\" class=row><div class=col-md-5><div class=row><div class=col-md-6><div class=form-group><label>Фамилия<br><em>Латиницей</em></label><input type=text ng-model=x.surname ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-6><div class=form-group><label>Имя<br><em>Латиницей</em></label><input type=text ng-model=x.name ng-required=true ng-trim=true class=form-control></div></div></div></div><div class=col-md-2><div class=form-group><label><br>Паспорт №</label><input type=text ng-model=x.passport_no ng-trim=true class=form-control></div></div><div class=col-md-5><div class=form-group><label><br>Дата рождения</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=issue.reCompute(x) uib-datepicker-popup=dd.MM.yyyy ng-model=x.date_of_birth is-open=x.isOpen close-text=Закрыть current-text=Сегодня clear-text=Очистить ng-required=true class=form-control><span class=input-group-btn><button type=button ng-click=\"x.isOpen = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span><span class=input-group-btn> <button style=\"margin-left: 20px\" ng-click=issue.deleteInsurant($index) type=button class=\"btn btn-danger\"><i aria-hidden=true class=\"fa fa-times\"></i></button></span><span class=input-group-btn> <button style=\"margin-left: 20px\" ng-click=issue.changeIcon($index) popover-trigger=click popover-placement=bottom uib-popover-template=&quot;myPopoverTemplate.html&quot; popover-title=\"Условия страховки\" type=button class=\"btn btn-info\"><i style=\"font-size: 130%\" aria-hidden=true class={{issue.iconsList[$index]}}></i> Условия</button></span></div></div></div></div><div class=row><div class=col-md-2><button type=button ng-click=issue.addInsurant() class=\"btn btn-default\"><i aria-hidden=true class=\"fa fa-plus\"></i> Добавить путешественника</button></div></div></div></div></div></div><div class=row><div class=col-md-10><div class=\"panel panel-default\"><div class=panel-heading><h2>Покупатель (страхователь)</h2></div><div class=panel-body><div class=row><div class=col-md-2><div class=form-group><label>Фамилия<br><em>Кирилицей</em></label><input type=text ng-model=issue.buyer.surname ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-2><div class=form-group><label>Имя<br><em>Кирилицей</em></label><input type=text ng-model=issue.buyer.name ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-3><div class=form-group><label><br>Телефон</label><input type=text ui-mask=0(999)999-999 ng-model=issue.buyer.phone ng-trim=true class=form-control></div></div></div></div></div><div class=row><button type=submit class=\"btn btn-primary btn-sm pull-right\">Оформить полис</button></div></div></div></form></div><script type=text/ng-template id=myPopoverTemplate.html><div style=\"width: 350px;\">\n    <ul class=\"list-group\">\n      <li ng-repeat=\"factor in x.factorListing\" ng-if=\"factor.name != \'Возраст\'\" class=\"list-group-item\"><a ng-if=\"factor.description != null &amp;&amp; service.data.description != \'\'\"><i uib-tooltip=\"{{factor.description}}\" class=\"fa fa-info-circle\"></i></a><a id=\"headingOne{{$index}}\" role=\"tab\" data-toggle=\"collapse\" data-parent=\"#accordion1\" data-target=\"#collapseOnefer{{$index}}\" aria-expanded=\"false\" aria-controls=\"collapseOne\" style=\"cursor:pointer;\" class=\"panel-heading collapsed\"><i aria-hidden=\"true\" style=\"color: #2f3233; font-size: 130%;\" class=\"fa fa-chevron-down\"></i> {{factor.name}}\n          <mark><span style=\"text-decoration-color: red; text-decoration-line: underline; text-decoration-style: dotted;\">: {{x.factors[factor.name]}}</span></mark></a>\n        <div id=\"collapseOnefer{{$index}}\" role=\"tabpanel\" aria-labelledby=\"headingOne\" aria-expanded=\"false\" style=\"height: 0px;\" class=\"panel-collapse collapse\">\n          <div class=\"panel-body\">\n            <div class=\"container\">\n              <div class=\"form-group\">\n                <ui-select ng-model=\"x.factors[factor.name]\" on-select=\"issue.reCompute(x)\" ng-required=\"true\" class=\"form-control\">\n                  <ui-select-match placeholder=\"Выберите из списка\">{{$select.selected}}</ui-select-match>\n                  <ui-select-choices repeat=\"type in factor.values | orderBy\">{{type}}</ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n          </div>\n        </div>\n      </li>\n    </ul>\n  </div></script>");
$templateCache.put("app/apolicy/list.html","<!--\nCreated by Ilyas on 17/11/20.\n\n--><!--ui-sref=\'app.policy_new\',--><div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>Полисы</h3></div><div class=box-body><form ng-submit=list.getPolicies() class=direct-chat-msg><div class=row><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=list.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in list.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive ng-if=\"list.company.company_type !=\'agent\'\"><div class=form-group><label>Сотрудники:</label><ui-select ng-model=list.filter.agent_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agent._id as agent in list.agents \">{{agent.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=list.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ФИО клиента:</label><input type=text ng-model=list.filter.name placeholder=\" Введите имя\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button> <button type=button ng-click=list.goToRealEstate() class=\"btn btn-primary\"><i class=\"fa fa-home\"></i><span> Недвижимость</span></button> <button type=button ng-click=list.goToPersonal() class=\"btn btn-primary\"><i class=\"fa fa-plus-square\"></i><span> Личное(НС)</span></button> <button type=button ng-click=list.goToVehicle() class=\"btn btn-primary\"><i class=\"fa fa-car\"></i><span> Транспортное средство</span></button> <button ng-click=list.goToShow() ng-disabled=!list.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button ng-click=list.confirmAction(list.selected_policy) ng-show=\"app.ua.id == list.selected_policy.user_id &amp;&amp; ((list.selected_policy._created |amDateFormat:\'DD-MM-yyyy\') == (list.current_date|amDateFormat:\'DD-MM-yyyy\'))\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=list.downloadPDF() ng-disabled=\"!list.selected_policy || list.selected_list.policy_no == \'00000\' || (list.selected_policy.data.status != \'Оформлен\' &amp;&amp; list.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=list.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div></form><paged-table options=list.policiesGridOptions disable-search=true></paged-table></div></div></div></div></div>");
$templateCache.put("app/apolicy/new.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=\"panel panel-default\"><div class=panel-heading><h2>Туристическая страховка</h2></div><div class=panel-body></div><div class=row><div stock-dict=policies.countries dict-table=Countries class=col-md-10><div class=form-group><label>Территория</label><ui-select ng-model=policies.pruduct.country_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}} <mark>({{$item.data.name_eng}})</mark></ui-select-match><ui-select-choices repeat=\"type._id as type in policies.countries| filterCountries:$select.search | orderBy:&quot;name&quot;\">{{type.name}} <mark>({{type.data.name_eng}})</mark></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-5><div class=form-group><label>Туда</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.today max-date=policies.pruduct.date_end ng-model=policies.pruduct.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-5><div class=form-group><label>Обратно</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.pruduct.date_start ng-model=policies.pruduct.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=col-md-4><div class=form-group><label>Количество дней</label><input type=text ng-model=policies.diffDays readonly class=form-control></div></div></div><div class=row><div class=col-md-10><div class=form-group><label style=\"visibility: hidden\">asdfsdf</label><div class=input-group><button ng-click=policies.goToSelect(policies.pruduct) type=button class=\"btn btn-primary\">Найти страховку</button></div></div></div></div></div>");
$templateCache.put("app/apolicy/select.html","<!--Created by Ilyas on 17/11/20.\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Создание полиса</div><div class=panel-body><div class=row><col-responsive><div class=form-group><label>Страхователь</label><input type=text ng-model=select.policy.client required class=form-control></div></col-responsive></div><div class=row><col-responsive stock-dict=select.products dict-table=Product><div class=form-group><label>Наименование программы кредитования</label><ui-select ng-model=select.policy.product_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in select.products track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер кредитного договора</label><input type=text ng-model=select.policy.credit_no required class=form-control></div></col-responsive><col-responsive stock-dict=select.currencies dict-table=Currencies><div class=form-group><label>Валюта</label><ui-select ng-model=select.currency class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"currency as currency in select.currencies\">{{currency.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Период страхования от</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=select.today max-date=select.policy.date_end ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_to_date.opened1=true\" ng-model=select.policy.date_start is-open=select.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"select.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Период страхования до</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=select.isAnnual uib-datepicker-popup=dd.MM.yyyy min-date=select.policy.date_start max-date=select.finish_date ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_from_date.opened=true\" ng-model=select.policy.date_end is-open=select.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=select.isAnnual ng-click=\"select.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=\"checkbox form-group\"><label><input type=checkbox ng-model=select.isAnnual ng-change=select.recalculateOnEventisAnnual()> Годовой полис</label></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label ng-if=!select.isAnnual>Количество дней: {{select.diffDays}}</label><label ng-if=select.isAnnual>Количество дней: 1 год</label></div></col-responsive></div><div class=row><col-responsive ng-repeat=\"insuranceType in select.insurancetypes\"><div class=form-group><i ng-class=insuranceType.data.class></i><div class=checkbox><label class=i-checks><input type=checkbox ng-model=select.types[insuranceType.name] ng-required=true ng-trim=true ng-change=\"select.showPanel(insuranceType, select.types[insuranceType.name])\"><i></i> {{insuranceType.name}}</label></div></div></col-responsive></div><div class=ln_solid></div><div ng-show=\"select.nedPanel == true\" class=row><div class=\"col-md-12 col-sm-12\"><div class=\"panel panel-success\"><div class=panel-heading><strong><big>СТРАХОВАНИЕ ИМУЩЕСТВА</big></strong></div><div class=panel-body><form ng-submit=select.addCollateralNed(select.insuranceformned)><div class=row><col-responsive><div class=form-group><label>Собственник</label><input type=text ng-model=select.insuranceformned.owner ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Объект страхования</label><ui-select ng-model=select.insuranceformned.objectned ng-required=true ng-trim=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"object as object in select.insuranceobjectsned track by object._id\">{{object.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=select.insuranceformned.adres ng-required=true ng-trim=true class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Действительная стоимость</label><input type=number ng-model=select.insuranceformned.coll_price ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=select.insuranceformned.insurance_summ ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=select.insuranceformned.insurance_premium ng-required=true ng-trim=true disabled class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Описание<span type=button tooltip-placement=right uib-tooltip=\"Здесь указывается описание имущества. Пример:Недвижимое имущество – квартира, жилой дом, гостиница, офисное помещение, баня ит.п.; Оборудование – Марка, модель и тип оборудования;ТМЦ – Наименование ТМЦ.\" class=\"btn btn-default btn-addon\">?</span></label><textarea rows=10 ng-required=true ng-trim=true ng-model=select.insuranceformned.description class=form-control></textarea></div></col-responsive></div><div class=row><col-responsive><div class=form-group><button type=button ng-click=select.calculatePremiumNed() class=\"btn btn-default\">Раcсчитать</button> <button type=submit class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button></div></col-responsive></div></form><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in select.collateralsned.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td><button uib-tooltip=Удалить ng-click=\"select.deleteCollateralNed(c, $index)\" class=\"btn btn-sm btn-icon btn-danger\"><i class=\"fa fa-minus\"></i></button></td></tr></tbody></table></div></div></div><div class=row><col-responsive><div class=form-group><label>Страховая сумма: {{select.policy.insurance_amountned}}</label><br><label>Страховая премия: {{select.policy.insurance_premiumned}}</label></div></col-responsive></div><br></div></div></div></div><div ng-show=\"select.lnPanel == true\" class=row><div class=\"col-md-12 col-sm-12\"><div class=\"panel panel-warning\"><div class=panel-heading><strong><big>СТРАХОВАНИЕ ЖИЗНИ ОТ НЕСЧАСТНЫХ СЛУЧАЕВ</big></strong></div><div class=panel-body><form ng-submit=select.addCollateralLn(select.insuranceformln)><div class=row><col-responsive><div class=form-group><label>Застрахованное лицо</label><input type=text ng-model=select.insuranceformln.client required class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата Рождения</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_to_date.opened5=true\" ng-model=select.insuranceformln.birthday is-open=select.search.popup_to_date.opened5 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"select.search.popup_to_date.opened5=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Документ удостоверяющий личность</label><input type=text ng-model=select.insuranceformln.pasport ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=select.insuranceformln.adres ng-required=true ng-trim=true disabled class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=select.insuranceformln.insurance_summ ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=select.insuranceformln.insurance_premium ng-required=true ng-trim=true disabled class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><button type=button ng-click=select.calculatePremiumLn() class=\"btn btn-default\">Раcсчитать</button> <button type=submit class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button></div></col-responsive></div></form><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in select.collateralsln.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td><button uib-tooltip=Удалить ng-click=\"select.deleteCollateralLn(c, $index)\" class=\"btn btn-sm btn-icon btn-danger\"><i class=\"fa fa-minus\"></i></button></td></tr></tbody></table></div></div></div><div class=row><col-responsive><div class=form-group><label>Страховая сумма: {{select.policy.insurance_amountln}}</label><br><label>Страховая премия: {{select.policy.insurance_premiumln}}</label></div></col-responsive></div><br></div></div></div></div><div ng-show=\"select.tsPanel == true\" class=row><div class=\"col-md-12 col-sm-12\"><div class=\"panel panel-info\"><div class=panel-heading><strong><big>СТРАХОВАНИЕ ТРАНСПОРТНЫХ СРЕДСТВ</big></strong></div><div class=panel-body><form ng-submit=select.addCollateralTs(select.insuranceformts)><div class=row><col-responsive><div class=form-group><label>Объект страхования</label><ui-select ng-model=select.insuranceformts.objectts class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"object as object in select.insuranceobjectsts track by object._id\">{{object.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Марка, модель ТС</label><input type=text ng-model=select.insuranceformts.model ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Гос. регистрационный №;</label><input type=text ng-model=select.insuranceformts.gosnumber ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Номер кузова/ шасси</label><input type=text ng-model=select.insuranceformts.number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=select.car_year_issue dict-table=Enums dict-filter={name:&quot;year_issue&quot;}><div class=form-group><label>Год выпуска</label><ui-select ng-model=select.insuranceformts.year_issue ng-required=true ng-trim=true class=form-control><ui-select-match>{{$select.selected.data.key}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in select.car_year_issue\">{{type.data.key}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=select.insuranceformts.adres ng-required=true ng-trim=true disabled class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=select.insuranceformts.insurance_summ ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Действительная стоимость</label><input type=number ng-model=select.insuranceformts.coll_price ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=select.insuranceformts.insurance_premium ng-required=true ng-trim=true disabled class=form-control></div></col-responsive><div class=\"col col-xs-12 col-sm-8 col-md-8\"><div class=form-group><label>Уполномоченные водители</label><input type=text ng-model=select.insuranceformts.driver disabled class=form-control></div></div></div><div class=row><col-responsive><div class=form-group><button type=button ng-click=select.calculatePremiumTs() class=\"btn btn-default\">Раcсчитать</button> <button type=submit class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button></div></col-responsive></div></form><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in select.collateralsts.ts\"><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td><td><button uib-tooltip=Удалить ng-click=\"select.deleteCollateralTs(c, $index)\" class=\"btn btn-sm btn-icon btn-danger\"><i class=\"fa fa-minus\"></i></button></td></tr></tbody></table></div></div></div><div class=row><col-responsive><div class=form-group><label>Страховая сумма: {{select.policy.insurance_amountts}}</label><br><label>Страховая премия: {{select.policy.insurance_premiumts}}</label></div></col-responsive></div><br></div></div></div></div><div class=row><div class=form-group><button ng-disabled=select.saving type=button ui-sref=app.policy class=\"btn btn-primary m-t\">Отмена</button> <button ng-disabled=collateralForm.$invalid type=button ng-click=select.savePolicy() class=\"btn btn-primary m-t\">Сохранить</button></div></div></div></div></div>");
$templateCache.put("app/apolicy/show.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=modal-content><div class=modal-header><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=modal-body><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title><h4 style=display:inline-block></h4><span>Номер полиса:</span> <input id=foo value={{show.policy.policy_no}} ng-disabled=true> <button ngclipboard=\"\" data-clipboard-target=#foo class=btn><i alt=\"Copy to clipboard\" class=\"fa fa-copy\"></i></button></h3></div><div class=box-body><div class=\"row m-b\"><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{show.policy.client}}</span></h5></div></div><div class=\"row m-b\"><div class=col-md-4><h5>Номер кредита:<span class=text-info> {{show.policy.credit_no}}</span></h5></div><div class=col-md-8><h5>Наименование программы кредитования:<span class=text-info>{{show.policy.product}}</span></h5></div></div><div class=\"row m-b\"><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|amDateFormat:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|amDateFormat:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=\"row m-b\"><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{show.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=show.policy.insurance_data.ned class=\"row m-b\"><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Описание</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td>{{c.description}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ts class=\"row m-b\"><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ts\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ln class=\"row m-b\"><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.data.file class=\"row m-b\"><div class=col-md-4><a href=\"{{show.api + \'docs/file/sertificates/\' +show.policy.data.file}}\" target=_blank>Скачать сертификат</a></div></div></div></div></div><div class=modal-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button><!--button.btn.btn-default.pull-right(type=\'button\'  ng-click=\"show.goToForm()\" ng-if=\"show.policy.data.status && show.policy.data.status == \'Истек\'\" ng-disabled=\"show.policy.data.status != \'Истек\'\")--><!--  i.fa.fa-refresh(aria-hidden=\'true\')--><!--  |   Возобновить--> <button type=button ng-click=show.confirmAction() ng-if=\"show.policy.data.status &amp;&amp; show.policy.data.status == \'Оформлен\' &amp;&amp; app.ua.id == show.policy.user_id &amp;&amp; ((show.policy._created |amDateFormat:\'DD-MM-yyyy\') == (show.current_date|amDateFormat:\'DD-MM-yyyy\'))\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=show.goToForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=show.confirmActionForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div>");
$templateCache.put("app/apolicy/view.html","<div class=container><div class=\"panel panel-default\"><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{view.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{view.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{view.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{view.policy.insurance_amount}} {{view.currency_name}}</span></h5></div><div class=col-md-5><h5>Страховая премия :<span class=text-info> {{view.policy.insurance_premium}} {{view.currency_name}} / {{view.policy.data.insurance_premium_kgs}} KGS</span></h5></div></div><div class=row><div class=col-md-10><h5>Страны пребывания:<span ng-repeat=\"country_id in view.policy.insurance_data.country_id\"><span ng-repeat=\"country in view.countries| filter:{_id:country_id}\" class=text-info> {{country.name}} <mark>({{country.data.name_eng}})</mark></span></span></h5></div><div class=col-md-2><h5></h5></div></div><div class=row><div class=col-md-10><h5>Страховая компания:<span class=text-info> {{view.product.company[0].name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Продукт:<span class=text-info> {{view.product.name}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><div class=col-md-10><h5>ФИО Клиента:<span class=text-info> {{view.policy.client.surname}} {{view.policy.client.name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Дата рождения:<span class=text-info> {{view.policy.client.date_of_birth|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Номер паспорта:<span class=text-info> {{view.policy.client.passport_no}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div stock-dict=view.services dict-table=Services class=row><ul style=\"background-color: gray\" class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer><h2><b>Факторы</b></h2></a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer><h2><b>Сервисы</b></h2></a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"(key, value) in view.policy.insurance_data.factors\"><td>{{key}}</td><td>{{value}}</td></tr></tbody></table></div><div id=service class=\"tab-pane fade\"><ul class=list-group><li ng-repeat=\"service_id in view.product.services_id\" class=list-group-item><span ng-repeat=\"service in view.services | filter:{_id:service_id}\">- {{service.name}}</span></li></ul></div></div></div></div></div></div></div><div class=panel-footer><button type=button ui-sref=app.apolicy.list class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=view.downloadPDF() ng-if=\"view.policy.policy_no != \'00000\'\" ng-disabled=\"view.policy.policy_no == \'00000\' || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=view.confirmAction() ng-if=\"view.policy.data.status &amp;&amp; view.policy.data.status == \'Оформлен\'\" ng-disabled=\"!view.policy.data.status || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=view.confirmActionTerm() ng-if=\"view.policy.data.status &amp;&amp; view.policy.data.status == \'Оформлен\'\" ng-disabled=\"!view.policy.data.status || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-thumbs-o-down\"></i> Расторгнуть</button> <button type=button ng-click=view.goToForm() ng-if=\"view.policy.data.status != \'Истек\' &amp;&amp; view.policy.data.status != \'Оформлен\' &amp;&amp; view.policy.data.status != \'Испорчен\' &amp;&amp; view.policy.data.status != \'Расторгнут\'\" ng-disabled=\"view.policy.data.status == \'Оформлен\' || view.policy.data.status == \'Испорчен\'|| view.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=view.confirmActionForm() ng-if=\"view.policy.data.status != \'Истек\' &amp;&amp; view.policy.data.status != \'Оформлен\' &amp;&amp; view.policy.data.status != \'Испорчен\' &amp;&amp; view.policy.data.status != \'Расторгнут\'\" ng-disabled=\"view.policy.data.status == \'Оформлен\' || view.policy.data.status == \'Испорчен\'|| view.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div>");
$templateCache.put("app/auth/login.html","<style>body{\n    margin: 0;\n    padding: 0;\n    font-family: sans-serif;\n    background: rgb(0,116,128);\n    color: black;\n    }\n    .box{\n  \n      width: 350px;\n  \n      padding: 40px;\n  \n      position: absolute;\n  \n      top: 50%;\n  \n    left: 50%;\n  \n    transform: translate(-50%,-50%);\n  \n    background: white;\n  \n    text-align: center;\n  \n    }\n  \n    .box h1{\n  \n      color: black;\n  \n      text-transform: uppercase;\n  \n      font-weight: 500;\n  \n    }\n  \n    .box input[type = \"text\"],.box input[type = \"password\"]{\n  \n      border:0;\n  \n    background: none;\n  \n    display: block;\n  \n    margin: 20px auto;\n  \n      text-align: center;\n  \n      border: 2px solid #3498db;\n  \n      padding: 14px 10px;\n  \n      width: 200px;\n  \n      outline: none;\n  \n      color: black;\n  \n      border-radius: 24px;\n  \n      transition: 0.25s;\n  \n    }\n  \n    .box input[type = \"text\"]:focus,.box input[type = \"password\"]:focus{\n  \n      width: 280px;\n  \n      border-color: rgb(0,116,128);\n  \n    }\n  \n    .box input[type = \"submit\"]{\n  \n      border:0;\n  \n    background: none;\n  \n    display: block;\n  \n    margin: 20px auto;\n  \n      text-align: center;\n  \n      border: 2px solid rgb(0,116,128);\n  \n      padding: 14px 40px;\n  \n      outline: none;\n  \n      color: black;\n  \n      border-radius: 24px;\n  \n      transition: 0.25s;\n  \n      cursor: pointer;\n  \n    }\n  \n    .box input[type = \"submit\"]:hover{\n  \n      background: rgb(0,116,128);\n  \n    }\n  \n  #footerNew .footerNewInner {\n    min-width: 1220px;\n    font-size: 9pt;\n    color: #333;\n    padding: 12px 20px;\n  }</style><form layout=column ng-submit=auth.login() class=box><h5>ВХОД В СИСТЕМУ</h5><input type=text name=username placeholder=логин ng-model=auth.username> <input type=password name=password placeholder=пароль ng-model=auth.password> <input type=submit name=\"\" value=войти ng-disabled=auth.auth_loading></form>");
$templateCache.put("app/auth/register.html","<div class=login-box><div style=\"display: flex; flex-direction: column; align-items: center\" class=login-logo><img src=/assets/images/logo-180.png ui-sref=home style=\"width:50%; height:50%\" alt=\"user image\" class=\"img-responsive img-circle\"><a ui-sref=home class=header-brand><div class=user-block><h5 class=username><div class=headerSize>{{\'ГОСУДАРСТВЕННАЯ СЛУЖБА РЕГУЛИРОВАНИЯ И НАДЗОРА ЗА ФИНАНСОВЫМ РЫНКОМ\' | translate}}</div></h5><span class=username><div class=headerSize>{{\'ПРИ ПРАВИТЕЛЬСТВЕ КЫРГЫЗСКОЙ РЕСПУБЛИКИ\' | translate}}</div></span></div></a></div><div class=login-box-body><form layout=column class=box><div class=box-header><div class=box-title>{{\'Форма регистрации\' | translate}}</div></div><div class=\"box-body p-6\"><div class=form-group><label class=form-label>{{\'Фамилия\' | translate}}</label><input type=text placeholder=\"{{ &quot;Введите фамилию&quot; | translate }}\" ng-model=auth.first_name class=form-control></div><div class=form-group><label class=form-label>{{\'Имя\' | translate}}</label><input type=text placeholder=\"{{ &quot;Введите имя&quot; | translate }}\" ng-model=auth.last_name class=form-control></div><div class=form-group><label class=form-label>{{\'Отчество\' | translate}}</label><input type=text placeholder=\"{{ &quot;Введите отчество&quot; | translate }}\" ng-model=auth.middle_name class=form-control></div><div class=form-group><label class=form-label>{{\'Email\' | translate}}</label><input type=email placeholder=\"{{ &quot;Введите Е-mail&quot; | translate }}\" ng-model=auth.email class=form-control></div><div class=form-group><label class=form-label>{{\'Телефон\' | translate}}</label><div class=input-group><div class=input-group-prepend><button type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false class=\"btn btn-secondary dropdown-toggle\">{{auth.countryCode}}</button></div><input type=text ui-mask=\"(999) 99-99-99\" ng-model=auth.countphone ui-mask-placeholder-char=- class=form-control></div></div><div class=form-group><label class=form-label>{{\'Напишите ответ\' | translate}}: {{auth.first_number}} + {{auth.second_number}}</label><input type=number placeholder=\"{{ &quot;Введите ответ&quot; | translate }}\" ng-model=auth.state.ask class=form-control></div><div class=form-footer><button ng-click=auth.sendOTP() ng-disabled=\"auth.isCountingDown==true\" class=\"btn btn-primary btn-block\">{{\'Получить смс код\' | translate}}</button></div></div><div ng-show=\"auth.isCountingDown==true\" class=\"box-body p-6\"><div class=form-group><label class=form-label>{{\'OTP\' | translate}}</label><input type=text ng-model=auth.otp ng-disabled=\"auth.isCountingDown==false\" ui-mask=999999 ui-mask-placeholder-char=- class=form-control></div><div class=form-footer><button ng-click=auth.checkOTP() class=\"btn btn-primary btn-block\">{{\'Потвердить OTP\' | translate}}</button></div></div><div ng-show=\"auth.isPasswordDown==true\" class=\"box-body p-6\"><div class=form-group><label class=form-label>{{\'Пароль\' | translate}}</label><input type=password placeholder=\"{{ \'Введите пароль\' | translate }}\" ng-model=auth.password class=form-control></div><div class=form-group><label class=form-label>{{\'Пароль для потверждения\' | translate}}</label><input type=password placeholder=\"{{ \'Введите пароль\' | translate }}\" ng-model=auth.password2 class=form-control></div><div class=form-footer><button ng-click=auth.register() class=\"btn btn-primary btn-block\">{{\'Зарегистрироваться\' | translate}}</button></div></div></form></div></div><footer class=\"footer fixed-bottom\"><div class=container><div class=\"row align-items-center flex-row-reverse\"><div class=\"col-12 col-lg-auto mt-3 mt-lg-0 text-center\">Copyright © 2018<a href=ivtlab.kg></a> {{ \'ОсОО \"ИВТ Лаб\"\' | translate }} {{ \'All rights reserved.\' | translate }}</div></div></div></footer>");
$templateCache.put("app/auth/reportPolicy.html","<div class=content><div class=row><div class=col-xs-12><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Здесь о вашем страховом полисе</h3></div><div class=box-body><div ng-show=auth.textError class=row><div class=col-xs-12><div><h2>К сожалению, Полис с таким номером отсутствует в базе</h2></div></div></div><div ng-show=auth.policyShow><table class=\"table table-hover\"><tbody><tr><th>Номер полиса</th><th ng-style=\"{\'background-color\':auth.color}\">Статус</th><th>ФИО клиента</th><th>Страховая сумма</th><th>Начало</th><th>Конец</th></tr><tr><td>{{auth.selected_policy.policy_no}}</td><td ng-style=\"{\'background-color\':auth.color}\">{{auth.selected_policy.data.status}}</td><td>{{auth.selected_policy.client}}</td><td>{{auth.selected_policy.insurance_amount}}</td><td>{{auth.selected_policy.insurance_data.date_start | date:\'dd.MM.yyyy\'}}</td><td>{{auth.selected_policy.insurance_data.date_end | date:\'dd.MM.yyyy\'}}</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/branch/branch.html","<div class=content><panel title=\"По филиалам\"><form ng-submit=branch.getPolicies()><div class=row><col-responsive stock-dict=branch.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=branch.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in branch.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Филиалы:</label><ui-select ng-model=branch.filter.branch_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agent._id as agent in branch.agents \">{{agent.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=branch.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=branch.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=branch.date_start ng-click=\"branch.search.popup_to_date.opened=true\" is-open=branch.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"branch.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=branch.date_start ng-model=branch.date_end ng-click=\"branch.search.popup_from_date.opened=true\" is-open=branch.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"branch.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"branch.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=ln_solid></div><button ng-click=branch.goToShow() ng-disabled=!branch.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button type=button ng-click=branch.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=branch.policiesGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/branch/show.html","<!--Created by ilias on 15.09.2017.\n--><div class=container><div class=\"panel panel-default\"><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{show.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><!--.col-md-4(stock-dict=\'show.currencies\' dict-table=\'Currencies\')--><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount}} {{show.currency_name}}<!--span( ng-repeat=\"country in show.countries| filter: {_id: show.currentCountryId}\" ng-if=\"show.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in show.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div><div class=col-md-5><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium}} {{show.currency_name}} / {{show.policy.data.insurance_premium_kgs}} KGS<!--span( ng-repeat=\"country in show.countries| filter: {_id: show.currentCountryId}\" ng-if=\"show.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in show.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div></div><div class=row><div class=col-md-10><h5>Страны пребывания:<span ng-repeat=\"country_id in show.policy.insurance_data.country_id\"><span ng-repeat=\"country in show.countries| filter:{_id:country_id}\" class=text-info> {{country.name}} <mark>({{country.data.name_eng}})</mark></span></span></h5></div><div class=col-md-2><h5></h5></div></div><div class=row><div class=col-md-10><h5>Страховая компания:<span class=text-info> {{show.product.company[0].name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Продукт:<span class=text-info> {{show.product.name}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><div class=col-md-10><h5>ФИО Клиента:<span class=text-info> {{show.policy.client.surname}} {{show.policy.client.name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Дата рождения:<span class=text-info> {{show.policy.client.date_of_birth|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Номер паспорта:<span class=text-info> {{show.policy.client.passport_no}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div stock-dict=show.services dict-table=Services class=row><ul style=\"background-color: gray\" class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer><h2><b>Факторы</b></h2></a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer><h2><b>Сервисы</b></h2></a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"(key, value) in show.policy.insurance_data.factors\"><td>{{key}}</td><td>{{value}}</td></tr></tbody></table></div><div id=service class=\"tab-pane fade\"><ul class=list-group><li ng-repeat=\"service_id in show.product.services_id\" class=list-group-item><span ng-repeat=\"service in show.services | filter:{_id:service_id}\">- {{service.name}}</span></li></ul></div></div></div></div></div></div></div><div class=panel-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button></div></div></div>");
$templateCache.put("app/clients/create.html","<!--Created by ilias on 18.02.17.\n--><div class=container><panel title=\"Создание клиента\"><div class=row><col-responsive><div class=form-group><label>ФИО клиента</label><input type=text ng-model=create.contractor.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=create.contractor.data.birthday is-open=create.popup_delivery_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"create.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Телефон</label><input type=number ng-model=create.contractor.data.phone ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>E-mail</label><input type=email ng-model=create.contractor.data.email ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Адрес</label><input type=text ng-model=create.contractor.data.address ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Место работы</label><input type=text ng-model=create.contractor.data.work ng-trim=true class=form-control></div><div stock-dict=create.contractor_types dict-table=Enums dict-filter={name:&quot;contractor_type&quot;} class=form-group><label>Тип</label><ui-select ng-model=create.contractor.contractor_type ng-init=\"create.contractor.contractor_type=&quot;client&quot;\" ng-disabled=true><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in create.contractor_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><udf-view udf-table=contractor udf-data=create.contractor class=\"col col-xs-12\"></udf-view></div><div class=row><button ng-disabled=contractor.saving type=button ng-click=create.putContractor() class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button ng-disabled=contractor.saving type=button ui-sref=app.clients.list class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></panel></div>");
$templateCache.put("app/clients/edit.html","<!--\neditd by ilias on 18.02.17.\n\n--><!-- header--><div class=\"wrapper bg-light lter b\"><a ui-sref=app.clients.list tooltip=Отмена class=\"btn btn-sm btn-default w-xxs m-r-sm\"><i class=\"fa fa-long-arrow-left\"></i></a><a ng-click=refresh() tooltip=Обновить class=\"btn btn-sm btn-default w-xxs m-r-sm\"><i class=\"fa fa-refresh\"></i></a></div><!-- / header--><div class=wrapper><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Изменения данных клиента</div><div class=panel-body><form name=clientForm class=\"bs-example form-validation\"><div class=row><col-responsive><div class=form-group><label>ФИО клиента</label><input type=text ng-model=edit.contractor.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=edit.contractor.data.birthday is-open=edit.popup_delivery_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"edit.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Телефон</label><input type=number ng-model=edit.contractor.data.phone ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>E-mail</label><input type=email ng-model=edit.contractor.data.email ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Адрес</label><input type=text ng-model=edit.contractor.data.address ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Место работы</label><input type=text ng-model=edit.contractor.data.work ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=edit.contractor_types dict-table=Enums dict-filter=\"{name: &quot;contractor_type&quot;}\"><div class=form-group><label>Тип</label><ui-select ng-model=edit.contractor.contractor_type ng-init=\"create.contractor.contractor_type=&quot;client&quot;\" ng-disabled=true><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in edit.contractor_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><udf-view udf-table=contractor udf-data=edit.contractor class=\"col col-xs-12\"></udf-view></div></form><hr><uib-tabset class=tab-container><uib-tab heading=Анализы><div ng-show=\"edit.curIdentity==null\" class=wrapper><table class=\"table table-bordered table-hover table-condensed\"><tr style=\"font-weight: bold\"><td style=width:15%>Вид анализа</td><td style=width:10%>Результат</td><td style=width:15%>Ед измерения</td><td style=width:15%>Дата сдачи</td><td style=width:25%></td></tr><tr ng-repeat=\"id in edit.contractor.data.identities\"><td>{{ id.product_name }}</td><td>{{ id.result }}</td><td>{{ id.product_unit }}</td><td>{{ id.date_receipt | date: \'dd.MM.yyyy\' }}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=edit.editIdentity(id) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=edit.removeIdentity($index) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></table><button ng-click=edit.editIdentity({}) class=\"btn btn-default\">Добавить</button></div><div class=wrapper><form ng-show=\"edit.curIdentity!=null\" class=\"bs-example form-validation\"><div class=row><col-responsive><div class=form-group><label>Продукт</label><product-select product-id=edit.product_id></product-select></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Результат</label><input type=text placeholder=Результат ng-model=edit.curIdentity.result class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата сдачи</label><div class=\"input-group no-margin\"><input type=text uib-dtpicker-popup ng-model=edit.curIdentity.date_receipt is-open=edit.date_receipt.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"edit.date_receipt.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><br><button ng-click=edit.finishIdentity(true) class=\"btn btn-primary m-b-lg\">Сохранить</button> <button ng-click=edit.finishIdentity(false) class=\"btn btn-default m-b-lg\">Отмена</button></form></div></uib-tab><uib-tab heading=Диагнозы><div ng-show=\"edit.curDiagnosis==null\" class=wrapper><table class=\"table table-bordered table-hover table-condensed\"><tr style=\"font-weight: bold\"><td>Название</td><td>Врач</td><td>Дата приема</td><td>Описание</td><td></td></tr><tr ng-repeat=\"diagnosis in edit.contractor.data.diagnosises\"><td>{{ diagnosis.name }}</td><td>{{ diagnosis.employee }}</td><td>{{ diagnosis.date }}</td><td>{{ diagnosis.comment }}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=edit.editDiagnosis(diagnosis) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=edit.removeDiagnosis($index) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></table><button ng-click=edit.editDiagnosis({}) class=\"btn btn-default m-b-lg\">Добавить</button></div><div class=wrapper><form ng-show=\"edit.curDiagnosis!=null\" class=\"bs-example form-validation\"><div class=row><col-responsive><div class=form-group><label class=control-label>Название</label><input type=text ng-model=edit.curDiagnosis.name class=form-control></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Врач</label><employee-select employee-id=edit.current_employee></employee-select></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Дата приема</label><div class=\"input-group no-margin\"><input type=text uib-dtpicker-popup ng-model=edit.curDiagnosis.date is-open=edit.date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"edit.date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Описание</label><textarea rows=7 style=max-width:100% ng-model=edit.curDiagnosis.comment class=form-control></textarea></div></col-responsive></div><br><button ng-click=edit.finishDiagnosis(true) class=\"btn btn-primary m-b-lg\">Сохранить</button> <button ng-click=edit.finishDiagnosis(false) class=\"btn btn-default m-b-lg\">Отмена</button></form></div></uib-tab><uib-tab heading=\"История лечения\"><div ng-show=\"edit.curHistories==null\" class=wrapper><table class=\"table table-bordered table-hover table-condensed\"><tr style=\"font-weight: bold\"><td style=width:25%>Наименование</td><td style=width:25%>Кол-во</td><td style=width:25%>Дата назначения</td><td style=width:25%>Продолжительность</td><td style=width:25%>Врач</td><td style=width:25%>Комментарии</td><td style=width:25%></td></tr><tr ng-repeat=\"history in edit.contractor.data.histories\"><td>{{ history.name }}</td><td>{{ history.summ }}</td><td>{{ history.date }}</td><td>{{ history.duration }}</td><td>{{ history.current_employee }}</td><td>{{ history.comment }}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=edit.editHistory(history) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=edit.removeHistory($index) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></table><button ng-click=edit.editHistory({}) class=\"btn btn-default m-b-lg\">Добавить</button></div><div class=wrapper><form ng-show=\"edit.curHistories!=null\" class=\"bs-example form-validation\"><div class=row><col-responsive><div class=form-group><label class=control-label>Название</label><input type=text ng-model=edit.curHistories.name class=form-control></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Кол-во</label><input type=number ng-model=edit.curHistories.summ class=form-control></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Дата приема</label><div class=\"input-group no-margin\"><input type=text uib-dtpicker-popup ng-model=edit.curHistories.date is-open=edit.date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"edit.date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Продолжительность</label><input type=number ng-model=edit.curHistories.duration class=form-control></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Врач</label><employee-select employee-id=edit.current_employee></employee-select></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Описание</label><textarea rows=7 style=max-width:100% ng-model=edit.curHistories.comment class=form-control></textarea></div></col-responsive></div><br><button ng-click=edit.finishHistory(true) class=\"btn btn-primary m-b-lg\">Сохранить</button> <button ng-click=edit.finishHistory(false) class=\"btn btn-default m-b-lg\">Отмена</button></form></div></uib-tab></uib-tabset><div class=\"form-group pull-right m-r-md\"><button type=submit ng-disabled=clientForm.$invalid ng-click=edit.saveClient() class=\"btn btn-primary btn-md m-r-xs\">Сохранить</button><!-- <button ng-click=\"validateClientForm()\" class=\"btn btn-primary btn-md m-r-xs\">Сохранить</button>--> <button ng-click=edit.cancel() class=\"btn btn-default btn-md\">Назад</button></div></div></div></div>");
$templateCache.put("app/clients/list.html","<!--\nCreated by ilias on 18.02.17.\n\n--><div class=container><panel title=Клиенты><button ui-sref=app.clients.create class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=!list.selected_contractor ui-sref=\"app.clients.view({id: list.selected_contractor._id})\" class=\"btn btn-default btn-sm\">Посмотреть</button> <button ng-disabled=!list.selected_contractor ui-sref=\"app.clients.edit({id: list.selected_contractor._id})\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=list.getContractors() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=list.contractorsGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/clients/modal.html","<!--\ncontractord by ilias on 23.03.17.\n\n--><form ng-submit=contractor.putContractor()><div class=modal-header><h3>Клиент</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>ФИО клиента</label><input type=text ng-model=contractor.contractor.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=contractor.contractor.data.birthday is-open=contractor.popup_delivery_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"contractor.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Телефон</label><input type=number ng-model=contractor.contractor.data.phone ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>E-mail</label><input type=email ng-model=contractor.contractor.data.email ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Адрес</label><input type=text ng-model=contractor.contractor.data.address ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Место работы</label><input type=text ng-model=contractor.contractor.data.work ng-trim=true class=form-control></div><div stock-dict=contractor.contractor_types dict-table=Enums dict-filter={name:&quot;contractor_type&quot;} class=form-group><label>Тип</label><ui-select ng-model=contractor.contractor.contractor_type ng-init=\"contractor.contractor.contractor_type=&quot;client&quot;\" ng-disabled=true><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in contractor.contractor_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive></div></div><div class=modal-footer><button ng-disabled=contractor.saving type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button ng-disabled=contractor.saving type=button ng-click=contractor.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/clients/view.html","<!--Created by ilias on 18.02.17.\n--><div class=container></div><div class=wrapper><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Данные о клиенте</div><div class=panel-body><div class=row><div class=col-sm-3><button ui-sref=app.clients.list class=\"btn btn-primary m-b\">Назад</button></div></div><div class=wrapper-md><div class=row><div class=col-sm-9><div class=\"panel panel-default\"><div class=col-sm-12><h3 style=\"text-align: center\">{{ view.contractor.name }}</h3><hr><div class=\"col-lg-6 col-sm-6\"><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>Дата Рождения:</strong></label><div class=col-xs-4><p class=form-control-static>{{ view.contractor.data.birthday | date: \'dd.MM.yyyy\' }}</p></div></div></div><!--.col.col-xs-12--><!--  .form-group--><!--    label.col-xs-4--><!--      strong Пол:--><!--    .col-xs-4--><!--      p.form-control-static(cbs-dict=\'Gender\') {{getGenderText(Gender, view.gender)}}--><!--.col.col-xs-12--><!--  .form-group--><!--    label.col-xs-4--><!--      strong Национальность:--><!--    .col-xs-4--><!--      p.form-control-static {{ view.nation }}--><!--.col.col-xs-12--><!--  .form-group--><!--    label.col-xs-4--><!--      strong Семейное положение:--><!--    .col-xs-4--><!--      p.form-control-static(cbs-dict=\'MaritalStatus\')  {{getMaritalStatusText(MaritalStatus, view.marital_status)}}--><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>E-mail :</strong></label><div class=col-xs-4><p class=form-control-static>{{view.contractor.data.email}}</p></div></div></div><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>Телефон:</strong></label><div class=col-xs-4><p class=form-control-static>{{view.contractor.data.phone}}</p></div></div></div></div><div class=\"col-lg-6 col-sm-6\"><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>Адрес:</strong></label><div class=col-xs-4><p class=form-control-static>{{view.contractor.data.address}}</p></div></div></div><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>Компания в система:</strong></label><div class=col-xs-4><p class=form-control-static>{{ view.contractor.contractor_company.name }}</p></div></div></div><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>Место работы:</strong></label><div class=col-xs-4><p class=form-control-static>{{ view.contractor.data.work }}</p></div></div></div><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>Тип клиента:</strong></label><div class=col-xs-4><p class=form-control-static>{{ view.contractor.contractor_type_value.data.name }}</p></div></div></div></div></div></div></div></div></div><uib-tabset><uib-tab heading=Анализы><div class=col-sm-12><div class=row><div class=col-sm-12><div class=\"panel panel-default m-t\"><div class=panel-heading><strong>Результаты анализов</strong></div><div><table data-page-size=5 class=\"table table-striped table-hover bg-white b-a\"><thead><tr><th data-toggle=true>Вид анализа</th><th data-hide=phone>Результат</th><th data-hide=phone,tablet>Ед измерения</th><th data-hide=phone,tablet>Дата сдачи</th></tr></thead><tbody><tr ng-repeat=\"loan in view.contractor.data.identities\"><td>{{ loan.product_name }}</td><td>{{ loan.result }}</td><td>{{ loan.product_unit }}</td><td>{{ loan.date_receipt | date: \'dd.MM.yyyy\' }}</td></tr></tbody><!-- <tfoot class=\"hide-if-no-paging\">--><!-- <tr>--><!-- <td colspan=\"5\" class=\"text-center\">--><!-- <ul class=\"pagination\"></ul>--><!-- </td>--><!-- </tr>--><!-- </tfoot>--></table></div></div></div></div></div></uib-tab><uib-tab heading=Диагнозы><div class=col-sm-12><div class=row><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-heading><strong>Диагноз</strong></div><div><table data-page-size=5 class=\"table table-striped table-hover bg-white b-a\"><thead><tr><th data-toggle=true>Название</th><th data-hide=true>Врач</th><th data-hide=true>Дата приема</th><th data-hide=true>Описание</th></tr></thead><tbody><tr ng-repeat=\"diagnosis in view.contractor.data.diagnosises\"><td>{{ diagnosis.name }}</td><td>{{ diagnosis.employee }}</td><td>{{ diagnosis.date | date: \'dd.MM.yyyy\'}}</td><td>{{ diagnosis.comment }}</td></tr></tbody><!-- <tfoot class=\"hide-if-no-paging\">--><!-- <tr>--><!-- <td colspan=\"5\" class=\"text-center\">--><!-- <ul class=\"pagination\"></ul>--><!-- </td>--><!-- </tr>--><!-- </tfoot>--></table></div></div></div></div></div></uib-tab><uib-tab heading=\"История лечения\"><div class=col-sm-12><div class=row><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-heading><strong>История лечения</strong></div><div><table data-page-size=5 class=\"table table-striped table-hover bg-white b-a\"><thead><tr><td data-hide=true>Наименование</td><td data-hide=true>Кол-во</td><td data-hide=true>Дата назначения</td><td data-hide=true>Продолжительность</td><td data-hide=true>Врач</td><td data-hide=true>Комментарии</td></tr></thead><tbody><tr ng-repeat=\"history in view.contractor.data.histories\"><td>{{ history.name }}</td><td>{{ history.summ }}</td><td>{{ history.date | date: \'dd.MM.yyyy\'}}</td><td>{{ history.duration }}</td><td>{{ history.current_employee }}</td><td>{{ history.comment }}</td></tr></tbody><!-- <tfoot class=\"hide-if-no-paging\">--><!-- <tr>--><!-- <td colspan=\"5\" class=\"text-center\">--><!-- <ul class=\"pagination\"></ul>--><!-- </td>--><!-- </tr>--><!-- </tfoot>--></table></div></div></div></div></div></uib-tab></uib-tabset><div class=row><div class=col-sm-3><button ui-sref=app.clients.list class=\"btn btn-primary\">Назад</button></div></div></div></div></div>");
$templateCache.put("app/collateral/collateral.html","<div class=container><panel title=Залоги><form ng-submit=collateral.getPolicies()><div class=row><col-responsive><div class=form-group><label>Клиент</label><contractor-select contractor-id=collateral.filter.client_id placeholder=\"Введите имя клиента\"></contractor-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса</label><input type=text ng-model=collateral.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"collateral.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=ln_solid></div><button type=button ng-click=collateral.goToNew() class=\"btn btn-primary btn-xs\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!collateral.selected_policy\' ng-click=\'collateral.editBranch()\')--> <button ng-click=collateral.goToShow() ng-disabled=!collateral.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button><!--button.btn.btn-default.btn-sm(ng-click=\'collateral.delete()\' ng-disabled=\"!collateral.selected_policy\")--> <button ng-click=collateral.confirmAction() ng-disabled=\"!collateral.selected_policy || collateral.selected_collateral.data.status != \'Сохранен\'\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=collateral.downloadPDF() ng-disabled=\"!collateral.selected_policy || collateral.selected_collateral.policy_no == \'00000\' || (collateral.selected_collateral.data.status != \'Оформлен\' &amp;&amp; collateral.selected_collateral.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=collateral.savePDF() ng-disabled=\"!collateral.selected_policy || collateral.selected_collateral.policy_no == \'00000\' || (collateral.selected_collateral.data.status != \'Оформлен\' &amp;&amp; collateral.selected_collateral.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Скачать pdf</button> <button type=button ng-click=collateral.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=collateral.collateralGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/collateral/create.html","<div class=container><panel title=\"Создание залога\"><form name=collateralForm><div class=row><label class=\"col-md-2 control-label\">Владелец:</label><div class=col-md-3><div class=form-group><contractor-select contractor-id=create.collateral.contractor_id placeholder=\"Введите имя клиента\"></contractor-select></div></div></div><div class=row><label class=\"col-md-2 control-label\">Название:</label><div class=col-md-3><div class=form-group><input type=text ng-model=create.collateral.name required class=form-control></div></div></div><div stock-dict=create.statuses dict-table=Enums dict-filter={name:&quot;collateral_type&quot;} class=row><label class=\"col-md-2 control-label\">Тип залога:</label><div class=col-md-3><div class=form-group><ui-select ng-model=create.collateral.enums_id ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in create.statuses\">{{type.data.name}}</ui-select-choices></ui-select></div></div></div><div class=row><label class=\"col-md-2 control-label\">ИДН:</label><div class=col-md-3><div class=form-group><input type=text ng-model=create.collateral.idn required class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Рын. стоимость:</label><div class=col-md-2><div class=form-group><input type=number min=0 ng-model=create.collateral.market_price required class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Залог. стоимость:</label><div class=col-md-2><div class=form-group><input type=number min=0 ng-model=create.collateral.coll_price required class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Ликвидность:</label><div class=col-md-3><div class=form-group><input type=text ng-model=create.collateral.liquidity required class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Правоустанавливающие документы:</label><div class=col-md-3><div class=form-group><input type=text ng-model=create.collateral.documents required class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Местонахождение:</label><div class=col-md-3><div class=form-group><input type=text ng-model=create.collateral.address required class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Описание:</label><div class=col-md-3><div class=form-group><textarea rows=5 ng-model=create.collateral.description class=form-control></textarea></div></div></div><div class=row><div class=\"col-md-3 col-md-offset-2\"><!--button.btn.btn-primary.m-t(ng-click=\'switchCollateralView(true, false, false)\') Назад--> <button ng-disabled=create.saving type=button ui-sref=app.collateral.list class=\"btn btn-primary m-t\">Отмена</button> <button ng-disabled=collateralForm.$invalid type=button ng-click=create.putCollateral() class=\"btn btn-primary m-t\">Сохранить</button></div></div></form></panel></div>");
$templateCache.put("app/collateral/list.html","<div class=container><panel title=Залоги><form ng-submit=list.getPolicies()><div class=row><col-responsive><div class=form-group><label>Клиент</label><contractor-select contractor-id=list.filter.client_id placeholder=\"Введите имя клиента\"></contractor-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса</label><input type=text ng-model=list.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=ln_solid></div><button ui-sref=app.collateral.create class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-click=list.goToShow() ng-disabled=!list.selected_collateral class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button ng-click=list.confirmAction() ng-disabled=!list.selected_collateral class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=list.getCollaterals() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=list.collateralGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/collateral/view.html","<div class=container><panel title=\"Просмотр залога\"><div class=row><label class=\"col-md-2 control-label\">Владелец:</label><div class=col-md-3><div class=form-group><contractor-select contractor-id=view.collateral.contractor_id placeholder=\"Введите имя клиента\" disabled></contractor-select></div></div></div><div class=row><label class=\"col-md-2 control-label\">Название:</label><div class=col-md-3><div class=form-group><input type=text ng-model=view.collateral.name ng-disabled class=form-control></div></div></div><div stock-dict=view.statuses dict-table=Enums dict-filter={name:&quot;collateral_type&quot;} class=row><label class=\"col-md-2 control-label\">Тип залога:</label><div class=col-md-3><div class=form-group><ui-select ng-model=view.collateral.type_id ng-disabled class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in view.statuses\">{{type.data.name}}</ui-select-choices></ui-select></div></div></div><div class=row><label class=\"col-md-2 control-label\">ИДН:</label><div class=col-md-3><div class=form-group><input type=text ng-model=view.collateral.idn ng-disabled class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Рын. стоимость:</label><div class=col-md-2><div class=form-group><input type=number min=0 ng-model=view.collateral.market_price ng-disabled class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Залог. стоимость:</label><div class=col-md-2><div class=form-group><input type=number min=0 ng-model=view.collateral.coll_price ng-disabled class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Ликвидность:</label><div class=col-md-3><div class=form-group><input type=text ng-model=view.collateral.liquidity ng-disabled class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Правоустанавливающие документы:</label><div class=col-md-3><div class=form-group><input type=text ng-model=view.collateral.documents ng-disabled class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Местонахождение:</label><div class=col-md-3><div class=form-group><input type=text ng-model=view.collateral.address ng-disabled class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Описание:</label><div class=col-md-3><div class=form-group><textarea rows=5 ng-model=view.collateral.description ng-disabled class=form-control></textarea></div></div></div><div class=row><div class=\"col-md-3 col-md-offset-2\"><button ng-disabled=view.saving type=button ui-sref=app.collateral.list class=\"btn btn-primary m-t\">Yfpfl</button></div></div></panel></div>");
$templateCache.put("app/company/avatar.html","<!--\nCreated by User on 9/22/2016.\n\n--><div class=modal-header><h3>{{ \'Радактирование изображения\' | translate }}</h3></div><div class=modal-body><div class=cropArea><img-crop image=avatar.image result-image=avatar.result_image area-type=square></img-crop></div></div><div class=modal-footer><button ng-click=avatar.cancel() class=\"btn btn-default btn-sm\">{{ \'Отмена\' | translate }}</button> <button ng-click=avatar.ok() class=\"btn btn-primary btn-sm\">{{ \'Сохранить\' | translate }}</button></div>");
$templateCache.put("app/company/company.html","<!--Created by Ilyas on 17/11/20.\n--><div class=content><!-- Main content--><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>Организация</h3></div><div class=box-body><button type=button ng-click=company.newCompany() class=\"btn btn-primary btn-sm\">Создать</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!branch.selected_branch\' ng-click=\'branch.editBranch()\')--> <button ng-click=company.editCompany() ng-disabled=\"company.selected_company==null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button><paged-table options=company.companiesGridOptions disable-search=true disable-paging=true></paged-table></div></div></div></div></div><!--.container--><!--  panel(title=\'Компании\')--><!--    .row--><!--      .col.col-xs-12--><!--        button.btn.btn-primary.btn-sm(ng-click=\'company.newCompany()\') Создать компанию--><!--    .row(ng-if=\'company.user_companies.length == 0\')--><!--      .col.col-xs-12--><!--        h4 У вас нет компании.--><!--    .row--><!--      .col.col-xs-6.col-sm-4.col-md-3.col-lg-2(ng-repeat=\'uc in company.user_companies\')--><!--        panel(title=\'{{uc.company.name}}\')--><!--          image(style=\'width:100%;\', src=\'assets/images/img.jpg\')--><!--          label.no-margin.small(ng-if=\'uc.user_id!=app.ua.id\') Доступ: {{uc.access}}--><!--          label.no-margin.small(ng-if=\'uc.user_id==app.ua.id\') Вы владелец--><!--          .ln_solid--> <!--          button.btn.btn-default.btn-sm(ng-click=\'company.editCompany(uc.company)\', ng-if=\'uc.user_id==app.ua.id\') Редактировать-->");
$templateCache.put("app/company/edit.html","<!--\nCreated by Ilyas on 17/11/20.\n\n--><form ng-submit=company.putCompany() class=from-horizontal><div class=modal-header></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Основная информация</a></li><li><a data-toggle=tab data-target=#contact>Контакты</a></li><li><a data-toggle=tab data-target=#user>Пользователи</a></li><li><a data-toggle=tab data-target=#logo>Логотип</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><col-responsive><div class=form-group><label>Официальное имя</label><input type=text ng-model=company.company.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Краткое имя</label><input type=text ng-model=company.company.short_name ng-required=false ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код компании</label><input type=text ng-model=company.company.code ng-required=false ng-trim=true maxlength=2 class=form-control></div></col-responsive><col-responsive stock-dict=company.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=company.company.data.status ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in company.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Дата регистрации</label><div class=\"input-group no-margin\"><input type=text ng-required=true uib-datepicker-popup=dd-MM-yyyy ng-model=company.company.data.reg_date ng-click=\"company.registrationDP.popup_to_date.opened=true\" is-open=company.registrationDP.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"company.registrationDP.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Номер регистрации</label><input type=text ng-model=company.company.data.register_number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ИНН</label><input type=text ng-model=company.company.data.inn ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код ОКПО</label><input type=text ng-model=company.company.data.code_okpo ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=company.company_types dict-table=Enums dict-filter={name:&quot;company_type&quot;}><div class=form-group><label>Тип</label><ui-select ng-model=company.company.company_type ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in company.company_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Менеджер</label><input type=text ng-model=company.company.data.manager ng-required=true ng-trim=true class=form-control></div></col-responsive><!--col-responsive(stock-dict=\'company.insurer_types\' dict-table=\'Enums\' dict-filter=\'{name:\"insurer_type\"}\')--><!--  .form-group--><!--    label Тип--><!--    ui-select.form-control(ng-model=\'company.company.data.insurer_type\' ng-required=\'true\')--><!--      ui-select-match {{$select.selected.data.name}}--><!--      ui-select-choices(repeat=\'type.data.key as type in company.insurer_types track by type.data.key\') {{type.data.name}}--><col-responsive><div class=form-group><label>Капитал</label><input type=text ng-model=company.company.data.capital ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Правила страхования</label><div class=input-group><input type=text ng-model=company.company.data.insurance_rules ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Образец полиса</label><div class=input-group><input type=text ng-model=company.company.data.policy_sample ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Описание</label><textarea ng-model=company.company.data.description rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Рекомендация</label><textarea ng-model=company.company.data.recommendation rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Франшиза</label><textarea ng-model=company.company.data.franchise rows=4 class=form-control></textarea></div></col-responsive></div></div><div id=contact class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Телефон</label><div class=input-group><input type=number ng-model=company.phone ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addPhone() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.phones\" class=list-group-item><label>{{x}}</label><a ng-click=company.deletePhone($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Адрес</label><div class=input-group><input type=text ng-model=company.address ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addAddress() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.addresses\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteAddress($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>E-mail</label><div class=input-group><input type=email ng-model=company.email ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addEmail() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.emails\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteEmail($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Вебсайт</label><div class=input-group><input type=text ng-model=company.website ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addWebsite() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.websites\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteWebsite($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div></div></div><div id=user class=\"tab-pane fade\"><div class=row><div class=row><!--.col.col-xs-12.col-sm-6.col-md-6(stock-dict=\'company.users\' dict-table=\'User\')--><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Ползователи</label><ui-select ng-model=company.currStaff.user_id ng-required=true class=form-control><ui-select-match>{{$select.selected.username}}</ui-select-match><ui-select-choices repeat=\"type.id as type in company.users\">{{type.username}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col col-xs-12\"><button type=button ng-click=company.addStaff() class=\"btn btn-primary btn-sm pull-right\">Добавить</button></div></div><div class=row><div class=\"col col-xs-12\"><h2>Список пользователей</h2><table class=\"table table-bordered\"><thead><tr><th>Пользователь</th><th>Филиал</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in company.company.staff\"><td><span ng-repeat=\"user in company.users\" ng-if=\"user.id == item.user_id\">{{user.username}}</span></td><td><span ng-repeat=\"branch in company.branches | filter:{_id:item.branch_id}\">{{branch.name}}</span></td><td><a ng-click=company.deleteStaff($index) class=\"btn btn-danger glyphicon glyphicon-remove-sign\"></a></td></tr></tbody></table></div></div></div></div><div id=logo class=\"tab-pane fade\"><div class=row><div flow-init={singleFile:true} class=\"col col-xs-12 col-md-8 col-lg-8\"><span flow-btn flow-file-added=\"company.handleFileSelect($event, $flow, $file)\" class=\"btn btn-default margin-right-8\">Выбрать файл...</span><span>{{$flow.files[0].name}}</span></div></div><div class=row><div class=\"col col-xs-12 col-md-8 col-lg-8\"><div class=cropArea><img-crop image=company.image result-image=company.result_image area-type=square result-image-size=100></img-crop></div><div>Итоговое изибражение:<div><img ng-src={{company.result_image}}></div><a data-target=# ng-click=company.upload() class=\"btn btn-primary\">Заменить существующий</a></div></div><div class=\"col col-xs-12 col-md-4 col-lg-4\"><div class=\"clearfix pull-left\"><h3>Логотип компании</h3><img ng-src={{app.api}}{{company.company.data.image}} class=profile-image-lg></div></div></div></div></div></div><div class=modal-body><!--button.btn.btn-primary.btn-sm.pull-right(type=\'submit\', ng-if=\'company.company.user_id==company.ua.id\') Сохранить--> <button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=company.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/currency/currency.html","<!--\nCreated by Ilias on 13/06/16.\n\n--><div class=container><panel title=\"Курс валют\"><button ng-click=currency.confirmAction() ng-disabled=\"currency.selected_currency == null\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button ng-click=currency.getCurrency() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=currency.currencyGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/dashboard/dashboard.html","<div class=content><section class=content><div class=row><div class=\"col-md-3 col-lg-3 col-xs-12\"><!-- Profile Image--><div class=\"box box-primary\"><div class=\"box-body box-profile\"><img ng-src={{app.api}}{{app.ua.data.image}} alt=\"User profile picture\" class=\"profile-user-img img-responsive img-circle\"><h3 class=\"profile-username text-center\">{{app.ua.data.surname}} {{app.ua.data.name}}</h3><p class=\"text-muted text-center\">@{{app.ua.username}} &bull; {{app.ua.rec_date | amDateFormat:\'MMMM DD, YYYY, HH:mm:ss\'}}</p><strong><i class=\"fa fa-inbox margin-r-5\"></i> {{\'E-mail\'| translate}}</strong><p class=text-muted>{{app.ua.email}}</p><hr><a ui-sref=app.profile.edit class=\"btn btn-success btn-block\"><b>Редактировать</b></a></div></div><div class=\"box box-primary\"><div class=\"box-header with-border\"><h3 class=box-title>Курсы валют на {{dashboard.today | amDateFormat:\'DD.MM.YYYY\'}} г.</h3></div><!-- /.box-header--><div class=box-body><ul class=\"list-group list-group-unbordered\"><li ng-repeat=\"currency in dashboard.currencies\" class=list-group-item><b>{{currency.currency}}</b><a class=pull-right>{{currency.value}}</a></li></ul></div></div><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>Документы</h3></div><div class=box-body><table id=dev-table class=\"table table-hover table-bordered\"><thead><tr><th>Наименование</th><th>Файл</th></tr></thead><tbody><tr ng-repeat=\"regulation in dashboard.regulations | orderBy:&quot;-created_from&quot;\"><td>{{regulation.name}}</td><td><a href=\"{{dashboard.api + regulation.file}}\" target=_blank>Скачать</a></td></tr></tbody></table></div></div></div><div class=\"col-xs-12 col-md-9 col-lg-9\"><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>Полисы скоро истекут</h3></div><div class=box-body><paged-table options=dashboard.policiesGridOptions disable-search=true></paged-table></div></div><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>Новости</h3></div><div class=box-body><div class=holder><div ng-repeat=\"item in dashboard.news\" class=border-wrapper><a ng-click=dashboard.goToNewsPage(item) class=\"h4 text-primary m-b-sm text-center\">{{item.name | limitTo: 75 }}{{item.name.length > 75 ? \'...\' : \'\'}}<span class=\"small pull-right\"></span></a><div class=row><div class=\"col-md-3 col-sm-3 col-xs-12\"><time class=\"comment-date small\">{{item.create_date | amDateFormat:\'DD MMM YYYY\'}}</time></div><div class=\"col-md-8 col-sm-8 col-xs-12\"><p ng-bind-html=\"item.description | limitTo: 500\"></p></div></div></div></div></div></div></div></div></section></div>");
$templateCache.put("app/defaults/defaults.html","<!--\nCreated by Ilyas on 17/11/20\n\n--><panel title=Документы><button ng-disabled=!defaults.selected_default ng-click=defaults.editDefault() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=defaults.getDefaults() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=defaults.gridOptions disable-paging=true disable-search=true></paged-table></panel>");
$templateCache.put("app/defaults/edit.html","<!--\nCreated by Ilyas on 17/11/20\n\n--><form ng-submit=defaults.putDefault() class=modal-content><div class=modal-header><h3>Параметры документа</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Тип</label><input ng-disabled=true ng-repeat=\"doc_type in defaults.doc_types | filter: {id:defaults.doc_default.document_type} | limitTo: 1 track by doc_type.id\" ng-model=doc_type.name class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Одобрение</label><label class=form-control><input type=checkbox ng-model=defaults.doc_default.data.approval.required><span ng-hide=defaults.doc_default.data.approval.required>&nbsp;Не обьязательно</span><span ng-show=defaults.doc_default.data.approval.required>&nbsp;Обьязательное одобрение</span></label></div></col-responsive><col-responsive ng-if=\"defaults.doc_default.data.approval.required===true\"><div stock-dict=defaults.approval_types dict-table=Enums dict-filter={name:&quot;approval_type&quot;} class=form-group><label>Должны одобрить</label><div class=form-control><label ng-repeat=\"type in defaults.approval_types track by type.data.key\" ng-class={&quot;margin-right-8&quot;:!$last}><input type=radio ng-model=defaults.doc_default.data.approval.approval_type ng-value=type.data.key name=approve_type><span>&nbsp;{{type.data.name}}</span></label></div></div></col-responsive><col-responsive ng-if=\"defaults.doc_default.data.approval.required===true\"><div class=form-group><label uib-tooltip=\"Одобрение будет проходить по порядку добавления ролей\">Добавить роль для одобрения</label><div stock-dict=defaults.roles dict-table=Roles class=input-group><ui-select ng-model=defaults.approval_role_id class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (defaults.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-disabled=!defaults.approval_role_id ng-click=defaults.addApprovalRole() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-plus text-primary\"></span></button></span></div></div></col-responsive><div ng-show=\"defaults.doc_default.data.approval.roles_id.length &gt; 0 &amp;&amp; defaults.doc_default.data.approval.required===true\" class=\"col col-xs-12\"><label>Роли для одобрения</label></div><div ng-show=\"defaults.doc_default.data.approval.roles_id.length &gt; 0 &amp;&amp; defaults.doc_default.data.approval.required===true\" class=\"col col-xs-12\"><col-responsive ng-repeat=\"role_id in defaults.doc_default.data.approval.roles_id\"><div class=input-group><div class=input-group-addon><span>{{$index+1}}</span></div><ui-select ng-model=role_id ng-disabled=true class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (defaults.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=defaults.delApprovalRole(role_id) class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></span></div></col-responsive></div><col-responsive><div class=form-group><label>Исполнитель</label><employee-select employee-id=defaults.doc_default.data.data.executor_id></employee-select></div></col-responsive></div></div><div class=modal-footer><button ng-disabled=\"defaults.saving==true\" type=button ng-click=defaults.cancel() class=\"btn btn-warning\">Отмена</button> <button ng-disabled=\"defaults.saving==true\" class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/dictionary/dictionary.html","<!--Created by Ilyas on 17/11/20\n--><div class=content><!-- Main content--><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>Справочники</h3></div><div class=box-body><div class=row><div class=\"col col-xs-12 col-md-3\"><div class=list-group><a ng-class=\"{active:dictionary.active_table.table==table.table}\" ng-click=\"dictionary.active_table=table\" ng-repeat=\"table in dictionary.tables | filter: dictionary.roleFilter track by table.table\" class=list-group-item>{{table.name}}</a></div></div><div class=\"col col-xs-12 col-md-9\"><button ng-click=dictionary.newDictionary() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=!dictionary.selected_dictionary ng-click=dictionary.editDictionary() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-disabled=!dictionary.selected_dictionary ng-click=dictionary.removeConfirmAction() class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-trash margin-right-8\"></span><span>Удалить</span></button><div dynamic=dictionary.grid></div></div></div></div></div></div></div></div>");
$templateCache.put("app/dictionary/modal.html","<!--Created by Ilyas on 17/11/20\n--><form ng-submit=edit.saveDictionary()><div class=modal-header><h3>{{edit.table.name}}</h3></div><div class=modal-body><ng-include src=edit.template></ng-include></div><div class=modal-footer><button type=button ng-click=edit.cancel() class=\"btn btn-default\">Отмена</button> <button type=submit class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/docs/comments.html","<!--\nCreated by ilias on 05/09/16.\n\n--><div ng-if=documentId class=list-group><div class=list-group-item><h4>Комментарии</h4><button ng-click=comments.getComments() class=\"btn btn-sm btn-default\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div><div ng-repeat=\"comment in comments.comments track by comment._id\" class=list-group-item><div class=\"margin-right-8 pull-left text-muted\">{{comment.entry_user.username}}</div><div class=\"small text-danger margin-right-8 pull-left\">&bull; {{comment.comment_type_value.data.name}}</div><div class=\"small pull-right text-muted\">{{comment._created | amDateFormat:\'Do MMMM YYYY, hh:mm:ss\'}}</div><div class=clearfix></div><div class=\"list-group-item-text pre\">{{comment.data.comment}}</div></div><div class=list-group-item><div class=form-group><textarea rows=5 ng-model=comments.comment class=form-control></textarea></div><button ng-click=comments.addComment() class=\"btn btn-primary btn-sm pull-right\">Добавить комментарий</button><div class=clearfix></div></div></div>");
$templateCache.put("app/docs/entry.html","<div class=container><div class=card><div class=card-header>{{entry.doc_type.name}}</div><div class=card-body><!--panel(title=\"{{entry.doc_type.name}}\" ng-if=\"entry.template\")--><form ng-submit=entry.save()><div class=btn-group-sm><button type=button ng-show=entry.can_approve ng-click=entry.approve() class=\"btn btn-success\"><span class=\"glyphicon glyphicon-ok margin-right-8\"></span><span>Одобрить</span></button> <button type=button ng-show=entry.can_approve ng-click=entry.reject() class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Отклонить</span></button> <button type=button ng-show=entry.can_execute ng-click=entry.execute() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-ok margin-right-8\"></span><span>Исполнить</span></button> <button type=button ng-show=entry.canRollback() ng-click=entry.rollback() class=\"btn btn-danger\">Отменить</button> <button type=button ng-show=entry.canCommit() ng-click=entry.commit() class=\"btn btn-success\">Применить</button> <button type=submit ng-show=entry.canSave() class=\"btn btn-primary\">Сохранить</button> <button type=button ng-disabled=\"entry.saving==true\" ng-click=entry.backToList() class=\"btn btn-warning\">Назад</button></div><div class=ln_solid></div><div ng-include=entry.template></div></form><div ng-show=entry.doc_loading class=\"loading-spinner fadeIn fadeOut animated\"><div id=circularG><div id=circularG_1 class=circularG></div><div id=circularG_2 class=circularG></div><div id=circularG_3 class=circularG></div><div id=circularG_4 class=circularG></div><div id=circularG_5 class=circularG></div><div id=circularG_6 class=circularG></div><div id=circularG_7 class=circularG></div><div id=circularG_8 class=circularG></div></div></div></div></div></div>");
$templateCache.put("app/docs/list.html","<!--\nCreated by ilias on 8/6/16.\n\n\n--><div class=\"my-3 my-md-5\"><div class=container><div class=row><div class=col-md-3><h3 class=\"page-title mb-5\">{{\'Документы\'| translate}}</h3><div><div class=\"list-group list-group-transparent mb-0\"><a href=# class=\"list-group-item list-group-item-action d-flex align-items-center active\"><span class=\"icon mr-3\"><i class=\"fa fa-inbox\"></i></span>Входящие<span class=\"ml-auto badge badge-primary\">14</span></a><a href=# class=\"list-group-item list-group-item-action d-flex align-items-center\"><span class=\"icon mr-3\"><i class=\"fa fa-send\"></i></span>Исходящие</a><a href=# class=\"list-group-item list-group-item-action d-flex align-items-center\"><span class=\"icon mr-3\"><i class=\"fa fa-info-circle\"></i></span>Служебные<span class=\"ml-auto badge badge-secondary\">3</span></a><a href=# class=\"list-group-item list-group-item-action d-flex align-items-center\"><span class=\"icon mr-3\"><i class=\"fa fa-star\"></i></span>Starred</a><a href=# class=\"list-group-item list-group-item-action d-flex align-items-center\"><span class=\"icon mr-3\"><i class=\"fa fa-file\"></i></span>Черновики</a><a href=# class=\"list-group-item list-group-item-action d-flex align-items-center\"><span class=\"icon mr-3\"><i class=\"fa fa-tag\"></i></span>Tags</a><a href=# class=\"list-group-item list-group-item-action d-flex align-items-center\"><span class=\"icon mr-3\"><i class=\"fa fa-trash-2\"></i></span>Trash</a></div><div class=mt-6><a href=# class=\"btn btn-secondary btn-block\">Compose new Email</a></div></div></div><div class=col-md-9><div class=card><div class=card-header>{{\'Мои документы\'|translate}}</div><div class=card-body><button ng-click=list.add() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-plus margin-right-8\"></span><span>Добавить</span></button> <button ng-disabled=!list.selected_doc ng-click=list.edit() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-disabled=!list.selected_doc ng-click=list.remove() class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-trash margin-right-8\"></span><span>Удалить</span></button><div class=ln_solid></div><paged-table options=list.gridOptions disable-search=true height=700></paged-table></div></div></div></div></div></div>");
$templateCache.put("app/docs/new.html","<div class=container><div class=card><div class=card-header><h1 class=page-title>{{\'Документы\'|translate}}</h1></div><div class=card-body><div class=row><div ng-repeat=\"type in docs.doc_types track by type.id\" class=\"col-6 col-sm-4 col-lg-2\"><div class=card><div class=\"card-body p-3 text-center\"><a ui-sref=app.docs.entry({type:type.id})><img style=\"width: 100%\" ng-src={{app.api}}{{type.icon}} class=cursor></a><div class=\"h4 m-0\">{{type.name}}</div></div></div></div></div></div></div></div>");
$templateCache.put("app/docs/view.html","<!--Created by ilias on 8/6/16.\n--><panel title={{view.doc_type.name}} ng-if=view.template><div class=btn-group-sm><button type=button ng-show=view.can_approve ng-click=view.approve() class=\"btn btn-success\"><span class=\"glyphicon glyphicon-ok margin-right-8\"></span><span>Одобрить</span></button> <button type=button ng-show=view.can_approve ng-click=view.reject() class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Отклонить</span></button> <button type=button ng-show=view.can_execute ng-click=view.execute() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-ok margin-right-8\"></span><span>Исполнить</span></button> <button type=button ng-show=view.can_execute ng-click=view.send() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-send margin-right-8\"></span><span>Отправить</span></button> <button type=button ng-show=view.canRollback() ng-click=view.rollback() class=\"btn btn-danger\">Отменить</button> <button type=button ng-show=view.canCommit() ng-click=view.commit() class=\"btn btn-success\">Применить</button> <button ng-show=view.canEdit() ng-click=view.editDoc() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button type=button ng-disabled=\"view.saving==true\" ui-sref=app.docs.list class=\"btn btn-warning\">Назад</button> <button ng-click=view.getDoc() uib-tooltip=Обновить class=\"btn btn-default\"><span class=\"glyphicon glyphicon-refresh\"></span></button> <button type=button ng-disabled=view.printing ng-click=view.print() uib-tooltip=\"Распечатать документ\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-print\"></span></button></div><div class=ln_solid></div><div ng-include=view.template></div></panel><div ng-show=view.doc_loading class=\"loading-spinner fadeIn fadeOut animated\"><div id=circularG><div id=circularG_1 class=circularG></div><div id=circularG_2 class=circularG></div><div id=circularG_3 class=circularG></div><div id=circularG_4 class=circularG></div><div id=circularG_5 class=circularG></div><div id=circularG_6 class=circularG></div><div id=circularG_7 class=circularG></div><div id=circularG_8 class=circularG></div></div></div>");
$templateCache.put("app/doctemplates/add.html","<div flow-init=add.flowConfig class=container><div class=row><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=x_panel><div class=x_title><h2>Добавить документ</h2><div class=clearfix></div></div><div class=x_content><form id=doctemp-form class=\"form-horizontal form-label-left\"><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Название<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input type=text id=title name=title required ng-model=add.docTemp.name class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Выберите файл<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><!--input(type=\"file\", flow-btn)--><file-load file-src=add.docTemp.url type=exp_fk allow=ods,odt,xls,xlsx></file-load><!--label.btn.btn-default.btn-file--><!--  input(type=\"file\", id=\"file\", name=\"file\", ng-model=\"add.docTemp.file\", hidden)--></div></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=add.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=add.saveDocTemp() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/doctemplates/list.html","<div class=container><div class=row><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=x_panel><div class=x_title><h2>Шаблоны документов</h2><div class=clearfix></div></div><div class=x_content><table class=table><thead><tr><th>#</th><th>Название</th><th><button type=button ng-click=list.openAddForm() class=\"btn btn-default btn-xs\">Добавить</button> <button type=button ng-click=list.getDocTeplates() class=\"btn btn-default btn-xs\">Обновить</button></th></tr></thead><tbody><tr ng-repeat=\"doc in list.docTemps\" ng-if=\"list.docTemps.length &gt; 0\"><td>{{ ($index + 1) }}</td><td padding-top>{{ doc.name }}</td><td><a target=_blank href=\"{{ list.api + \'download/\' + doc.url }}\" class=\"btn btn-primary btn-xs\">Скачать</a> <button type=button ng-click=list.deleteDoc(doc) class=\"btn btn-danger btn-xs\">Удалить</button></td></tr><tr ng-if=\"list.docTemps.length == 0\"><td></td><td>Нет шаблонов</td><td></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/employee/create.html","<!--\nCreated by ilias on 20.08.2017.\n\n--><form ng-submit=employee.createEmployee()><div class=modal-header><h3>Новый сотрудник</h3></div><div class=modal-body><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>ФИО</label><input type=text ng-model=employee.employee.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"employee.popup_delivery_date.opened=true\" ng-model=employee.employee.birthday is-open=employee.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"employee.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=employee.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/employee/edit.html","<!--\nCreated by ilias on 20.08.2017.\n\n--><form ng-submit=employee.updateEmployee()><div class=modal-header><h3>Сотрудник<div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>ФИО</label><input type=text ng-model=employee.employee.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"employee.popup_delivery_date.opened=true\" ng-model=employee.employee.birthday is-open=employee.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"employee.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></h3></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=employee.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/employee/employee.html","<!--Created by ilias on 20.08.2017.\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Сотрудники</div><div class=panel-body><button ng-click=employee.newEmployee() class=\"btn btn-primary btn-sm\">Добавить<!--button.btn.btn-default.btn-sm(ng-click=\"employee.editEmployee()\" ng-disabled=\"users.selected_user == null\")--> <button ng-click=employee.editEmployee() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=employee.deleteEmployee(employee.selected_user) class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button ng-click=employee.getEmployees() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button></button><paged-table options=employee.employeeGridOptions disable-search=true></paged-table></div></div></div>");
$templateCache.put("app/fpolicy/list.html","<div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Полисы</div><div class=panel-body><form ng-submit=list.getPolicies() class=direct-chat-msg><div class=row><col-responsive><div class=form-group><label>Сотрудники:</label><ui-select ng-model=list.filter.agent_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.surname}} {{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"agent.id as agent in list.agents \">{{agent.data.surname}} {{agent.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=list.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in list.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=list.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ФИО клиента:</label><input type=text ng-model=list.filter.client placeholder=\" Введите Фио клиента\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button> <button ng-click=list.goToShow() ng-disabled=!list.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button type=button ng-click=list.downloadPDF() ng-disabled=\"!list.selected_policy || list.selected_list.policy_no == \'00000\' || (list.selected_policy.data.status != \'Оформлен\' &amp;&amp; list.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=list.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div></form><paged-table options=list.policiesGridOptions disable-search=true></paged-table></div></div></div></div></div></div>");
$templateCache.put("app/fpolicy/show.html","<!--Created by troy on 07.10.2016.\n--><div class=container><div class=panel><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=panel><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{show.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{show.policy.client}}</span></h5></div></div><div class=row><div class=col-md-10><h5>Номер кредита:<span class=text-info> {{show.policy.credit_no}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{show.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=show.policy.insurance_data.ned class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ts class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ts\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ln class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=panel-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button><!--button.btn.btn-default.pull-right(type=\'button\'  ng-click=\"show.goToForm()\" ng-if=\"show.policy.data.status && show.policy.data.status == \'Истек\'\" ng-disabled=\"show.policy.data.status != \'Истек\'\")--><!--  i.fa.fa-refresh(aria-hidden=\'true\')--><!--  |   Возобновить--> <button type=button ng-click=show.confirmAction() ng-if=\"show.policy.data.status &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button><!--button.btn.btn-success.pull-right(type=\'button\' ng-click=\"show.goToForm()\" ng-if=\"show.policy.data.status != \'Истек\' && show.policy.data.status != \'Оформлен\' && show.policy.data.status != \'Испорчен\' && show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\")--><!--  i.fa.fa-pencil(aria-hidden=\'true\')--><!--  |   Изменить--><!--button.btn.btn-success.pull-right(type=\'button\' ng-click=\"show.confirmActionForm()\" ng-if=\"show.policy.data.status != \'Истек\' && show.policy.data.status != \'Оформлен\' && show.policy.data.status != \'Испорчен\' && show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\")--><!--  i.fa.fa-pencil-square-o(aria-hidden=\'true\')--><!--  |   Выдать--></div></div></div>");
$templateCache.put("app/hpolicy/list.html","<div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Полисы</div><div class=panel-body><form ng-submit=list.getPolicies() class=direct-chat-msg><div class=row><col-responsive><div class=form-group><label>Филиалы</label><ui-select ng-model=list.filter.branch_id ng-required=true on-select=list.getAgents(list.filter.branch_id) class=form-control><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"company._id as company in list.branches \">{{company.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Сотрудники:</label><ui-select ng-model=list.filter.agent_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.surname}} {{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"agent.id as agent in list.agents \">{{agent.data.surname}} {{agent.data.name}}</ui-select-choices></ui-select><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}></col-responsive></div></col-responsive><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=list.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in list.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=list.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ФИО клиента:</label><input type=text ng-model=list.filter.client placeholder=\" Введите Фио клиента\" class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=list.filter.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=list.filter.date_start ng-click=\"list.search.popup_to_date.opened=true\" is-open=list.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=list.filter.date_start ng-model=list.filter.date_end ng-click=\"list.search.popup_from_date.opened=true\" is-open=list.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button> <button ng-click=list.goToShow() ng-disabled=!list.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button type=button ng-click=list.downloadPDF() ng-disabled=\"!list.selected_policy || list.selected_list.policy_no == \'00000\' || (list.selected_policy.data.status != \'Оформлен\' &amp;&amp; list.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=list.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div></form><paged-table options=list.policiesGridOptions disable-search=true></paged-table></div></div></div></div></div></div>");
$templateCache.put("app/hpolicy/show.html","<!--Created by troy on 07.10.2016.\n--><div class=container><div class=panel><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{show.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{show.policy.client}}</span></h5></div></div><div class=row><div class=col-md-10><h5>Номер кредита:<span class=text-info> {{show.policy.credit_no}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{show.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=show.policy.insurance_data.ned class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ts class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ts\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ln class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=panel-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button><!--button.btn.btn-default.pull-right(type=\'button\'  ng-click=\"show.goToForm()\" ng-if=\"show.policy.data.status && show.policy.data.status == \'Истек\'\" ng-disabled=\"show.policy.data.status != \'Истек\'\")--><!--  i.fa.fa-refresh(aria-hidden=\'true\')--><!--  |   Возобновить--><!--button.btn.btn-danger.pull-right(type=\'button\' ng-click=\"show.confirmAction()\", ng-if=\"show.policy.data.status && show.policy.data.status == \'Оформлен\'\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\")--><!--  i.fa.fa-scissors(aria-hidden=\'true\')--><!--  |   Испортить--><!--button.btn.btn-success.pull-right(type=\'button\' ng-click=\"show.goToForm()\" ng-if=\"show.policy.data.status != \'Истек\' && show.policy.data.status != \'Оформлен\' && show.policy.data.status != \'Испорчен\' && show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\")--><!--  i.fa.fa-pencil(aria-hidden=\'true\')--><!--  |   Изменить--><!--button.btn.btn-success.pull-right(type=\'button\' ng-click=\"show.confirmActionForm()\" ng-if=\"show.policy.data.status != \'Истек\' && show.policy.data.status != \'Оформлен\' && show.policy.data.status != \'Испорчен\' && show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\")--><!--  i.fa.fa-pencil-square-o(aria-hidden=\'true\')--><!--  |   Выдать--></div></div></div>");
$templateCache.put("app/main/main.html","<div class=wrapper><header class=main-header><!-- Logo--><a ui-sref=app.dashboard class=logo><span class=logo-mini><b>АРС</b></span><span class=logo><b>СК АрсеналЪ</b></span></a><nav class=\"navbar navbar-static-top\"><!-- Sidebar toggle button--><a data-toggle=push-menu role=button class=sidebar-toggle><span class=sr-only>Toggle navigation</span><span class=icon-bar><i class=\"fa fa-bars\"></i></span><span class=icon-bar><i class=\"fa fa-bars\"></i></span><span class=icon-bar><i class=\"fa fa-bars\"></i></span></a><div class=navbar-custom-menu><ul class=\"nav navbar-nav\"><li class=\"dropdown user-menu\"><a ng-click=app.logOut()>Выход</a></li></ul></div></nav></header><aside class=main-sidebar><div class=sidebar><div class=\"user-panel direct-chat-msg\"><h5 class=\"text-bold direct-chat-msg\">{{app.uc.name}}</h5><div class=\"pull-left image\"><img ng-src={{app.api}}{{app.ua.data.image}} alt=\"User Image\" class=img-circle></div><div class=\"pull-left info\"><p>{{app.ua.data.surname}} {{app.ua.data.name}}</p><p>@{{app.ua.username}}</p></div></div><div id=sidebar-menu side-nav class=\"main_menu_side hidden-print main_menu\"><ul class=\"nav side-menu sidebar-menu\"><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i><span>Дашборд</span></a></li></ul><ul class=\"nav side-menu sidebar-menu\"><li ng-repeat=\"menu in app.navigation | orderBy : &quot;data.position&quot;\"><a class=dynamic_menu><i ng-class=menu.data.icon></i><span>{{menu.name}} <span class=\"fa fa-chevron-down\"></span></span></a><ul style=display:block class=\"nav child_menu treeview-menu\"><li ng-repeat=\"child in menu.children | orderBy : &quot;data.position&quot;\"><a ui-sref={{child.data.route}} class=dynamic_menu>{{child.name}}</a></li></ul></li><li ng-repeat=\"menu in app.admin_menu | orderBy : &quot;data.position&quot;\"><a class=admin_menu><i ng-class=menu.data.icon></i><span>{{menu.name}} <span class=\"fa fa-chevron-down\"></span></span></a><ul class=\"nav child_menu treeview-menu\"><li ng-repeat=\"child in menu.children | orderBy : &quot;data.position&quot;\"><a ui-sref={{child.data.route}} class=admin_menu>{{child.name}}</a></li></ul></li></ul></div></div></aside><div role=main style=\"padding: 20px 20px 20px 20px; min-height: 800px\" class=content-wrapper><ui-view><div style=height:100px class=row></div></ui-view></div><footer class=main-footer><div class=\"pull-right hidden-xs\"><b>Version</b> 0.0.11</div><strong>Copyright © 2021<a href=https://arsins.kg/ target=_blank> ЗАО \"Страховая компания АРСЕНАЛЪ-КЫРГЫЗСТАН\"</a>.</strong> All rights reserved.</footer></div>");
$templateCache.put("app/menu/item.html","<!--\nCreated by Ilyas on 17/11/20\n\n--><div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>{{item.menu._id ? \"Изменить\":\"Добавить\"}}</h3></div><div class=box-body><form ng-submit=item.putMenu() class=form-horizontal><div class=form-group><div class=row><div class=\"col-md-2 col-xs-12 col-lg-2 text-right\"><label>Родитель</label></div><div class=\"col-xs-12 col-md-8 col-lg-8\"><ui-select ng-model=item.menu.parent_id ng-disabled=item.children.length&gt;0 theme=bootstrap remove-selected=false><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"menu._id as menu in (menu.menus | filter:{name:$select.search} | filter: menu.filterOnlyParents | orderBy:&quot;data.position&quot;) track by menu._id\" ui-disable-choice=\"menu._id==item.menu._id\">{{menu.name}}</ui-select-choices></ui-select></div></div></div><div class=form-group><div class=row><div class=\"col-md-2 col-xs-12 col-lg-2 text-right\"><label>Наименование</label></div><div class=\"col-xs-12 col-md-8 col-lg-8\"><input type=text ng-model=item.menu.name ng-required=true ng-trim=true class=form-control></div></div></div><div ng-hide=item.disabled class=form-group><div class=row><div class=\"col-md-2 col-xs-12 col-lg-2 text-right\"><label>Путь</label></div><div class=\"col-xs-12 col-md-8 col-lg-8\"><input type=text ng-model=item.menu.data.route class=form-control></div></div></div><div class=form-group><div class=row><div class=\"col-md-2 col-xs-12 col-lg-2 text-right\"><label>Позиция</label></div><div class=\"col-xs-12 col-md-8 col-lg-8\"><input type=number ng-model=item.menu.data.position ng-required=true class=form-control></div></div></div><div class=form-group><div class=row><div class=\"col-md-2 col-xs-12 col-lg-2 text-right\"><label>Иконка</label></div><div class=\"col-xs-12 col-md-8 col-lg-8\"><div ng-class=\"{&quot;input-group&quot;: item.menu.data.icon}\"><div class=input-group-btn><button ng-if=item.menu.data.icon class=\"btn btn-default\"><i ng-class=item.menu.data.icon></i></button></div><input type=text ng-model=item.menu.data.icon class=form-control></div></div></div></div><button ng-if=item.menu._id class=\"btn btn-primary btm-sm\">Сохранить</button> <button ng-if=!item.menu._id class=\"btn btn-primary btm-sm\">Добавить</button> <button ng-if=item.menu._id ng-click=item.confirmAction(item.menu) class=\"btn btn-danger btm-sm\">Удалить</button></form></div></div></div></div></div>");
$templateCache.put("app/menu/menu.html","<div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=row><div class=\"col col-md-2 col-sm-3\"><div class=row><div class=\"col col-md-12\"><button ui-sref=app.menu.item({id:&quot;new&quot;}) class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-click=menu.getMenus() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><div ng-repeat=\"menu_item in menu.menus | filter: menu.filterOnlyParents | orderBy : &quot;data.position&quot;\" class=list-group><a ui-sref=app.menu.item({id:menu_item._id}) class=list-group-item>{{menu_item.data.position}}) {{menu_item.name}}</a><a ui-sref=app.menu.item({id:child._id}) ng-repeat=\"child in menu.menus | filter:{parent_id:menu_item._id} | orderBy : &quot;data.position&quot;\" class=list-group-item>&#9;{{child.data.position}}. {{child.name}}</a></div></div></div></div><div class=\"col col-md-10 col-sm-9\"><ui-view></ui-view></div></div></div></div></div>");
$templateCache.put("app/modals/confirmation-dialog.html","<div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button data-dismiss=modal aria-label=Close class=close><span aria-hidden=true>×</span></button><h4 class=modal-title>Окно подтверждения!</h4></div><div class=modal-body><p>Вы уверены {{policy_dialog.text.text}}</p></div><div class=modal-footer><button type=button ng-click=policy_dialog.cancel() class=\"btn btn-default pull-left\">Нет</button> <button type=button ng-click=policy_dialog.ok() class=\"btn btn-primary\">Да</button></div></div></div>");
$templateCache.put("app/modals/dialog_parameter.html","<!--Created by troy on 15.12.2016.\n--><div class=container><form ng-submit=term_dialog.ok() class=from-horizontal><div class=\"panel panel-default\"><div class=panel-heading>Окно подтверждения!</div><div class=panel-body><h5>Вы уверены {{term_dialog.text.text}}</h5><div class=form-group><label for=money>Возвращаемая сумма:</label><input id=money type=number ng-model=term_dialog.moneyBack min=0 step=0.01 ng-required=true class=form-control></div></div><div class=panel-footer><button id=delete type=submit class=\"btn btn-success\">Расторгнуть</button> <button type=button ng-click=term_dialog.cancel() class=\"btn btn-primary\">Нет</button></div></div></form></div>");
$templateCache.put("app/modals/search-product.html","<!--Created by jaynakus on 7/18/16.\n--><div class=modal-header><h3>Поиск</h3></div><div class=modal-body><input ng-keyup=pressed($event) ng-model=query ng-model-options={debounce:200} placeholder=Поиск autofocus class=form-control><paged-table id=search options=gridOptions disable-search=true></paged-table><div class=clearfix></div></div><div class=modal-footer><button ng-click=cancel() class=\"btn btn-primary\">Отмена</button> <button ng-click=ok() class=\"btn btn-success\">OK</button></div>");
$templateCache.put("app/news/form.html","<div class=content><!-- Main content--><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>Форма - Создание новости</h3></div><div class=box-body><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_content><form id=news-form class=\"form-horizontal form-label-left\"><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Дата</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-click=\"form.search.popup_to_date.opened=true\" ng-model=form.newsItem.create_date is-open=form.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"form.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div stock-dict=form.sectionsofpublication dict-table=Sectionsofpublication class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Раздел публикации</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><ui-select ng-model=form.newsItem.sectionsofpublication_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in form.sectionsofpublication\">{{type.name}}</ui-select-choices></ui-select></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Название<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input type=text id=name_ru name=name_ru required ng-model=form.newsItem.name class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Описание<span class=required>*</span></label><div class=\"col-md-8 col-sm-8 col-xs-12\"><wysiwyg-edit content=form.newsItem.description ng-model=form.newsItem.description required></wysiwyg-edit></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Ссылка</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><textarea id=link name=link width=100 height=80 ng-model=form.newsItem.link class=\"form-control col-md-7 col-xs-12\"></textarea></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Актив<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=checkbox><label><input type=checkbox checked ng-model=form.newsItem.is_active class=flat></label></div></div></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=form.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=form.saveNews() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/news/list.html","<div class=content><!-- Main content--><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>Новости</h3></div><div class=box-body><form id=news-form class=direct-chat-msg><div class=row><col-responsive><div class=form-group><label class=control-label>Наименование</label><input type=text ng-model=list.searchValues.name class=form-control></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Актив</label><select ng-model=list.searchValues.is_active class=form-control><option value=all>Все</option><option value=yes>Активные</option><option value=no>Неактивные</option></select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label class=control-label>Дата создания от</label><div class=\"input-group no-margin\"><input type=text name=valid_from ng-model=list.searchValues.created_from uib-datepicker-popup=dd.MM.yyyy datepicker-options=list.dateOptions is-open=list.dateOptions.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.dateOptions.opened1 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Дата создания до</label><div class=\"input-group no-margin\"><input type=text name=valid_to ng-model=list.searchValues.created_to uib-datepicker-popup=dd.MM.yyyy datepicker-options=list.dateOptions is-open=list.dateOptions.opened2 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.dateOptions.opened2 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><button type=button ng-click=list.getNews() class=\"btn btn-primary btn-xs\">Найти</button> <button type=button ng-click=list.openCreateForm() class=\"btn btn-primary btn-xs\">Добавить</button> <button type=button ng-click=list.openEditForm() ng-disabled=\"list.selected_news == null\" class=\"btn btn-primary btn-xs\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button type=button ng-click=list.removeNews() ng-disabled=\"list.selected_news == null\" class=\"btn btn-primary btn-xs\"><span>Удалить</span></button></form><paged-table options=list.gridOptions disable-search=false></paged-table></div></div></div></div></div>");
$templateCache.put("app/news/uploadimage.html","<div class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Загрузить картинку</h2><div class=clearfix></div></div><div class=x_content><form id=image-upload-form class=\"form-horizontal form-label-left\"><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Выберите картинку<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><label class=\"btn btn-default btn-file\"><input type=file id=file name=file ng-model=uploadimage.newsItem.image hidden></label></div></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=uploadimage.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=uploadimage.saveImage() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/news/view.html","<!--Created by admin on 30.08.2016.\n--><div class=\"form-group form-group-sm\"><button ui-sref=app.dashboard title=Назад class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-chevron-left margin-right-8\"><span>Назад</span></span></button></div><panel title={{view.document.name}}><div class=container><div class=\"col-sm-10 col-md-10\"><div class=row><div class=form-group><div class=\"col-sm-8 col-md-8\"><p>Создано: <time class=comment-date>{{view.document.created_date | amDateFormat:\'DD MMM YYYY HH:mm\'}}</time></p><h4>Тема: {{view.document.name}}</h4><div dynamic=view.document.description></div></div></div></div></div></div><div class=row><a ng-click=view.toTheTop() title=Наверх class=\"pull-right toTheTop\"><h1><span class=\"glyphicon glyphicon-hand-up\"></span></h1></a></div></panel>");
$templateCache.put("app/operation/operation.html","<!--\nCreated by Ilyas on 17/11/20\n\n--><panel title=Операции><button ng-click=operation.getOperations() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=operation.gridOptions disable-search=true></paged-table></panel>");
$templateCache.put("app/operation/view.html","<!--Created by Ilyas on 17/11/20.\n--><div class=modal-header><h3>Операция</h3></div><div class=modal-body><div class=row-striped><div class=row><div class=\"col col-xs-12 col-md-4\">Филал</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.branch.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Доукмент</div><div class=\"col col-xs-12 col-md-8\"><a ui-sref=app.docs.view({id:view.operation.document_id})>{{view.operation.document.title}}</a><p class=small>{{view.operation.document.short_desc}}</p></div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Продукт</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.product.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Единица измерения</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.unit.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Количество</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.quantity | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Валюта</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.currency.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Стоимость</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.quote_unit_price | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Сумма</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.total_cost | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Доп. стоимотсь</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.additional_cost | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Статус операции</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.operation_status_value.data.name}}</div></div><div ng-if=view.operation.branch2 class=row><div class=\"col col-xs-12 col-md-4\">Филал назначения</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.branch2.name}}</div></div><div ng-if=view.operation.contractor class=row><div class=\"col col-xs-12 col-md-4\">Контрагент</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.contractor.name}}</div></div><div ng-if=view.operation.is_due class=row><div class=\"col col-xs-12 col-md-4\">В долг</div><div class=\"col col-xs-12 col-md-8\"><input type=checkbox ng-model=view.operation.is_due></div></div><div ng-if=view.operation.is_due class=row><div class=\"col col-xs-12 col-md-4\">Дата выплаты</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.due_date | amDateFormat:\"Do MMMM YYYY\"}}</div></div><div ng-if=view.operation.is_advance class=row><div class=\"col col-xs-12 col-md-4\">Аванс</div><div class=\"col col-xs-12 col-md-8\"><input type=checkbox ng-model=view.operation.is_advance></div></div><div ng-if=view.operation.employee class=row><div class=\"col col-xs-12 col-md-4\">Сотрудник</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.employee.user.username}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Комметарий</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.comment}}</div></div></div></div><div class=modal-footer><button ng-click=view.cancel() class=\"btn btn-default btn-sm\">Закрыть</button></div>");
$templateCache.put("app/payment/edit.html","<!--Created by Ilyas on 17/11/20\n--><form ng-submit=edit.savePayment()><div class=modal-header><h3>Платеж</h3></div><div class=modal-body><div class=form-horizontal><div class=row><col-responsive><div stock-dict=edit.branches dict-table=Branches class=form-group><label>Филиал</label><ui-select ng-model=edit.payment.branch_id ng-required=true><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"branch._id as branch in edit.branches track by branch._id\">{{branch.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=edit.currencies dict-table=Currencies class=form-group><label>Валюта</label><ui-select ng-model=edit.payment.currency_id ng-required=true><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"currency._id as currency in edit.currencies track by currency._id\">{{currency.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=edit.payment_directions dict-table=Enums dict-filter={name:&quot;payment_direction&quot;} class=form-group><label>Направление платежа</label><ui-select ng-model=edit.payment.payment_direction ng-required=true><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"payment_direction.data.key as payment_direction in edit.payment_directions track by payment_direction.data.key\">{{payment_direction.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=edit.payment_types dict-table=Enums dict-filter={name:&quot;payment_type&quot;} class=form-group><label>Тип платежа</label><ui-select ng-model=edit.payment.payment_type ng-required=true><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"payment_type.data.key as payment_type in edit.payment_types track by payment_type.data.key\">{{payment_type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Сумма</label><input type=number step=0.01 min=0 ng-model=edit.payment.amount ng-required=true class=form-control></div></col-responsive><col-responsive><div ng-class={&quot;has-error&quot;:payment.contractor_error} class=form-group><label>Контрагент</label><contractor-select contractor-id=edit.payment.data.contractor_id></contractor-select></div></col-responsive><col-responsive><div ng-class={&quot;has-error&quot;:payment.employee_error} class=form-group><label>Сотрудник</label><employee-select employee-id=edit.payment.data.employee_id></employee-select></div></col-responsive><col-responsive><div stock-dict=edit.branches dict-table=Branches ng-class={&quot;has-error&quot;:payment.branch_error} class=form-group><label>Филиал назначения</label><ui-select ng-model=edit.payment.data.branch_id ng-required=true><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"branch._id as branch in edit.branches track by branch._id\">{{branch.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=edit.payment.data.comment ng-trim=true class=form-control></textarea></div></col-responsive></div></div></div><div class=modal-footer><button ng-disabled=\"edit.saving===true\" type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button ng-disabled=\"edit.saving===true\" type=button ng-click=edit.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/payment/payment.html","<!--\nCreated by Ilyas on 17/11/20\n\n--><panel title=Платежи><button ng-click=payment.newPayment() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=!payment.selected_payment ng-click=payment.editPayment() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=payment.getPayments() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=payment.gridOptions disable-search=true></paged-table></panel>");
$templateCache.put("app/payment/view.html","<!--Created by Ilyas on 17/11/20\n--><div class=modal-header><h3>Платеж</h3></div><div class=modal-body><div class=row-striped><div class=row><div class=\"col col-xs-12 col-md-4\">Филал</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.branch.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Доукмент</div><div class=\"col col-xs-12 col-md-8\"><a ui-sref=app.docs.view({id:view.payment.document_id})>{{view.payment.document.title}}</a><p class=small>{{view.payment.document.short_desc}}</p></div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Валюта</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.currency.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Сумма</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.amount | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Дата платежа</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.payment_date | amDateFormat: \'Do MMMM YYYY\'}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Направление платежа</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.payment_direction_value.data.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Тип платежа</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.payment_type_value.data.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Статус платежа</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.payment_status_value.data.name}}</div></div><div ng-if=view.payment.branch2 class=row><div class=\"col col-xs-12 col-md-4\">Филал назначения</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.branch2.name}}</div></div><div ng-if=view.payment.contractor class=row><div class=\"col col-xs-12 col-md-4\">Контрагент</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.contractor.name}}</div></div><div ng-if=view.payment.employee class=row><div class=\"col col-xs-12 col-md-4\">Сотрудник</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.employee.user.username}}</div></div></div></div><div class=modal-footer><button ng-click=view.cancel() class=\"btn btn-default btn-sm\">Закрыть</button></div>");
$templateCache.put("app/policy/form.html","<!--\nCreated by troy on 24.11.2016.\n\n--><div class=container><!--pre {{forming.policy.insurance_data|json}}--><div class=row><div class=col-md-12><button type=button ui-sref=app.policy class=\"btn btn-warning\">Выход</button> <button type=button ng-click=forming.confirmActionSave() ng-disabled=\"!forming.policy.insurance_premium || forming.policy.insurance_premium &lt;= 0\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Возобновить</button></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{forming.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{forming.policy.client}}</span></h5></div></div><div class=row><div class=col-md-10><h5>Номер кредита:<span class=text-info> {{forming.policy.credit_no}}</span></h5></div><div class=col-md-2></div></div><div class=row><col-responsive><div class=form-group><label>Период страхования от</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=forming.today max-date=forming.policy.date_end ng-change=forming.recalculateOnEventAll() ng-click=\"forming.search.popup_to_date.opened1=true\" ng-model=forming.policy.date_start is-open=forming.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"forming.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Период страхования до</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=forming.isAnnual uib-datepicker-popup=dd.MM.yyyy min-date=forming.policy.date_start max-date=forming.finish_date ng-change=forming.recalculateOnEventAll() ng-click=\"forming.search.popup_from_date.opened=true\" ng-model=forming.policy.date_end is-open=forming.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=forming.isAnnual ng-click=\"forming.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{forming.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{forming.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{forming.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=forming.policy.insurance_data.ned class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in forming.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=forming.policy.insurance_data.ts class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in forming.policy.insurance_data.ts\"><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=forming.policy.insurance_data.ln class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in forming.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/policy/issue.html","<!--\nCreated by ilias on 07.10.2016.\n\n--><div class=container><form ng-submit=issue.confirmAction() class=from-horizontal><div class=row><div class=col-md-10><button type=button ui-sref=app.apolicy.select class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-hand-o-left\"></i> Изменить полис</button><div class=\"panel panel-default\"><div class=panel-heading><h2 style=display:inline>Ваш страховой полис</h2></div><!--.panel-body(stock-dict=\'issue.currencies\' dict-table=\'Currencies\')--><div class=panel-body><table class=\"table table-striped\"><thead></thead><tbody><tr><td>Страховщик</td><td>{{issue.product.company[0].name}}</td></tr><tr ng-if=\"issue.company.company_type == \'agent\'\"><td>Агент страховой компании</td><td>{{issue.company.name}} Телефон {{issue.company.data.phones[0]}}</td></tr><tr><td>Период действия страхового полиса</td><td>с {{issue.product.tmp_product.date_start | date:\'dd-MM-yyyy\'}} по {{issue.product.tmp_product.date_end | date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Продукт</td><td>{{issue.product.name}}</td></tr><tr><td>Страна поездки</td><td><span ng-repeat=\"x in issue.countriesView\">{{x.name}} <mark>({{x.data.name_eng}})</mark></span></td></tr><tr><td>Страховая сумма</td><td><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><label ng-if=\"issue.min_insurance!=null\">{{issue.product.insurance_amount}}<span> {{issue.currency_name}}</span></label><label ng-if=\"issue.min_insurance==null\">0</label><a data-toggle=collapse data-target=#collapse1 ng-click=issue.pdrobneeIconCnange() style=cursor:pointer class=pull-right><i ng-class=issue.pdrobneeIcon aria-hidden=true></i> Сервисы</a></h4></div><div id=collapse1 class=\"panel-collapse collapse\"><div class=panel-body><ul><li ng-repeat=\"x in issue.product.services\"><span>{{x.name}}</span></li></ul></div></div></div></td></tr><tr ng-repeat=\"x in issue.insurants\"><td>Стоимость страхового полиса ({{$index+1}}-го)</td><td><h4 ng-if=\"x.theprice!=null\">{{x.theprice}} {{issue.currency_name}} / {{(x.theprice * issue.currencyRate).toFixed(2)}} KGS</h4><span class=small>(курс валют: 1 {{issue.currency_name}}: {{issue.currencyRate}} KGS)</span><h4 ng-if=\"x.theprice==null\">0</h4></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-md-10><div class=\"panel panel-default\"><div class=panel-heading><h2>Путешественники (застрахованные)</h2></div><div class=panel-body><div ng-repeat=\"x in issue.insurants\" class=row><div class=col-md-5><div class=row><div class=col-md-6><div class=form-group><label>Фамилия<br><em>Латиницей</em></label><input type=text ng-model=x.surname ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-6><div class=form-group><label>Имя<br><em>Латиницей</em></label><input type=text ng-model=x.name ng-required=true ng-trim=true class=form-control></div></div></div></div><div class=col-md-2><div class=form-group><label><br>Паспорт №</label><input type=text ng-model=x.passport_no ng-trim=true class=form-control></div></div><div class=col-md-5><div class=form-group><label><br>Дата рождения</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=issue.reCompute(x) max-date=issue.today uib-datepicker-popup=dd.MM.yyyy ng-model=x.date_of_birth is-open=x.isOpen close-text=Закрыть current-text=Сегодня clear-text=Очистить ng-required=true class=form-control><span class=input-group-btn><button type=button ng-click=\"x.isOpen = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span><span class=input-group-btn> <button style=\"margin-left: 20px\" ng-click=issue.deleteInsurant($index) type=button class=\"btn btn-danger\"><i aria-hidden=true class=\"fa fa-times\"></i></button></span><span class=input-group-btn> <button style=\"margin-left: 20px\" ng-click=issue.changeIcon($index) popover-trigger=click popover-placement=bottom uib-popover-template=&quot;myPopoverTemplate.html&quot; popover-title=\"Условия страховки\" type=button class=\"btn btn-info\"><i style=\"font-size: 130%\" aria-hidden=true class={{issue.iconsList[$index]}}></i> Условия</button></span></div></div></div></div><div class=row><div class=col-md-2><button type=button ng-click=issue.addInsurant() class=\"btn btn-default\"><i aria-hidden=true class=\"fa fa-plus\"></i> Добавить путешественника</button></div></div></div></div></div></div><div class=row><div class=col-md-10><div class=\"panel panel-default\"><div class=panel-heading><h2>Покупатель (страхователь)</h2></div><div class=panel-body><div class=row><div class=col-md-2><div class=form-group><label>Фамилия<br><em>Кирилицей</em></label><input type=text ng-model=issue.buyer.surname ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-2><div class=form-group><label>Имя<br><em>Кирилицей</em></label><input type=text ng-model=issue.buyer.name ng-required=true ng-trim=true class=form-control></div></div><!--.col-md-3--><!--  .form-group--><!--    label--><!--      br--><!--      | Электронная почта--><!--    input.form-control(type=\'email\' ng-model=\"issue.buyer.email\" ng-required=\'true\' ng-trim=\'true\')--><!----><!--.col-md-3--><!--  .form-group--><!--    label--><!--      br--><!--      | Телефон--><!--    input.form-control(type=\'text\' ui-mask=\"0(999)999-999\" ng-model=\"issue.buyer.phone\" ng-required=\'true\' ng-trim=\'true\')\n              //.input-group.no-margin\n              //  span.input-group-btn\n              //    button.btn.btn-default(type=\"button\", ng-click=\"select.popup_delivery_date.opened=true\")\n              //      i.glyphicon.glyphicon-calendar\n              //  input.form-control(type=\"text\", ng-model=\'select.a\', uib-datepicker-popup=\"dd-MM-yyyy\", is-open=\"profile.popup_delivery_date.opened\", close-text=\"Закрыть\", current-text=\'Сегодня\', clear-text=\'Очистить\')\n              //  span.input-group-btn\n              //    button.btn.btn-default(type=\"button\" style=\"margin-left: 20px; width: 50px;\")\n              //      i.fa.fa-plus(aria-hidden=\'true\')\n              \n              --></div></div></div><div class=row><button type=submit class=\"btn btn-primary btn-sm pull-right\">Оформить полис</button></div></div></div></form></div><script type=text/ng-template id=myPopoverTemplate.html><div style=\"width: 350px;\">\n    <ul class=\"list-group\">\n      <li ng-repeat=\"factor in x.factorListing\" ng-if=\"factor.name != \'Возраст\'\" class=\"list-group-item\"><a ng-if=\"factor.description != null &amp;&amp; service.data.description != \'\'\"><i uib-tooltip=\"{{factor.description}}\" class=\"fa fa-info-circle\"></i></a><a id=\"headingOne{{$index}}\" role=\"tab\" data-toggle=\"collapse\" data-parent=\"#accordion1\" data-target=\"#collapseOnefer{{$index}}\" aria-expanded=\"false\" aria-controls=\"collapseOne\" style=\"cursor:pointer;\" class=\"panel-heading collapsed\"><i aria-hidden=\"true\" style=\"color: #2f3233; font-size: 130%;\" class=\"fa fa-chevron-down\"></i> {{factor.name}}\n          <mark><span style=\"text-decoration-color: red; text-decoration-line: underline; text-decoration-style: dotted;\">: {{x.factors[factor.name]}}</span></mark></a>\n        <div id=\"collapseOnefer{{$index}}\" role=\"tabpanel\" aria-labelledby=\"headingOne\" aria-expanded=\"false\" style=\"height: 0px;\" class=\"panel-collapse collapse\">\n          <div class=\"panel-body\">\n            <div class=\"container\">\n              <div class=\"form-group\">\n                <ui-select ng-model=\"x.factors[factor.name]\" on-select=\"issue.reCompute(x)\" ng-required=\"true\" class=\"form-control\">\n                  <ui-select-match placeholder=\"Выберите из списка\">{{$select.selected}}</ui-select-match>\n                  <ui-select-choices repeat=\"type in factor.values | orderBy\">{{type}}</ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n          </div>\n        </div>\n      </li>\n    </ul>\n  </div></script>");
$templateCache.put("app/policy/new.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=\"panel panel-default\"><div class=panel-heading><h2>Туристическая страховка</h2></div><div class=panel-body></div><div class=row><div stock-dict=policies.countries dict-table=Countries class=col-md-10><div class=form-group><label>Территория</label><ui-select ng-model=policies.pruduct.country_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}} <mark>({{$item.data.name_eng}})</mark></ui-select-match><ui-select-choices repeat=\"type._id as type in policies.countries| filterCountries:$select.search | orderBy:&quot;name&quot;\">{{type.name}} <mark>({{type.data.name_eng}})</mark></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-5><div class=form-group><label>Туда</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.today max-date=policies.pruduct.date_end ng-model=policies.pruduct.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-5><div class=form-group><label>Обратно</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.pruduct.date_start ng-model=policies.pruduct.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=col-md-4><div class=form-group><label>Количество дней</label><input type=text ng-model=policies.diffDays readonly class=form-control></div></div></div><div class=row><div class=col-md-10><div class=form-group><label style=\"visibility: hidden\">asdfsdf</label><div class=input-group><button ng-click=policies.goToSelect(policies.pruduct) type=button class=\"btn btn-primary\">Найти страховку</button></div></div></div></div></div>");
$templateCache.put("app/policy/personal.html","<!--Created by Ilyas on 17/11/20\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-success\"><div class=\"panel-heading font-bold\">Страхование жизни от несчеастных случаев</div><div class=panel-body><div class=row><col-responsive><div class=form-group><label>Страхователь</label><input type=text ng-model=select.policy.client required class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ИНН</label><input type=text ng-model=select.policy.data.inn required class=form-control></div></col-responsive></div><div class=row><col-responsive stock-dict=select.products dict-table=Product><div class=form-group><label>Наименование программы</label><ui-select ng-model=select.policy.product_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in select.products track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер кредитного договора</label><input type=text ng-model=select.policy.credit_no required class=form-control></div></col-responsive><col-responsive stock-dict=select.currencies dict-table=Currencies><div class=form-group><label>Валюта</label><ui-select ng-model=select.currency class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"currency as currency in select.currencies\">{{currency.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Период страхования от</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=select.today max-date=select.policy.date_end ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_to_date.opened1=true\" ng-model=select.policy.date_start is-open=select.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"select.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Период страхования до</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=select.isAnnual uib-datepicker-popup=dd.MM.yyyy min-date=select.policy.date_start ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_from_date.opened=true\" ng-model=select.policy.date_end is-open=select.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=select.isAnnual ng-click=\"select.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=\"checkbox form-group\"><label><input type=checkbox ng-model=select.isAnnual ng-change=select.recalculateOnEventisAnnual()> Годовой полис</label></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label ng-if=!select.isAnnual>Количество дней: {{select.diffDays}}</label><label ng-if=select.isAnnual>Количество дней: 1 год</label></div></col-responsive></div><div class=ln_solid></div><div class=row><div class=\"col-md-12 col-sm-12\"><form ng-submit=select.addCollateralLn(select.insuranceformln)><div class=row><col-responsive><div class=form-group><label>Застрахованное лицо</label><input type=text ng-model=select.insuranceformln.client required class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ИНН</label><input type=text ng-model=select.insuranceformln.inn required class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата Рождения</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_to_date.opened5=true\" ng-model=select.insuranceformln.birthday is-open=select.search.popup_to_date.opened5 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"select.search.popup_to_date.opened5=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Документ удостоверяющий личность</label><input type=text ng-model=select.insuranceformln.pasport ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=select.insuranceformln.adres ng-required=true ng-trim=true disabled class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Объект страхования</label><ui-select ng-model=select.insuranceformln.objectln ng-required=true ng-trim=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"object as object in select.insuranceobjectsln track by object._id\">{{object.name}} - {{object.rate}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=select.insuranceformln.insurance_summ ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=select.insuranceformln.insurance_premium ng-required=true ng-trim=true disabled step=0.1 min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>НСП</label><input type=number ng-model=select.insuranceformln.nsp ng-required=true ng-trim=true disabled step=0.1 min=0 class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><button type=button ng-click=select.calculatePremiumLn() class=\"btn btn-default\">Раcсчитать</button> <button type=submit class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button></div></col-responsive></div></form><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in select.collateralsln.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td><button uib-tooltip=Удалить ng-click=\"select.deleteCollateralLn(c, $index)\" class=\"btn btn-sm btn-icon btn-danger\"><i class=\"fa fa-minus\"></i></button></td></tr></tbody></table></div></div></div><div class=row><col-responsive><div class=form-group><label>Страховая сумма: {{select.policy.insurance_amountln}}</label><br><label>Страховая премия: {{select.policy.insurance_premiumln}}</label></div></col-responsive></div><br></div></div><div class=row><div class=col-md-12><div class=form-group><button ng-disabled=select.saving type=button ng-click=select.cancel() class=\"btn btn-primary m-t\">Отмена</button> <button ng-disabled=collateralForm.$invalid type=button ng-click=select.savePolicy() class=\"btn btn-primary m-t\">Сохранить</button></div></div></div></div></div></div>");
$templateCache.put("app/policy/policy.html","<div class=content><!-- Main content--><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>Полисы</h3></div><div class=box-body><form ng-submit=policy.getPolicies() class=direct-chat-msg><div class=row><col-responsive stock-dict=policy.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=policy.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in policy.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=policy.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ФИО клиента:</label><input type=text ng-model=policy.filter.client placeholder=\" Введите Фио клиента\" class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=policy.filter.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=policy.filter.date_start ng-click=\"policy.search.popup_to_date.opened=true\" is-open=policy.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policy.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=policy.filter.date_start ng-model=policy.filter.date_end ng-click=\"policy.search.popup_from_date.opened=true\" is-open=policy.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policy.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"policy.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button> <button type=button ng-click=policy.goToRealEstate() class=\"btn btn-primary\"><i class=\"fa fa-home\"></i><span> Недвижимость</span></button> <button type=button ng-click=policy.goToPersonal() class=\"btn btn-primary\"><i class=\"fa fa-plus-square\"></i><span> Личное(НС)</span></button> <button type=button ng-click=policy.goToVehicle() class=\"btn btn-primary\"><i class=\"fa fa-car\"></i><span> Транспортное средство</span></button> <button ng-click=policy.goToShow() ng-disabled=!policy.selected_policy class=\"btn btn-default\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button ng-click=policy.confirmAction(policy.selected_policy) ng-show=\"app.ua.id == policy.selected_policy.user_id &amp;&amp; ((policy.selected_policy._created |amDateFormat:\'DD-MM-yyyy\') == (policy.current_date|amDateFormat:\'DD-MM-yyyy\'))\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=policy.downloadPDF() ng-disabled=\"!policy.selected_policy || policy.selected_policy.policy_no == \'00000\' || (policy.selected_policy.data.status != \'Оформлен\' &amp;&amp; policy.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=policy.getPolicies() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div></form><paged-table options=policy.policiesGridOptions disable-search=true height=500></paged-table></div></div></div></div></div>");
$templateCache.put("app/policy/real_estate.html","<!--Created by Ilyas on 17/11/20\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-success\"><div class=\"panel-heading font-bold\">Страхование имущества</div><div class=panel-body><div class=row><col-responsive><div class=form-group><label>Страхователь</label><input type=text ng-model=select.policy.client required placeholder=\"Введите ФИО\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ИНН</label><input type=text ng-model=select.policy.data.inn required class=form-control></div></col-responsive></div><div class=row><col-responsive stock-dict=select.products dict-table=Product><div class=form-group><label>Наименование продуктов</label><ui-select ng-model=select.policy.product_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in select.products track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер кредитного договора</label><input type=text ng-model=select.policy.credit_no required class=form-control></div></col-responsive><col-responsive stock-dict=select.currencies dict-table=Currencies><div class=form-group><label>Валюта</label><ui-select ng-model=select.currency class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"currency as currency in select.currencies\">{{currency.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Период страхования от</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=select.today max-date=select.policy.date_end ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_to_date.opened1=true\" ng-model=select.policy.date_start is-open=select.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"select.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Период страхования до</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=select.isAnnual uib-datepicker-popup=dd.MM.yyyy min-date=select.policy.date_start ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_from_date.opened=true\" ng-model=select.policy.date_end is-open=select.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=select.isAnnual ng-click=\"select.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=\"checkbox form-group\"><label><input type=checkbox ng-model=select.isAnnual ng-change=select.recalculateOnEventisAnnual()> Годовой полис</label></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label ng-if=!select.isAnnual>Количество дней: {{select.diffDays}}</label><label ng-if=select.isAnnual>Количество дней: 1 год</label></div></col-responsive></div><div class=ln_solid></div><div class=row><div class=\"col-md-12 col-sm-12\"><form ng-submit=select.addCollateralNed(select.insuranceformned)><div class=row><col-responsive><div class=form-group><label>Собственник</label><input type=text ng-model=select.insuranceformned.owner ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Объект страхования</label><ui-select ng-model=select.insuranceformned.objectned ng-required=true ng-trim=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"object as object in select.insuranceobjectsned track by object._id\">{{object.name}} - {{object.rate}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=select.insuranceformned.adres ng-required=true ng-trim=true class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Действительная стоимость</label><input type=number ng-model=select.insuranceformned.coll_price ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=select.insuranceformned.insurance_summ ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=select.insuranceformned.insurance_premium ng-required=true ng-trim=true disabled class=form-control></div></col-responsive><col-responsive><div class=form-group><label>НСП</label><input type=number ng-model=select.insuranceformned.nsp ng-required=true ng-trim=true disabled class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Описание<span type=button tooltip-placement=right uib-tooltip=\"Здесь указывается описание имущества. Пример:Недвижимое имущество – квартира, жилой дом, гостиница, офисное помещение, баня ит.п.; Оборудование – Марка, модель и тип оборудования;ТМЦ – Наименование ТМЦ.\" class=\"btn btn-default btn-addon\">?</span></label><textarea rows=10 ng-required=true ng-trim=true ng-model=select.insuranceformned.description class=form-control></textarea></div></col-responsive></div><div class=row><col-responsive><div class=form-group><button type=button ng-click=select.calculatePremiumNed() class=\"btn btn-default\">Раcсчитать</button> <button type=submit class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button></div></col-responsive></div></form><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in select.collateralsned.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td><button uib-tooltip=Удалить ng-click=\"select.deleteCollateralNed(c, $index)\" class=\"btn btn-sm btn-icon btn-danger\"><i class=\"fa fa-minus\"></i></button></td></tr></tbody></table></div></div></div><div class=row><col-responsive><div class=form-group><label>Страховая сумма: {{select.policy.insurance_amountned}}</label><br><label>Страховая премия: {{select.policy.insurance_premiumned}}</label></div></col-responsive></div><br></div></div><div class=row><div class=col-md-12><div class=form-group><button ng-disabled=select.saving type=button ng-click=select.cancel() class=\"btn btn-primary m-t\">Отмена</button> <button ng-disabled=collateralForm.$invalid type=button ng-click=select.savePolicy() class=\"btn btn-primary m-t\">Сохранить</button></div></div></div></div></div></div>");
$templateCache.put("app/policy/select.html","<!--Created by Ilyas on 17/11/20\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Создание полиса</div><div class=panel-body><div class=row><col-responsive><div class=form-group><label>Страхователь</label><input type=text ng-model=select.policy.client required class=form-control></div></col-responsive></div><div class=row><col-responsive stock-dict=select.products dict-table=Product><div class=form-group><label>Наименование программы кредитования</label><ui-select ng-model=select.policy.product_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in select.products track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер кредитного договора</label><input type=text ng-model=select.policy.credit_no required class=form-control></div></col-responsive><col-responsive stock-dict=select.currencies dict-table=Currencies><div class=form-group><label>Валюта</label><ui-select ng-model=select.currency class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"currency as currency in select.currencies\">{{currency.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Период страхования от</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=select.today max-date=select.policy.date_end ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_to_date.opened1=true\" ng-model=select.policy.date_start is-open=select.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"select.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Период страхования до</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=select.isAnnual uib-datepicker-popup=dd.MM.yyyy min-date=select.policy.date_start max-date=select.finish_date ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_from_date.opened=true\" ng-model=select.policy.date_end is-open=select.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=select.isAnnual ng-click=\"select.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=\"checkbox form-group\"><label><input type=checkbox ng-model=select.isAnnual ng-change=select.recalculateOnEventisAnnual()> Годовой полис</label></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label ng-if=!select.isAnnual>Количество дней: {{select.diffDays}}</label><label ng-if=select.isAnnual>Количество дней: 1 год</label></div></col-responsive></div><div class=row><col-responsive ng-repeat=\"insuranceType in select.insurancetypes\"><div class=form-group><i ng-class=insuranceType.data.class></i><div class=checkbox><label class=i-checks><input type=checkbox ng-model=select.types[insuranceType.name] ng-required=true ng-trim=true ng-change=\"select.showPanel(insuranceType, select.types[insuranceType.name])\"><i></i> {{insuranceType.name}}</label></div></div></col-responsive></div><div class=ln_solid></div><div ng-show=\"select.nedPanel == true\" class=row><div class=\"col-md-12 col-sm-12\"><div class=\"panel panel-success\"><div class=panel-heading><strong><big>СТРАХОВАНИЕ ИМУЩЕСТВА</big></strong></div><div class=panel-body><form ng-submit=select.addCollateralNed(select.insuranceformned)><div class=row><col-responsive><div class=form-group><label>Собственник</label><input type=text ng-model=select.insuranceformned.owner ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Объект страхования</label><ui-select ng-model=select.insuranceformned.objectned ng-required=true ng-trim=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"object as object in select.insuranceobjectsned track by object._id\">{{object.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=select.insuranceformned.adres ng-required=true ng-trim=true class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Действительная стоимость</label><input type=number ng-model=select.insuranceformned.coll_price ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=select.insuranceformned.insurance_summ ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=select.insuranceformned.insurance_premium ng-required=true ng-trim=true disabled class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Описание<span type=button tooltip-placement=right uib-tooltip=\"Здесь указывается описание имущества. Пример:Недвижимое имущество – квартира, жилой дом, гостиница, офисное помещение, баня ит.п.; Оборудование – Марка, модель и тип оборудования;ТМЦ – Наименование ТМЦ.\" class=\"btn btn-default btn-addon\">?</span></label><textarea rows=10 ng-required=true ng-trim=true ng-model=select.insuranceformned.description class=form-control></textarea></div></col-responsive></div><div class=row><col-responsive><div class=form-group><button type=button ng-click=select.calculatePremiumNed() class=\"btn btn-default\">Раcсчитать</button> <button type=submit class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button></div></col-responsive></div></form><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in select.collateralsned.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td><button uib-tooltip=Удалить ng-click=\"select.deleteCollateralNed(c, $index)\" class=\"btn btn-sm btn-icon btn-danger\"><i class=\"fa fa-minus\"></i></button></td></tr></tbody></table></div></div></div><div class=row><col-responsive><div class=form-group><label>Страховая сумма: {{select.policy.insurance_amountned}}</label><br><label>Страховая премия: {{select.policy.insurance_premiumned}}</label></div></col-responsive></div><br></div></div></div></div><div ng-show=\"select.lnPanel == true\" class=row><div class=\"col-md-12 col-sm-12\"><div class=\"panel panel-warning\"><div class=panel-heading><strong><big>СТРАХОВАНИЕ ЖИЗНИ ОТ НЕСЧАСТНЫХ СЛУЧАЕВ</big></strong></div><div class=panel-body><form ng-submit=select.addCollateralLn(select.insuranceformln)><div class=row><col-responsive><div class=form-group><label>Застрахованное лицо</label><input type=text ng-model=select.insuranceformln.client required class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата Рождения</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_to_date.opened5=true\" ng-model=select.insuranceformln.birthday is-open=select.search.popup_to_date.opened5 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"select.search.popup_to_date.opened5=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Документ удостоверяющий личность</label><input type=text ng-model=select.insuranceformln.pasport ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=select.insuranceformln.adres ng-required=true ng-trim=true disabled class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=select.insuranceformln.insurance_summ ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=select.insuranceformln.insurance_premium ng-required=true ng-trim=true disabled class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><button type=button ng-click=select.calculatePremiumLn() class=\"btn btn-default\">Раcсчитать</button> <button type=submit class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button></div></col-responsive></div></form><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in select.collateralsln.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td><button uib-tooltip=Удалить ng-click=\"select.deleteCollateralLn(c, $index)\" class=\"btn btn-sm btn-icon btn-danger\"><i class=\"fa fa-minus\"></i></button></td></tr></tbody></table></div></div></div><div class=row><col-responsive><div class=form-group><label>Страховая сумма: {{select.policy.insurance_amountln}}</label><br><label>Страховая премия: {{select.policy.insurance_premiumln}}</label></div></col-responsive></div><br></div></div></div></div><div ng-show=\"select.tsPanel == true\" class=row><div class=\"col-md-12 col-sm-12\"><div class=\"panel panel-info\"><div class=panel-heading><strong><big>СТРАХОВАНИЕ ТРАНСПОРТНЫХ СРЕДСТВ</big></strong></div><div class=panel-body><form ng-submit=select.addCollateralTs(select.insuranceformts)><div class=row><col-responsive><div class=form-group><label>Объект страхования</label><ui-select ng-model=select.insuranceformts.objectts class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"object as object in select.insuranceobjectsts track by object._id\">{{object.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Марка, модель ТС</label><input type=text ng-model=select.insuranceformts.model ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Гос. регистрационный №;</label><input type=text ng-model=select.insuranceformts.gosnumber ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Номер кузова/ шасси</label><input type=text ng-model=select.insuranceformts.number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=select.car_year_issue dict-table=Enums dict-filter={name:&quot;year_issue&quot;}><div class=form-group><label>Год выпуска</label><ui-select ng-model=select.insuranceformts.year_issue ng-required=true ng-trim=true class=form-control><ui-select-match>{{$select.selected.data.key}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in select.car_year_issue\">{{type.data.key}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=select.insuranceformts.adres ng-required=true ng-trim=true disabled class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=select.insuranceformts.insurance_summ ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Действительная стоимость</label><input type=number ng-model=select.insuranceformts.coll_price ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=select.insuranceformts.insurance_premium ng-required=true ng-trim=true disabled class=form-control></div></col-responsive><div class=\"col col-xs-12 col-sm-8 col-md-8\"><div class=form-group><label>Уполномоченные водители</label><input type=text ng-model=select.insuranceformts.driver disabled class=form-control></div></div></div><div class=row><col-responsive><div class=form-group><button type=button ng-click=select.calculatePremiumTs() class=\"btn btn-default\">Раcсчитать</button> <button type=submit class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button></div></col-responsive></div></form><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in select.collateralsts.ts\"><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td><td><button uib-tooltip=Удалить ng-click=\"select.deleteCollateralTs(c, $index)\" class=\"btn btn-sm btn-icon btn-danger\"><i class=\"fa fa-minus\"></i></button></td></tr></tbody></table></div></div></div><div class=row><col-responsive><div class=form-group><label>Страховая сумма: {{select.policy.insurance_amountts}}</label><br><label>Страховая премия: {{select.policy.insurance_premiumts}}</label></div></col-responsive></div><br></div></div></div></div><div class=row><div class=form-group><button ng-disabled=select.saving type=button ui-sref=app.policy class=\"btn btn-primary m-t\">Отмена</button> <button ng-disabled=collateralForm.$invalid type=button ng-click=select.savePolicy() class=\"btn btn-primary m-t\">Сохранить</button></div></div></div></div></div>");
$templateCache.put("app/policy/show.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=modal-content><div class=modal-header><div class=row><div class=col-md-12><div style=\"text-color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"text-color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"text-color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"text-color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"text-color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=modal-body><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title><h4 style=display:inline-block></h4><span>Номер полиса:</span> <input id=foo value={{show.policy.policy_no}} ng-disabled=true> <button ngclipboard=\"\" data-clipboard-target=#foo class=btn><i alt=\"Copy to clipboard\" class=\"fa fa-copy\"></i></button></h3></div><div class=box-body><div class=\"row m-b\"><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{show.policy.client}}</span></h5></div></div><div class=\"row m-b\"><div class=col-md-4><h5>Номер кредита:<span class=text-info> {{show.policy.credit_no}}</span></h5></div><div class=col-md-8><h5>Наименование программы кредитования:<span class=text-info>{{show.policy.product}}</span></h5></div></div><div class=\"row m-b\"><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|amDateFormat:\'DD-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|amDateFormat:\'DD-MM-yyyy\'}}</span></h5></div></div><div class=\"row m-b\"><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{show.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=show.policy.insurance_data.ned class=\"row m-b\"><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th><th>Описание</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td>{{c.description}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ts class=\"row m-b\"><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ts\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ln class=\"row m-b\"><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>ИНН</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.inn}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.data.file class=\"row m-b\"><div class=col-md-4><a href=\"{{show.api + \'docs/file/sertificates/\' +show.policy.data.file}}\" target=_blank>Скачать сертификат</a></div></div></div></div></div><div class=modal-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button><!--button.btn.btn-default.pull-right(type=\'button\'  ng-click=\"show.goToForm()\" ng-if=\"show.policy.data.status && show.policy.data.status == \'Истек\'\" ng-disabled=\"show.policy.data.status != \'Истек\'\")--><!--  i.fa.fa-refresh(aria-hidden=\'true\')--><!--  |   Возобновить--> <button type=button ng-click=show.confirmAction() ng-if=\"(show.policy.data.status &amp;&amp; show.policy.data.status == \'Оформлен\' &amp;&amp; app.ua.id == show.policy.user_id &amp;&amp; ((show.policy._created | amDateFormat:\'DD-MM-yyyy\') == (show.current_date | amDateFormat:\'DD-MM-yyyy\'))) || app.ua.role &gt;= 10\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=show.goToForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=show.confirmActionForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div>");
$templateCache.put("app/policy/vehicle.html","<!--Created by Ilyas on 17/11/20\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-success\"><div class=\"panel-heading font-bold\">Страхование транспортных средств</div><div class=panel-body><div class=row><col-responsive><div class=form-group><label>Страхователь</label><input type=text ng-model=select.policy.client required class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ИНН</label><input type=text ng-model=select.policy.data.inn required class=form-control></div></col-responsive></div><div class=row><col-responsive stock-dict=select.products dict-table=Product><div class=form-group><label>Наименование программы</label><ui-select ng-model=select.policy.product_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in select.products track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер кредитного договора</label><input type=text ng-model=select.policy.credit_no required class=form-control></div></col-responsive><col-responsive stock-dict=select.currencies dict-table=Currencies><div class=form-group><label>Валюта</label><ui-select ng-model=select.currency class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"currency as currency in select.currencies\">{{currency.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Период страхования от</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=select.today max-date=select.policy.date_end ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_to_date.opened1=true\" ng-model=select.policy.date_start is-open=select.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"select.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Период страхования до</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=select.isAnnual uib-datepicker-popup=dd.MM.yyyy min-date=select.policy.date_start ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_from_date.opened=true\" ng-model=select.policy.date_end is-open=select.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=select.isAnnual ng-click=\"select.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=\"checkbox form-group\"><label><input type=checkbox ng-model=select.isAnnual ng-change=select.recalculateOnEventisAnnual()> Годовой полис</label></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label ng-if=!select.isAnnual>Количество дней: {{select.diffDays}}</label><label ng-if=select.isAnnual>Количество дней: 1 год</label></div></col-responsive></div><div class=ln_solid></div><div class=row><div class=\"col-md-12 col-sm-12\"><form ng-submit=select.addCollateralTs(select.insuranceformts)><div class=row><col-responsive><div class=form-group><label>Объект страхования</label><ui-select ng-model=select.insuranceformts.objectts class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"object as object in select.insuranceobjectsts track by object._id\">{{object.name}} - {{object.rate}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Марка, модель ТС</label><input type=text ng-model=select.insuranceformts.model ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Гос. регистрационный №;</label><input type=text ng-model=select.insuranceformts.gosnumber ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Номер кузова/ шасси</label><input type=text ng-model=select.insuranceformts.number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=select.car_year_issue dict-table=Enums dict-filter={name:&quot;year_issue&quot;}><div class=form-group><label>Год выпуска</label><ui-select ng-model=select.insuranceformts.year_issue ng-required=true ng-trim=true class=form-control><ui-select-match>{{$select.selected.data.key}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in select.car_year_issue\">{{type.data.key}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=select.insuranceformts.adres ng-required=true ng-trim=true disabled class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=select.insuranceformts.insurance_summ ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Действительная стоимость</label><input type=number ng-model=select.insuranceformts.coll_price ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=select.insuranceformts.insurance_premium ng-required=true ng-trim=true disabled class=form-control></div></col-responsive><col-responsive><div class=form-group><label>НСП</label><input type=number ng-model=select.insuranceformts.nsp ng-required=true ng-trim=true disabled class=form-control></div></col-responsive><div class=\"col col-xs-12 col-sm-8 col-md-8\"><div class=form-group><label>Уполномоченные водители</label><input type=text ng-model=select.insuranceformts.driver disabled class=form-control></div></div></div><div class=row><col-responsive><div class=form-group><button type=button ng-click=select.calculatePremiumTs() class=\"btn btn-default\">Раcсчитать</button> <button type=submit class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button></div></col-responsive></div></form><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in select.collateralsts.ts\"><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td><td><button uib-tooltip=Удалить ng-click=\"select.deleteCollateralTs(c, $index)\" class=\"btn btn-sm btn-icon btn-danger\"><i class=\"fa fa-minus\"></i></button></td></tr></tbody></table></div></div></div><div class=row><col-responsive><div class=form-group><label>Страховая сумма: {{select.policy.insurance_amountts}}</label><br><label>Страховая премия: {{select.policy.insurance_premiumts}}</label></div></col-responsive></div><br></div></div><div class=row><div class=col-md-12><div class=form-group><button ng-disabled=select.saving type=button ng-click=select.cancel() class=\"btn btn-primary m-t\">Отмена</button> <button ng-disabled=collateralForm.$invalid type=button ng-click=select.savePolicy() class=\"btn btn-primary m-t\">Сохранить</button></div></div></div></div></div></div>");
$templateCache.put("app/policy/view.html","<div class=container><div class=\"panel panel-default\"><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{view.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{view.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{view.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{view.policy.insurance_amount}} {{view.currency_name}}</span></h5></div><div class=col-md-5><h5>Страховая премия :<span class=text-info> {{view.policy.insurance_premium}} {{view.currency_name}} / {{view.policy.data.insurance_premium_kgs}} KGS</span></h5></div></div><div class=row><div class=col-md-10><h5>Страны пребывания:<span ng-repeat=\"country_id in view.policy.insurance_data.country_id\"><span ng-repeat=\"country in view.countries| filter:{_id:country_id}\" class=text-info> {{country.name}} <mark>({{country.data.name_eng}})</mark></span></span></h5></div><div class=col-md-2><h5></h5></div></div><div class=row><div class=col-md-10><h5>Страховая компания:<span class=text-info> {{view.product.company[0].name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Продукт:<span class=text-info> {{view.product.name}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><div class=col-md-10><h5>ФИО Клиента:<span class=text-info> {{view.policy.client.surname}} {{view.policy.client.name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Дата рождения:<span class=text-info> {{view.policy.client.date_of_birth|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Номер паспорта:<span class=text-info> {{view.policy.client.passport_no}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div stock-dict=view.services dict-table=Services class=row><ul style=\"background-color: gray\" class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer><h2><b>Факторы</b></h2></a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer><h2><b>Сервисы</b></h2></a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"(key, value) in view.policy.insurance_data.factors\"><td>{{key}}</td><td>{{value}}</td></tr></tbody></table></div><div id=service class=\"tab-pane fade\"><ul class=list-group><li ng-repeat=\"service_id in view.product.services_id\" class=list-group-item><span ng-repeat=\"service in view.services | filter:{_id:service_id}\">- {{service.name}}</span></li></ul></div></div></div></div></div></div></div><div class=panel-footer><button type=button ui-sref=app.apolicy.list class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=view.downloadPDF() ng-if=\"view.policy.policy_no != \'00000\'\" ng-disabled=\"view.policy.policy_no == \'00000\' || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=view.confirmAction() ng-if=\"view.policy.data.status &amp;&amp; view.policy.data.status == \'Оформлен\'\" ng-disabled=\"!view.policy.data.status || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=view.confirmActionTerm() ng-if=\"view.policy.data.status &amp;&amp; view.policy.data.status == \'Оформлен\'\" ng-disabled=\"!view.policy.data.status || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-thumbs-o-down\"></i> Расторгнуть</button> <button type=button ng-click=view.goToForm() ng-if=\"view.policy.data.status != \'Истек\' &amp;&amp; view.policy.data.status != \'Оформлен\' &amp;&amp; view.policy.data.status != \'Испорчен\' &amp;&amp; view.policy.data.status != \'Расторгнут\'\" ng-disabled=\"view.policy.data.status == \'Оформлен\' || view.policy.data.status == \'Испорчен\'|| view.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=view.confirmActionForm() ng-if=\"view.policy.data.status != \'Истек\' &amp;&amp; view.policy.data.status != \'Оформлен\' &amp;&amp; view.policy.data.status != \'Испорчен\' &amp;&amp; view.policy.data.status != \'Расторгнут\'\" ng-disabled=\"view.policy.data.status == \'Оформлен\' || view.policy.data.status == \'Испорчен\'|| view.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div>");
$templateCache.put("app/product/new.html","<!--\nCreated by troy on 13.10.2016.\n\n--><panel title=Продукт><wizard hide-indicators=false indicators-position=top><wz-step wz-title=\"Основные данные\"><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.product class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Основные данные</h2><!--pre.text-left {{new_product.new_product|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next=\"import.read()\" ng-disabled=\"!import.fileData\") Дальше--><a wz-next=new_product.saveProduct() class=\"btn btn-success\"><i aria-hidden=true class=\"fa fa-long-arrow-right\"></i></a></div></div></div><br><div class=form-group><label for=first-name class=\"control-label col-md-3 col-sm-3 col-xs-12\">Название<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input id=first-name type=text ng-model=new_product.new_product.name class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label stock-dict=new_product.insurancetypes dict-table=InsuranceTypes class=\"control-label col-md-3 col-sm-3 col-xs-12\">Вид страхования<span class=required>*</span></label><div class=\"col-md-3 col-sm-3 col-xs-12\"><ui-select ng-model=new_product.new_product.insurance_type ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type.code as type in new_product.insurancetypes track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></div><div class=form-group><label for=middle-name class=\"control-label col-md-3 col-sm-3 col-xs-12\">Начало</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"input-group no-margin\"><input id=middle-name type=text min-date=new_product.today max-date=new_product.new_product.date_end uib-datepicker-popup=dd-MM-yyyy ng-click=\"profile.popup_delivery_date.opened=true\" ng-model=new_product.new_product.date_start is-open=profile.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=form-group><label for=middle-name2 class=\"control-label col-md-3 col-sm-3 col-xs-12\">Конец</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"input-group no-margin\"><input id=middle-name2 type=text uib-datepicker-popup=dd-MM-yyyy min-date=new_product.new_product.date_start ng-click=\"profile.popup_delivery_date.opened1=true\" ng-model=new_product.new_product.date_end is-open=profile.popup_delivery_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=form-group><label for=middle-name22 class=\"control-label col-md-3 col-sm-3 col-xs-12\">Описание</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=form-group><textarea id=middle-name22 rows=4 ng-model=new_product.new_product.description class=form-control></textarea></div></div></div></form></wz-step><wz-step wz-title=Сервисы><div dynamic=html></div><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.product class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Сервисы</h2><!--pre.text-left {{new_product.new_product|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next ng-disabled=\"import.alerts.length>0\") Дальше--> <!--a.btn.btn-primary(wz-previous=\"import.clear()\") Назад--><a wz-previous=import.clear() class=\"btn btn-primary\"><i aria-hidden=true class=\"fa fa-long-arrow-left\"></i></a><a wz-next=new_product.saveProduct() class=\"btn btn-success\"><i aria-hidden=true class=\"fa fa-long-arrow-right\"></i></a></div></div></div><br><div class=row><div stock-dict=new_product.tmp_services dict-table=Services class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Сервисы</label><div class=input-group><ui-select ng-model=new_product.new_product.services_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in new_product.tmp_services | filter:{name:$select.search} | orderBy:&quot;name&quot;\">{{type.name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened1=true\" style=visibility:hidden ng-disabled=true class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></form></wz-step><wz-step wz-title=Факторы><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.product class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Дополнительные факторы</h2><!--pre.text-left {{new_product.current_F|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next ng-disabled=\"import.alerts.length>0\") Дальше--> <!--a.btn.btn-primary(wz-previous) Назад--><a wz-previous class=\"btn btn-primary\"><i aria-hidden=true class=\"fa fa-long-arrow-left\"></i></a><a ng-click=new_product.confirmActionFinish() class=\"btn btn-success\">Готово</a></div></div></div><br><div class=row><div class=col-md-8><div class=row><div stock-dict=new_product.tmp_factors dict-table=Factors class=col-md-10><div class=form-group><label>Выбрать фактор</label><ui-select ng-model=new_product.current_F.factor on-select=new_product.clearFactorValues() ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in new_product.tmp_factors track by type._id | orderBy:&quot;name&quot;\">{{type.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-10><div class=form-group><label>Коэффициент</label><input type=number ng-model=new_product.current_F.coefficient class=form-control><!--coefficient_type--></div></div></div><div class=row><div stock-dict=new_product.tmp_coefficients dict-table=Enums dict-filter={name:&quot;coefficient_type&quot;} class=col-md-10><div class=form-group><label>Вид коэффициента</label><ui-select ng-model=new_product.current_F.coefficient_type class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in new_product.tmp_coefficients track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-md-10 pull-left\"><div class=radio><label><input type=radio name=optradio ng-model=new_product.current_F.is_default ng-value=false> Опциональный</label></div><div class=radio><label><input type=radio name=optradio ng-model=new_product.current_F.is_default ng-value=true checked> Включен по умолчанию</label></div></div></div></div><div class=\"col-md-4 pull-left\"><div class=form-group><label>Значения фактора</label><ui-select ng-model=new_product.current_F.values ng-required=true multiple class=form-control><ui-select-match>{{$item}}</ui-select-match><ui-select-choices repeat=\"type in new_product.current_F.factor.values| filter:$select.search| filter:new_product.factorValueFilter | orderBy:new_product.sortFactorValues\">{{type}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-12><button type=button ng-click=new_product.confirmActionF() class=\"btn btn-success btn-sm pull-right\">Сохранить фактор</button></div></div><span ng-init=new_product.initMS2() style=display:none></span></form><h2>Список факторов</h2><div style=\"height:200px; overflow-y:auto\" class=panel-group><div ng-repeat=\"x in new_product.factorListTS track by x.factor_name\" class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a data-toggle=collapse data-target=#collapse22{{$index}} class=\"btn btn-info\"><i aria-hidden=true class=\"fa fa-chevron-down\"></i><!--span(ng-repeat=\"y in x.countries.items\")  {{$index+1}}.{{y.name}}--> {{x.factor_name}}</a> <button type=button ng-click=new_product.confirmActionFDeleteAll(x) class=\"btn btn-danger btn-sm pull-right\"><span class=\"glyphicon glyphicon-remove\"></span> Remove</button></h4></div><panel-collapse id=collapse22{{$index}} class=collapse><div class=panel-body><div class=row><div class=\"col-md-6 col-sm-6 col-xs-6\"><table class=\"table table-striped\"><thead><tr><th>Значения</th><th>Коэффициент</th><th>Тип коэффициента</th><th>По умолчанию</th><th></th></tr></thead><tbody><tr ng-repeat=\"y in x.data\"><td><span ng-repeat=\"z in y.values\">{{$index + 1}}: \"{{z}}\",<br></span></td><td>{{y.coefficient}}</td><td>{{y.coefficient_type}}</td><td>{{y.is_default}}</td><td><button type=button ng-click=new_product.confirmActionFdelete($index,y,x) class=\"btn btn-danger btn-sm pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr></tbody></table></div></div></div></panel-collapse></div></div></wz-step></wizard></panel><script type=text/ng-template id=myPopoverTemplate.html><div style=\"max-width: 200px; max-height: 500px; overflow-y: auto;\">\n    <ul class=\"list-group\">\n      <li ng-repeat=\"y in x.countries\" class=\"list-group-item\">\n        {{$index+1}}: \"{{y.name}}\"\n      </li>\n    </ul>\n  </div></script>");
$templateCache.put("app/product/product.html","<!--Created by Ilyas on 17/11/20\n--><div class=conten><panel title=Продукты><!--button.btn.btn-primary.btn-sm(ng-click=\'product.newProduct()\') Добавить--> <button ui-sref=app.product_new class=\"btn btn-primary btn-xs\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!product.selected_product\' ng-click=\'product.editProduct()\')--> <button ng-click=product.gotoedit(product.selected_product) ng-disabled=\"product.selected_product == null\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=product.gotoview(product.selected_product) ng-disabled=\"product.selected_product == null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button ng-click=product.confirmAction() ng-disabled=\"product.selected_product == null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-trash\"></i><span> Удалить</span></button> <button ng-click=product.getProducts() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=product.productsGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/product/view.html","<!--\nCreated by troy on 28.11.2016.\n\n--><div class=container><button type=button ui-sref=app.product class=\"btn btn-warning\"><i aria-hidden=true class=\"fa fa-hand-o-left\"></i> Назад</button><ul class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer>Основные Данные</a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer>Сервисы</a></li><li><a data-toggle=tab data-target=#factor style=cursor:pointer>Факторы</a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><hr><div class=row><div class=col-md-7><table class=\"table table-striped\"><tbody><tr><td>Название продукта</td><td>{{view_product.product.name}}</td></tr><tr><td>Компания продукта</td><td>{{view_product.product.company.name}}</td></tr><tr><td>Код продукта</td><td>{{view_product.product.code}}</td></tr><tr><td>Тип страхования</td><td>{{view_product.product.insurance_type}}</td></tr><tr><td>Начало</td><td>{{view_product.toDate(view_product.product.date_start)|date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Конец</td><td>{{view_product.toDate(view_product.product.date_end)|date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Описание</td><td>{{view_product.product.description}}</td></tr></tbody></table></div></div></div><div id=service class=\"tab-pane fade\"><hr><ul class=list-group><li ng-repeat=\"service in view_product.product.services\" class=list-group-item>{{$index + 1}}. {{service.name}}</li></ul></div><div id=factor class=\"tab-pane fade\"><hr><table class=\"table table-striped\"><thead><tr class=row><th class=col-md-3>Фактор</th><th class=col-md-1>Коэффицент</th><th class=col-md-2>Тип коэффицента</th><th class=col-md-6>Значения</th></tr></thead><tbody><tr ng-repeat=\"factor in view_product.product.factors\" class=row><td class=col-md-3>{{factor.factor.name}}</td><td class=col-md-1>{{factor.coefficient}}</td><td class=col-md-2>{{factor.coefficient_type}}</td><td class=col-md-6><span ng-repeat=\"value in factor.values\"><span ng-if=\"factor.factor.usage != \'age\'\">{{$index + 1}}).</span><span> {{value}}</span><br ng-if=\"($index + 1)%4 == 0\"></span></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/profile/avatar.html","<!--\nCreated by User on 9/22/2016.\n\n--><div class=modal-header><h3>{{\'Радактирование аватара\' | translate}}</h3></div><div class=modal-body><div class=cropArea><img-crop image=avatar.image result-image=avatar.result_image area-type=square></img-crop></div></div><div class=modal-footer><button ng-click=avatar.cancel() class=\"btn btn-default btn-sm\">{{\'Отмена\' | translate}}</button> <button ng-click=avatar.ok() class=\"btn btn-primary btn-sm\">{{\'Сохранить\' | translate}}</button></div>");
$templateCache.put("app/profile/edit.html","<div class=content><div class=\"box box-primary\"><div class=\"box-header font-bold\">{{\'Мой профиль\' | translate}}</div><div class=box-body><button ui-sref=app.dashboard class=\"btn btn-default pull-right\">{{\'Назад\'| translate}}</button><div class=content><div class=row><div class=\"col col-xs-12 col-lg-3\"><h4>{{ \'Аватар пользователя\' | translate }}</h4><p>{{ \'Здесь вы можете поменять ваш аватар или удалить\' | translate }}</p></div><div flow-init={singleFile:true} class=\"col col-xs-12 col-lg-9\"><div class=\"clearfix pull-left\"><img ng-src={{app.api}}{{edit.profile.data.image}} class=profile-image-lg></div><h5>{{ \'Загрузить новый аватар\' | translate }}</h5><span flow-btn flow-file-added=\"edit.imageSelected($event, $flow, $file)\" class=\"btn btn-secondary margin-right-8\">{{ \'Выбрать файл...\' | translate}}</span><span>{{$flow.files[0].name}}</span><hr><btn ng-click=\"edit.profile.data.image=&quot;image/user/default/user_icon.png&quot;\" class=\"btn btn-secondary\">{{\'Удалить аватар\'|translate}}</btn></div></div><div class=ln_solid></div><div class=row><div class=\"col col-xs-12 col-lg-3\"><h4>{{\'Основные параметры\' | translate }}</h4><p>{{\'Эта информация доступна в вашем профиле\' | translate }}</p></div><div class=\"col col-xs-12 col-lg-9\"><form ng-submit=edit.putData() class=form-horizontal><div class=form-group><label>{{\'E-mail\'| translate}}</label><input type=text ng-model=edit.profile.email ng-trim=true ng-required=true class=form-control></div><div class=form-group><label>{{\'Фамилия\' | translate }}</label><input type=text ng-model=edit.profile.data.surname ng-trim=true class=form-control></div><div class=form-group><label>{{ \'Имя\' | translate}}</label><input type=text ng-model=edit.profile.data.name ng-trim=true class=form-control></div><div class=form-group><label>{{ \'Отчество\' | translate}}</label><input type=text ng-model=edit.profile.data.middlename ng-trim=true class=form-control></div><div class=form-group><label>{{ \'Адрес\' | translate }}</label><input type=text ng-model=edit.profile.data.address ng-trim=true class=form-control></div><div class=form-group><label>{{ \'Мобильный телефон\' | translate }}</label><input type=text ng-model=edit.profile.data.mobile ng-trim=true class=form-control></div><div class=form-group><label>{{ \'Рабочий телефон\' | translate }}</label><input type=text ng-model=edit.profile.data.phone ng-trim=true class=form-control></div><div class=form-group><label>{{ \'Дата рождения\' | translate }}</label><fsa-date ng-model=edit.profile.birthday required></fsa-date></div><button ng-disabled=!edit.isEdited() class=\"btn btn-success\">{{\'Сохранить изменения\'|translate}}</button></form></div></div><div class=ln_solid></div><div class=row><div class=\"col col-xs-12 col-lg-3\"><h4>{{\'Сменить пароль\'| translate}}</h4><p>{{\'Для смены пароля заполните все поля\'| translate}}</p></div><div class=\"col col-xs-12 col-lg-9\"><form ng-submit=edit.changePassword() class=form-horizontal><div class=form-group><label>{{\'Текущий пароль\'|translate}}</label><input type=password ng-model=edit.profile.password ng-required=true class=form-control></div><div class=form-group><label class=margin-right-8>{{\'Новый пароль\'| translate}}</label><span ng-show=edit.profile.new_password><span ng-class=\"{&quot;success&quot;:edit.passwordLevel() &gt; 0}\" class=\"indicator danger\"></span><span ng-class=\"{&quot;success&quot;:edit.passwordLevel() &gt; 1}\" class=\"indicator danger\"></span><span ng-class=\"{&quot;success&quot;:edit.passwordLevel() &gt; 2}\" class=\"indicator danger\"></span></span> <input type=password ng-model=edit.profile.new_password ng-required=true class=form-control></div><div class=form-group><label class=margin-right-8>{{\'Повтор нового пароля\'|translate}}</label><span ng-if=edit.passwordConfirmed() class=\"glyphicon glyphicon-ok text-success\"></span> <input type=password ng-model=edit.profile.confirm_password ng-required=true class=form-control></div><button ng-disabled=!edit.canChangePassword() class=\"btn btn-warning\">{{\'Сменить пароль\'|translate}}</button></form></div></div></div></div></div></div>");
$templateCache.put("app/profile/profile.html","<!--\nCreated by troy on 13.09.2016.\n\n--><ui-view></ui-view>");
$templateCache.put("app/profile/view.html","<!--Created by troy on 09.09.2016.\n--><div ng-controller=\"ProfileViewController as profile\" class=container><div class=ln_solid></div><div class=\"row-striped row-v-padding\"><div class=col-md-5><h3>Авторизация</h3><div class=\"well well-sm\"><div class=row><!--.col-md-4--><!--  h1 Picture--><div class=col-md-12><div class=form-group><div class=input-group><input ng-model=profile.profile.username type=text placeholder=\"Имя пользователя\" disabled class=form-control><span class=input-group-btn><button type=button ng-click=profile.changeUsername() class=\"btn btn-secondary\"><span class=\"glyphicon glyphicon-pencil\"></span></button></span></div></div><div class=form-group><div class=input-group><input ng-model=profile.profile.email type=text placeholder=Email disabled class=form-control><span class=input-group-btn><button type=button ng-click=profile.changeEmail() class=\"btn btn-secondary\"><span class=\"glyphicon glyphicon-pencil\"></span></button></span></div></div><button type=button ng-click=profile.changePassword() class=\"btn btn-primary btn-sm\">Изменить Пароль</button></div><div class=col-md-6></div></div></div></div><div class=col-md-7><h3>Личные данные</h3><div class=\"well well-sm\"><div class=row><div class=col-md-12><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Фамилия</b></h5><div class=col-md-8><h5 ng-bind=profile.profile.data.surname></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Имя</b></h5><div class=col-md-8><h5 ng-bind=profile.profile.data.name></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Отчество</b></h5><div class=col-md-8><h5 ng-bind=profile.profile.data.middleName></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Адрес</b></h5><div class=col-md-8><h5 ng-bind=profile.profile.data.address></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Дата рждения</b></h5><div class=col-md-8><h5 ng-bind=\"profile.profile.data.birthDate | date:\'dd-MM-yyyy\'\"></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Телефон</b></h5><div class=col-md-8><h5><span ng-repeat=\"x in profile.profile.data.phones\"><span ng-if=$index&gt;0>{{\" \"+\"; \"}}</span><span>{{x}}</span></span></h5></div></div></div><div class=ln_solid></div><div class=row><button type=button ui-sref=app.profile.edit class=\"btn btn-primary btn-sm pull-right\">Изменить</button></div></div></div></div></div></div><div class=ln_solid><script type=text/ng-template id=changePassword.html><form ng-submit=\"$ctrl.passwordSave()\">\n        <div class=\"modal-header\">\n          <h3>Изменение пароля</h3>\n          <pre>{{$ctrl.password|json}}</pre>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Текущий пароль</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.currentPswd\" type=\"password\" minlength=\"3\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Новый пароль</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.newPswd\" type=\"password\" minlength=\"6\" id=\"inputPassword\" placeholder=\"Минимум 6 символов\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Подтверждение</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.confirmPswd\" type=\"password\" id=\"inputPasswordConfirm\" data-match=\"#inputPassword\" data-match-error=\"Пароль не подтвержден\" required class=\"form-control\">\n                <h5 style=\"color:red;\" ng-if=\"($ctrl.password.confirmPswd.length &gt;5)&amp;&amp;($ctrl.password.confirmPswd!=$ctrl.password.newPswd)\">Пароль не прдтвержден</h5>\n              </div>\n            </div>\n          </div>\n          <div class=\"ln_solid\"></div>\n          <div class=\"row pull-right\"></div>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\">Сохранить</button>\n          <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-warning btn-sm\">Отмена</button>\n        </div>\n      </form></script><script type=text/ng-template id=changeUsername.html><form ng-submit=\"$ctrl.usernameSave()\">\n        <div class=\"modal-header\">\n          <h3>Изменение имени пользователя</h3>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-4\"><b>Пароль</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.currentPswd\" type=\"password\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-4\"><b>Имя пользователя</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.username\" type=\"text\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\">Сохранить</button>\n          <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-warning btn-sm\">Отмена</button>\n        </div>\n      </form></script><script type=text/ng-template id=changeEmail.html><form ng-submit=\"$ctrl.emailSave()\">\n        <div class=\"modal-header\">\n          <h3>Изменение E-mail\'a</h3>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Пароль</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.currentPswd\" type=\"password\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Email</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.email\" type=\"email\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\">Сохранить</button>\n          <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-warning btn-sm\">Отмена</button>\n        </div>\n      </form></script></div></div>");
$templateCache.put("app/property/form.html","");
$templateCache.put("app/property/list.html","");
$templateCache.put("app/property/property.html","");
$templateCache.put("app/regulations/form.html","<div class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Нормативные документы</h2><div class=clearfix></div></div><div class=x_content><form id=regulations-form class=\"form-horizontal form-label-left\"><div stock-dict=form.departmentdocuments dict-table=Departmentdocument class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Раздел публикации</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><ui-select ng-model=form.regulationsItem.departmentdocument_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in form.departmentdocuments\">{{type.name}}</ui-select-choices></ui-select></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Наименование<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input type=text id=name_ru name=name_ru required ng-model=form.regulationsItem.name class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">файлы<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div><file-load file-src=form.regulationsItem.file type=regulations allow=pdf,word,zip></file-load></div><!--.form-group--><!--  div(flow-init=\'form.uploader.flow.opts\' flow-name=\"form.uploader.flow\" flow-file-success=\"form.uploader.controllerFn($flow, $file, $message)\" flow-file-added=\"!!{jpg:1,gif:1,png:1,doc:1,xls:1,xlsx:1,pnt:1,htm:1,pdf:1,txt:1,docx:1}[$file.getExtension()]\")--><!--    button.btn.btn-default.btn-sm(flow-btn)--><!--      span.glyphicon.glyphicon-plus Файл--><!--    button.btn.btn-default.btn-sm(ng-click=\"form.upload()\" type=\"button\") Загрузить--><!--    div(ng-repeat=\"file in form.uploader.flow.files\")--><!--      span {{file.name}} ---><!--      a(ng-click=\"removeFile(file.name); file.cancel();\") X--><!--      div.progress.progress-striped(ng-class=\"{active: file.isUploading()}\")--><!--        div.progress-bar(role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: (file.progress() * 100) + \'%\'}\" style=\"width: 100%;\")--><!--          span.sr-only.ng-binding 1% Complete--><!--  span файлы: {{form.uploader.flow.files.length}}--></div></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=form.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=form.saveRegulations() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/regulations/list.html","<div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>Документы</h3></div><div class=box-body><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_content><div class=row><div class=\"col-md-3 col-sm-12 col-xs-12 form-group\"><label class=control-label>Наименование</label><input type=text ng-model=list.searchValues.name class=form-control></div><div class=\"col-md-3 col-sm-12 col-xs-12 form-group\"><label class=control-label>Дата создания от</label><div class=\"input-group no-margin\"><input type=text name=valid_from ng-model=list.searchValues.created_from uib-datepicker-popup=dd.MM.yyyy datepicker-options=list.dateOptions is-open=list.dateOptions.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.dateOptions.opened1 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-3 col-sm-12 col-xs-12 form-group\"><label class=control-label>Дата создания до</label><div class=\"input-group no-margin\"><input type=text name=valid_to ng-model=list.searchValues.created_to uib-datepicker-popup=dd.MM.yyyy datepicker-options=list.dateOptions is-open=list.dateOptions.opened2 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.dateOptions.opened2 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"row direct-chat-msg\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><button type=button ng-click=list.getRegulations() class=\"btn btn-default\">Найти</button> <button type=button ng-click=list.openCreateForm() class=\"btn btn-primary\">Создать</button> <button type=button ng-click=list.openEditForm() ng-disabled=!list.selected_regulations class=\"btn btn-default\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button type=button ng-click=list.confirmAction() ng-disabled=!list.selected_regulations class=\"btn btn-danger\"><span>Удалить</span></button></div></div></div></div></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=row><div class=col-md-12><paged-table options=list.gridOptions disable-search=false></paged-table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/regulations/regulations.html","<vak-header></vak-header><div id=body class=container><div class=row><div class=\"sidenav col-md-3 col-sm-3 col-xs-12\"><div class=panel><div class=panel-heading><div class=panel-title>{{\'REGULATIONS_LABEL\' | translate}}</div></div><div class=\"panel-body side\"><ul class=list-group><li ng-repeat=\"department in regulations.departments\" ng-click=regulations.getRegulations(department._id) class=list-group-item>{{department.name_ru}}</li><li ng-click=regulations.goToAnti() class=list-group-item>{{\'ANTI_PLAGIARISM_LABEL\' | translate}}</li></ul></div></div></div><div class=\"col-md-9 col-sm-9 col-xs-12\"><div class=panel><div class=panel-heading><div class=panel-title>{{\'REGULATIONS_LABEL\' | translate}}</div></div><div class=panel-body></div><table id=dev-table class=\"table table-hover table-bordered\"><thead><tr><th>#</th><th>{{\'NAME_RU_LABEL\' | translate}}</th><th>{{\'NAME_KG_LABEL\' | translate}}</th><th>{{\'FILE_LABEL\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"regulation in regulations.regulations.list | orderBy:&quot;-created_from&quot;\"><td>{{$index+1}}</td><td>{{regulation.name_ru}}</td><td>{{regulation.name_kg}}</td><td><a href=\"{{regulations.link + regulation.file}}\" target=_blank>{{\'DOWNLOAD_FILE\' | translate}}</a></td></tr></tbody></table></div></div></div></div><vak-footer></vak-footer>");
$templateCache.put("app/report/report.html","<div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Просмотр отчета</div><div class=panel-body><div class=row><col-responsive stock-dict=report.report_categories dict-table=ReportCategories><div class=form-group><label>Категория</label><ui-select ng-model=report.report_category_id><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"category._id as category in report.report_categories|filter:{name:$select.search}\" group-by=app.parentGroup>{{category.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Отчет</label><ui-select ng-model=report.selected_report><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"report in report.reports|filter:{name:$select.search}\">{{report.name}}</ui-select-choices></ui-select></div></col-responsive></div><div id=reportViewer></div></div></div></div></div></div>");
$templateCache.put("app/report/reporta.html","<div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=row><col-responsive><div class=form-group><label>Категория</label><ui-select ng-model=reporta.search.report_category_id on-select=reporta.getReportList()><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"category._id as category in reporta.report_categories|filter:{name:$select.search}\" group-by=app.parentGroup>{{category.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Отчет</label><ui-select ng-model=reporta.selected_report on-select=reporta.setSelected($select.selected)><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"reporta in reporta.reports|filter:{name:$select.search}\">{{reporta.name}}</ui-select-choices></ui-select></div></col-responsive></div><div id=viewerContent></div><div id=designerContent></div></div></div></div>");
$templateCache.put("app/report_template/query_edit.html","<form ng-submit=edit.save()><div class=modal-header><h3>Запрос</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Код</label><input type=text ng-model=edit.query.code ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.query.name ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Ключ возврата</label><input type=text ng-model=edit.query.result_key ng-required=true class=form-control></div></col-responsive></div><div class=form-group><label>Запрос</label><textarea rows=10 ng-required=true ng-model=edit.query.query class=form-control></textarea></div></div><div class=modal-footer><button ng-disabled=edit.saving type=button ng-click=edit.cancel() class=\"btn btn-warning\">Отмена</button> <button ng-disabled=edit.saving type=submit class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/report_template/report_template.html","<div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Шаблоны отчетов</div><div class=panel-body><div class=form-group><button ng-click=report_template.newTemplate() class=\"btn btn-primary\">Новый шаблон</button> <button ng-click=report_template.editTemplate() ng-disabled=!report_template.selected_template class=\"btn btn-default\">Редактировать</button> <button ng-click=report_template.getTemplates() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div><paged-table options=report_template.gridOptions disable-paging=true disable-search=true></paged-table></div></div><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Запросы отчетов</div><div class=panel-body><div class=form-group><button ng-click=report_template.newQuery() class=\"btn btn-primary\">Новый запрос</button> <button ng-click=report_template.editQuery() ng-disabled=!report_template.selected_query class=\"btn btn-default\">Редактировать</button> <button ng-click=report_template.getQueries() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div><paged-table options=report_template.queriesGridOptions disable-paging=true disable-search=true></paged-table></div></div></div></div></div>");
$templateCache.put("app/report_template/template_edit.html","<form ng-submit=edit.save()><div class=modal-header><h3>Шаблон отчета</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Код</label><input type=text ng-model=edit.template.code ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.template.name ng-required=true class=form-control></div></col-responsive><col-responsive stock-dict=edit.report_categories dict-table=DirReportCategories><div class=form-group><label>Категория</label><ui-select ng-model=edit.template.report_category_id><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"category._id as category in edit.report_categories|filter:{name:$select.search}\" group-by=app.parentGroup>{{category.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=form-group><label>Шаблон</label><textarea rows=10 ng-required=true ng-model=edit.template.template class=form-control></textarea></div></div><div class=modal-footer><button ng-disabled=edit.saving type=button ng-click=edit.cancel() class=\"btn btn-warning\">Отмена</button> <button ng-disabled=edit.saving type=submit class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/reportend/reportend.html","<!--Created by ilias on 17.05.2018.\n--><div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Составить отчет</div><div class=panel-body><form class=direct-chat-msg><div class=row><col-responsive><div class=form-group><label>Филиалы</label><ui-select ng-model=reportend.branch_id on-select=reportend.getAgents() theme=bootstrap on-remove=reportend.removeBranches()><ui-select-match allow-clear=true placeholder=\"Выберите филиал\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"company._id as company in reportend.branches\"><div ng-bind=company.name></div></ui-select-choices></ui-select></div></col-responsive><col-responsive ng-if=\"reportend.company.company_type != \'agent\' &amp;&amp; reportend.company.company_type != \'branch_company\'\"><div class=form-group><label>Агенты:</label><select ng-model=reportend.user_id ng-options=\"item.id as item.data.surname + \' \' + item.data.name for item in reportend.agents | filter:{surname:search}\" class=form-control></select></div></col-responsive></div><div class=row><col-responsive stock-dict=reportend.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=reportend.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in reportend.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=reportend.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=reportend.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=reportend.date_start ng-model=reportend.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><button type=button ng-click=reportend.getPolicies() class=\"btn btn-primary btn-xs\"><i aria-hidden=true class=\"fa fa-search\"></i> Применить фильтр</button> <button type=button ng-click=reportend.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button> <button type=button ng-click=reportend.downloadPDFRPCR() ng-disabled=\"reportend.branch_id != null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет</button> <button type=button ng-click=reportend.downloadEXCELRPCR() ng-disabled=\"reportend.branch_id != null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет Excel]</button></form><paged-table options=reportend.policiesGridOptions disable-search=true height=700></paged-table></div></div></div></div></div>");
$templateCache.put("app/reportperiod/reportperiod.html","<!--Created by ilias on 17.05.2018.\n--><div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Составить отчет</div><div class=panel-body><form class=direct-chat-msg><div class=row><col-responsive><div class=form-group><label>Филиалы</label><ui-select ng-model=reportperiod.branch_id on-select=reportperiod.getAgents() theme=bootstrap on-remove=reportperiod.removeBranches()><ui-select-match allow-clear=true placeholder=\"Выберите филиал\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"company._id as company in reportperiod.branches\"><div ng-bind=company.name></div></ui-select-choices></ui-select></div></col-responsive><col-responsive ng-if=\"reportperiod.company.company_type != \'agent\' &amp;&amp; reportperiod.company.company_type != \'branch_company\'\"><div class=form-group><label>Агенты:</label><select ng-model=reportperiod.user_id ng-options=\"item.id as item.data.surname + \' \' + item.data.name for item in reportperiod.agents | filter:{surname:search}\" class=form-control></select></div></col-responsive></div><div class=row><col-responsive stock-dict=reportperiod.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=reportperiod.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in reportperiod.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=reportperiod.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=reportperiod.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=reportperiod.date_start ng-model=reportperiod.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><button type=button ng-click=reportperiod.getPolicies() class=\"btn btn-primary btn-xs\"><i aria-hidden=true class=\"fa fa-search\"></i> Применить фильтр</button> <button type=button ng-click=reportperiod.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button> <button type=button ng-click=reportperiod.downloadPDFRPCR() ng-disabled=\"reportperiod.branch_id != null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет</button> <button type=button ng-click=reportperiod.downloadEXCELRPCR() ng-disabled=\"reportperiod.branch_id != null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет Excel</button> <button type=button ng-click=reportperiod.downloadPDFRPC() ng-disabled=\"reportperiod.branch_id != null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет по Вознаграждению</button> <button type=button ng-click=reportperiod.downloadPDFRPFR() ng-disabled=\"(reportperiod.branch_id == null) || (reportperiod.user_id != null)\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет по филиалу</button> <button type=button ng-click=reportperiod.downloadEXCELRPFR() ng-disabled=\"(reportperiod.branch_id == null) || (reportperiod.user_id != null)\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет по филиалу Excel</button> <button type=button ng-click=reportperiod.downloadPDFRPF() ng-disabled=\"(reportperiod.branch_id == null) || (reportperiod.user_id != null)\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет Вознаграждения по филиалу</button> <button type=button ng-click=reportperiod.downloadPDFRPAR() ng-disabled=\"reportperiod.user_id == null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет по агенту</button> <button type=button ng-click=reportperiod.downloadPDFRPA() ng-disabled=\"reportperiod.user_id == null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет Вознаграждения по агенту</button> <button type=button ng-click=reportperiod.downloadPDFRPAP() ng-if=false ng-disabled=\"reportperiod.company.company_type!=\'agent\' &amp;&amp; reportperiod.company._id == reportperiod.filter.agent_id\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет вознаграждения</button> <button type=button ng-if=false ng-click=reportperiod.downloadExcelRPAP() ng-disabled=\"reportperiod.company.company_type!=\'agent\' &amp;&amp; reportperiod.company._id == reportperiod.filter.agent_id\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет вознаграждения Excel</button> <button type=button ng-click=reportperiod.downloadPDFOR() ng-disabled=\"reportperiod.branch_id != null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет по истекающим</button> <button type=button ng-click=reportperiod.downloadExcelOR() ng-disabled=\"reportperiod.branch_id != null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет по истекающим Excel</button></form><paged-table options=reportperiod.policiesGridOptions disable-search=true height=700></paged-table></div></div></div></div></div>");
$templateCache.put("app/role/edit.html","<!--\nCreated by Ilyas on 17/11/20\n\n--><form ng-submit=role.saveRole()><div class=modal-header><h3>Роль</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=role.role.name ng-required=true ng-trim=true class=form-control></div><div class=form-group><label>Имя роли для одобрения</label><input type=text ng-model=role.role.data.approval_name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><label>Права</label><div class=form-group><label class=form-control><input type=checkbox ng-model=role.role.data.read disabled><span>&nbsp;Чтение</span></label></div><div class=form-group><label class=form-control><input type=checkbox ng-model=role.role.data.write><span>&nbsp;Редактирование</span></label></div><div class=form-group><label class=form-control><input type=checkbox ng-model=role.role.data.delete><span>&nbsp;Удаление</span></label></div></col-responsive><col-responsive><div class=form-group><label>Меню</label><ui-select ng-model=role.role.menus_id multiple><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"menu._id as menu in role.menus | filter: $select.search\" group-by=role.menuParentGroup>{{menu.name}}</ui-select-choices></ui-select></div></col-responsive></div></div><div class=modal-footer><button ng-disabled=\"role.saving===true\" type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button ng-disabled=\"role.saving===true\" type=button ng-click=role.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/role/role.html","<!--Created by Ilyas on 17/11/20\n--><div class=content><!-- Main content--><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>Роли</h3></div><div class=box-body><button ng-click=role.newRole() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=!role.selected_role ng-click=role.editRole() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=role.getRoles() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=role.rolesGridOptions disable-search=true disable-paging=true></paged-table></div></div></div></div></div>");
$templateCache.put("app/sidebar/sidebar.html","<div class=\"col-md-4 col-lg-4 col-xs-12\"><div class=card><div class=card-body><div class=list-group><a href=#news data-parent=#accordion data-toggle=collapse class=list-group-item><span>{{\'Руководство\'| translate}}</span></a><a href=#toggle data-parent=#accordion data-toggle=collapse class=list-group-item><span> {{\'Структура\'| translate}}</span></a><a href=# data-parent=#accordion class=list-group-item><span> {{\'Распределение функциональных обязанностей\'| translate}}</span></a><a href=#prafo data-parent=#accordion data-toggle=collapse class=list-group-item><span> {{\'План действии-2014\'| translate}}</span></a><a href=#/regulations data-parent=#accordion data-toggle=collapse class=list-group-item><span> {{\'Отчеты об итогах деятелности Госфиннадзора\'| translate}}</span></a><a href=#/regulations data-parent=#accordion data-toggle=collapse class=list-group-item><span> {{\'Фотогалерея\'| translate}}</span></a><a href=#rsb data-parent=#accordion data-toggle=collapse class=list-group-item><span> {{\'339\'| translate}}</span></a><div id=rsb class=collapse><ul class=list-group-item><a ui-sref=# class=list-group-item>{{\'Обсуждение положения о составе затрат\'| translate}}</a><a ui-sref=# class=list-group-item>{{\'Обсуждения вопросов обязательного страхования жилья\'| translate}}</a><a ui-sref=# class=list-group-item>{{\'Обсуждение вопросов реорганизации\'| translate}}</a></ul></div></div></div></div></div>");
$templateCache.put("app/tpolicy/list.html","<div class=content><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Полисы</div><div class=panel-body><form ng-submit=list.getPolicies() class=direct-chat-msg><div class=row><col-responsive><div class=form-group><label>Сотрудники:</label><ui-select ng-model=list.filter.agent_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.surname}} {{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"agent.id as agent in list.agents \">{{agent.data.surname}} {{agent.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=list.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in list.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=list.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ФИО клиента:</label><input type=text ng-model=list.filter.client placeholder=\" Введите Фио клиента\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button> <button ng-click=list.goToShow() ng-disabled=!list.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button type=button ng-click=list.downloadPDF() ng-disabled=\"!list.selected_policy || list.selected_list.policy_no == \'00000\' || (list.selected_policy.data.status != \'Оформлен\' &amp;&amp; list.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=list.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div></form><paged-table options=list.policiesGridOptions disable-search=true></paged-table></div></div></div></div></div></div>");
$templateCache.put("app/tpolicy/show.html","<!--Created by troy on 07.10.2016.\n--><div class=container><div class=panel><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=panel><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{show.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{show.policy.client}}</span></h5></div></div><div class=row><div class=col-md-10><h5>Номер кредита:<span class=text-info> {{show.policy.credit_no}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{show.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=show.policy.insurance_data.ned class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ts class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ts\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ln class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=panel-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button><!--button.btn.btn-default.pull-right(type=\'button\'  ng-click=\"show.goToForm()\" ng-if=\"show.policy.data.status && show.policy.data.status == \'Истек\'\" ng-disabled=\"show.policy.data.status != \'Истек\'\")--><!--  i.fa.fa-refresh(aria-hidden=\'true\')--><!--  |   Возобновить--><!--button.btn.btn-danger.pull-right(type=\'button\' ng-click=\"show.confirmAction()\", ng-if=\"show.policy.data.status && show.policy.data.status == \'Оформлен\'\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\")--><!--  i.fa.fa-scissors(aria-hidden=\'true\')--><!--  |   Испортить--><!--button.btn.btn-success.pull-right(type=\'button\' ng-click=\"show.goToForm()\" ng-if=\"show.policy.data.status != \'Истек\' && show.policy.data.status != \'Оформлен\' && show.policy.data.status != \'Испорчен\' && show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\")--><!--  i.fa.fa-pencil(aria-hidden=\'true\')--><!--  |   Изменить--><!--button.btn.btn-success.pull-right(type=\'button\' ng-click=\"show.confirmActionForm()\" ng-if=\"show.policy.data.status != \'Истек\' && show.policy.data.status != \'Оформлен\' && show.policy.data.status != \'Испорчен\' && show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\")--><!--  i.fa.fa-pencil-square-o(aria-hidden=\'true\')--><!--  |   Выдать--></div></div></div>");
$templateCache.put("app/users/create.html","<!--\nCreated by troy on 15.11.2016.\n\n--><form ng-submit=user.createUser()><div class=modal-header><h3>Новый пользователь</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Информация для авторизации</a></li><li><a data-toggle=tab data-target=#menu1>Информация о пользователе</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div></div></div><div id=menu1 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/users/edit.html","<!--\nCreated by Ilyas on 17/11/20\n\n--><form ng-submit=user.updateUser()><div class=modal-header><h3>Пользователь</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Информация для авторизации</a></li><li><a data-toggle=tab data-target=#menu1>Информация о пользователе</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Важность</label><input type=number ng-model=user.user.role ng-trim=true class=form-control></div></div><div stock-dict=user.roles dict-table=Roles class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Роли</label><ui-select ng-model=user.user.roles_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in user.roles\">{{type.name}}</ui-select-choices></ui-select></div></div></div></div><div id=menu1 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/users/users.html","<!--\nCreated by Ilyas on 17/11/20\n\n--><div class=content><!-- Main content--><div class=row><div class=\"col-xs-12 col-md-12 col-lg-12\"><div class=\"box box-success\"><div class=\"box-header with-border\"><h3 class=box-title>Справочники</h3></div><div class=box-body><form ng-submit=users.getUsers() class=direct-chat-msg><div class=row><col-responsive><div class=form-group><label>Email:</label><input type=text ng-model=users.filter.email placeholder=\"Введите email\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Логин:</label><input type=text ng-model=users.filter.login placeholder=\"Введите логин\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"users.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button> <button ng-click=users.newUser() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-click=users.editUser() ng-disabled=\"users.selected_user == null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=product.getProducts() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div></form><paged-table options=users.usersGridOptions disable-search=true></paged-table></div></div></div></div></div>");
$templateCache.put("app/components/contractorSelect/contractor-select.html","<div><div ng-hide=\"asText===true\" class=input-group><div ng-show=loadingContractors class=input-group-addon><span class=\"glyphicon glyphicon-refresh\"></span></div><div ng-show=noContractors class=input-group-addon><span class=\"glyphicon glyphicon-remove text-danger\"></span></div><input type=text ng-model=contractor.selected uib-typeahead=\"contractor as contractor.name for contractor in contractor.searchContractor($viewValue)\" typeahead-loading=loadingContractors typeahead-no-results=noContractors ng-disabled=ngDisabled ng-required=ngRequired class=form-control><div class=input-group-btn><button type=button ng-click=contractor.openSelectContractor() ng-disabled=ngDisabled class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-paperclip\"></span></button></div></div><span ng-show=\"asText===true\">{{ contractor.selected.name }}</span></div>");
$templateCache.put("app/components/contractorSelect/select.html","<!--\nCreated by Ilyas on 17/11/20.\n\n--><div class=modal-header><h3>{{contractor.modalOptions.title}}</h3></div><div class=modal-body><div class=row><div class=\"col col-xs-12 col-sm-12 col-md-4\"><form ng-submit=contractor.searchContractors() class=form-horizontal><div class=form-group><label>Наименование</label><input type=search ng-model=contractor.search_name class=form-control></div><div stock-dict=contractor.contractor_types dict-table=Enums dict-filter={name:&quot;contractor_type&quot;} ng-hide=contractor.modalOptions.filter.contractor_type class=from-group><label>Тип контрагента</label><ui-select ng-model=contractor.contractor_type><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"contractor_type.data.key as contractor_type in contractor.contractor_types | filter:$select.search track by contractor_type.data.key\">{{contractor_type.data.name}}</ui-select-choices></ui-select></div><div stock-dict=contractor.industries dict-table=Industries class=from-group><label>Индустрия</label><ui-select ng-model=contractor.industry_id><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"industry._id as industry in contractor.industries | filter:{name:$select.search} track by industry._id\" group-by=contractor.industryParentGroup>{{industry.name}}</ui-select-choices></ui-select></div><button type=submit class=\"btn btn-success\">Показать</button> <button type=button ng-click=contractor.createContractor() class=\"btn btn-success\">Создать новый</button></form></div><div class=\"col col-xs-12 col-sm-12 col-md-8\"><paged-table options=contractor.gridOptions disable-search=true></paged-table></div></div></div><div class=modal-footer><button type=button ng-click=contractor.cancel() class=\"btn btn-default\">Отмена</button> <button ng-disabled=!contractor.selected_contractor ng-click=contractor.selectContractor() class=\"btn btn-primary\">Принять</button></div>");
$templateCache.put("app/components/fileLoad/file-link.html","<a ng-href={{file_link}} target=_blank>{{file_name}}</a>");
$templateCache.put("app/components/fileLoad/file-load.html","<div class=file-load><div class=\"bdr bdr-v\"><div class=bdr-h></div></div><div tabindex=0 flow-init flow-object=file.flow class=file-content><div class=file-thumbnail><img ng-src=assets/pdf/default/pdf_icon.svg></div><div class=file-opt><div class=file-icon><span class=\"glyphicon glyphicon-file\"></span></div><div class=file-info><div ng-repeat=\"file_item in $flow.files | limitTo: 1\"><uib-progressbar max=file_item.size value=file_item.sizeUploaded() ng-class=\"{active: file_item.isUploading(), success: file_item.isComplete()}\" class=progress-xs></uib-progressbar><div><div class=file-name><span>{{file_item.name}}</span></div><div class=file-size><span>{{file_item.size|fileSize}}</span></div></div><div class=file-btns><div class=btn-group-sm><button type=button uib-tooltip=\"Загрузить новый\" tooltip-append-to-body=true flow-btn ng-hide=file.isUploading() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-cloud-upload\"></span></button> <button type=button uib-tooltip=Отмена tooltip-append-to-body=true ng-click=file_item.cancel() class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove\"></span></button> <button type=button uib-tooltip=Повторить tooltip-append-to-body=true ng-click=file_item.retry() ng-show=file_item.error class=\"btn btn-warning\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div></div></div><div ng-if=\"$flow.files.length==0 &amp;&amp; file.file\"><div><div class=file-name><span>{{file.file.name}}</span></div><div class=file-size><span>{{file.file.size|fileSize}}</span></div></div><div class=file-btns><div class=btn-group-sm><button type=button uib-tooltip=\"Загрузить новый\" tooltip-append-to-body=true flow-btn class=\"btn btn-default\"><span class=\"glyphicon glyphicon-cloud-upload\"></span></button><a href=\"{{file.api + fileSrc}}\" target=_blank uib-tooltip=Скачать tooltip-append-to-body=true class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-download-alt\"></span></a><!--button.btn.btn-danger(type=\'button\' uib-tooltip=\'Удалить\' tooltip-append-to-body=\'true\' flow-btn)--><!--  span.glyphicon.glyphicon-remove--></div></div></div><div ng-if=\"$flow.files.length==0 &amp;&amp; !file.file\"><div><div class=file-name><span>Выберите файл</span></div><div class=file-size></div></div><div class=file-btns><div class=btn-group-sm><button type=button uib-tooltip=\"Загрузить новый\" tooltip-append-to-body=true flow-btn class=\"btn btn-default\"><span class=\"glyphicon glyphicon-cloud-upload\"></span> Выбрать</button></div></div></div></div></div></div></div>");
$templateCache.put("app/dictionary/department/edit.html","<div ng-controller=\"DepartmentController as department\" class=row><col-responsive><div class=form-group><label>{{\'Наименование\' | translate}}</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование en\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование kg\' | translate}}</label><input type=text ng-model=edit.dictionary.name_kg ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/department/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/currencies/edit.html","<div ng-controller=\"CurrencyController as currency\" class=row><div class=\"col col-md-4\"><div class=form-group><label>Государство</label><input type=text ng-model=edit.dictionary.data.country class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Намименование</label><input type=text ng-model=edit.dictionary.name ng-required=true class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Знак</label><input type=text ng-model=edit.dictionary.data.symbol class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label for=code>Код</label><input id=code type=text ng-model=edit.dictionary.data.code class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label for=short_name>Короткое название</label><input id=short_name type=text ng-model=edit.dictionary.data.short_name class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Намименование (ISO 4217)</label><input type=text ng-model=edit.dictionary.data.name class=form-control></div></div></div>");
$templateCache.put("app/dictionary/currencies/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/departmentdocument/edit.html","<!--\nCreated by ilias on 19.06.2018.\n\n--><div ng-controller=\"DepartmentdocumentController as departmentdocument\" class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/departmentdocument/view.html","<!--\nCreated by ilias on 19.06.2018.\n\n--><pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/dirposition/edit.html","<div ng-controller=\"DirPositionController as dirposition\" class=row><col-responsive><div class=form-group><label>{{\'Наименование\' | translate}}</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование en\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование kg\' | translate}}</label><input type=text ng-model=edit.dictionary.name_kg ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Порядок\' | translate}}</label><input type=number ng-model=edit.dictionary.order ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><div class=checkbox><label>{{\'Показать\' | translate}} <input type=checkbox checked ng-model=edit.dictionary.visible class=flat></label></div><!--label.custom-control.custom-checkbox.custom-control-inline--><!--  input.form-control.custom-control-input(type=\'checkbox\', ng-model=\'edit.dictionary.visible\')--><!--  span.custom-control-label {{\'Показать\' | translate}}--></div></col-responsive></div>");
$templateCache.put("app/dictionary/dirposition/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/dirreportcategories/edit.html","<div ng-controller=\"DirReportCategoriesController as category\" class=row><div class=\"col-md-6 col-xs-12\"><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div><div class=\"col-md-6 col-xs-12\"><div class=form-group><label>Родительская категория</label><ui-select ng-model=edit.dictionary.parent_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in category.dirReportCategories | filter: {name:$select.search} track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name></span></ui-select-choices></ui-select></div></div></div>");
$templateCache.put("app/dictionary/dirstructure/edit.html","<!--\nCreated by ilias on 29.10.2018.\n\n--><div ng-controller=\"DirstructureController as dirstructure\" class=row><col-responsive><div class=form-group><label>{{\'Наименование ru\' | translate}}</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование kg\' | translate}}</label><input type=text ng-model=edit.dictionary.name_kg ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование en\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Порядок\' | translate}}</label><input type=number ng-model=edit.dictionary.data.order ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Показывать\' | translate}}</label><div class=form-group><div class=checkbox><label>{{\'Показать\' | translate}} <input type=checkbox checked ng-model=edit.dictionary.data.visible class=flat></label></div></div></div></col-responsive></div>");
$templateCache.put("app/dictionary/dirstructure/view.html","<!--\nCreated by ilias on 29.10.2018.\n\n--><pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/dirtags/edit.html","<div ng-controller=\"DirtagsController as dirtags\" class=row><col-responsive><div class=form-group><label>{{\'Наименование ru\' | translate}}</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование kg\' | translate}}</label><input type=text ng-model=edit.dictionary.name_kg ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование en\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/dirtags/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/enums/edit.html","<div ng-controller=\"EnumController as enum\" class=row><col-responsive><div class=form-group><label>Тип</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.data.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Коэффициент</label><input type=text ng-model=edit.dictionary.data.key ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/enums/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/examsections/edit.html","<div ng-controller=\"ExamSectionsController as section\" class=row><col-responsive><div class=form-group><label>{{\'Наименование ru\' | translate}}</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование kg\' | translate}}</label><input type=text ng-model=edit.dictionary.name_kg ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование en\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/examsections/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/graphics/edit.html","<div ng-controller=\"GraphicsController as graphics\" class=row><col-responsive><div class=form-group><label>{{\'Дата\' | translate}}</label><input type=text uib-datepicker-popup ng-click=\"form.search.popup_to_date.opened=true\" ng-model=edit.dictionary.date is-open=form.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control></div></col-responsive><col-responsive><div class=\"form-group d-flex\"><label>{{\'Время\' | translate}}</label><div uib-timepicker ng-model=edit.dictionary.time hour-step=graphics.hstep minute-step=graphics.mstep show-meridian=graphics.ismeridian></div></div></col-responsive><col-responsive><div class=form-group><label>{{\'Количество\' | translate}}</label><input type=number ng-model=edit.dictionary.count ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/graphics/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/industries/edit.html","<div ng-controller=\"IndustryController as industry\" class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=edit.industries dict-table=Industries dict-options={onlyParents:true} dict-first-item=\"{_id:null,name:&quot;Нет родителя&quot;}\"><div class=form-group><label>Родетельская индустрия</label><ui-select ng-model=edit.dictionary.parent_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in (edit.industries | filter: {name:$select.search}) track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive ng-show=\"app.ua.role&gt;=10\"><div class=form-group><label>Основная индустрия</label><input type=number ng-model=edit.dictionary.data.base_industry class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/industries/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/insuranceforms/edit.html","<div ng-controller=\"InsuranceformsController as insuranceforms\" class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Тип</label><input type=text ng-model=edit.dictionary.typeinput ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Ключ</label><input type=text ng-model=edit.dictionary.data.key ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=insurancetypes.parents dict-table=InsuranceObjects><div class=form-group><label>Объект страхования</label><ui-select ng-model=edit.dictionary.insurance_object_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in insurancetypes.parents track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive></div>");
$templateCache.put("app/dictionary/insuranceforms/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/insuranceobjects/edit.html","<div ng-controller=\"InsuranceobjectsController as insuranceobjects\" class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Коэффициент</label><input type=number ng-model=edit.dictionary.rate ng-trim=true step=0.001 class=form-control></div></col-responsive><col-responsive stock-dict=insurancetypes.parents dict-table=InsuranceTypes><div class=form-group><label>Тип страхования</label><ui-select ng-model=edit.dictionary.insurance_type_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in insurancetypes.parents track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive></div>");
$templateCache.put("app/dictionary/insuranceobjects/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/insurancetypes/edit.html","<div ng-controller=\"InsurancetypesController as insurancetypes\" class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Коэффициент</label><input type=number ng-model=edit.dictionary.rate ng-trim=true ng-pattern=/^[0-9]+(.[0-9]{1,2})?$/ step=0.001 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Описание</label><input type=text ng-model=edit.dictionary.description ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код</label><input type=text ng-model=edit.dictionary.code ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=insurancetypes.parents dict-table=InsuranceTypes><div class=form-group><label>Родитель</label><ui-select ng-model=edit.dictionary.parent_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in insurancetypes.parents track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive stock-dict=insurancetypes.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=edit.dictionary.status class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in insurancetypes.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label><br><input type=checkbox ng-model=edit.dictionary.mandatory> Обязательное</label><label style=margin-left:10px><br><input type=checkbox ng-model=edit.dictionary.is_used> Используется</label></div></col-responsive></div>");
$templateCache.put("app/dictionary/insurancetypes/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/language/edit.html","<div ng-controller=\"LanguageController as language\" class=row><col-responsive><div class=form-group><label>{{\'Ключ\' | translate}}</label><input type=text ng-model=edit.dictionary.key ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'На русском\' | translate}}</label><input type=text ng-model=edit.dictionary.name_ru ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'На кыргызском\' | translate}}</label><input type=text ng-model=edit.dictionary.name_kg ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'На английском\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/language/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/legalframedoctype/edit.html","<div ng-controller=\"LegalframedoctypeController as legalframedoctype\" class=row><col-responsive><div class=form-group><label>{{\'Наименование_RU\' | translate}}</label><input type=text ng-model=edit.dictionary.name_ru ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование_KG\' | translate }}</label><input type=text ng-model=edit.dictionary.name_kg ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование_EN\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Порядок\' | translate}}</label><input type=number ng-model=edit.dictionary.order ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/legalframedoctype/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/period/edit.html","<div ng-controller=\"PeriodController as period\" class=row><col-responsive><div class=form-group><label>Начало</label><input type=number ng-model=edit.dictionary.start ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Конец</label><input type=number ng-model=edit.dictionary.end ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Коэффициент</label><input type=number ng-model=edit.dictionary.rate ng-required=true ng-trim=true ng-pattern=/^[0-9]+(.[0-9]{1,2})?$/ step=0.001 class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/period/view.html","");
$templateCache.put("app/dictionary/polldepartment/edit.html","<div ng-controller=\"PollDepartmentController as polldepartment\" class=row><div class=col-md-9><div class=form-group><label>{{\'Наименование\' | translate}}</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div></div>");
$templateCache.put("app/dictionary/polldepartment/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/product/edit.html","<div ng-controller=\"ProductController as product\" class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=edit.industries dict-table=Industries dict-options={onlyParents:true} dict-first-item=\"{_id:null,name:&quot;Нет родителя&quot;}\"><div class=form-group><label>Родетельская индустрия</label><ui-select ng-model=edit.dictionary.parent_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in (edit.industries | filter: {name:$select.search}) track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label for=code>Код</label><input id=code type=text ng-model=edit.dictionary.data.code class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/product/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/reestr/edit.html","<div ng-controller=\"ReestrController as registries\" class=row><col-responsive><div class=form-group><label>{{\'Наименование_RU\' | translate}}</label><input type=text ng-model=edit.dictionary.name_ru ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование_KG\' | translate }}</label><input type=text ng-model=edit.dictionary.name_kg ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование_EN\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Ссылка на шаблон\' | translate}}</label><input type=text ng-model=edit.dictionary.data.template ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование db\' | translate}}</label><input type=text ng-model=edit.dictionary.data.db ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Тип\' | translate}}</label><input type=text ng-model=edit.dictionary.data.type ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Порядок\' | translate}}</label><input type=number ng-model=edit.dictionary.order ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/reestr/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/relativedegree/edit.html","<div class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/relativedegree/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/reportcategories/edit.html","<div ng-controller=\"ReportCategoryController as category\" class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=category.categories dict-table=ReportCategories dict-options={onlyParents:true} dict-first-item=\"{_id:null,name:&quot;Нет родителя&quot;}\"><div class=form-group><label>Родительская категория</label><ui-select ng-model=edit.dictionary.parent_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in (category.categories | filter: {name:$select.search}) track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name></span></ui-select-choices></ui-select></div></col-responsive></div>");
$templateCache.put("app/dictionary/reportcategories/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/reportingdeadlines/edit.html","<div ng-controller=\"ReportingdeadlinesController as reportingdeadlines\" class=row><col-responsive><div class=form-group><label>{{\'Наименование_RU\' | translate}}</label><input type=text ng-model=edit.dictionary.name_ru ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование_KG\' | translate }}</label><input type=text ng-model=edit.dictionary.name_kg ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование_EN\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Порядок\' | translate}}</label><input type=number ng-model=edit.dictionary.order ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/reportingdeadlines/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/reportsections/edit.html","<div ng-controller=\"ReestrController as registries\" class=row><col-responsive><div class=form-group><label>{{\'Наименование_RU\' | translate}}</label><input type=text ng-model=edit.dictionary.name_ru ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование_KG\' | translate }}</label><input type=text ng-model=edit.dictionary.name_kg ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование_EN\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-required=true ng-trim=true class=form-control></div></col-responsive><div class=col-xs-12><div class=form-group><label>{{\'Контактные данные\' | translate}}</label><textarea ng-model=edit.dictionary.data.address ng-required=true ng-trim=true style=\"max-width: 100%\" class=form-control></textarea></div></div><div class=col-xs-12><div class=form-group><label>{{\'Текст внизу\' | translate}}</label><wysiwyg-edit content=edit.dictionary.data.warning_text ng-model=edit.dictionary.warning_text required></wysiwyg-edit></div></div><!--col-responsive--><!--  .form-group--><!--    label {{\'Ссылка на шаблон\' | translate}}--><!--    input.form-control(type=\'text\' ng-model=\'edit.dictionary.data.link\' ng-required=\'true\' ng-trim=\'true\')--><col-responsive><div class=form-group><label>{{\'Порядок\' | translate}}</label><input type=number ng-model=edit.dictionary.order ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/reportsections/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/reportsectionstypes/edit.html","<div ng-controller=\"ReportsectionstypesController as reportsectionstypes\" class=row><col-responsive><div class=form-group><label>{{\'Наименование_RU\' | translate}}</label><input type=text ng-model=edit.dictionary.name_ru ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование_KG\' | translate }}</label><input type=text ng-model=edit.dictionary.name_kg ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование_EN\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-required=true ng-trim=true class=form-control></div></col-responsive><div stock-dict=edit.reportsectionstypes dict-table=ReportSections class=col-xs-12><div class=form-group><label>{{\'Выберите раздел отчетности\' | translate}}</label><ui-select ng-model=edit.dictionary.report_section_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match><span ng-bind=$select.selected.name_ru></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in (edit.reportsectionstypes | filter: {name_ru:$select.search}) track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name_ru></span></ui-select-choices></ui-select></div></div><col-responsive><div class=form-group><label>{{\'Порядок\' | translate}}</label><input type=number ng-model=edit.dictionary.order ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/reportsectionstypes/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/sectionsofpublication/edit.html","<!--\nCreated by admin on 03.07.2018.\n\n--><div ng-controller=\"SectionsofpublicationController as sectionsofpublication\" class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Порядок</label><input type=number ng-model=edit.dictionary.order ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/sectionsofpublication/view.html","<!--Created by admin on 03.07.2018.\n--><pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/sectionsofpublicationactivity/edit.html","<div ng-controller=\"SectionsofpublicationController as sectionsofpublication\" class=row><col-responsive><div class=form-group><label>{{\'Наименование_RU\' | translate}}</label><input type=text ng-model=edit.dictionary.name_ru ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование_KG\' | translate }}</label><input type=text ng-model=edit.dictionary.name_kg ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование_EN\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Ссылка на шаблон\' | translate}}</label><input type=text ng-model=edit.dictionary.data.template ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Порядок\' | translate}}</label><input type=number ng-model=edit.dictionary.order ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/sectionsofpublicationactivity/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/sector/edit.html","<div ng-controller=\"SectorController as sector\" class=row><col-responsive><div class=form-group><label>{{\'Наименование\' | translate}}</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование kg\' | translate}}</label><input type=text ng-model=edit.dictionary.name_kg ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование en\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/sector/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/typeofownership/edit.html","<div ng-controller=\"TypeofownershipController as typeofownership\" class=row><col-responsive><div class=form-group><label>{{\'Наименование\' | translate}}</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование kg\' | translate}}</label><input type=text ng-model=edit.dictionary.name_kg ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Наименование en\' | translate}}</label><input type=text ng-model=edit.dictionary.name_en ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/typeofownership/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/docs/advance/edit.html","<div ng-controller=\"DocsAdvanceEditController as advance\" class=container><div class=row><col-responsive><div class=form-group><label>Заголовок</label><input type=text ng-model=entry.document.title ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Принимающий</label><employee-select employee-id=entry.document.data.executor_id ng-required=true ng-disabled=\"advance.executor_not_editable || advance.is_executor\"></employee-select></div></col-responsive><col-responsive><div class=form-group><label>Короткое описание</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=entry.document.data.comment class=form-control></textarea></div></col-responsive><col-responsive><div stock-dict=advance.currencies dict-table=Currencies class=form-group><label>Валюта</label><ui-select ng-model=entry.document.data.currency_id ng-required=true><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"currency._id as currency in (advance.currencies | filter:{name:$select.search} | orderBy:&quot;currency.name&quot;) track by currency._id\"><span ng-bind=currency.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Сумма</label><input type=number ng-model=entry.document.data.amount step=0.01 ng-required=true class=form-control></div></col-responsive></div><panel title=Одобрение collapsed=true><div class=row><col-responsive><div class=form-group><label>Требуется одобрение</label><label class=form-control><div class=checkbox-inline><input type=checkbox ng-model=entry.document.approval.required ng-disabled=\"advance.approval_not_editable || advance.is_executor\"><span ng-show=entry.document.approval.required>Требуется одобрение</span><span ng-hide=entry.document.approval.required>Одобрение не требуется</span></div></label></div></col-responsive><col-responsive><div ng-init=\"entry.document.approval.approval_type=&quot;one&quot;\" class=form-group><label>Должны одобрить<span uib-tooltip=\"Сколько пользователей из каждой роли должны одобрить\" class=\"fa fa-question-circle\"></span></label><div stock-dict=advance.approval_types dict-table=Enums dict-filter={name:&quot;approval_type&quot;} class=form-control><label ng-repeat=\"type in advance.approval_types track by type.data.key\" class=radio-inline><input type=radio ng-model=entry.document.approval.approval_type ng-value=type.data.key ng-disabled=\"!entry.document.approval.required || advance.approval_not_editable || advance.is_executor\"><span>{{type.data.name}}</span></label></div></div></col-responsive><col-responsive><div class=form-group><label>Добавить роль для одобрения<span uib-tooltip=\"Одобрение будет проходить по порядку добавления ролей\" class=\"fa fa-question-circle\"></span></label><div stock-dict=advance.roles dict-table=Roles class=input-group><ui-select ng-model=advance.approval_role_id ng-disabled=\"!entry.document.approval.required || advance.approval_not_editable || advance.is_executor\" class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (advance.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-disabled=\"!advance.approval_role_id || !entry.document.approval.required || advance.approval_not_editable || advance.is_executor\" ng-click=advance.addApprovalRole() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-plus text-primary\"></span></button></span></div></div></col-responsive><div class=\"col col-xs-12\"><label>Роли для одобрения</label></div><div stock-dict=advance.roles dict-table=Roles class=\"col col-xs-12\"><col-responsive ng-repeat=\"role_id in entry.document.approval.roles_id\"><div class=input-group><div class=input-group-addon><span>{{$index+1}}</span></div><ui-select ng-model=role_id ng-disabled=true class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (advance.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=advance.delApprovalRole(role_id) ng-disabled=\"advance.approval_not_editable || advance.is_executor\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></span></div></col-responsive></div></div></panel></div>");
$templateCache.put("app/docs/advance/view.html","<div ng-controller=\"DocsAdvanceViewController as advance\" class=container><div class=container><h3>{{view.document.title}}</h3><label class=margin-right-8>{{view.document.document_status_value.data.name}}</label><label class=pull-right>Создан <span am-time-ago=view.document.data.date></span></label></div><div class=ln_solid></div><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Принимающий</col-responsive><col-responsive class=col-lg-10>{{view.document.executor.username}}</col-responsive></div><div ng-if=view.document.short_desc class=row><col-responsive class=col-lg-2>Короткое описание</col-responsive><col-responsive class=col-lg-10>{{view.document.short_desc}}</col-responsive></div><div ng-if=view.document.data.comment class=row><col-responsive class=col-lg-2>Комментарий</col-responsive><col-responsive class=col-lg-10>{{view.document.data.comment}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Сумма аванса</col-responsive><col-responsive class=col-lg-10>{{view.document.data.amount | number}} {{view.document.currency.name}}</col-responsive></div></div><div class=ln_solid></div><div ng-show=view.document.approval.required><div class=ln_solid></div><h4>Одобрения</h4><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Должны одобрить</col-responsive><col-responsive class=col-lg-10>{{view.document.approval_type_value.data.name}}</col-responsive></div></div><ul><li ng-repeat=\"approval_role in view.document.approval.approval_roles\"><h5 ng-class=\"{&quot;text-success&quot;:approval_role.approved===true, &quot;text-danger&quot;:approval_role.approved===false}\"><span ng-show=\"approval_role.approved===true\" class=\"glyphicon glyphicon-ok-circle margin-right-8\"></span><span ng-show=\"approval_role.approved===false\" class=\"glyphicon glyphicon-remove-circle margin-right-8\"></span><span ng-repeat=\"role in view.document.roles|filter:{_id:approval_role.role_id} track by role._id\">{{role.data.approval_name}}</span></h5><ul><li ng-repeat=\"approval_user in approval_role.approval_users\" ng-class=\"{&quot;text-success&quot;:approval_user.approved===true, &quot;text-danger&quot;:approval_user.approved===false}\"><span class=\"fa fa-user margin-right-8\"></span><span ng-repeat=\"user in view.document.approval_users|filter:{id:approval_user.user_id} track by user.id\">{{user.username}}</span></li></ul></li></ul></div><div class=ln_solid></div><document-comment document-id=view.document._id></document-comment></div>");
$templateCache.put("app/docs/cash_expenditure/edit.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsCashExpenditureEditController as cash_expenditure\" class=container><div class=row><col-responsive><div class=form-group><label>Заголовок</label><input type=text ng-model=entry.document.title ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div stock-dict=cash_expenditure.branches dict-table=Branches class=form-group><label>Филиал</label><branch-select ng-model=entry.document.branch_id branches=cash_expenditure.branches ng-required=true></branch-select></div></col-responsive><col-responsive><div class=form-group><label>Исполнитель</label><employee-select employee-id=entry.document.data.executor_id ng-disabled=\"cash_expenditure.executor_not_editable || cash_expenditure.is_executor\"></employee-select></div></col-responsive><col-responsive><div class=form-group><label>Короткое описание</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=entry.document.data.comment class=form-control></textarea></div></col-responsive></div><div class=ln_solid></div><div class=row><col-responsive><div class=form-group><label>Контрагент</label><contractor-select contractor-id=entry.document.data.contractor_id></contractor-select></div></col-responsive><col-responsive><div stock-dict=cash_expenditure.currencies dict-table=Currencies class=form-group><label>Валюта</label><ui-select ng-model=entry.document.data.currency_id><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"currency._id as currency in (cash_expenditure.currencies | filter:{name:$select.search} | orderBy:&quot;currency.name&quot;) track by currency._id\"><span ng-bind=currency.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Сумма</label><input type=number step=0.01 ng-model=entry.document.data.amount ng-required=true ng-trim=true class=form-control></div></col-responsive></div><panel title=Одобрение collapsed=true><div class=row><col-responsive><div class=form-group><label>Требуется одобрение</label><label class=form-control><div class=checkbox-inline><input type=checkbox ng-model=entry.document.approval.required ng-disabled=\"cash_expenditure.approval_not_editable || cash_expenditure.is_executor\"><span ng-show=entry.document.approval.required>Требуется одобрение</span><span ng-hide=entry.document.approval.required>Одобрение не требуется</span></div></label></div></col-responsive><col-responsive><div ng-init=\"entry.document.approval.approval_type=&quot;one&quot;\" class=form-group><label>Должны одобрить<span uib-tooltip=\"Сколько пользователей из каждой роли должны одобрить\" class=\"fa fa-question-circle\"></span></label><div stock-dict=cash_expenditure.approval_types dict-table=Enums dict-filter={name:&quot;approval_type&quot;} class=form-control><label ng-repeat=\"type in cash_expenditure.approval_types track by type.data.key\" class=radio-inline><input type=radio ng-model=entry.document.approval.approval_type ng-value=type.data.key ng-disabled=\"!entry.document.approval.required || cash_expenditure.approval_not_editable || cash_expenditure.is_executor\"><span>{{type.data.name}}</span></label></div></div></col-responsive><col-responsive><div class=form-group><label>Добавить роль для одобрения<span uib-tooltip=\"Одобрение будет проходить по порядку добавления ролей\" class=\"fa fa-question-circle\"></span></label><div stock-dict=cash_expenditure.roles dict-table=Roles class=input-group><ui-select ng-model=cash_expenditure.approval_role_id ng-disabled=\"!entry.document.approval.required || cash_expenditure.approval_not_editable || cash_expenditure.is_executor\" class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (cash_expenditure.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-disabled=\"!cash_expenditure.approval_role_id || !entry.document.approval.required || cash_expenditure.approval_not_editable || cash_expenditure.is_executor\" ng-click=cash_expenditure.addApprovalRole() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-plus text-primary\"></span></button></span></div></div></col-responsive><div class=\"col col-xs-12\"><label>Роли для одобрения</label></div><div stock-dict=cash_expenditure.roles dict-table=Roles class=\"col col-xs-12\"><col-responsive ng-repeat=\"role_id in entry.document.approval.roles_id\"><div class=input-group><div class=input-group-addon><span>{{$index+1}}</span></div><ui-select ng-model=role_id ng-disabled=true class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (cash_expenditure.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=cash_expenditure.delApprovalRole(role_id) ng-disabled=\"cash_expenditure.approval_not_editable || cash_expenditure.is_executor\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></span></div></col-responsive></div></div></panel></div>");
$templateCache.put("app/docs/cash_expenditure/view.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsCashExpenditureViewController as cash_expenditure\" class=container><div class=container><h3>{{view.document.title}}</h3><label class=margin-right-8>{{view.document.document_status_value.data.name}}</label><label class=pull-right>Создан <span am-time-ago=view.document.data.date></span></label></div><div class=ln_solid></div><div class=\"row-striped row-v-padding row-col-bold\"><div ng-if=view.document.branch_id class=row><col-responsive class=col-lg-2>Филиал</col-responsive><col-responsive class=col-lg-10>{{view.document.branch.name}}</col-responsive></div><div ng-if=view.document.data.executor_id class=row><col-responsive class=col-lg-2>Исполнитель</col-responsive><col-responsive class=col-lg-10>{{view.document.executor.username}}</col-responsive></div><div ng-if=view.document.short_desc class=row><col-responsive class=col-lg-2>Короткое описание</col-responsive><col-responsive class=col-lg-10>{{view.document.short_desc}}</col-responsive></div><div ng-if=view.document.data.comment class=row><col-responsive class=col-lg-2>Комментарий</col-responsive><col-responsive class=col-lg-10>{{view.document.data.comment}}</col-responsive></div><div ng-if=view.document.data.contractor_id class=row><col-responsive class=col-lg-2>Контрагент</col-responsive><col-responsive class=col-lg-10>{{view.document.contractor.name}}</col-responsive></div><div ng-if=view.document.data.contractor_id class=row><col-responsive class=col-lg-2>Сумма оплаты</col-responsive><col-responsive class=col-lg-10>{{view.document.currency.name}} {{view.document.data.amount | number}}</col-responsive></div></div><div class=ln_solid></div><div ng-show=view.document.approval.required><div class=ln_solid></div><h4>Одобрения</h4><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Должны одобрить</col-responsive><col-responsive class=col-lg-10>{{view.document.approval_type_value.data.name}}</col-responsive></div></div><ul><li ng-repeat=\"approval_role in view.document.approval.approval_roles\"><h5 ng-class=\"{&quot;text-success&quot;:approval_role.approved===true, &quot;text-danger&quot;:approval_role.approved===false}\"><span ng-show=\"approval_role.approved===true\" class=\"glyphicon glyphicon-ok-circle margin-right-8\"></span><span ng-show=\"approval_role.approved===false\" class=\"glyphicon glyphicon-remove-circle margin-right-8\"></span><span ng-repeat=\"role in view.document.roles|filter:{_id:approval_role.role_id} track by role._id\">{{role.data.approval_name}}</span></h5><ul><li ng-repeat=\"approval_user in approval_role.approval_users\" ng-class=\"{&quot;text-success&quot;:approval_user.approved===true, &quot;text-danger&quot;:approval_user.approved===false}\"><span class=\"fa fa-user margin-right-8\"></span><span ng-repeat=\"user in view.document.approval_users|filter:{id:approval_user.user_id} track by user.id\">{{user.username}}</span></li></ul></li></ul></div><div class=ln_solid></div><document-comment document-id=view.document._id></document-comment></div>");
$templateCache.put("app/docs/consumption/edit.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsConsumptionEditController as consumption\" class=container><div class=row><col-responsive><div class=form-group><label>Заголовок</label><input type=text ng-model=entry.document.title ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div stock-dict=consumption.branches dict-table=Branches dict-filter={branch_type:&quot;cost_center&quot;} class=form-group><label>Центр затрат</label><branch-select ng-model=entry.document.branch_id branches=consumption.branches></branch-select></div></col-responsive><col-responsive><div stock-dict=consumption.purposes dict-table=CostCenterPurposes dict-filter={branch_id:entry.document.branch_id} dict-options={onlyChildren:true} class=form-group><label>Назначение ЦЗ</label><ui-select ng-model=entry.document.data.purpose_id ng-required=true><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"purpose._id as purpose in consumption.purposes track by purpose._id\" group-by=consumption.purposeParentGroup>{{purpose.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Принимающий</label><employee-select employee-id=entry.document.data.executor_id ng-disabled=\"consumption.executor_not_editable || consumption.is_executor\"></employee-select></div></col-responsive><col-responsive><div class=form-group><label>Дата доставки</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=entry.document.data.delivery_date is-open=consumption.popup_delivery_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"consumption.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Короткое описание</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=entry.document.data.comment class=form-control></textarea></div></col-responsive></div><div class=ln_solid></div><div class=row><col-responsive><div stock-dict=consumption.product_sources dict-table=Enums dict-filter={name:&quot;product_source&quot;} class=form-group><label>Источник</label><ui-select ng-model=entry.document.data.product_source ng-required=true on-select=consumption.sourceSelected()><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"source.data.key as source in consumption.product_sources track by source.data.key\">{{source.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=consumption.source_branches dict-table=Branches class=form-group><label>Филиал источник</label><branch-select ng-model=entry.document.data.branch_id branches=consumption.source_branches ng-disabled=\"entry.document.data.product_source!==&quot;branch&quot;\"></branch-select></div></col-responsive><col-responsive><div class=form-group><label>Контрагент</label><contractor-select contractor-id=entry.document.data.contractor_id ng-disabled=\"entry.document.data.product_source!=&quot;contractor&quot;\"></contractor-select></div></col-responsive><col-responsive><div class=form-group><label>Способ оплаты</label><div ng-init=\"consumption.payment_method=&quot;cash&quot;\" class=form-control><label class=radio-inline><input type=radio name=payment_method ng-model=consumption.payment_method value=cash><span>Наличные</span></label><label class=radio-inline><input type=radio name=payment_method ng-model=consumption.payment_method value=debt><span>В долг</span></label><label class=radio-inline><input type=radio name=payment_method ng-model=consumption.payment_method value=advance><span>Аванс</span></label></div></div></col-responsive><col-responsive><div stock-dict=consumption.currencies dict-table=Currencies class=form-group><label>Валюта</label><ui-select ng-model=entry.document.data.currency_id><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"currency._id as currency in (consumption.currencies | filter:{name:$select.search} | orderBy:&quot;currency.name&quot;) track by currency._id\"><span ng-bind=currency.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Дата выплаты</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=entry.document.data.due_date is-open=consumption.popup_due_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"consumption.popup_due_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Сотрудник</label><employee-select employee-id=entry.document.data.employee_id ng-disabled=!entry.document.data.is_advance></employee-select></div></col-responsive></div><panel title=Товары ng-show=entry.document><button ng-disabled=\"entry.saving==true\" type=button ng-click=consumption.productNew() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=\"entry.saving==true || !consumption.selected_product\" type=button ng-click=consumption.productEdit() class=\"btn btn-default btn-sm\">Изменить</button> <button ng-disabled=\"entry.saving==true || !consumption.selected_product\" type=button ng-click=consumption.productRemove() class=\"btn btn-danger btn-sm\">Удалить</button><paged-table options=consumption.productsGridOptions disable-search=true disable-paging=true></paged-table></panel><panel title=Одобрение collapsed=true><div class=row><col-responsive><div class=form-group><label>Требуется одобрение</label><label class=form-control><div class=checkbox-inline><input type=checkbox ng-model=entry.document.approval.required ng-disabled=\"consumption.approval_not_editable || consumption.is_executor\"><span ng-show=entry.document.approval.required>Требуется одобрение</span><span ng-hide=entry.document.approval.required>Одобрение не требуется</span></div></label></div></col-responsive><col-responsive><div ng-init=\"entry.document.approval.approval_type=&quot;one&quot;\" class=form-group><label>Должны одобрить<span uib-tooltip=\"Сколько пользователей из каждой роли должны одобрить\" class=\"fa fa-question-circle\"></span></label><div stock-dict=consumption.approval_types dict-table=Enums dict-filter={name:&quot;approval_type&quot;} class=form-control><label ng-repeat=\"type in consumption.approval_types track by type.data.key\" class=radio-inline><input type=radio ng-model=entry.document.approval.approval_type ng-value=type.data.key ng-disabled=\"!entry.document.approval.required || consumption.approval_not_editable || consumption.is_executor\"><span>{{type.data.name}}</span></label></div></div></col-responsive><col-responsive><div class=form-group><label>Добавить роль для одобрения<span uib-tooltip=\"Одобрение будет проходить по порядку добавления ролей\" class=\"fa fa-question-circle\"></span></label><div stock-dict=consumption.roles dict-table=Roles class=input-group><ui-select ng-model=consumption.approval_role_id ng-disabled=\"!entry.document.approval.required || consumption.approval_not_editable || consumption.is_executor\" class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (consumption.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-disabled=\"!consumption.approval_role_id || !entry.document.approval.required || consumption.approval_not_editable || consumption.is_executor\" ng-click=consumption.addApprovalRole() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-plus text-primary\"></span></button></span></div></div></col-responsive><div class=\"col col-xs-12\"><label>Роли для одобрения</label></div><div stock-dict=consumption.roles dict-table=Roles class=\"col col-xs-12\"><col-responsive ng-repeat=\"role_id in entry.document.approval.roles_id\"><div class=input-group><div class=input-group-addon><span>{{$index+1}}</span></div><ui-select ng-model=role_id ng-disabled=true class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (consumption.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=consumption.delApprovalRole(role_id) ng-disabled=\"consumption.approval_not_editable || consumption.is_executor\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></span></div></col-responsive></div></div></panel></div>");
$templateCache.put("app/docs/consumption/product_select.html","<!--\nCreated by ilias on 30/08/16.\n\n--><form ng-submit=product.productSave() class=modal-content><div class=modal-header><h3>Выбор продукта</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Продукт</label><product-select product-id=product.product.product_id product-unit-id=product.product.unit_id on-product-load=product.onProductLoaded($product)></product-select></div></col-responsive><col-responsive stock-dict=product.units dict-table=Units dict-filter={_id:product.product.unit_id}><div class=form-group><label>Единица измерения</label><ui-select ng-model=product.product.unit_id ng-disabled=true><ui-select-match ng-value=\"product.product.unit=$select.selected\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"unit._id as unit in product.units | filter:$select.search track by unit._id\">{{unit.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=product.pr dict-table=PricingRules dict-filter={product_id:product.product.product_id} dict-on-load=product.onRulesLoaded() class=form-group><label>Скидка</label><ui-select ng-model=product.product.rules_id on-select=product.onRuleSelect() multiple><ui-select-match allow-clear=true>{{$item.discount}}%</ui-select-match><ui-select-choices repeat=\"rule._id as rule in product.pr | filter:$select.search | orderBy:&quot;rule.priority&quot;\"><div ng-if=\"rule._id !== undefined\" class=row><div class=\"col col-sm-6\"><span>Приоритет: {{rule.priority}}</span></div><div class=\"col col-sm-6\"><span>Скидка: {{rule.discount}}%</span></div><div class=\"col col-sm-12 small\"><div ng-show=rule.valid_from>От: {{rule.valid_from | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div><div ng-show=rule.valid_up_to>До: {{rule.valid_up_to | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div></div></div></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Количество</label><input type=number min={{product.product.unit.data.round}} step={{product.product.unit.data.round}} ng-model=product.product.quantity ng-change=product.calcTotalCost(product.product);product.calcUnitPrice(product.product) ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Цена за единицу</label><input type=number step=0.01 ng-model=product.product.quote_unit_price ng-change=product.calcTotalCost(product.product) class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дополнительная стоимость</label><input type=number step=0.01 ng-model=product.product.additional_cost class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Общая стоимость</label><input type=number step=0.01 ng-model=product.product.total_cost ng-change=product.calcUnitPrice(product.product) class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=product.product.comment class=form-control></textarea></div></col-responsive></div></div><div class=modal-footer><button type=button ng-click=product.cancel() class=\"btn btn-warning btn-sm\">Отмена</button> <button class=\"btn btn-primary btn-sm\">Сохранить</button></div></form>");
$templateCache.put("app/docs/consumption/view.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsConsumptionViewController as consumption\" class=container><div class=container><h3>{{view.document.title}}</h3><label class=margin-right-8>{{view.document.document_status_value.data.name}}</label><label class=pull-right>Создан <span am-time-ago=view.document.data.date></span></label></div><div class=ln_solid></div><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Филиал</col-responsive><col-responsive class=col-lg-10>{{view.document.branch.name}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Назначение ЦЗ</col-responsive><col-responsive class=col-lg-10>{{view.document.purpose.name}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Принимающий</col-responsive><col-responsive class=col-lg-10>{{view.document.executor.username}}</col-responsive></div><div ng-if=view.document.data.delivery_date class=row><col-responsive class=col-lg-2>Дата доставки</col-responsive><col-responsive class=col-lg-10>{{view.document.data.delivery_date | amDateFormat:\"Do MMMM YYYY\"}}</col-responsive></div><div ng-if=view.document.short_desc class=row><col-responsive class=col-lg-2>Короткое описание</col-responsive><col-responsive class=col-lg-10>{{view.document.short_desc}}</col-responsive></div><div ng-if=view.document.data.comment class=row><col-responsive class=col-lg-2>Комментарий</col-responsive><col-responsive class=col-lg-10>{{view.document.data.comment}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Источник</col-responsive><col-responsive class=col-lg-10>{{view.document.product_source_value.data.name}}</col-responsive></div><div ng-if=\"view.document.data.branch_id &amp;&amp; view.document.data.product_source==&quot;branch&quot;\" class=row><col-responsive class=col-lg-2>Филиал источник</col-responsive><col-responsive class=col-lg-10>{{view.document.branch2.name}}</col-responsive></div><div ng-if=\"view.document.data.contractor_id &amp;&amp; view.document.data.product_source==&quot;contractor&quot;\" class=row><col-responsive class=col-lg-2>Контрагент</col-responsive><col-responsive class=col-lg-10>{{view.document.contractor.name}}</col-responsive></div><div ng-if=view.document.data.is_advance class=row><col-responsive class=col-lg-2>Сотрудник</col-responsive><col-responsive class=col-lg-10>{{view.document.employee.user.username}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Способ оплаты</col-responsive><col-responsive class=col-lg-10><span ng-show=\"!view.document.data.is_due &amp;&amp; !view.document.data.is_advance\">Наличные</span><span ng-show=view.document.data.is_due>В долг</span><span ng-show=view.document.data.is_advance>Аванс</span></col-responsive></div><div ng-if=view.document.data.due_date class=row><col-responsive class=col-lg-2>Дата выплаты</col-responsive><col-responsive class=col-lg-10>{{view.document.data.due_date | amDateFormat:\"Do MMMM YYYY\"}}</col-responsive></div></div><div class=ln_solid></div><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>Продукт</th><th>Единица изм.</th><th>Количество</th><th>Цена за ед.</th><th>Общая стоимость</th><th>Дополнительная стоимость</th><th>Комментарий</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.products\"><td><span ng-repeat=\"product_item in view.document.products|filter: {_id:product.product_id} track by product_item._id\">{{product_item.name}}</span></td><td><span ng-repeat=\"unit_item in view.document.units|filter: {_id:product.unit_id} track by unit_item._id\">{{unit_item.name}}</span></td><td>{{product.quantity | number}}</td><td>{{product.quote_unit_price | number}}</td><td>{{product.total_cost | number}}</td><td>{{product.additional_cost | number}}</td><td>{{product.comment}}</td></tr></tbody></table></div><div class=row><div class=\"col col-xs-12\"><div class=text-right><h4>Итоговая сумма</h4><label>{{view.document.currency.name}} {{consumption.totalSum() | number}}</label></div></div></div><div ng-show=view.document.approval.required><div class=ln_solid></div><h4>Одобрения</h4><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Должны одобрить</col-responsive><col-responsive class=col-lg-10>{{view.document.approval_type_value.data.name}}</col-responsive></div></div><ul><li ng-repeat=\"approval_role in view.document.approval.approval_roles\"><h5 ng-class=\"{&quot;text-success&quot;:approval_role.approved===true, &quot;text-danger&quot;:approval_role.approved===false}\"><span ng-show=\"approval_role.approved===true\" class=\"glyphicon glyphicon-ok-circle margin-right-8\"></span><span ng-show=\"approval_role.approved===false\" class=\"glyphicon glyphicon-remove-circle margin-right-8\"></span><span ng-repeat=\"role in view.document.roles|filter:{_id:approval_role.role_id} track by role._id\">{{role.data.approval_name}}</span></h5><ul><li ng-repeat=\"approval_user in approval_role.approval_users\" ng-class=\"{&quot;text-success&quot;:approval_user.approved===true, &quot;text-danger&quot;:approval_user.approved===false}\"><span class=\"fa fa-user margin-right-8\"></span><span ng-repeat=\"user in view.document.approval_users|filter:{id:approval_user.user_id} track by user.id\">{{user.username}}</span></li></ul></li></ul></div><div class=ln_solid></div><document-comment document-id=view.document._id></document-comment></div>");
$templateCache.put("app/docs/customer_payment/discount_select.html","<!--\nCreated by ilias on 30/08/16.\n\n--><form ng-submit=product.productSave() class=modal-content><div class=modal-header><h3>Выбор услуги</h3></div><div class=modal-body><div class=row><col-responsive><div stock-dict=product.pr dict-table=PricingRules dict-filter={product_id:product.product.product_id} class=form-group><label>Скидка</label><ui-select ng-model=product.product.rules_id on-select=product.onRuleSelect() multiple><ui-select-match allow-clear=true>{{$item.discount}}%</ui-select-match><ui-select-choices repeat=\"rule._id as rule in product.pr | filter:$select.search | orderBy:&quot;rule.priority&quot;\"><div ng-if=\"rule._id !== undefined\" class=row><div class=\"col col-sm-6\"><span>Приоритет: {{rule.priority}}</span></div><div class=\"col col-sm-6\"><span>Скидка: {{rule.discount}}%</span></div><div class=\"col col-sm-12 small\"><div ng-show=rule.valid_from>От: {{rule.valid_from | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div><div ng-show=rule.valid_up_to>До: {{rule.valid_up_to | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div></div></div></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Цена</label><input type=number step=0.01 ng-model=product.product_sum ng-change=product.calcTotalCost(product.product) class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Итоговая стоимость</label><input type=number step=0.01 ng-model=product.total_sum ng-disabled=true class=form-control></div></col-responsive></div></div><div class=modal-footer><button type=button ng-click=product.cancel() class=\"btn btn-warning btn-sm\">Отмена</button> <button class=\"btn btn-primary btn-sm\">Сохранить</button></div></form>");
$templateCache.put("app/docs/customer_payment/edit.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsCustomerPaymentEditController as customer_payment\" class=container><div class=row><col-responsive><div class=form-group><label>Исполнитель</label><employee-select employee-id=entry.document.data.executor_id ng-disabled=\"customer_payment.executor_not_editable || customer_payment.is_executor\"></employee-select></div></col-responsive><col-responsive><div class=form-group><label>Короткое описание</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=entry.document.data.comment class=form-control></textarea></div></col-responsive></div><div class=ln_solid></div><div class=row><col-responsive><div class=form-group><label>Пациент</label><contractor-select contractor-id=entry.document.data.contractor_id></contractor-select></div></col-responsive><col-responsive><div stock-dict=customer_payment.pr dict-table=PricingRules dict-filter={product_id:customer_payment.product.product_id} class=form-group><label>Скидка</label><ui-select ng-model=customer_payment.product.rules_id on-select=customer_payment.onRuleSelect() on-remove=customer_payment.onRuleSelect() multiple><ui-select-match allow-clear=true>{{$item.discount}}%</ui-select-match><ui-select-choices repeat=\"rule._id as rule in customer_payment.pr | filter:$select.search | orderBy:&quot;rule.priority&quot;\"><div ng-if=\"rule._id !== undefined\" class=row><div class=\"col col-sm-6\"><span>Приоритет: {{rule.priority}}</span></div><div class=\"col col-sm-6\"><span>Скидка: {{rule.discount}}%</span></div><div class=\"col col-sm-12 small\"><div ng-show=rule.valid_from>От: {{rule.valid_from | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div><div ng-show=rule.valid_up_to>До: {{rule.valid_up_to | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div></div></div></ui-select-choices></ui-select></div></col-responsive></div><div class=ln_solid></div><div class=row><col-responsive><div stock-dict=customer_payment.currencies dict-table=Currencies dict-on-load=customer_payment.currenciesLoaded($event) class=form-group><label>Валюта</label><ui-select ng-model=entry.document.data.currency_id><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"currency._id as currency in (customer_payment.currencies | filter:{name:$select.search} | orderBy:&quot;currency.name&quot;) track by currency._id\"><span ng-bind=currency.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Фактические оплата</label><input ng-model=entry.document.data.fact_amount ng-trim=true type=number class=form-control></div></col-responsive></div><panel title=Услуги ng-show=entry.document><button ng-disabled=\"entry.saving==true\" type=button ng-click=customer_payment.productNew() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=\"entry.saving==true || !customer_payment.selected_product\" type=button ng-click=customer_payment.openSelectEmployee(customer_payment.selected_product) class=\"btn btn-default btn-sm\">Врач</button> <button ng-disabled=\"entry.saving==true || !customer_payment.selected_product\" type=button ng-click=customer_payment.productRemove() class=\"btn btn-danger btn-sm\">Удалить</button><paged-table options=customer_payment.productsGridOptions disable-search=true disable-paging=true></paged-table></panel><panel title=Платежи><div class=row><col-responsive><div class=row><div class=\"col col-xs-12\"><div class=text-left><h4>Итоговая стоимость</h4><label>{{customer_payment.total_sum | number}}</label></div></div></div></col-responsive><col-responsive><div class=row><div class=\"col col-xs-12\"><div class=text-left><h4>Долг</h4><label>{{customer_payment.paymentSum | number}}</label></div></div></div></col-responsive></div></panel></div>");
$templateCache.put("app/docs/customer_payment/medical_examination-select-modal.html","<div class=modal-header><h3>Медосмотр</h3></div><div class=modal-body><div class=list-group><a ng-repeat=\"doc in medical_examination.docs track by doc._id\" ng-click=medical_examination.docSelect(doc) href=javascript:void(0) class=list-group-item><div class=media><div class=media-left><img ng-src={{app.api}}image/docs/default/{{doc.document_type}}.svg class=document_icon_small></div><div class=media-body><b>{{doc.title}}<span am-time-ago=doc._created class=\"small pull-right\"></span></b><div>{{doc.short_desc}}</div><div ng-switch=doc.document_status class=small><span ng-switch-when=draft class=\"label label-default\">&bull; Черновик</span><span ng-switch-when=approval class=\"label label-warning\">&bull; На одобрение</span><span ng-switch-when=approved class=\"label label-success\">&bull; Одобрен</span><span ng-switch-when=rejected class=\"label label-danger\">&bull; Отклонен</span><span ng-switch-when=committed class=\"label label-default\">&bull; Исполнен</span></div></div></div></a></div><div ng-show=medical_examination.doc_loading class=\"loading-spinner fadeIn fadeOut animated\"><div id=circularG><div id=circularG_1 class=circularG></div><div id=circularG_2 class=circularG></div><div id=circularG_3 class=circularG></div><div id=circularG_4 class=circularG></div><div id=circularG_5 class=circularG></div><div id=circularG_6 class=circularG></div><div id=circularG_7 class=circularG></div><div id=circularG_8 class=circularG></div></div></div></div><div class=modal-footer><button type=button ng-click=medical_examination.cancel() class=\"btn btn-default btn-sm\">Отмена</button></div>");
$templateCache.put("app/docs/customer_payment/view.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsCustomerPaymentViewController as customer_payment\" class=container><div class=container><h3>{{view.document.title}}</h3><label class=margin-right-8>{{view.document.document_status_value.data.name}}</label><label class=pull-right>Создан <span am-time-ago=view.document.data.date></span></label></div><div class=ln_solid></div><div class=\"row-striped row-v-padding row-col-bold\"><div ng-if=view.document.branch_id class=row><col-responsive class=col-lg-2>Филиал</col-responsive><col-responsive class=col-lg-10>{{view.document.branch.name}}</col-responsive></div><div ng-if=view.document.data.executor_id class=row><col-responsive class=col-lg-2>Исполнитель</col-responsive><col-responsive class=col-lg-10>{{view.document.executor.username}}</col-responsive></div><div ng-if=view.document.short_desc class=row><col-responsive class=col-lg-2>Короткое описание</col-responsive><col-responsive class=col-lg-10>{{view.document.short_desc}}</col-responsive></div><div ng-if=view.document.data.comment class=row><col-responsive class=col-lg-2>Комментарий</col-responsive><col-responsive class=col-lg-10>{{view.document.data.comment}}</col-responsive></div><div ng-if=view.document.data.contractor_id class=row><col-responsive class=col-lg-2>Контрагент</col-responsive><col-responsive class=col-lg-10>{{view.document.contractor.name}}</col-responsive></div></div><div class=ln_solid></div><panel title=Услуги><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>Услуга</th><th>Врач</th><th>Цена</th><th>Итоговая стоимость</th><th>Скидка (%)</th><th>Комментарий</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.products\"><td><span ng-repeat=\"product_item in view.document.products|filter: {_id:product.product_id} track by product_item._id\">{{product_item.name}}</span></td><td><span ng-repeat=\"employee_item in view.document.employees|filter: {id:product.employee_id} track by employee_item.id\">{{employee_item.data.surname || employee_item.data.name || employee_item.data.middlename ? ((employee_item.data.surname ? employee_item.data.surname + \' \' : \'\') + (employee_item.data.name ? employee_item.data.name + \' \' : \'\') + (employee_item.data.middlename ? employee_item.data.middlename + \' \' : \'\')) : employee_item.username}}</span></td><td>{{product.quote_unit_price | number}}</td><td>{{product.total_cost | number}}</td><td>{{product.discount | number}}</td><td>{{product.comment}}</td></tr></tbody></table></div><div class=row><div class=\"col col-xs-12\"><div class=text-right><h4>Итоговая сумма</h4><label>{{view.document.currency.name}} {{customer_payment.totalSum() | number}}</label></div></div></div><div class=row><div class=\"col col-xs-12\"><div class=text-right><h4>Оплачено</h4><label>{{view.document.currency.name}} {{view.document.data.fact_amount | number}}</label></div></div></div><div class=row><div class=\"col col-xs-12\"><div class=text-right><h4>Долг</h4><label>{{view.document.currency.name}} {{customer_payment.paymentSum | number}}</label></div></div></div></panel><div class=ln_solid></div><document-comment document-id=view.document._id></document-comment></div>");
$templateCache.put("app/docs/letter/edit.html","<div ng-controller=\"DocsLetterEditController as letter\" class=container><div class=row><col-responsive><div class=form-group><label>{{\'Номер\'|translate}}</label><input type=text ng-model=entry.document.number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Дата регистрации\'|translate}}</label><div class=input-group><input type=text name=valid_from ng-model=entry.document.reg_date uib-datepicker-popup=dd.MM.yyyy datepicker-options=letter.dateOptions is-open=letter.dateOptions.opened1 close-text=\"{{ \'Закрыть\' | translate}}\" current-text=\"{{ \'Сегодня\' | translate}}\" clear-text=\"{{ \'Очистить\' | translate}}\" class=form-control><div class=input-group-append><button type=button ng-click=\"letter.dateOptions.opened1 = true\" class=\"btn btn-secondary\"><i class=\"fa fa-calendar\"></i></button></div></div></div></col-responsive><col-responsive><div class=form-group><label>{{\'Исходящий № документа\'|translate}}</label><input type=text ng-model=entry.document.sendnumber ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Исходящая дата документа\'|translate}}</label><div class=input-group><input type=text name=valid_from ng-model=entry.document.reg_date uib-datepicker-popup=dd.MM.yyyy datepicker-options=letter.dateOptions is-open=letter.dateOptions.opened1 close-text=\"{{ \'Закрыть\' | translate}}\" current-text=\"{{ \'Сегодня\' | translate}}\" clear-text=\"{{ \'Очистить\' | translate}}\" class=form-control><div class=input-group-append><button type=button ng-click=\"letter.dateOptions.opened1 = true\" class=\"btn btn-secondary\"><i class=\"fa fa-calendar\"></i></button></div></div></div></col-responsive><col-responsive><div class=form-group><label>{{\'Количество листов\'|translate}}</label><input type=number ng-model=entry.document.number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>{{\'Исполнитель\'|translate}}</label><search-input modelobject=entry.document.user modeldisplay=entry.document.user modelret=entry.document.user_id></search-input></div></col-responsive><col-responsive><div class=form-group><label>{{\'Резолюция руководителя\'|translate}}</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>{{\'Откуда поступил\'|translate}}</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>{{\'Содержание\'|translate}}</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>{{\'Примечание\'|translate}}</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive></div></div>");
$templateCache.put("app/docs/letter/view.html","");
$templateCache.put("app/docs/medical_examination/customer_payment-select-modal.html","<div class=modal-header><h3>Прием оплаты</h3></div><div class=modal-body><div class=list-group><a ng-click=customer_payment.docSelect() href=javascript:void(0) class=list-group-item><div class=media><div class=media-left><div class=document_icon_small><div class=\"fa fa-plus fa-3x fa-align-center\"></div></div></div><div class=media-body><b>Новый документ</b><div>Оформить новый прием оплаты</div></div></div></a><a ng-repeat=\"doc in customer_payment.docs track by doc._id\" ng-click=customer_payment.docSelect(doc._id) href=javascript:void(0) class=list-group-item><div class=media><div class=media-left><img ng-src={{app.api}}image/docs/default/{{doc.document_type}}.svg class=document_icon_small></div><div class=media-body><b>{{doc.title}}<span am-time-ago=doc._created class=\"small pull-right\"></span></b><div>{{doc.short_desc}}</div><div ng-switch=doc.document_status class=small><span ng-switch-when=draft class=\"label label-default\">&bull; Черновик</span><span ng-switch-when=approval class=\"label label-warning\">&bull; На одобрение</span><span ng-switch-when=approved class=\"label label-success\">&bull; Одобрен</span><span ng-switch-when=rejected class=\"label label-danger\">&bull; Отклонен</span><span ng-switch-when=committed class=\"label label-default\">&bull; Исполнен</span></div></div></div></a></div><div ng-show=customer_payment.doc_loading class=\"loading-spinner fadeIn fadeOut animated\"><div id=circularG><div id=circularG_1 class=circularG></div><div id=circularG_2 class=circularG></div><div id=circularG_3 class=circularG></div><div id=circularG_4 class=circularG></div><div id=circularG_5 class=circularG></div><div id=circularG_6 class=circularG></div><div id=circularG_7 class=circularG></div><div id=circularG_8 class=circularG></div></div></div></div><div class=modal-footer><button type=button ng-click=customer_payment.cancel() class=\"btn btn-default btn-sm\">Отмена</button></div>");
$templateCache.put("app/docs/medical_examination/discount_select.html","<!--\nCreated by ilias on 30/08/16.\n\n--><form ng-submit=product.productSave() class=modal-content><div class=modal-header><h3>Выбор услуги</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Услуга</label><product-select product-id=product.product.product_id modal-options=product.productModalOptions></product-select></div></col-responsive><col-responsive><div stock-dict=product.pr dict-table=PricingRules dict-filter={product_id:product.product.product_id} class=form-group><label>Скидка</label><ui-select ng-model=product.product.rules_id on-select=product.onRuleSelect() multiple><ui-select-match allow-clear=true>{{$item.discount}}%</ui-select-match><ui-select-choices repeat=\"rule._id as rule in product.pr | filter:$select.search | orderBy:&quot;rule.priority&quot;\"><div ng-if=\"rule._id !== undefined\" class=row><div class=\"col col-sm-6\"><span>Приоритет: {{rule.priority}}</span></div><div class=\"col col-sm-6\"><span>Скидка: {{rule.discount}}%</span></div><div class=\"col col-sm-12 small\"><div ng-show=rule.valid_from>От: {{rule.valid_from | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div><div ng-show=rule.valid_up_to>До: {{rule.valid_up_to | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div></div></div></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Цена</label><input type=number step=0.01 ng-model=product.product.quote_unit_price ng-change=product.calcTotalCost(product.product) class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Итоговая стоимость</label><input type=number step=0.01 ng-model=product.product.total_cost ng-disabled=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=product.product.comment class=form-control></textarea></div></col-responsive></div></div><div class=modal-footer><button type=button ng-click=product.cancel() class=\"btn btn-warning btn-sm\">Отмена</button> <button class=\"btn btn-primary btn-sm\">Сохранить</button></div></form>");
$templateCache.put("app/docs/medical_examination/edit.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsMedicalExaminationEditController as medical_examination\" class=container><div class=row><col-responsive><div class=form-group><label>Пациент</label><contractor-select contractor-id=entry.document.data.contractor_id item=entry.document.data.patient modal-options=medical_examination.contractorModalOptions></contractor-select></div></col-responsive><col-responsive><div class=form-group><label>Дата приема</label><div class=\"input-group no-margin\"><input type=text uib-dtpicker-popup ng-model=entry.document.data.reception_date is-open=medical_examination.popup_delivery_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"medical_examination.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=entry.document.data.comment class=form-control></textarea></div></col-responsive></div><div class=ln_solid></div><div class=row><col-responsive><div stock-dict=medical_examination.branches dict-table=Branches class=form-group><label>Филиал</label><branch-select ng-model=entry.document.branch_id branches=medical_examination.branches ng-required=true></branch-select></div></col-responsive><col-responsive><div class=form-group><label>Принимающий</label><employee-select employee-id=entry.document.data.executor_id ng-disabled=\"medical_examination.executor_not_editable || medical_examination.is_executor\"></employee-select></div></col-responsive></div><panel title=Услуги ng-show=entry.document><button ng-disabled=\"entry.saving==true\" type=button ng-click=medical_examination.productNew() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=\"entry.saving==true || !medical_examination.selected_product\" type=button ng-click=medical_examination.discountEdit() class=\"btn btn-default btn-sm\">Скидка</button> <button ng-disabled=\"entry.saving==true || !medical_examination.selected_product\" type=button ng-click=medical_examination.productRemove() class=\"btn btn-danger btn-sm\">Удалить</button><paged-table options=medical_examination.productsGridOptions disable-search=true disable-paging=true></paged-table></panel></div>");
$templateCache.put("app/docs/medical_examination/view.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsMedicalExaminationViewController as medical_examination\" class=container><div class=container><h3>{{view.document.title}}</h3><label class=margin-right-8>{{view.document.document_status_value.data.name}}</label><label class=pull-right>Создан <span am-time-ago=view.document.data.date></span></label></div><div class=ln_solid></div><div class=\"row-striped row-v-padding row-col-bold\"><div ng-if=view.document.branch_id class=row><col-responsive class=col-lg-2>Филиал</col-responsive><col-responsive class=col-lg-10>{{view.document.branch.name}}</col-responsive></div><div ng-if=view.document.data.executor_id class=row><col-responsive class=col-lg-2>Принимающий</col-responsive><col-responsive class=col-lg-10>{{view.document.executor.username}}</col-responsive></div><div ng-if=view.document.data.delivery_date class=row><col-responsive class=col-lg-2>Дата приема</col-responsive><col-responsive class=col-lg-10>{{view.document.data.reception_date | amDateFormat:\"Do MMMM YYYY, HH:mm\"}}</col-responsive></div><div ng-if=view.document.short_desc class=row><col-responsive class=col-lg-2>Короткое описание</col-responsive><col-responsive class=col-lg-10>{{view.document.short_desc}}</col-responsive></div><div ng-if=view.document.data.comment class=row><col-responsive class=col-lg-2>Комментарий</col-responsive><col-responsive class=col-lg-10>{{view.document.data.comment}}</col-responsive></div><div ng-if=view.document.data.contractor_id class=row><col-responsive class=col-lg-2>Пациент</col-responsive><col-responsive class=col-lg-10>{{view.document.contractor.name}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Способ оплаты</col-responsive><col-responsive class=col-lg-10><span ng-show=!view.document.data.is_due>Наличные</span><span ng-show=view.document.data.is_due>В долг</span></col-responsive></div><div ng-if=view.document.data.due_date class=row><col-responsive class=col-lg-2>Дата выплаты</col-responsive><col-responsive class=col-lg-10>{{view.document.data.due_date | amDateFormat:\"Do MMMM YYYY\"}}</col-responsive></div><div ng-if=view.document.customer_payment_documents.length&gt;0 class=row><col-responsive class=col-lg-2>Документы оплаты оформленные по записи на медосмотр</col-responsive><col-responsive class=col-lg-10><a ng-repeat=\"document in view.document.customer_payment_documents\" ui-sref=\"app.approval.view({type:document.document_type, id: document._id})\">{{document.title}} {{!$last?\',\':\'\'}}</a></col-responsive></div></div><div class=ln_solid></div><panel title=Услуги><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>Услуга</th><th>Цена</th><th>Итоговая стоимость</th><th>Скидка (%)</th><th>Комментарий</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.products\"><td><span ng-repeat=\"product_item in view.document.products|filter: {_id:product.product_id} track by product_item._id\">{{product_item.name}}</span><span ng-repeat=\"unit_item in view.document.units|filter: {_id:product.unit_id} track by unit_item._id\"> {{unit_item.name}}</span></td><td>{{product.quote_unit_price | number}}</td><td>{{product.total_cost | number}}</td><td>{{product.discount | number}}</td><td>{{product.comment}}</td></tr></tbody></table></div><div class=row><div class=\"col col-xs-12\"><div class=text-right><h4>Итоговая сумма</h4><label>{{view.document.currency.name}} {{medical_examination.totalSum() | number}}</label></div></div></div></panel><panel title=\"Оплаченные услуги\" ng-show=\"view.document.data.payd_products.length &gt; 0\"><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>Продукт</th><th>Количество</th><th>Документ</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.delivered_products\"><td><span ng-repeat=\"product_item in view.document.products|filter: {_id:product.product_id} track by product_item._id\">{{product_item.name}}</span></td><td>{{product.quantity | number}}<span ng-repeat=\"unit_item in view.document.units|filter: {_id:product.unit_id} track by unit_item._id\"> {{unit_item.name}}</span></td><td><span ng-repeat=\"document in view.document.documents|filter: {_id:product.document_id} track by document._id\"><a ui-sref=\"app.approval.view({id:document._id, type:document.document_type})\">{{document.title}}</a></span></td></tr></tbody></table></div></panel><div class=form-group><button ng-click=medical_examination.createCustomerPayment() ng-show=medical_examination.canCreateCustomerPayment() class=\"btn btn-primary btn-sm pull-right\">Оформить прием оплаты</button><div class=clearfix></div></div><div class=ln_solid></div><document-comment document-id=view.document._id></document-comment></div>");
$templateCache.put("app/docs/move/edit.html","<!--\nCreated by troy   on 03/08/16.\n\n--><div ng-controller=\"DocsMoveEditController as move\" class=container><div class=row><col-responsive><div class=form-group><label>Заголовок</label><input type=text ng-model=entry.document.title ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div stock-dict=move.branches dict-table=Branches class=form-group><label>Филиал</label><branch-select ng-model=entry.document.branch_id branches=move.branches ng-required=true></branch-select></div></col-responsive><col-responsive><div class=form-group><label>Принимающий</label><employee-select employee-id=entry.document.data.executor_id ng-disabled=\"move.executor_not_editable || move.is_executor\"></employee-select></div></col-responsive><col-responsive><div class=form-group><label>Дата доставки</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=entry.document.data.delivery_date is-open=move.popup_delivery_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"move.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Короткое описание</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=entry.document.data.comment class=form-control></textarea></div></col-responsive></div><div class=ln_solid></div><div class=row><col-responsive><div stock-dict=move.branches dict-table=Branches ng-disabled=move.is_executor class=form-group><label>Филиал назначения</label><branch-select ng-model=entry.document.data.branch_id branches=move.branches ng-required=true></branch-select></div></col-responsive><col-responsive><div stock-dict=move.currencies dict-table=Currencies class=form-group><label>Валюта</label><ui-select ng-model=entry.document.data.currency_id><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"currency._id as currency in (move.currencies | filter:{name:$select.search} | orderBy:&quot;currency.name&quot;) track by currency._id\"><span ng-bind=currency.name></span></ui-select-choices></ui-select></div></col-responsive></div><panel title=Товары ng-show=entry.document><button ng-disabled=\"entry.saving==true\" type=button ng-click=move.productNew() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=\"entry.saving==true || !move.selected_product\" type=button ng-click=move.productEdit() class=\"btn btn-default btn-sm\">Изменить</button> <button ng-disabled=\"entry.saving==true || !move.selected_product\" type=button ng-click=move.productRemove() class=\"btn btn-danger btn-sm\">Удалить</button><paged-table options=move.productsGridOptions disable-search=true disable-paging=true></paged-table></panel><panel title=Одобрение collapsed=true><div class=row><col-responsive><div class=form-group><label>Требуется одобрение</label><label class=form-control><div class=checkbox-inline><input type=checkbox ng-model=entry.document.approval.required ng-disabled=\"move.approval_not_editable || move.is_executor\"><span ng-show=entry.document.approval.required>Требуется одобрение</span><span ng-hide=entry.document.approval.required>Одобрение не требуется</span></div></label></div></col-responsive><col-responsive><div ng-init=\"entry.document.approval.approval_type=&quot;one&quot;\" class=form-group><label>Должны одобрить<span uib-tooltip=\"Сколько пользователей из каждой роли должны одобрить\" class=\"fa fa-question-circle\"></span></label><div stock-dict=move.approval_types dict-table=Enums dict-filter={name:&quot;approval_type&quot;} class=form-control><label ng-repeat=\"type in move.approval_types track by type.data.key\" class=radio-inline><input type=radio ng-model=entry.document.approval.approval_type ng-value=type.data.key ng-disabled=\"!entry.document.approval.required || move.approval_not_editable || move.is_executor\"><span>{{type.data.name}}</span></label></div></div></col-responsive><col-responsive><div class=form-group><label>Добавить роль для одобрения<span uib-tooltip=\"Одобрение будет проходить по порядку добавления ролей\" class=\"fa fa-question-circle\"></span></label><div stock-dict=move.roles dict-table=Roles class=input-group><ui-select ng-model=move.approval_role_id ng-disabled=\"!entry.document.approval.required || move.approval_not_editable || move.is_executor\" class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (move.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-disabled=\"!move.approval_role_id || !entry.document.approval.required || move.approval_not_editable || move.is_executor\" ng-click=move.addApprovalRole() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-plus text-primary\"></span></button></span></div></div></col-responsive><div class=\"col col-xs-12\"><label>Роли для одобрения</label></div><div stock-dict=move.roles dict-table=Roles class=\"col col-xs-12\"><col-responsive ng-repeat=\"role_id in entry.document.approval.roles_id\"><div class=input-group><div class=input-group-addon><span>{{$index+1}}</span></div><ui-select ng-model=role_id ng-disabled=true class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (move.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=move.delApprovalRole(role_id) ng-disabled=\"move.approval_not_editable || move.is_executor\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></span></div></col-responsive></div></div></panel></div>");
$templateCache.put("app/docs/move/product_select.html","<!--\nCreated by troy on 30/08/16.\n\n--><form ng-submit=product.productSave() class=modal-content><div class=modal-header><h3>Выбор продукта</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Продукт</label><product-select product-id=product.product.product_id product-unit-id=product.product.unit_id on-product-load=product.onProductLoaded($product)></product-select></div></col-responsive><col-responsive stock-dict=product.units dict-table=Units dict-filter={_id:product.product.unit_id}><div class=form-group><label>Единица измерения</label><ui-select ng-model=product.product.unit_id ng-disabled=true><ui-select-match ng-value=\"product.product.unit=$select.selected\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"unit._id as unit in product.units | filter:$select.search track by unit._id\">{{unit.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=product.pr dict-table=PricingRules dict-filter={product_id:product.product.product_id} dict-on-load=product.onRulesLoaded() class=form-group><label>Скидка</label><ui-select ng-model=product.product.rules_id on-select=product.onRuleSelect() multiple><ui-select-match allow-clear=true>{{$item.discount}}%</ui-select-match><ui-select-choices repeat=\"rule._id as rule in product.pr | filter:$select.search | orderBy:&quot;rule.priority&quot;\"><div ng-if=\"rule._id !== undefined\" class=row><div class=\"col col-sm-6\"><span>Приоритет: {{rule.priority}}</span></div><div class=\"col col-sm-6\"><span>Скидка: {{rule.discount}}%</span></div><div class=\"col col-sm-12 small\"><div ng-show=rule.valid_from>От: {{rule.valid_from | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div><div ng-show=rule.valid_up_to>До: {{rule.valid_up_to | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div></div></div></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Количество</label><input type=number min={{product.product.unit.data.round}} step={{product.product.unit.data.round}} ng-model=product.product.quantity ng-change=product.calcTotalCost(product.product);product.calcUnitPrice(product.product) ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Цена за единицу</label><input type=number step=0.01 ng-model=product.product.quote_unit_price ng-change=product.calcTotalCost(product.product) class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дополнительная стоимость</label><input type=number step=0.01 ng-model=product.product.additional_cost class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Общая стоимость</label><input type=number step=0.01 ng-model=product.product.total_cost ng-change=product.calcUnitPrice(product.product) class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=product.product.comment class=form-control></textarea></div></col-responsive></div></div><div class=modal-footer><button type=button ng-click=product.cancel() class=\"btn btn-warning btn-sm\">Отмена</button> <button class=\"btn btn-primary btn-sm\">Сохранить</button></div></form>");
$templateCache.put("app/docs/move/view.html","<!--\nCreated by troy on 03/08/16.\n\n--><div ng-controller=\"DocsMoveViewController as move\" class=container><div class=container><h3>{{view.document.title}}</h3><label class=margin-right-8>{{view.document.document_status_value.data.name}}</label><label class=pull-right>Создан <span am-time-ago=view.document.data.date></span></label></div><div class=ln_solid></div><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Филиал</col-responsive><col-responsive class=col-lg-10>{{view.document.branch.name}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Принимающий</col-responsive><col-responsive class=col-lg-10>{{view.document.executor.username}}</col-responsive></div><div ng-if=view.document.data.delivery_date class=row><col-responsive class=col-lg-2>Дата доставки</col-responsive><col-responsive class=col-lg-10>{{view.document.data.delivery_date | amDateFormat:\"Do MMMM YYYY\"}}</col-responsive></div><div ng-if=view.document.short_desc class=row><col-responsive class=col-lg-2>Короткое описание</col-responsive><col-responsive class=col-lg-10>{{view.document.short_desc}}</col-responsive></div><div ng-if=view.document.data.comment class=row><col-responsive class=col-lg-2>Комментарий</col-responsive><col-responsive class=col-lg-10>{{view.document.data.comment}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Филиал назначения</col-responsive><col-responsive class=col-lg-10>{{view.document.branch2.name}}</col-responsive></div></div><div class=ln_solid></div><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>Продукт</th><th>Единица изм.</th><th>Количество</th><th>Цена за ед.</th><th>Общая стоимость</th><th>Дополнительная стоимость</th><th>Комментарий</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.products\"><td><span ng-repeat=\"product_item in view.document.products|filter: {_id:product.product_id} track by product_item._id\">{{product_item.name}}</span></td><td><span ng-repeat=\"unit_item in view.document.units|filter: {_id:product.unit_id} track by unit_item._id\">{{unit_item.name}}</span></td><td>{{product.quantity | number}}</td><td>{{product.quote_unit_price | number}}</td><td>{{product.total_cost | number}}</td><td>{{product.additional_cost | number}}</td><td>{{product.comment}}</td></tr></tbody></table></div><div class=row><div class=\"col col-xs-12\"><div class=text-right><h4>Итоговая сумма</h4><label>{{view.document.currency.name}} {{move.totalSum() | number}}</label></div></div></div><div ng-show=view.document.approval.required><div class=ln_solid></div><h4>Одобрения</h4><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Должны одобрить</col-responsive><col-responsive class=col-lg-10>{{view.document.approval_type_value.data.name}}</col-responsive></div></div><ul><li ng-repeat=\"approval_role in view.document.approval.approval_roles\"><h5 ng-class=\"{&quot;text-success&quot;:approval_role.approved===true, &quot;text-danger&quot;:approval_role.approved===false}\"><span ng-show=\"approval_role.approved===true\" class=\"glyphicon glyphicon-ok-circle margin-right-8\"></span><span ng-show=\"approval_role.approved===false\" class=\"glyphicon glyphicon-remove-circle margin-right-8\"></span><span ng-repeat=\"role in view.document.roles|filter:{_id:approval_role.role_id} track by role._id\">{{role.data.approval_name}}</span></h5><ul><li ng-repeat=\"approval_user in approval_role.approval_users\" ng-class=\"{&quot;text-success&quot;:approval_user.approved===true, &quot;text-danger&quot;:approval_user.approved===false}\"><span class=\"fa fa-user margin-right-8\"></span><span ng-repeat=\"user in view.document.approval_users|filter:{id:approval_user.user_id} track by user.id\">{{user.username}}</span></li></ul></li></ul></div><div class=ln_solid></div><document-comment document-id=view.document._id></document-comment></div>");
$templateCache.put("app/docs/order/edit.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsOrderEditController as order\" class=container><div class=row><col-responsive><div class=form-group><label>Заголовок</label><input type=text ng-model=entry.document.title ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div stock-dict=order.branches dict-table=Branches class=form-group><label>Филиал</label><branch-select ng-model=entry.document.branch_id branches=order.branches ng-required=true></branch-select></div></col-responsive><col-responsive><div class=form-group><label>Снабженец</label><employee-select employee-id=entry.document.data.executor_id ng-disabled=\"order.executor_not_editable || order.is_executor\"></employee-select></div></col-responsive><col-responsive><div class=form-group><label>Короткое описание</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=entry.document.data.comment class=form-control></textarea></div></col-responsive></div><panel title=Товары ng-show=entry.document><button ng-disabled=\"entry.saving==true\" type=button ng-click=order.productNew() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=\"entry.saving==true || !order.selected_product\" type=button ng-click=order.productEdit() class=\"btn btn-default btn-sm\">Изменить</button> <button ng-disabled=\"entry.saving==true || !order.selected_product\" type=button ng-click=order.productRemove() class=\"btn btn-danger btn-sm\">Удалить</button><paged-table options=order.productsGridOptions disable-search=true disable-paging=true></paged-table></panel></div>");
$templateCache.put("app/docs/order/product_select.html","<!--\nCreated by ilias on 30/08/16.\n\n--><form ng-submit=product.productSave() class=modal-content><div class=modal-header><h3>Выбор продукта</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Продукт</label><product-select product-id=product.product.product_id product-unit-id=product.product.unit_id></product-select></div></col-responsive><col-responsive stock-dict=product.units dict-table=Units dict-filter={_id:product.product.unit_id}><div class=form-group><label>Единица измерения</label><ui-select ng-model=product.product.unit_id ng-disabled=true><ui-select-match ng-value=\"product.product.unit=$select.selected\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"unit._id as unit in product.units | filter:$select.search track by unit._id\">{{unit.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Количество</label><input type=number min={{product.product.unit.data.round}} step={{product.product.unit.data.round}} ng-model=product.product.quantity ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=product.product.comment class=form-control></textarea></div></col-responsive></div></div><div class=modal-footer><button type=button ng-click=product.cancel() class=\"btn btn-warning btn-sm\">Отмена</button> <button class=\"btn btn-primary btn-sm\">Сохранить</button></div></form>");
$templateCache.put("app/docs/order/purchase-select-modal.html","<div class=modal-header><h3>Покупка</h3></div><div class=modal-body><div class=list-group><a ng-click=purchase.docSelect() href=javascript:void(0) class=list-group-item><div class=media><div class=media-left><div class=document_icon_small><div class=\"fa fa-plus fa-3x fa-align-center\"></div></div></div><div class=media-body><b>Новый документ</b><div>Оформить новую покупку</div></div></div></a><a ng-repeat=\"doc in purchase.docs track by doc._id\" ng-click=purchase.docSelect(doc._id) href=javascript:void(0) class=list-group-item><div class=media><div class=media-left><img ng-src={{app.api}}image/docs/default/{{doc.document_type}}.svg class=document_icon_small></div><div class=media-body><b>{{doc.title}}<span am-time-ago=doc._created class=\"small pull-right\"></span></b><div>{{doc.short_desc}}</div><div ng-switch=doc.document_status class=small><span ng-switch-when=draft class=\"label label-default\">&bull; Черновик</span><span ng-switch-when=approval class=\"label label-warning\">&bull; На одобрение</span><span ng-switch-when=approved class=\"label label-success\">&bull; Одобрен</span><span ng-switch-when=rejected class=\"label label-danger\">&bull; Отклонен</span><span ng-switch-when=committed class=\"label label-default\">&bull; Исполнен</span></div></div></div></a></div><div ng-show=purchase.doc_loading class=\"loading-spinner fadeIn fadeOut animated\"><div id=circularG><div id=circularG_1 class=circularG></div><div id=circularG_2 class=circularG></div><div id=circularG_3 class=circularG></div><div id=circularG_4 class=circularG></div><div id=circularG_5 class=circularG></div><div id=circularG_6 class=circularG></div><div id=circularG_7 class=circularG></div><div id=circularG_8 class=circularG></div></div></div></div><div class=modal-footer><button type=button ng-click=purchase.cancel() class=\"btn btn-default btn-sm\">Отмена</button></div>");
$templateCache.put("app/docs/order/view.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsOrderViewController as order\" class=container><div class=container><h3>{{view.document.title}}</h3><label class=margin-right-8>{{view.document.document_status_value.data.name}}</label><label class=pull-right>Создан <span am-time-ago=view.document.data.date></span></label></div><div class=ln_solid></div><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Филиал</col-responsive><col-responsive class=col-lg-10>{{view.document.branch.name}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Снабженец</col-responsive><col-responsive class=col-lg-10>{{view.document.executor.username}}</col-responsive></div><div ng-if=view.document.short_desc class=row><col-responsive class=col-lg-2>Короткое описание</col-responsive><col-responsive class=col-lg-10>{{view.document.short_desc}}</col-responsive></div><div ng-if=view.document.data.comment class=row><col-responsive class=col-lg-2>Комментарий</col-responsive><col-responsive class=col-lg-10>{{view.document.data.comment}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Заявитель</col-responsive><col-responsive class=col-lg-10>{{view.document.user.username}}</col-responsive></div><div ng-if=view.document.purchase_documents.length&gt;0 class=row><col-responsive class=col-lg-2>Документы покупки оформленные по заявке</col-responsive><col-responsive class=col-lg-10><a ng-repeat=\"document in view.document.purchase_documents\" ui-sref=\"app.approval.view({type:document.document_type, id: document._id})\">{{document.title}} {{!$last?\',\':\'\'}}</a></col-responsive></div></div><div class=ln_solid></div><panel title=Заказы><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>#</th><th>Продукт</th><th>Единица изм.</th><th>Количество</th><th>Куплено</th><th>Комментарий</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.products\" ng-class=\"{success:product.selected, active:product.executed}\"><td><input type=checkbox ng-model=product.selected ng-disabled=product.executed></td><td><span ng-repeat=\"product_item in view.document.products|filter: {_id:product.product_id} track by product_item._id\">{{product_item.name}}</span></td><td><span ng-repeat=\"unit_item in view.document.units|filter: {_id:product.unit_id} track by unit_item._id\">{{unit_item.name}}</span></td><td>{{product.quantity | number}}</td><td>{{product.bought_quantity | number}}</td><td>{{product.comment}}</td></tr></tbody></table></div></panel><panel title=\"Исполненные заказы\" ng-show=\"view.document.data.executed_products.length &gt; 0\"><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>Продукт</th><th>Единица изм.</th><th>Количество</th><th>Документ</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.executed_products\"><td><span ng-repeat=\"product_item in view.document.products|filter: {_id:product.product_id} track by product_item._id\">{{product_item.name}}</span></td><td><span ng-repeat=\"unit_item in view.document.units|filter: {_id:product.unit_id} track by unit_item._id\">{{unit_item.name}}</span></td><td>{{product.quantity | number}}</td><td><span ng-repeat=\"document in view.document.documents|filter: {_id:product.document_id} track by document._id\"><a ui-sref=\"app.approval.view({id:document._id, type:document.document_type})\">{{document.title}}</a></span></td></tr></tbody></table></div></panel><div class=form-group><button ng-click=order.createPurchase() ng-show=order.canCreatePurchase() class=\"btn btn-primary btn-sm pull-right\">Оформить покупку</button><div class=clearfix></div></div><div class=ln_solid></div><document-comment document-id=view.document._id></document-comment></div>");
$templateCache.put("app/docs/purchase/edit.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsPurchaseEditController as purchase\" class=container><div class=row><col-responsive><div class=form-group><label>Заголовок</label><input type=text ng-model=entry.document.title ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div stock-dict=purchase.branches dict-table=Branches class=form-group><label>Филиал</label><branch-select ng-model=entry.document.branch_id branches=purchase.branches ng-required=true></branch-select></div></col-responsive><col-responsive><div class=form-group><label>Принимающий</label><employee-select employee-id=entry.document.data.executor_id ng-disabled=\"purchase.executor_not_editable || purchase.is_executor\"></employee-select></div></col-responsive><col-responsive><div class=form-group><label>Дата доставки</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=entry.document.data.delivery_date is-open=purchase.popup_delivery_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"purchase.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Короткое описание</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=entry.document.data.comment class=form-control></textarea></div></col-responsive></div><div class=ln_solid></div><div class=row><col-responsive><div class=form-group><label>Контрагент</label><contractor-select contractor-id=entry.document.data.contractor_id></contractor-select></div></col-responsive><col-responsive><div class=form-group><label>Способ оплаты</label><div ng-init=\"purchase.payment_method=&quot;cash&quot;\" class=form-control><label class=radio-inline><input type=radio name=payment_method ng-model=purchase.payment_method value=cash><span>Наличные</span></label><label class=radio-inline><input type=radio name=payment_method ng-model=purchase.payment_method value=debt><span>В долг</span></label><label class=radio-inline><input type=radio name=payment_method ng-model=purchase.payment_method value=advance><span>Аванс</span></label></div></div></col-responsive><col-responsive><div stock-dict=purchase.currencies dict-table=Currencies class=form-group><label>Валюта</label><ui-select ng-model=entry.document.data.currency_id><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"currency._id as currency in (purchase.currencies | filter:{name:$select.search} | orderBy:&quot;currency.name&quot;) track by currency._id\"><span ng-bind=currency.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Дата выплаты</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=entry.document.data.due_date is-open=purchase.popup_due_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"purchase.popup_due_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Сотрудник</label><employee-select employee-id=entry.document.data.employee_id ng-disabled=!entry.document.data.is_advance></employee-select></div></col-responsive></div><panel title=Товары ng-show=entry.document><button ng-disabled=\"entry.saving==true\" type=button ng-click=purchase.productNew() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=\"entry.saving==true || !purchase.selected_product\" type=button ng-click=purchase.productEdit() class=\"btn btn-default btn-sm\">Изменить</button> <button ng-disabled=\"entry.saving==true || !purchase.selected_product\" type=button ng-click=purchase.productRemove() class=\"btn btn-danger btn-sm\">Удалить</button><paged-table options=purchase.productsGridOptions disable-search=true disable-paging=true></paged-table></panel><panel title=\"Товары по предложению контрагента\" ng-if=entry.document.data.from_products.length&gt;0><button ng-disabled=\"entry.saving==true || !purchase.selected_from_product\" type=button ng-click=purchase.productFromNew() class=\"btn btn-primary btn-sm\">Добавить в товары</button><paged-table options=purchase.fromProductsGridOptions disable-search=true disable-paging=true></paged-table></panel><panel title=Одобрение collapsed=true><div class=row><col-responsive><div class=form-group><label>Требуется одобрение</label><label class=form-control><div class=checkbox-inline><input type=checkbox ng-model=entry.document.approval.required ng-disabled=\"purchase.approval_not_editable || purchase.is_executor\"><span ng-show=entry.document.approval.required>Требуется одобрение</span><span ng-hide=entry.document.approval.required>Одобрение не требуется</span></div></label></div></col-responsive><col-responsive><div ng-init=\"entry.document.approval.approval_type=&quot;one&quot;\" class=form-group><label>Должны одобрить<span uib-tooltip=\"Сколько пользователей из каждой роли должны одобрить\" class=\"fa fa-question-circle\"></span></label><div stock-dict=purchase.approval_types dict-table=Enums dict-filter={name:&quot;approval_type&quot;} class=form-control><label ng-repeat=\"type in purchase.approval_types track by type.data.key\" class=radio-inline><input type=radio ng-model=entry.document.approval.approval_type ng-value=type.data.key ng-disabled=\"!entry.document.approval.required || purchase.approval_not_editable || purchase.is_executor\"><span>{{type.data.name}}</span></label></div></div></col-responsive><col-responsive><div class=form-group><label>Добавить роль для одобрения<span uib-tooltip=\"Одобрение будет проходить по порядку добавления ролей\" class=\"fa fa-question-circle\"></span></label><div stock-dict=purchase.roles dict-table=Roles class=input-group><ui-select ng-model=purchase.approval_role_id ng-disabled=\"!entry.document.approval.required || purchase.approval_not_editable || purchase.is_executor\" class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (purchase.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-disabled=\"!purchase.approval_role_id || !entry.document.approval.required || purchase.approval_not_editable || purchase.is_executor\" ng-click=purchase.addApprovalRole() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-plus text-primary\"></span></button></span></div></div></col-responsive><div class=\"col col-xs-12\"><label>Роли для одобрения</label></div><div stock-dict=purchase.roles dict-table=Roles class=\"col col-xs-12\"><col-responsive ng-repeat=\"role_id in entry.document.approval.roles_id\"><div class=input-group><div class=input-group-addon><span>{{$index+1}}</span></div><ui-select ng-model=role_id ng-disabled=true class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (purchase.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=purchase.delApprovalRole(role_id) ng-disabled=\"purchase.approval_not_editable || purchase.is_executor\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></span></div></col-responsive></div></div></panel><panel title=\"Связанные документы\" collapsed=true><div class=row><col-responsive><button type=button ng-click=purchase.linkOrderDoc() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-paperclip margin-right-8\"></span><span>Привязать документ \"Заявка на покупку\"</span></button></col-responsive><col-responsive ng-repeat=\"document_id in entry.document.data.order_documents_id\"><div ng-repeat=\"document in entry.document.order_documents | filter: {_id:document_id} track by document._id\" class=\"media media-bordered\"><div class=media-left><img ng-src={{app.api}}image/docs/default/{{document.document_type}}.svg class=document_icon_small></div><div class=media-body><h4 class=media-heading><a target=_blank ui-sref=\"app.docs.view({type:document.document_type, id:document._id})\">{{document.title}}</a></h4><small am-time-ago=document.data.date></small></div><div class=media-right><button type=button ng-click=purchase.removeLinkOrderDoc(document_id) class=\"btn btn-link\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></div></div></col-responsive></div></panel></div>");
$templateCache.put("app/docs/purchase/order-select-modal.html","<div class=modal-header><h3>Заявки на покупку</h3></div><div class=modal-body><div class=list-group><a ng-repeat=\"doc in order.docs track by doc._id\" ng-click=order.docSelect(doc) href=javascript:void(0) class=list-group-item><div class=media><div class=media-left><img ng-src={{app.api}}image/docs/default/{{doc.document_type}}.svg class=document_icon_small></div><div class=media-body><b>{{doc.title}}<span am-time-ago=doc._created class=\"small pull-right\"></span></b><div>{{doc.short_desc}}</div><div ng-switch=doc.document_status class=small><span ng-switch-when=draft class=\"label label-default\">&bull; Черновик</span><span ng-switch-when=approval class=\"label label-warning\">&bull; На одобрение</span><span ng-switch-when=approved class=\"label label-success\">&bull; Одобрен</span><span ng-switch-when=rejected class=\"label label-danger\">&bull; Отклонен</span><span ng-switch-when=committed class=\"label label-default\">&bull; Исполнен</span></div></div></div></a></div><div ng-show=order.doc_loading class=\"loading-spinner fadeIn fadeOut animated\"><div id=circularG><div id=circularG_1 class=circularG></div><div id=circularG_2 class=circularG></div><div id=circularG_3 class=circularG></div><div id=circularG_4 class=circularG></div><div id=circularG_5 class=circularG></div><div id=circularG_6 class=circularG></div><div id=circularG_7 class=circularG></div><div id=circularG_8 class=circularG></div></div></div></div><div class=modal-footer><button type=button ng-click=order.cancel() class=\"btn btn-default btn-sm\">Отмена</button></div>");
$templateCache.put("app/docs/purchase/product_select.html","<!--\nCreated by ilias on 30/08/16.\n\n--><form ng-submit=product.productSave() class=modal-content><div class=modal-header><h3>Выбор продукта</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Продукт</label><product-select product-id=product.product.product_id product-unit-id=product.product.unit_id on-product-load=product.onProductLoaded($product)></product-select></div></col-responsive><col-responsive stock-dict=product.units dict-table=Units dict-filter={_id:product.product.unit_id}><div class=form-group><label>Единица измерения</label><ui-select ng-model=product.product.unit_id ng-disabled=true><ui-select-match ng-value=\"product.product.unit=$select.selected\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"unit._id as unit in product.units | filter:$select.search track by unit._id\">{{unit.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=product.pr dict-table=PricingRules dict-filter={product_id:product.product.product_id} dict-on-load=product.onRulesLoaded() class=form-group><label>Скидка</label><ui-select ng-model=product.product.rules_id on-select=product.onRuleSelect() multiple><ui-select-match allow-clear=true>{{$item.discount}}%</ui-select-match><ui-select-choices repeat=\"rule._id as rule in product.pr | filter:$select.search | orderBy:&quot;rule.priority&quot;\"><div ng-if=\"rule._id !== undefined\" class=row><div class=\"col col-sm-6\"><span>Приоритет: {{rule.priority}}</span></div><div class=\"col col-sm-6\"><span>Скидка: {{rule.discount}}%</span></div><div class=\"col col-sm-12 small\"><div ng-show=rule.valid_from>От: {{rule.valid_from | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div><div ng-show=rule.valid_up_to>До: {{rule.valid_up_to | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div></div></div></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Количество</label><input type=number min={{product.product.unit.data.round}} step={{product.product.unit.data.round}} ng-model=product.product.quantity ng-change=product.calcTotalCost(product.product);product.calcUnitPrice(product.product) ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Цена за единицу</label><input type=number step=0.01 ng-model=product.product.quote_unit_price ng-change=product.calcTotalCost(product.product) class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дополнительная стоимость</label><input type=number step=0.01 ng-model=product.product.additional_cost class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Общая стоимость</label><input type=number step=0.01 ng-model=product.product.total_cost ng-change=product.calcUnitPrice(product.product) class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=product.product.comment class=form-control></textarea></div></col-responsive></div></div><div class=modal-footer><button type=button ng-click=product.cancel() class=\"btn btn-warning btn-sm\">Отмена</button> <button class=\"btn btn-primary btn-sm\">Сохранить</button></div></form>");
$templateCache.put("app/docs/purchase/purchase_reception-select-modal.html","<div class=modal-header><h3>Прием покупки</h3></div><div class=modal-body><div class=list-group><a ng-click=purchase_reception.docSelect() href=javascript:void(0) class=list-group-item><div class=media><div class=media-left><div class=document_icon_small><div class=\"fa fa-plus fa-3x fa-align-center\"></div></div></div><div class=media-body><b>Новый документ</b><div>Оформить новый прием покупки</div></div></div></a><a ng-repeat=\"doc in purchase_reception.docs track by doc._id\" ng-click=purchase_reception.docSelect(doc._id) href=javascript:void(0) class=list-group-item><div class=media><div class=media-left><img ng-src={{app.api}}image/docs/default/{{doc.document_type}}.svg class=document_icon_small></div><div class=media-body><b>{{doc.title}}<span am-time-ago=doc._created class=\"small pull-right\"></span></b><div>{{doc.short_desc}}</div><div ng-switch=doc.document_status class=small><span ng-switch-when=draft class=\"label label-default\">&bull; Черновик</span><span ng-switch-when=approval class=\"label label-warning\">&bull; На одобрение</span><span ng-switch-when=approved class=\"label label-success\">&bull; Одобрен</span><span ng-switch-when=rejected class=\"label label-danger\">&bull; Отклонен</span><span ng-switch-when=committed class=\"label label-default\">&bull; Исполнен</span></div></div></div></a></div><div ng-show=purchase_reception.doc_loading class=\"loading-spinner fadeIn fadeOut animated\"><div id=circularG><div id=circularG_1 class=circularG></div><div id=circularG_2 class=circularG></div><div id=circularG_3 class=circularG></div><div id=circularG_4 class=circularG></div><div id=circularG_5 class=circularG></div><div id=circularG_6 class=circularG></div><div id=circularG_7 class=circularG></div><div id=circularG_8 class=circularG></div></div></div></div><div class=modal-footer><button type=button ng-click=purchase_reception.cancel() class=\"btn btn-default btn-sm\">Отмена</button></div>");
$templateCache.put("app/docs/purchase/view.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsPurchaseViewController as purchase\" class=container><div class=container><h3>{{view.document.title}}</h3><label class=margin-right-8>{{view.document.document_status_value.data.name}}</label><label class=pull-right>Создан <span am-time-ago=view.document.data.date></span></label></div><div class=ln_solid></div><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Филиал</col-responsive><col-responsive class=col-lg-10>{{view.document.branch.name}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Принимающий</col-responsive><col-responsive class=col-lg-10>{{view.document.executor.username}}</col-responsive></div><div ng-if=view.document.data.delivery_date class=row><col-responsive class=col-lg-2>Дата доставки</col-responsive><col-responsive class=col-lg-10>{{view.document.data.delivery_date | amDateFormat:\"Do MMMM YYYY\"}}</col-responsive></div><div ng-if=view.document.short_desc class=row><col-responsive class=col-lg-2>Короткое описание</col-responsive><col-responsive class=col-lg-10>{{view.document.short_desc}}</col-responsive></div><div ng-if=view.document.data.comment class=row><col-responsive class=col-lg-2>Комментарий</col-responsive><col-responsive class=col-lg-10>{{view.document.data.comment}}</col-responsive></div><div ng-if=view.document.data.from_company_id class=row><col-responsive class=col-lg-2>От компании</col-responsive><col-responsive class=col-lg-10>{{view.document.from_company.name}}</col-responsive></div><div ng-if=view.document.data.contractor_id class=row><col-responsive class=col-lg-2>Контрагент</col-responsive><col-responsive class=col-lg-10>{{view.document.contractor.name}}</col-responsive></div><div ng-if=view.document.data.is_advance class=row><col-responsive class=col-lg-2>Сотрудник</col-responsive><col-responsive class=col-lg-10>{{view.document.employee.user.username}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Способ оплаты</col-responsive><col-responsive class=col-lg-10><span ng-show=\"!view.document.data.is_due &amp;&amp; !view.document.data.is_advance\">Наличные</span><span ng-show=view.document.data.is_due>В долг</span><span ng-show=view.document.data.is_advance>Аванс</span></col-responsive></div><div ng-if=view.document.data.due_date class=row><col-responsive class=col-lg-2>Дата выплаты</col-responsive><col-responsive class=col-lg-10>{{view.document.data.due_date | amDateFormat:\"Do MMMM YYYY\"}}</col-responsive></div><div ng-if=view.document.data.order_documents_id.length&gt;0 class=row><col-responsive class=col-lg-2>Заявки на покупку</col-responsive><col-responsive class=col-lg-10><span ng-repeat=\"document_id in view.document.data.order_documents_id\"><a ng-repeat=\"document in view.document.order_documents|filter: {_id: document_id}\" ui-sref=\"app.approval.view({type:document.document_type, id: document_id})\">{{document.title}} {{!$last?\',\':\'\'}}</a></span></col-responsive></div><div ng-if=view.document.purchase_reception_documents.length&gt;0 class=row><col-responsive class=col-lg-2>Документы приема оформленные по покупке</col-responsive><col-responsive class=col-lg-10><a ng-repeat=\"document in view.document.purchase_reception_documents\" ui-sref=\"app.approval.view({type:document.document_type, id: document._id})\">{{document.title}} {{!$last?\',\':\'\'}}</a></col-responsive></div></div><div class=ln_solid></div><panel title=\"Товары для покупки\"><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>Продукт</th><th>Количество</th><th>Доставлено</th><th>Цена за ед.</th><th>Общая стоимость</th><th>Дополнительная стоимость</th><th>Комментарий</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.products\"><td><span ng-repeat=\"product_item in view.document.products|filter: {_id:product.product_id} track by product_item._id\">{{product_item.name}}</span></td><td>{{product.quantity | number}}<span ng-repeat=\"unit_item in view.document.units|filter: {_id:product.unit_id} track by unit_item._id\">&nbsp;{{unit_item.data.short_name}}</span></td><td>{{product.delivered_quantity | number}}<span ng-repeat=\"unit_item in view.document.units|filter: {_id:product.unit_id} track by unit_item._id\">&nbsp;{{unit_item.data.short_name}}</span></td><td>{{product.quote_unit_price || 0 | number}} {{view.document.currency.data.short_name}}</td><td>{{product.total_cost || 0 | number}} {{view.document.currency.data.short_name}}</td><td>{{product.additional_cost || 0 | number}} {{view.document.currency.data.short_name}}</td><td>{{product.comment}}</td></tr></tbody></table></div><div class=row><div class=\"col col-xs-12\"><div class=text-right><h4>Итоговая сумма</h4><label>{{purchase.totalSum() | number}} {{view.document.currency.name}}</label></div></div></div></panel><panel title=\"Товары по предложении контрагента\" ng-if=view.document.data.from_products.length&gt;0><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>Продукт</th><th>Количество</th><th>Цена за ед.</th><th>Общая стоимость</th><th>Дополнительная стоимость</th><th>Комментарий</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.from_products\"><td>{{product.product.name}}</td><td>{{product.quantity | number}} {{product.unit.name}}</td><td>{{product.quote_unit_price | number}} {{view.document.from_currency.name}}</td><td>{{product.total_cost | number}} {{view.document.from_currency.name}}</td><td>{{product.additional_cost | number}} {{view.document.from_currency.name}}</td><td>{{product.comment}}</td></tr></tbody></table></div><div class=row><div class=\"col col-xs-12\"><div class=text-right><h4>Итоговая сумма</h4><label>{{view.document.from_currency.name}} {{sale.fromTotalSum() | number}}</label></div></div></div></panel><panel title=\"Доставленные товары\" ng-show=\"view.document.data.delivered_products.length &gt; 0\"><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>Продукт</th><th>Единица изм.</th><th>Количество</th><th>Документ</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.delivered_products\"><td><span ng-repeat=\"product_item in view.document.products|filter: {_id:product.product_id} track by product_item._id\">{{product_item.name}}</span></td><td><span ng-repeat=\"unit_item in view.document.units|filter: {_id:product.unit_id} track by unit_item._id\">{{unit_item.name}}</span></td><td>{{product.quantity | number}}</td><td><span ng-repeat=\"document in view.document.documents|filter: {_id:product.document_id} track by document._id\"><a ui-sref=\"app.approval.view({id:document._id, type:document.document_type})\">{{document.title}}</a></span></td></tr></tbody></table></div></panel><div class=form-group><button ng-click=purchase.createPurchaseReception() ng-show=purchase.canCreatePurchaseReception() class=\"btn btn-primary btn-sm pull-right\">Оформить прием покупки</button><div class=clearfix></div></div><div ng-show=view.document.approval.required><div class=ln_solid></div><h4>Одобрения</h4><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Должны одобрить</col-responsive><col-responsive class=col-lg-10>{{view.document.approval_type_value.data.name}}</col-responsive></div></div><ul><li ng-repeat=\"approval_role in view.document.approval.approval_roles\"><h5 ng-class=\"{&quot;text-success&quot;:approval_role.approved===true, &quot;text-danger&quot;:approval_role.approved===false}\"><span ng-show=\"approval_role.approved===true\" class=\"glyphicon glyphicon-ok-circle margin-right-8\"></span><span ng-show=\"approval_role.approved===false\" class=\"glyphicon glyphicon-remove-circle margin-right-8\"></span><span ng-repeat=\"role in view.document.roles|filter:{_id:approval_role.role_id} track by role._id\">{{role.data.approval_name}}</span></h5><ul><li ng-repeat=\"approval_user in approval_role.approval_users\" ng-class=\"{&quot;text-success&quot;:approval_user.approved===true, &quot;text-danger&quot;:approval_user.approved===false}\"><span class=\"fa fa-user margin-right-8\"></span><span ng-repeat=\"user in view.document.approval_users|filter:{id:approval_user.user_id} track by user.id\">{{user.username}}</span></li></ul></li></ul></div><div class=ln_solid></div><document-comment document-id=view.document._id></document-comment></div>");
$templateCache.put("app/docs/purchase_reception/edit.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsPurchaseReceptionEditController as purchase_reception\" class=container><div class=row><col-responsive><div class=form-group><label>Заголовок</label><input type=text ng-model=entry.document.title ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div stock-dict=purchase_reception.branches dict-table=Branches class=form-group><label>Филиал</label><branch-select ng-model=entry.document.branch_id branches=purchase_reception.branches ng-required=true></branch-select></div></col-responsive><col-responsive><div class=form-group><label>Принимающий</label><employee-select employee-id=entry.document.data.executor_id ng-disabled=\"purchase_reception.executor_not_editable || purchase_reception.is_executor\"></employee-select></div></col-responsive><col-responsive><div class=form-group><label>Короткое описание</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=entry.document.data.comment class=form-control></textarea></div></col-responsive></div><div class=ln_solid></div><div class=row><col-responsive><div class=form-group><label>Контрагент</label><contractor-select contractor-id=entry.document.data.contractor_id></contractor-select></div></col-responsive></div><panel title=Товары ng-show=entry.document><button ng-disabled=\"entry.saving==true\" type=button ng-click=purchase_reception.productNew() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=\"entry.saving==true || !purchase_reception.selected_product\" type=button ng-click=purchase_reception.productEdit() class=\"btn btn-default btn-sm\">Изменить</button> <button ng-disabled=\"entry.saving==true || !purchase_reception.selected_product\" type=button ng-click=purchase_reception.productRemove() class=\"btn btn-danger btn-sm\">Удалить</button><paged-table options=purchase_reception.productsGridOptions disable-search=true disable-paging=true></paged-table></panel><panel title=Одобрение collapsed=true><div class=row><col-responsive><div class=form-group><label>Требуется одобрение</label><label class=form-control><div class=checkbox-inline><input type=checkbox ng-model=entry.document.approval.required ng-disabled=\"purchase_reception.approval_not_editable || purchase_reception.is_executor\"><span ng-show=entry.document.approval.required>Требуется одобрение</span><span ng-hide=entry.document.approval.required>Одобрение не требуется</span></div></label></div></col-responsive><col-responsive><div ng-init=\"entry.document.approval.approval_type=&quot;one&quot;\" class=form-group><label>Должны одобрить<span uib-tooltip=\"Сколько пользователей из каждой роли должны одобрить\" class=\"fa fa-question-circle\"></span></label><div stock-dict=purchase_reception.approval_types dict-table=Enums dict-filter={name:&quot;approval_type&quot;} class=form-control><label ng-repeat=\"type in purchase_reception.approval_types track by type.data.key\" class=radio-inline><input type=radio ng-model=entry.document.approval.approval_type ng-value=type.data.key ng-disabled=\"!entry.document.approval.required || purchase_reception.approval_not_editable || purchase_reception.is_executor\"><span>{{type.data.name}}</span></label></div></div></col-responsive><col-responsive><div class=form-group><label>Добавить роль для одобрения<span uib-tooltip=\"Одобрение будет проходить по порядку добавления ролей\" class=\"fa fa-question-circle\"></span></label><div stock-dict=purchase_reception.roles dict-table=Roles class=input-group><ui-select ng-model=purchase_reception.approval_role_id ng-disabled=\"!entry.document.approval.required || purchase_reception.approval_not_editable || purchase_reception.is_executor\" class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (purchase_reception.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-disabled=\"!purchase_reception.approval_role_id || !entry.document.approval.required || purchase_reception.approval_not_editable || purchase_reception.is_executor\" ng-click=purchase_reception.addApprovalRole() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-plus text-primary\"></span></button></span></div></div></col-responsive><div class=\"col col-xs-12\"><label>Роли для одобрения</label></div><div stock-dict=purchase_reception.roles dict-table=Roles class=\"col col-xs-12\"><col-responsive ng-repeat=\"role_id in entry.document.approval.roles_id\"><div class=input-group><div class=input-group-addon><span>{{$index+1}}</span></div><ui-select ng-model=role_id ng-disabled=true class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (purchase_reception.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=purchase_reception.delApprovalRole(role_id) ng-disabled=\"purchase_reception.approval_not_editable || purchase_reception.is_executor\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></span></div></col-responsive></div></div></panel><panel title=\"Связанные документы\" collapsed=true><div class=row><col-responsive><button type=button ng-click=purchase_reception.linkPurchaseDoc() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-paperclip margin-right-8\"></span><span>Привязать документ \"Покупка\"</span></button></col-responsive><col-responsive ng-repeat=\"document_id in entry.document.data.purchase_documents_id\"><div ng-repeat=\"document in entry.document.purchase_documents | filter: {_id:document_id} track by document._id\" class=\"media media-bordered\"><div class=media-left><img ng-src={{app.api}}image/docs/default/{{document.document_type}}.svg class=document_icon_small></div><div class=media-body><h4 class=media-heading><a target=_blank ui-sref=\"app.docs.view({type:document.document_type, id:document._id})\">{{document.title}}</a></h4><small am-time-ago=document.data.date></small></div><div class=media-right><button type=button ng-click=purchase_reception.removeLinkPurchaseDoc(document_id) class=\"btn btn-link\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></div></div></col-responsive></div></panel></div>");
$templateCache.put("app/docs/purchase_reception/product_select.html","<!--\nCreated by ilias on 30/08/16.\n\n--><form ng-submit=product.productSave() class=modal-content><div class=modal-header><h3>Выбор продукта</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Продукт</label><product-select product-id=product.product.product_id product-unit-id=product.product.unit_id></product-select></div></col-responsive><col-responsive stock-dict=product.units dict-table=Units dict-filter={_id:product.product.unit_id}><div class=form-group><label>Единица измерения</label><ui-select ng-model=product.product.unit_id ng-disabled=true><ui-select-match ng-value=\"product.product.unit=$select.selected\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"unit._id as unit in product.units | filter:$select.search track by unit._id\">{{unit.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Количество</label><input type=number min={{product.product.unit.data.round}} step={{product.product.unit.data.round}} ng-model=product.product.quantity ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=product.product.comment class=form-control></textarea></div></col-responsive></div></div><div class=modal-footer><button type=button ng-click=product.cancel() class=\"btn btn-warning btn-sm\">Отмена</button> <button class=\"btn btn-primary btn-sm\">Сохранить</button></div></form>");
$templateCache.put("app/docs/purchase_reception/purchase-select-modal.html","<div class=modal-header><h3>Покупка</h3></div><div class=modal-body><div class=list-group><a ng-repeat=\"doc in purchase.docs track by doc._id\" ng-click=purchase.docSelect(doc) href=javascript:void(0) class=list-group-item><div class=media><div class=media-left><img ng-src={{app.api}}image/docs/default/{{doc.document_type}}.svg class=document_icon_small></div><div class=media-body><b>{{doc.title}}<span am-time-ago=doc._created class=\"small pull-right\"></span></b><div>{{doc.short_desc}}</div><div ng-switch=doc.document_status class=small><span ng-switch-when=draft class=\"label label-default\">&bull; Черновик</span><span ng-switch-when=approval class=\"label label-warning\">&bull; На одобрение</span><span ng-switch-when=approved class=\"label label-success\">&bull; Одобрен</span><span ng-switch-when=rejected class=\"label label-danger\">&bull; Отклонен</span><span ng-switch-when=committed class=\"label label-default\">&bull; Исполнен</span></div></div></div></a></div><div ng-show=purchase.doc_loading class=\"loading-spinner fadeIn fadeOut animated\"><div id=circularG><div id=circularG_1 class=circularG></div><div id=circularG_2 class=circularG></div><div id=circularG_3 class=circularG></div><div id=circularG_4 class=circularG></div><div id=circularG_5 class=circularG></div><div id=circularG_6 class=circularG></div><div id=circularG_7 class=circularG></div><div id=circularG_8 class=circularG></div></div></div></div><div class=modal-footer><button type=button ng-click=purchase.cancel() class=\"btn btn-default btn-sm\">Отмена</button></div>");
$templateCache.put("app/docs/purchase_reception/view.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsPurchaseReceptionViewController as purchase_reception\" class=container><div class=container><h3>{{view.document.title}}</h3><label class=margin-right-8>{{view.document.document_status_value.data.name}}</label><label class=pull-right>Создан <span am-time-ago=view.document.data.date></span></label></div><div class=ln_solid></div><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Филиал</col-responsive><col-responsive class=col-lg-10>{{view.document.branch.name}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Принимающий</col-responsive><col-responsive class=col-lg-10>{{view.document.executor.username}}</col-responsive></div><div ng-if=view.document.short_desc class=row><col-responsive class=col-lg-2>Короткое описание</col-responsive><col-responsive class=col-lg-10>{{view.document.short_desc}}</col-responsive></div><div ng-if=view.document.data.comment class=row><col-responsive class=col-lg-2>Комментарий</col-responsive><col-responsive class=col-lg-10>{{view.document.data.comment}}</col-responsive></div><div ng-if=view.document.data.contractor_id class=row><col-responsive class=col-lg-2>Контрагент</col-responsive><col-responsive class=col-lg-10>{{view.document.contractor.name}}</col-responsive></div><div ng-if=view.document.data.purchase_documents_id.length&gt;0 class=row><col-responsive class=col-lg-2>Документы \"Покупка\"</col-responsive><col-responsive class=col-lg-10><div ng-repeat=\"document_id in view.document.data.purchase_documents_id\"><div ng-repeat=\"document in view.document.purchase_documents|filter: {_id: document_id}\"><a ui-sref=\"app.approval.view({type:document.document_type, id: document_id})\">{{document.title}} {{!$last?\',\':\'\'}}</a></div><div ng-if=document.data.order_documents_id.length&gt;0><label>Документы \"Заявка на покупку\"</label><div ng-repeat=\"order_document_id in document.data.order_documents_id\"><a ng-repeat=\"order_document in document.order_documents|filter: {_id: order_document_id}\" ui-sref=\"app.approval.view({type:order_document.document_type, id: order_document_id})\">{{order_document.title}} {{!$last?\',\':\'\'}}</a></div></div></div></col-responsive></div></div><div class=ln_solid></div><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>Продукт</th><th>Количество</th><th>Комментарий</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.products\"><td><span ng-repeat=\"product_item in view.document.products|filter: {_id:product.product_id} track by product_item._id\">{{product_item.name}}</span></td><td>{{product.quantity | number}}<span ng-repeat=\"unit_item in view.document.units|filter: {_id:product.unit_id} track by unit_item._id\">&nbsp;{{unit_item.data.short_name}}</span></td><td>{{product.comment}}</td></tr></tbody></table></div><div ng-show=view.document.approval.required><div class=ln_solid></div><h4>Одобрения</h4><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Должны одобрить</col-responsive><col-responsive class=col-lg-10>{{view.document.approval_type_value.data.name}}</col-responsive></div></div><ul><li ng-repeat=\"approval_role in view.document.approval.approval_roles\"><h5 ng-class=\"{&quot;text-success&quot;:approval_role.approved===true, &quot;text-danger&quot;:approval_role.approved===false}\"><span ng-show=\"approval_role.approved===true\" class=\"glyphicon glyphicon-ok-circle margin-right-8\"></span><span ng-show=\"approval_role.approved===false\" class=\"glyphicon glyphicon-remove-circle margin-right-8\"></span><span ng-repeat=\"role in view.document.roles|filter:{_id:approval_role.role_id} track by role._id\">{{role.data.approval_name}}</span></h5><ul><li ng-repeat=\"approval_user in approval_role.approval_users\" ng-class=\"{&quot;text-success&quot;:approval_user.approved===true, &quot;text-danger&quot;:approval_user.approved===false}\"><span class=\"fa fa-user margin-right-8\"></span><span ng-repeat=\"user in view.document.approval_users|filter:{id:approval_user.user_id} track by user.id\">{{user.username}}</span></li></ul></li></ul></div><div class=ln_solid></div><document-comment document-id=view.document._id></document-comment></div>");
$templateCache.put("app/docs/repayment/edit.html","<div ng-controller=\"DocsRepaymentEditController as repayment\" class=container><div class=row><col-responsive><div class=form-group><label>Заголовок</label><input type=text ng-model=entry.document.title ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div stock-dict=repayment.branches dict-table=Branches class=form-group><label>Филиал</label><branch-select ng-model=entry.document.branch_id branches=repayment.branches ng-required=true></branch-select></div></col-responsive><col-responsive><div class=form-group><label>Принимающий</label><employee-select employee-id=entry.document.data.executor_id ng-required=true ng-disabled=\"repayment.executor_not_editable || repayment.is_executor\"></employee-select></div></col-responsive><col-responsive><div stock-dict=repayment.payment_types dict-table=Enums dict-filter={name:&quot;payment_type&quot;} class=form-group><label>Тип платежа</label><ui-select ng-model=entry.document.data.payment_type><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"payment_type.data.key as payment_type in repayment.payment_types\">{{payment_type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Контрагент</label><contractor-select contractor-id=entry.document.data.contractor_id ng-required=true></contractor-select></div></col-responsive><col-responsive><div class=form-group><label>Короткое описание</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=entry.document.data.comment class=form-control></textarea></div></col-responsive><col-responsive><div stock-dict=repayment.currencies dict-table=Currencies class=form-group><label>Валюта</label><ui-select ng-model=entry.document.data.currency_id ng-required=true><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"currency._id as currency in (repayment.currencies | filter:{name:$select.search} | orderBy:&quot;currency.name&quot;) track by currency._id\"><span ng-bind=currency.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Сумма</label><input type=number ng-model=entry.document.data.amount step=0.01 ng-required=true class=form-control></div></col-responsive></div><panel title=Одобрение collapsed=true><div class=row><col-responsive><div class=form-group><label>Требуется одобрение</label><label class=form-control><div class=checkbox-inline><input type=checkbox ng-model=entry.document.approval.required ng-disabled=\"repayment.approval_not_editable || repayment.is_executor\"><span ng-show=entry.document.approval.required>Требуется одобрение</span><span ng-hide=entry.document.approval.required>Одобрение не требуется</span></div></label></div></col-responsive><col-responsive><div ng-init=\"entry.document.approval.approval_type=&quot;one&quot;\" class=form-group><label>Должны одобрить<span uib-tooltip=\"Сколько пользователей из каждой роли должны одобрить\" class=\"fa fa-question-circle\"></span></label><div stock-dict=repayment.approval_types dict-table=Enums dict-filter={name:&quot;approval_type&quot;} class=form-control><label ng-repeat=\"type in repayment.approval_types track by type.data.key\" class=radio-inline><input type=radio ng-model=entry.document.approval.approval_type ng-value=type.data.key ng-disabled=\"!entry.document.approval.required || repayment.approval_not_editable || repayment.is_executor\"><span>{{type.data.name}}</span></label></div></div></col-responsive><col-responsive><div class=form-group><label>Добавить роль для одобрения<span uib-tooltip=\"Одобрение будет проходить по порядку добавления ролей\" class=\"fa fa-question-circle\"></span></label><div stock-dict=repayment.roles dict-table=Roles class=input-group><ui-select ng-model=repayment.approval_role_id ng-disabled=\"!entry.document.approval.required || repayment.approval_not_editable || repayment.is_executor\" class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (repayment.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-disabled=\"!repayment.approval_role_id || !entry.document.approval.required || repayment.approval_not_editable || repayment.is_executor\" ng-click=repayment.addApprovalRole() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-plus text-primary\"></span></button></span></div></div></col-responsive><div class=\"col col-xs-12\"><label>Роли для одобрения</label></div><div stock-dict=repayment.roles dict-table=Roles class=\"col col-xs-12\"><col-responsive ng-repeat=\"role_id in entry.document.approval.roles_id\"><div class=input-group><div class=input-group-addon><span>{{$index+1}}</span></div><ui-select ng-model=role_id ng-disabled=true class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (repayment.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=repayment.delApprovalRole(role_id) ng-disabled=\"repayment.approval_not_editable || repayment.is_executor\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></span></div></col-responsive></div></div></panel></div>");
$templateCache.put("app/docs/repayment/view.html","<div ng-controller=\"DocsRepaymentViewController as repayment\" class=container><div class=container><h3>{{view.document.title}}</h3><label class=margin-right-8>{{view.document.document_status_value.data.name}}</label><label class=pull-right>Создан <span am-time-ago=view.document.data.date></span></label></div><div class=ln_solid></div><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Филиал</col-responsive><col-responsive class=col-lg-10>{{view.document.branch.name}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Принимающий</col-responsive><col-responsive class=col-lg-10>{{view.document.executor.username}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Тип платежа</col-responsive><col-responsive class=col-lg-10>{{view.document.payment_type_value.data.name}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Контрагент</col-responsive><col-responsive class=col-lg-10>{{view.document.contractor.name}}</col-responsive></div><div ng-if=view.document.short_desc class=row><col-responsive class=col-lg-2>Короткое описание</col-responsive><col-responsive class=col-lg-10>{{view.document.short_desc}}</col-responsive></div><div ng-if=view.document.data.comment class=row><col-responsive class=col-lg-2>Комментарий</col-responsive><col-responsive class=col-lg-10>{{view.document.data.comment}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Сумма</col-responsive><col-responsive class=col-lg-10>{{view.document.data.amount | number}} {{view.document.currency.name}}</col-responsive></div></div><div class=ln_solid></div><div ng-show=view.document.approval.required><div class=ln_solid></div><h4>Одобрения</h4><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Должны одобрить</col-responsive><col-responsive class=col-lg-10>{{view.document.approval_type_value.data.name}}</col-responsive></div></div><ul><li ng-repeat=\"approval_role in view.document.approval.approval_roles\"><h5 ng-class=\"{&quot;text-success&quot;:approval_role.approved===true, &quot;text-danger&quot;:approval_role.approved===false}\"><span ng-show=\"approval_role.approved===true\" class=\"glyphicon glyphicon-ok-circle margin-right-8\"></span><span ng-show=\"approval_role.approved===false\" class=\"glyphicon glyphicon-remove-circle margin-right-8\"></span><span ng-repeat=\"role in view.document.roles|filter:{_id:approval_role.role_id} track by role._id\">{{role.data.approval_name}}</span></h5><ul><li ng-repeat=\"approval_user in approval_role.approval_users\" ng-class=\"{&quot;text-success&quot;:approval_user.approved===true, &quot;text-danger&quot;:approval_user.approved===false}\"><span class=\"fa fa-user margin-right-8\"></span><span ng-repeat=\"user in view.document.approval_users|filter:{id:approval_user.user_id} track by user.id\">{{user.username}}</span></li></ul></li></ul></div><div class=ln_solid></div><document-comment document-id=view.document._id></document-comment></div>");
$templateCache.put("app/docs/salary/edit.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsSalaryEditController as salary\" class=container><div class=row><col-responsive><div class=form-group><label>Заголовок</label><input type=text ng-model=entry.document.title ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div stock-dict=salary.branches dict-table=Branches class=form-group><label>Филиал</label><branch-select ng-model=entry.document.branch_id branches=salary.branches ng-required=true></branch-select></div></col-responsive><col-responsive><div class=form-group><label>Исполнитель</label><employee-select employee-id=entry.document.data.executor_id ng-disabled=\"salary.executor_not_editable || salary.is_executor\"></employee-select></div></col-responsive><col-responsive><div class=form-group><label>Короткое описание</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=entry.document.data.comment class=form-control></textarea></div></col-responsive></div><div class=ln_solid></div><div class=row><col-responsive><div class=form-group><label>Сотрудник</label><employee-select employee-id=entry.document.data.employee_id></employee-select></div></col-responsive><col-responsive><div stock-dict=salary.currencies dict-table=Currencies class=form-group><label>Валюта</label><ui-select ng-model=entry.document.data.currency_id><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"currency._id as currency in (salary.currencies | filter:{name:$select.search} | orderBy:&quot;currency.name&quot;) track by currency._id\"><span ng-bind=currency.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Сумма</label><input type=number step=0.01 ng-model=entry.document.data.amount ng-required=true ng-trim=true class=form-control></div></col-responsive></div></div>");
$templateCache.put("app/docs/salary/view.html","<!--Created by ilias on 16.03.17.\n--><div ng-controller=\"DocsCashExpenditureViewController as cash_expenditure\" class=container><div class=container><h3>{{view.document.title}}</h3><label class=margin-right-8>{{view.document.document_status_value.data.name}}</label><label class=pull-right>Создан <span am-time-ago=view.document.data.date></span></label></div><div class=ln_solid></div><div class=\"row-striped row-v-padding row-col-bold\"><div ng-if=view.document.branch_id class=row><col-responsive class=col-lg-2>Филиал</col-responsive><col-responsive class=col-lg-10>{{view.document.branch.name}}</col-responsive></div><div ng-if=view.document.data.executor_id class=row><col-responsive class=col-lg-2>Исполнитель</col-responsive><col-responsive class=col-lg-10>{{view.document.executor.username}}</col-responsive></div><div ng-if=view.document.short_desc class=row><col-responsive class=col-lg-2>Короткое описание</col-responsive><col-responsive class=col-lg-10>{{view.document.short_desc}}</col-responsive></div><div ng-if=view.document.data.comment class=row><col-responsive class=col-lg-2>Комментарий</col-responsive><col-responsive class=col-lg-10>{{view.document.data.comment}}</col-responsive></div><div ng-if=view.document.data.employee_id class=row><col-responsive class=col-lg-2>Контрагент</col-responsive><col-responsive class=col-lg-10>{{view.document.employee.username}}</col-responsive></div><div ng-if=view.document.data.employee_id class=row><col-responsive class=col-lg-2>Сумма оплаты</col-responsive><col-responsive class=col-lg-10>{{view.document.currency.name}} {{view.document.data.amount | number}}</col-responsive></div></div><div class=ln_solid></div><div ng-show=view.document.approval.required><div class=ln_solid></div><h4>Одобрения</h4><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Должны одобрить</col-responsive><col-responsive class=col-lg-10>{{view.document.approval_type_value.data.name}}</col-responsive></div></div><ul><li ng-repeat=\"approval_role in view.document.approval.approval_roles\"><h5 ng-class=\"{&quot;text-success&quot;:approval_role.approved===true, &quot;text-danger&quot;:approval_role.approved===false}\"><span ng-show=\"approval_role.approved===true\" class=\"glyphicon glyphicon-ok-circle margin-right-8\"></span><span ng-show=\"approval_role.approved===false\" class=\"glyphicon glyphicon-remove-circle margin-right-8\"></span><span ng-repeat=\"role in view.document.roles|filter:{_id:approval_role.role_id} track by role._id\">{{role.data.approval_name}}</span></h5><ul><li ng-repeat=\"approval_user in approval_role.approval_users\" ng-class=\"{&quot;text-success&quot;:approval_user.approved===true, &quot;text-danger&quot;:approval_user.approved===false}\"><span class=\"fa fa-user margin-right-8\"></span><span ng-repeat=\"user in view.document.approval_users|filter:{id:approval_user.user_id} track by user.id\">{{user.username}}</span></li></ul></li></ul></div><div class=ln_solid></div><document-comment document-id=view.document._id></document-comment></div>");
$templateCache.put("app/docs/sale/edit.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsSaleEditController as sale\" class=container><div class=row><col-responsive><div class=form-group><label>Заголовок</label><input type=text ng-model=entry.document.title ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div stock-dict=sale.branches dict-table=Branches class=form-group><label>Филиал</label><branch-select ng-model=entry.document.branch_id branches=sale.branches ng-required=true></branch-select></div></col-responsive><col-responsive><div class=form-group><label>Исполнитель</label><employee-select employee-id=entry.document.data.executor_id ng-disabled=\"sale.executor_not_editable || sale.is_executor\"></employee-select></div></col-responsive><col-responsive><div class=form-group><label>Дата доставки</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=entry.document.data.delivery_date is-open=sale.popup_delivery_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"sale.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Короткое описание</label><textarea ng-model=entry.document.short_desc ng-trim=true class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=entry.document.data.comment class=form-control></textarea></div></col-responsive></div><div class=ln_solid></div><div class=row><col-responsive><div class=form-group><label>Контрагент</label><contractor-select contractor-id=entry.document.data.contractor_id></contractor-select></div></col-responsive><col-responsive><div class=form-group><label>Способ оплаты</label><div ng-init=\"sale.payment_method=&quot;cash&quot;\" class=form-control><label class=radio-inline><input type=radio name=payment_method ng-model=sale.payment_method value=cash><span>Наличные</span></label><label class=radio-inline><input type=radio name=payment_method ng-model=sale.payment_method value=debt><span>В долг</span></label></div></div></col-responsive><col-responsive><div stock-dict=sale.currencies dict-table=Currencies class=form-group><label>Валюта</label><ui-select ng-model=entry.document.data.currency_id><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"currency._id as currency in (sale.currencies | filter:{name:$select.search} | orderBy:&quot;currency.name&quot;) track by currency._id\"><span ng-bind=currency.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Дата выплаты</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=entry.document.data.due_date is-open=sale.popup_due_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"sale.popup_due_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><panel title=Товары ng-show=entry.document><button ng-disabled=\"entry.saving==true\" type=button ng-click=sale.productNew() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=\"entry.saving==true || !sale.selected_product\" type=button ng-click=sale.productEdit() class=\"btn btn-default btn-sm\">Изменить</button> <button ng-disabled=\"entry.saving==true || !sale.selected_product\" type=button ng-click=sale.productRemove() class=\"btn btn-danger btn-sm\">Удалить</button><paged-table options=sale.productsGridOptions disable-search=true disable-paging=true></paged-table></panel><panel title=\"Товары по заявке\" ng-if=entry.document.data.from_products.length&gt;0><button ng-disabled=\"entry.saving==true || !sale.selected_from_product\" type=button ng-click=sale.productFromNew() class=\"btn btn-primary btn-sm\">Добавить в товары</button><paged-table options=sale.fromProductsGridOptions disable-search=true disable-paging=true></paged-table></panel><panel title=Одобрение collapsed=true><div class=row><col-responsive><div class=form-group><label>Требуется одобрение</label><label class=form-control><div class=checkbox-inline><input type=checkbox ng-model=entry.document.approval.required ng-disabled=\"sale.approval_not_editable || sale.is_executor\"><span ng-show=entry.document.approval.required>Требуется одобрение</span><span ng-hide=entry.document.approval.required>Одобрение не требуется</span></div></label></div></col-responsive><col-responsive><div ng-init=\"entry.document.approval.approval_type=&quot;one&quot;\" class=form-group><label>Должны одобрить<span uib-tooltip=\"Сколько пользователей из каждой роли должны одобрить\" class=\"fa fa-question-circle\"></span></label><div stock-dict=sale.approval_types dict-table=Enums dict-filter={name:&quot;approval_type&quot;} class=form-control><label ng-repeat=\"type in sale.approval_types track by type.data.key\" class=radio-inline><input type=radio ng-model=entry.document.approval.approval_type ng-value=type.data.key ng-disabled=\"!entry.document.approval.required || sale.approval_not_editable || sale.is_executor\"><span>{{type.data.name}}</span></label></div></div></col-responsive><col-responsive><div class=form-group><label>Добавить роль для одобрения<span uib-tooltip=\"Одобрение будет проходить по порядку добавления ролей\" class=\"fa fa-question-circle\"></span></label><div stock-dict=sale.roles dict-table=Roles class=input-group><ui-select ng-model=sale.approval_role_id ng-disabled=\"!entry.document.approval.required || sale.approval_not_editable || sale.is_executor\" class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (sale.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-disabled=\"!sale.approval_role_id || !entry.document.approval.required || sale.approval_not_editable || sale.is_executor\" ng-click=sale.addApprovalRole() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-plus text-primary\"></span></button></span></div></div></col-responsive><div class=\"col col-xs-12\"><label>Роли для одобрения</label></div><div stock-dict=sale.roles dict-table=Roles class=\"col col-xs-12\"><col-responsive ng-repeat=\"role_id in entry.document.approval.roles_id\"><div class=input-group><div class=input-group-addon><span>{{$index+1}}</span></div><ui-select ng-model=role_id ng-disabled=true class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (sale.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=sale.delApprovalRole(role_id) ng-disabled=\"sale.approval_not_editable || sale.is_executor\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></span></div></col-responsive></div></div></panel></div>");
$templateCache.put("app/docs/sale/product_select.html","<!--\nCreated by ilias on 30/08/16.\n\n--><form ng-submit=product.productSave() class=modal-content><div class=modal-header><h3>Выбор продукта</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Продукт</label><product-select product-id=product.product.product_id product-unit-id=product.product.unit_id on-product-load=product.onProductLoaded($product)></product-select></div></col-responsive><col-responsive stock-dict=product.units dict-table=Units dict-filter={_id:product.product.unit_id}><div class=form-group><label>Единица измерения</label><ui-select ng-model=product.product.unit_id ng-disabled=true><ui-select-match ng-value=\"product.product.unit=$select.selected\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"unit._id as unit in product.units | filter:$select.search track by unit._id\">{{unit.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=product.pr dict-table=PricingRules dict-filter={product_id:product.product.product_id} dict-on-load=product.onRulesLoaded() class=form-group><label>Скидка</label><ui-select ng-model=product.product.rules_id on-select=product.onRuleSelect() multiple><ui-select-match allow-clear=true>{{$item.discount}}%</ui-select-match><ui-select-choices repeat=\"rule._id as rule in product.pr | filter:$select.search | orderBy:&quot;rule.priority&quot;\"><div ng-if=\"rule._id !== undefined\" class=row><div class=\"col col-sm-6\"><span>Приоритет: {{rule.priority}}</span></div><div class=\"col col-sm-6\"><span>Скидка: {{rule.discount}}%</span></div><div class=\"col col-sm-12 small\"><div ng-show=rule.valid_from>От: {{rule.valid_from | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div><div ng-show=rule.valid_up_to>До: {{rule.valid_up_to | amDateFormat:\'Do MMMM YYYY, HH:mm\'}}</div></div></div></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Количество</label><input type=number min={{product.product.unit.data.round}} step={{product.product.unit.data.round}} ng-model=product.product.quantity ng-change=product.calcTotalCost(product.product);product.calcUnitPrice(product.product) ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Цена за единицу</label><input type=number step=0.01 ng-model=product.product.quote_unit_price ng-change=product.calcTotalCost(product.product) class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дополнительная стоимость</label><input type=number step=0.01 ng-model=product.product.additional_cost class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Общая стоимость</label><input type=number step=0.01 ng-model=product.product.total_cost ng-change=product.calcUnitPrice(product.product) class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=product.product.comment class=form-control></textarea></div></col-responsive></div></div><div class=modal-footer><button type=button ng-click=product.cancel() class=\"btn btn-warning btn-sm\">Отмена</button> <button class=\"btn btn-primary btn-sm\">Сохранить</button></div></form>");
$templateCache.put("app/docs/sale/view.html","<!--\nCreated by ilias on 03/08/16.\n\n--><div ng-controller=\"DocsSaleViewController as sale\" class=container><div class=container><h3>{{view.document.title}}</h3><label class=margin-right-8>{{view.document.document_status_value.data.name}}</label><label class=pull-right>Создан <span am-time-ago=view.document.data.date></span></label></div><div class=ln_solid></div><div class=\"row-striped row-v-padding row-col-bold\"><div ng-if=view.document.branch_id class=row><col-responsive class=col-lg-2>Филиал</col-responsive><col-responsive class=col-lg-10>{{view.document.branch.name}}</col-responsive></div><div ng-if=view.document.data.executor_id class=row><col-responsive class=col-lg-2>Исполнитель</col-responsive><col-responsive class=col-lg-10>{{view.document.executor.username}}</col-responsive></div><div ng-if=view.document.data.delivery_date class=row><col-responsive class=col-lg-2>Дата доставки</col-responsive><col-responsive class=col-lg-10>{{view.document.data.delivery_date | amDateFormat:\"Do MMMM YYYY\"}}</col-responsive></div><div ng-if=view.document.short_desc class=row><col-responsive class=col-lg-2>Короткое описание</col-responsive><col-responsive class=col-lg-10>{{view.document.short_desc}}</col-responsive></div><div ng-if=view.document.data.comment class=row><col-responsive class=col-lg-2>Комментарий</col-responsive><col-responsive class=col-lg-10>{{view.document.data.comment}}</col-responsive></div><div ng-if=view.document.data.from_company_id class=row><col-responsive class=col-lg-2>По заявке от компании</col-responsive><col-responsive class=col-lg-10>{{view.document.from_company.name}}</col-responsive></div><div ng-if=view.document.data.contractor_id class=row><col-responsive class=col-lg-2>Контрагент</col-responsive><col-responsive class=col-lg-10>{{view.document.contractor.name}}</col-responsive></div><div class=row><col-responsive class=col-lg-2>Способ оплаты</col-responsive><col-responsive class=col-lg-10><span ng-show=!view.document.data.is_due>Наличные</span><span ng-show=view.document.data.is_due>В долг</span></col-responsive></div><div ng-if=view.document.data.due_date class=row><col-responsive class=col-lg-2>Дата выплаты</col-responsive><col-responsive class=col-lg-10>{{view.document.data.due_date | amDateFormat:\"Do MMMM YYYY\"}}</col-responsive></div></div><div class=ln_solid></div><panel title=\"Товары на продажу\"><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>Продукт</th><th>Единица изм.</th><th>Количество</th><th>Цена за ед.</th><th>Общая стоимость</th><th>Дополнительная стоимость</th><th>Комментарий</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.products\"><td><span ng-repeat=\"product_item in view.document.products|filter: {_id:product.product_id} track by product_item._id\">{{product_item.name}}</span></td><td><span ng-repeat=\"unit_item in view.document.units|filter: {_id:product.unit_id} track by unit_item._id\">{{unit_item.name}}</span></td><td>{{product.quantity | number}}</td><td>{{product.quote_unit_price | number}}</td><td>{{product.total_cost | number}}</td><td>{{product.additional_cost | number}}</td><td>{{product.comment}}</td></tr></tbody></table></div><div class=row><div class=\"col col-xs-12\"><div class=text-right><h4>Итоговая сумма</h4><label>{{view.document.currency.name}} {{sale.totalSum() | number}}</label></div></div></div></panel><panel title=\"Товары по заявке\" ng-if=view.document.data.from_products.length&gt;0><div class=table-responsive><table class=\"table table-sm table-striped\"><thead><tr><th>Продукт</th><th>Количество</th><th>Цена за ед.</th><th>Общая стоимость</th><th>Дополнительная стоимость</th><th>Комментарий</th></tr></thead><tbody><tr ng-repeat=\"product in view.document.data.from_products\"><td>{{product.product.name}}</td><td>{{product.quantity | number}} {{product.unit.name}}</td><td>{{product.quote_unit_price | number}} {{view.document.from_currency.name}}</td><td>{{product.total_cost | number}} {{view.document.from_currency.name}}</td><td>{{product.additional_cost | number}} {{view.document.from_currency.name}}</td><td>{{product.comment}}</td></tr></tbody></table></div><div class=row><div class=\"col col-xs-12\"><div class=text-right><h4>Итоговая сумма</h4><label>{{view.document.from_currency.name}} {{sale.fromTotalSum() | number}}</label></div></div></div></panel><div ng-show=view.document.approval.required><div class=ln_solid></div><h4>Одобрения</h4><div class=\"row-striped row-v-padding row-col-bold\"><div class=row><col-responsive class=col-lg-2>Должны одобрить</col-responsive><col-responsive class=col-lg-10>{{view.document.approval_type_value.data.name}}</col-responsive></div></div><ul><li ng-repeat=\"approval_role in view.document.approval.approval_roles\"><h5 ng-class=\"{&quot;text-success&quot;:approval_role.approved===true, &quot;text-danger&quot;:approval_role.approved===false}\"><span ng-show=\"approval_role.approved===true\" class=\"glyphicon glyphicon-ok-circle margin-right-8\"></span><span ng-show=\"approval_role.approved===false\" class=\"glyphicon glyphicon-remove-circle margin-right-8\"></span><span ng-repeat=\"role in view.document.roles|filter:{_id:approval_role.role_id} track by role._id\">{{role.data.approval_name}}</span></h5><ul><li ng-repeat=\"approval_user in approval_role.approval_users\" ng-class=\"{&quot;text-success&quot;:approval_user.approved===true, &quot;text-danger&quot;:approval_user.approved===false}\"><span class=\"fa fa-user margin-right-8\"></span><span ng-repeat=\"user in view.document.approval_users|filter:{id:approval_user.user_id} track by user.id\">{{user.username}}</span></li></ul></li></ul></div><div class=ln_solid></div><document-comment document-id=view.document._id></document-comment></div>");}]);